
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iVGec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $7D1yr = parcelRequire("7D1yr");


var $5X6fy = parcelRequire("5X6fy");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");

const $bfb9b1580f9516c1$export$bc90872e265d166e = 12;
// Matches the existing `.gridParent` 12px left + 12px right gutter expansion.
const $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH = 24;
const $bfb9b1580f9516c1$var$key = new (0, $kCECX.PluginKey)('gridPlugin');
const $bfb9b1580f9516c1$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($bfb9b1580f9516c1$var$key, props);
        dispatch(tr);
        return true;
    };
const $bfb9b1580f9516c1$var$sides = [
    'left',
    'right'
];
const $bfb9b1580f9516c1$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $bfb9b1580f9516c1$export$bc90872e265d166e && maxHighlight >= $bfb9b1580f9516c1$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $bfb9b1580f9516c1$export$bc90872e265d166e + size : true);
};
const $bfb9b1580f9516c1$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $7Y8M5.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $bfb9b1580f9516c1$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', $bfb9b1580f9516c1$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $7Y8M5.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $bfb9b1580f9516c1$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $bfb9b1580f9516c1$export$bc90872e265d166e;
    for(let i = 0; i <= $bfb9b1580f9516c1$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $bfb9b1580f9516c1$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $bfb9b1580f9516c1$var$GridLegacy = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none',
                width: `${overlayWidth}px`
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $bfb9b1580f9516c1$var$GridNext = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth);
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none',
                width: `${overlayWidth}px`
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $bfb9b1580f9516c1$var$ThemedGridLegacy = (0, $7D1yr.b)($bfb9b1580f9516c1$var$GridLegacy);
const $bfb9b1580f9516c1$var$ThemedGrid = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_core_static_css', 'isEnabled', true), $bfb9b1580f9516c1$var$GridNext, $bfb9b1580f9516c1$var$ThemedGridLegacy);
const $bfb9b1580f9516c1$var$selector = (states)=>{
    return {
        lineLength: states.widthState?.lineLength,
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $bfb9b1580f9516c1$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { lineLength: lineLength, width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $bfb9b1580f9516c1$var$selector);
    const overlayWidth = (lineLength || width || (0, $7Y8M5.akEditorFullPageMaxWidth)) + $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH;
    if (!visible || !highlight) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($bfb9b1580f9516c1$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $7Y8M5.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight,
        overlayWidth: overlayWidth
    });
};
const $bfb9b1580f9516c1$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $bfb9b1580f9516c1$var$gridPMPlugin = new (0, $kpCD8.SafePlugin)({
    key: $bfb9b1580f9516c1$var$key,
    state: {
        init () {
            return $bfb9b1580f9516c1$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($bfb9b1580f9516c1$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $bfb9b1580f9516c1$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $bfb9b1580f9516c1$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $bfb9b1580f9516c1$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$bfb9b1580f9516c1$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($bfb9b1580f9516c1$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};
module.exports["gridPlugin"] = $bfb9b1580f9516c1$export$c090e341e8f725a9;

});

parcelRegister("1A89X", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $5aU9U = parcelRequire("5aU9U");

class $7e4c18d2699116f4$export$8cfd0a0bfa522949 extends (0, $5aU9U.Step) {
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $eOaGc.StepResult).fail('No node at given position');
        if (target.isText) return (0, $eOaGc.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $aPdNQ.Fragment).empty, target.marks);
        const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $eOaGc.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $7e4c18d2699116f4$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
    constructor(pos, attrs){
        super();
        this.pos = void 0;
        this.attrs = void 0;
        this.pos = pos;
        this.attrs = attrs;
    }
}
(0, $5aU9U.Step).jsonID('setAttrs', $7e4c18d2699116f4$export$8cfd0a0bfa522949);
module.exports["SetAttrsStep"] = $7e4c18d2699116f4$export$8cfd0a0bfa522949;

});

parcelRegister("89gPK", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $5ad357f2123c826c$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
module.exports["calcColumnsFromPx"] = $5ad357f2123c826c$export$10912f14d8d54640;

});

parcelRegister("b8ZJI", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $89gPK = parcelRequire("89gPK");


var $e3qgT = parcelRequire("e3qgT");


var $yNGEI = parcelRequire("yNGEI");


var $34CLe = parcelRequire("34CLe");


const $4f7a300912d0ecb6$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $4f7a300912d0ecb6$export$adfc02948d64a4f2 = (layout)=>$4f7a300912d0ecb6$var$validWidthModes.indexOf(layout) > -1;
const $4f7a300912d0ecb6$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil((0, $yNGEI.calcPxFromPct)(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $4f7a300912d0ecb6$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7Y8M5.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ((0, $34CLe.wrappedLayouts).indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return calculatedPctWidth;
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && (0, $34CLe.wrappedLayouts).indexOf(layout) !== -1) // when layout is wrap-left, wrap-right, align-start, align-end
    // but no pctWidth is defined
    return Math.min((0, $yNGEI.calcPxFromPct)(0.5, lineLength || width), origWidth);
    return origWidth;
};
const $4f7a300912d0ecb6$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = (0, $yNGEI.calcPxFromPct)(gridWidth / 100, lineLength);
    const columnSpan = Math.round((0, $89gPK.calcColumnsFromPx)(pxWidth, lineLength, gridSize));
    const alignedWidth = (0, $e3qgT.calcPxFromColumns)(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcMediaPxWidth"] = $4f7a300912d0ecb6$export$5e51fc02b9ada5af;

});

parcelRegister("76kDm", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $d7bd499ffb775b71$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
module.exports["calcPctFromPx"] = $d7bd499ffb775b71$export$55ddb36b3404ec6d;

});

parcelRegister("bfl0n", function(module, exports) {
const $037ce7e6baaea8b0$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
module.exports["handleSides"] = $037ce7e6baaea8b0$export$8ee741c8b9b43371;

});

parcelRegister("fb9eF", function(module, exports) {
const $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};
module.exports["imageAlignmentMap"] = $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5;

});

parcelRegister("3GQSw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $9to0k = parcelRequire("9to0k");


var $7Y8M5 = parcelRequire("7Y8M5");


var $krYZG = parcelRequire("krYZG");


var $l3s1y = parcelRequire("l3s1y");


var $8dGm2 = parcelRequire("8dGm2");


var $bfl0n = parcelRequire("bfl0n");


var $h5qPS = parcelRequire("h5qPS");

const $8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $krYZG.ACTION_SUBJECT).EMBEDS : (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $krYZG.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $8fc8e2ef5831c0bb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $bfl0n.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $7Y8M5.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $l3s1y.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9to0k.Resizable), {
            ref: this.resizable,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints, onResizeStart: onResizeStart } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            if (onResizeStart) onResizeStart();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $8dGm2.gridTypeForLayout)(layout), []);
            });
        };
    }
}
module.exports["default"] = $8fc8e2ef5831c0bb$export$2e2bcd8739ae039;

});

parcelRegister("9to0k", function(module, exports) {
"use strict";
var $6e597142fca2a0bf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e597142fca2a0bf$var$__assign = module.exports && module.exports.__assign || function() {
    $6e597142fca2a0bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e597142fca2a0bf$var$__assign.apply(this, arguments);
};
var $6e597142fca2a0bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $6e597142fca2a0bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6e597142fca2a0bf$var$React = $6e597142fca2a0bf$var$__importStar((parcelRequire("cozmU")));

var $9aSOx = parcelRequire("9aSOx");


var $6e597142fca2a0bf$var$fast_memoize_1 = $6e597142fca2a0bf$var$__importDefault((parcelRequire("9HfYc")));
var $6e597142fca2a0bf$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $6e597142fca2a0bf$var$clamp = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $6e597142fca2a0bf$var$snap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $6e597142fca2a0bf$var$hasDirection = $6e597142fca2a0bf$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $6e597142fca2a0bf$var$findClosestSnap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $6e597142fca2a0bf$var$endsWith = $6e597142fca2a0bf$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $6e597142fca2a0bf$var$getStringSize = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'px')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, '%')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vh')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vw')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmax')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $6e597142fca2a0bf$var$calculateNewMax = $6e597142fca2a0bf$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $6e597142fca2a0bf$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $6e597142fca2a0bf$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $6e597142fca2a0bf$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $6e597142fca2a0bf$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $6e597142fca2a0bf$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $6e597142fca2a0bf$var$baseClassName = '__resizable_base__';
var $6e597142fca2a0bf$var$Resizable = /** @class */ function(_super) {
    $6e597142fca2a0bf$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $6e597142fca2a0bf$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($6e597142fca2a0bf$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $6e597142fca2a0bf$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($6e597142fca2a0bf$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $6e597142fca2a0bf$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($6e597142fca2a0bf$var$baseClassName);
        else element.className += $6e597142fca2a0bf$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($6e597142fca2a0bf$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($6e597142fca2a0bf$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $6e597142fca2a0bf$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $6e597142fca2a0bf$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $6e597142fca2a0bf$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $6e597142fca2a0bf$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $6e597142fca2a0bf$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $6e597142fca2a0bf$var$React.createElement($9aSOx.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $6e597142fca2a0bf$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($6e597142fca2a0bf$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $6e597142fca2a0bf$var$React.createElement("div", $6e597142fca2a0bf$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $6e597142fca2a0bf$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $6e597142fca2a0bf$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($6e597142fca2a0bf$var$React.PureComponent);
module.exports.Resizable = $6e597142fca2a0bf$var$Resizable;

});

parcelRegister("9HfYc", function(module, exports) {
//
// Main
//
function $70f4847fca63d9bd$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $70f4847fca63d9bd$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $70f4847fca63d9bd$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $70f4847fca63d9bd$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $70f4847fca63d9bd$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $70f4847fca63d9bd$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $70f4847fca63d9bd$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $70f4847fca63d9bd$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $70f4847fca63d9bd$var$monadic : $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyVariadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyMonadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$monadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $70f4847fca63d9bd$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $70f4847fca63d9bd$var$cacheDefault = {
    create: function create() {
        return new $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $70f4847fca63d9bd$var$memoize;
module.exports.strategies = {
    variadic: $70f4847fca63d9bd$var$strategyVariadic,
    monadic: $70f4847fca63d9bd$var$strategyMonadic
};

});

parcelRegister("h5qPS", function(module, exports) {
const $3866694567b9f2f6$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? // extreme last case if there are no points somehow
    target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
module.exports["snapTo"] = $3866694567b9f2f6$export$ce5a040a76868800;

});

parcelRegister("jU5kz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $hZR9z = parcelRequire("hZR9z");


var $6aEgq = parcelRequire("6aEgq");


var $4ezc2 = parcelRequire("4ezc2");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");


var $4mxZP = parcelRequire("4mxZP");


var $f4MCV = parcelRequire("f4MCV");


var $iUhs4 = parcelRequire("iUhs4");


var $9V98o = parcelRequire("9V98o");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $5I4Vo = parcelRequire("5I4Vo");


var $ldqjS = parcelRequire("ldqjS");


var $2xhuI = parcelRequire("2xhuI");

var $2BvhC = parcelRequire("2BvhC");


var $6keIx = parcelRequire("6keIx");


var $dAzds = parcelRequire("dAzds");

var $gtLXJ = parcelRequire("gtLXJ");

var $8qft0 = parcelRequire("8qft0");

const $a9d84f7bb61ac6b4$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aEgq))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hZR9z))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ezc2))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignRight)
    }
];
const $a9d84f7bb61ac6b4$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4MCV))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUhs4))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)))
    }
];
const $a9d84f7bb61ac6b4$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $2BvhC.toolbarMessages).wrapLeft,
    center: (0, $2xhuI.default).alignImageCenter,
    'wrap-right': (0, $2BvhC.toolbarMessages).wrapRight,
    wide: (0, $2xhuI.default).layoutWide,
    'full-width': (0, $2xhuI.default).layoutFullWidth,
    'align-end': (0, $2xhuI.default).alignImageRight,
    'align-start': (0, $2xhuI.default).alignImageLeft
};
const $a9d84f7bb61ac6b4$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $a9d84f7bb61ac6b4$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $a9d84f7bb61ac6b4$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $dAzds.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $5I4Vo.insideTable)(state) || (0, $gtLXJ.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).SELECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $a9d84f7bb61ac6b4$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $8qft0.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                    children: (0, $ldqjS.tooltip)(layoutOption.keyboardShortcut)
                })
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $bjg0G.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $ieeJu.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $a9d84f7bb61ac6b4$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $a9d84f7bb61ac6b4$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$a9d84f7bb61ac6b4$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$a9d84f7bb61ac6b4$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$a9d84f7bb61ac6b4$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $8qft0.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a9d84f7bb61ac6b4$export$2e2bcd8739ae039 = $a9d84f7bb61ac6b4$var$buildLayoutButtons;
module.exports["alignmentIcons"] = $a9d84f7bb61ac6b4$export$45400139bf999022;
module.exports["wrappingIcons"] = $a9d84f7bb61ac6b4$export$88511ca1ca567d46;
module.exports["layoutToMessages"] = $a9d84f7bb61ac6b4$export$b978ceeb25a89f87;
module.exports["buildLayoutDropdown"] = $a9d84f7bb61ac6b4$export$31e29507a90f6f72;
module.exports["default"] = $a9d84f7bb61ac6b4$export$2e2bcd8739ae039;

});

parcelRegister("kVd8s", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $5aU9U = parcelRequire("5aU9U");

const $616ba2be6cd111db$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $616ba2be6cd111db$export$c1b7e6427b2a2113 extends (0, $5aU9U.Step) {
    invert() {
        return new $616ba2be6cd111db$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $616ba2be6cd111db$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor(pos, prev, next){
        super();
        this.prev = void 0;
        this.next = void 0;
        this.pos = void 0;
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $5aU9U.Step).jsonID($616ba2be6cd111db$export$3f33e36adb7672cc, $616ba2be6cd111db$export$c1b7e6427b2a2113);
module.exports["TableSortStep"] = $616ba2be6cd111db$export$c1b7e6427b2a2113;

});

parcelRegister("3gmKQ", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $hVgcP = parcelRequire("hVgcP");


var $20WsY = parcelRequire("20WsY");


var $ixHGM = parcelRequire("ixHGM");


var $kpCD8 = parcelRequire("kpCD8");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");
var $b9b39f75b7ac85cf$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $b9b39f75b7ac85cf$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});



var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $3ztIq = parcelRequire("3ztIq");





var $liXVw = parcelRequire("liXVw");

var $gWBVp = parcelRequire("gWBVp");


var $2lPWP = parcelRequire("2lPWP");


var $aPdNQ = parcelRequire("aPdNQ");











var $ieeJu = parcelRequire("ieeJu");





var $dpfrn = parcelRequire("dpfrn");








var $cI8RZ = parcelRequire("cI8RZ");




const $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('extensionPlugin');


function $004bdf518602b49b$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}


const $7d5ef977555345d3$var$factory = (0, $cI8RZ.pluginFactory)((0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1), (0, $004bdf518602b49b$export$2e2bcd8739ae039), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $7d5ef977555345d3$export$656c7661095efe2e = $7d5ef977555345d3$var$factory.createPluginState;
const $7d5ef977555345d3$export$8d4021544bdece00 = $7d5ef977555345d3$var$factory.createCommand;
const $7d5ef977555345d3$export$f05434c51e3762e = $7d5ef977555345d3$var$factory.getPluginState;






var $jfFbl = parcelRequire("jfFbl");


var $btvbC = parcelRequire("btvbC");

var $2l49p = parcelRequire("2l49p");








var $cRgxl = parcelRequire("cRgxl");

const $167f96829d9c9919$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $bjg0G.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $bjg0G.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $167f96829d9c9919$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $167f96829d9c9919$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $bjg0G.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $btvbC.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $167f96829d9c9919$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $167f96829d9c9919$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $2l49p.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $167f96829d9c9919$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $2l49p.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
/**
 * Converts a ProseMirror node to its text representation.
 * Handles text nodes with marks (links) and inline nodes (status, mention, emoji).
 * Returns the content for this node, with a trailing separator for text blocks.
 */ const $167f96829d9c9919$var$convertNodeToText = (node, mentionSet, parent, locale)=>{
    if (node.isInline) {
        const schema = node.type.schema;
        let finalText = '';
        if (node.isText) {
            finalText = node.text || '';
            if (node.marks.length > 0) {
                for (const mark of node.marks)// if it's link, include the href in the text
                if (mark.type === schema.marks.link) {
                    const href = mark.attrs.href;
                    const text = node.text || '';
                    // If the text differs from the href, include both
                    if (text && text !== href) finalText = `${text} ${href}`;
                    else finalText = href;
                }
            }
        } else switch(node.type){
            case schema.nodes.status:
                finalText = node.attrs.text || '';
                break;
            case schema.nodes.mention:
                mentionSet.add(node.attrs.id);
                finalText = `@${node.attrs.id}`;
                break;
            case schema.nodes.emoji:
                finalText = node.attrs.shortName || '';
                break;
            case schema.nodes.date:
                const timestamp = new Date(Number(node.attrs.timestamp));
                finalText = !isNaN(timestamp.getTime()) ? timestamp.toLocaleDateString(locale ?? 'en-US') : String(node.attrs.timestamp);
                break;
            default:
                finalText = node.textContent;
                break;
        }
        if (parent && parent.isTextblock && node === parent.lastChild && parent.childCount > 0) finalText += '\n\n';
        return finalText;
    }
    return '';
};
/**
 * Resolves mention IDs to their display names and replaces them in the text.
 * Returns the text with resolved mentions, or the original text if the provider is unavailable.
 */ const $167f96829d9c9919$var$resolveMentionsInText = async (text, mentionSet, api)=>{
    const mentionProvider = api?.mention?.sharedState?.currentState()?.mentionProvider;
    if (!mentionProvider || !(0, $cRgxl.isResolvingMentionProvider)(mentionProvider)) return text;
    let resolvedText = text;
    for (const id of mentionSet){
        const mention = await mentionProvider.resolveMentionName(id);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        resolvedText = resolvedText.replace(`@${id}`, `@${mention.name}` || "@\u2026");
    }
    return resolvedText;
};
const $167f96829d9c9919$export$9defe25170de6263 = async ({ locale: locale, schema: schema, unsupportedContent: unsupportedContent, api: api })=>{
    try {
        if (!unsupportedContent) throw new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $2lPWP.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        let text = '';
        const mentionSet = new Set();
        pmNode.nodesBetween(0, pmNode.content.size, (node, _pos, parent)=>{
            text += $167f96829d9c9919$var$convertNodeToText(node, mentionSet, parent, locale);
        });
        // Trim leading/trailing whitespace from the collected text
        text = text.trim();
        text = await $167f96829d9c9919$var$resolveMentionsInText(text, mentionSet, api);
        (0, $jfFbl.copyToClipboard)(text);
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $167f96829d9c9919$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    const nodeWithPos = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi?.analytics?.actions.fireAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        action: (0, $krYZG.ACTION).COPY_FAILED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};


function $3d915853de2ecd5c$export$4971331372cec95a(state) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $3d915853de2ecd5c$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $3d915853de2ecd5c$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $3d915853de2ecd5c$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state)) return $3d915853de2ecd5c$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $3d915853de2ecd5c$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $3d915853de2ecd5c$export$fa79c3ccfdddfece = (sourceNode)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $dpfrn.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $3d915853de2ecd5c$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeSelectedNode)(tr);
};
const $3d915853de2ecd5c$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeParentNodeOfType)(nodeType)(tr);
};



var $9Rq82 = parcelRequire("9Rq82");





var $8tXCb = parcelRequire("8tXCb");


var $YvadP = parcelRequire("YvadP");











const $61358629666c9a4d$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('macroPlugin');


const $783fd49d73f6388e$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $783fd49d73f6388e$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $bjg0G.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $bjg0G.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $bjg0G.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $bjg0G.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).UPDATED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $krYZG.INPUT_METHOD).MACRO_BROWSER : (0, $krYZG.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $783fd49d73f6388e$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $YvadP.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $8tXCb.normaliseNestedLayout)(state, node);
};
const $783fd49d73f6388e$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $783fd49d73f6388e$export$87074dfcaea41da3(macroAttributes, state);
};
const $783fd49d73f6388e$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($9Rq82)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1), {
            macroProvider: resolvedProvider
        }));
        return true;
    };




const $92573c06ef675309$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $92573c06ef675309$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $krYZG.ACTION).INVOKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
const $92573c06ef675309$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $3ztIq.validator)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: true
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $167f96829d9c9919$export$bb057d1dfc5c8b1b)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $aPdNQ.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $aPdNQ.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $167f96829d9c9919$export$cd9967958db163fc)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $167f96829d9c9919$export$1004a88e790d2d21)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $krYZG.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        insertAtSelection: (adf)=>{
            if (!(0, $iDrrr.fg)('platform_forge_inline_bodied_macro')) return;
            try {
                validate(adf);
            } catch  {
                throw new Error(`insertAtSelection(): Invalid ADF given.`);
            }
            const { dispatch: dispatch, state: state } = options.editorView;
            const newNode = state.schema.nodeFromJSON(adf);
            const tr = state.tr.replaceSelectionWith(newNode).scrollIntoView();
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAtSelection(): The given ADFEntity cannot replace the current selection.\n${err}`);
            }
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('insertAtSelection');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $bjg0G.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                ...(0, $iDrrr.fg)('platform_forge_inline_bodied_macro') ? {
                    type: node.type.name
                } : {},
                content: (0, $gWBVp.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $aPdNQ.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newType = node.type;
            if (changedValues.hasOwnProperty('type') && changedValues.type !== node.type.name && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro')) newType = changedValues.type ? schema.nodes[changedValues.type] : undefined;
            if (!newType) throw new Error(`update(): Invalid ADF node type '${changedValues.type}'.`);
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = newType.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $2lPWP.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                if (newType === node.type) tr.replaceWith(pos, pos + node.nodeSize, newNode);
                else {
                    tr.replaceRangeWith(pos, pos + node.nodeSize, newNode);
                    if (node.isBlock && newNode.isInline) (0, $liXVw.autoJoinTr)(tr, [
                        'paragraph'
                    ]);
                    tr.doc.check();
                }
                // Keep selection if content does not change
                if (newType === node.type && newContent === node.content) tr.setSelection((0, $kCECX.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof opts?.scrollIntoView === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $3d915853de2ecd5c$export$845f8c516a847983)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(editorView.state);
                editInLegacy = $92573c06ef675309$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};




const $5313dd79acf665fc$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5313dd79acf665fc$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5313dd79acf665fc$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $bjg0G.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
            let action = (0, $krYZG.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $bjg0G.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $bjg0G.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                } else action = (0, $krYZG.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $krYZG.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5313dd79acf665fc$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5313dd79acf665fc$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5313dd79acf665fc$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        const nodeWithPos = (0, $167f96829d9c9919$export$b003700b6d25caa7)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $92573c06ef675309$export$5c24840493a9fa44)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5313dd79acf665fc$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5313dd79acf665fc$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(view.state);
        return $5313dd79acf665fc$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5313dd79acf665fc$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5313dd79acf665fc$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};





var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");



function $d40259b0c24668cb$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.escape).common, (state, dispatch)=>{
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
    }, list);
    return (0, $44cyU.keymap)(list);
}








const $bf6f7e4036588680$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $61358629666c9a4d$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $61358629666c9a4d$export$18d4026d1ea86bb1),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $783fd49d73f6388e$export$e45aff648def0591)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });



var $1sE44 = parcelRequire("1sE44");





var $lp7sw = parcelRequire("lp7sw");

var $4EksL = parcelRequire("4EksL");

var $1tdnq = parcelRequire("1tdnq");

var $iscRo = parcelRequire("iscRo");








const $17c52fed0a81d13d$export$f01d446fba239e5a = (manifests)=>{
    const transforms = [];
    for (const manifest of manifests){
        for (const nodeModule of Object.values(manifest.modules.nodes ?? {}))if (nodeModule.blockTransform) transforms.push(nodeModule.blockTransform);
    }
    return transforms;
};





var $cd8tA = parcelRequire("cd8tA");



const $e273459f17684478$var$maybeGetExtensionModuleNode = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $cd8tA.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode;
};
const $e273459f17684478$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const extensionModuleNode = await $e273459f17684478$var$maybeGetExtensionModuleNode(view, extensionProvider);
        const updateMethod = extensionModuleNode?.update;
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            showEditButton: !!updateMethod,
            showCopyButton: !extensionModuleNode?.hideCopyButton,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};



const $584598053f9859f0$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $584598053f9859f0$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $584598053f9859f0$export$21b8c38408ff6d69 = (view, api)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
            try {
                const manifests = await extensionProvider.getExtensions();
                api?.blockMenu?.actions.registerBlockMenuTransforms((0, $17c52fed0a81d13d$export$f01d446fba239e5a)(manifests));
            } catch  {
            // Transform registration remains unavailable when manifests cannot be loaded.
            }
        } catch  {
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $584598053f9859f0$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $167f96829d9c9919$export$f1c79f28529bfc9a)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $167f96829d9c9919$export$cdb701fa2b3c99df)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // This is the current assumption and it's wrong but we are keeping it
    // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $584598053f9859f0$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $584598053f9859f0$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            // Default to showing synchronously; the manifest-driven value (if any)
            // is resolved asynchronously via updateEditButton for provider-based
            // extensions.
            showCopyButton: true,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $584598053f9859f0$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions, intl)=>{
    const state = (0, $7d5ef977555345d3$export$656c7661095efe2e)(dispatch, {
        showEditButton: false,
        showCopyButton: true,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight,
        allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $584598053f9859f0$export$21b8c38408ff6d69(editorView, pluginInjectionApi);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $584598053f9859f0$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1),
        props: {
            handleDOMEvents: {
                /**
         * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
         * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
         * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
         */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $kCECX.TextSelection) ? (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $bjg0G.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $iscRo.isSelectionAtStartOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $1tdnq.isSelectionAtEndOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $4EksL.GapCursorSelection) || selection instanceof (0, $kCECX.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
                 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
                 */ const previousPositionDecrement = selection instanceof (0, $4EksL.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                multiBodiedExtension: (0, $1sE44.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, // isAnchorInMBE.pos < head.pos represents downwards selection
                    head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize // isHeadInMBE.pos < anchor.pos represents upwards selection
                    );
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), // It's to enable nested extensions selection
            {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};




var $04Oo7 = parcelRequire("04Oo7");


var $8Dx7s = parcelRequire("8Dx7s");

const $b098027f4699dcb1$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $b098027f4699dcb1$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $04Oo7.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $8Dx7s.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $b098027f4699dcb1$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};



var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");





var $2sp5n = parcelRequire("2sp5n");

var $3nm9z = parcelRequire("3nm9z");


var $2xhuI = parcelRequire("2xhuI");


var $2aFJ8 = parcelRequire("2aFJ8");


var $g6uqx = parcelRequire("g6uqx");




var $eQeCt = parcelRequire("eQeCt");


var $jaFVy = parcelRequire("jaFVy");





var $6RqDx = parcelRequire("6RqDx");


var $4mxZP = parcelRequire("4mxZP");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $9V98o = parcelRequire("9V98o");












// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $7d58a2ee0cc4b964$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: nodes }, selection: selection } = state;
    const { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem, panel_c1: panel_c1 } = nodes;
    if (!selectedExtNode) return false;
    const parentNodeTypes = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        blockquote,
        listItem
    ] : [
        panel,
        blockquote,
        listItem
    ];
    return selectedExtNode.node.type === extension && (0, $bjg0G.hasParentNodeOfType)(parentNodeTypes.filter(Boolean))(selection);
};
const $7d58a2ee0cc4b964$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    // Skip agent-managed-block extension until it supports the layout controls in its custom node
    const extensionKey = selectedExtNode.node.attrs.extensionKey;
    if ((0, $2sp5n.AGENT_MANAGED_EXTENSION_KEY) === extensionKey) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $bjg0G.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $bjg0G.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $bjg0G.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $7d58a2ee0cc4b964$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) && !$7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                        label: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                        label: formatMessage((0, $2xhuI.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $2xhuI.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                        label: formatMessage((0, $2xhuI.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $2xhuI.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $7d58a2ee0cc4b964$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) || $7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $2xhuI.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)));
            break;
        case 'full-width':
            title = formatMessage((0, $2xhuI.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $2xhuI.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $2xhuI.default).layoutWide),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $2xhuI.default).layoutFullWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $7d58a2ee0cc4b964$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? $7d58a2ee0cc4b964$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $7d58a2ee0cc4b964$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $7d58a2ee0cc4b964$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
                const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                (0, $5313dd79acf665fc$export$f45ebaf24963f4bb)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $3nm9z.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? false : undefined
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $7d58a2ee0cc4b964$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $bjg0G.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $2aFJ8.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $7d58a2ee0cc4b964$export$7652656d91146fb9 = ({ formatMessage: formatMessage, extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state, locale: locale })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent?.(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        extensionApi?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).COPY_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionDynamicType: node.type.name,
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey
            }
        });
        (0, $167f96829d9c9919$export$9defe25170de6263)({
            locale: locale,
            unsupportedContent: adf,
            schema: state.schema,
            api: extensionApi
        }).then(()=>{
            extensionApi?.copyButton?.actions.afterCopy(formatMessage((0, $2xhuI.default).copiedToClipboard));
        }).catch((error)=>{
            (0, $167f96829d9c9919$export$67e8f2a5d4f25de0)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
        });
        return true;
    };
};
const $7d58a2ee0cc4b964$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, copyEnabled: copyEnabled = true, deleteEnabled: deleteEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        const { formatMessage: formatMessage, locale: locale } = intl;
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi?.decorations?.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi?.contextPanel?.actions.applyChange;
        const editorAnalyticsAPI = extensionApi?.analytics?.actions;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $7d58a2ee0cc4b964$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $jaFVy.isOfflineMode)(extensionApi?.connectivity?.sharedState?.currentState()?.mode), extensionApi);
        const breakoutItems = $7d58a2ee0cc4b964$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if (extensionObj?.node.attrs.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && extensionObj?.node.attrs.extensionKey.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $dpfrn.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $3nm9z.messages).unnamedSource);
            return {
                title: formatMessage((0, $3nm9z.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $eQeCt.getNodeName)(state, extensionObj?.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $dpfrn.getChildrenInfo)(state, extensionObj?.node),
                checkboxLabel: formatMessage((0, $3nm9z.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$7d58a2ee0cc4b964$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
            };
        };
        // Hide the copy button when the host disables it for every extension
        // (`copyEnabled`), when the extension's manifest node opts out via
        // `hideCopyButton` (e.g. redactions), or for the legacy content macro.
        //
        // The host check is deliberately evaluated before the gate, so the gate is
        // only read — and so only exposed — for hosts that opted in. Reading it
        // unconditionally would report an exposure on every extension toolbar in
        // every product, drowning the rollout metric in traffic it cannot affect.
        const shouldHideCopyButton = !copyEnabled && (0, $iDrrr.fg)('platform_editor_extension_hide_toolbar_actions') || !extensionState.showCopyButton && (0, $iDrrr.fg)('platform_editor_extension_hide_copy_button') || extensionObj?.node.attrs.extensionType === 'com.atlassian.confluence.migration' && extensionObj?.node.attrs.extensionKey === 'legacy-content';
        const shouldHideDeleteButton = !deleteEnabled && (0, $iDrrr.fg)('platform_editor_extension_hide_toolbar_actions');
        // With both trailing actions gone the toolbar ends after the breakout
        // options, so the divider that used to introduce them would be an orphan.
        const hasTrailingActions = !shouldHideCopyButton || !shouldHideDeleteButton;
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$7d58a2ee0cc4b964$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0 || !hasTrailingActions
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: $7d58a2ee0cc4b964$export$7652656d91146fb9({
                                formatMessage: formatMessage,
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state,
                                locale: locale
                            })
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                // Hide this separator when either neighbour is hidden, otherwise it
                // renders as an orphaned divider before or after the delete button.
                {
                    type: 'separator',
                    hidden: shouldHideCopyButton || shouldHideDeleteButton
                },
                {
                    ...shouldHideDeleteButton && {
                        hidden: true
                    },
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    appearance: 'danger',
                    onClick: (0, $3d915853de2ecd5c$export$366c74c25333cf63)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $2xhuI.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $7d58a2ee0cc4b964$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $3d915853de2ecd5c$export$366c74c25333cf63)()(state, dispatch);
        else (0, $3d915853de2ecd5c$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };



var $1A89X = parcelRequire("1A89X");


var $2nOF5 = parcelRequire("2nOF5");





var $6MtNT = parcelRequire("6MtNT");




const $f28c64404a6658d7$var$pluginKey = new (0, $kCECX.PluginKey)('extensionUniqueIdPlugin');
const $f28c64404a6658d7$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $6MtNT.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $1A89X.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    step.attrs?.localId === null);
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $2nOF5.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $f28c64404a6658d7$var$pluginKey
    });



var $fJUEv = parcelRequire("fJUEv");




parcelRequire("cozmU");











var $8HW7o = parcelRequire("8HW7o");








parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eRn3r = parcelRequire("eRn3r");


var $4o0zT = parcelRequire("4o0zT");


var $fjZlw = parcelRequire("fjZlw");


const $6a7a68fea06620b8$var$loadConfigPanel = ()=>(parcelRequire("4N8T6")).then((module)=>module.default);

const $6a7a68fea06620b8$var$ConfigPanelLazy = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("4N8T6")).then((module)=>module.default));
const $6a7a68fea06620b8$var$ConfigPanelLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "KzLW6",
    name: "ConfigPanelLoadable",
    loader: $6a7a68fea06620b8$var$loadConfigPanel,
    loading: (0, $fjZlw.default)
});
const $6a7a68fea06620b8$var$_default_1 = (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fjZlw.default), {}),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($6a7a68fea06620b8$var$ConfigPanelLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsx)($6a7a68fea06620b8$var$ConfigPanelLoadable, {
        ...props
    });
$6a7a68fea06620b8$var$_default_1.preload = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $6a7a68fea06620b8$var$ConfigPanelLazy.preload() : $6a7a68fea06620b8$var$ConfigPanelLoadable.preload();
var $6a7a68fea06620b8$export$2e2bcd8739ae039 = $6a7a68fea06620b8$var$_default_1;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $chu6R = parcelRequire("chu6R");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");

function $4d99bbf49073cd12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d99bbf49073cd12$var$noop = ()=>{};
const $4d99bbf49073cd12$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $4d99bbf49073cd12$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    /* E300 */ boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $4d99bbf49073cd12$var$saveIndicatorTextStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.075'
});
const $4d99bbf49073cd12$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $cozmU.useState)(false);
    const shown = (0, $cozmU.useRef)(false);
    const onSaveStarted = (0, $cozmU.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $4d99bbf49073cd12$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "Saving",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $4d99bbf49073cd12$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $3nm9z.messages).saveIndicator))))));
};


const $fc213d5917462889$var$areParametersEqual = (firstParameters, secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $fc213d5917462889$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $kCECX.NodeSelection)) return (0, $kCECX.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $kCECX.TextSelection)) return (0, $kCECX.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $4EksL.GapCursorSelection)) return new (0, $4EksL.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $8HW7o.CellSelection)) return new (0, $8HW7o.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $fc213d5917462889$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
                    duration: 5000,
                    visible: true,
                    children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                        const editorView = getEditorView?.();
                        if (!editorView) return null;
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                            api: api,
                            showHeader: true,
                            closeOnEsc: true,
                            extensionType: extensionType,
                            extensionKey: extKey,
                            nodeKey: nodeKey,
                            extensionParameters: parameters,
                            parameters: configParams,
                            extensionProvider: extensionProvider,
                            autoSaveTrigger: autoSaveResolve,
                            autoSaveReject: autoSaveReject,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: async (updatedParameters)=>{
                                await $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                                onSaveEnded();
                                if (autoSaveResolve) autoSaveResolve();
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: async ()=>{
                                try {
                                    await new Promise((resolve, reject)=>{
                                        (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                    });
                                } catch (e) {
                                    // Even if the save failed, we should proceed with closing the panel
                                    // eslint-disable-next-line no-console
                                    console.error(`Autosave failed with error`, e);
                                }
                                (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
                            },
                            featureFlags: featureFlags
                        });
                    }
                });
            }
        };
async function $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($fc213d5917462889$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $5313dd79acf665fc$export$5e06148a47ef53c2)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $fc213d5917462889$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}












var $3k5Tv = parcelRequire("3k5Tv");


var $iMnC5 = parcelRequire("iMnC5");











parcelRequire("cozmU");




var $kA6Zo = parcelRequire("kA6Zo");






parcelRequire("cozmU");


var $jND0n = parcelRequire("jND0n");

function $76989ca55049fc51$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $jND0n.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}


const $923147737bfc3fc6$var$itemBodyStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $923147737bfc3fc6$var$itemTextStyles = (0, $buxP3.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $923147737bfc3fc6$var$summaryStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $923147737bfc3fc6$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: $923147737bfc3fc6$var$itemBodyStyles,
        children: summary ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
            xcss: $923147737bfc3fc6$var$itemTextStyles,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    id: "context-panel-title",
                    "data-testid": "context-panel-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                    xcss: $923147737bfc3fc6$var$summaryStyles,
                    children: summary
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kA6Zo.Flex), {
            direction: "column",
            alignItems: "center",
            testId: "context-panel-title",
            children: title
        })
    });
}
const $923147737bfc3fc6$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($923147737bfc3fc6$var$HeaderAfterIconElement);
var $923147737bfc3fc6$export$2e2bcd8739ae039 = $923147737bfc3fc6$var$_default_1;














const $1ae0de3813cee7fd$var$iconWidth = '40px';
const $1ae0de3813cee7fd$var$itemIconStyles = (0, $buxP3.xcss)({
    width: $1ae0de3813cee7fd$var$iconWidth,
    height: $1ae0de3813cee7fd$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $1ae0de3813cee7fd$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $cozmU.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: $1ae0de3813cee7fd$var$itemIconStyles,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedIcon, {
                label: title
            })
        })
    });
}
const $1ae0de3813cee7fd$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($1ae0de3813cee7fd$var$HeaderIcon);
var $1ae0de3813cee7fd$export$2e2bcd8739ae039 = $1ae0de3813cee7fd$var$_default_1;




const $32d059b94ccba6f8$var$selector = (states)=>{
    return {
        showContextPanel: states.extensionState?.showContextPanel,
        extensionProvider: states.extensionState?.extensionProvider,
        processParametersAfter: states.extensionState?.processParametersAfter
    };
};
function $32d059b94ccba6f8$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $32d059b94ccba6f8$var$selector);
    (0, $cozmU.useEffect)(()=>{
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $32d059b94ccba6f8$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api) {
    const closePanelById = api?.contextPanel?.actions?.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $32d059b94ccba6f8$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos?.node.attrs;
        const extensionType = nodeAttrs?.extensionType;
        const extensionKey = nodeAttrs?.extensionKey;
        /**
     * Loading extension manifest fails when using
     * 	extensionKey directly from nodeAttrs.
     * Always get extensionKey from getExtensionKeyAndNodeKey to load
     * 	extension manifest successfully.
     */ const [extKey, _] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1ae0de3813cee7fd$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $923147737bfc3fc6$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $32d059b94ccba6f8$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
                    /**
           * 	If context panel is open, then first update extension plugin state.
           * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
           * 		which will call hideConfigPanel.
           */ if (extensionState?.showContextPanel) {
                        await $32d059b94ccba6f8$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $fJUEv.CONFIG_PANEL_WIDTH));
    }
}
async function $32d059b94ccba6f8$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    const applyChange = api?.contextPanel?.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $32d059b94ccba6f8$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorState = editorView.state;
    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
                duration: 5000,
                visible: true,
                children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: async (updatedParameters)=>{
                            await (0, $fc213d5917462889$export$2f221d4ebb46923c)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onCancel: ()=>$32d059b94ccba6f8$export$237eef05f48e1226({
                                api: api,
                                editorView: editorView
                            }),
                        featureFlags: featureFlags,
                        // Remove below prop when cleaning platform_editor_ai_object_sidebar_injection FG
                        // Becuase it will always be true
                        usingObjectSidebarPanel: true
                    });
                }
            })
        });
};


const $bd6dbeefb66a82f7$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $fJUEv.CONFIG_PANEL_ID)}-${(0, $03RpJ.default)()}`;
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const extensionLoadingHandlers = {};
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $iDrrr.fg)('cc_maui_annotations_on_extensions') ? (0, $hVgcP.extensionWithAnnotationStage0) : (0, $hVgcP.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $b098027f4699dcb1$export$1a85854d3d541a64)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $20WsY.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $ixHGM.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $ixHGM.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel,
                extensionProvider: pluginState?.extensionProvider,
                processParametersAfter: pluginState?.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $584598053f9859f0$export$ae829ec7b2625219)(dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight,
                            allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
                        }, featureFlags, options?.__rendererExtensionOptions, getIntl());
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $d40259b0c24668cb$export$2e2bcd8739ae039)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $f28c64404a6658d7$export$ae829ec7b2625219)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $bf6f7e4036588680$export$ae829ec7b2625219)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            getExtensionLoadingHandlers: ()=>extensionLoadingHandlers,
            insertMacroFromMacroBrowser: (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$f151d046c10e64b5)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$8ee156b55126996c)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $5313dd79acf665fc$export$1efb7858e16078f5)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            registerExtensionLoadingHandler: ({ extensionType: extensionType, handler: handler })=>{
                extensionLoadingHandlers[extensionType] = handler;
                return ()=>{
                    if (extensionLoadingHandlers[extensionType] === handler) delete extensionLoadingHandlers[extensionType];
                };
            },
            runMacroAutoConvert: $783fd49d73f6388e$export$774dc72aee79b8eb,
            forceAutoSave: $3d915853de2ecd5c$export$265d048971b3d878
        },
        pluginsOptions: {
            floatingToolbar: (0, $7d58a2ee0cc4b964$export$86ce8f8241c20a3)({
                breakoutEnabled: options.breakoutEnabled,
                copyEnabled: options.copyEnabled,
                deleteEnabled: options.deleteEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: // if showContextPanel action is not available, or platform_editor_ai_object_sidebar_injection feature flag is off
            // 	then keep using old context panel.
            !showContextPanel || !(0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? (0, $fc213d5917462889$export$7c8c60c0acb92731)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel && (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? ({ editorView: editorView })=>{
            (0, $32d059b94ccba6f8$export$781dfcd068e3a2e0)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};
module.exports["extensionPlugin"] = $bd6dbeefb66a82f7$export$feb99ebbc74a9193;

});

parcelRegister("fJUEv", function(module, exports) {
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $2549d8cb406fc6f5$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $2549d8cb406fc6f5$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5 = 320;
const $2549d8cb406fc6f5$export$cb69418acbe13bc2 = 'extensions-panel';
module.exports["ALLOWED_LOGGED_MACRO_PARAMS"] = $2549d8cb406fc6f5$export$2a99ab8c82908148;
module.exports["ALLOWED_PARAM_TYPES"] = $2549d8cb406fc6f5$export$d17c9f402b8c93c8;
module.exports["CONFIG_PANEL_WIDTH"] = $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5;
module.exports["CONFIG_PANEL_ID"] = $2549d8cb406fc6f5$export$cb69418acbe13bc2;

});

parcelRegister("fjZlw", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3nm9z = parcelRequire("3nm9z");


var $1VhsF = parcelRequire("1VhsF");


var $lfoFx = parcelRequire("lfoFx");

function $1b8a019e594923bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b8a019e594923bc$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $1b8a019e594923bc$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $1b8a019e594923bc$var$LoadingStateWithErrorHandling = (0, $kSwu1.injectIntl)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1VhsF.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $3nm9z.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $1b8a019e594923bc$var$LoadingState = (props)=>$1b8a019e594923bc$var$LoadingStateWithErrorHandling(props);
var $1b8a019e594923bc$export$2e2bcd8739ae039 = $1b8a019e594923bc$var$LoadingState;
module.exports["default"] = $1b8a019e594923bc$export$2e2bcd8739ae039;

});

parcelRegister("4N8T6", function(module, exports) {

let $37d2a1f196eb661b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $37d2a1f196eb661b$var$load("6wr18"),
    $37d2a1f196eb661b$var$load("6dLts"),
    $37d2a1f196eb661b$var$load("jdPbE"),
    $37d2a1f196eb661b$var$load("eUsnQ"),
    $37d2a1f196eb661b$var$load("6C7Vr"),
    $37d2a1f196eb661b$var$load("Wowvf"),
    $37d2a1f196eb661b$var$load("iWnyc"),
    $37d2a1f196eb661b$var$load("7EorR"),
    $37d2a1f196eb661b$var$load("hhss7"),
    $37d2a1f196eb661b$var$load("ffEVr"),
    $37d2a1f196eb661b$var$load("8GyM5")
]).then(()=>parcelRequire('jqjhk'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("jND0n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




const $aef92eb44b339a57$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $aef92eb44b339a57$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $aef92eb44b339a57$var$safeError('Missing AbortController');
    return new AbortController();
};
function $aef92eb44b339a57$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $cozmU.useMemo)(()=>$aef92eb44b339a57$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $cozmU.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    (0, $cozmU.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}


function $b16dcb6878bf018c$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    const [value, setValue] = (0, $cozmU.useState)(initialValue);
    (0, $aef92eb44b339a57$export$daf4e774a28efe06)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}
module.exports["useStateFromPromise"] = $b16dcb6878bf018c$export$4960a9d54b2095bb;

});

parcelRegister("7eCZG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $9GVkD = parcelRequire("9GVkD");

const $2bc440c5b7704872$var$accessibilityUtilsPluginKey = new (0, $kCECX.PluginKey)('accessibilityUtilsPlugin');
const $2bc440c5b7704872$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($2bc440c5b7704872$var$accessibilityUtilsPluginKey, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2bc440c5b7704872$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $2bc440c5b7704872$var$accessibilityUtilsPluginKey.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: $2bc440c5b7704872$var$accessibilityUtilsPluginKey,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($2bc440c5b7704872$var$accessibilityUtilsPluginKey);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $2bc440c5b7704872$var$ContentComponent({ api: api }) {
    const { ariaLiveElementAttributes: ariaLiveElementAttributes, key: key, message: message } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'accessibilityUtils'
    ], (states)=>{
        return {
            ariaLiveElementAttributes: states.accessibilityUtilsState?.ariaLiveElementAttributes,
            key: states.accessibilityUtilsState?.key,
            message: states.accessibilityUtilsState?.message
        };
    });
    const role = ariaLiveElementAttributes?.priority === 'important' ? 'alert' : 'status';
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        },
        children: message
    });
}
module.exports["accessibilityUtilsPlugin"] = $2bc440c5b7704872$export$8bab9b7a6db7fbeb;

});

parcelRegister("dYbu7", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $luPs0 = parcelRequire("luPs0");


var $jkcNT = parcelRequire("jkcNT");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");





var $9WBFV = parcelRequire("9WBFV");


var $eEdSM = parcelRequire("eEdSM");


var $kCECX = parcelRequire("kCECX");

/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $4206d88bb6bf09d0$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        const { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $kCECX.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $4206d88bb6bf09d0$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $9WBFV.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $9WBFV.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ]))(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = tr.doc.type.schema;
        const alignmentApplied = (0, $9WBFV.toggleBlockMarkNext)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $9WBFV.changeImageAlignment)(align))(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const alignmentApplied = (0, $9WBFV.changeImageAlignmentNext)(align)(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $4206d88bb6bf09d0$export$7364e99daa3bbf34 = (align, api, inputMethod)=>(state, dispatch)=>{
        return $4206d88bb6bf09d0$var$cascadeCommands([
            $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod),
            $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod)
        ])(state, dispatch);
    };
const $4206d88bb6bf09d0$export$69636f7bd4c47a65 = (api, align, inputMethod)=>({ tr: tr })=>{
        $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        return tr;
    };


function $6e1ab1814f069c0a$export$e832373cff8dec22(api) {
    const list = {};
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignLeft).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('start', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignCenter).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('center', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignRight).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('end', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    return (0, $eBSR7.keymap)(list);
}



var $kpCD8 = parcelRequire("kpCD8");






var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");

const $ec4ef7b6447b9bb9$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $8HW7o.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $bjg0G.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};


function $35e6e74aabe4f7bc$var$createInitialPluginState(editorState, pluginConfig) {
    return {
        align: (0, $ec4ef7b6447b9bb9$export$fcb629559422d129)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $35e6e74aabe4f7bc$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('alignmentPlugin');
function $35e6e74aabe4f7bc$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $kpCD8.SafePlugin)({
        key: $35e6e74aabe4f7bc$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $35e6e74aabe4f7bc$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextPluginState = (0, $ec4ef7b6447b9bb9$export$fcb629559422d129)(nextState);
                const isEnabled = (0, $4206d88bb6bf09d0$export$f3f99b2459c4a09f)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($35e6e74aabe4f7bc$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}






var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");





var $d4948231fc8e9cf5$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $kSwu1 = parcelRequire("kSwu1");





var $5NB3T = parcelRequire("5NB3T");


var $6keIx = parcelRequire("6keIx");

var $hYOVX = parcelRequire("hYOVX");

var $12XbP = parcelRequire("12XbP");

var $5ttHX = parcelRequire("5ttHX");

var $5aXzT = parcelRequire("5aXzT");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");





/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");













parcelRequire("cozmU");
















const $4c7fa596df2cd7ed$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
        label: (0, $5NB3T.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
        label: (0, $5NB3T.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
        label: (0, $5NB3T.alignmentMessages).alignCenter
    }
};
const $4c7fa596df2cd7ed$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $4c7fa596df2cd7ed$var$iconAndMessageMap[props.alignment];
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};





parcelRequire("cozmU");







function $ae14d841fc6b2664$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $ldqjS.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content,
        titlePosition: 'bottom'
    });
}
var $ae14d841fc6b2664$export$2e2bcd8739ae039 = $ae14d841fc6b2664$var$AlignmentButton;


const $0b4982f0f832bb7b$var$alignmentWrapper = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $0b4982f0f832bb7b$var$alignmentWrapperStylesUnbounded = null;
const $0b4982f0f832bb7b$var$alignCenterKeyboardShortcut = (0, $ldqjS.alignCenter);
const $0b4982f0f832bb7b$var$alignRightKeyboardShortcut = (0, $ldqjS.alignRight);
const $0b4982f0f832bb7b$var$alignmentOptions = [
    {
        title: (0, $5NB3T.alignmentMessages).alignLeft,
        shortcut: (0, $ldqjS.alignLeft),
        value: 'start'
    },
    {
        title: (0, $5NB3T.alignmentMessages).alignCenter,
        shortcut: $0b4982f0f832bb7b$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $5NB3T.alignmentMessages).alignRight,
        shortcut: $0b4982f0f832bb7b$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $0b4982f0f832bb7b$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "alignment-buttons",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0Of8r2Pgdg _1wydGWPgdg _2Zuz6Q2ADO _1Znuxb2ADO _1EqgXlQEt6 _17lj8pFQfX",
            "_3qgovSYbGa",
            className
        ]),
        children: $0b4982f0f832bb7b$var$alignmentOptions.map((alignment)=>{
            const { value: value, title: title, shortcut: shortcut } = alignment;
            const message = intl.formatMessage(title);
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ae14d841fc6b2664$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                    alignment: value
                }),
                value: value,
                label: message,
                shortcut: shortcut,
                onClick: onClick,
                isSelected: value === selectedAlignment
            }, value);
        })
    });
}
const $0b4982f0f832bb7b$var$_default_1 = (0, $kSwu1.injectIntl)($0b4982f0f832bb7b$var$Alignment);
var $0b4982f0f832bb7b$export$2e2bcd8739ae039 = $0b4982f0f832bb7b$var$_default_1;



function $4f8fa5cbf32e9355$var$_defineProperty(e, r, t) {
    return (r = $4f8fa5cbf32e9355$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f8fa5cbf32e9355$var$_toPropertyKey(t) {
    var i = $4f8fa5cbf32e9355$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4f8fa5cbf32e9355$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $4f8fa5cbf32e9355$var$AlignmentToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, align: align, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = align ?? 'start';
        const title = intl.formatMessage((0, $5NB3T.alignmentMessages).alignment);
        const alignmentLabelMap = {
            start: intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft),
            center: intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter),
            end: intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight)
        };
        const ariaLabel = `${title}, ${alignmentLabelMap[alignment] ?? ''}`;
        const reducedSpacing = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? 'compact' : 'none';
        const items = [
            {
                key: 'alignmentLeft',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft),
                value: {
                    name: 'start'
                },
                isActive: align === 'start',
                elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                    children: (0, $ldqjS.tooltip)((0, $ldqjS.alignLeft))
                }),
                elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                    label: ""
                })
            },
            {
                key: 'alignmentCenter',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter),
                value: {
                    name: 'center'
                },
                isActive: align === 'center',
                elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                    children: (0, $ldqjS.tooltip)((0, $ldqjS.alignCenter))
                }),
                elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                    label: ""
                })
            },
            {
                key: 'alignmentRight',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight),
                value: {
                    name: 'end'
                },
                isActive: align === 'end',
                elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                    children: (0, $ldqjS.tooltip)((0, $ldqjS.alignRight))
                }),
                elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))), {
                    label: ""
                })
            }
        ];
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $12XbP.ToolbarDropdownWrapper), {
            children: [
                (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    items: [
                        {
                            items: items
                        }
                    ],
                    isOpen: isOpen,
                    onItemActivated: this.handleOnItemActivated,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onOpenChange: (attrs)=>this.setState({
                            isOpen: attrs?.isOpen
                        }),
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    fitWidth: 200,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        "aria-label": ariaLabel,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hYOVX.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ttHX.ToolbarExpandIcon), {})
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    isOpen: isOpen,
                    handleClickOutside: (event)=>{
                        if (event instanceof MouseEvent) this.hide({
                            isOpen: false,
                            event: event
                        });
                    },
                    handleEscapeKeydown: this.hideOnEscape,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    },
                    fitWidth: 112,
                    fitHeight: 80,
                    closeOnTab: true,
                    trigger: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldbHR.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        className: "align-btn",
                        "aria-label": ariaLabel,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hYOVX.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ttHX.ToolbarExpandIcon), {})
                            ]
                        }),
                        ref: this.toolbarItemRef
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b4982f0f832bb7b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    ), {
                        onClick: (align)=>this.changeAlignment(align, false),
                        selectedAlignment: alignment
                    })
                }),
                !api?.primaryToolbar && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5aXzT.ToolbarSeparator), {})
            ]
        });
    }
    componentDidUpdate(_prevProps) {
        if (this.props.toolbarType !== (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).FLOATING && this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.toolbarItemRef.current?.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args);
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toolbarItemRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $4f8fa5cbf32e9355$var$_defineProperty(this, "state", {
            isOpen: false
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "changeAlignment", (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toggleOpen", ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toggleOpenByKeyboard", (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "handleOnItemActivated", ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>this.changeAlignment(item.value.name, shouldCloseMenu));
        $4f8fa5cbf32e9355$var$_defineProperty(this, "hide", (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if (attrs?.event instanceof KeyboardEvent && attrs.event.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "hideOnEscape", ()=>{
            this.hide();
            this.toolbarItemRef?.current?.focus();
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
$4f8fa5cbf32e9355$var$_defineProperty($4f8fa5cbf32e9355$var$AlignmentToolbar, "displayName", 'AlignmentToolbar');
const $4f8fa5cbf32e9355$var$_default_1 = (0, $kSwu1.injectIntl)($4f8fa5cbf32e9355$var$AlignmentToolbar);
var $4f8fa5cbf32e9355$export$2e2bcd8739ae039 = $4f8fa5cbf32e9355$var$_default_1;


const $6c9b0dc1d976046d$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true
};
function $6c9b0dc1d976046d$export$b15abb95157a91c7({ api: api, editorView: editorView }) {
    const { align: align, isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $cozmU.useCallback)((align)=>{
        return (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)(align, api, (0, $krYZG.INPUT_METHOD).FLOATING_TB)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4f8fa5cbf32e9355$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? false : $6c9b0dc1d976046d$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: $6c9b0dc1d976046d$var$FloatingToolbarSettings.disabled || !isEnabled,
        toolbarType: (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).FLOATING,
        api: api
    });
}

















function $d6389b7d9d757985$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { align: align, isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $cozmU.useCallback)((align)=>(0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)(align, api, (0, $krYZG.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch), [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4f8fa5cbf32e9355$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api,
        toolbarType: (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).PRIMARY
    });
}





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




parcelRequire("cozmU");











var $a6nzD = parcelRequire("a6nzD");

var $lslMH = parcelRequire("lslMH");



















const $594f5b856ab4c87c$export$8a5a39b03f4aaab = ()=>({
        start: {
            key: (0, $3nacY.ALIGN_LEFT_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_LEFT_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_LEFT_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignLeft,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
            keymap: (0, $ldqjS.alignLeft)
        },
        center: {
            key: (0, $3nacY.ALIGN_CENTER_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_CENTER_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_CENTER_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignCenter,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
            keymap: (0, $ldqjS.alignCenter)
        },
        end: {
            key: (0, $3nacY.ALIGN_RIGHT_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_RIGHT_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_RIGHT_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignRight,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
            keymap: (0, $ldqjS.alignRight)
        }
    });


const $3e48004ecc148ec6$export$4301fcd45f99f8a5 = ({ children: children, api: api })=>{
    const { align: align = 'start', isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>({
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        }));
    const { icon: Icon } = (0, $594f5b856ab4c87c$export$8a5a39b03f4aaab)()[align];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $5NB3T.alignmentMessages).alignment);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            size: "small",
            testId: `text-alignment-menu-${align}-icon`
        }),
        isDisabled: !isEnabled,
        testId: "text-alignment-menu",
        label: title,
        tooltipComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: title
        }),
        children: children
    });
};





parcelRequire("cozmU");











var $is7KY = parcelRequire("is7KY");


var $dVKvM = parcelRequire("dVKvM");

var $i9j2V = parcelRequire("i9j2V");


const $28ee2ef9ecf5849d$export$ff21a61af4a241d = ({ option: { label: label, icon: Icon, keymap: keymap }, api: api, alignment: alignment, parents: parents })=>{
    const { align: align } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align
        };
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shortcut = (0, $ldqjS.tooltip)(keymap);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        isSelected: align === alignment,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }),
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)(keymap),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            api?.core.actions.execute((0, $4206d88bb6bf09d0$export$69636f7bd4c47a65)(api, alignment, (0, $is7KY.getInputMethodFromParentKeys)(parents)));
        },
        children: formatMessage(label)
    });
};





parcelRequire("cozmU");





var $jgJIe = parcelRequire("jgJIe");

const $b6c847e432bd5d2d$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3nacY.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};



const $2ac7a5076f35ec99$var$getAlignmentMenuItems = (api)=>{
    return Object.entries((0, $594f5b856ab4c87c$export$8a5a39b03f4aaab)()).map(([alignment, item])=>{
        const { key: key, type: type, rank: rank } = item;
        return {
            type: type,
            key: key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_MENU_SECTION).type,
                    key: (0, $3nacY.ALIGNMENT_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $28ee2ef9ecf5849d$export$ff21a61af4a241d), {
                    api: api,
                    option: item,
                    alignment: alignment,
                    parents: parents
                });
            }
        };
    });
};
const $2ac7a5076f35ec99$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            type: (0, $3nacY.ALIGNMENT_GROUP).type,
            key: (0, $3nacY.ALIGNMENT_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION).type,
                    key: (0, $3nacY.TEXT_SECTION).key,
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.ALIGNMENT_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.ALIGNMENT_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.ALIGNMENT_MENU).type,
            key: (0, $3nacY.ALIGNMENT_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_GROUP).type,
                    key: (0, $3nacY.ALIGNMENT_GROUP).key,
                    rank: (0, $hVLmg.ALIGNMENT_GROUP_RANK)[(0, $3nacY.ALIGNMENT_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3e48004ecc148ec6$export$4301fcd45f99f8a5), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.ALIGNMENT_MENU_SECTION).type,
            key: (0, $3nacY.ALIGNMENT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_MENU).type,
                    key: (0, $3nacY.ALIGNMENT_MENU).key,
                    rank: (0, $hVLmg.ALIGNMENT_MENU_RANK)[(0, $3nacY.ALIGNMENT_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.ALIGNMENT_MENU_SECTION).key]
                }
            ],
            component: (0, $b6c847e432bd5d2d$export$4b1545b4f2016d26)
        },
        ...$2ac7a5076f35ec99$var$getAlignmentMenuItems(api)
    ];
};


const $d4ff49a147e1ecac$var$defaultConfig = {
    align: 'start'
};
const $d4ff49a147e1ecac$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d6389b7d9d757985$export$94516d5cccf573e3), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2ac7a5076f35ec99$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'alignment',
        component: primaryToolbarComponent
    });
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $luPs0.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $35e6e74aabe4f7bc$export$18d4026d1ea86bb1).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $35e6e74aabe4f7bc$export$ae829ec7b2625219)(dispatch, $d4ff49a147e1ecac$var$defaultConfig)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $6e1ab1814f069c0a$export$e832373cff8dec22)(api)
                }
            ];
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : ()=>{
                const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6c9b0dc1d976046d$export$b15abb95157a91c7), {
                                api: api,
                                editorView: view
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 4,
                        pluginName: 'alignment'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["alignmentPlugin"] = $d4ff49a147e1ecac$export$48e8beb2d4cfb048;

});

parcelRegister("gLxaI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $epbW8 = parcelRequire("epbW8");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $jkcNT = parcelRequire("jkcNT");





var $krYZG = parcelRequire("krYZG");

var $1SZMn = parcelRequire("1SZMn");


var $kCECX = parcelRequire("kCECX");


var $cI8RZ = parcelRequire("cI8RZ");





var $8nvEM = parcelRequire("8nvEM");


var $ieeJu = parcelRequire("ieeJu");




var $0bdaad0e85f57dec$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
    ACTIONS[ACTIONS["SET_HOVERED_ANNOTATION"] = 8] = "SET_HOVERED_ANNOTATION";
    ACTIONS[ACTIONS["FLUSH_PENDING_SELECTIONS"] = 9] = "FLUSH_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_PENDING_SELECTIONS"] = 10] = "SET_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_INLINE_COMMENTS_FETCHED"] = 11] = "SET_INLINE_COMMENTS_FETCHED";
    return ACTIONS;
}({});









var $3mJu6 = parcelRequire("3mJu6");


var $eSYrd = parcelRequire("eSYrd");


var $fRYCB = parcelRequire("fRYCB");

var $gWBVp = parcelRequire("gWBVp");








var $iDrrr = parcelRequire("iDrrr");

var $4dfa7de3992b5086$export$ad08e20e7e22e394 = /*#__PURE__*/ function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    AnnotationSelectionType["DISABLED"] = "disabled";
    AnnotationSelectionType["VALID"] = "valid";
    return AnnotationSelectionType;
}({});
const $4dfa7de3992b5086$var$prefix = 'ak-editor-annotation';
const $4dfa7de3992b5086$export$711f43d01b7e0019 = {
    prefix: $4dfa7de3992b5086$var$prefix,
    floatingComponent: `${$4dfa7de3992b5086$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$4dfa7de3992b5086$var$prefix}-toolbar-create-button`,
    componentSave: `${$4dfa7de3992b5086$var$prefix}-dummy-save-button`,
    componentClose: `${$4dfa7de3992b5086$var$prefix}-dummy-close-button`
};


function $f5fb2d59ed261397$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $f5fb2d59ed261397$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $f5fb2d59ed261397$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $f5fb2d59ed261397$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $f5fb2d59ed261397$export$c023470e9a462982($from).map($f5fb2d59ed261397$var$filterAnnotationIds);
    annotations.sort((a, b)=>$f5fb2d59ed261397$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $f5fb2d59ed261397$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $f5fb2d59ed261397$export$2ecc008effaefd6e = (doc)=>{
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($f5fb2d59ed261397$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
/*
 * verifies if annotation mark contains valid attributes
 */ const $f5fb2d59ed261397$var$validateAnnotationMark = (annotationMark)=>{
    const { id: id, annotationType: annotationType } = annotationMark.attrs;
    return validateAnnotationId(id) && validateAnnotationType(annotationType);
    function validateAnnotationId(id) {
        if (!id || typeof id !== 'string') return false;
        const invalidIds = [
            'null',
            'undefined'
        ];
        return !invalidIds.includes(id.toLowerCase());
    }
    function validateAnnotationType(type) {
        if (!type || typeof type !== 'string') return false;
        const allowedTypes = Object.values((0, $epbW8.AnnotationTypes));
        return allowedTypes.includes(type);
    }
};
const $f5fb2d59ed261397$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $f5fb2d59ed261397$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $8nvEM.Decoration).node(start, end, {
        class: `${(0, $eSYrd.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $f5fb2d59ed261397$export$824a8ce0be7d4e38.block
    });
    return (0, $8nvEM.Decoration).inline(start, end, {
        class: `${(0, $eSYrd.AnnotationSharedClassNames).draft}`
    }, {
        key: $f5fb2d59ed261397$export$824a8ce0be7d4e38.inline
    });
};
const $f5fb2d59ed261397$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $f5fb2d59ed261397$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $kCECX.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>node?.type.name === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    const anchorAnnotationMarks = node?.marks || [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    if (nodeBefore && annotationMark.isInSet(nodeBefore.marks)) {
        const existingMarkIds = marks.map((m)=>m.attrs.id);
        marks = marks.concat(...nodeBefore.marks.filter((m)=>!existingMarkIds.includes(m.attrs.id)));
    }
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $f5fb2d59ed261397$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $f5fb2d59ed261397$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [], isBlockNodeSupported)=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $kCECX.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            const isLegacyMediaSingleWrapper = node.type.name === 'mediaSingle' && supportedBlockNodes.includes('media') && !supportedBlockNodes.includes('mediaSingle');
            if ($f5fb2d59ed261397$export$bb7c9ea7da92cd01(node, supportedBlockNodes, isBlockNodeSupported) && !isLegacyMediaSingleWrapper) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $f5fb2d59ed261397$export$31c5af77b755d41f(editorState, bookmark) {
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $f5fb2d59ed261397$export$544b399faf6001b7 = new (0, $kCECX.PluginKey)('inlineCommentPluginKey');
const $f5fb2d59ed261397$export$f05434c51e3762e = (state)=>{
    return $f5fb2d59ed261397$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $f5fb2d59ed261397$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $fRYCB.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $f5fb2d59ed261397$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) attributes = {
            inputMethod: inputMethod,
            overlap: $f5fb2d59ed261397$var$getAnnotationsInSelectionCount(state)
        };
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $f5fb2d59ed261397$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $f5fb2d59ed261397$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $f5fb2d59ed261397$export$af7e6fc08350a63d = (state, supportedBlockNodes = [], isBlockNodeSupported)=>{
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $f5fb2d59ed261397$export$f05434c51e3762e(state) || {};
    const allowedInlineNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const isSelectionEmpty = selection.empty;
    const isTextOrAllSelection = selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.AllSelection);
    const isSupportedBlockNodeSelection = selection instanceof (0, $kCECX.NodeSelection) && $f5fb2d59ed261397$export$bb7c9ea7da92cd01(selection.node, supportedBlockNodes, isBlockNodeSupported);
    const isValidNodeSelection = selection instanceof (0, $kCECX.NodeSelection) && (allowedInlineNodes.includes(selection.node.type.name) || isSupportedBlockNodeSelection);
    const isValidSelection = isTextOrAllSelection || isValidNodeSelection;
    // Allow media so that it can enter draft mode
    if ((0, $3mJu6.currentMediaNodeWithPos)(state)?.node) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
    if (isSelectionEmpty || !isValidSelection) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const containsInvalidNodes = !isSupportedBlockNodeSelection && $f5fb2d59ed261397$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    if (containsInvalidNodes) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
    if (disallowOnWhitespace && $f5fb2d59ed261397$export$6d32268ea00f42b0(selection, state.schema)) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) && (0, $fRYCB.isEmptyTextSelection)(selection, state.schema)) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
};
const $f5fb2d59ed261397$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $fRYCB.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
const $f5fb2d59ed261397$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [], isBlockNodeSupported)=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0 || (0, $iDrrr.fg)('cc_maui_annotations_on_extensions') && isBlockNodeSupported?.(node) === true;
};
function $f5fb2d59ed261397$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $gWBVp.isText)(node, schema)) {
            if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node.eq(content.lastChild) && // and there are multiple nodes
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $gWBVp.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $f5fb2d59ed261397$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $f5fb2d59ed261397$export$f05434c51e3762e(state);
    return !!commentsPluginState?.annotations && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $f5fb2d59ed261397$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $fRYCB.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $f5fb2d59ed261397$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $f5fb2d59ed261397$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $f5fb2d59ed261397$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $kCECX.NodeSelection)) {
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = node?.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            })) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};
const $f5fb2d59ed261397$export$98b0a2a6ba343064 = (state)=>{
    const annotations = $f5fb2d59ed261397$export$f05434c51e3762e(state)?.annotations;
    if (annotations) {
        /**
     * annotations type is { [key: string]: boolean };
     * Here, key represents mark.attr.id and it is used to find where annotation to be presented in the document.
     * When value is false, it means it is unresolved annotation.
     *
     * But sometimes annotation map has entry with key undefined somehow.
     * And it is not valid mark attribute id, so it won't be presented anywhere in the document.
     */ const unresolvedAnnotationKeys = Object.keys(annotations).filter((key)=>key !== 'undefined' && annotations[key] === false);
        return unresolvedAnnotationKeys.length > 0;
    }
    return false;
};


var $31323b7e8bd0e126$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED:
            return {
                ...pluginState,
                annotationsLoaded: true
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotationsLoaded: true,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE:
            return $31323b7e8bd0e126$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.supportedBlockNodes, action.data.isBlockNodeSupported, action.data.targetNodeId, action.data.isOpeningMediaCommentFromToolbar);
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false,
                isOpeningMediaCommentFromToolbar: false,
                selectedAnnotations: []
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).ADD_INLINE_COMMENT:
            const updatedPluginState = $31323b7e8bd0e126$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined,
                ...pluginState.isAnnotationManagerEnabled && {
                    skipSelectionHandling: true
                }
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $31323b7e8bd0e126$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false,
                isOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION:
            return {
                ...pluginState,
                hoveredAnnotations: [
                    ...action.data.hoveredAnnotations
                ],
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS:
            return {
                ...pluginState,
                selectedAnnotations: action.data.canSetAsSelectedAnnotations ? [
                    ...pluginState.pendingSelectedAnnotations
                ] : pluginState.selectedAnnotations,
                pendingSelectedAnnotations: [],
                isInlineCommentViewClosed: false
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS:
            return {
                ...pluginState,
                pendingSelectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $31323b7e8bd0e126$var$getNewDraftState(pluginState, drafting, editorState, targetType, supportedBlockNodes, isBlockNodeSupported, targetNodeId, isOpeningMediaCommentFromToolbar) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $8nvEM.DecorationSet).empty;
    const newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(editorState, newState.bookmark, supportedBlockNodes, isBlockNodeSupported);
        const draftDecoration = (0, $f5fb2d59ed261397$export$b3b680ab7872fa4c)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    newState.isOpeningMediaCommentFromToolbar = isOpeningMediaCommentFromToolbar;
    return newState;
}



const $42647913cd19dc49$var$handleDocChanged = (tr, prevPluginState)=>{
    if (!tr.getMeta('replaceDocument')) return $42647913cd19dc49$var$getSelectionChangedHandler(false)(tr, prevPluginState);
    return {
        ...prevPluginState,
        dirtyAnnotations: true
    };
};
/**
 * Creates a handleDocChanged function with its own deleted annotations cache.
 * This ensures each editor instance has its own cache, avoiding cross-contamination.
 */ const $42647913cd19dc49$var$createHandleDocChanged = ()=>{
    // Cache for preserving deleted annotation resolved states through delete/undo cycles
    // This lives in closure scope per editor instance to avoid serialization and reduce state size
    const deletedAnnotationsCache = {};
    return (tr, prevPluginState)=>{
        if (tr.getMeta('replaceDocument')) return {
            ...prevPluginState,
            dirtyAnnotations: true
        };
        const updatedState = $42647913cd19dc49$var$getSelectionChangedHandler(false)(tr, prevPluginState);
        // Collect annotation IDs currently in the document
        const annotationIdsInDocument = new Set();
        tr.doc.descendants((node)=>{
            node.marks.forEach((mark)=>{
                if (mark.type.name === 'annotation') annotationIdsInDocument.add(mark.attrs.id);
            });
        });
        const annotationIdsInState = Object.keys(prevPluginState.annotations);
        // Early return if annotations haven't changed
        const annotationsHaveChanged = annotationIdsInDocument.size !== annotationIdsInState.length || annotationIdsInState.some((id)=>!annotationIdsInDocument.has(id));
        if (!annotationsHaveChanged) return updatedState;
        // Cache deleted annotations to be able to restore their resolved states on undo
        const updatedAnnotations = {};
        annotationIdsInState.forEach((id)=>{
            if (!annotationIdsInDocument.has(id)) deletedAnnotationsCache[id] = prevPluginState.annotations[id];
        });
        // Update annotations to match document state, preserving resolved states through delete/undo
        // Only include annotations that have a known resolved state - don't default new annotations to false
        // as this would cause them to briefly appear as unresolved before the provider sets their actual state
        annotationIdsInDocument.forEach((id)=>{
            const knownState = prevPluginState.annotations[id] ?? deletedAnnotationsCache[id];
            if (knownState !== undefined) updatedAnnotations[id] = knownState;
        });
        return {
            ...updatedState,
            annotations: updatedAnnotations
        };
    };
};
const $42647913cd19dc49$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $kCECX.NodeSelection)) {
        const bookmarkSelection = bookmark?.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $kCECX.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
			 * Currently, after updating the alt text of a mediaSingle node,
			 * the selection moves to the media node.
			 * (then will append a transaction to its parent node)
			 */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') return !bookmarkNode.firstChild?.eq(selectionNode);
            else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $42647913cd19dc49$var$getSelectionChangeHandlerOld = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (// If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $f5fb2d59ed261397$export$e171deb7d9f0a865)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $f5fb2d59ed261397$export$3bf994b39b13856a)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $f5fb2d59ed261397$export$a411569b9111c88e)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $42647913cd19dc49$var$getSelectionChangeHandlerNew = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $f5fb2d59ed261397$export$3bf994b39b13856a)(tr.selection, tr.doc);
        // NOTE: I've left this commented code here as a reference that the previous old code would reset the selected annotations
        // if the selection is empty. If this is no longer needed, we can remove this code.
        // if (selectedAnnotations.length === 0) {
        // 	return {
        // 		...pluginState,
        // 		pendingSelectedAnnotations: selectedAnnotations,
        // 		pendingSelectedAnnotationsUpdateCount:
        // 			pluginState.pendingSelectedAnnotationsUpdateCount + 1,
        // 		isInlineCommentViewClosed: true,
        // 		selectAnnotationMethod: undefined,
        // 	};
        // }
        if ((0, $f5fb2d59ed261397$export$a411569b9111c88e)(selectedAnnotations, pluginState.pendingSelectedAnnotations)) return {
            ...pluginState,
            pendingSelectedAnnotations: selectedAnnotations,
            pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $42647913cd19dc49$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>pluginState.isAnnotationManagerEnabled ? $42647913cd19dc49$var$getSelectionChangeHandlerNew(reopenCommentView)(tr, pluginState) : $42647913cd19dc49$var$getSelectionChangeHandlerOld(reopenCommentView)(tr, pluginState);
// Create the handler with cache once at module level
const $42647913cd19dc49$var$handleDocChangedWithSync = $42647913cd19dc49$var$createHandleDocChanged();
const $42647913cd19dc49$var$getDocChangedHandler = (tr, prevPluginState)=>{
    // Check feature flag at runtime to support test variants
    if ((0, $ieeJu.expValEquals)('platform_editor_annotations_sync_on_docchange', 'isEnabled', true)) return $42647913cd19dc49$var$handleDocChangedWithSync(tr, prevPluginState);
    return $42647913cd19dc49$var$handleDocChanged(tr, prevPluginState);
};
const $42647913cd19dc49$var$dest = (0, $cI8RZ.pluginFactory)((0, $f5fb2d59ed261397$export$544b399faf6001b7), (0, $31323b7e8bd0e126$export$2e2bcd8739ae039), {
    onSelectionChanged: $42647913cd19dc49$var$getSelectionChangedHandler(true),
    onDocChanged: $42647913cd19dc49$var$getDocChangedHandler,
    mapping: (tr, pluginState, editorState)=>{
        const { draftDecorationSet: draftDecorationSet, bookmark: bookmark } = pluginState;
        let mappedDecorationSet = (0, $8nvEM.DecorationSet).empty, mappedBookmark;
        let hasMappedDecorations = false;
        if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
        hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $f5fb2d59ed261397$export$824a8ce0be7d4e38)).includes(spec.key)).length > 0;
        // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
        // we need to reset bookmark to hide create component and to avoid invalid draft being published
        // We only perform this change when document selection has changed.
        if (!hasMappedDecorations && $42647913cd19dc49$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: undefined
        };
        if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
        // return same pluginState if mappings did not change
        if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
        return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: mappedBookmark
        };
    }
});
const $42647913cd19dc49$export$656c7661095efe2e = $42647913cd19dc49$var$dest.createPluginState;
const $42647913cd19dc49$export$8d4021544bdece00 = $42647913cd19dc49$var$dest.createCommand;












var $bhf6v = parcelRequire("bhf6v");








var $eOaGc = parcelRequire("eOaGc");





const $1bac1a5a00358626$var$isAnnotationStep = (step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark.type.name === 'annotation';
const $1bac1a5a00358626$var$addAnnotationMark = (id, supportedBlockNodes, isBlockNodeSupported)=>(transaction, state)=>{
        const inlineCommentState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark, supportedBlockNodes, isBlockNodeSupported);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            const tr = (0, $bhf6v.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // The mark may not be applied to the current "head" of the bookmark so determine what was applied
            // above and use that instead
            const annotationMarkStep = tr.steps.reverse().find($1bac1a5a00358626$var$isAnnotationStep);
            const headBasedOnMark = from === head ? annotationMarkStep?.from : annotationMarkStep?.to;
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, headBasedOnMark ?? head));
        }
        return tr;
    };
const $1bac1a5a00358626$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes, isBlockNodeSupported)=>(transaction, state)=>{
            let tr = $1bac1a5a00358626$var$addAnnotationMark(id, supportedBlockNodes, isBlockNodeSupported)(transaction, state);
            editorAPI?.editorViewModeEffects?.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $1bac1a5a00358626$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $1bac1a5a00358626$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $krYZG.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $1bac1a5a00358626$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $f5fb2d59ed261397$export$a28639698c912d2c)(drafting, method)(state);
            editorAnalyticsAPI?.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const tr = $1bac1a5a00358626$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $1bac1a5a00358626$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark)
            });
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $1bac1a5a00358626$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $krYZG.ACTION).RESOLVED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$addPreemptiveGateErrorAnalytics = (editorAnalyticsAPI)=>(errorReason)=>(transaction, state)=>{
            const analyticsEvent = {
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorReason: errorReason
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$addDeleteAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {}
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $1bac1a5a00358626$var$_default_1 = {
    addAnnotationMark: $1bac1a5a00358626$var$addAnnotationMark,
    addInlineComment: $1bac1a5a00358626$var$addInlineComment,
    handleDraftState: $1bac1a5a00358626$var$handleDraftState,
    addOpenCloseAnalytics: $1bac1a5a00358626$var$addOpenCloseAnalytics,
    addInsertAnalytics: $1bac1a5a00358626$var$addInsertAnalytics,
    addResolveAnalytics: $1bac1a5a00358626$var$addResolveAnalytics,
    addPreemptiveGateErrorAnalytics: $1bac1a5a00358626$var$addPreemptiveGateErrorAnalytics,
    addDeleteAnalytics: $1bac1a5a00358626$var$addDeleteAnalytics
};
var $1bac1a5a00358626$export$2e2bcd8739ae039 = $1bac1a5a00358626$var$_default_1;


const $0592d2368c2c3f07$export$2c4e3be4c627582b = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('commenting')({
        tr: tr
    });
};
const $0592d2368c2c3f07$export$dc07a25f8edf98a5 = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('default')({
        tr: tr
    });
};


const $5a3eafd29b4d037d$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // TODO: EDF-716 - This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $1SZMn.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, (tr, state)=>transformer((0, $1bac1a5a00358626$export$2e2bcd8739ae039).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, transformer);
    };
const $5a3eafd29b4d037d$export$da26c8d097933b72 = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).CLOSE_COMPONENT
    });
const $5a3eafd29b4d037d$export$ffa869a92c2481c3 = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $5a3eafd29b4d037d$export$a3833f7fc842f6da = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED
    });
const $5a3eafd29b4d037d$export$940b79a08b19cea6 = (editorAnalyticsAPI)=>(canSetAsSelectedAnnotations, errorReason)=>{
        const command = {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS,
            data: {
                canSetAsSelectedAnnotations: canSetAsSelectedAnnotations
            }
        };
        if (!!errorReason) return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, (tr, state)=>(0, $1bac1a5a00358626$export$2e2bcd8739ae039).addPreemptiveGateErrorAnalytics(editorAnalyticsAPI)(errorReason)(tr, state));
        return (0, $42647913cd19dc49$export$8d4021544bdece00)(command);
    };
const $5a3eafd29b4d037d$export$a99e2fe25edc1abd = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], isBlockNodeSupported, state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    const selectedNodeIsSupported = selection instanceof (0, $kCECX.NodeSelection) && ((0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(selection.node, supportedBlockNodes, isBlockNodeSupported) || selection.node.type === state.schema.nodes.mediaSingle && !!selection.node.firstChild && (0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(selection.node.firstChild, supportedBlockNodes, isBlockNodeSupported));
    if (selectedNodeIsSupported) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $5a3eafd29b4d037d$export$75bee4cee90040 = (id, supportedNodes = [], isBlockNodeSupported)=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($5a3eafd29b4d037d$var$removeInlineCommentFromNode(id, supportedNodes, isBlockNodeSupported, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $5a3eafd29b4d037d$export$d087dc0f7213ba13 = (editorAnalyticsAPI)=>(id, supportedNodes = [], isBlockNodeSupported)=>(state, dispatch)=>{
            const { tr: tr } = state;
            state.doc.descendants((node, pos)=>{
                // Inline comment on mediaInline is not supported as part of comments on media project
                // Thus, we skip the decoration for mediaInline node
                if (node.type.name === 'mediaInline') return false;
                const isSupportedBlock = node.isBlock && (0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(node, supportedNodes, isBlockNodeSupported);
                node.marks.filter((mark)=>mark.type === state.schema.marks.annotation && mark.attrs.id === id).forEach((mark)=>{
                    if (isSupportedBlock) tr.removeNodeMark(pos, mark);
                    else tr.removeMark(pos, pos + node.nodeSize, mark);
                });
            });
            if (dispatch) {
                dispatch((0, $1bac1a5a00358626$export$2e2bcd8739ae039).addDeleteAnalytics(editorAnalyticsAPI)(tr, state));
                return true;
            }
            return false;
        };
const $5a3eafd29b4d037d$var$getDraftCommandAction = (drafting, targetType, targetNodeId, supportedBlockNodes, isBlockNodeSupported, isOpeningMediaCommentFromToolbar)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorState, supportedBlockNodes, isBlockNodeSupported) !== (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID) return false;
        return {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                supportedBlockNodes: supportedBlockNodes,
                isBlockNodeSupported: isBlockNodeSupported,
                targetNodeId: targetNodeId,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            }
        };
    };
};
const $5a3eafd29b4d037d$export$d80af6562490622d = (supportedBlockNodes = [], isBlockNodeSupported)=>(node, viewMethod, isOpeningMediaCommentFromToolbar)=>(state, dispatch)=>{
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && (0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(node, supportedBlockNodes, isBlockNodeSupported)) {
                const unresolvedAnnotationMarks = (node?.marks || []).filter((mark)=>mark.type === annotation && !pluginState?.annotations[mark.attrs.id]).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), {
                            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod,
                                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $5a3eafd29b4d037d$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [], api, isBlockNodeSupported)=>(drafting, inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR, targetType = 'inline', targetNodeId, isOpeningMediaCommentFromToolbar)=>{
        const commandAction = $5a3eafd29b4d037d$var$getDraftCommandAction(drafting, targetType, targetNodeId, supportedBlockNodes, isBlockNodeSupported, isOpeningMediaCommentFromToolbar);
        if (Boolean(api?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $1bac1a5a00358626$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)(state.tr, state);
            const newPluginState = commandAction(state);
            if (tr && newPluginState) {
                tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), newPluginState);
                if (drafting) (0, $0592d2368c2c3f07$export$2c4e3be4c627582b)(api, tr);
                else (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(api, tr);
                if (dispatch) dispatch(tr);
            } else return false;
            return true;
        };
        else return (0, $42647913cd19dc49$export$8d4021544bdece00)(commandAction, (0, $1bac1a5a00358626$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod));
    };
const $5a3eafd29b4d037d$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes, isBlockNodeSupported)=>{
        const commandAction = (editorState)=>({
                type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        if (Boolean(editorAPI?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $1bac1a5a00358626$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported)(state.tr, state);
            tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), commandAction(state));
            (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(editorAPI, tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
        else return (0, $42647913cd19dc49$export$8d4021544bdece00)(commandAction, (0, $1bac1a5a00358626$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported));
    };
const $5a3eafd29b4d037d$export$ef4c42f03863dce9 = (mouseData)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $5a3eafd29b4d037d$export$1e715f68ff6f5a2f = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$export$c1805eee6fd0cf44 = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION,
        data: {
            hoveredAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $epbW8.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes, isBlockNodeSupported)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $epbW8.AnnotationTypes).INLINE_COMMENT) return $5a3eafd29b4d037d$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported)(state, dispatch);
            return false;
        };
const $5a3eafd29b4d037d$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};





const $7cab94c6d4281aad$export$802ec1d716a6bb1 = {
    ...(0, $epbW8.annotation),
    toDOM: (node)=>{
        return [
            'span',
            {
                // Needs id as a reference point
                id: node.attrs.id,
                // Used to determine if the annotation is active
                annotationType: node.attrs.annotationType,
                // Below are used for prosemirror (ie. copy/paste behaviour)
                'data-mark-type': 'annotation',
                'data-mark-annotation-type': node.attrs.annotationType,
                'data-id': node.attrs.id
            },
            0
        ];
    }
};









var $kpCD8 = parcelRequire("kpCD8");















const $d252fa5145d6fd3d$export$b3ab33741101ad90 = (isUnresolved, hasFocus, isHovered)=>{
    if (!isUnresolved) return;
    if (hasFocus) return (0, $eSYrd.AnnotationSharedClassNames).focus;
    if (isHovered) return (0, $eSYrd.AnnotationSharedClassNames).hover;
    return (0, $eSYrd.AnnotationSharedClassNames).blur;
};
const $d252fa5145d6fd3d$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $eSYrd.BlockAnnotationSharedClassNames).focus : (0, $eSYrd.BlockAnnotationSharedClassNames).blur;
};









var $bjg0G = parcelRequire("bjg0G");




const $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED = 'draft-not-started';
const $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS = 'draft-in-progress';
const $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_MISSING = 'range-no-longer-exists';
const $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_INVALID = 'invalid-range';
const $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID = 'id-not-valid';
const $fcd3fd145d889c5a$var$domRefFromPos = (view, position)=>{
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $bjg0G.findDomRefAtPos)(position, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return undefined;
    }
    return dom;
};
const $fcd3fd145d889c5a$export$86f3258f283eb796 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return false;
        const decoration = draftDecorationSet?.find();
        // If a draft decoration exists then we should block the user from creating a new one.
        if (!!decoration?.length) return false;
        return (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorView.state, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported) === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
    };
const $fcd3fd145d889c5a$export$768048043e8d2bcd = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        if (!!selectedAnnotations?.length) {
            // if there are selected annotations when starting a draft, we need to clear the selected annotations
            // before we start the draft.
            (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            // not only that but we need to also deselect any other annotations that are currently selected.
            selectedAnnotations?.forEach((annotation)=>{
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: annotation.id,
                        isSelected: false,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                    }
                });
            });
        }
        (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, options.provider.supportedBlockNodes, options.api, options.provider.isBlockNodeSupported)(true)(editorView.state, editorView.dispatch);
        const { draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        const decorations = draftDecorationSet?.find();
        // If the matching decorations is not found containing the id, it means something went wrong with the draft.
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_INVALID
        };
        const from = decorations[0].from;
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        options.annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                targetElement: targetElement,
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes
            }
        });
        return {
            success: true,
            targetElement: targetElement,
            // In Editor the action result is undefined, because the editor will perform the transaction on the document.
            actionResult: undefined,
            inlineNodeTypes: inlineNodeTypes
        };
    };
const $fcd3fd145d889c5a$export$eeeb486534738631 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        return {
            success: true
        };
    };
const $fcd3fd145d889c5a$export$8bc7b93e04771bda = (editorView, options)=>(id)=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet, bookmark: bookmark } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length || !bookmark) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_MISSING
        };
        const from = decorations[0].from;
        (0, $5a3eafd29b4d037d$export$51eda81011da4982)(options.editorAnalyticsAPI, options.api)(id, (0, $epbW8.AnnotationTypes).INLINE_COMMENT, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        // Using the original decoration from position we should be able to locate the new target element.
        // This is because the new annotation will be created at the same position as the draft decoration.
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        // When a draft is applied it is automatically selected, so we need to set the selected annotation.
        // emit the event for the selected annotation.
        options.annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: id,
                isSelected: true,
                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
            }
        });
        return {
            success: true,
            targetElement: // Get the dom element from the newly created annotation and return it here.
            targetElement,
            // In Editor this is undefined, because the editor will update the document.
            actionResult: undefined
        };
    };
const $fcd3fd145d889c5a$export$1a473231c51c1d5b = (editorView, _options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const from = decorations[0].from;
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        return {
            success: true,
            inlineNodeTypes: inlineNodeTypes,
            targetElement: targetElement,
            actionResult: undefined
        };
    };
const $fcd3fd145d889c5a$export$b8ac6bdd928e737c = (editorView, options)=>(id, isSelected)=>{
        const { annotations: annotations, isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlySelectedIndex = selectedAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlySelected = isCurrentlySelectedIndex !== -1;
        if (isSelected !== isCurrentlySelected) {
            // the annotation is selection is changing.
            if (isCurrentlySelected && !isSelected) {
                // the selected annotaion is being unselected, so we need to close the view.
                (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: false,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            } else if (!isCurrentlySelected && isSelected) {
                // the annotation is currently not selected and is being selected, so we need to open the view.
                (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(id)(editorView.state, editorView.dispatch);
                // the current annotations are going to be unselected. So we need to notify listeners of this change also.
                selectedAnnotations?.forEach((annotation)=>{
                    if (annotation.id !== id) options.annotationManager?.emit({
                        name: 'annotationSelectionChanged',
                        data: {
                            annotationId: annotation.id,
                            isSelected: false,
                            inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                        }
                    });
                });
                // Lastly we need to emit the event for the selected annotation.
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: true,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            }
        }
        return {
            success: true,
            isSelected: isSelected
        };
    };
const $fcd3fd145d889c5a$export$5ada3da2e2f0701f = (editorView, _options)=>(id, isHovered)=>{
        const { annotations: annotations, hoveredAnnotations: hoveredAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlyHoveredIndex = hoveredAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlyHovered = isCurrentlyHoveredIndex !== -1;
        if (isHovered !== isCurrentlyHovered) {
            // the annotation in hovered is changing.
            if (isCurrentlyHovered && !isHovered) // the hovered annotaion is being unhovered, so we should remove the hover state.
            (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            else if (!isCurrentlyHovered && isHovered) // the annotation is currently not hovered and is being hovered.
            (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)(id)(editorView.state, editorView.dispatch);
        }
        return {
            success: true,
            isHovered: isHovered
        };
    };
const $fcd3fd145d889c5a$export$6baae9b3f0f9bdce = (editorView, options)=>(id)=>{
        const { annotations: annotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        (0, $5a3eafd29b4d037d$export$d087dc0f7213ba13)(options.editorAnalyticsAPI)(id, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
        return {
            success: true,
            actionResult: undefined
        };
    };






parcelRequire("cozmU");




var $iLcY8 = parcelRequire("iLcY8");


var $ldqjS = parcelRequire("ldqjS");





var $83k8i = parcelRequire("83k8i");


var $gZpSA = parcelRequire("gZpSA");




var $jaFVy = parcelRequire("jaFVy");


var $eDtFr = parcelRequire("eDtFr");







const $c64cd5f7ffbeb7e3$var$getValidNodes = (state)=>{
    const { schema: schema } = state;
    const { annotation: annotation } = schema.marks;
    return Object.keys(schema.nodes).reduce((acc, current)=>{
        const type = schema.nodes[current];
        if (type.allowsMarkType(annotation)) acc.push(type);
        return acc;
    }, []);
};
const $c64cd5f7ffbeb7e3$export$8921e02ce71849ce = ({ state: state, bookmark: bookmark })=>{
    if (!bookmark) return false;
    const { tr: tr } = state;
    const resolvedBookmark = bookmark.resolve(tr.doc);
    const isSelectionMatchingBookmark = resolvedBookmark.to === tr.selection.to && resolvedBookmark.from === tr.selection.from;
    return isSelectionMatchingBookmark;
};
const $c64cd5f7ffbeb7e3$export$4f0bdd9681380033 = (state)=>{
    return {
        items: [],
        nodeType: $c64cd5f7ffbeb7e3$var$getValidNodes(state),
        title: 'Annotation suppressed toolbar'
    };
};
const $c64cd5f7ffbeb7e3$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>({ state: state, intl: intl, isToolbarAbove: isToolbarAbove = false, _supportedNodes: _supportedNodes = [], api: api, createCommentExperience: createCommentExperience, annotationManager: annotationManager, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments = ()=>true, contentType: contentType })=>{
        const selectionValid = (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(state);
        const isMediaSelected = (0, $3mJu6.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? (0, $83k8i.annotationMessages).createCommentDisabled : (0, $83k8i.annotationMessages).createCommentInvalid);
        const canAddComments = getCanAddComments();
        const isCommentButtonDisabled = !canAddComments || selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
        const disabledTooltipContent = !canAddComments ? intl.formatMessage((0, $83k8i.annotationMessages).noPermissionToAddComment, {
            contentType: contentType
        }) : commentDisabledMessage;
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: isCommentButtonDisabled || (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode),
            testId: (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingToolbarCreateButton,
            interactionName: 'start-inline-comment-action',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            tooltipContent: isCommentButtonDisabled ? disabledTooltipContent : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $ldqjS.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                onCommentButtonMount && onCommentButtonMount();
                // Check if the selection includes an non-text inline node
                const inlineCommentPluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                const inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                    doc: state.doc,
                    pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, inlineCommentPluginState?.bookmark)
                }) ?? [];
                const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).VIEWED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
                        isDisabled: selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED,
                        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $iLcY8.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                editorAnalyticsAPI?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        pageMode: 'edit'
                    }
                });
                if (annotationManager) {
                    annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
                        if (canStartDraft) {
                            createCommentExperience?.start({
                                attributes: {
                                    pageClass: 'editor',
                                    commentType: 'inline',
                                    entryPoint: 'highlightActions'
                                }
                            });
                            createCommentExperience?.initExperience.start();
                            const result = annotationManager.startDraft();
                            if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                            // but the action was not completed, the result should contain a reason.
                            editorAnalyticsAPI?.fireAnalyticsEvent({
                                action: (0, $krYZG.ACTION).ERROR,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                                }
                            });
                        }
                    }).catch(()=>{
                        editorAnalyticsAPI?.fireAnalyticsEvent({
                            action: (0, $krYZG.ACTION).ERROR,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                errorReason: `toolbar-start-draft-preemptive-gate-error`
                            }
                        });
                    });
                    return true;
                } else {
                    createCommentExperience?.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'inline',
                            entryPoint: 'highlightActions'
                        }
                    });
                    createCommentExperience?.initExperience.start();
                    return (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(editorAnalyticsAPI)(true)(state, dispatch);
                }
            },
            supportsViewMode: true // TODO: MODES-3950 - Clean up this floating toolbar view mode logic,
        };
        const toolbarTitle = intl.formatMessage((0, $83k8i.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $gZpSA.calculateToolbarPositionAboveSelection) : (0, $gZpSA.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: $c64cd5f7ffbeb7e3$var$getValidNodes(state),
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated,
            pluginName: 'annotation'
        };
    };



const $4e917acc307ae91b$var$fetchProviderStates = async (provider, annotationIds)=>{
    if (!provider || !provider.getState) return {};
    const data = await provider.getState(annotationIds);
    const result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $epbW8.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $4e917acc307ae91b$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    const inlineCommentStates = await $4e917acc307ae91b$var$fetchProviderStates(provider, annotationIds);
    if (Object.keys(inlineCommentStates).length === 0) {
        const { annotationsLoaded: annotationsLoaded } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(editorView.state) || {};
        if (!annotationsLoaded) (0, $5a3eafd29b4d037d$export$a3833f7fc842f6da)()(editorView.state, editorView.dispatch);
        return;
    }
    if (editorView.dispatch) (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $4e917acc307ae91b$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState, isAnnotationManagerEnabled = false)=>{
    return {
        annotationsLoaded: false,
        annotations: {},
        selectedAnnotations: [],
        hoveredAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false,
        pendingSelectedAnnotations: [],
        pendingSelectedAnnotationsUpdateCount: 0,
        isAnnotationManagerEnabled: isAnnotationManagerEnabled
    };
};
const $4e917acc307ae91b$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $5a3eafd29b4d037d$export$ef4c42f03863dce9)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $4e917acc307ae91b$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $1SZMn.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $4e917acc307ae91b$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $4e917acc307ae91b$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
        if (mouseData?.isSelecting) (0, $5a3eafd29b4d037d$export$ef4c42f03863dce9)({
            isSelecting: false
        })(state, dispatch);
    };
const $4e917acc307ae91b$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $5a3eafd29b4d037d$export$c6dc86fb1ced7a07)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $4e917acc307ae91b$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, featureFlagsPluginState: featureFlagsPluginState, annotationManager: annotationManager } = options;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $f5fb2d59ed261397$export$544b399faf6001b7),
        state: (0, $42647913cd19dc49$export$656c7661095efe2e)(options.dispatch, $4e917acc307ae91b$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState, !!annotationManager)),
        view (editorView) {
            let allowAnnotationFn;
            let startDraftFn;
            let clearDraftFn;
            let applyDraftFn;
            let getDraftFn;
            let setIsAnnotationSelectedFn;
            let setIsAnnotationHoveredFn;
            let clearAnnotationFn;
            if (annotationManager) {
                allowAnnotationFn = (0, $fcd3fd145d889c5a$export$86f3258f283eb796)(editorView, options);
                startDraftFn = (0, $fcd3fd145d889c5a$export$768048043e8d2bcd)(editorView, options);
                clearDraftFn = (0, $fcd3fd145d889c5a$export$eeeb486534738631)(editorView, options);
                applyDraftFn = (0, $fcd3fd145d889c5a$export$8bc7b93e04771bda)(editorView, options);
                getDraftFn = (0, $fcd3fd145d889c5a$export$1a473231c51c1d5b)(editorView, options);
                setIsAnnotationSelectedFn = (0, $fcd3fd145d889c5a$export$b8ac6bdd928e737c)(editorView, options);
                setIsAnnotationHoveredFn = (0, $fcd3fd145d889c5a$export$5ada3da2e2f0701f)(editorView, options);
                clearAnnotationFn = (0, $fcd3fd145d889c5a$export$6baae9b3f0f9bdce)(editorView, options);
                annotationManager.hook('allowAnnotation', allowAnnotationFn);
                annotationManager.hook('startDraft', startDraftFn);
                annotationManager.hook('clearDraft', clearDraftFn);
                annotationManager.hook('applyDraft', applyDraftFn);
                annotationManager.hook('getDraft', getDraftFn);
                annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                annotationManager.hook('clearAnnotation', clearAnnotationFn);
            }
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $4e917acc307ae91b$var$fetchState(provider, (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$4e917acc307ae91b$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$4e917acc307ae91b$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$4e917acc307ae91b$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$4e917acc307ae91b$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(annotationId)(editorView.state, editorView.dispatch);
            };
            const setHoveredAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)(annotationId)(editorView.state, editorView.dispatch);
            };
            const removeHoveredannotationFn = ()=>{
                (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            };
            const closeInlineCommentFn = ()=>{
                (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn).on('sethoveredannotation', setHoveredAnnotationFn).on('removehoveredannotation', removeHoveredannotationFn).on('closeinlinecomment', closeInlineCommentFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            /**
       * This flag is used to prevent the preemptive gate from being called multiple times while a check is in-flight.
       * If a check is still pending then it's most likely because the product is busy and trying to block the
       * selection of an annotation.
       */ let isPreemptiveGateActive = false;
            return {
                update (view, _prevState) {
                    const { selectedAnnotations: selectedAnnotations, annotations: annotations, isDrafting: isDrafting, bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                    const { selectedAnnotations: prevSelectedAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(_prevState) || {};
                    const selectedAnnotationId = selectedAnnotations && selectedAnnotations.length !== 0 && selectedAnnotations[0].id ? selectedAnnotations[0].id : undefined;
                    // If the new state has an unresolved selected annotation, and it's different from
                    // the previous one then...
                    if (//This checks the selected annotation is different from the previous one
                    selectedAnnotationId && selectedAnnotationId !== prevSelectedAnnotations?.[0]?.id && // This ensures that the selected annotation is unresolved
                    annotations && annotations[selectedAnnotationId] === false) {
                        // ...we mark the select annotation experience as complete.
                        // The selectComponentExperience is using a simplified object, which is why it's type asserted.
                        options.selectCommentExperience?.selectAnnotation.complete(selectedAnnotationId);
                        // ...and start a new UFO press trace since the selected comment is changing
                        options.viewInlineCommentTraceUFOPress?.();
                    }
                    const { api: api } = options;
                    if (isDrafting && !view.state.selection.eq(_prevState.selection) && Boolean(api?.toolbar)) // It is possible that user update selection while having a active draft,
                    // so we need to reset the user intent to allow inline text toolbar to be visible
                    api?.core.actions.execute(({ tr: tr })=>{
                        if ((0, $c64cd5f7ffbeb7e3$export$8921e02ce71849ce)({
                            state: view.state,
                            bookmark: bookmark
                        })) (0, $0592d2368c2c3f07$export$2c4e3be4c627582b)(api, tr);
                        else (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(api, tr);
                        return tr;
                    });
                    if (annotationManager) {
                        // In the Editor, Annotations can be selected in three ways:
                        // 1. By clicking on the annotation in the editor
                        // 2. By using the annotation manager to select the annotation
                        // 3. By moving the cursor to the annotation and using the keyboard to select it
                        // Item 1 & 3 need to be protected by the preemptive gate. This is because these actions could be performed by a user
                        // at a time when changing the selection could cause data loss.
                        // The following preemptive check is designed to cover these items.
                        const { pendingSelectedAnnotations: pendingSelectedAnnotations, pendingSelectedAnnotationsUpdateCount: pendingSelectedAnnotationsUpdateCount } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                        const { pendingSelectedAnnotationsUpdateCount: prevPendingSelectedAnnotationsUpdateCount } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(_prevState) || {};
                        if (!isPreemptiveGateActive && pendingSelectedAnnotationsUpdateCount !== prevPendingSelectedAnnotationsUpdateCount && !!pendingSelectedAnnotations?.length) {
                            // Need to set a lock to avoid calling gate multiple times. The lock will be released
                            // when the preemptive gate is complete.
                            isPreemptiveGateActive = true;
                            annotationManager.checkPreemptiveGate().then((canSelectAnnotation)=>{
                                const { isDrafting: isDrafting, pendingSelectedAnnotations: latestPendingSelectedAnnotations, selectedAnnotations: latestSelectedAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                                if (canSelectAnnotation) {
                                    if (isDrafting) // The user must have chosen to discard there draft. So before we flush the pending selections
                                    // we need to clear the draft if there is one.
                                    (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(view.state, view.dispatch);
                                    // Flush the pending selections into the selected annotations list.
                                    (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(true)(view.state, view.dispatch);
                                    latestSelectedAnnotations?.filter((annotation)=>latestPendingSelectedAnnotations?.findIndex((pendingAnnotation)=>pendingAnnotation.id === annotation.id) === -1).forEach((annotation)=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: annotation.id,
                                                isSelected: false,
                                                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                                            }
                                        });
                                    });
                                    // Notify the annotation manager that the pending selection has changed.
                                    latestPendingSelectedAnnotations?.forEach(({ id: id })=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: id,
                                                isSelected: true,
                                                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(view.state, id) ?? []
                                            }
                                        });
                                    });
                                } else // Clears the pending selections if the preemptive gate returns false.
                                // We should need to worry about dispatching change events here because the pending selections
                                // are being aborted and the selections will remain unchanged.
                                (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false)(view.state, view.dispatch);
                            }).catch((error)=>{
                                // If an error has occured we will clear any pending selections to avoid accidentally setting the wrong thing.
                                (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false, 'pending-selection-preemptive-gate-error')(view.state, view.dispatch);
                            }).finally(()=>{
                                isPreemptiveGateActive = false;
                            });
                        }
                    }
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $5a3eafd29b4d037d$export$ffa869a92c2481c3)()(view.state, view.dispatch);
                    $4e917acc307ae91b$var$fetchState(provider, (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn).off('sethoveredannotation', setHoveredAnnotationFn).off('removehoveredannotation', removeHoveredannotationFn).off('closeinlinecomment', closeInlineCommentFn);
                    if (annotationManager) {
                        annotationManager.unhook('allowAnnotation', allowAnnotationFn);
                        annotationManager.unhook('startDraft', startDraftFn);
                        annotationManager.unhook('clearDraft', clearDraftFn);
                        annotationManager.unhook('applyDraft', applyDraftFn);
                        annotationManager.unhook('getDraft', getDraftFn);
                        annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                        annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                        annotationManager.unhook('clearAnnotation', clearAnnotationFn);
                    }
                }
            };
        },
        props: {
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state);
                    if (!pluginState?.mouseData.isSelecting) $4e917acc307ae91b$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    return $4e917acc307ae91b$var$onMouseUp(view.state, view.dispatch)(event);
                },
                click: (view, event)=>{
                    if (!(event.target instanceof HTMLElement)) return false;
                    // Find the nearest ancestor (or self) with the data-id attribute
                    const annotationId = event.target.closest('[data-id]')?.getAttribute('data-id');
                    if (!annotationId) return false;
                    const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state);
                    const isSelected = pluginState?.selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                    // If the annotation is selected and the inline comment view is open, do nothing
                    // as the user is already in the comment view.
                    if (isSelected && !pluginState?.isInlineCommentViewClosed) return false;
                    const { annotations: annotations } = pluginState || {};
                    const isUnresolved = annotations && annotations[annotationId] === false;
                    if (!isUnresolved) return false;
                    if (annotationManager) {
                        // The manager disable setting the selected annotation on click because in the editor this is already
                        // handled by the selection update handler. When the manager is enabled, and a selection changes it's pushed into
                        // the pendingSelectedAnnotations array. This is then used to update the selection when the preemptive gate
                        // is released.
                        const isPendingSelection = pluginState?.pendingSelectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                        // If the annotation is selected and the inline comment view is open, do nothing
                        // as the user is already in the comment view.
                        if (isPendingSelection) return false;
                        (0, $5a3eafd29b4d037d$export$a99e2fe25edc1abd)(annotationId)(view.state, view.dispatch);
                    } else (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(annotationId)(view.state, view.dispatch);
                    return true;
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed, hoveredAnnotations: hoveredAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
                let decorations = draftDecorationSet ?? (0, $8nvEM.DecorationSet).empty;
                const focusDecorations = [];
                // TODO: EDITOR-760 - This needs to be optimised, it's not a good idea to scan the entire document
                // everytime we need to update the decorations. This handler will be called alot. We should be caching
                // the decorations in plugin state and only updating them when required.
                state.doc.descendants((node, pos)=>{
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlock = node.isBlock && (0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(node, provider.supportedBlockNodes, provider.isBlockNodeSupported);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id);
                            const isHovered = !isInlineCommentViewClosed && !!hoveredAnnotations?.some((hoveredAnnotation)=>hoveredAnnotation.id === mark.attrs.id);
                            if (isSupportedBlock) focusDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $d252fa5145d6fd3d$export$bb73203a2b3a63e2)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $f5fb2d59ed261397$export$824a8ce0be7d4e38).block
                            }));
                            else if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`
                                }, {
                                    key: (0, $f5fb2d59ed261397$export$824a8ce0be7d4e38).block
                                }));
                            } else focusDecorations.push((0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};









var $44cyU = parcelRequire("44cyU");


function $cd81b5c969c7454e$export$e832373cff8dec22(api) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addInlineComment).common, (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    return (0, $44cyU.keymap)(list);
}








parcelRequire("cozmU");













var $4Qu9h = parcelRequire("4Qu9h");














var $cozmU = parcelRequire("cozmU");

class $e7e8300dcbc69083$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}


const $395a577224af18f4$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
const $395a577224af18f4$var$selector = (states)=>{
    return {
        annotations: states.annotationState?.annotations,
        bookmark: states.annotationState?.bookmark,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        isOpeningMediaCommentFromToolbar: states.annotationState?.isOpeningMediaCommentFromToolbar,
        selectAnnotationMethod: states.annotationState?.selectAnnotationMethod,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isAnnotationManagerEnabled: states.annotationState?.isAnnotationManagerEnabled
    };
};
function $395a577224af18f4$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const { annotations: annotations, bookmark: bookmark, isInlineCommentViewClosed: isInlineCommentViewClosed, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, selectAnnotationMethod: selectAnnotationMethod, selectedAnnotations: selectedAnnotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'annotation'
    ], $395a577224af18f4$var$selector);
    const annotationsList = (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(editorView.state.doc);
    const selection = (0, $f5fb2d59ed261397$export$31c5af77b755d41f)(state, bookmark);
    const position = $395a577224af18f4$var$findPosForDOM(selection);
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $bjg0G.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $krYZG.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: error.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    // Network Status
    const networkStatusSelector = (0, $4Qu9h.useSharedPluginStateSelector)(editorAPI, 'connectivity.mode');
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingComponent,
            "data-editor-popup": "true",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(CreateComponent, {
                dom: dom,
                textSelection: textSelection,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCreate: (id)=>{
                    if (!isAnnotationManagerEnabled) {
                        const createAnnotationResult = (0, $5a3eafd29b4d037d$export$51eda81011da4982)(editorAnalyticsAPI, editorAPI)(id, (0, $epbW8.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                        if (!createAnnotationResult) throw new Error('Failed to create annotation');
                    }
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCreateError: (id)=>// This is called when optimistic create inline comment encounters an error,
                    // in which case the optimistically added annotation must be removed.
                    (0, $5a3eafd29b4d037d$export$75bee4cee90040)(id, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, editorView.dispatch),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClose: ()=>{
                    if (!isAnnotationManagerEnabled) {
                        (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(editorAnalyticsAPI, undefined, editorAPI)(false)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                    }
                },
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                isOffline: (0, $jaFVy.isOfflineMode)(networkStatusSelector)
            })
        });
    }
    // View Component
    const activeAnnotations = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    selectedAnnotations?.filter((mark)=>annotations && annotations[mark.id] === false) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        // fire analytics
        const payload = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: editorView.state.doc.nodeAt(position)?.type.name,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e7e8300dcbc69083$export$1fe5705f230796ba), {
        "data-editor-popup": "true",
        "data-testid": (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingComponent,
        onViewed: onAnnotationViewed,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(ViewComponent, {
            annotationsList: annotationsList,
            annotations: activeAnnotations,
            getInlineNodeTypes: getInlineNodeTypes,
            dom: dom,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onDelete: (id)=>(0, $5a3eafd29b4d037d$export$75bee4cee90040)(id, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, dispatch),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onResolve: (id)=>(0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                    [id]: true
                }, (0, $1SZMn.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClose: ()=>{
                (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            },
            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
            isOffline: (0, $jaFVy.isOfflineMode)(networkStatusSelector)
        })
    }, (0, $f5fb2d59ed261397$export$1832a9899106877a)(activeAnnotations));
}





parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");




parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");











var $bFSJa = parcelRequire("bFSJa");




var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");






























const $e802a94405541046$export$7a6737b74121da6f = ({ state: state, api: api, canAddComments: canAddComments })=>{
    const annotationSelectionType = state ? (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(state) : (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const isAnnotationSelectionInvalid = annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
    const isOffline = (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
    return {
        isAnnotationSelectionInvalid: isAnnotationSelectionInvalid,
        isOffline: isOffline,
        canAddComments: canAddComments,
        isDisabled: !canAddComments || isAnnotationSelectionInvalid || isOffline
    };
};
const $e802a94405541046$export$dd62b022312fd583 = ({ state: state, isVisible: isVisible, annotationSelectionType: annotationSelectionType })=>{
    const isMediaSelected = state ? (0, $3mJu6.currentMediaNodeWithPos)(state) : false;
    let isDrafting = false;
    if (state) isDrafting = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(state)?.isDrafting || false;
    // comments on media can only be added via media floating toolbar
    if (isDrafting || isMediaSelected || annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID || !isVisible) return false;
    return true;
};
const $e802a94405541046$export$b5fd00fffbd8948d = ({ api: api })=>{
    api.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            source: 'highlightActionsMenu',
            pageMode: 'edit'
        }
    });
};
const $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent = ({ api: api, errorReason: errorReason })=>{
    api.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorReason: errorReason
        }
    });
};
const $e802a94405541046$export$aa79a97671c224b4 = ({ api: api, isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment, annotationSelectionType: annotationSelectionType })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).VIEWED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            isDisabled: annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED,
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            mode: (0, $iLcY8.MODE).EDITOR
        }
    });
};
const $e802a94405541046$export$c983cfb71edde6e4 = ({ annotationProviders: annotationProviders, api: api, state: state, dispatch: dispatch })=>{
    const annotationManager = annotationProviders?.annotationManager;
    if (annotationManager) {
        annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
            if (canStartDraft) {
                annotationProviders.createCommentExperience?.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'inline',
                        entryPoint: 'highlightActions'
                    }
                });
                annotationProviders.createCommentExperience?.initExperience.start();
                const result = annotationManager.startDraft();
                if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                // but the action was not completed, the result should contain a reason.
                $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent({
                    api: api,
                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                });
            }
        }).catch(()=>{
            $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent({
                api: api,
                errorReason: `toolbar-start-draft-preemptive-gate-error`
            });
        });
        return true;
    } else {
        annotationProviders?.createCommentExperience?.start({
            attributes: {
                pageClass: 'editor',
                commentType: 'inline',
                entryPoint: 'highlightActions'
            }
        });
        annotationProviders?.createCommentExperience?.initExperience.start();
        return (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true)(state, dispatch);
    }
};


const $9f81a4d757ba3795$export$b0b121505277a396 = ({ state: state, annotationProviders: annotationProviders, api: api, annotationSelectionType: annotationSelectionType, bookmark: bookmark })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!state) return;
        if (annotationProviders?.inlineComment) annotationProviders.inlineComment.onCommentButtonMount?.();
        // Check if the selection includes an non-text inline node
        const inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark)
        }) ?? [];
        const isNonTextInlineNodeInludedInComment = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
        (0, $e802a94405541046$export$aa79a97671c224b4)({
            api: api,
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            annotationSelectionType: annotationSelectionType
        });
    // for now trying to replicate current onMount logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



const $05c1ca35e1c29444$export$44a3d5aec3da3e9f = ({ api: api, annotationProviders: annotationProviders })=>{
    const { isVisible: isVisible, bookmark: bookmark } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], (states)=>({
            isVisible: states.annotationState?.isVisible,
            bookmark: states.annotationState?.bookmark
        }));
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const annotationSelectionType = editorView?.state ? (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorView.state) : (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const { getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders?.inlineComment ?? {};
    (0, $9f81a4d757ba3795$export$b0b121505277a396)({
        state: editorView?.state,
        annotationProviders: annotationProviders,
        api: api,
        annotationSelectionType: annotationSelectionType,
        bookmark: bookmark
    });
    const intl = (0, $kSwu1.useIntl)();
    const onClick = ()=>{
        if (!api || !annotationProviders || !editorView?.state || !editorView?.dispatch) return;
        (0, $e802a94405541046$export$b5fd00fffbd8948d)({
            api: api
        });
        (0, $e802a94405541046$export$c983cfb71edde6e4)({
            annotationProviders: annotationProviders,
            api: api,
            state: editorView.state,
            dispatch: editorView.dispatch
        });
    };
    if (!(0, $e802a94405541046$export$dd62b022312fd583)({
        state: editorView?.state,
        isVisible: isVisible,
        annotationSelectionType: annotationSelectionType
    })) return null;
    const canAddComments = getCanAddComments ? getCanAddComments() : true;
    const commentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
    const commentDisabledMessage = intl.formatMessage((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? (0, $83k8i.annotationMessages).createCommentDisabled : (0, $83k8i.annotationMessages).createCommentInvalid);
    const noPermissionToAddCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).noPermissionToAddComment, {
        contentType: contentType
    });
    const { isDisabled: isDisabled, isAnnotationSelectionInvalid: isAnnotationSelectionInvalid } = (0, $e802a94405541046$export$7a6737b74121da6f)({
        state: editorView?.state,
        api: api,
        canAddComments: canAddComments
    });
    const tooltipContentWhenDisabled = ()=>{
        if (!canAddComments) return noPermissionToAddCommentMessage;
        else if (isAnnotationSelectionInvalid) return commentDisabledMessage;
        else // i.e. isOffline. No tooltip message needed.
        return (0, $ieeJu.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true) ? undefined : commentDisabledMessage;
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
        content: isDisabled ? tooltipContentWhenDisabled() : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
            description: commentMessage,
            keymap: (0, $ldqjS.addInlineComment)
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: "",
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingToolbarCreateButton,
            isDisabled: isDisabled,
            children: commentMessage
        })
    });
};


const $2eb2031ab7df2eff$export$a758406ca53b86a5 = (api, annotationProviders)=>{
    return [
        {
            type: (0, $3nacY.COLLAB_SECTION).type,
            key: (0, $3nacY.COLLAB_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.COMMENT_GROUP).type,
            key: (0, $3nacY.COMMENT_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.COLLAB_SECTION).type,
                    key: (0, $3nacY.COLLAB_SECTION).key,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.COMMENT_HERO_BUTTON).type,
            key: (0, $3nacY.COMMENT_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.COMMENT_GROUP).type,
                    key: (0, $3nacY.COMMENT_GROUP).key,
                    rank: (0, $hVLmg.COLLAB_SECTION_RANK)[(0, $3nacY.COMMENT_GROUP).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $05c1ca35e1c29444$export$44a3d5aec3da3e9f), {
                    api: api,
                    annotationProviders: annotationProviders
                });
            }
        }
    ];
};


const $0eb166b24708d17a$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    /**
   * Allows external editor UI, currently AI suggestions, to safely close an inline comment
   * without bypassing the provider's unsaved-content guard.
   */ const requestCloseInlineComment = async ()=>{
        try {
            const requestClose = annotationProviders?.inlineComment.requestClose;
            if (!requestClose) return true;
            const canClose = await requestClose();
            if (!canClose) return false;
            return api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), {
                    type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).CLOSE_COMPONENT
                });
                return tr;
            }) ?? false;
        } catch  {
            // Preserve the active comment if its close guard cannot complete.
            return false;
        }
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2eb2031ab7df2eff$export$a758406ca53b86a5)(api, annotationProviders));
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $7cab94c6d4281aad$export$802ec1d716a6bb1)
                }
            ];
        },
        actions: {
            hasAnyUnResolvedAnnotationInPage: $f5fb2d59ed261397$export$98b0a2a6ba343064,
            requestCloseInlineComment: requestCloseInlineComment,
            stripNonExistingAnnotations: $f5fb2d59ed261397$export$ca9ec32b395faf65,
            applyInlineCommentDraft: (annotationId)=>(0, $5a3eafd29b4d037d$export$51eda81011da4982)(api?.analytics?.actions, api)(annotationId, (0, $epbW8.AnnotationTypes).INLINE_COMMENT, annotationProviders?.inlineComment.supportedBlockNodes),
            removeInlineCommentAnnotation: (annotationId)=>(0, $5a3eafd29b4d037d$export$d087dc0f7213ba13)(api?.analytics?.actions)(annotationId, annotationProviders?.inlineComment.supportedBlockNodes ?? []),
            setInlineCommentDraftState: (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, annotationProviders?.inlineComment.supportedBlockNodes, undefined, annotationProviders?.inlineComment.isBlockNodeSupported),
            showCommentForBlockNode: (0, $5a3eafd29b4d037d$export$d80af6562490622d)(annotationProviders?.inlineComment.supportedBlockNodes, annotationProviders?.inlineComment.isBlockNodeSupported),
            setSelectedAnnotation: $5a3eafd29b4d037d$export$1e715f68ff6f5a2f,
            setPendingSelectedAnnotation: $5a3eafd29b4d037d$export$a99e2fe25edc1abd
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            delete clonedPluginState?.featureFlagsPluginState;
            return clonedPluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch })=>{
                        if (annotationProviders) return (0, $4e917acc307ae91b$export$e4aab3acac8f34b)({
                            dispatch: dispatch,
                            provider: annotationProviders.inlineComment,
                            editorAnalyticsAPI: api?.analytics?.actions,
                            featureFlagsPluginState: featureFlags,
                            selectCommentExperience: annotationProviders.selectCommentExperience,
                            viewInlineCommentTraceUFOPress: annotationProviders.viewInlineCommentTraceUFOPress,
                            annotationManager: annotationProviders.annotationManager,
                            api: api
                        });
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $cd81b5c969c7454e$export$e832373cff8dec22)(api);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            floatingToolbar (state) {
                const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                const bookmark = pluginState?.bookmark;
                if ((0, $c64cd5f7ffbeb7e3$export$8921e02ce71849ce)({
                    state: state,
                    bookmark: bookmark
                })) return (0, $c64cd5f7ffbeb7e3$export$4f0bdd9681380033)(state);
            },
            selectionToolbar (state, intl) {
                if (isToolbarAIFCEnabled) return;
                if (!annotationProviders) return;
                const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    const { isToolbarAbove: isToolbarAbove, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders.inlineComment;
                    const toolbarConfig = (0, $c64cd5f7ffbeb7e3$export$6dd6ab35df8f7f86)(api?.analytics?.actions)({
                        state: state,
                        intl: intl,
                        isToolbarAbove: isToolbarAbove,
                        api: api,
                        createCommentExperience: annotationProviders.createCommentExperience,
                        annotationManager: annotationProviders.annotationManager,
                        onCommentButtonMount: onCommentButtonMount,
                        getCanAddComments: getCanAddComments,
                        contentType: contentType
                    });
                    if (!toolbarConfig) return undefined;
                    else return {
                        ...toolbarConfig,
                        rank: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 1 : undefined
                    };
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders || !editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($0eb166b24708d17a$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $0eb166b24708d17a$var$selector = (states)=>{
    return {
        isVisible: states.annotationState?.isVisible,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        annotations: states.annotationState?.annotations
    };
};
function $0eb166b24708d17a$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const annotationState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $0eb166b24708d17a$var$selector);
    // need to explicitly check for false as undefined is also a valid value to continue
    if (annotationState?.isVisible === false) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-editor-popup": "true",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $395a577224af18f4$export$ce99d9856d415465), {
            providers: annotationProviders,
            editorView: editorView,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        })
    });
}
module.exports["annotationPlugin"] = $0eb166b24708d17a$export$df895cff1a8daaf7;

});

parcelRegister("60Pfj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $icr1E = parcelRequire("icr1E");




parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");


var $2xhuI = parcelRequire("2xhuI");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $bcDqz = parcelRequire("bcDqz");





var $kCECX = parcelRequire("kCECX");


var $iDrrr = parcelRequire("iDrrr");


var $jv11C = parcelRequire("jv11C");

const $64e94b4488f18b2c$var$AGG_PATH = '/gateway/api/graphql';
const $64e94b4488f18b2c$var$USERS_OPERATION_NAME = 'AvatarGroupUsersQuery';
const $64e94b4488f18b2c$var$USERS_QUERY = `
	query ${$64e94b4488f18b2c$var$USERS_OPERATION_NAME}($accountIds: [ID!]!) {
		users(accountIds: $accountIds) {
			accountId
			name
		}
	}
`;
const $64e94b4488f18b2c$export$a1160cf07102030 = async (accountIds)=>{
    if (!accountIds.length) return {};
    try {
        const response = await fetch($64e94b4488f18b2c$var$AGG_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: $64e94b4488f18b2c$var$USERS_OPERATION_NAME,
                query: $64e94b4488f18b2c$var$USERS_QUERY,
                variables: {
                    accountIds: accountIds
                }
            })
        });
        if (!response.ok) throw new Error(`AGG user request failed: ${response.status}`);
        const json = await response.json();
        return (json.data?.users ?? []).reduce((namesById, user)=>{
            if (user.accountId && user.name) namesById[user.accountId] = user.name;
            return namesById;
        }, {});
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-avatar-group/fetchUserNames'
        });
        return {};
    }
};


/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $7Y8M5 = parcelRequire("7Y8M5");

function $2c5192d22ce51ce3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c5192d22ce51ce3$export$2755d6ea511694ef = {
    name: "1a9lj0e",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-full, 9999px);min-width:var(--ds-space-400, 32px);margin-left:var(--ds-space-negative-050, -4px)"
};
const $2c5192d22ce51ce3$export$84e713f68a1110f7 = {
    name: "1g5siac",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:var(--ds-radius-full, 9999px);height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $2c5192d22ce51ce3$export$4aebd143f31d0c0d = (backgroundColor, textColor)=>/*#__PURE__*/ (0, $lOiVq.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7Y8M5.akEditorSmallZIndex),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: backgroundColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: textColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(9),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #FFFFFF)"}`,
        boxSizing: 'border-box'
    });





parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports







const $f7ab6790bfd0e9a1$export$1a8ce77350a239fa = (props)=>{
    // The fallback mirrors a participant palette slot; red is reserved for deleted content.
    const fallbackColor = (0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') ? "var(--ds-background-accent-orange-subtle, #FCA700)" : "var(--ds-background-accent-red-subtle, #F87168)";
    const participantColor = props.api?.collabEdit?.actions?.getAvatarColor(props.presenceId ?? props.sessionId) ?? {
        backgroundColor: fallbackColor,
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
    };
    const avatar = props.name.substr(0, 1).toUpperCase();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $2c5192d22ce51ce3$export$4aebd143f31d0c0d)(participantColor?.backgroundColor, participantColor?.textColor),
        "data-testid": "editor-collab-badge"
    }, avatar);
};


const $74dae352f55c58dc$var$getUserNameForAttribution = (participant, participants, userNamesById = {})=>{
    const actingUserId = participant.actingUserId;
    if (!(0, $iDrrr.fg)('platform_move_presence_agents') || !actingUserId) return undefined;
    const currentParticipantName = participants.find((user)=>user.sessionId !== participant.sessionId && user.userId === actingUserId && user.isHydrated)?.name;
    return currentParticipantName ?? userNamesById[actingUserId];
};
const $74dae352f55c58dc$var$getAvatarName = (participant, participants, formatMessage, userNamesById)=>{
    const participantName = participant.name || formatMessage((0, $icr1E.avatarGroupMessages).anonymousCollaborator);
    const userNameForAttribution = $74dae352f55c58dc$var$getUserNameForAttribution(participant, participants, userNamesById);
    if (!userNameForAttribution) return participantName;
    return formatMessage((0, $icr1E.avatarGroupMessages).agentWithUser, {
        agentName: participantName,
        userName: userNameForAttribution
    });
};
const $74dae352f55c58dc$var$toAvatar = (participant, api, formatMessage, participants, userNamesById = {})=>({
        name: $74dae352f55c58dc$var$getAvatarName(participant, participants, formatMessage, userNamesById),
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f7ab6790bfd0e9a1$export$1a8ce77350a239fa), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId,
            presenceId: participant.presenceId
        })
    });
const $74dae352f55c58dc$var$_default_1 = (0, $dOBRD.default)($74dae352f55c58dc$var$toAvatar, function participantEquals([a, , , aParticipants, aUserNamesById = {}], [b, , , bParticipants, bUserNamesById = {}]) {
    const actingUserId = a.actingUserId;
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId && actingUserId === b.actingUserId && (!actingUserId || $74dae352f55c58dc$var$getUserNameForAttribution(a, aParticipants, aUserNamesById) === $74dae352f55c58dc$var$getUserNameForAttribution(b, bParticipants, bUserNamesById));
});
var $74dae352f55c58dc$export$2e2bcd8739ae039 = $74dae352f55c58dc$var$_default_1;


const $b9a68f91ae5e2d47$var$scrollToCollabCursor = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).MATCHED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SELECTION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAPI?.core?.actions?.execute(({ tr: tr })=>{
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI?.core?.actions?.focus();
    }
};
const $b9a68f91ae5e2d47$var$getMissingActingUserIdsKey = (participants, userNamesById)=>{
    const participantUserIds = new Set();
    const missingActingUserIds = new Set();
    for (const participant of participants)if (participant.userId) participantUserIds.add(participant.userId);
    for (const participant of participants){
        const actingUserId = participant.actingUserId;
        if (actingUserId && !participantUserIds.has(actingUserId) && !userNamesById[actingUserId]) missingActingUserIds.add(actingUserId);
    }
    let missingActingUserIdsKey = '';
    for (const actingUserId of missingActingUserIds)missingActingUserIdsKey = missingActingUserIdsKey ? `${missingActingUserIdsKey}|${actingUserId}` : actingUserId;
    return missingActingUserIdsKey;
};
const $b9a68f91ae5e2d47$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    const intl = (0, $kSwu1.useIntl)();
    const [userNamesById, setUserNamesById] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({});
    // .slice() turns ReadonlyArray<CollabParticipant> into a mutable CollabParticipant[]
    const participants = props.participants?.toArray()?.slice();
    const missingActingUserIdsKey = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!participants || !(0, $iDrrr.fg)('platform_move_presence_agents')) return '';
        return $b9a68f91ae5e2d47$var$getMissingActingUserIdsKey(participants, userNamesById);
    }, [
        participants,
        userNamesById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!missingActingUserIdsKey) return;
        let cancelled = false;
        (0, $64e94b4488f18b2c$export$a1160cf07102030)(missingActingUserIdsKey.split('|')).then((namesById)=>{
            if (cancelled || !Object.keys(namesById).length) return;
            setUserNamesById((currentNamesById)=>({
                    ...currentNamesById,
                    ...namesById
                }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        missingActingUserIdsKey
    ]);
    if (!participants) return null;
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $74dae352f55c58dc$export$2e2bcd8739ae039)(participant, editorAPI, intl.formatMessage, participants, userNamesById));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2c5192d22ce51ce3$export$84e713f68a1110f7)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bcDqz.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags?.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $b9a68f91ae5e2d47$var$scrollToCollabCursor(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $ldbHR = parcelRequire("ldbHR");


var $gFEZF = parcelRequire("gFEZF");


var $4o0zT = parcelRequire("4o0zT");


const $3b97246b3b12f768$var$ID = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, props.children);
const $3b97246b3b12f768$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $3b97246b3b12f768$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2c5192d22ce51ce3$export$2755d6ea511694ef)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)(Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        "aria-pressed": (0, $4o0zT.isExperimentEnabled)('platform_editor_invite_to_edit_button_aria_pressed') ? selected : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};


const $d7162b71707afb6b$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $2xhuI.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { sessionId: sessionId, activeParticipants: activeParticipants, initialised: initialised } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'collabEdit'
    ], (states)=>({
            sessionId: states.collabEditState?.sessionId,
            activeParticipants: states.collabEditState?.activeParticipants,
            initialised: states.collabEditState?.initialised
        }));
    if (!initialised) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b9a68f91ae5e2d47$export$8232a93d94178362), {
        sessionId: sessionId,
        participants: activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3b97246b3b12f768$export$c166df103ee37df9), {
            title: title,
            selected: selected,
            onClick: onClick,
            Component: Component
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $d7162b71707afb6b$var$_default_1 = (0, $kSwu1.injectIntl)($d7162b71707afb6b$var$AvatarsWithPluginState);
var $d7162b71707afb6b$export$2e2bcd8739ae039 = $d7162b71707afb6b$var$_default_1;


function $6e842f53b8767f36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6e842f53b8767f36$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6e842f53b8767f36$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $lOiVq.css)($6e842f53b8767f36$var$toolbarButtonWrapper, "flex-grow:1;");
const $6e842f53b8767f36$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-label": intl.formatMessage((0, $icr1E.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $6e842f53b8767f36$var$toolbarButtonWrapperFullWidth : $6e842f53b8767f36$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $d7162b71707afb6b$export$2e2bcd8739ae039), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $6e842f53b8767f36$export$2e2bcd8739ae039 = $6e842f53b8767f36$var$AvatarGroupPluginWrapper;



const $a8a812b290024729$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6e842f53b8767f36$export$2e2bcd8739ae039), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props?.collabEdit,
            takeFullWidth: props?.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) api?.primaryToolbar?.actions.registerComponent({
        name: 'avatarGroup',
        component: primaryToolbarComponent
    });
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !api?.primaryToolbar && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d7162b71707afb6b$export$2e2bcd8739ae039), {
                    featureFlags: api?.featureFlags?.sharedState.currentState() ?? {},
                    editorAnalyticsAPI: api?.analytics?.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};
module.exports["avatarGroupPlugin"] = $a8a812b290024729$export$56985cb4934eb626;

});

parcelRegister("cX2jD", function(module, exports) {

var $hdvEd = parcelRequire("hdvEd");


var $1A89X = parcelRequire("1A89X");


var $eOaGc = parcelRequire("eOaGc");

const $eb881e8362450641$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $1A89X.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $eb881e8362450641$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $eb881e8362450641$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $eb881e8362450641$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $1A89X.SetAttrsStep);
        const isAttrStep = step instanceof (0, $eOaGc.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $eb881e8362450641$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$eb881e8362450641$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $eb881e8362450641$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $hdvEd.BatchAttrsStep)(data);
};


const $93904b52e4acc73e$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $eb881e8362450641$export$383250d570a1fb48
        }
    };
};
module.exports["batchAttributeUpdatesPlugin"] = $93904b52e4acc73e$export$5af772f765987c49;

});

parcelRegister("dHFAY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $eRJEr = parcelRequire("eRJEr");


var $iQ6F7 = parcelRequire("iQ6F7");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $lVAkE = parcelRequire("lVAkE");


var $6FQH1 = parcelRequire("6FQH1");

const $bb8f0178a1bbd465$export$4c9c90f81bda40ce = ({ tr: tr })=>{
    const meta = {
        type: 'startPreserving'
    };
    return tr.setMeta((0, $6FQH1.selectionPreservationPluginKey), meta);
};
const $bb8f0178a1bbd465$export$7ee148889ab74bda = ({ tr: tr })=>{
    const meta = {
        type: 'stopPreserving'
    };
    return tr.setMeta((0, $6FQH1.selectionPreservationPluginKey), meta);
};


const $a155f8ac3d617cef$var$getKeyboardEventInfo = (event)=>{
    const key = event.key.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCut = isMetaCtrl && key === 'x';
    const isPaste = isMetaCtrl && key === 'v';
    const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
    const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey);
    const isDestructive = isDelete || isCut || isPaste || isUndo || isRedo;
    const isModifierOnly = [
        'control',
        'meta',
        'alt',
        'shift'
    ].includes(key) && !isMetaCtrl;
    const isCopy = isMetaCtrl && key === 'c';
    const isInert = isModifierOnly || isCopy;
    return {
        isDelete: isDelete,
        isDestructive: isDestructive,
        isInert: isInert
    };
};
const $a155f8ac3d617cef$export$f38920f5272efc06 = (api)=>(event)=>({ tr: tr })=>{
            if (!api) return tr;
            const { isDelete: isDelete, isDestructive: isDestructive, isInert: isInert } = $a155f8ac3d617cef$var$getKeyboardEventInfo(event);
            // Handle delete/backspace key presses with custom logic to ensure preserved selection is used
            if (isDelete) tr = (0, $lVAkE.deleteSelectedRange)(tr, api.blockControls?.sharedState.currentState()?.preservedSelection);
            const isBlockMenuOpen = api.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
            // When selected content is being removed/modified/undo/redo and the block menu is open
            // close the block menu and refocus the editor
            const shouldCloseBlockMenu = isDestructive && isBlockMenuOpen;
            if (shouldCloseBlockMenu) {
                api.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api.core.actions.focus({
                    scrollIntoView: false
                });
            }
            // Stop preserving when:
            // 1. Content is being removed (delete/cut/paste) OR
            // 2. Menu is closed AND user pressed a non-inert key (i.e. action which modifies selection or content)
            // 3. undo/redo actions
            const shouldStopPreservingSelection = isDestructive || !isBlockMenuOpen && !isInert;
            if (shouldStopPreservingSelection) (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                tr: tr
            });
            return tr;
        };



var $3BXSc = parcelRequire("3BXSc");

const $ae3c630ae8088563$export$e21678cf246ba963 = (mapping)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $3BXSc.key));
        return tr.setMeta((0, $3BXSc.key), {
            ...currMeta,
            preservedSelectionMapping: mapping
        });
    };



var $b3nYA = parcelRequire("b3nYA");


var $krYZG = parcelRequire("krYZG");


var $1xYQH = parcelRequire("1xYQH");





var $i2jOy = parcelRequire("i2jOy");





var $9aKak = parcelRequire("9aKak");

const $56dbb4d04b905509$var$getSelectionToIndex = (fromIndex, $to, depth)=>{
    const toIndex = $to.index(depth);
    const toIndexAfter = $to.indexAfter(depth);
    // If $to is at the start of a node (indexAfter === index), don't include that node
    // This occurs when the preserved selection is outside of inline positions at node boundaries
    if (toIndexAfter === toIndex && toIndex > fromIndex) return toIndex - 1;
    return toIndex;
};
const $56dbb4d04b905509$export$86c511a177340b22 = (api, direction)=>{
    return ({ tr: tr })=>{
        const preservedSelection = api?.blockControls.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection ?? tr.selection;
        // Use getNodeBoundsFromSelection to get the proper block boundaries
        const nodeBounds = (0, $9aKak.getNodeBoundsFromSelection)(selection);
        if (!nodeBounds) return tr;
        const currentNodePos = nodeBounds.from;
        const { $from: $from, $to: $to } = selection;
        const depth = tr.doc.resolve(currentNodePos).depth;
        const fromIndex = $from.index(depth);
        let trAfterNodeMove = tr;
        if (direction === (0, $1xYQH.DIRECTION).UP) {
            if (fromIndex > 0) {
                const moveToPos = $from.posAtIndex(fromIndex - 1, depth);
                trAfterNodeMove = (0, $b3nYA.moveNode)(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        } else {
            // selectionToIndex is the index of the last node in the selection
            const selectionToIndex = $56dbb4d04b905509$var$getSelectionToIndex(fromIndex, $to, depth);
            // Adding 2 so we jump over the next node to the position after it
            const moveToIndex = selectionToIndex + 2;
            if (moveToIndex <= $to.node(depth).childCount) {
                const moveToPos = $to.posAtIndex(moveToIndex, depth);
                trAfterNodeMove = (0, $b3nYA.moveNode)(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        }
        // map selection
        const mappedSelection = (0, $i2jOy.mapPreservedSelection)(selection, trAfterNodeMove);
        if (mappedSelection) trAfterNodeMove.setSelection(mappedSelection);
        //recalculate canMoveUp and canMoveDown
        const { moveUp: moveUp, moveDown: moveDown } = (0, $9aKak.canMoveNodeUpOrDown)(trAfterNodeMove);
        const currentMeta = trAfterNodeMove.getMeta((0, $3BXSc.key));
        const newMeta = {
            ...currentMeta,
            toggleMenu: {
                moveUp: moveUp,
                moveDown: moveDown
            }
        };
        return trAfterNodeMove.setMeta((0, $3BXSc.key), newMeta);
    };
};






var $jv11C = parcelRequire("jv11C");


var $aPdNQ = parcelRequire("aPdNQ");











var $ieeJu = parcelRequire("ieeJu");


var $aHnsS = parcelRequire("aHnsS");


var $irTNm = parcelRequire("irTNm");


var $bbndg = parcelRequire("bbndg");


var $icvkv = parcelRequire("icvkv");


var $izfLh = parcelRequire("izfLh");





var $SlYRR = parcelRequire("SlYRR");


var $hTjcC = parcelRequire("hTjcC");

const $fcbccc7790679e9d$var$createNewLayout = (schema, layoutContents)=>{
    if (layoutContents.length === 0 || layoutContents.length > (0, $icvkv.maxLayoutColumnSupported)()) return null;
    const width = (0, $hTjcC.DEFAULT_COLUMN_DISTRIBUTIONS)[layoutContents.length];
    if (!width) return null;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes || {};
    try {
        const layoutContent = (0, $aPdNQ.Fragment).fromArray(layoutContents.map((layoutContent)=>{
            return layoutColumn.createChecked({
                width: width
            }, layoutContent);
        }));
        const layoutSectionNode = layoutSection.createChecked(undefined, layoutContent);
        return layoutSectionNode;
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    return null;
};
const $fcbccc7790679e9d$var$moveToExistingLayout = (toLayout, toLayoutPos, sourceContent, from, to, tr, $originalFrom, $originalTo, api, selectMovedNode)=>{
    const isSameLayout = (0, $SlYRR.isInSameLayout)($originalFrom, $originalTo);
    const sourceContentEndPos = from + sourceContent.size;
    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, from, sourceContentEndPos);
    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
    if (isSameLayout) {
        // reorder columns
        tr.delete(from, sourceContentEndPos);
        const mappedTo = tr.mapping.map(to);
        tr.insert(mappedTo, sourceContent);
        if (selectMovedNode) tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(mappedTo))).scrollIntoView();
        (0, $aHnsS.attachMoveNodeAnalytics)(tr, (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', true, api, hasSelectedMultipleNodes);
    } else if (toLayout.childCount < (0, $icvkv.maxLayoutColumnSupported)()) {
        (0, $izfLh.removeFromSource)(tr, tr.doc.resolve(from), sourceContentEndPos);
        $fcbccc7790679e9d$var$insertToDestinationNoWidthUpdate(tr, tr.mapping.map(to), sourceContent);
        (0, $aHnsS.attachMoveNodeAnalytics)(tr, (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', false, api, hasSelectedMultipleNodes);
    }
    return tr;
};
/**
 * This function is similar to insertToDestination
 * But without update width step, mainly rely on the append transaction from layout.
 * @param tr
 * @param to
 * @param sourceNode
 * @returns
 */ const $fcbccc7790679e9d$var$insertToDestinationNoWidthUpdate = (tr, to, sourceContent)=>{
    const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
    let content = null;
    try {
        const sourceFragment = sourceContent;
        content = layoutColumn.createChecked({
            width: 0
        }, (0, $irTNm.isFragmentOfType)(sourceFragment, 'layoutColumn') ? sourceFragment.firstChild?.content : sourceFragment);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    if (content) tr.insert(to, content);
    return tr;
};
/**
 * Check if the node at `from` can be moved to node at `to` to create/expand a layout.
 * Returns the source and destination nodes and positions if it's a valid move, otherwise, undefined
 */ const $fcbccc7790679e9d$var$canMoveToLayout = (api, from, to, tr, moveNodeAtCursorPos)=>{
    if (from === to) return;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, doc: doc, bodiedSyncBlock: bodiedSyncBlock } = tr.doc.type.schema.nodes || {};
    // layout plugin does not exist
    if (!layoutSection || !layoutColumn) return;
    const $to = tr.doc.resolve(to);
    const allowedParentTypes = [
        doc,
        layoutSection
    ];
    if (bodiedSyncBlock) allowedParentTypes.push(bodiedSyncBlock);
    // drop at invalid position, not top level, or not a layout column
    if (!$to.nodeAfter || !allowedParentTypes.includes($to.parent.type)) return;
    const $from = tr.doc.resolve(from);
    // invalid from position or dragging a layout
    if (!$from.nodeAfter || $from.nodeAfter.type === layoutSection) return;
    let sourceContent = $from.nodeAfter;
    let sourceFrom = from;
    let sourceTo = from + sourceContent.nodeSize;
    if (!moveNodeAtCursorPos) {
        const { anchor: anchor, head: head } = (0, $i2jOy.getMultiSelectionIfPosInside)(api, from);
        if (anchor !== undefined && head !== undefined) {
            sourceFrom = Math.min(anchor, head);
            sourceTo = Math.max(anchor, head);
            sourceContent = tr.doc.slice(sourceFrom, sourceTo).content;
            // TODO: ED-26959 - this might become expensive for large content, consider removing it if check has been done beforehand
            if ((0, $irTNm.containsNodeOfType)(sourceContent, 'layoutSection')) return;
        } else sourceContent = (0, $aPdNQ.Fragment).from($from.nodeAfter);
    }
    const toNode = $to.nodeAfter;
    return {
        toNode: toNode,
        $to: $to,
        sourceContent: sourceContent,
        $sourceFrom: tr.doc.resolve(sourceFrom),
        sourceTo: sourceTo
    };
};
const $fcbccc7790679e9d$var$removeBreakoutMarks = (tr, $from, to)=>{
    let fromContentWithoutBreakout = null;
    const { breakout: breakout } = tr.doc.type.schema.marks || {};
    tr.doc.nodesBetween($from.pos, to, (node, pos, parent)=>{
        // should never remove breakout from previous layoutSection
        if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
            if (node.type.name === 'layoutSection') return false;
        }
        // breakout doesn't exist on nested nodes
        if (parent?.type.name === 'doc' && node.marks.some((m)=>m.type === breakout)) tr.removeNodeMark(pos, breakout);
        // descending is not needed as  breakout doesn't exist on nested nodes
        return false;
    });
    // resolve again the source content after node updated (remove breakout marks)
    fromContentWithoutBreakout = tr.doc.slice($from.pos, to).content;
    return fromContentWithoutBreakout;
};
const $fcbccc7790679e9d$var$getBreakoutMode = (content, breakout)=>{
    if (content instanceof (0, $aPdNQ.Node)) return content.marks.find((m)=>m.type === breakout)?.attrs.mode;
    else if (content instanceof (0, $aPdNQ.Fragment)) {
        // Find the first breakout mode in the fragment
        let firstBreakoutMode;
        for(let i = 0; i < content.childCount; i++){
            const child = content.child(i);
            const breakoutMark = child.marks.find((m)=>m.type === breakout);
            if (breakoutMark) {
                firstBreakoutMode = breakoutMark.attrs.mode;
                break;
            }
        }
        return firstBreakoutMode;
    }
};
const $fcbccc7790679e9d$var$getBreakoutModeAndWidth = (content, breakout)=>{
    const findBreakoutMark = (node)=>node.marks.find((m)=>m.type === breakout);
    const extractBreakoutAttributes = (mark)=>mark ? {
            breakoutMode: mark.attrs.mode,
            breakoutWidth: mark.attrs.width
        } : null;
    if (content instanceof (0, $aPdNQ.Node)) return extractBreakoutAttributes(findBreakoutMark(content));
    else if (content instanceof (0, $aPdNQ.Fragment)) // Find the first breakout mode in the fragment
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        const breakoutMark = findBreakoutMark(child);
        if (breakoutMark) return extractBreakoutAttributes(breakoutMark);
    }
    return null;
};
const $fcbccc7790679e9d$export$6e686efeb3f3578c = (api)=>(from, to, options)=>({ tr: tr })=>{
            if (!api) return tr;
            const canMove = $fcbccc7790679e9d$var$canMoveToLayout(api, from, to, tr, options?.moveNodeAtCursorPos);
            if (!canMove) return tr;
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $bbndg.isCollapsedHeading)(api, from)) api.blockCollapse?.commands.expandHeading(from)({
                tr: tr
            });
            const { toNode: toNode, $to: $to, sourceContent: sourceContent, $sourceFrom: $sourceFrom, sourceTo: sourceTo } = canMove;
            const { layoutSection: layoutSection, layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
            const { breakout: breakout } = tr.doc.type.schema.marks || {};
            // get breakout mode from destination node,
            // if not found, get from source node,
            let breakoutMode;
            let breakoutWidth;
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) ({ breakoutMode: breakoutMode, breakoutWidth: breakoutWidth } = $fcbccc7790679e9d$var$getBreakoutModeAndWidth(toNode, breakout) || $fcbccc7790679e9d$var$getBreakoutModeAndWidth(sourceContent, breakout) || {});
            else breakoutMode = $fcbccc7790679e9d$var$getBreakoutMode(toNode, breakout) || $fcbccc7790679e9d$var$getBreakoutMode(sourceContent, breakout);
            // we don't want to remove marks when moving/re-ordering layoutSection
            const shouldRemoveMarks = $sourceFrom.node().type !== layoutSection;
            const fromContentBeforeBreakoutMarksRemoved = tr.doc.slice($sourceFrom.pos, sourceTo).content;
            // remove breakout from source content
            let fromContentWithoutBreakout = shouldRemoveMarks ? $fcbccc7790679e9d$var$removeBreakoutMarks(tr, $sourceFrom, sourceTo) : fromContentBeforeBreakoutMarksRemoved;
            if (!fromContentWithoutBreakout) return tr;
            if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            if (toNode.type === layoutSection) {
                const toPos = options?.moveToEnd ? to + toNode.nodeSize - 1 : to + 1;
                return $fcbccc7790679e9d$var$moveToExistingLayout(toNode, to, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else if (toNode.type === layoutColumn) {
                const toLayout = $to.parent;
                const toLayoutPos = to - $to.parentOffset - 1;
                const toPos = options?.moveToEnd ? to + toNode.nodeSize : to;
                return $fcbccc7790679e9d$var$moveToExistingLayout(toLayout, toLayoutPos, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else {
                let toNodeWithoutBreakout = toNode;
                // remove breakout from node;
                if (breakout && $to.nodeAfter && $to.nodeAfter.marks.some((m)=>m.type === breakout)) {
                    tr.removeNodeMark(to, breakout);
                    // resolve again the source node after node updated (remove breakout marks)
                    toNodeWithoutBreakout = tr.doc.resolve(to).nodeAfter || toNode;
                }
                if ((0, $irTNm.isFragmentOfType)(fromContentWithoutBreakout, 'layoutColumn') && fromContentWithoutBreakout.firstChild) fromContentWithoutBreakout = fromContentWithoutBreakout.firstChild.content;
                const layoutContents = options?.moveToEnd ? [
                    toNodeWithoutBreakout,
                    fromContentWithoutBreakout
                ] : [
                    fromContentWithoutBreakout,
                    toNodeWithoutBreakout
                ];
                const newLayout = $fcbccc7790679e9d$var$createNewLayout(tr.doc.type.schema, layoutContents);
                if (newLayout) {
                    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, $sourceFrom.pos, sourceTo);
                    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    tr = (0, $izfLh.removeFromSource)(tr, $sourceFrom, sourceTo);
                    const mappedTo = tr.mapping.map(to);
                    tr.delete(mappedTo, mappedTo + toNodeWithoutBreakout.nodeSize).insert(mappedTo, newLayout);
                    if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode,
                            width: breakoutWidth
                        })
                    ]);
                    else breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode
                        })
                    ]);
                    if ((0, $iDrrr.fg)('platform_editor_column_count_analytics')) // layout created via drag and drop will always be 2 columns
                    (0, $aHnsS.fireInsertLayoutAnalytics)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes, 2);
                    else (0, $aHnsS.fireInsertLayoutAnalytics)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes);
                }
                return tr;
            }
        };






var $9HWym = parcelRequire("9HWym");


var $kpCD8 = parcelRequire("kpCD8");





var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");




const $77f30cc17fbf24cf$export$fd198b85b7fd4b80 = new (0, $kCECX.PluginKey)('firstNodeDec');
const $77f30cc17fbf24cf$var$createFirstNodeDecSet = (state)=>{
    const firstNode = state.doc.firstChild;
    if (!firstNode) return (0, $8nvEM.DecorationSet).empty;
    const firstNodeDecoration = (0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $8nvEM.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0;',
        class: 'first-node-in-document'
    }) : (0, $8nvEM.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0'
    });
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        firstNodeDecoration
    ]);
};
const $77f30cc17fbf24cf$export$4a529dfc67d1b47b = ()=>new (0, $kpCD8.SafePlugin)({
        key: $77f30cc17fbf24cf$export$fd198b85b7fd4b80,
        state: {
            init (_, state) {
                return $77f30cc17fbf24cf$var$createFirstNodeDecSet(state);
            },
            apply (tr, currentState, _, newState) {
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
                // Reapply decorations if there are any steps that modify the document
                if (isDocChanged) return $77f30cc17fbf24cf$var$createFirstNodeDecSet(newState);
                return currentState;
            }
        },
        props: {
            decorations (state) {
                return $77f30cc17fbf24cf$export$fd198b85b7fd4b80.getState(state);
            }
        }
    });



var $cbY7C = parcelRequire("cbY7C");


var $5YDZX = parcelRequire("5YDZX");











var $2pQiO = parcelRequire("2pQiO");




/** Far-right margin width reserved for the Rovo button, where the Remix button must not show. */ const $21cd54fe956109a1$export$f71c1df40151e4dd = 80;



const $8ac8586c6f9c2f0b$export$2e0e85f705dfca46 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'stopEditing'
    }));
};
const $8ac8586c6f9c2f0b$export$67bd57d439e8e4eb = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'startEditing'
    }));
};
const $8ac8586c6f9c2f0b$export$62b9e387feb21f54 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'mouseLeave'
    }));
};
const $8ac8586c6f9c2f0b$export$681e7b82bbbeba93 = (view, side)=>{
    const meta = side ? {
        type: 'mouseEnter',
        side: side
    } : {
        type: 'mouseEnter'
    };
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), meta));
};
const $8ac8586c6f9c2f0b$export$f6d493eea1569e93 = (view, side)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'setHoverSide',
        side: side
    }));
};
const $8ac8586c6f9c2f0b$export$2ded006fde40ec1d = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'clearHoverSide'
    }));
};



const $1ea096474dcf7ec3$export$bab59f27a7347e45 = (view, event)=>{
    // Check if this is a keyboard shortcut (Ctrl/Cmd + key)
    const isShortcut = event.ctrlKey || event.metaKey || event.altKey;
    if (isShortcut) return false;
    // Only consider actual typing keys (not shortcuts)
    // We need to check if it's a single character key or a deletion key
    // and ensure it's not part of a shortcut
    const isTypingKey = // Single character keys (letters, numbers, symbols)
    event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete' || event.key === ' ' || event.key === 'Enter';
    if (!isTypingKey) return false;
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    // if user hasnt started typing yet, start timer
    if (!state?.isEditing) (0, $8ac8586c6f9c2f0b$export$67bd57d439e8e4eb)(view);
    return false;
};






var $anBbz = parcelRequire("anBbz");


var $h7MdN = parcelRequire("h7MdN");




/** Per-view pending hover state; avoids cross-editor singleton. */ const $4e83e20bfa47616e$var$pendingByView = new WeakMap();
/** Per-view RAF handle so clearPendingHoverSide cancels only that view's callback. */ const $4e83e20bfa47616e$var$rafIdByView = new WeakMap();
const $4e83e20bfa47616e$var$cancelScheduledProcessForView = (view)=>{
    const id = $4e83e20bfa47616e$var$rafIdByView.get(view);
    if (id !== undefined) {
        cancelAnimationFrame(id);
        $4e83e20bfa47616e$var$rafIdByView.delete(view);
    }
};
const $4e83e20bfa47616e$var$clearPendingHoverSide = (view)=>{
    $4e83e20bfa47616e$var$pendingByView.delete(view);
    $4e83e20bfa47616e$var$cancelScheduledProcessForView(view);
};
const $4e83e20bfa47616e$var$BLOCK_SELECTORS = '[data-node-anchor], [data-drag-handler-anchor-name]';
const $4e83e20bfa47616e$var$LEGACY_RIGHT_EDGE_SELECTOR = '[data-blocks-right-edge-button-container]';
const $4e83e20bfa47616e$var$getRightControlSelector = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-controls-side="right"], ${$4e83e20bfa47616e$var$LEGACY_RIGHT_EDGE_SELECTOR}` : $4e83e20bfa47616e$var$LEGACY_RIGHT_EDGE_SELECTOR;
const $4e83e20bfa47616e$var$LEGACY_LEFT_CONTROL_SELECTOR = '[data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]';
const $4e83e20bfa47616e$var$getLeftControlSelector = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-ctrl-drag-handle], ${$4e83e20bfa47616e$var$LEGACY_LEFT_CONTROL_SELECTOR}` : $4e83e20bfa47616e$var$LEGACY_LEFT_CONTROL_SELECTOR;
// Top-level blocks (no block ancestor), matched by anchor attribute so it works under both the
// legacy and native-anchor schemes.
const $4e83e20bfa47616e$var$getRootBlocks = (view)=>Array.from(view.dom.querySelectorAll($4e83e20bfa47616e$var$BLOCK_SELECTORS)).filter((el)=>!el.parentElement?.closest($4e83e20bfa47616e$var$BLOCK_SELECTORS));
// Find the root block whose vertical bounds contain clientY. Returns the measured rect so callers
// can reuse it without re-measuring.
const $4e83e20bfa47616e$var$findBlockAtY = (view, clientY)=>{
    for (const el of $4e83e20bfa47616e$var$getRootBlocks(view)){
        const rect = el.getBoundingClientRect();
        if (clientY >= rect.top && clientY <= rect.bottom) return {
            block: el,
            rect: rect
        };
    }
    return null;
};
const $4e83e20bfa47616e$var$getRightMarginBoundary = (view)=>(view.dom.ownerDocument.defaultView?.innerWidth ?? Number.POSITIVE_INFINITY) - (0, $21cd54fe956109a1$export$f71c1df40151e4dd);
// Classify where the cursor sits in the right margin beside the block at its height, running the
// block lookup once so the caller doesn't traverse the DOM twice per mousemove.
const $4e83e20bfa47616e$var$classifyRightMarginPosition = (view, event)=>{
    const found = $4e83e20bfa47616e$var$findBlockAtY(view, event.clientY);
    if (!found) return null;
    if (event.clientX <= found.rect.right) return null;
    return event.clientX > $4e83e20bfa47616e$var$getRightMarginBoundary(view) && !(0, $anBbz.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true) ? {
        type: 'gap'
    } : {
        type: 'active',
        block: found.block
    };
};
/**
 * Process hover position and set left/right side. Only invoked when right-side controls are
 * enabled (confluence_remix_button_right_side_block_fg); handleMouseMove returns early otherwise.
 */ const $4e83e20bfa47616e$var$processHoverSide = (view, api)=>{
    const event = $4e83e20bfa47616e$var$pendingByView.get(view);
    if (!event) return;
    $4e83e20bfa47616e$var$pendingByView.delete(view);
    $4e83e20bfa47616e$var$rafIdByView.delete(view);
    const editorContentArea = view.dom.closest('.ak-editor-content-area');
    if (!(editorContentArea instanceof HTMLElement)) return;
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    const target = event.target instanceof HTMLElement ? event.target : null;
    // EDITOR-7926: skip hover-side tracking while a diff is on screen (or a suggestion card is open)
    // so setHoverSide/mouseEnter don't flip-flop and jitter the controls.
    const currentUserIntent = api?.userIntent?.sharedState.currentState()?.currentUserIntent;
    const isDisplayingDiff = api?.showDiff?.sharedState.currentState()?.isDisplayingChanges ?? false;
    if (isDisplayingDiff || currentUserIntent === 'reviewing') return;
    // When hovering over block controls directly, infer side from which control we're over.
    // This is more reliable than bounds when controls are in portals outside the editor DOM.
    const rightEdgeElement = target?.closest($4e83e20bfa47616e$var$getRightControlSelector());
    if (rightEdgeElement) {
        if (state?.isMouseOut && (0, $anBbz.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
            (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view, 'right');
            return;
        }
        if (state?.hoverSide !== 'right') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'right');
        return;
    }
    const leftControlElement = target?.closest($4e83e20bfa47616e$var$getLeftControlSelector());
    if (leftControlElement) {
        if (state?.hoverSide !== 'left') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'left');
        return;
    }
    const closestBlock = target?.closest($4e83e20bfa47616e$var$BLOCK_SELECTORS);
    const blockElement = closestBlock instanceof HTMLElement ? closestBlock : null;
    // Not over a block: the cursor may be in the right margin beside content.
    const marginZone = blockElement ? null : $4e83e20bfa47616e$var$classifyRightMarginPosition(view, event);
    if (marginZone?.type === 'active' && api) {
        // handleMouseOver only reads event.target, so a target-only stand-in is enough here.
        (0, $h7MdN.handleMouseOver)(view, {
            target: marginZone.block
        }, api);
        // mouseenter doesn't fire over the click overlay, so clear isMouseOut here to re-show.
        if (state?.isMouseOut) {
            if ((0, $anBbz.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
                (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view, 'right');
                return;
            }
            (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view);
        }
        if (state?.hoverSide !== 'right') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'right');
        return;
    }
    // Keep the existing fixed Rovo gap in the control cohort. The treatment uses explicitly marked
    // control surfaces instead, so the rest of the right margin remains hoverable.
    if (marginZone?.type === 'gap' || event.clientX > $4e83e20bfa47616e$var$getRightMarginBoundary(view) && (!blockElement || !(0, $anBbz.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true))) {
        if (!state?.isMouseOut) {
            (0, $8ac8586c6f9c2f0b$export$2ded006fde40ec1d)(view);
            (0, $8ac8586c6f9c2f0b$export$62b9e387feb21f54)(view);
        }
        return;
    }
    // Over a block: fall through to the midpoint split so the left half keeps the drag handle and
    // the right half shows the Remix button.
    // Pick the side from the content midpoint, keeping the original left/right halves.
    const { left: left, right: right } = editorContentArea.getBoundingClientRect();
    const midpoint = (left + right) / 2;
    const nextHoverSide = event.clientX > midpoint ? 'right' : 'left';
    if (state?.hoverSide !== nextHoverSide) {
        if (state?.isMouseOut && target?.closest($4e83e20bfa47616e$var$BLOCK_SELECTORS) && (0, $anBbz.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
            (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view, nextHoverSide);
            return;
        }
        (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, nextHoverSide);
    }
};
const $4e83e20bfa47616e$export$3248c033e90a4ba0 = (view, event, rightSideControlsEnabled, api)=>{
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    // if user has stopped editing and moved their mouse, show block controls again
    if (state?.isEditing) (0, $8ac8586c6f9c2f0b$export$2e0e85f705dfca46)(view);
    // Only track hover side when right-side controls are enabled (single source: confluence_remix_button_right_side_block_fg via config)
    if (!rightSideControlsEnabled) return false;
    if (!(event instanceof MouseEvent)) return false;
    $4e83e20bfa47616e$var$pendingByView.set(view, event);
    $4e83e20bfa47616e$var$cancelScheduledProcessForView(view);
    const id = requestAnimationFrame(()=>{
        $4e83e20bfa47616e$var$processHoverSide(view, api);
    });
    $4e83e20bfa47616e$var$rafIdByView.set(view, id);
    return false;
};
const $4e83e20bfa47616e$export$fcff8e67f71577c3 = (view, rightSideControlsEnabled)=>{
    if (rightSideControlsEnabled) $4e83e20bfa47616e$var$clearPendingHoverSide(view);
    (0, $8ac8586c6f9c2f0b$export$62b9e387feb21f54)(view);
    return false;
};
const $4e83e20bfa47616e$export$2560ef85393729a7 = (view)=>{
    (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view);
    return false;
};


/** Elements that extend the editor hover area (block controls, right-edge button, etc.) */ const $78a32da2f9d512bf$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR = '[data-blocks-right-edge-button-container], [data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]';
const $78a32da2f9d512bf$var$getBlockControlsHoverAreaSelector = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-controls-surface], [data-editor-block-ctrl-drag-handle], ${$78a32da2f9d512bf$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR}` : $78a32da2f9d512bf$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR;
const $78a32da2f9d512bf$var$MOUSE_LEAVE_DEBOUNCE_MS = 200;
/** ClickAreaBlock overlay that wraps the editor content and covers the right margin. */ const $78a32da2f9d512bf$var$CLICK_AREA_SELECTOR = '[data-editor-click-wrapper]';
const $78a32da2f9d512bf$var$isMovingToBlockControlsArea = (target)=>target instanceof Element && !!target.closest($78a32da2f9d512bf$var$getBlockControlsHoverAreaSelector());
/**
 * The right margin is covered by the ClickAreaBlock overlay, which sits outside .ak-editor-content-area.
 * Hovering there should still surface the right-side Remix button, so keep controls alive — but only on
 * the right (past the content's right edge), and not in the far-right Rovo gap. The left gutter must
 * dismiss like the experiment-off path, so it is treated as inactive.
 */ const $78a32da2f9d512bf$var$isOverActiveClickArea = (target, clientX)=>{
    if (!(target instanceof Element)) return false;
    const clickArea = target.closest($78a32da2f9d512bf$var$CLICK_AREA_SELECTOR);
    if (!clickArea) return false;
    const contentRight = clickArea.querySelector('.ak-editor-content-area')?.getBoundingClientRect().right;
    if (contentRight !== undefined && clientX <= contentRight) return false;
    const innerWidth = target.ownerDocument.defaultView?.innerWidth ?? Number.POSITIVE_INFINITY;
    return clientX <= innerWidth - (0, $21cd54fe956109a1$export$f71c1df40151e4dd);
};
const $78a32da2f9d512bf$var$isOverTreatmentClickArea = (target, editorContentArea, clientX)=>{
    if (!(target instanceof Element) || !(editorContentArea instanceof HTMLElement)) return false;
    if (!target.closest($78a32da2f9d512bf$var$CLICK_AREA_SELECTOR)) return false;
    return clientX > editorContentArea.getBoundingClientRect().right;
};
const $78a32da2f9d512bf$export$d14f503a2a677768 = new (0, $kCECX.PluginKey)('interactionTrackingPlugin');
const $78a32da2f9d512bf$export$66f3b9297f4ee65b = (rightSideControlsEnabled = false, api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $78a32da2f9d512bf$export$d14f503a2a677768,
        state: {
            init () {
                const state = {
                    isEditing: false
                };
                if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) state.isMouseOut = false;
                return state;
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($78a32da2f9d512bf$export$d14f503a2a677768);
                const newState = {};
                switch(meta?.type){
                    case 'startEditing':
                        newState.isEditing = true;
                        break;
                    case 'stopEditing':
                        newState.isEditing = false;
                        break;
                    case 'mouseLeave':
                        newState.isMouseOut = true;
                        newState.hoverSide = undefined;
                        break;
                    case 'mouseEnter':
                        newState.isMouseOut = false;
                        if (meta.side) newState.hoverSide = meta.side;
                        break;
                    case 'setHoverSide':
                        newState.hoverSide = meta.side;
                        break;
                    case 'clearHoverSide':
                        newState.hoverSide = undefined;
                        break;
                }
                return {
                    ...pluginState,
                    ...newState
                };
            }
        },
        props: {
            handleKeyDown: $1ea096474dcf7ec3$export$bab59f27a7347e45,
            handleDOMEvents: {
                mousemove: (view, event)=>(0, $4e83e20bfa47616e$export$3248c033e90a4ba0)(view, event, rightSideControlsEnabled, api)
            }
        },
        view: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
            const editorContentArea = view.dom.closest('.ak-editor-content-area');
            // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
            let unbindMouseEnter;
            let unbindMouseLeave;
            let unbindDocumentMouseMove;
            let mouseLeaveTimeoutId = null;
            let lastMousePosition = {
                x: 0,
                y: 0
            };
            const scheduleMouseLeave = (event)=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
                // Preserve the existing hover targets for the control cohort.
                if (rightSideControlsEnabled && ($78a32da2f9d512bf$var$isMovingToBlockControlsArea(event.relatedTarget) || $78a32da2f9d512bf$var$isOverActiveClickArea(event.relatedTarget, event.clientX))) return;
                if (rightSideControlsEnabled && (0, $4o0zT.isExperimentEnabled)('cc_maui_remix_button_hover_corridor') && $78a32da2f9d512bf$var$isOverTreatmentClickArea(event.relatedTarget, editorContentArea, event.clientX)) return;
                mouseLeaveTimeoutId = setTimeout(()=>{
                    mouseLeaveTimeoutId = null;
                    // Re-check the control cohort's existing hover targets after the debounce.
                    if (rightSideControlsEnabled && typeof document !== 'undefined') {
                        const el = document.elementFromPoint(lastMousePosition.x, lastMousePosition.y);
                        if (el && ($78a32da2f9d512bf$var$isMovingToBlockControlsArea(el) || $78a32da2f9d512bf$var$isOverActiveClickArea(el, lastMousePosition.x))) return;
                        if (el && (0, $4o0zT.isExperimentEnabled)('cc_maui_remix_button_hover_corridor') && $78a32da2f9d512bf$var$isOverTreatmentClickArea(el, editorContentArea, lastMousePosition.x)) return;
                    }
                    (0, $4e83e20bfa47616e$export$fcff8e67f71577c3)(view, rightSideControlsEnabled);
                }, $78a32da2f9d512bf$var$MOUSE_LEAVE_DEBOUNCE_MS);
            };
            const cancelScheduledMouseLeave = ()=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
            };
            const handleDocumentMouseMove = (event)=>{
                lastMousePosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                // Catches block controls in portals that handleDOMEvents.mousemove misses.
                const isOverKnownHoverTarget = editorContentArea?.contains(event.target) || $78a32da2f9d512bf$var$isMovingToBlockControlsArea(event.target);
                const overClickArea = event.target instanceof Element && !!event.target.closest($78a32da2f9d512bf$var$CLICK_AREA_SELECTOR);
                if (isOverKnownHoverTarget || overClickArea) (0, $4e83e20bfa47616e$export$3248c033e90a4ba0)(view, event, rightSideControlsEnabled, api);
            };
            const handleTreatmentDocumentMouseMove = (event)=>{
                if ((0, $5YDZX.isBlockControlsSuppressionTarget)(event.target)) {
                    lastMousePosition = {
                        x: event.clientX,
                        y: event.clientY
                    };
                    cancelScheduledMouseLeave();
                    if (!$78a32da2f9d512bf$export$d14f503a2a677768.getState(view.state)?.isMouseOut) (0, $4e83e20bfa47616e$export$fcff8e67f71577c3)(view, rightSideControlsEnabled);
                    return;
                }
                handleDocumentMouseMove(event);
            };
            if (editorContentArea) {
                if (rightSideControlsEnabled && typeof document !== 'undefined') {
                    // RemixButtonDecoration fires exposure when the control is visible; this
                    // mount-time split only selects the appropriate interaction listener.
                    if ((0, $2pQiO.UNSAFE_expValNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', false) === true) unbindDocumentMouseMove = (0, $cbY7C.bind)(document, {
                        type: 'mousemove',
                        listener: handleTreatmentDocumentMouseMove,
                        options: {
                            passive: true
                        }
                    });
                    else unbindDocumentMouseMove = (0, $cbY7C.bind)(document, {
                        type: 'mousemove',
                        listener: handleDocumentMouseMove,
                        options: {
                            passive: true
                        }
                    });
                }
                unbindMouseEnter = (0, $cbY7C.bind)(editorContentArea, {
                    type: 'mouseenter',
                    listener: ()=>{
                        if (rightSideControlsEnabled) cancelScheduledMouseLeave();
                        (0, $4e83e20bfa47616e$export$2560ef85393729a7)(view);
                    }
                });
                unbindMouseLeave = (0, $cbY7C.bind)(editorContentArea, {
                    type: 'mouseleave',
                    listener: (event)=>{
                        const e = event;
                        lastMousePosition = {
                            x: e.clientX,
                            y: e.clientY
                        };
                        if (rightSideControlsEnabled) scheduleMouseLeave(e);
                        else (0, $4e83e20bfa47616e$export$fcff8e67f71577c3)(view, false);
                    }
                });
            }
            return {
                destroy: ()=>{
                    if (rightSideControlsEnabled) {
                        cancelScheduledMouseLeave();
                        unbindDocumentMouseMove?.();
                    }
                    unbindMouseEnter?.();
                    unbindMouseLeave?.();
                }
            };
        } : undefined
    });
};
const $78a32da2f9d512bf$export$27d80eabdcbf88a5 = (state)=>{
    return $78a32da2f9d512bf$export$d14f503a2a677768.getState(state);
};













var $1hQ0e = parcelRequire("1hQ0e");





var $kAPZe = parcelRequire("kAPZe");















var $2RAus = parcelRequire("2RAus");




const $a1fa225e90ca0ccd$export$a61ec0b8c52b12b5 = (transactions)=>{
    return transactions.some((tr)=>tr.getMeta('pointer') && tr.selectionSet);
};
const $a1fa225e90ca0ccd$export$176558ea818a3e54 = (tr)=>{
    return tr.getMeta((0, $6FQH1.selectionPreservationPluginKey));
};
const $a1fa225e90ca0ccd$export$a7b6f48b0ef94ac5 = (tr)=>tr.getMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META)) === true;
const $a1fa225e90ca0ccd$export$36518d6d9145806a = (a, b)=>{
    return !a && !b || !!a && !!b && a.eq(b);
};
const $a1fa225e90ca0ccd$export$e6bc8ad830dbda92 = (selection, view, options)=>{
    try {
        if (options?.focusEditor && !view.hasFocus()) // The native browser selection is only painted while the editor owns focus.
        // Formatting toolbar interactions can move focus away before we restore the range.
        view.focus();
        const domSelection = window.getSelection();
        if (!domSelection) return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        // Convert ProseMirror selection to DOM selection using view.domAtPos
        const anchor = view.domAtPos(selection.anchor);
        const head = view.domAtPos(selection.head);
        if (!anchor || !head) return;
        // Create a new DOM range from the ProseMirror selection
        const range = doc.createRange();
        range.setStart(anchor.node, anchor.offset);
        range.setEnd(head.node, head.offset);
        // Update the DOM selection to match ProseMirror's selection
        domSelection.removeAllRanges();
        domSelection.addRange(range);
    } catch  {
    // Silently fail if DOM selection sync fails
    // This can happen if positions are invalid or DOM hasn't updated yet
    }
};


const $635b558f5a41e938$export$36720c70349457f = (api)=>()=>{
        return new (0, $kpCD8.SafePlugin)({
            key: (0, $6FQH1.selectionPreservationPluginKey),
            state: {
                init () {
                    return {
                        preservedSelection: undefined,
                        syncDomSelectionForDoc: undefined
                    };
                },
                apply (tr, pluginState) {
                    const meta = (0, $a1fa225e90ca0ccd$export$176558ea818a3e54)(tr);
                    const newState = {
                        ...pluginState
                    };
                    if (meta?.type === 'startPreserving') {
                        newState.preservedSelection = (0, $i2jOy.createPreservedSelection)(tr.doc.resolve(tr.selection.from), tr.doc.resolve(tr.selection.to));
                        newState.syncDomSelectionForDoc = undefined;
                    } else if (meta?.type === 'stopPreserving') {
                        newState.preservedSelection = undefined;
                        newState.syncDomSelectionForDoc = undefined;
                    } else if (tr.docChanged) {
                        if (newState.preservedSelection) newState.preservedSelection = (0, $i2jOy.mapPreservedSelection)(newState.preservedSelection, tr);
                        newState.syncDomSelectionForDoc = (0, $a1fa225e90ca0ccd$export$a7b6f48b0ef94ac5)(tr) ? tr.doc : undefined;
                    }
                    if (!(0, $a1fa225e90ca0ccd$export$36518d6d9145806a)(newState.preservedSelection, pluginState.preservedSelection)) {
                        if (newState.preservedSelection) api?.core.actions.execute(api?.selection?.commands?.setBlockSelection(newState.preservedSelection));
                        else api?.core.actions.execute(api?.selection?.commands?.clearBlockSelection());
                    }
                    return newState;
                }
            },
            appendTransaction (transactions, _oldState, newState) {
                const pluginState = (0, $6FQH1.selectionPreservationPluginKey).getState(newState);
                const preservedSel = pluginState?.preservedSelection;
                const stateSel = newState.selection;
                if (!preservedSel) return null;
                // Auto-stop if user explicitly changes selection
                if ((0, $a1fa225e90ca0ccd$export$a61ec0b8c52b12b5)(transactions)) return (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                const selectionUnchanged = stateSel.from === preservedSel.from && stateSel.to === preservedSel.to;
                const selectionInvalid = preservedSel.from < 0 || preservedSel.to > newState.doc.content.size;
                if (selectionUnchanged || selectionInvalid) return null;
                const newSelection = (0, $i2jOy.createPreservedSelection)(newState.doc.resolve(preservedSel.from), newState.doc.resolve(preservedSel.to));
                // If selection becomes invalid, stop preserving
                if (!newSelection) return (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                return newState.tr.setSelection(newSelection);
            },
            view (initialView) {
                let view = initialView;
                const doc = (0, $1hQ0e.getDocument)();
                let pendingFormatSelectionSyncFrame;
                if (!doc) return {
                    update () {},
                    destroy () {}
                };
                const unbindDocumentMouseDown = (0, $cbY7C.bind)(doc, {
                    type: 'mousedown',
                    listener: (e)=>{
                        if (!(e.target instanceof HTMLElement)) return;
                        const { preservedSelection: preservedSelection } = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state) || {};
                        // If there is no current preserved selection or the editor is not focused, do nothing
                        if (!preservedSelection) return;
                        const clickedDragHandle = !!e.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR));
                        // When mouse down on a drag handle we continue preserving the selection
                        if (clickedDragHandle) return;
                        const clickedOutsideEditor = !e.target.closest('.ProseMirror');
                        // When mouse down outside the editor continue to preserve the selection
                        if (clickedOutsideEditor) return;
                        // Otherwise mouse down anywhere else in the editor stops preserving the selection
                        const tr = view.state.tr;
                        (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                            tr: tr
                        });
                        view.dispatch(tr);
                    },
                    // Use capture phase to stop preservation before appendTransaction runs,
                    // preventing unwanted selection restoration when the user clicks into the editor.
                    options: {
                        capture: true
                    }
                });
                return {
                    update (updateView, prevState) {
                        view = updateView;
                        const prevPreservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(prevState)?.preservedSelection;
                        const currPluginState = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state);
                        const currPreservedSelection = currPluginState?.preservedSelection;
                        const prevActiveNode = (0, $3BXSc.key).getState(prevState)?.activeNode;
                        const currActiveNode = (0, $3BXSc.key).getState(view.state)?.activeNode;
                        // Sync DOM selection when the preserved selection or active node changes
                        // AND the document has changed (e.g., nodes moved)
                        // This prevents stealing focus during menu navigation while still fixing ghost highlighting
                        const hasPreservedSelection = !!currPreservedSelection;
                        const preservedSelectionChanged = !(0, $a1fa225e90ca0ccd$export$36518d6d9145806a)(prevPreservedSelection, currPreservedSelection);
                        const activeNodeChanged = prevActiveNode !== currActiveNode;
                        const docChanged = prevState.doc !== view.state.doc;
                        const hasFormatSyncRequestForCurrentDoc = currPluginState?.syncDomSelectionForDoc === view.state.doc;
                        const shouldSyncDOMSelection = (hasPreservedSelection && (preservedSelectionChanged || activeNodeChanged) || hasFormatSyncRequestForCurrentDoc) && docChanged;
                        if (shouldSyncDOMSelection) {
                            const syncSelection = view.state.selection;
                            if (hasFormatSyncRequestForCurrentDoc) {
                                if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                                pendingFormatSelectionSyncFrame = requestAnimationFrame(()=>{
                                    pendingFormatSelectionSyncFrame = undefined;
                                    (0, $a1fa225e90ca0ccd$export$e6bc8ad830dbda92)(syncSelection, view, {
                                        focusEditor: true
                                    });
                                });
                            } else (0, $a1fa225e90ca0ccd$export$e6bc8ad830dbda92)(syncSelection, view);
                        }
                    },
                    destroy () {
                        if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                        unbindDocumentMouseDown();
                    }
                };
            },
            props: {
                handleKeyDown: (view, event)=>{
                    const { preservedSelection: preservedSelection } = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state) || {};
                    // If there is no current preserved selection, do nothing
                    if (!preservedSelection) return false;
                    api?.core?.actions.execute(api?.blockControls?.commands?.handleKeyDownWithPreservedSelection(event));
                    // While preserving selection, if user presses delete/backspace, prevent event from being
                    // handled by ProseMirror natively so that we can apply logic using the preserved selection.
                    return [
                        'backspace',
                        'delete'
                    ].includes(event.key.toLowerCase());
                }
            }
        });
    };



var $4PdTO = parcelRequire("4PdTO");














var $jbxiN = parcelRequire("jbxiN");


var $5ZzY2 = parcelRequire("5ZzY2");


var $kejMu = parcelRequire("kejMu");

const $6bf6cf1ab4ce135a$export$8b0a29773089448c = (context, reliableAnchorEnabled)=>context?.targetNode.type.name === 'layoutColumn' || Boolean(context) && reliableAnchorEnabled && context?.targetNode.parentType !== 'doc' ? undefined : 'left';
const $6bf6cf1ab4ce135a$var$getNodeContext = (state, pos)=>{
    const node = state.doc.nodeAt(pos);
    if (!node) return undefined;
    const $pos = state.doc.resolve(pos);
    const ancestors = [];
    for(let depth = 0; depth <= $pos.depth; depth++){
        const ancestor = $pos.node(depth);
        ancestors.push({
            depth: depth,
            pos: depth === 0 ? 0 : $pos.before(depth),
            type: {
                name: ancestor.type.name
            }
        });
    }
    return {
        ancestors: ancestors,
        depth: $pos.depth + 1,
        node: node,
        parentType: $pos.parent.type.name,
        pos: pos,
        type: {
            name: node.type.name
        }
    };
};
const $6bf6cf1ab4ce135a$export$4f1661252fe88f52 = (state, targetPos, activeNode)=>{
    const targetNodeContext = $6bf6cf1ab4ce135a$var$getNodeContext(state, targetPos);
    if (!targetNodeContext) return undefined;
    const activeNodeContext = activeNode ? $6bf6cf1ab4ce135a$var$getNodeContext(state, activeNode.pos) : undefined;
    const rootPos = activeNode ? activeNode.rootPos ?? activeNode.pos : targetPos;
    const rootNodeContext = $6bf6cf1ab4ce135a$var$getNodeContext(state, rootPos) ?? targetNodeContext;
    return {
        activeControlKey: activeNode?.controlKey,
        activeNode: activeNode && activeNodeContext ? {
            ...activeNodeContext,
            rootPos: rootPos,
            rootType: {
                name: activeNode.rootNodeType ?? rootNodeContext.type.name
            }
        } : undefined,
        rootNode: rootNodeContext,
        targetNode: targetNodeContext
    };
};
const $6bf6cf1ab4ce135a$export$f8fa93bfcf9e5778 = (view, activeNode, target = 'root')=>{
    if (!activeNode) return undefined;
    const rootPos = activeNode.rootPos ?? activeNode.pos;
    return $6bf6cf1ab4ce135a$export$4f1661252fe88f52(view.state, target === 'active' ? activeNode.pos : rootPos, activeNode);
};


const $a8915bbb2da1fdad$export$ba2ce54b2062db21 = (components)=>components.some((component)=>Boolean(component.component) || component.type === 'button' || component.type === 'menu' || component.type === 'menu-item' || component.type === 'nested-menu');


const $cfde8fc53cbe0d39$var$NO_ACTIVE = 'none';
const $cfde8fc53cbe0d39$var$EMPTY_CANDIDATES = new Map();
const $cfde8fc53cbe0d39$var$EMPTY_POSITIONS = [];
const $cfde8fc53cbe0d39$var$EMPTY_PROTECTED_POSITIONS = [];
const $cfde8fc53cbe0d39$export$1d5371bf2773f5c9 = {
    activeRevision: $cfde8fc53cbe0d39$var$NO_ACTIVE,
    candidates: $cfde8fc53cbe0d39$var$EMPTY_CANDIDATES,
    positions: $cfde8fc53cbe0d39$var$EMPTY_POSITIONS,
    protectedPositions: $cfde8fc53cbe0d39$var$EMPTY_PROTECTED_POSITIONS,
    visiblePositions: $cfde8fc53cbe0d39$var$EMPTY_POSITIONS
};
const $cfde8fc53cbe0d39$var$getActiveRevision = (activeNode)=>activeNode ? [
        activeNode.pos,
        activeNode.nodeType,
        activeNode.rootPos ?? activeNode.pos,
        activeNode.rootNodeType ?? ''
    ].join(':') : $cfde8fc53cbe0d39$var$NO_ACTIVE;
const $cfde8fc53cbe0d39$var$isInRange = (position, range)=>position >= range.from && position <= range.to;
const $cfde8fc53cbe0d39$var$normalizeRange = (range, contentSize)=>({
        from: Math.max(0, Math.min(contentSize, Math.min(range.from, range.to))),
        to: Math.max(0, Math.min(contentSize, Math.max(range.from, range.to)))
    });
const $cfde8fc53cbe0d39$var$getSurfaces = (resolvedSurfaces)=>resolvedSurfaces.flatMap(({ childrenMap: childrenMap, components: components, root: root })=>root && (0, $a8915bbb2da1fdad$export$ba2ce54b2062db21)(components) ? [
            {
                childrenMap: childrenMap,
                root: root
            }
        ] : []);
const $cfde8fc53cbe0d39$var$getNodeId = (node)=>{
    const localId = node.attrs?.localId;
    return typeof localId === 'string' ? localId : undefined;
};
const $cfde8fc53cbe0d39$var$sameCandidate = (first, second)=>first?.id === second?.id && first?.contextRevision === second?.contextRevision && first?.isPersistent === second?.isPersistent && first?.nodeRef === second?.nodeRef && first?.nodeType === second?.nodeType && first?.nodeSize === second?.nodeSize && first?.pos === second?.pos && first?.renders === second?.renders;
const $cfde8fc53cbe0d39$var$sameCandidateMap = (first, second)=>{
    if (first.size !== second.size) return false;
    for (const [position, candidate] of first){
        if (!$cfde8fc53cbe0d39$var$sameCandidate(candidate, second.get(position))) return false;
    }
    return true;
};
const $cfde8fc53cbe0d39$var$samePositions = (first, second)=>first.length === second.length && first.every((position, index)=>position === second[index]);
const $cfde8fc53cbe0d39$var$normalizePositions = (positions)=>Array.from(new Set(positions)).sort((first, second)=>first - second);
const $cfde8fc53cbe0d39$var$mapPositions = (positions, tr)=>$cfde8fc53cbe0d39$var$normalizePositions(positions.map((position)=>tr.docChanged ? tr.mapping.mapResult(position, 1) : {
            deleted: false,
            pos: position
        }).filter((result)=>!result.deleted).map((result)=>result.pos));
const $cfde8fc53cbe0d39$var$createSurfaceContextAtPosition = (state, position, activeNode)=>{
    const blockControlsContext = (0, $6bf6cf1ab4ce135a$export$4f1661252fe88f52)(state, position, activeNode);
    return blockControlsContext ? (0, $5ZzY2.createSurfaceContext)((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT), blockControlsContext) : undefined;
};
const $cfde8fc53cbe0d39$var$willAnySurfaceRenderAt = (surfaces, state, position, activeNode)=>{
    const surfaceContext = $cfde8fc53cbe0d39$var$createSurfaceContextAtPosition(state, position, activeNode);
    return surfaces.some(({ childrenMap: childrenMap, root: root })=>(0, $kejMu.willComponentRender)(root, childrenMap, surfaceContext));
};
const $cfde8fc53cbe0d39$var$addCandidateAt = ({ candidates: candidates, position: position, state: state, surfaces: surfaces, activeNode: activeNode })=>{
    const node = state.doc.nodeAt(position);
    if (!node?.isBlock) {
        candidates.delete(position);
        return;
    }
    const isPersistent = $cfde8fc53cbe0d39$var$willAnySurfaceRenderAt(surfaces, state, position, undefined);
    const renders = isPersistent || activeNode !== undefined && $cfde8fc53cbe0d39$var$willAnySurfaceRenderAt(surfaces, state, position, activeNode);
    candidates.set(position, {
        contextRevision: $cfde8fc53cbe0d39$var$getActiveRevision(activeNode),
        id: $cfde8fc53cbe0d39$var$getNodeId(node),
        isPersistent: isPersistent,
        nodeRef: node,
        nodeType: node.type.name,
        nodeSize: node.nodeSize,
        renders: renders,
        pos: position
    });
};
const $cfde8fc53cbe0d39$var$isInvalidated = (candidate, position, invalidation, changedRange)=>{
    if (invalidation?.all) return true;
    if (invalidation?.ids?.some((id)=>id === candidate.id)) return true;
    if (invalidation?.positions?.includes(position)) return true;
    return Boolean(changedRange && $cfde8fc53cbe0d39$var$isInRange(position, changedRange) || invalidation?.ranges?.some((range)=>$cfde8fc53cbe0d39$var$isInRange(position, range)));
};
const $cfde8fc53cbe0d39$var$getPositions = (candidates)=>Array.from(candidates.values()).filter((candidate)=>candidate.renders).map((candidate)=>candidate.pos).sort((first, second)=>first - second);
const $cfde8fc53cbe0d39$var$mapCandidates = (state, tr, retain)=>{
    const mapped = new Map();
    for (const candidate of state.candidates.values()){
        const result = tr.docChanged ? tr.mapping.mapResult(candidate.pos, 1) : {
            deleted: false,
            pos: candidate.pos
        };
        if (!result.deleted && retain(result.pos, candidate)) mapped.set(result.pos, result.pos === candidate.pos ? candidate : {
            ...candidate,
            pos: result.pos
        });
    }
    return mapped;
};
const $cfde8fc53cbe0d39$export$e9a3c245d64fdef4 = ({ newState: newState, previousState: previousState, tr: tr })=>{
    if (!tr.docChanged) return previousState;
    const candidates = new Map();
    for (const candidate of previousState.candidates.values()){
        const result = tr.mapping.mapResult(candidate.pos, 1);
        if (!result.deleted) candidates.set(result.pos, result.pos === candidate.pos ? candidate : {
            ...candidate,
            pos: result.pos
        });
    }
    const protectedPositions = $cfde8fc53cbe0d39$var$normalizePositions(previousState.protectedPositions.map((position)=>tr.mapping.mapResult(position, 1)).filter((result)=>!result.deleted).map((result)=>result.pos));
    const visiblePositions = $cfde8fc53cbe0d39$var$mapPositions(previousState.visiblePositions, tr);
    const positions = $cfde8fc53cbe0d39$var$getPositions(candidates);
    const candidatesUnchanged = $cfde8fc53cbe0d39$var$sameCandidateMap(previousState.candidates, candidates);
    const positionsUnchanged = $cfde8fc53cbe0d39$var$samePositions(previousState.positions, positions);
    const protectedUnchanged = $cfde8fc53cbe0d39$var$samePositions(previousState.protectedPositions, protectedPositions);
    if (candidatesUnchanged && positionsUnchanged && protectedUnchanged && $cfde8fc53cbe0d39$var$samePositions(previousState.visiblePositions, visiblePositions)) return previousState;
    return {
        ...previousState,
        candidates: candidatesUnchanged ? previousState.candidates : candidates,
        positions: positionsUnchanged ? previousState.positions : positions,
        protectedPositions: protectedUnchanged ? previousState.protectedPositions : protectedPositions,
        visiblePositions: visiblePositions
    };
};
const $cfde8fc53cbe0d39$export$41f4692a5297f434 = ({ activeNodesByPosition: activeNodesByPosition, activeNode: activeNode, changedRange: changedRange, documentChanged: documentChanged = false, invalidation: invalidation, newState: newState, protectedPositions: protectedPositions, resolvedSurfaces: resolvedSurfaces, state: state, visiblePositions: visiblePositions })=>$cfde8fc53cbe0d39$export$bf8449693ad9ef92({
        activeNode: activeNode,
        meta: {
            activeNodesByPosition: activeNodesByPosition,
            changedRange: changedRange,
            documentChanged: documentChanged,
            invalidation: invalidation,
            protectedPositions: protectedPositions,
            visiblePositions: visiblePositions
        },
        newState: newState,
        previousState: state,
        resolvedSurfaces: resolvedSurfaces,
        tr: newState.tr
    });
const $cfde8fc53cbe0d39$export$bf8449693ad9ef92 = ({ activeNode: activeNode, meta: meta, newState: newState, previousState: previousState, resolvedSurfaces: resolvedSurfaces, tr: tr })=>{
    const activeRevision = $cfde8fc53cbe0d39$var$getActiveRevision(activeNode);
    const activeChanged = activeRevision !== previousState.activeRevision;
    const hasVisiblePositionsUpdate = Boolean(meta && Object.prototype.hasOwnProperty.call(meta, 'visiblePositions'));
    const visiblePositions = hasVisiblePositionsUpdate ? $cfde8fc53cbe0d39$var$normalizePositions(meta?.visiblePositions ?? $cfde8fc53cbe0d39$var$EMPTY_POSITIONS) : tr.docChanged ? $cfde8fc53cbe0d39$var$mapPositions(previousState.visiblePositions, tr) : previousState.visiblePositions;
    const visiblePositionsChanged = !$cfde8fc53cbe0d39$var$samePositions(visiblePositions, previousState.visiblePositions);
    const requestedProtectedPositions = $cfde8fc53cbe0d39$var$normalizePositions(meta?.protectedPositions ?? previousState.protectedPositions);
    const protectedPositions = $cfde8fc53cbe0d39$var$samePositions(previousState.protectedPositions, requestedProtectedPositions) ? previousState.protectedPositions : requestedProtectedPositions;
    const protectedSet = new Set(protectedPositions);
    if (activeNode) {
        protectedSet.add(activeNode.pos);
        protectedSet.add(activeNode.rootPos ?? activeNode.pos);
    }
    const visibleSet = new Set(visiblePositions);
    const retain = (position, candidate)=>(candidate?.isPersistent || protectedSet.has(position) || visibleSet.has(position)) && position >= 0 && position <= newState.doc.content.size;
    const surfaces = $cfde8fc53cbe0d39$var$getSurfaces(resolvedSurfaces);
    const activeNodeAt = (position)=>meta?.activeNodesByPosition?.get(position) ?? activeNode ?? undefined;
    const changedRange = meta?.changedRange ? $cfde8fc53cbe0d39$var$normalizeRange(meta.changedRange, newState.doc.content.size) : undefined;
    const invalidation = meta?.invalidation;
    const documentChanged = meta?.documentChanged ?? tr.docChanged;
    const previousCandidates = $cfde8fc53cbe0d39$var$mapCandidates(previousState, tr, retain);
    const dirty = (candidate, position)=>{
        const currentNode = newState.doc.nodeAt(position);
        const currentContextRevision = $cfde8fc53cbe0d39$var$getActiveRevision(activeNodeAt(position));
        return activeChanged || candidate.contextRevision !== currentContextRevision || candidate.nodeRef !== currentNode || $cfde8fc53cbe0d39$var$isInvalidated(candidate, position, invalidation, changedRange);
    };
    if (surfaces.length === 0) {
        const noCandidates = previousCandidates.size === 0;
        if (noCandidates && previousState.positions.length === 0 && $cfde8fc53cbe0d39$var$samePositions(visiblePositions, previousState.visiblePositions) && activeRevision === previousState.activeRevision && protectedPositions === previousState.protectedPositions) return previousState;
        return {
            activeRevision: activeRevision,
            candidates: noCandidates ? previousState.candidates : $cfde8fc53cbe0d39$var$EMPTY_CANDIDATES,
            positions: $cfde8fc53cbe0d39$var$EMPTY_POSITIONS,
            protectedPositions: protectedPositions,
            visiblePositions: visiblePositions
        };
    }
    for (const [position, candidate] of previousCandidates)if (dirty(candidate, position)) {
        $cfde8fc53cbe0d39$var$addCandidateAt({
            candidates: previousCandidates,
            position: position,
            state: newState,
            surfaces: surfaces,
            activeNode: activeNodeAt(position)
        });
        const updatedCandidate = previousCandidates.get(position);
        if (updatedCandidate && !retain(position, updatedCandidate)) previousCandidates.delete(position);
    }
    // IO supplies exact visible positions. Iterate those positions directly so a long visible
    // container cannot cause a traversal of its entire nested document.
    if (visiblePositionsChanged || documentChanged || invalidation?.all || changedRange) {
        for (const position of visiblePositions)if (!previousCandidates.has(position)) $cfde8fc53cbe0d39$var$addCandidateAt({
            candidates: previousCandidates,
            position: position,
            state: newState,
            surfaces: surfaces,
            activeNode: activeNodeAt(position)
        });
    }
    const directPositions = new Set([
        ...protectedSet,
        ...invalidation?.positions ?? []
    ]);
    for (const position of directPositions)if (retain(position) && !previousCandidates.has(position)) $cfde8fc53cbe0d39$var$addCandidateAt({
        candidates: previousCandidates,
        position: position,
        state: newState,
        surfaces: surfaces,
        activeNode: activeNodeAt(position)
    });
    const positions = $cfde8fc53cbe0d39$var$getPositions(previousCandidates);
    if ($cfde8fc53cbe0d39$var$sameCandidateMap(previousState.candidates, previousCandidates) && $cfde8fc53cbe0d39$var$samePositions(previousState.positions, positions) && $cfde8fc53cbe0d39$var$samePositions(previousState.visiblePositions, visiblePositions) && activeRevision === previousState.activeRevision && protectedPositions === previousState.protectedPositions) return previousState;
    return {
        activeRevision: activeRevision,
        candidates: $cfde8fc53cbe0d39$var$sameCandidateMap(previousState.candidates, previousCandidates) ? previousState.candidates : previousCandidates,
        positions: $cfde8fc53cbe0d39$var$samePositions(previousState.positions, positions) ? previousState.positions : positions,
        protectedPositions: protectedPositions,
        visiblePositions: visiblePositions
    };
};






const $754ec62fae81da81$var$mergeInvalidation = ({ current: current, incoming: incoming, tr: tr })=>{
    if (!current && !incoming) return undefined;
    if (!incoming && !tr.docChanged) return current;
    const ids = [
        ...current?.ids ?? [],
        ...incoming?.ids ?? []
    ];
    const positions = [
        ...(current?.positions ?? []).map((position)=>tr.mapping.map(position, 1)),
        ...incoming?.positions ?? []
    ];
    const ranges = [
        ...(current?.ranges ?? []).map(({ from: from, to: to })=>({
                from: tr.mapping.map(from, -1),
                to: tr.mapping.map(to, 1)
            })),
        ...incoming?.ranges ?? []
    ];
    return ids.length || positions.length || ranges.length ? {
        ids: ids,
        positions: positions,
        ranges: ranges
    } : undefined;
};
const $754ec62fae81da81$var$mapAnchors = (anchors, tr)=>{
    if (!tr.docChanged || anchors.size === 0) return anchors;
    let changed = false;
    const mappedAnchors = new Map();
    for (const [position, name] of anchors){
        const mapped = tr.mapping.mapResult(position, 1);
        if (!mapped.deleted) {
            mappedAnchors.set(mapped.pos, name);
            changed || (changed = mapped.pos !== position);
        } else changed = true;
    }
    return changed ? mappedAnchors : anchors;
};
const $754ec62fae81da81$export$64f447718bba8261 = ({ invalidation: invalidation, previous: previous, tr: tr })=>({
        invalidation: $754ec62fae81da81$var$mergeInvalidation({
            current: previous.invalidation,
            incoming: invalidation,
            tr: tr
        })
    });
const $754ec62fae81da81$export$73db93f318abe217 = ({ pending: pending, previous: previous, tr: tr })=>!tr.docChanged && pending.invalidation === previous.invalidation;
const $754ec62fae81da81$export$da547146f46337b6 = ({ newState: newState, pending: pending, previous: previous, tr: tr })=>({
        ...previous,
        anchors: $754ec62fae81da81$var$mapAnchors(previous.anchors, tr),
        candidates: tr.docChanged ? (0, $cfde8fc53cbe0d39$export$e9a3c245d64fdef4)({
            newState: newState,
            previousState: previous.candidates,
            tr: tr
        }) : previous.candidates,
        decorations: tr.docChanged ? previous.decorations.map(tr.mapping, tr.doc) : previous.decorations,
        documentChanged: previous.documentChanged || tr.docChanged,
        invalidation: pending.invalidation
    });


const $7aafd2de513a1827$export$5adf3d3f9d6b07e7 = (candidates)=>({
        activeNodesByPosition: new Map(),
        anchors: new Map(),
        candidates: candidates,
        decorations: (0, $8nvEM.DecorationSet).empty,
        documentChanged: false
    });
const $7aafd2de513a1827$var$isReconciliationCommit = (meta)=>meta?.type === 'commitReconciliation';
const $7aafd2de513a1827$var$commitReconciliation = (previous, meta)=>({
        ...previous,
        ...meta.reconciliation,
        documentChanged: false,
        invalidation: undefined
    });
const $7aafd2de513a1827$export$3c564fcab2e336c4 = (input)=>{
    if ($7aafd2de513a1827$var$isReconciliationCommit(input.meta)) return $7aafd2de513a1827$var$commitReconciliation(input.previous, input.meta);
    const pending = (0, $754ec62fae81da81$export$64f447718bba8261)({
        invalidation: input.invalidation,
        previous: input.previous,
        tr: input.tr
    });
    if ((0, $754ec62fae81da81$export$73db93f318abe217)({
        pending: pending,
        previous: input.previous,
        tr: input.tr
    })) return input.previous;
    return (0, $754ec62fae81da81$export$da547146f46337b6)({
        newState: input.newState,
        pending: pending,
        previous: input.previous,
        tr: input.tr
    });
};






var $4RpM6 = parcelRequire("4RpM6");







const $a3b523e416d800c0$export$3a6e1f077fabc5a2 = 'block-controls-surface-anchor';
const $a3b523e416d800c0$export$f61a1376bd53a20 = 'data-block-controls-surface-anchor';
const $a3b523e416d800c0$export$189036dc6093a3a7 = 'data-block-controls-surface-node-type';
const $a3b523e416d800c0$export$139252ecae10e01e = '--block-controls-surface-anchor-name';
/**
 * These node views expose the box used by the measured placement fallback rather than their
 * ProseMirror node wrapper. The marker carries the name through a custom property so sparse CSS
 * can name that inner box without adding a widget or changing the node view.
 */ const $a3b523e416d800c0$var$INNER_CONTENT_NODE_TYPES = new Set([
    'blockCard',
    'bodiedExtension',
    'embedCard',
    'extension',
    'mediaSingle',
    'multiBodiedExtension',
    'table'
]);
const $a3b523e416d800c0$var$getMarkerStyle = (nodeType, anchorName)=>{
    const inheritedName = `${$a3b523e416d800c0$export$139252ecae10e01e}: ${anchorName};`;
    // Inner boxes get their anchor from the sparse global selector. Naming only the node wrapper
    // would position media/table/extension controls against the wrapper instead of visible content.
    return $a3b523e416d800c0$var$INNER_CONTENT_NODE_TYPES.has(nodeType) ? inheritedName : `${inheritedName} anchor-name: ${anchorName};`;
};
const $a3b523e416d800c0$export$502fa7412f6a6bb5 = (state, positions, resolveAnchorName, previousAnchors)=>{
    const anchors = new Map();
    const decorations = [];
    for (const position of positions){
        if (anchors.has(position)) continue;
        const node = state.doc.nodeAt(position);
        if (!node?.isBlock) continue;
        const anchorName = resolveAnchorName(node, position, previousAnchors?.get(position));
        if (!anchorName) continue;
        anchors.set(position, anchorName);
        decorations.push((0, $8nvEM.Decoration).node(position, position + node.nodeSize, {
            [$a3b523e416d800c0$export$f61a1376bd53a20]: anchorName,
            [$a3b523e416d800c0$export$189036dc6093a3a7]: node.type.name,
            style: $a3b523e416d800c0$var$getMarkerStyle(node.type.name, anchorName)
        }, {
            type: $a3b523e416d800c0$export$3a6e1f077fabc5a2,
            anchorName: anchorName,
            nodeType: node.type.name
        }));
    }
    return {
        anchors: anchors,
        decorations: (0, $8nvEM.DecorationSet).create(state.doc, decorations)
    };
};






const $4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE = 'data-prosemirror-node-name';
const $4b2c21d7d3b916ad$export$c4377b7ce17e217c = (view, onChange)=>{
    const win = view.dom.ownerDocument.defaultView;
    if (!win || typeof win.IntersectionObserver === 'undefined') return {
        update: ()=>{},
        destroy: ()=>{}
    };
    const targets = new Map();
    const visibleTargets = new Set();
    let previousPositions = [];
    let previousDoc = view.state.doc;
    let destroyed = false;
    const resolvePosition = (element)=>{
        try {
            const domPosition = view.posAtDOM(element, 0);
            const nodeName = element.getAttribute($4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE);
            const directNode = view.state.doc.nodeAt(domPosition);
            if (directNode?.isBlock && directNode.type.name === nodeName && view.nodeDOM(domPosition) === element) return domPosition;
            const $position = view.state.doc.resolve(domPosition);
            for(let depth = $position.depth; depth > 0; depth--){
                const node = $position.node(depth);
                if (!node.isBlock || node.type.name !== nodeName) continue;
                const position = $position.before(depth);
                const nodeDOM = view.nodeDOM(position);
                if (nodeDOM === element || nodeDOM instanceof Node && (nodeDOM.contains(element) || element.contains(nodeDOM))) return position;
            }
            return undefined;
        } catch  {
            return undefined;
        }
    };
    const getVisiblePositions = ()=>{
        const positions = new Set();
        visibleTargets.forEach((element)=>{
            const position = targets.get(element)?.position;
            if (position !== undefined) positions.add(position);
        });
        return Array.from(positions).sort((first, second)=>first - second);
    };
    const emit = ()=>{
        if (destroyed) return;
        const positions = getVisiblePositions();
        if (positions.length !== previousPositions.length || positions.some((position, index)=>position !== previousPositions[index])) {
            previousPositions = positions;
            onChange(positions);
        }
    };
    const intersectionObserver = new win.IntersectionObserver((entries)=>{
        let changed = false;
        for (const entry of entries){
            const element = entry.target;
            const target = targets.get(element);
            if (!target || !view.dom.contains(element)) continue;
            const isIntersecting = entry.isIntersecting;
            if (target.isIntersecting !== isIntersecting) {
                target.isIntersecting = isIntersecting;
                if (isIntersecting) {
                    target.position = resolvePosition(element);
                    if (target.position !== undefined) visibleTargets.add(element);
                    else target.isIntersecting = false;
                } else visibleTargets.delete(element);
                changed = true;
            }
        }
        if (changed) emit();
    }, {
        root: null,
        threshold: 0
    });
    const removeTarget = (element)=>{
        const target = targets.get(element);
        if (!target) return;
        targets.delete(element);
        visibleTargets.delete(element);
        intersectionObserver.unobserve(element);
    };
    const observeElement = (element)=>{
        const nodeName = element.getAttribute($4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE);
        if (element === view.dom || !nodeName || !view.state.schema.nodes[nodeName]?.isBlock || !view.dom.contains(element)) return;
        if (targets.has(element)) return;
        targets.set(element, {
            isIntersecting: false
        });
        intersectionObserver.observe(element);
    };
    const observeSubtree = (node)=>{
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const element = node;
        observeElement(element);
        const descendants = element.querySelectorAll(`[${$4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE}]`);
        for(let index = 0; index < descendants.length; index++)observeElement(descendants[index]);
    };
    const unobserveSubtree = (node)=>{
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const element = node;
        removeTarget(element);
        const descendants = element.querySelectorAll(`[${$4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE}]`);
        for(let index = 0; index < descendants.length; index++)removeTarget(descendants[index]);
    };
    const mutationObserver = new win.MutationObserver((records)=>{
        let removedVisibleTarget = false;
        for (const record of records){
            for(let index = 0; index < record.removedNodes.length; index++){
                const node = record.removedNodes[index];
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (view.dom.contains(node)) continue;
                    const before = visibleTargets.size;
                    unobserveSubtree(node);
                    removedVisibleTarget || (removedVisibleTarget = before !== visibleTargets.size);
                }
            }
            for(let index = 0; index < record.addedNodes.length; index++)observeSubtree(record.addedNodes[index]);
        }
        if (removedVisibleTarget) emit();
    });
    const initialTargets = view.dom.querySelectorAll(`[${$4b2c21d7d3b916ad$var$NODE_NAME_ATTRIBUTE}]`);
    for(let index = 0; index < initialTargets.length; index++)observeElement(initialTargets[index]);
    mutationObserver.observe(view.dom, {
        childList: true,
        subtree: true
    });
    return {
        update () {
            if (previousDoc !== view.state.doc) {
                previousDoc = view.state.doc;
                visibleTargets.forEach((element)=>{
                    const target = targets.get(element);
                    if (target) target.position = resolvePosition(element);
                });
                emit();
            }
        },
        destroy () {
            destroyed = true;
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
            targets.clear();
            visibleTargets.clear();
        }
    };
};


const $fa3f82a23aebe293$var$haveAnchorPositionsChanged = (positions, anchors)=>positions.length !== anchors.size || positions.some((position)=>!anchors.has(position));
const $fa3f82a23aebe293$export$4a2cabc2b98c0de5 = ({ api: api, pluginKey: pluginKey, view: view })=>{
    const win = view.dom.ownerDocument.defaultView;
    let frame;
    let visiblePositions = [];
    let registryChanged = true;
    const reconcile = ()=>{
        frame = undefined;
        const previous = pluginKey.getState(view.state);
        if (!previous || api?.limitedMode?.sharedState.currentState()?.enabled) return;
        const controls = (0, $3BXSc.key).getState(view.state);
        const activeNode = controls?.activeNode;
        const activeNodesByPosition = new Map();
        const menu = controls?.isMenuOpen ? controls.menuTriggerByNode : undefined;
        if (menu && controls?.menuTriggerBy && view.state.doc.nodeAt(menu.pos)) {
            const menuNode = {
                ...menu,
                anchorName: controls.menuTriggerBy
            };
            activeNodesByPosition.set(menu.pos, menuNode);
            activeNodesByPosition.set(menu.rootPos ?? menu.pos, menuNode);
        }
        const resolvedSurfaces = [
            (0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE),
            (0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE)
        ].map((surface)=>(0, $kejMu.resolveSurface)(api?.uiControlRegistry?.actions.getComponents(surface) ?? [], surface));
        const candidates = (0, $cfde8fc53cbe0d39$export$41f4692a5297f434)({
            activeNode: activeNode,
            activeNodesByPosition: activeNodesByPosition,
            newState: view.state,
            state: previous.candidates,
            visiblePositions: visiblePositions,
            protectedPositions: [
                ...activeNodesByPosition.keys()
            ],
            resolvedSurfaces: resolvedSurfaces,
            documentChanged: previous.documentChanged,
            invalidation: {
                ...previous.invalidation,
                all: registryChanged
            }
        });
        const visibilityChanged = registryChanged;
        registryChanged = false;
        const anchorPositions = candidates.positions;
        if (!visibilityChanged && !$fa3f82a23aebe293$var$haveAnchorPositionsChanged(anchorPositions, previous.anchors) && candidates === previous.candidates && !previous.documentChanged && !previous.invalidation) return;
        const nodeIdProvider = (0, $4RpM6.getNodeIdProvider)(view);
        const { anchors: anchors, decorations: decorations } = (0, $a3b523e416d800c0$export$502fa7412f6a6bb5)(view.state, anchorPositions, (node, position, previousAnchorName)=>{
            if (previousAnchorName) {
                nodeIdProvider.setIdForNode(node, previousAnchorName);
                return previousAnchorName;
            }
            return nodeIdProvider.getOrGenerateId(node, position);
        }, previous.anchors);
        view.dispatch(view.state.tr.setMeta(pluginKey, {
            reconciliation: {
                activeNodesByPosition: activeNodesByPosition,
                anchors: anchors,
                candidates: candidates,
                decorations: decorations
            },
            type: 'commitReconciliation'
        }));
    };
    const schedule = ()=>{
        if (frame === undefined && win) frame = win.requestAnimationFrame(reconcile);
    };
    const observer = (0, $4b2c21d7d3b916ad$export$c4377b7ce17e217c)(view, (positions)=>{
        visiblePositions = positions;
        schedule();
    });
    const invalidate = ()=>{
        registryChanged = true;
        schedule();
    };
    const unsubscribe = api?.uiControlRegistry?.actions.subscribe(invalidate);
    const unsubscribers = [
        api?.editorDisabled?.sharedState.onChange(invalidate),
        api?.editorViewMode?.sharedState.onChange(invalidate),
        api?.limitedMode?.sharedState.onChange(invalidate),
        api?.showDiff?.sharedState.onChange(invalidate),
        api?.userIntent?.sharedState.onChange(invalidate)
    ];
    return {
        update (currentView, previousState) {
            observer.update();
            const sparse = pluginKey.getState(currentView.state);
            const controls = (0, $3BXSc.key).getState(currentView.state);
            const previousControls = (0, $3BXSc.key).getState(previousState);
            if (controls?.isDragging !== previousControls?.isDragging || controls?.isResizerResizing !== previousControls?.isResizerResizing) invalidate();
            if (sparse?.documentChanged || sparse?.invalidation || controls?.activeNode !== previousControls?.activeNode || controls?.isMenuOpen !== previousControls?.isMenuOpen || controls?.menuTriggerByNode !== previousControls?.menuTriggerByNode) schedule();
        },
        destroy () {
            if (frame !== undefined) win?.cancelAnimationFrame(frame);
            observer.destroy();
            unsubscribe?.();
            unsubscribers.forEach((unsubscribe)=>unsubscribe?.());
        }
    };
};


const $2d2d2a0b149dfa16$export$124d0b9d0fc52a78 = new (0, $kCECX.PluginKey)('blockControlsSparseSurfaces');
const $2d2d2a0b149dfa16$export$3540c976585d7feb = (api)=>new (0, $kpCD8.SafePlugin)({
        key: $2d2d2a0b149dfa16$export$124d0b9d0fc52a78,
        state: {
            init: ()=>(0, $7aafd2de513a1827$export$5adf3d3f9d6b07e7)((0, $cfde8fc53cbe0d39$export$1d5371bf2773f5c9)),
            apply (tr, previous, _oldState, newState) {
                return (0, $7aafd2de513a1827$export$3c564fcab2e336c4)({
                    invalidation: tr.getMeta((0, $4PdTO.BLOCK_CONTROLS_SURFACE_INVALIDATION)),
                    meta: tr.getMeta($2d2d2a0b149dfa16$export$124d0b9d0fc52a78),
                    newState: newState,
                    previous: previous,
                    tr: tr
                });
            }
        },
        props: {
            decorations (state) {
                return api?.limitedMode?.sharedState.currentState()?.enabled || (0, $3BXSc.key).getState(state)?.isDragging ? (0, $8nvEM.DecorationSet).empty : $2d2d2a0b149dfa16$export$124d0b9d0fc52a78.getState(state)?.decorations;
            }
        },
        view: (view)=>(0, $fa3f82a23aebe293$export$4a2cabc2b98c0de5)({
                api: api,
                pluginKey: $2d2d2a0b149dfa16$export$124d0b9d0fc52a78,
                view: view
            })
    });



var $2w4SV = parcelRequire("2w4SV");


var $bOZni = parcelRequire("bOZni");

/* block-controls-left-surfaces.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $cozmU = parcelRequire("cozmU");














var $3k5Tv = parcelRequire("3k5Tv");


var $2XHKU = parcelRequire("2XHKU");







/* block-controls-left-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");








var $dQMlg = parcelRequire("dQMlg");

























const $98d4d22d5f1a9af3$export$2e1bb7d588e29ed3 = (components, surface, surfaceContext)=>{
    const { childrenMap: childrenMap, root: root, topLevelChildren: topLevelChildren } = (0, $kejMu.resolveSurface)(components, surface);
    if (!root || !topLevelChildren || topLevelChildren.length === 0) return {
        hoverOnlyComponents: [],
        persistentComponents: components
    };
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const storedSurfaceContext = context ? (0, $5ZzY2.createSurfaceContext)((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT), {
        activeNode: undefined,
        rootNode: context.targetNode,
        targetNode: context.targetNode
    }) : undefined;
    const isLeaf = (component)=>{
        const children = childrenMap.get((0, $kejMu.getComponentIdentity)(component));
        return !children || children.length === 0;
    };
    const persistentComponents = [];
    const hoverOnlyComponents = [];
    for (const component of components){
        if (!isLeaf(component)) {
            persistentComponents.push(component);
            hoverOnlyComponents.push(component);
            continue;
        }
        if ((0, $kejMu.willComponentRender)(component, childrenMap, storedSurfaceContext)) persistentComponents.push(component);
        else hoverOnlyComponents.push(component);
    }
    return {
        hoverOnlyComponents: hoverOnlyComponents,
        persistentComponents: persistentComponents
    };
};



var $lhJQI = parcelRequire("lhJQI");

const $24a7d4ba99de24c1$var$BlockControlsVisibilityContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    shouldHideHoverControls: false,
    useCssStyles: false
});
const $24a7d4ba99de24c1$var$BlockControlItem = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-editor-block-control-item": true,
        children: children
    });
const $24a7d4ba99de24c1$var$HoverBlockControlItem = ({ children: children })=>{
    const { shouldHideHoverControls: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $cozmU.useContext)($24a7d4ba99de24c1$var$BlockControlsVisibilityContext);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($24a7d4ba99de24c1$var$BlockControlItem, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lhJQI.VisibilityWrapper), {
            shouldHide: shouldHideHoverControls,
            useCssStyles: useCssStyles,
            children: children
        })
    });
};
const $24a7d4ba99de24c1$var$PersistentBlockControlItem = ({ children: children })=>{
    const { useCssStyles: useCssStyles } = (0, $cozmU.useContext)($24a7d4ba99de24c1$var$BlockControlsVisibilityContext);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($24a7d4ba99de24c1$var$BlockControlItem, {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lhJQI.VisibilityWrapper), {
            shouldHide: false,
            useCssStyles: useCssStyles,
            children: children
        })
    });
};
const $24a7d4ba99de24c1$export$8dd25c8d0f5ed852 = ({ children: children, shouldHideHoverControls: shouldHideHoverControls, useCssStyles: useCssStyles })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            shouldHideHoverControls: shouldHideHoverControls,
            useCssStyles: useCssStyles
        }), [
        shouldHideHoverControls,
        useCssStyles
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($24a7d4ba99de24c1$var$BlockControlsVisibilityContext.Provider, {
        value: value,
        children: children
    });
};
const $24a7d4ba99de24c1$var$withoutVisibilityPredicate = (component)=>{
    const { isHidden: _isHidden, ...visibleComponent } = component;
    return visibleComponent;
};
/**
 * Replaces the shared surface group with one stable wrapper group per visible control. The wrappers
 * inherit each control's rank, so SurfaceRenderer keeps the registry order without re-evaluating
 * the controls' visibility predicates.
 */ const $24a7d4ba99de24c1$var$getBlockControlsSurfaceComponents = (components, { group: group, section: section, surface: surface }, surfaceContext)=>{
    const resolvedSurface = (0, $kejMu.resolveSurface)(components, surface);
    const groupIdentity = (0, $kejMu.getComponentIdentity)(group);
    const controls = resolvedSurface.childrenMap.get(groupIdentity) ?? [];
    const visibleControls = controls.filter((control)=>!(control.isHidden?.({
            surfaceContext: surfaceContext
        }) ?? false));
    if (!resolvedSurface.root || visibleControls.length === 0) return undefined;
    const controlIdentities = new Set(controls.map((0, $kejMu.getComponentIdentity)));
    const visibleControlIdentities = new Set(visibleControls.map((0, $kejMu.getComponentIdentity)));
    const { persistentComponents: persistentComponents } = (0, $98d4d22d5f1a9af3$export$2e1bb7d588e29ed3)(resolvedSurface.components.filter((component)=>{
        const identity = (0, $kejMu.getComponentIdentity)(component);
        return !controlIdentities.has(identity) || visibleControlIdentities.has(identity);
    }), surface, surfaceContext);
    const persistentIdentities = new Set(persistentComponents.map((0, $kejMu.getComponentIdentity)));
    const structuralComponents = resolvedSurface.components.filter((component)=>{
        const identity = (0, $kejMu.getComponentIdentity)(component);
        return identity !== groupIdentity && !controlIdentities.has(identity);
    }).map($24a7d4ba99de24c1$var$withoutVisibilityPredicate);
    const wrappedControls = visibleControls.flatMap((control)=>{
        const identity = (0, $kejMu.getComponentIdentity)(control);
        const rank = control.parents?.find((parent)=>(0, $kejMu.getComponentIdentity)(parent) === groupIdentity)?.rank ?? 0;
        const wrapper = {
            component: persistentIdentities.has(identity) ? $24a7d4ba99de24c1$var$PersistentBlockControlItem : $24a7d4ba99de24c1$var$HoverBlockControlItem,
            key: `block-control-item:${identity}`,
            parents: [
                {
                    ...section,
                    rank: rank
                }
            ],
            type: 'group'
        };
        const visibleControl = {
            ...$24a7d4ba99de24c1$var$withoutVisibilityPredicate(control),
            parents: [
                {
                    key: wrapper.key,
                    rank: 0,
                    type: wrapper.type
                }
            ]
        };
        return [
            wrapper,
            visibleControl
        ];
    });
    return [
        ...structuralComponents,
        ...wrappedControls
    ];
};
const $24a7d4ba99de24c1$export$95f4abc80abfba6 = (components, surfaceContext)=>$24a7d4ba99de24c1$var$getBlockControlsSurfaceComponents(components, {
        group: (0, $eRJEr.BLOCK_CONTROLS_LEFT_GROUP),
        section: (0, $eRJEr.BLOCK_CONTROLS_LEFT_SECTION),
        surface: (0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE)
    }, surfaceContext);
const $24a7d4ba99de24c1$export$98af22c10f74589b = (components, surfaceContext)=>$24a7d4ba99de24c1$var$getBlockControlsSurfaceComponents(components, {
        group: (0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
        section: (0, $eRJEr.BLOCK_CONTROLS_RIGHT_SECTION),
        surface: (0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE)
    }, surfaceContext);






const $70688e1c5a2cf80f$var$leftSurfaceOuterStyles = null;
const $70688e1c5a2cf80f$var$leftSurfaceGutterStyles = {
    container: "_3n40gWbNoQ _0u2WMmrU95 _1pp6NdYbGa",
    row: "_37wbyuz9WS _1pp6NdYbGa _27asfwIZbP _31KQPbYbGa"
};
const $70688e1c5a2cf80f$var$leftSurfaceRowStyles = null; // Applied in addition to leftSurfaceRowStyles when the target node is sticky-eligible (e.g. long
// tables): the outer wrapper spans the node's full height (see `placement.height`), so the content
// can stick near the top of the viewport instead of scrolling off with the node's top edge.
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN in ./consts (must be a static literal here).
const $70688e1c5a2cf80f$var$leftSurfaceStickyStyles = null;
const $70688e1c5a2cf80f$var$BlockControlsLeftSurfaceContent = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const blockControlsContext = surfaceContext.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const controlSide = (0, $6bf6cf1ab4ce135a$export$8b0a29773089448c)(blockControlsContext, (0, $4o0zT.isExperimentEnabled)('platform_editor_controls_reliable_anchor'));
    const { shouldHide: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $lhJQI.useBlockControlsVisibility)({
        api: api,
        controlSide: controlSide,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut
    });
    const isSticky = placement.isSticky;
    const isTopLevel = blockControlsContext?.targetNode.parentType === 'doc';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "left",
        "data-testid": source === 'stored' ? 'block-controls-left-surface-stored' : source === 'active' ? 'block-controls-left-surface-active' : 'block-controls-left-surface',
        style: placement.style,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2RljVsYpy6 _42Yu6BgtVO",
            isTopLevel && $70688e1c5a2cf80f$var$leftSurfaceGutterStyles.container
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_2mHwu8FQfX _0hPCNLDIqT _3iDTPbQ4SZ",
                isTopLevel && $70688e1c5a2cf80f$var$leftSurfaceGutterStyles.row,
                isSticky && "_1mT5xdHE3j _2IhTon2ADO"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $24a7d4ba99de24c1$export$8dd25c8d0f5ed852), {
                shouldHideHoverControls: shouldHideHoverControls,
                useCssStyles: useCssStyles,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQMlg.SurfaceRenderer), {
                    components: components,
                    surface: (0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE),
                    surfaceContext: surfaceContext
                })
            })
        })
    });
}; /** Renders one left block-controls surface at a document position. */ 
const $70688e1c5a2cf80f$export$30145a712ffbbca = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    if (!placement) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($70688e1c5a2cf80f$var$BlockControlsLeftSurfaceContent, {
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
};




const $df8a3971dd475720$export$b0cbe0136ad0edbb = (activeNode, storedPositions)=>{
    const targetsByPosition = new Map();
    for (const position of storedPositions)targetsByPosition.set(position, {
        position: position,
        source: 'stored'
    });
    if (activeNode) {
        const rootPosition = activeNode.rootPos ?? activeNode.pos;
        targetsByPosition.set(rootPosition, {
            position: rootPosition,
            source: 'root'
        });
        if (activeNode.pos !== rootPosition) targetsByPosition.set(activeNode.pos, {
            position: activeNode.pos,
            source: 'active'
        });
    }
    return Array.from(targetsByPosition.values()).sort((first, second)=>first.position - second.position);
};



var $2INqe = parcelRequire("2INqe");

const $234470d187f9c266$var$INNER_CONTAINER_SELECTORS = {
    blockCard: '.datasourceView-content-inner-wrap',
    bodiedExtension: '.extension-container[data-layout]',
    embedCard: '.rich-media-item',
    extension: '.extension-container[data-layout]',
    mediaSingle: `.${(0, $2INqe.resizerItemClassName)}`,
    multiBodiedExtension: '.extension-container[data-layout]',
    table: `.${(0, $2INqe.resizerItemClassName)}`
};
const $234470d187f9c266$export$424aaf56b3266f55 = (nodeType)=>$234470d187f9c266$var$INNER_CONTAINER_SELECTORS[nodeType] !== undefined;
const $234470d187f9c266$export$1af8b8b0dd8d08da = (nodeElement, nodeType)=>{
    const selector = $234470d187f9c266$var$INNER_CONTAINER_SELECTORS[nodeType];
    if (!selector) return nodeElement;
    return nodeElement.querySelector(selector) ?? nodeElement;
};



var $jWiWP = parcelRequire("jWiWP");




const $f8594cb83650f9fd$export$919e5d0c3910bbe8 = ({ offsetParentRect: offsetParentRect, offsetParentScrollLeft: offsetParentScrollLeft, offsetParentScrollTop: offsetParentScrollTop, placement: placement })=>({
        ...placement,
        left: placement.left - (offsetParentRect?.left ?? 0) + offsetParentScrollLeft,
        top: placement.top - (offsetParentRect?.top ?? 0) + offsetParentScrollTop
    });
const $f8594cb83650f9fd$export$90170883635d4723 = ({ layout: layout, nodeRect: nodeRect, nodeType: nodeType, nodeTypeWithLevel: nodeTypeWithLevel, parentNodeType: parentNodeType, side: side })=>{
    if (nodeType === 'layoutColumn') // nodeRect.left + width/2 === nodeRect.right - width/2 — side-independent.
    return {
        left: nodeRect.left + nodeRect.width / 2,
        top: nodeRect.top,
        transform: 'translate(-50%, -50%)'
    };
    const gap = (0, $hTjcC.dragHandleGap)(nodeType, parentNodeType);
    const top = nodeRect.top + (0, $hTjcC.topPositionAdjustment)(nodeTypeWithLevel, layout);
    const height = (0, $jWiWP.shouldBeSticky)(nodeType) ? nodeRect.height : undefined;
    if (side === 'right') return {
        left: nodeRect.right + gap,
        top: top,
        transform: '',
        height: height
    };
    return {
        left: nodeRect.left,
        top: top,
        transform: `translateX(calc(-100% - ${gap}px))`,
        height: height
    };
};
const $f8594cb83650f9fd$export$54a73b8249dd22f5 = ({ leftGutterBoundary: leftGutterBoundary, ...options })=>{
    const placement = $f8594cb83650f9fd$export$90170883635d4723({
        ...options,
        side: 'left'
    });
    if (options.nodeType === 'layoutColumn') return placement;
    const gap = (0, $hTjcC.dragHandleGap)(options.nodeType, options.parentNodeType);
    return {
        ...placement,
        left: leftGutterBoundary,
        transform: '',
        width: Math.max(0, options.nodeRect.left - leftGutterBoundary - gap)
    };
};
const $f8594cb83650f9fd$export$bd91f529ff2fbab1 = (placement)=>({
        isSticky: placement.height !== undefined,
        style: {
            height: placement.height,
            left: placement.left,
            top: placement.top,
            transform: placement.transform,
            ...placement.width !== undefined ? {
                width: placement.width
            } : {}
        }
    });
/**
 * Where a surface goes when its anchor stops resolving, as the fallback argument to the block-axis
 * `anchor()` calls below.
 *
 * An anchor is invalid once its element stops generating a box e.g. (`display: none`) / removed node
 * Currently, anchor fallback is not unstable with some of the position-visibility options, so here
 * we manually set a fallback of -9999 so that it will render offscreen out of the viewport
 * without causing extra overflows
 */ const $f8594cb83650f9fd$var$INVALID_ANCHOR_OFFSCREEN_PX = 9999;
const $f8594cb83650f9fd$var$INVALID_ANCHOR_FALLBACK_TOP = `-${$f8594cb83650f9fd$var$INVALID_ANCHOR_OFFSCREEN_PX}px`;
const $f8594cb83650f9fd$var$INVALID_ANCHOR_FALLBACK_BOTTOM = `${$f8594cb83650f9fd$var$INVALID_ANCHOR_OFFSCREEN_PX}px`;
const $f8594cb83650f9fd$export$e4284299d90b52b0 = ({ anchorName: anchorName, layout: layout, nodeType: nodeType, nodeTypeWithLevel: nodeTypeWithLevel, parentNodeType: parentNodeType, side: side })=>{
    if (nodeType === 'layoutColumn') // The column's horizontal midpoint, matching the measured `nodeRect.left + width / 2` and the
    // legacy drag handle's own layout-column formula. Side-independent.
    return {
        isSticky: false,
        style: {
            left: `calc((anchor(${anchorName} left) + anchor(${anchorName} right)) / 2)`,
            positionAnchor: anchorName,
            top: `anchor(${anchorName} top, ${$f8594cb83650f9fd$var$INVALID_ANCHOR_FALLBACK_TOP})`,
            transform: 'translate(-50%, -50%)'
        }
    };
    const gap = (0, $hTjcC.dragHandleGap)(nodeType, parentNodeType);
    const isSticky = (0, $jWiWP.shouldBeSticky)(nodeType);
    return {
        isSticky: isSticky,
        style: {
            // A sticky wrapper is stretched with `bottom` instead of a measured `height`. Pairing it
            // with the adjusted `top` keeps the box ending exactly where the node does, however far
            // the top adjustment pushed the start down and however much the node later grows.
            ...isSticky ? {
                bottom: `anchor(${anchorName} bottom, ${$f8594cb83650f9fd$var$INVALID_ANCHOR_FALLBACK_BOTTOM})`
            } : {},
            left: side === 'right' ? `calc(anchor(${anchorName} right) + ${gap}px)` : `anchor(${anchorName} left)`,
            positionAnchor: anchorName,
            top: `calc(anchor(${anchorName} top, ${$f8594cb83650f9fd$var$INVALID_ANCHOR_FALLBACK_TOP}) + ${(0, $hTjcC.topPositionAdjustment)(nodeTypeWithLevel, layout)}px)`,
            // The left side grows away from the node without knowing its own width, so it pulls itself
            // back past its own box and the gap. The right side grows into the margin, so the gap is
            // already folded into `left` above.
            transform: side === 'right' ? '' : `translateX(calc(-100% - ${gap}px))`
        }
    };
};
const $f8594cb83650f9fd$export$e428c24bc880e76b = (options)=>{
    const placement = $f8594cb83650f9fd$export$e4284299d90b52b0({
        ...options,
        side: 'left'
    });
    if (options.nodeType === 'layoutColumn') return placement;
    const gap = (0, $hTjcC.dragHandleGap)(options.nodeType, options.parentNodeType);
    return {
        ...placement,
        style: {
            ...placement.style,
            left: 0,
            // In a `right` inset, `anchor(... left)` resolves from the containing block's right edge
            // to the anchor's left edge. Adding the gap ends this wrapper just before the node.
            right: `calc(anchor(${options.anchorName} left) + ${gap}px)`,
            transform: ''
        }
    };
};


const $77d3edece9c98308$var$EMPTY_SURFACE_POSITIONS = [];
const $77d3edece9c98308$var$EMPTY_SURFACE_ANCHORS = new Map();
const $77d3edece9c98308$var$EMPTY_SURFACE_COMPONENTS = [];
const $77d3edece9c98308$var$EMPTY_MEASURED_SURFACES = [];
const $77d3edece9c98308$export$4cff02cd9e409191 = ({ api: api, editorView: editorView })=>{
    const { activeNode: activeNode, surfaceAnchors: surfaceAnchors, surfaceActiveNodes: surfaceActiveNodes, surfaceNodePositions: surfaceNodePositions } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            activeNode: states.blockControlsState?.activeNode,
            surfaceActiveNodes: states.blockControlsState?.surfaceActiveNodes,
            surfaceAnchors: states.blockControlsState?.surfaceAnchors ?? $77d3edece9c98308$var$EMPTY_SURFACE_ANCHORS,
            surfaceNodePositions: states.blockControlsState?.surfaceNodePositions ?? $77d3edece9c98308$var$EMPTY_SURFACE_POSITIONS
        }));
    const components = api.uiControlRegistry?.actions.getComponents((0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE)) ?? $77d3edece9c98308$var$EMPTY_SURFACE_COMPONENTS;
    const targets = (0, $cozmU.useMemo)(()=>{
        const candidates = new Set(surfaceNodePositions);
        return (0, $df8a3971dd475720$export$b0cbe0136ad0edbb)(activeNode, surfaceNodePositions).filter(({ position: position })=>candidates.has(position));
    }, [
        activeNode,
        surfaceNodePositions
    ]);
    const surfaces = (0, $cozmU.useMemo)(()=>targets.flatMap((target)=>{
            const context = (0, $6bf6cf1ab4ce135a$export$4f1661252fe88f52)(editorView.state, target.position, surfaceActiveNodes?.get(target.position) ?? activeNode);
            if (!context) return [];
            const surfaceContext = (0, $5ZzY2.createSurfaceContext)((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT), context);
            const surfaceComponents = (0, $24a7d4ba99de24c1$export$95f4abc80abfba6)(components, surfaceContext);
            if (!surfaceComponents) return [];
             // The cache supplies the same anchor names used by ProseMirror decorations.
            const anchorName = (0, $2XHKU.isCSSAnchorSupported)() ? surfaceAnchors.get(target.position) : undefined; // Top-level controls can respond to the available left gutter without the surface
            // host knowing which controls are registered or how they adapt.
            const isTopLevel = context.targetNode.parentType === 'doc';
            return [
                {
                    ...target,
                    anchorName: anchorName,
                    blockControlsContext: context,
                    isTopLevel: isTopLevel,
                    surfaceComponents: surfaceComponents,
                    surfaceContext: surfaceContext
                }
            ];
        }), [
        activeNode,
        components,
        editorView,
        targets,
        surfaceAnchors,
        surfaceActiveNodes
    ]);
    /**
   * Placements that need no measuring, so they are derived rather than stored: every inset is an
   * `anchor()` the browser re-resolves on every layout change.
   */ const anchoredPlacements = (0, $cozmU.useMemo)(()=>new Map(surfaces.flatMap(({ anchorName: anchorName, blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position })=>{
            if (!anchorName) return [];
            const options = {
                anchorName: anchorName,
                layout: blockControlsContext.targetNode.node.attrs.layout,
                nodeType: blockControlsContext.targetNode.type.name,
                nodeTypeWithLevel: (0, $9HWym.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType
            };
            const placement = isTopLevel ? (0, $f8594cb83650f9fd$export$e428c24bc880e76b)(options) : (0, $f8594cb83650f9fd$export$e4284299d90b52b0)({
                ...options,
                side: 'left'
            });
            return [
                [
                    position,
                    placement
                ]
            ];
        })), [
        surfaces
    ]); // Only the surfaces that still need measuring drive the effect below, so a document of anchored
    // blocks binds no scroll or resize listeners at all.
    //
    // The shared empty array matters: `surfaces` gets a new identity on every hover, since
    // `activeNode` is one of its dependencies. Returning a fresh `[]` would give the effect a
    // changed dependency each time and re-run it for nothing, which is the cost the anchored path
    // exists to avoid.
    const measuredSurfaces = (0, $cozmU.useMemo)(()=>{
        const measured = surfaces.filter(({ anchorName: anchorName })=>!anchorName);
        return measured.length === 0 ? $77d3edece9c98308$var$EMPTY_MEASURED_SURFACES : measured;
    }, [
        surfaces
    ]);
    const [placements, setPlacements] = (0, $cozmU.useState)(new Map());
    const animationFrameRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (measuredSurfaces.length === 0) {
            // Clear only when there is something to clear. Handing React a fresh Map every time would
            // fail its identity check and commit a render to replace one empty map with another.
            setPlacements((previous)=>previous.size > 0 ? new Map() : previous);
            return;
        }
        const measurementTargets = measuredSurfaces.flatMap(({ blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position })=>{
            const targetNodeElement = editorView.nodeDOM(blockControlsContext.targetNode.pos);
            const targetElementRoot = targetNodeElement instanceof HTMLElement ? targetNodeElement : targetNodeElement?.parentElement;
            if (!targetElementRoot) return [];
            return [
                {
                    blockControlsContext: blockControlsContext,
                    isTopLevel: isTopLevel,
                    position: position,
                    targetElement: (0, $234470d187f9c266$export$1af8b8b0dd8d08da)(targetElementRoot, blockControlsContext.targetNode.type.name),
                    targetElementRoot: targetElementRoot
                }
            ];
        });
        const offsetParent = editorView.dom.offsetParent;
        const isDocumentOffsetParent = !offsetParent || offsetParent === (0, $1hQ0e.getDocument)()?.body;
        const scrollingOffsetParent = offsetParent instanceof HTMLElement && !isDocumentOffsetParent ? offsetParent : undefined;
        const updatePositions = ()=>{
            animationFrameRef.current = undefined;
            const offsetParentRect = offsetParent?.getBoundingClientRect();
            const offsetParentScrollTop = scrollingOffsetParent?.scrollTop ?? window.scrollY;
            const offsetParentScrollLeft = scrollingOffsetParent?.scrollLeft ?? window.scrollX;
            const nextPlacements = new Map();
            for (const { blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position, targetElement: targetElement, targetElementRoot: targetElementRoot } of measurementTargets){
                if (!targetElementRoot.isConnected || !targetElement.isConnected) continue;
                const options = {
                    layout: targetElementRoot.getAttribute('layout') ?? '',
                    nodeRect: targetElement.getBoundingClientRect(),
                    nodeType: blockControlsContext.targetNode.type.name,
                    nodeTypeWithLevel: (0, $9HWym.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                    parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType
                };
                const placement = isTopLevel ? (0, $f8594cb83650f9fd$export$54a73b8249dd22f5)({
                    ...options,
                    leftGutterBoundary: offsetParentRect?.left ?? 0
                }) : (0, $f8594cb83650f9fd$export$90170883635d4723)({
                    ...options,
                    side: 'left'
                });
                nextPlacements.set(position, (0, $f8594cb83650f9fd$export$bd91f529ff2fbab1)((0, $f8594cb83650f9fd$export$919e5d0c3910bbe8)({
                    offsetParentRect: offsetParentRect,
                    offsetParentScrollLeft: offsetParentScrollLeft,
                    offsetParentScrollTop: offsetParentScrollTop,
                    placement: placement
                })));
            }
            setPlacements(nextPlacements);
        };
        const schedulePositionUpdate = ()=>{
            if (animationFrameRef.current === undefined) animationFrameRef.current = requestAnimationFrame(updatePositions);
        };
        updatePositions();
        const resizeObserver = new ResizeObserver(schedulePositionUpdate);
        const observedElements = new Set([
            editorView.dom
        ]);
        for (const { targetElement: targetElement } of measurementTargets)observedElements.add(targetElement);
        if (offsetParent instanceof HTMLElement) observedElements.add(offsetParent);
        observedElements.forEach((element)=>resizeObserver.observe(element));
        const unbindWindowResize = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: schedulePositionUpdate
        });
        const unbindWindowScroll = (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: schedulePositionUpdate,
            options: {
                capture: true,
                passive: true
            }
        });
        const visualViewport = window.visualViewport;
        const unbindVisualViewportResize = visualViewport ? (0, $cbY7C.bind)(visualViewport, {
            type: 'resize',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindVisualViewportScroll = visualViewport ? (0, $cbY7C.bind)(visualViewport, {
            type: 'scroll',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindTransitionEnd = (0, $cbY7C.bind)(editorView.dom, {
            type: 'transitionend',
            listener: schedulePositionUpdate,
            options: {
                capture: true
            }
        });
        return ()=>{
            if (animationFrameRef.current !== undefined) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = undefined;
            }
            resizeObserver.disconnect();
            unbindWindowResize();
            unbindWindowScroll();
            unbindVisualViewportResize?.();
            unbindVisualViewportScroll?.();
            unbindTransitionEnd();
        };
    }, [
        editorView,
        measuredSurfaces
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: surfaces.map(({ position: position, source: source, surfaceComponents: surfaceComponents, surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $70688e1c5a2cf80f$export$30145a712ffbbca), {
                api: api,
                components: surfaceComponents,
                forceVisibleOnMouseOut: Boolean(activeNode?.handleOptions?.isFocused),
                placement: anchoredPlacements.get(position) ?? placements.get(position),
                source: source,
                surfaceContext: surfaceContext
            }, position))
    });
};


/* block-controls-right-surfaces.tsx generated by @compiled/babel-plugin v3.0.2 */ 





























/* block-controls-right-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 





parcelRequire("cozmU");











const $03db82a6f4106802$var$rightSurfaceOuterStyles = null;
const $03db82a6f4106802$var$rightSurfaceRowStyles = null; // Applied in addition to rightSurfaceRowStyles when the target node is sticky-eligible (e.g. long
// tables): the outer wrapper spans the node's full height (see `placement.height`), so the content
// can stick near the top of the viewport instead of scrolling off with the node's top edge.
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN in ./consts (must be a static literal here).
const $03db82a6f4106802$var$rightSurfaceStickyStyles = null;
const $03db82a6f4106802$var$BlockControlsRightSurfaceContent = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const { shouldHide: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $lhJQI.useBlockControlsVisibility)({
        api: api,
        controlSide: 'right',
        forceVisibleOnMouseOut: forceVisibleOnMouseOut
    });
    const isSticky = placement.isSticky;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "right",
        "data-testid": source === 'stored' ? 'block-controls-right-surface-stored' : source === 'active' ? 'block-controls-right-surface-active' : 'block-controls-right-surface',
        style: placement.style,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2RljVsYpy6 _42Yu6BgtVO"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_2mHwu8FQfX _0hPCNLDIqT _3iDTPbQ4SZ",
                isSticky && "_1mT5xdHE3j _2IhTon2ADO"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $24a7d4ba99de24c1$export$8dd25c8d0f5ed852), {
                shouldHideHoverControls: shouldHideHoverControls,
                useCssStyles: useCssStyles,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQMlg.SurfaceRenderer), {
                    components: components,
                    surface: (0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE),
                    surfaceContext: surfaceContext
                })
            })
        })
    });
};
const $03db82a6f4106802$export$bab798c3f2a2fbbd = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    if (!placement) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($03db82a6f4106802$var$BlockControlsRightSurfaceContent, {
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
};







const $46b926345779f3b2$var$EMPTY_SURFACE_POSITIONS = [];
const $46b926345779f3b2$var$EMPTY_SURFACE_ANCHORS = new Map();
const $46b926345779f3b2$var$EMPTY_SURFACE_COMPONENTS = [];
const $46b926345779f3b2$var$EMPTY_MEASURED_SURFACES = [];
const $46b926345779f3b2$export$79baf52a56f1adef = ({ api: api, editorView: editorView })=>{
    const { activeNode: activeNode, surfaceAnchors: surfaceAnchors, surfaceActiveNodes: surfaceActiveNodes, surfaceNodePositions: surfaceNodePositions } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            activeNode: states.blockControlsState?.activeNode,
            surfaceActiveNodes: states.blockControlsState?.surfaceActiveNodes,
            surfaceAnchors: states.blockControlsState?.surfaceAnchors ?? $46b926345779f3b2$var$EMPTY_SURFACE_ANCHORS,
            surfaceNodePositions: states.blockControlsState?.surfaceNodePositions ?? $46b926345779f3b2$var$EMPTY_SURFACE_POSITIONS
        }));
    const components = api.uiControlRegistry?.actions.getComponents((0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE)) ?? $46b926345779f3b2$var$EMPTY_SURFACE_COMPONENTS;
    const targets = (0, $cozmU.useMemo)(()=>{
        const candidates = new Set(surfaceNodePositions);
        return (0, $df8a3971dd475720$export$b0cbe0136ad0edbb)(activeNode, surfaceNodePositions).filter(({ position: position })=>candidates.has(position));
    }, [
        activeNode,
        surfaceNodePositions
    ]);
    const surfaces = (0, $cozmU.useMemo)(()=>targets.flatMap((target)=>{
            const context = (0, $6bf6cf1ab4ce135a$export$4f1661252fe88f52)(editorView.state, target.position, surfaceActiveNodes?.get(target.position) ?? activeNode);
            if (!context) return [];
            const surfaceContext = (0, $5ZzY2.createSurfaceContext)((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT), context);
            const surfaceComponents = (0, $24a7d4ba99de24c1$export$98af22c10f74589b)(components, surfaceContext);
            if (!surfaceComponents) return [];
             // The cache supplies the same anchor names used by ProseMirror decorations.
            const anchorName = (0, $2XHKU.isCSSAnchorSupported)() ? surfaceAnchors.get(target.position) : undefined;
            return [
                {
                    ...target,
                    anchorName: anchorName,
                    blockControlsContext: context,
                    surfaceComponents: surfaceComponents,
                    surfaceContext: surfaceContext
                }
            ];
        }), [
        activeNode,
        components,
        editorView,
        targets,
        surfaceAnchors,
        surfaceActiveNodes
    ]);
    /**
   * Placements that need no measuring, so they are derived rather than stored: every inset is an
   * `anchor()` the browser re-resolves on every layout change.
   */ const anchoredPlacements = (0, $cozmU.useMemo)(()=>new Map(surfaces.flatMap(({ anchorName: anchorName, blockControlsContext: blockControlsContext, position: position })=>anchorName ? [
                [
                    position,
                    (0, $f8594cb83650f9fd$export$e4284299d90b52b0)({
                        anchorName: anchorName,
                        nodeType: blockControlsContext.targetNode.type.name,
                        nodeTypeWithLevel: (0, $9HWym.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                        layout: blockControlsContext.targetNode.node.attrs.layout,
                        parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType,
                        side: 'right'
                    })
                ]
            ] : [])), [
        surfaces
    ]); // Only the surfaces that still need measuring drive the effect below, so a document of anchored
    // blocks binds no scroll or resize listeners at all.
    //
    // The shared empty array matters: `surfaces` gets a new identity on every hover, since
    // `activeNode` is one of its dependencies. Returning a fresh `[]` would give the effect a
    // changed dependency each time and re-run it for nothing, which is the cost the anchored path
    // exists to avoid.
    const measuredSurfaces = (0, $cozmU.useMemo)(()=>{
        const measured = surfaces.filter(({ anchorName: anchorName })=>!anchorName);
        return measured.length === 0 ? $46b926345779f3b2$var$EMPTY_MEASURED_SURFACES : measured;
    }, [
        surfaces
    ]);
    const [placements, setPlacements] = (0, $cozmU.useState)(new Map());
    const animationFrameRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (measuredSurfaces.length === 0) {
            // Clear only when there is something to clear. Handing React a fresh Map every time would
            // fail its identity check and commit a render to replace one empty map with another.
            setPlacements((previous)=>previous.size > 0 ? new Map() : previous);
            return;
        }
        const measurementTargets = measuredSurfaces.flatMap(({ blockControlsContext: blockControlsContext, position: position })=>{
            const targetNodeElement = editorView.nodeDOM(blockControlsContext.targetNode.pos);
            const targetElementRoot = targetNodeElement instanceof HTMLElement ? targetNodeElement : targetNodeElement?.parentElement;
            if (!targetElementRoot) return [];
            return [
                {
                    blockControlsContext: blockControlsContext,
                    position: position,
                    targetElement: (0, $234470d187f9c266$export$1af8b8b0dd8d08da)(targetElementRoot, blockControlsContext.targetNode.type.name),
                    targetElementRoot: targetElementRoot
                }
            ];
        });
        const offsetParent = editorView.dom.offsetParent;
        const isDocumentOffsetParent = !offsetParent || offsetParent === (0, $1hQ0e.getDocument)()?.body;
        const scrollingOffsetParent = offsetParent instanceof HTMLElement && !isDocumentOffsetParent ? offsetParent : undefined;
        const updatePositions = ()=>{
            animationFrameRef.current = undefined;
            const offsetParentRect = offsetParent?.getBoundingClientRect();
            const offsetParentScrollTop = scrollingOffsetParent?.scrollTop ?? window.scrollY;
            const offsetParentScrollLeft = scrollingOffsetParent?.scrollLeft ?? window.scrollX;
            const nextPlacements = new Map();
            for (const { blockControlsContext: blockControlsContext, position: position, targetElement: targetElement, targetElementRoot: targetElementRoot } of measurementTargets){
                if (!targetElementRoot.isConnected || !targetElement.isConnected) continue;
                const placement = (0, $f8594cb83650f9fd$export$90170883635d4723)({
                    layout: targetElementRoot.getAttribute('layout') ?? '',
                    nodeRect: targetElement.getBoundingClientRect(),
                    nodeType: blockControlsContext.targetNode.type.name,
                    nodeTypeWithLevel: (0, $9HWym.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                    parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType,
                    side: 'right'
                });
                nextPlacements.set(position, (0, $f8594cb83650f9fd$export$bd91f529ff2fbab1)((0, $f8594cb83650f9fd$export$919e5d0c3910bbe8)({
                    offsetParentRect: offsetParentRect,
                    offsetParentScrollLeft: offsetParentScrollLeft,
                    offsetParentScrollTop: offsetParentScrollTop,
                    placement: placement
                })));
            }
            setPlacements(nextPlacements);
        };
        const schedulePositionUpdate = ()=>{
            if (animationFrameRef.current === undefined) animationFrameRef.current = requestAnimationFrame(updatePositions);
        };
        updatePositions();
        const resizeObserver = new ResizeObserver(schedulePositionUpdate);
        const observedElements = new Set([
            editorView.dom
        ]);
        for (const { targetElement: targetElement } of measurementTargets)observedElements.add(targetElement);
        if (offsetParent instanceof HTMLElement) observedElements.add(offsetParent);
        observedElements.forEach((element)=>resizeObserver.observe(element));
        const unbindWindowResize = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: schedulePositionUpdate
        });
        const unbindWindowScroll = (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: schedulePositionUpdate,
            options: {
                capture: true,
                passive: true
            }
        });
        const visualViewport = window.visualViewport;
        const unbindVisualViewportResize = visualViewport ? (0, $cbY7C.bind)(visualViewport, {
            type: 'resize',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindVisualViewportScroll = visualViewport ? (0, $cbY7C.bind)(visualViewport, {
            type: 'scroll',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindTransitionEnd = (0, $cbY7C.bind)(editorView.dom, {
            type: 'transitionend',
            listener: schedulePositionUpdate,
            options: {
                capture: true
            }
        });
        return ()=>{
            if (animationFrameRef.current !== undefined) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = undefined;
            }
            resizeObserver.disconnect();
            unbindWindowResize();
            unbindWindowScroll();
            unbindVisualViewportResize?.();
            unbindVisualViewportScroll?.();
            unbindTransitionEnd();
        };
    }, [
        editorView,
        measuredSurfaces
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: surfaces.map(({ position: position, source: source, surfaceComponents: surfaceComponents, surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $03db82a6f4106802$export$bab798c3f2a2fbbd), {
                api: api,
                components: surfaceComponents,
                forceVisibleOnMouseOut: Boolean(activeNode?.handleOptions?.isFocused),
                placement: anchoredPlacements.get(position) ?? placements.get(position),
                source: source,
                surfaceContext: surfaceContext
            }, position))
    });
};





parcelRequire("cozmU");







/* block-controls-surface-drag-handle.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $kSwu1 = parcelRequire("kSwu1");








var $b2omX = parcelRequire("b2omX");


var $8dxef = parcelRequire("8dxef");





var $ldqjS = parcelRequire("ldqjS");


var $i6cU6 = parcelRequire("i6cU6");


var $8LYsc = parcelRequire("8LYsc");








var $lpNn5 = parcelRequire("lpNn5");
















const $286a401ce1b08347$export$c74f4d134603910f = (anchorPos, openedViaKeyboard)=>({
        anchorPos: anchorPos,
        openedViaKeyboard: openedViaKeyboard
    });
const $286a401ce1b08347$export$aedba7900cf20c7e = (node)=>{
    if (!node) return (0, $hTjcC.spacingBetweenNodesForPreview).default;
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.spacingBetweenNodesForPreview)[`heading${node.attrs.level}`] ?? (0, $hTjcC.spacingBetweenNodesForPreview).default;
    return (0, $hTjcC.spacingBetweenNodesForPreview)[nodeTypeName] ?? (0, $hTjcC.spacingBetweenNodesForPreview).default;
};
const $286a401ce1b08347$export$8f0a13ded3f90102 = (node)=>{
    if (!node) return (0, $hTjcC.nodeMargins).default;
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.nodeMargins)[`heading${node.attrs.level}`] ?? (0, $hTjcC.nodeMargins).default;
    return (0, $hTjcC.nodeMargins)[nodeTypeName] ?? (0, $hTjcC.nodeMargins).default;
};



var $frZvB = parcelRequire("frZvB");


var $eYPgl = parcelRequire("eYPgl");




const $946ff4c7c13f21c2$export$1de8070d9a6a8efd = (0, $cozmU.createContext)(undefined);
const $946ff4c7c13f21c2$export$3003b66c1c752635 = ()=>(0, $cozmU.useContext)($946ff4c7c13f21c2$export$1de8070d9a6a8efd);









var $hiQdW = parcelRequire("hiQdW");


var $bjg0G = parcelRequire("bjg0G");





var $4Vdlk = parcelRequire("4Vdlk");


var $deUyp = parcelRequire("deUyp");


var $d1Uph = parcelRequire("d1Uph");












var $9BGzJ = parcelRequire("9BGzJ");

const $49c9c259fcc0972f$var$EDITOR_BLOCKS_DRAG_INIT = 'Editor Blocks Drag Initialization Time';
const $49c9c259fcc0972f$export$77d6d50d8dfae206 = ({ api: api, elementRef: elementRef, getAnchorName: getAnchorName, getPos: getPos, nodeType: nodeType, start: start, view: view })=>{
    (0, $cozmU.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !view) return;
        return (0, $4Vdlk.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $bbndg.isCollapsedHeading)(api, handlePos)) {
                        (0, $bbndg.prepareCollapsedHeadingSelection)({
                            api: api,
                            expand: false,
                            headingPos: handlePos,
                            tr: tr
                        });
                        return tr;
                    }
                    if (!tr.selection.empty && (0, $bOZni.isHandleCorrelatedToSelection)(view.state, tr.selection, handlePos)) api?.blockControls?.commands.setMultiSelectPositions()({
                        tr: tr
                    });
                    else tr = (0, $bOZni.selectNode)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const { doc: doc, selection: selection } = view.state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const multiSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                if (multiSelect) {
                    sliceFrom = Math.min(multiSelect.anchor, multiSelect.head);
                    sliceTo = Math.max(multiSelect.anchor, multiSelect.head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultipleNodes = startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultipleNodes || startPos === undefined) return {
                            x: 0,
                            y: 0
                        };
                        const domAtPos = view.domAtPos.bind(view);
                        let heightBeforeHandle = 0;
                        let nodeStart = sliceFrom;
                        let activeNodeMarginTop = 0;
                        for(let index = 0; index < expandedSlice.content.childCount; index++){
                            const node = expandedSlice.content.maybeChild(index);
                            const nodeEnd = nodeStart + (node?.nodeSize ?? 0);
                            if (nodeEnd <= startPos) {
                                const nodeElement = (0, $bjg0G.findDomRefAtPos)(nodeStart, domAtPos);
                                const margins = (0, $286a401ce1b08347$export$8f0a13ded3f90102)(node);
                                heightBeforeHandle += (nodeElement instanceof HTMLElement ? nodeElement.offsetHeight : 0) + margins.top + margins.bottom;
                            } else {
                                activeNodeMarginTop = (0, $286a401ce1b08347$export$8f0a13ded3f90102)(node).top;
                                break;
                            }
                            nodeStart = nodeEnd;
                        }
                        return {
                            x: 0,
                            y: heightBeforeHandle + activeNodeMarginTop
                        };
                    },
                    render: ({ container: container })=>{
                        if (!isDraggingMultipleNodes && startPos !== undefined) {
                            const dom = (0, $bjg0G.findDomRefAtPos)(startPos, view.domAtPos.bind(view));
                            return dom instanceof HTMLElement ? (0, $9BGzJ.dragPreview)(container, {
                                dom: dom,
                                nodeType: nodeType
                            }) : undefined;
                        }
                        const previewContent = [];
                        expandedSlice.content.descendants((node, pos)=>{
                            const dom = (0, $bjg0G.findDomRefAtPos)(sliceFrom + pos, view.domAtPos.bind(view));
                            if (dom instanceof HTMLElement) previewContent.push({
                                dom: dom,
                                nodeSpacing: (0, $286a401ce1b08347$export$aedba7900cf20c7e)(node),
                                nodeType: node.type.name
                            });
                            return false;
                        });
                        return previewContent.length > 0 ? (0, $9BGzJ.dragPreview)(container, previewContent) : undefined;
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                if (start === undefined) return;
                // This handle is outside ProseMirror, so it owns the side effects normally started by PM.
                (0, $hiQdW.startMeasure)($49c9c259fcc0972f$var$EDITOR_BLOCKS_DRAG_INIT);
                (0, $d1Uph.defaultActiveAnchorTracker).reset();
                api?.core?.actions.execute(({ tr: tr })=>{
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const multiSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                    const attributes = multiSelect ? (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, multiSelect.anchor, multiSelect.head) : {
                        hasSelectedMultipleNodes: false,
                        nodeTypes: resolvedMovingNode.nodeAfter?.type.name
                    };
                    api?.blockControls?.commands.setNodeDragged(getPos, getAnchorName(), nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api?.analytics?.actions.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).DRAGGED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            hasSelectedMultipleNodes: attributes.hasSelectedMultipleNodes,
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: attributes.nodeTypes || ''
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).UI
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        api,
        elementRef,
        getAnchorName,
        getPos,
        nodeType,
        start,
        view
    ]);
};



var $fKt2m = parcelRequire("fKt2m");

const $4eaaad2403e4f845$var$SURFACE_DRAG_HANDLE_HEIGHT = 24;
const $4eaaad2403e4f845$var$SURFACE_DRAG_HANDLE_WIDTH = 12;
const $4eaaad2403e4f845$var$SURFACE_DRAG_HANDLE_BORDER_RADIUS = 4;
const $4eaaad2403e4f845$var$SURFACE_DRAG_HANDLE_Z_INDEX = 100;
const $4eaaad2403e4f845$var$dragHandleStyles = {
    root: "_30huDKYbGa _0bjKvDUNDJ _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHyKLB _3iDTPbQ4SZ _24h04i2Njc _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0jFU0VoWWg _39xV02xpxF _0KLXru66of _1UtDYz4YkS _0wOv4QAxrc _42Yu6BgtVO _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0QAuWQjOvk _24bGaToM2E _4EiLyUXzJH _1eOmH6o126 _0qoAqtVrZW _3sFUREiSCN _3gzVzLN4oS",
    scaled: "_0jFU0Vfgtu _39xV02HBbb",
    selected: "_0KLXruY9q9 _1UtDYzrFwf",
    keyboardFocused: "_32BiAhXzJH",
    firefoxSelection: "_41Q9JKjOvk",
    layoutColumn: "_1VJPcalxle",
    iconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $4eaaad2403e4f845$var$handleIconDragStart = (event)=>{
    if (!(0, $8dxef.getBrowserInfo)().chrome) return;
    event.stopPropagation();
    event.currentTarget.parentElement?.dispatchEvent(new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: event.dataTransfer
    }));
};
const $4eaaad2403e4f845$var$isSelected = (selection, pos, view)=>{
    if (typeof pos !== 'number' || !selection || !view) return false;
    return (0, $bOZni.isHandleCorrelatedToSelection)(view.state, selection, pos);
};
const $4eaaad2403e4f845$export$864462199165f9e3 = ({ api: api, surfaceContext: surfaceContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const view = (0, $946ff4c7c13f21c2$export$3003b66c1c752635)();
    const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
    const activeNode = context?.activeNode;
    const pos = activeNode?.pos;
    const nodeType = activeNode?.type.name ?? '';
    const buttonRef = (0, $cozmU.useRef)(null);
    const posRef = (0, $cozmU.useRef)(pos);
    posRef.current = pos;
    const getPos = (0, $cozmU.useCallback)(()=>posRef.current, []);
    const { activeNodeAnchorName: activeNodeAnchorName, handleOptions: handleOptions, interactionState: interactionState, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'interaction',
        'selection'
    ], (states)=>({
            activeNodeAnchorName: states.blockControlsState?.activeNode?.anchorName,
            handleOptions: states.blockControlsState?.activeNode?.handleOptions,
            interactionState: states.interactionState?.interactionState,
            selection: states.selectionState?.selection
        }));
    const [dragHandleSelected, setDragHandleSelected] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setDragHandleSelected($4eaaad2403e4f845$var$isSelected(selection, pos, view));
    }, [
        pos,
        selection,
        view
    ]);
    const isLayoutColumn = nodeType === 'layoutColumn';
    const isTopLevelNode = activeNode?.parentType === 'doc';
    const getAnchorName = (0, $cozmU.useCallback)(()=>{
        const surfaceAnchor = posRef.current === undefined ? undefined : api?.blockControls.sharedState.currentState()?.surfaceAnchors?.get(posRef.current);
        if (surfaceAnchor) return surfaceAnchor;
        if (activeNodeAnchorName) return activeNodeAnchorName;
        const currentPos = posRef.current;
        if (!view || currentPos === undefined) return '';
        const dom = view.nodeDOM(currentPos);
        if (!(dom instanceof HTMLElement)) return '';
        const anchorAttrName = (0, $fKt2m.getAnchorAttrName)();
        return dom.getAttribute(anchorAttrName) ?? dom.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME)) ?? dom.closest(`[${anchorAttrName}]`)?.getAttribute(anchorAttrName) ?? '';
    }, [
        activeNodeAnchorName,
        api,
        view
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = buttonRef.current;
        if (!view || !element) return;
        (0, $b2omX.surfaceDragHandleElementStore).set(view, element);
        return ()=>(0, $b2omX.surfaceDragHandleElementStore).release(view, element);
    }, [
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!handleOptions?.isFocused || !buttonRef.current || !view) return;
        let animationFrameId;
        let attempts = 0;
        const focusHandle = ()=>{
            const button = buttonRef.current;
            if (!button) return;
            button.focus();
            if (button.ownerDocument.activeElement !== button && attempts < 5) {
                attempts++;
                animationFrameId = requestAnimationFrame(focusHandle);
            }
        };
        focusHandle();
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            view.focus();
        };
    }, [
        handleOptions?.isFocused,
        view
    ]);
    (0, $49c9c259fcc0972f$export$77d6d50d8dfae206)({
        api: api,
        elementRef: buttonRef,
        getAnchorName: getAnchorName,
        getPos: getPos,
        nodeType: nodeType,
        start: pos,
        view: view
    });
    const handleMouseDown = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(api?.blockControls?.commands.setSelectedViaDragHandle(true));
    }, [
        api
    ]);
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        if (!view) return;
        const openedViaKeyboard = event.detail === 0;
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', (0, $286a401ce1b08347$export$c74f4d134603910f)(startPos, openedViaKeyboard));
            const selection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection ?? tr.selection;
            const resolvedStartPos = tr.doc.resolve(startPos);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeTypes: resolvedStartPos.nodeAfter?.type.name || ''
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            })(tr);
            (0, $2w4SV.expandAndUpdateSelection)({
                api: api,
                isShiftPressed: event.shiftKey,
                nodeType: nodeType,
                selection: selection,
                startPos: startPos,
                tr: tr
            });
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) (0, $bbndg.prepareCollapsedHeadingSelection)({
                api: api,
                expand: true,
                headingPos: startPos,
                tr: tr
            });
            api?.blockControls?.commands.startPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands.toggleBlockMenu({
                anchorName: getAnchorName(),
                openedViaKeyboard: openedViaKeyboard,
                triggerByNode: {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: activeNode?.rootPos ?? resolvedStartPos.before(1)
                }
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        activeNode?.rootPos,
        api,
        getAnchorName,
        getPos,
        nodeType,
        view
    ]);
    const label = formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
        br: ' '
    });
    const helpDescriptors = (0, $cozmU.useMemo)(()=>[
            {
                description: formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
                    br: /*#__PURE__*/ (0, $8aG6j.jsx)("br", {})
                })
            }
        ], [
        formatMessage
    ]);
    const handleTooltipShow = (0, $cozmU.useCallback)(()=>{
        api?.accessibilityUtils?.actions.ariaNotify(label, {
            priority: 'important'
        });
    }, [
        api,
        label
    ]);
    if (!view || !activeNode || pos === undefined) return null;
    const tooltipContent = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.TooltipContentWithMultipleShortcuts), {
        helpDescriptors: helpDescriptors
    });
    const browser = (0, $8dxef.getBrowserInfo)();
    const button = /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
        ref: buttonRef,
        type: "button",
        "aria-label": label,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onDrop: (event)=>event.stopPropagation(),
        "data-editor-block-ctrl-drag-handle": true,
        "data-blocks-drag-handle": (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') || undefined,
        "data-testid": "block-controls-surface-drag-handle",
        className: (0, $hekY6.default)([
            $4eaaad2403e4f845$var$dragHandleStyles.root,
            browser.gecko && $4eaaad2403e4f845$var$dragHandleStyles.firefoxSelection,
            isLayoutColumn && $4eaaad2403e4f845$var$dragHandleStyles.layoutColumn,
            dragHandleSelected && interactionState !== 'hasNotHadInteraction' && $4eaaad2403e4f845$var$dragHandleStyles.selected,
            handleOptions?.isFocused && $4eaaad2403e4f845$var$dragHandleStyles.keyboardFocused,
            $4eaaad2403e4f845$var$dragHandleStyles.scaled
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            onDragStart: $4eaaad2403e4f845$var$handleIconDragStart,
            className: (0, $hekY6.default)([
                $4eaaad2403e4f845$var$dragHandleStyles.iconWrapper
            ]),
            children: (0, $eYPgl.shouldUseNestedDragHandleIcon)(Boolean(isTopLevelNode), isLayoutColumn) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $frZvB.DragHandleNestedIcon), {}) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
                label: "",
                size: "small",
                spacing: "spacious"
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        position: "top",
        content: tooltipContent,
        ignoreTooltipPointerEvents: true,
        onShow: handleTooltipShow,
        children: button
    });
};


const $c010f6dde1747120$export$88d90db17f630aa9 = ({ api: api })=>[
        {
            component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4eaaad2403e4f845$export$864462199165f9e3), {
                    api: api,
                    surfaceContext: surfaceContext
                }),
            isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                const context = surfaceContext?.get((0, $jbxiN.BLOCK_CONTROL_UI_CONTEXT));
                return api?.editorViewMode?.sharedState.currentState()?.mode === 'view' || !context?.activeNode || context.targetNode.pos !== context.activeNode.pos || context.activeControlKey !== undefined && context.activeControlKey !== (0, $eRJEr.BLOCK_CONTROLS_DRAG_HANDLE).key;
            },
            ...(0, $eRJEr.BLOCK_CONTROLS_DRAG_HANDLE),
            parents: [
                {
                    ...(0, $eRJEr.BLOCK_CONTROLS_LEFT_GROUP),
                    rank: 200
                }
            ]
        }
    ];


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");













var $fngNp = parcelRequire("fngNp");


var $7Y8M5 = parcelRequire("7Y8M5");
















function $9d0abd7f97ed1440$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This anchor element selector disregards anchors that are solely utilized for size measurements,
 * including those within table rows and media.
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelector = '[data-drag-handler-anchor-name]:not([data-drag-handler-node-type="tableRow"], [data-drag-handler-node-type="media"])';
/**
 * Disregards anchors that can not have handles next to them, and so shouldn't have an extended hover zone
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"])`;
/**
 * Extended version that also excludes descendants of taskList.
 * preventing the ::after hover zone from blocking checkbox inputs in blockTaskItem nodes.
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"], [data-prosemirror-node-name="taskList"] [${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}])`;
const $9d0abd7f97ed1440$var$gutterPaddingWidth = ()=>(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? `${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px` : '100%';
const $9d0abd7f97ed1440$var$gutterPaddingLeft = ()=>(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? `-${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px` : '-100px';
const $9d0abd7f97ed1440$var$extendedHoverZone = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.block-ctrl-drag-preview ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $9d0abd7f97ed1440$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $9d0abd7f97ed1440$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // hover zone for layout column should be placed near the top of the column (where drag handle is)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&& [data-drag-handler-anchor-name][data-layout-column]::after': {
                content: '""',
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                top: `${-(0, $kAPZe.DRAG_HANDLE_WIDTH) / 2}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                height: `${(0, $kAPZe.DRAG_HANDLE_WIDTH)}px`,
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        //eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-blocks-drag-handle-container="true"] + [data-drag-handler-anchor-depth="0"]::after': {
            display: 'none'
        }
    });
const $9d0abd7f97ed1440$var$extendedHoverZoneNext = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.block-ctrl-drag-preview ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // Top level depth hover zone should extend to gutter padding area
            // we select the top level by using NOT nested anchor selector
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $9d0abd7f97ed1440$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $9d0abd7f97ed1440$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`[data-blocks-drag-handle-container="true"] + ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            display: 'none'
        }
    });
const $9d0abd7f97ed1440$var$layoutColumnExtendedHoverZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // hover zone for layout column should be placed near the top of the column (where drag handle is)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            content: '""',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            top: `${-(0, $kAPZe.DRAG_HANDLE_WIDTH) / 2}px`,
            left: 0,
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $kAPZe.DRAG_HANDLE_WIDTH)}px`,
            cursor: 'default',
            zIndex: 1
        }
    }
});
const $9d0abd7f97ed1440$var$layoutColumnWithoutHoverZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // when advanced_layouts is off, layout columns should not have hover zones, because there aren't any drag handles for layout columns
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            display: 'none'
        }
    }
});
const $9d0abd7f97ed1440$var$extendHoverZoneReduced = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $9d0abd7f97ed1440$var$extendHoverZoneReducedNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`> ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $9d0abd7f97ed1440$var$extendedDragZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $9d0abd7f97ed1440$var$extendedDragZoneNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $9d0abd7f97ed1440$var$paragraphWithTrailingBreakAsOnlyChild = '+ :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $9d0abd7f97ed1440$var$indentatedParagraphWithTrailingBreakAsOnlyChild = '+ div.fabric-editor-indentation-mark > :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $9d0abd7f97ed1440$var$paragraphWithPlaceholder = '+ p > .placeholder-decoration';
const $9d0abd7f97ed1440$var$dragHandleContainer = '.ProseMirror-widget[data-blocks-drag-handle-container="true"]';
const $9d0abd7f97ed1440$var$dragHandleSelector = 'button[data-testid="block-ctrl-drag-handle"]';
const $9d0abd7f97ed1440$var$dropTargetContainer = '.ProseMirror-widget[data-blocks-drop-target-container="true"]';
const $9d0abd7f97ed1440$var$dividerBodiedInCustomPanelWithNoIconSelector = '[data-panel-type].ak-editor-panel__no-icon .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + hr, [data-panel-type] hr:first-child';
const $9d0abd7f97ed1440$var$withInlineNodeStyleSelectors = [
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$paragraphWithTrailingBreakAsOnlyChild}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$indentatedParagraphWithTrailingBreakAsOnlyChild}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$paragraphWithPlaceholder}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`
].join(', ');
const $9d0abd7f97ed1440$var$withFormatInLayoutStyleFixSelectors = [
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-font-size > :is(h1, h2, h3, h4, h5, h6):first-child`
].join(', ');
/**
 * Please do not change change transform to display:none, or visibility:hidden
 * Otherwise it might break composition input for Chrome
 * https://product-fabric.atlassian.net/browse/ED-24136
 */ const $9d0abd7f97ed1440$var$withInlineNodeStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$9d0abd7f97ed1440$var$withInlineNodeStyleSelectors]: {
        transform: 'scale(0)'
    }
});
const $9d0abd7f97ed1440$var$legacyBreakoutWideLayoutStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '.ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
        '@media (width>=1280px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidth)}px`
        }
    }
});
const $9d0abd7f97ed1440$var$globalDnDStyle = {
    name: "rngdgu",
    styles: ".ProseMirror{[data-layout-content]{user-drag:none;}}"
};
var $9d0abd7f97ed1440$var$_ref = {
    name: "e9bpdb",
    styles: ".ProseMirror-widget:first-child + *:not([data-panel-type], .code-block, [data-node-type=\"nestedExpand\"], [data-node-type=\"expand\"], [data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}.ProseMirror-widget:first-child + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child, .ProseMirror-widget:first-child + .ProseMirror-widget + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child{margin-top:0 !important;}"
};
const $9d0abd7f97ed1440$var$globalStyles = ()=>$9d0abd7f97ed1440$var$_ref;
const $9d0abd7f97ed1440$var$withDividerInPanelStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$dividerBodiedInCustomPanelWithNoIconSelector}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$withDeleteLinesStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`p[data-drag-handler-anchor-name] ${$9d0abd7f97ed1440$var$dragHandleContainer}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'none !important'
    }
});
// Image dnd is broken in Firefox due to a previous fix for image caption https://product-fabric.atlassian.net/browse/ED-14034
// We could remove this fix if the previous issue is invalid
const $9d0abd7f97ed1440$var$withMediaSingleStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    ['.ProseMirror.ua-firefox .mediaSingleView-content-wrap[data-drag-handler-node-type="mediaSingle"][data-drag-handler-anchor-name], .ProseMirror.ua-firefox [data-drag-handler-anchor-name][data-drag-handler-node-type] .mediaSingleView-content-wrap']: {
        userSelect: 'auto',
        cursor: 'pointer'
    }
});
const $9d0abd7f97ed1440$var$withFormatInLayoutStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$withFormatInLayoutStyleFixSelectors}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$headingWithIndentationInLayoutStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$withRelativePosStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $fngNp.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $9d0abd7f97ed1440$var$withRelativePosStyleNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $fngNp.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $9d0abd7f97ed1440$var$withAnchorNameZindexStyle = {
    name: "okzdt4",
    styles: ".ProseMirror{&& [data-drag-handler-anchor-depth=\"0\"][data-drag-handler-anchor-name]{z-index:1;}}"
};
const $9d0abd7f97ed1440$var$withAnchorNameZindexStyleNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}]:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])`]: {
            zIndex: 1
        }
    }
});
// This style is used to define width for block card (with datasource) that does not have layout
// In full-width editor, block card has width of full-width layout
// In fixed-width editor, block card has width of wide layout
const $9d0abd7f97ed1440$var$blockCardWithoutLayout = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-content-area.fabric-editor--full-width-mode .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor-block-card-width': `min(calc(100cqw - ${(0, $7Y8M5.akEditorBreakoutPadding)}px), 1800px)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        '--ak-editor-block-card-width': 'max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))'
    }
});
const $9d0abd7f97ed1440$var$nextAnchorSelector = [
    '&[data-node-anchor]',
    // adjacent sibling with anchor
    '&:not([data-node-anchor]) [data-node-anchor]:first-of-type',
    // first nested anchor inside adjacent sibling
    '&.ProseMirror-widget + [data-node-anchor]',
    // adjacent sibling with anchor (when next to a widget like gap cursor)
    '&.ProseMirror-widget + :not([data-node-anchor]) [data-node-anchor]:first-of-type' // first nested anchor inside adjacent sibling (when next to a widget like gap cursor)
].join(', ');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $9d0abd7f97ed1440$var$combinedControlsFallbackAnchorNames = `${(0, $hTjcC.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)}, ${(0, $hTjcC.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME)}`;
const $9d0abd7f97ed1440$var$dragHandlerAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-decorator-widget"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$9d0abd7f97ed1440$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-quick-insert-button"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$9d0abd7f97ed1440$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        }
    }
});
// Applies anchor-name via node decoration attributes rather than adjacency CSS selectors.
// This is more reliable than dragHandlerAnchorStyles which depends on DOM structure.
// Only nodes decorated with data-active-drag-handle / data-active-quick-insert get anchor-name.
const $9d0abd7f97ed1440$var$staticControlsAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Active node can be both drag-handle and quick-insert target. Expose all three names:
        // node anchor + both control-specific fallback anchors.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-drag-handle][data-active-quick-insert][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${$9d0abd7f97ed1440$var$combinedControlsFallbackAnchorNames}, var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-drag-handle][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${(0, $hTjcC.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)}, var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-quick-insert][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${(0, $hTjcC.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME)}, var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $9d0abd7f97ed1440$var$sparseSurfaceAnchorName = 'var(--block-controls-surface-anchor-name)';
// Inner node-view boxes own the visible geometry for these nodes. The root arm keeps a sparse
// marker useful when a node view has not mounted its inner box yet.
const $9d0abd7f97ed1440$var$sparseSurfaceAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="blockCard"]:has(.datasourceView-content-inner-wrap) .datasourceView-content-inner-wrap': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="blockCard"]:not(:has(.datasourceView-content-inner-wrap))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="bodiedExtension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="bodiedExtension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="embedCard"]:has(.rich-media-item) .rich-media-item': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="embedCard"]:not(:has(.rich-media-item))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="extension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="extension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="mediaSingle"]:has(.resizer-item) .resizer-item': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="mediaSingle"]:not(:has(.resizer-item))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="multiBodiedExtension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="multiBodiedExtension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // `.pm-table-resizer-container` wraps the ENTIRE table, including cell content, so a
        // nested `mediaSingle`/ embed resizer inside a cell is also a descendant of it — a plain
        // descendant selector can't tell the table's own resize handle apart from a media resizer.
        // The table's own `.resizer-item.display-handle` is a direct child of
        // `.pm-table-resizer-container`, while any nested cell content sits many levels deeper, so
        // the `>` direct child combinator is required to avoid hijacking the table's anchor-name
        // onto a nested cell's media resizer instead of the table's own resize-handle chrome.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="table"]:has(.pm-table-resizer-container > .resizer-item) .pm-table-resizer-container > .resizer-item': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="table"]:not(:has(.pm-table-resizer-container > .resizer-item))': {
            anchorName: $9d0abd7f97ed1440$var$sparseSurfaceAnchorName
        }
    }
});
// Styles applied to nodes with anchors when dragging
const $9d0abd7f97ed1440$var$dragAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:not([data-node-anchor] [data-node-anchor])': {
            // all top level nodes with anchor
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:has([data-blocks-drop-target-container]) [data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-name="media"][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // first table row to avoid multiple anchors in table
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-prosemirror-node-name="table"] [data-prosemirror-node-name="tableRow"][data-node-anchor]:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $9d0abd7f97ed1440$export$cc5403d58ddfa812 = ({ api: api })=>{
    const { isDragging: isDraggingFromState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging
        }));
    const sparseSurfacesEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration');
    const isDragging = sparseSurfacesEnabled || (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true) ? isDraggingFromState : false;
    const shouldRenderAnchors = (0, $2XHKU.isCSSAnchorSupported)() && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    const sparseSurfaceAnchorsEnabled = Boolean((0, $2XHKU.isCSSAnchorSupported)()) && sparseSurfacesEnabled;
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $9d0abd7f97ed1440$var$globalStyles(),
            $9d0abd7f97ed1440$var$globalDnDStyle,
            (!sparseSurfacesEnabled || isDragging) && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $9d0abd7f97ed1440$var$extendedHoverZoneNext() : $9d0abd7f97ed1440$var$extendedHoverZone()),
            isDragging && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $9d0abd7f97ed1440$var$extendedDragZoneNext : $9d0abd7f97ed1440$var$extendedDragZone),
            (!sparseSurfacesEnabled || isDragging) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $9d0abd7f97ed1440$var$extendHoverZoneReducedNext : $9d0abd7f97ed1440$var$extendHoverZoneReduced : undefined,
            // platform_editor_controls note: this allows drag handles to render on empty lines
            toolbarFlagsEnabled ? undefined : $9d0abd7f97ed1440$var$withInlineNodeStyle,
            $9d0abd7f97ed1440$var$withDeleteLinesStyleFix,
            $9d0abd7f97ed1440$var$withMediaSingleStyleFix,
            $9d0abd7f97ed1440$var$legacyBreakoutWideLayoutStyle,
            $9d0abd7f97ed1440$var$headingWithIndentationInLayoutStyleFix,
            (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $9d0abd7f97ed1440$var$blockCardWithoutLayout : undefined,
            $9d0abd7f97ed1440$var$withDividerInPanelStyleFix,
            $9d0abd7f97ed1440$var$withFormatInLayoutStyleFix,
            (!sparseSurfacesEnabled || isDragging) && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $9d0abd7f97ed1440$var$withRelativePosStyleNext : $9d0abd7f97ed1440$var$withRelativePosStyle),
            (!sparseSurfacesEnabled || isDragging) && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $9d0abd7f97ed1440$var$withAnchorNameZindexStyleNext : $9d0abd7f97ed1440$var$withAnchorNameZindexStyle),
            (!sparseSurfacesEnabled || isDragging) && (((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) && (0, $ieeJu.expValEquals)('advanced_layouts', 'isEnabled', true) ? $9d0abd7f97ed1440$var$layoutColumnExtendedHoverZone : $9d0abd7f97ed1440$var$layoutColumnWithoutHoverZone),
            sparseSurfaceAnchorsEnabled ? isDragging ? $9d0abd7f97ed1440$var$dragAnchorStyles : false : (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) ? // dragAnchorStyles sets anchor-name on ALL nodes during drag (needed for drop target positioning).
            // staticControlsAnchorStyles handles anchor-name via node decorations for non-drag state.
            // shouldRenderAnchors guards both: only apply anchor styles on browsers that support CSS anchor positioning.
            shouldRenderAnchors ? isDragging ? $9d0abd7f97ed1440$var$dragAnchorStyles : $9d0abd7f97ed1440$var$staticControlsAnchorStyles : false : shouldRenderAnchors && (isDragging ? $9d0abd7f97ed1440$var$dragAnchorStyles : $9d0abd7f97ed1440$var$dragHandlerAnchorStyles),
            sparseSurfaceAnchorsEnabled && $9d0abd7f97ed1440$var$sparseSurfaceAnchorStyles
        ]
    });
};



const $ba9a19c78f543467$export$7a291905586a23d3 = ({ api: api, config: config })=>{
    const nodeDecorationRegistry = [];
    const rightSideControlsEnabled = config?.rightSideControlsEnabled ?? false;
    const quickInsertButtonEnabled = config?.quickInsertButtonEnabled ?? true;
    const registryBlockControlsEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration');
    if (registryBlockControlsEnabled) {
        api?.uiControlRegistry?.actions.register([
            (0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE),
            {
                ...(0, $eRJEr.BLOCK_CONTROLS_LEFT_SECTION),
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_LEFT_SURFACE),
                        rank: 100
                    }
                ]
            },
            {
                ...(0, $eRJEr.BLOCK_CONTROLS_LEFT_GROUP),
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_LEFT_SECTION),
                        rank: 100
                    }
                ]
            },
            ...(0, $c010f6dde1747120$export$88d90db17f630aa9)({
                api: api
            })
        ]);
        // The right surface host stays generic: it only registers the toolbar/section/group
        // hierarchy. Individual features contribute their own buttons into
        // BLOCK_CONTROLS_RIGHT_GROUP from their own plugins, same as the left surface.
        api?.uiControlRegistry?.actions.register([
            (0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE),
            {
                ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_SECTION),
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_SURFACE),
                        rank: 100
                    }
                ]
            },
            {
                ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_GROUP),
                parents: [
                    {
                        ...(0, $eRJEr.BLOCK_CONTROLS_RIGHT_SECTION),
                        rank: 100
                    }
                ]
            }
        ]);
    }
    return {
        name: 'blockControls',
        actions: {
            getTextInfo: (editorView)=>{
                const blockControlsState = api?.blockControls?.sharedState.currentState();
                const preservedSelection = blockControlsState?.preservedSelection;
                if (preservedSelection && preservedSelection.from !== preservedSelection.to) {
                    // CellSelection covers a table: collect each selected cell's text joined with spaces
                    // so that adjacent cells are not fused (e.g. 'hello world' + 'foo' must not
                    // become 'hello worldfoo'). Intl.Segmenter word-counting requires correct
                    // word boundaries, which raw textContent fusion breaks.
                    if (preservedSelection instanceof (0, $8HW7o.CellSelection)) {
                        // Use node(1) to reliably target the table node regardless of $anchorCell depth.
                        // node(-1) would return tableRow if $anchorCell is at tableCell depth.
                        const tableNode = preservedSelection.$anchorCell.node(1);
                        const cellTexts = [];
                        if (tableNode) // forEachCell iterates only the selected cells, not all cells in the table.
                        preservedSelection.forEachCell((cell)=>{
                            cellTexts.push(cell.textContent);
                        });
                        const textContent = cellTexts.filter(Boolean).join(' ');
                        return {
                            textLength: textContent.length,
                            textContent: textContent
                        };
                    }
                    const { from: from, to: to } = preservedSelection;
                    const textContent = editorView.state.doc.textBetween(from, to, '\n');
                    return {
                        textLength: textContent.length,
                        textContent: textContent
                    };
                }
                const pos = blockControlsState?.menuTriggerByNode?.pos;
                if (pos === null || pos === undefined) return null;
                const node = editorView.state.doc.nodeAt(pos);
                if (!node) return null;
                return {
                    textLength: node.textContent.length,
                    textContent: node.textContent
                };
            },
            registerNodeDecoration: (factory)=>{
                nodeDecorationRegistry.push(factory);
            },
            unregisterNodeDecoration: (type)=>{
                const idx = nodeDecorationRegistry.findIndex((f)=>f.type === type);
                if (idx !== -1) nodeDecorationRegistry.splice(idx, 1);
            }
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'blockControlsPmPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $3BXSc.createPlugin)(api, getIntl, nodeViewPortalProviderAPI, registryBlockControlsEnabled ? [] : nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled && !registryBlockControlsEnabled)
                }
            ];
            if (registryBlockControlsEnabled) pmPlugins.push({
                name: 'blockControlsSparseSurfaces',
                plugin: ()=>(0, $2d2d2a0b149dfa16$export$3540c976585d7feb)(api)
            });
            if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) pmPlugins.push({
                name: 'blockControlsInteractionTrackingPlugin',
                plugin: ()=>(0, $78a32da2f9d512bf$export$66f3b9297f4ee65b)(rightSideControlsEnabled, api)
            });
            pmPlugins.push({
                name: 'blockControlsSelectionPreservationPlugin',
                plugin: (0, $635b558f5a41e938$export$36720c70349457f)(api)
            });
            // platform_editor_controls note: quick insert rendering fixes
            //
            // Not registered under the registry migration: the decoration puts an inline
            // `margin-top: 0` on the first document node, which fights features that render their own
            // content above it — a leading show-diff widget is left flush against the node below.
            if ((0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) && !registryBlockControlsEnabled) pmPlugins.push({
                name: 'firstNodeDec',
                plugin: (0, $77f30cc17fbf24cf$export$4a529dfc67d1b47b)
            });
            return pmPlugins;
        },
        commands: {
            expandAndUpdateSelection: ({ startPos: startPos, selection: selection, isShiftPressed: isShiftPressed, nodeType: nodeType })=>({ tr: tr })=>{
                    (0, $2w4SV.expandAndUpdateSelection)({
                        tr: tr,
                        selection: selection,
                        startPos: startPos,
                        isShiftPressed: isShiftPressed,
                        nodeType: nodeType,
                        api: api
                    });
                    return tr;
                },
            moveNode: (0, $b3nYA.moveNode)(api),
            moveToLayout: (0, $fcbccc7790679e9d$export$6e686efeb3f3578c)(api),
            showDragHandleAt: (pos, anchorName, nodeType, handleOptions, rootPos, rootAnchorName, rootNodeType)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType,
                            handleOptions: handleOptions,
                            rootPos: rootPos,
                            rootAnchorName: rootAnchorName,
                            rootNodeType: rootNodeType
                        }
                    });
                    return tr;
                },
            showControlAtPosition: (pos, control, options)=>({ tr: tr })=>{
                    const node = tr.doc.nodeAt(pos);
                    if (!node) return tr;
                    const anchorName = api?.core.actions.getAnchorIdForNode(node, pos);
                    if (!anchorName) return tr;
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            controlKey: control.key,
                            nodeType: (0, $9HWym.getNodeTypeWithLevel)(node),
                            handleOptions: options
                        }
                    });
                    return tr;
                },
            toggleBlockMenu: (options)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    const currentUserIntent = api?.userIntent?.sharedState.currentState()?.currentUserIntent;
                    const isMenuCurrentlyOpen = api?.blockControls?.sharedState.currentState()?.isMenuOpen;
                    if (options?.closeMenu) {
                        tr.setMeta((0, $3BXSc.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    // Do not open the block menu for layout columns. Anchor resolution can lag behind
                    // a migrated surface click, so prefer the explicit node metadata when available.
                    if (options?.triggerByNode?.nodeType === 'layoutColumn' || options?.anchorName?.includes('layoutColumn')) {
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        tr.setMeta((0, $3BXSc.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    let toggleMenuMeta = {
                        anchorName: options?.anchorName,
                        triggerByNode: options?.triggerByNode
                    };
                    const menuTriggerBy = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
                    if (options?.anchorName) {
                        const { moveUp: moveUp, moveDown: moveDown } = (0, $9aKak.canMoveNodeUpOrDown)(tr);
                        toggleMenuMeta = {
                            ...toggleMenuMeta,
                            moveUp: moveUp,
                            moveDown: moveDown,
                            openedViaKeyboard: options?.openedViaKeyboard
                        };
                    }
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        toggleMenu: toggleMenuMeta
                    });
                    if ((menuTriggerBy === undefined || !!menuTriggerBy && menuTriggerBy === options?.anchorName) && currentUserIntent === 'blockMenuOpen') {
                        const state = api?.blockControls.sharedState.currentState();
                        if (state?.isSelectedViaDragHandle) api?.userIntent?.commands.setCurrentUserIntent('dragHandleSelected')({
                            tr: tr
                        });
                        else // Toggled from drag handle
                        api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                    } else if (!isMenuCurrentlyOpen) // When opening the menu, pause the active session timer
                    {
                        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                            shouldStartTimer: false,
                            shouldPersistActiveSession: true
                        })({
                            tr: tr
                        });
                    }
                    return tr;
                },
            setNodeDragged: (getPos, anchorName, nodeType)=>({ tr: tr })=>{
                    const pos = getPos();
                    if (pos === undefined) return tr;
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        isDragging: true,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType
                        }
                    });
                    if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    })({
                        tr: tr
                    });
                    api?.userIntent?.commands.setCurrentUserIntent('dragging')({
                        tr: tr
                    });
                    return tr;
                },
            setMultiSelectPositions: (anchor, head)=>({ tr: tr })=>{
                    const { anchor: userAnchor, head: userHead } = tr.selection;
                    let $expandedAnchor, $expandedHead;
                    if (anchor !== undefined && head !== undefined) {
                        $expandedAnchor = tr.doc.resolve(anchor);
                        $expandedHead = tr.doc.resolve(head);
                    } else {
                        const expandedSelection = (0, $iQ6F7.expandSelectionBounds)(tr.selection.$anchor, tr.selection.$head);
                        $expandedAnchor = expandedSelection.$anchor;
                        $expandedHead = expandedSelection.$head;
                    }
                    api?.selection?.commands.setManualSelection($expandedAnchor.pos, $expandedHead.pos)({
                        tr: tr
                    });
                    const $from = $expandedAnchor.min($expandedHead);
                    const $to = $expandedAnchor.max($expandedHead);
                    let expandedNormalisedSel;
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_fix_table_move_shortcut') && $from.nodeAfter && $from.nodeAfter === $to.nodeBefore) {
                        // Single node
                        (0, $bOZni.selectNode)(tr, $from.pos, $from.nodeAfter.type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if ($from.nodeAfter === $to.nodeBefore) {
                        // Single node
                        (0, $bOZni.selectNode)(tr, $from.pos, $expandedAnchor.node().type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if ($to.nodeBefore?.type.name === 'mediaSingle' || $from.nodeAfter?.type.name === 'mediaSingle') {
                        // Media
                        expandedNormalisedSel = new (0, $kCECX.TextSelection)($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    } else {
                        // this is to normalise the selection's boundaries to inline positions, preventing it from collapsing
                        expandedNormalisedSel = (0, $kCECX.TextSelection).between($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    }
                    const multiSelectDnD = {
                        anchor: $expandedAnchor.pos,
                        head: $expandedHead.pos,
                        textAnchor: expandedNormalisedSel.anchor,
                        textHead: expandedNormalisedSel.head,
                        userAnchor: userAnchor,
                        userHead: userHead
                    };
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        multiSelectDnD: multiSelectDnD
                    });
                    return tr;
                },
            setSelectedViaDragHandle: (isSelectedViaDragHandle)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    return tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        isSelectedViaDragHandle: isSelectedViaDragHandle
                    });
                },
            mapPreservedSelection: (mapping)=>(0, $ae3c630ae8088563$export$e21678cf246ba963)(mapping),
            moveNodeWithBlockMenu: (direction)=>(0, $56dbb4d04b905509$export$86c511a177340b22)(api, direction),
            handleKeyDownWithPreservedSelection: (0, $a155f8ac3d617cef$export$f38920f5272efc06)(api),
            startPreservingSelection: ()=>(0, $bb8f0178a1bbd465$export$4c9c90f81bda40ce),
            stopPreservingSelection: ()=>(0, $bb8f0178a1bbd465$export$7ee148889ab74bda)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const sharedState = {
                isMenuOpen: (0, $3BXSc.key).getState(editorState)?.isMenuOpen ?? false,
                menuTriggerBy: (0, $3BXSc.key).getState(editorState)?.menuTriggerBy ?? undefined,
                menuTriggerByNode: (0, $3BXSc.key).getState(editorState)?.menuTriggerByNode ?? undefined,
                blockMenuOptions: (0, $3BXSc.key).getState(editorState)?.blockMenuOptions ?? undefined,
                activeNode: (0, $3BXSc.key).getState(editorState)?.activeNode ?? undefined,
                activeDropTargetNode: (0, $3BXSc.key).getState(editorState)?.activeDropTargetNode ?? undefined,
                isDragging: (0, $3BXSc.key).getState(editorState)?.isDragging ?? false,
                isPMDragging: (0, $3BXSc.key).getState(editorState)?.isPMDragging ?? false,
                multiSelectDnD: (0, $3BXSc.key).getState(editorState)?.multiSelectDnD ?? undefined,
                lastDragCancelled: (0, $3BXSc.key).getState(editorState)?.lastDragCancelled ?? false,
                isEditing: (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.isEditing,
                isSelectedViaDragHandle: (0, $3BXSc.key).getState(editorState)?.isSelectedViaDragHandle ?? false
            };
            if (registryBlockControlsEnabled) {
                const surfaces = (0, $2d2d2a0b149dfa16$export$124d0b9d0fc52a78).getState(editorState);
                sharedState.surfaceNodePositions = surfaces?.candidates.positions;
                sharedState.surfaceAnchors = surfaces?.anchors;
                sharedState.surfaceActiveNodes = surfaces?.activeNodesByPosition;
            }
            if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                sharedState.isMouseOut = (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.isMouseOut ?? false;
                // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
                sharedState.rightSideControlsEnabled = rightSideControlsEnabled;
                sharedState.hoverSide = rightSideControlsEnabled ? (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.hoverSide : undefined;
            }
            sharedState.preservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(editorState)?.preservedSelection;
            return sharedState;
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d0abd7f97ed1440$export$cc5403d58ddfa812), {
                        api: api
                    }),
                    registryBlockControlsEnabled && editorView && api ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $946ff4c7c13f21c2$export$1de8070d9a6a8efd).Provider, {
                        value: editorView,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $77d3edece9c98308$export$4cff02cd9e409191), {
                                api: api,
                                editorView: editorView
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $46b926345779f3b2$export$79baf52a56f1adef), {
                                api: api,
                                editorView: editorView
                            })
                        ]
                    }) : null
                ]
            });
        }
    };
};
module.exports["blockControlsPlugin"] = $ba9a19c78f543467$export$7a291905586a23d3;

});

parcelRegister("hTjcC", function(module, exports) {

var $kAPZe = parcelRequire("kAPZe");


var $hy0gD = parcelRequire("hy0gD");

var $jaNze = parcelRequire("jaNze");


var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $5c444c693a8a0d14$export$3c415fc37e843546 = 'data-active-drag-handle';
const $5c444c693a8a0d14$export$e9f85d19bcc65a35 = 'data-active-quick-insert';
const $5c444c693a8a0d14$export$d2253616b100a50f = '[data-editor-block-controls-surface]';
const $5c444c693a8a0d14$export$2993f0134faf61b5 = '--editor-block-controls-active-drag-handle-anchor';
const $5c444c693a8a0d14$export$78e6503524c3440d = '--editor-block-controls-active-quick-insert-anchor';
const $5c444c693a8a0d14$export$f373eda827748b3 = 24;
const $5c444c693a8a0d14$export$aa77a5cc2a5f88a7 = 4;
const $5c444c693a8a0d14$export$5ad27d778a09d25c = (0, $7Y8M5.akRichMediaResizeZIndex) + (0, $7Y8M5.akEditorUnitZIndex); //place above legacy resizer
const $5c444c693a8a0d14$var$LEGACY_DRAG_HANDLE_DEFAULT_GAP = 8;
const $5c444c693a8a0d14$var$MIGRATED_DRAG_HANDLE_DEFAULT_GAP = 12;
const $5c444c693a8a0d14$export$afbc9d6595284dfa = 4;
const $5c444c693a8a0d14$export$28e15aedc0c878e3 = 12;
const $5c444c693a8a0d14$export$e4842b8390e65360 = 2.5;
const $5c444c693a8a0d14$export$f0af6742db040d57 = (0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$28e15aedc0c878e3;
// Non-resizable/default-sized nodes get the same gap as resizable/breakout nodes
// (DRAG_HANDLE_MAX_GAP) once the registry-backed surfaces are on; kept at the legacy value
// otherwise to avoid an unrelated visual change for consumers still on the old decoration path.
const $5c444c693a8a0d14$var$getDragHandleDefaultGap = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $5c444c693a8a0d14$var$MIGRATED_DRAG_HANDLE_DEFAULT_GAP : $5c444c693a8a0d14$var$LEGACY_DRAG_HANDLE_DEFAULT_GAP;
const $5c444c693a8a0d14$export$d2a2373f7346fed2 = 6; // 4px for the divider vertical padding and 2px for the divider height
const $5c444c693a8a0d14$export$d5bafa9c4e821a51 = 5;
const $5c444c693a8a0d14$export$1e2b3336ca8c087c = 2;
const $5c444c693a8a0d14$export$f8ee0d00a7415eee = 1;
const $5c444c693a8a0d14$export$7ca48bd6d02a13e0 = 3;
const $5c444c693a8a0d14$export$40d0d70c288e6373 = 3;
const $5c444c693a8a0d14$export$51dbe10140b62321 = 3;
const $5c444c693a8a0d14$export$45051ba26713425e = 8;
const $5c444c693a8a0d14$export$2d43c475787cc3b2 = 2;
const $5c444c693a8a0d14$export$bd30577e4ba2fc75 = 0;
const $5c444c693a8a0d14$export$47dad309b5731d64 = 8;
const $5c444c693a8a0d14$export$acab25f15fd410d6 = 8;
const $5c444c693a8a0d14$export$355f64931df48ac6 = 24;
const $5c444c693a8a0d14$export$b2fc508ca59eba40 = 24;
const $5c444c693a8a0d14$export$c5ab994ee6fdf098 = 24;
const $5c444c693a8a0d14$export$8b6a8ea78955a3a3 = {
    width: $5c444c693a8a0d14$export$c5ab994ee6fdf098,
    height: $5c444c693a8a0d14$export$b2fc508ca59eba40
};
const $5c444c693a8a0d14$export$37704ab652bb303e = 16;
const $5c444c693a8a0d14$var$nodeTypeExcludeList = [
    'embedCard',
    'mediaSingle',
    'table'
];
const $5c444c693a8a0d14$export$e5ea166c620fdfb2 = (nodeType, parentNodeType)=>{
    if (parentNodeType === 'syncBlock' || parentNodeType === 'bodiedSyncBlock') return $5c444c693a8a0d14$export$e4842b8390e65360;
    if (parentNodeType && parentNodeType !== 'doc') return $5c444c693a8a0d14$export$afbc9d6595284dfa;
    let breakoutResizableNodesList = [];
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodesList = (0, $jaNze.getBreakoutResizableNodes)();
    else breakoutResizableNodesList = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes);
    if ((0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 20;
        else return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $5c444c693a8a0d14$var$getDragHandleDefaultGap() + 20;
    if ($5c444c693a8a0d14$var$nodeTypeExcludeList.includes(nodeType)) return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    return $5c444c693a8a0d14$var$getDragHandleDefaultGap();
};
const $5c444c693a8a0d14$export$5002400b4eb1f7c6 = (nodeType)=>{
    let breakoutResizableNodesList = [];
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodesList = (0, $jaNze.getBreakoutResizableNodes)();
    else breakoutResizableNodesList = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes);
    if ($5c444c693a8a0d14$var$nodeTypeExcludeList.includes(nodeType) || (0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 20;
        else return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 12;
    return $5c444c693a8a0d14$var$getDragHandleDefaultGap();
};
const $5c444c693a8a0d14$export$5721e547e9b6cc17 = (nodeType)=>{
    switch(nodeType){
        case 'bodiedExtension':
            return '28px';
        case 'multiBodiedExtension':
            if ((0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '28px';
            return `${(0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$afbc9d6595284dfa}px`;
        case 'expand':
        case 'nestedExpand':
            return '24px';
        case 'layoutColumn':
            return '20px';
        case 'panel':
            return '40px';
        case 'tableCell':
            return '8px';
        case 'tableHeader':
            return '8px';
        default:
            return `${(0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$afbc9d6595284dfa}px`;
    }
};
const $5c444c693a8a0d14$export$403b33ae238c7c59 = (nodeType, layout)=>{
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) switch(nodeType){
        case 'layoutSection':
            return $5c444c693a8a0d14$export$45051ba26713425e;
    }
    if ((nodeType === 'mediaSingle' || nodeType === 'embedCard') && layout && [
        'wrap-left',
        'wrap-right'
    ].includes(layout)) return $5c444c693a8a0d14$export$47dad309b5731d64;
    switch(nodeType){
        case 'rule':
            return -$5c444c693a8a0d14$export$d2a2373f7346fed2;
        case 'table':
            return $5c444c693a8a0d14$export$f373eda827748b3;
        case 'paragraph':
            return $5c444c693a8a0d14$export$2d43c475787cc3b2;
        case 'paragraph-small':
            return $5c444c693a8a0d14$export$bd30577e4ba2fc75;
        case 'heading-1':
            return $5c444c693a8a0d14$export$d5bafa9c4e821a51;
        case 'heading-2':
            return $5c444c693a8a0d14$export$1e2b3336ca8c087c;
        case 'heading-3':
            return -$5c444c693a8a0d14$export$f8ee0d00a7415eee;
        case 'heading-4':
            return -$5c444c693a8a0d14$export$7ca48bd6d02a13e0;
        case 'heading-5':
            return -$5c444c693a8a0d14$export$40d0d70c288e6373;
        case 'heading-6':
            return -$5c444c693a8a0d14$export$51dbe10140b62321;
        default:
            return 0;
    }
};
const $5c444c693a8a0d14$export$6475396024cc89ff = {
    [-24]: "var(--ds-space-negative-300, -24px)",
    [-20]: "var(--ds-space-negative-250, -20px)",
    [-16]: "var(--ds-space-negative-200, -16px)",
    [-12]: "var(--ds-space-negative-150, -12px)",
    [-8]: "var(--ds-space-negative-100, -8px)",
    [-6]: "var(--ds-space-negative-075, -6px)",
    [-4]: "var(--ds-space-negative-050, -4px)",
    [-2]: "var(--ds-space-negative-025, -2px)",
    0: "var(--ds-space-0, 0px)",
    2: "var(--ds-space-025, 2px)",
    4: "var(--ds-space-050, 4px)",
    6: "var(--ds-space-075, 6px)",
    8: "var(--ds-space-100, 8px)",
    12: "var(--ds-space-150, 12px)",
    16: "var(--ds-space-200, 16px)",
    20: "var(--ds-space-250, 20px)",
    24: "var(--ds-space-300, 24px)"
};
const $5c444c693a8a0d14$export$c4b2eae94cb9784e = Object.fromEntries(// 49 = -24 -> 0 -> 24 totaling 49 entries.
Array.from({
    length: 49
}, (_, index)=>{
    const currKeyValue = index - 24;
    const keyValues = Object.keys($5c444c693a8a0d14$export$6475396024cc89ff).map(Number);
    const value = keyValues.reduce((acc, curr)=>{
        return Math.abs(currKeyValue - curr) < Math.abs(currKeyValue - acc) ? curr : acc;
    }, 1000);
    return [
        currKeyValue,
        $5c444c693a8a0d14$export$6475396024cc89ff[value]
    ];
}));
const $5c444c693a8a0d14$export$67c6a77242c01faa = {
    paragraph: {
        top: '0.75rem',
        bottom: '0'
    },
    heading1: {
        top: '1.45833em',
        bottom: '0'
    },
    heading2: {
        top: '1.4em',
        bottom: '0'
    },
    heading3: {
        top: '1.31249em',
        bottom: '0'
    },
    heading4: {
        top: '1.25em',
        bottom: '0'
    },
    heading5: {
        top: '1.45833em',
        bottom: '0'
    },
    heading6: {
        top: '1.59091em',
        bottom: '0'
    },
    table: {
        top: '0',
        bottom: '0'
    },
    bulletList: {
        top: '10px',
        bottom: '0'
    },
    orderedList: {
        top: '10px',
        bottom: '0'
    },
    decisionList: {
        top: '0.5rem',
        bottom: '0'
    },
    taskList: {
        top: '0.75rem',
        bottom: '0'
    },
    codeBlock: {
        top: '0.75rem',
        bottom: '0'
    },
    panel: {
        top: '0.75rem',
        bottom: '0'
    },
    rule: {
        top: '1.5rem',
        bottom: '1.5rem'
    },
    mediaSingle: {
        top: '24px',
        bottom: '24px'
    },
    media: {
        top: '24px',
        bottom: '24px'
    },
    bodiedExtension: {
        top: '0',
        bottom: '0'
    },
    multiBodiedExtension: {
        top: '0',
        bottom: '0'
    },
    extension: {
        top: '0',
        bottom: '0'
    },
    layoutSection: {
        top: '0',
        bottom: '0'
    },
    blockquote: {
        top: '0',
        bottom: '0'
    },
    embedCard: {
        top: '24px',
        bottom: '24px'
    },
    blockCard: {
        top: '0.75rem',
        bottom: '0'
    },
    default: {
        top: '0',
        bottom: '0'
    }
};
const $5c444c693a8a0d14$export$ffe7e67ee4ab1502 = {
    table: {
        top: 24,
        bottom: 16
    },
    paragraph: {
        top: 12,
        bottom: 6
    },
    bulletList: {
        top: 16,
        bottom: 0
    },
    orderedList: {
        top: 16,
        bottom: 0
    },
    decisionList: {
        top: 12,
        bottom: 0
    },
    taskList: {
        top: 8,
        bottom: 0
    },
    codeBlock: {
        top: 12,
        bottom: 0
    },
    panel: {
        top: 8,
        bottom: 0
    },
    rule: {
        top: 24,
        bottom: 24
    },
    mediaSingle: {
        top: 24,
        bottom: 24
    },
    media: {
        top: 24,
        bottom: 24
    },
    bodiedExtension: {
        top: 0,
        bottom: 0
    },
    multiBodiedExtension: {
        top: 0,
        bottom: 0
    },
    extension: {
        top: 12,
        bottom: 12
    },
    heading1: {
        top: 40,
        bottom: 0
    },
    heading2: {
        top: 40,
        bottom: 0
    },
    heading3: {
        top: 36,
        bottom: 0
    },
    heading4: {
        top: 22,
        bottom: 0
    },
    heading5: {
        top: 22,
        bottom: 0
    },
    heading6: {
        top: 18,
        bottom: 0
    },
    layoutSection: {
        top: 8,
        bottom: 0
    },
    blockquote: {
        top: 12,
        bottom: 0
    },
    expand: {
        top: 4,
        bottom: 0
    },
    nestedExpand: {
        top: 1,
        bottom: 0
    },
    default: {
        top: 0,
        bottom: 0
    }
};
const $5c444c693a8a0d14$export$d77e6458bbcae98b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};
module.exports["ACTIVE_DRAG_HANDLE_ATTR"] = $5c444c693a8a0d14$export$3c415fc37e843546;
module.exports["ACTIVE_QUICK_INSERT_ATTR"] = $5c444c693a8a0d14$export$e9f85d19bcc65a35;
module.exports["BLOCK_CONTROLS_SURFACE_SELECTOR"] = $5c444c693a8a0d14$export$d2253616b100a50f;
module.exports["ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME"] = $5c444c693a8a0d14$export$2993f0134faf61b5;
module.exports["ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME"] = $5c444c693a8a0d14$export$78e6503524c3440d;
module.exports["DRAG_HANDLE_HEIGHT"] = $5c444c693a8a0d14$export$f373eda827748b3;
module.exports["DRAG_HANDLE_BORDER_RADIUS"] = $5c444c693a8a0d14$export$aa77a5cc2a5f88a7;
module.exports["DRAG_HANDLE_ZINDEX"] = $5c444c693a8a0d14$export$5ad27d778a09d25c;
module.exports["DRAG_HANDLE_MAX_WIDTH_PLUS_GAP"] = $5c444c693a8a0d14$export$f0af6742db040d57;
module.exports["DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$d2a2373f7346fed2;
module.exports["DRAG_HANDLE_H1_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$d5bafa9c4e821a51;
module.exports["DRAG_HANDLE_H2_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$1e2b3336ca8c087c;
module.exports["DRAG_HANDLE_H4_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$7ca48bd6d02a13e0;
module.exports["DRAG_HANDLE_H5_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$40d0d70c288e6373;
module.exports["DRAG_HANDLE_H6_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$51dbe10140b62321;
module.exports["DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$2d43c475787cc3b2;
module.exports["DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$bd30577e4ba2fc75;
module.exports["STICKY_CONTROLS_TOP_MARGIN"] = $5c444c693a8a0d14$export$acab25f15fd410d6;
module.exports["STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER"] = $5c444c693a8a0d14$export$355f64931df48ac6;
module.exports["QUICK_INSERT_HEIGHT"] = $5c444c693a8a0d14$export$b2fc508ca59eba40;
module.exports["QUICK_INSERT_WIDTH"] = $5c444c693a8a0d14$export$c5ab994ee6fdf098;
module.exports["QUICK_INSERT_DIMENSIONS"] = $5c444c693a8a0d14$export$8b6a8ea78955a3a3;
module.exports["QUICK_INSERT_LEFT_OFFSET"] = $5c444c693a8a0d14$export$37704ab652bb303e;
module.exports["dragHandleGap"] = $5c444c693a8a0d14$export$e5ea166c620fdfb2;
module.exports["rootElementGap"] = $5c444c693a8a0d14$export$5002400b4eb1f7c6;
module.exports["getNestedNodeLeftPaddingMargin"] = $5c444c693a8a0d14$export$5721e547e9b6cc17;
module.exports["topPositionAdjustment"] = $5c444c693a8a0d14$export$403b33ae238c7c59;
module.exports["spacingBetweenNodesForPreview"] = $5c444c693a8a0d14$export$67c6a77242c01faa;
module.exports["nodeMargins"] = $5c444c693a8a0d14$export$ffe7e67ee4ab1502;
module.exports["DEFAULT_COLUMN_DISTRIBUTIONS"] = $5c444c693a8a0d14$export$d77e6458bbcae98b;

});

parcelRegister("fKt2m", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");

const $1f3d35a5748f6f52$export$ea34df48337a3b78 = 'data-node-anchor';
const $1f3d35a5748f6f52$export$195bd9e1fd438938 = 'data-prosemirror-node-name';
const $1f3d35a5748f6f52$export$684dbfb461b166c3 = ()=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) return $1f3d35a5748f6f52$export$ea34df48337a3b78;
    return 'data-drag-handler-anchor-name';
};
const $1f3d35a5748f6f52$export$916bc5085eed228a = ()=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) return $1f3d35a5748f6f52$export$195bd9e1fd438938;
    return 'data-drag-handler-node-type';
};
const $1f3d35a5748f6f52$var$isHeadingElement = (element)=>{
    const headingTags = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    return headingTags.includes(element.tagName);
};
const $1f3d35a5748f6f52$export$374251d21964e516 = (element)=>{
    if (!element) return '';
    const nodeType = element?.getAttribute($1f3d35a5748f6f52$export$195bd9e1fd438938);
    if (!nodeType) return '';
    if ($1f3d35a5748f6f52$var$isHeadingElement(element)) switch(element.tagName){
        case 'H1':
            return 'heading-1';
        case 'H2':
            return 'heading-2';
        case 'H3':
            return 'heading-3';
        case 'H4':
            return 'heading-4';
        case 'H5':
            return 'heading-5';
        case 'H6':
            return 'heading-6';
    }
    return nodeType;
};
module.exports["NODE_ANCHOR_ATTR_NAME"] = $1f3d35a5748f6f52$export$ea34df48337a3b78;
module.exports["NODE_NODE_TYPE_ATTR_NAME"] = $1f3d35a5748f6f52$export$195bd9e1fd438938;
module.exports["getAnchorAttrName"] = $1f3d35a5748f6f52$export$684dbfb461b166c3;
module.exports["getTypeNameAttrName"] = $1f3d35a5748f6f52$export$916bc5085eed228a;
module.exports["getTypeNameFromDom"] = $1f3d35a5748f6f52$export$374251d21964e516;

});

parcelRegister("jWiWP", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $kAPZe = parcelRequire("kAPZe");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $hTjcC = parcelRequire("hTjcC");

const $6fa4b82a3edab148$var$STICKY_NODES = [
    'panel',
    'table',
    'expand',
    'layoutSection',
    'bodiedExtension'
];
const $6fa4b82a3edab148$export$3c9c03fbeb71a88 = (dom, type)=>{
    if (!dom) return 'auto';
    const table = dom.querySelector('table');
    const isTable = table && (!type || type === 'table');
    if (isTable) return `${dom.offsetTop + (table?.offsetTop || 0)}px`;
    else if (type === 'rule') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT)}px`;
    else if (type === 'layoutColumn') return `${-dom.offsetTop / 2}px`;
    else if (type === 'heading-1') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_H1_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-2') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_H2_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-3') return `${dom.offsetTop}px`;
    else if (type === 'heading-4') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H4_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-5') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H5_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-6') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H6_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph-small') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT)}px`;
    else return `${dom.offsetTop}px`;
};
const $6fa4b82a3edab148$export$c3d34436f1edd9bd = (dom, type, innerContainer, macroInteractionUpdates, parentType)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return type === 'layoutColumn' ? `${dom.offsetLeft + dom.clientWidth / 2 - (0, $hTjcC.DRAG_HANDLE_HEIGHT) / 2}px` : `${dom.offsetLeft - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px`;
};
const $6fa4b82a3edab148$export$d106346a0f891cc2 = (dom, anchor, anchorRectCache)=>anchorRectCache?.getHeight(anchor) || dom?.offsetHeight;
const $6fa4b82a3edab148$var$getStickyNodes = (0, $dOBRD.default)(()=>[
        ...$6fa4b82a3edab148$var$STICKY_NODES,
        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : []
    ]);
const $6fa4b82a3edab148$export$f988e74eefbc47fc = (nodeType)=>{
    return (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && $6fa4b82a3edab148$var$getStickyNodes().includes(nodeType);
};
const $6fa4b82a3edab148$export$cc6777b6e60d5179 = (anchor, isSticky, isTopLevelNode, isLayoutColumn, fallbackAnchor)=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: fallbackAnchor ? `anchor(${anchor} end, anchor(${fallbackAnchor} end))` : `anchor(${anchor} end)`
    };
    return (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: `anchor(${anchor} end)`
    };
};
const $6fa4b82a3edab148$export$738fa80805cb522c = (nodeHeight, isSticky, isTopLevelNode, fallbackPxHeight, isLayoutColumn)=>{
    return (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        height: 'unset'
    } : {
        height: `${nodeHeight || fallbackPxHeight}px`
    };
};
const $6fa4b82a3edab148$export$9a1c84c70b9df34 = (nodeType, isTopLevelNode)=>{
    return(// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    isTopLevelNode && [
        'table'
    ].includes(nodeType) && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1'));
};
module.exports["getTopPosition"] = $6fa4b82a3edab148$export$3c9c03fbeb71a88;
module.exports["getLeftPosition"] = $6fa4b82a3edab148$export$c3d34436f1edd9bd;
module.exports["getNodeHeight"] = $6fa4b82a3edab148$export$d106346a0f891cc2;
module.exports["shouldBeSticky"] = $6fa4b82a3edab148$export$f988e74eefbc47fc;
module.exports["getControlBottomCSSValue"] = $6fa4b82a3edab148$export$cc6777b6e60d5179;
module.exports["getControlHeightCSSValue"] = $6fa4b82a3edab148$export$738fa80805cb522c;
module.exports["shouldMaskNodeControls"] = $6fa4b82a3edab148$export$9a1c84c70b9df34;

});

parcelRegister("j8XGH", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $7qyBc = parcelRequire("7qyBc");

const $2c494448cfdcad64$export$f4b94aaa3c88263b = (doc, start)=>{
    const node = doc.nodeAt(start);
    if (!node) return false;
    if (node.type.name === 'mediaGroup' && node.childCount === 1) return new (0, $kCECX.NodeSelection)(doc.resolve(start + 1));
    return new (0, $kCECX.NodeSelection)(doc.resolve(start));
};
const $2c494448cfdcad64$export$301ee8a09bc7f6dc = (tr, tableNodePos)=>{
    (0, $7qyBc.selectTableClosestToPos)(tr, tr.doc.resolve(tableNodePos + 1));
    return tr;
};
const $2c494448cfdcad64$export$a35518af0efc77c7 = (tr, nodePos, nodeType)=>{
    if (nodeType === 'table') return $2c494448cfdcad64$export$301ee8a09bc7f6dc(tr, nodePos);
    const selection = $2c494448cfdcad64$export$f4b94aaa3c88263b(tr.doc, nodePos);
    if (selection) tr.setSelection(selection);
    return tr;
};
module.exports["getNodeSelectionForPos"] = $2c494448cfdcad64$export$f4b94aaa3c88263b;
module.exports["selectNodeAtPos"] = $2c494448cfdcad64$export$a35518af0efc77c7;

});

parcelRegister("7qyBc", function(module, exports) {

var $2xHHU = parcelRequire("2xHHU");


var $k8Ycp = parcelRequire("k8Ycp");

const $bd9449c887bcb88b$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    const tableSelection = (0, $k8Ycp.getTableSelectionClosesToPos)($pos);
    if (tableSelection) return (0, $2xHHU.cloneTr)(tr.setSelection(tableSelection));
    return tr;
};
module.exports["selectTableClosestToPos"] = $bd9449c887bcb88b$export$3e7c4d16b1cc1be3;

});

parcelRegister("k8Ycp", function(module, exports) {

var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $9GtVc = parcelRequire("9GtVc");

const $14e73e4025e25e13$export$cec96519863940d = ($pos)=>{
    const table = (0, $9GtVc.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $8Z43Z.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = $pos.doc.resolve(head);
            const $anchor = $pos.doc.resolve(anchor);
            return new (0, $8HW7o.CellSelection)($anchor, $head);
        }
    }
};
module.exports["getTableSelectionClosesToPos"] = $14e73e4025e25e13$export$cec96519863940d;

});

parcelRegister("bdkuW", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $rOV4B = parcelRequire("rOV4B");


var $3BXSc = parcelRequire("3BXSc");

const $36371d5e159b0ca8$export$79a8e1d39d3c2449 = ({ getPos: getPos, view: view, anchorName: anchorName })=>{
    let newAnchorName = anchorName || '';
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) return newAnchorName;
    const pos = getPos();
    if (anchorName || pos === undefined) return newAnchorName;
    const node = view.state.doc.nodeAt(pos);
    const state = (0, $3BXSc.key).getState(view.state);
    if (state?.decorations) {
        const nodeDecs = (0, $rOV4B.findNodeDecs)(view.state, state.decorations, pos, pos + (node?.nodeSize ?? 0));
        const nodeDec = nodeDecs.at(0);
        if (!nodeDec) return newAnchorName;
        newAnchorName = nodeDec.spec.anchorName;
    }
    return newAnchorName;
};
module.exports["refreshAnchorName"] = $36371d5e159b0ca8$export$79a8e1d39d3c2449;

});

parcelRegister("lhJQI", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $7Y8M5 = parcelRequire("7Y8M5");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $jkcNT = parcelRequire("jkcNT");

function $cd656ac427b6f5fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd656ac427b6f5fb$var$RIGHT_CONTROL_HIDE_DELAY_MS = 150;
const $cd656ac427b6f5fb$var$baseStyles = (0, $buxP3.xcss)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out'
});
const $cd656ac427b6f5fb$var$visibleStyles = (0, $buxP3.xcss)({
    opacity: 1,
    visibility: 'visible'
});
const $cd656ac427b6f5fb$var$hiddenStyles = (0, $buxP3.xcss)({
    opacity: 0,
    visibility: 'hidden'
});
const $cd656ac427b6f5fb$var$displayContentsStyles = (0, $buxP3.xcss)({
    display: 'contents'
});
const $cd656ac427b6f5fb$var$baseStylesCSS = /*#__PURE__*/ (0, $lOiVq.css)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $cd656ac427b6f5fb$var$visibleStylesCSS = {
    name: "nk3zlf",
    styles: "opacity:1;visibility:visible"
};
const $cd656ac427b6f5fb$var$hiddenStylesCSS = {
    name: "8792bh",
    styles: "opacity:0;visibility:hidden"
};
const $cd656ac427b6f5fb$var$displayContentsStylesCSS = {
    name: "49aokf",
    styles: "display:contents"
};
const $cd656ac427b6f5fb$export$742141830a7bafbb = ({ api: api, controlSide: controlSide, forceVisibleOnMouseOut: forceVisibleOnMouseOut, isPersistent: isPersistent })=>{
    const { isTypeAheadOpen: isTypeAheadOpen, isEditing: isEditing, isMouseOut: isMouseOut, hoverSide: hoverSide, editorViewMode: editorViewMode, userIntent: userIntent, isDisplayingDiff: isDisplayingDiff, rightSideControlsEnabled: rightSideControlsEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'typeAhead',
        'blockControls',
        'editorViewMode',
        'userIntent',
        'showDiff'
    ], (states)=>({
            isTypeAheadOpen: states.typeAheadState?.isOpen,
            isEditing: states.blockControlsState?.isEditing,
            isMouseOut: states.blockControlsState?.isMouseOut,
            hoverSide: states.blockControlsState?.hoverSide,
            editorViewMode: states.editorViewModeState?.mode,
            userIntent: states.userIntentState?.currentUserIntent,
            isDisplayingDiff: states.showDiffState?.isDisplayingChanges,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled
        }));
    const isViewMode = editorViewMode === 'view';
    // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
    // Both controls are restricted by side: the drag handle shows on the left half, the Remix button on
    // the right half (and the right margin), matching the midpoint split in handle-mouse-move.
    const shouldRestrictBySide = rightSideControlsEnabled && controlSide !== undefined && !isViewMode;
    // Only restrict by side when hoverSide is known (after mousemove). When undefined, show both
    // controls so drag handle is visible on load and for keyboard-only users.
    const sideHidden = shouldRestrictBySide && hoverSide !== undefined ? hoverSide !== controlSide : false;
    // In view mode with right-side controls, we delay hiding on isMouseOut (see below) so the right-edge
    // button stays visible when the user moves from the block toward the button (e.g. in edit/live
    // pages), avoiding flicker as the mouse crosses boundaries.
    const hideOnMouseOut = isMouseOut;
    // When forceVisibleOnMouseOut is true (e.g. drag handle focused via keyboard Shift+Ctrl+H),
    // override the mouse-out condition so the control stays visible regardless of mouse position.
    const shouldHideWhenMouseOut = forceVisibleOnMouseOut ? false : hideOnMouseOut;
    // Persistent controls (e.g. an AI suggestion icon on every qualifying node) aren't hover-driven,
    // so none of the hover/typing/mouse-out/diff-review reasons below apply to them — they're never
    // hidden by this container.
    const shouldHideImmediate = !isPersistent && (isTypeAheadOpen || isEditing || shouldHideWhenMouseOut || userIntent === 'aiStreaming' || // EDITOR-7926: hide the drag handle while a diff is on screen or a suggestion card is open.
    isDisplayingDiff || userIntent === 'reviewing' || sideHidden);
    // Delay hiding the right control in view mode to reduce flickering when moving from block
    // toward the right-edge button (avoids rapid show/hide as mouse crosses boundaries).
    const isRightControlViewMode = isViewMode && rightSideControlsEnabled && controlSide === 'right';
    // When in right-control view mode, we delay hiding so start visible; useEffect will update after delay
    const [delayedShouldHide, setDelayedShouldHide] = (0, $cozmU.useState)(false);
    const hideTimeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isRightControlViewMode) return;
        if (!shouldHideImmediate) {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            setDelayedShouldHide(false);
            return;
        }
        hideTimeoutRef.current = setTimeout(()=>{
            hideTimeoutRef.current = null;
            setDelayedShouldHide(true);
        }, $cd656ac427b6f5fb$var$RIGHT_CONTROL_HIDE_DELAY_MS);
        return ()=>{
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        };
    }, [
        shouldHideImmediate,
        isRightControlViewMode
    ]);
    const shouldHide = isRightControlViewMode ? delayedShouldHide : shouldHideImmediate;
    const useCssStyles = (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    return {
        shouldHide: shouldHide,
        useCssStyles: useCssStyles
    };
};
const $cd656ac427b6f5fb$export$aef0ec05064f7676 = ({ children: children, shouldHide: shouldHide, shouldUseDisplayContents: shouldUseDisplayContents, useCssStyles: useCssStyles })=>{
    if (useCssStyles) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $cd656ac427b6f5fb$var$baseStylesCSS,
            shouldHide ? $cd656ac427b6f5fb$var$hiddenStylesCSS : $cd656ac427b6f5fb$var$visibleStylesCSS,
            shouldUseDisplayContents && $cd656ac427b6f5fb$var$displayContentsStylesCSS
        ]
    }, children);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $cd656ac427b6f5fb$var$baseStyles,
            shouldHide ? $cd656ac427b6f5fb$var$hiddenStyles : $cd656ac427b6f5fb$var$visibleStyles,
            shouldUseDisplayContents && $cd656ac427b6f5fb$var$displayContentsStyles
        ]
    }, children);
};
const $cd656ac427b6f5fb$export$e7448669708130cc = ({ api: api, children: children, controlSide: controlSide, forceVisibleOnMouseOut: forceVisibleOnMouseOut, isPersistent: isPersistent, shouldUseDisplayContents: shouldUseDisplayContents })=>{
    const { shouldHide: shouldHide, useCssStyles: useCssStyles } = $cd656ac427b6f5fb$export$742141830a7bafbb({
        api: api,
        controlSide: controlSide,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        isPersistent: isPersistent
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)($cd656ac427b6f5fb$export$aef0ec05064f7676, {
        shouldHide: shouldHide,
        shouldUseDisplayContents: shouldUseDisplayContents,
        useCssStyles: useCssStyles
    }, children);
};
module.exports["useBlockControlsVisibility"] = $cd656ac427b6f5fb$export$742141830a7bafbb;
module.exports["VisibilityWrapper"] = $cd656ac427b6f5fb$export$aef0ec05064f7676;
module.exports["VisibilityContainer"] = $cd656ac427b6f5fb$export$e7448669708130cc;

});

parcelRegister("69FTU", function(module, exports) {

var $hTjcC = parcelRequire("hTjcC");

const $15abd54de8dd8e0e$export$78de92b32db40bc4 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return `${dom.offsetLeft - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px`;
};
const $15abd54de8dd8e0e$export$6efb694a25295ec1 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    const gap = (0, $hTjcC.rootElementGap)(nodeType);
    const width = widgetDimensions.width;
    if (!innerContainer) return `${dom.offsetLeft + leftAdjustment + dom.offsetWidth - gap - width}px`;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth - gap - width}px` : `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth / 2 - gap - width}px`;
};
module.exports["getLeftPositionForRootElement"] = $15abd54de8dd8e0e$export$78de92b32db40bc4;
module.exports["getRightPositionForRootElement"] = $15abd54de8dd8e0e$export$6efb694a25295ec1;

});

parcelRegister("4PdTO", function(module, exports) {
const $49b97973592b0cec$export$bc8f172a7b59f6f8 = 'blockControlsSurfaceInvalidation';
const $49b97973592b0cec$export$e9d9d89287b09e8 = (tr, invalidation)=>{
    const previous = tr.getMeta($49b97973592b0cec$export$bc8f172a7b59f6f8);
    return tr.setMeta($49b97973592b0cec$export$bc8f172a7b59f6f8, {
        ids: [
            ...previous?.ids ?? [],
            ...invalidation.ids ?? []
        ],
        positions: [
            ...previous?.positions ?? [],
            ...invalidation.positions ?? []
        ],
        ranges: [
            ...previous?.ranges ?? [],
            ...invalidation.ranges ?? []
        ]
    });
};
module.exports["BLOCK_CONTROLS_SURFACE_INVALIDATION"] = $49b97973592b0cec$export$bc8f172a7b59f6f8;
module.exports["invalidateBlockControlsSurfaces"] = $49b97973592b0cec$export$e9d9d89287b09e8;

});

parcelRegister("9ki8I", function(module, exports) {

var $dWeA1 = parcelRequire("dWeA1");

const $e0d48c9969d27ff1$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $dWeA1.border)
                }
            ];
        }
    });
module.exports["borderPlugin"] = $e0d48c9969d27ff1$export$39349c329288443f;

});

parcelRegister("fLS6B", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $acWDI = parcelRequire("acWDI");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $lMCDO = parcelRequire("lMCDO");


var $1KOhB = parcelRequire("1KOhB");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $kCECX = parcelRequire("kCECX");

const $b9859c35f29c69d8$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('breakoutPlugin');
const $b9859c35f29c69d8$export$f05434c51e3762e = (state)=>$b9859c35f29c69d8$export$18d4026d1ea86bb1.getState(state) || undefined;






var $8aEKG = parcelRequire("8aEKG");

var $7p4vo = parcelRequire("7p4vo");

var $6MtNT = parcelRequire("6MtNT");


var $6SJ6d = parcelRequire("6SJ6d");








var $4o0zT = parcelRequire("4o0zT");





var $8dxef = parcelRequire("8dxef");
















var $6gBg9 = parcelRequire("6gBg9");








var $8QOo3 = parcelRequire("8QOo3");







const $a625bc7e8547ea8a$export$cc135306f1c4ff36 = ({ tr: tr, node: node, pos: pos, isLivePage: isLivePage })=>{
    if (isLivePage || (0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) {
        const wasExpandExpanded = (0, $8QOo3.expandedState).get(node);
        const newExpand = tr.doc.nodeAt(pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $8QOo3.expandedState).set(newExpand, wasExpandExpanded);
    }
};
const $a625bc7e8547ea8a$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    if ((0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true)) $a625bc7e8547ea8a$export$cc135306f1c4ff36({
        tr: tr,
        node: node.node,
        pos: node.pos,
        isLivePage: isLivePage
    });
    else if (isLivePage || (0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) {
        const wasExpandExpanded = (0, $8QOo3.expandedState).get(node.node);
        const newExpand = tr.doc.nodeAt(node.pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $8QOo3.expandedState).set(newExpand, wasExpandExpanded);
    }
};


function $370b3dd575cda351$export$2347aa63864fccd4(width, mode, pos, isLivePage) {
    return (state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        let tr;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
            const marks = state.schema.marks.breakout.create({
                width: width,
                mode: mode
            }).addToSet(node.marks);
            tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        } else tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
            state.schema.marks.breakout.create({
                width: width,
                mode: mode
            })
        ]);
        if (node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
            tr: tr,
            node: node,
            pos: pos,
            isLivePage: isLivePage
        });
        else if (node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(pos);
            const oldNode = node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        // keep current selection, necessary to not remove NodeSelection for keyboard resizing
        if (state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.eq(node)) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
        if (dispatch) dispatch(tr);
        return true;
    };
}








const $f3f9224dd2294dde$export$66c2d241f2aa07a3 = {
    FULL: (0, $7Y8M5.akEditorFullWidthLayoutWidth),
    MAX: (0, $7Y8M5.akEditorMaxLayoutWidth),
    MIN: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    WIDE: (0, $7Y8M5.akEditorCalculatedWideLayoutWidth)
};
const $f3f9224dd2294dde$export$1a936a589e97b653 = (api)=>{
    const editorWidth = api?.width.sharedState?.currentState()?.width ?? 0;
    const padding = editorWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    return editorWidth - 2 * padding - (0, $7Y8M5.akEditorGutterPadding);
};
const $f3f9224dd2294dde$export$7568354ddf1b7e67 = (proposedWidth, containerWidth)=>{
    return Math.max($f3f9224dd2294dde$export$66c2d241f2aa07a3.MIN, Math.min(proposedWidth, containerWidth, $f3f9224dd2294dde$export$66c2d241f2aa07a3.MAX));
};


const $0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP = 10;
const $0f6d40dbf214f8ed$var$getKeyboardResizeWidth = (currentWidth, step, api)=>{
    const containerWidth = (0, $f3f9224dd2294dde$export$1a936a589e97b653)(api);
    const resizeStartWidth = Math.min(currentWidth, containerWidth);
    return (0, $f3f9224dd2294dde$export$7568354ddf1b7e67)(resizeStartWidth + step, containerWidth);
};
const $0f6d40dbf214f8ed$var$getAncestorResizableNode = (view, breakoutResizableNodes)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const selectedNode = selection.node;
        if (breakoutResizableNodes.has(selectedNode.type)) return {
            node: selectedNode,
            pos: selection.$from.pos
        };
    } else if (selection instanceof (0, $kCECX.TextSelection)) {
        let node = null;
        let nodePos = null;
        // only top level nodes are resizable
        const resolvedPos = view.state.doc.resolve(selection.$from.pos);
        const currentNode = resolvedPos.node(1);
        if (breakoutResizableNodes.has(currentNode.type)) {
            node = currentNode;
            nodePos = resolvedPos.before(1);
            return {
                node: node,
                pos: nodePos
            };
        }
    }
    return null;
};
const $0f6d40dbf214f8ed$export$bab59f27a7347e45 = (api)=>(view, event)=>{
        const browser = (0, $8dxef.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        if (metaKey && event.altKey && isBracketKey) {
            const breakoutResizableNodes = (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $7p4vo.getBreakoutResizableNodeTypesNew)(view.state.schema) : (0, $8aEKG.getBreakoutResizableNodeTypes)(view.state.schema, (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true));
            const result = $0f6d40dbf214f8ed$var$getAncestorResizableNode(view, breakoutResizableNodes);
            if (result) {
                const { node: node, pos: pos } = result;
                const breakoutMark = node?.marks.find((mark)=>mark.type.name === 'breakout');
                if (breakoutMark) {
                    const step = event.code === 'BracketRight' ? $0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP : -$0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP;
                    const newWidth = $0f6d40dbf214f8ed$var$getKeyboardResizeWidth(breakoutMark.attrs.width, step, api);
                    if (newWidth !== breakoutMark.attrs.width) {
                        const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
                        (0, $370b3dd575cda351$export$2347aa63864fccd4)(newWidth, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
                        view.focus();
                    }
                    return true;
                }
            }
        }
        return false;
    };









var $iDrrr = parcelRequire("iDrrr");











var $cbY7C = parcelRequire("cbY7C");


var $lFU5S = parcelRequire("lFU5S");


var $h1Peg = parcelRequire("h1Peg");





var $4Vdlk = parcelRequire("4Vdlk");


var $cIWiw = parcelRequire("cIWiw");


var $fGXGw = parcelRequire("fGXGw");





var $anBbz = parcelRequire("anBbz");


var $lpNn5 = parcelRequire("lpNn5");

const $5114ca5c92242368$var$getNodeName = (nodeName)=>{
    if (nodeName === 'layoutSection') return 'layout';
    else if (nodeName === 'codeBlock' || nodeName === 'expand') return nodeName;
    else if ((nodeName === 'rule' || nodeName === 'panel' || nodeName === 'panel_c1') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true)) return nodeName;
    else if ((nodeName === 'extension' || nodeName === 'bodiedExtension' || nodeName === 'multiBodiedExtension') && (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) return nodeName;
    else return 'node';
};
/**
 * Read by `.pm-breakout-resize-tooltip-anchor`, declared in `editor-core`'s `resizerStyles.ts` and
 * its Compiled mirror. Rename in all three or the tooltip pins to the top of the rail.
 */ const $5114ca5c92242368$var$tooltipAnchorTopVar = '--pm-breakout-resize-tooltip-anchor-top';
const $5114ca5c92242368$export$5c0a5eee165b9845 = {
    expand: (0, $lFU5S.messages).resizeExpand,
    codeBlock: (0, $lFU5S.messages).resizeCodeBlock,
    layout: (0, $lFU5S.messages).resizeLayout,
    rule: (0, $lFU5S.messages).resizeRule,
    panel: (0, $lFU5S.messages).resizePanel,
    panel_c1: (0, $lFU5S.messages).resizePanel,
    node: (0, $lFU5S.messages).resizeElement,
    extension: (0, $lFU5S.messages).resizeExtension,
    bodiedExtension: (0, $lFU5S.messages).resizeExtension,
    multiBodiedExtension: (0, $lFU5S.messages).resizeExtension
};
/**
 * Remove during `platform_editor_use_vanilla_components` cleanup — replaced by
 * `createHandleTooltip`, which does the same job without a React tree per resize handle.
 */ const $5114ca5c92242368$var$RailWithTooltip = ({ rail: rail, target: target, intl: intl })=>{
    const [nodeName, setNodeName] = (0, $cozmU.useState)('node');
    (0, $cozmU.useLayoutEffect)(()=>{
        const node = target.querySelector('[data-prosemirror-node-name]');
        const name = $5114ca5c92242368$var$getNodeName(node?.dataset.prosemirrorNodeName);
        setNodeName(name);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: intl.formatMessage($5114ca5c92242368$export$5c0a5eee165b9845[nodeName]),
        position: "mouse",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "pm-breakout-resize-handle-rail-inside-tooltip",
            ref: (el)=>{
                if (el && rail.parentNode !== el) el.appendChild(rail);
            }
        })
    });
};
/** Identifies the vanilla tooltip for tests and debugging. */ const $5114ca5c92242368$var$TOOLTIP_CLASS_NAME = 'pm-breakout-resize-tooltip';
/**
 * Classes applied to the tooltip element: the shared default look, plus our own hook. The default
 * still reaches a `[popover]` because the tooltip is painted in the top layer but stays in the DOM
 * under `.ProseMirror`.
 */ const $5114ca5c92242368$var$TOOLTIP_CLASS_NAMES = `${(0, $h1Peg.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$5114ca5c92242368$var$TOOLTIP_CLASS_NAME}`;
/**
 * Vanilla DOM equivalent of `RailWithTooltip`, behind `platform_editor_use_vanilla_components`.
 *
 * Anchored to a point rather than to the rail, which spans the node's full height and would strand
 * the tooltip at the top of a tall node. This reproduces the control arm's `position="mouse"`,
 * which latches the cursor as the tooltip opens and does not move it afterwards — so no cursor
 * tracking is needed, just one style write per hover.
 */ const $5114ca5c92242368$var$createHandleTooltip = ({ anchor: anchor, intl: intl, target: target })=>{
    // Only correct once ProseMirror has populated `contentDOM`, so callers must build on first
    // hover — earlier reads fall back to the generic 'node' label.
    const node = target.querySelector('[data-prosemirror-node-name]');
    const nodeName = $5114ca5c92242368$var$getNodeName(node?.dataset.prosemirrorNodeName);
    return new (0, $h1Peg.VanillaTooltip)(anchor, intl.formatMessage($5114ca5c92242368$export$5c0a5eee165b9845[nodeName]), // Let the tooltip generate its own id.
    undefined, $5114ca5c92242368$var$TOOLTIP_CLASS_NAMES, // Default delay, matching the ADS tooltip.
    300, // No inline styles
    undefined, // No `onShow`.
    undefined, // Below the cursor, matching the control arm's `position="mouse"`.
    'bottom');
};
const $5114ca5c92242368$export$2023dee10a108a1 = ({ target: target, onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
    let state = 'default';
    const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions') || (0, $4o0zT.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
    const createHandle = (side)=>{
        const handle = document.createElement('div');
        handle.contentEditable = 'false';
        handle.classList.add('pm-breakout-resize-handle-container');
        handle.style.gridColumn = side === 'left' ? '1' : '3';
        const rail = document.createElement('div');
        rail.classList.add('pm-breakout-resize-handle-rail');
        if (side === 'left') {
            handle.classList.add('pm-breakout-resize-handle-container--left');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-left');
        } else {
            handle.classList.add('pm-breakout-resize-handle-container--right');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-right');
        }
        const handleHitBox = document.createElement('div');
        handleHitBox.classList.add('pm-breakout-resize-handle-hit-box');
        const thumb = document.createElement('div');
        thumb.classList.add('pm-breakout-resize-handle-thumb');
        thumb.style.pointerEvents = 'none';
        rail.appendChild(thumb);
        // Marks the point the pointer entered the rail, and anchors the tooltip there: zero height
        // so it is a point not a box, full rail width so the tooltip centres like the control arm.
        //
        // Must stay a child of `rail` — `openTooltipAt` sets `top` from the rail's `offsetY`, which
        // only lines up while the rail is the containing block. jsdom cannot catch a wrong parent.
        //
        // Not built on the control arm, which must keep byte-identical DOM.
        let tooltipAnchor;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            // Positioned by `.pm-breakout-resize-tooltip-anchor`; only the pointer's Y is passed in.
            tooltipAnchor = document.createElement('div');
            tooltipAnchor.classList.add('pm-breakout-resize-tooltip-anchor');
            rail.appendChild(tooltipAnchor);
        }
        const tooltipContainer = document.createElement('div');
        tooltipContainer.classList.add('pm-breakout-resize-handle-rail-wrapper');
        handle.appendChild(tooltipContainer);
        handle.appendChild(handleHitBox);
        const key = crypto.randomUUID();
        const renderTooltip = ()=>nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)($5114ca5c92242368$var$RailWithTooltip, {
                    rail: rail,
                    target: target,
                    intl: intl
                }), tooltipContainer, key);
        let vanillaTooltip;
        // Tracks whether there is anything to tear down: the tooltip mounts on first hover and so
        // may never mount at all.
        let isTooltipMounted = false;
        const mountTooltip = ()=>{
            if (isTooltipMounted) return;
            isTooltipMounted = true;
            // `tooltipAnchor` is always set when the experiment is on; the check also narrows it.
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components') && tooltipAnchor) {
                vanillaTooltip = $5114ca5c92242368$var$createHandleTooltip({
                    anchor: tooltipAnchor,
                    target: target,
                    intl: intl
                });
                return;
            }
            // `RailWithTooltip`'s ref moves `rail` into the tooltip wrapper, so the DOM ends up
            // identical to the pre-mount state below.
            renderTooltip();
        };
        // React 18 registers ~130 native event listeners on every portal container (see
        // `listenToAllSupportedEvents`), and never removes them. Mounting this tooltip up front
        // costs that for every resizable node in the document — two containers per node when the
        // left handle is enabled — even though only the hovered handle can ever show a tooltip.
        //
        // Instead, park `rail` directly in the wrapper and mount the tooltip on the first
        // `mouseenter` of the node (see `registerEvents` below). The rail has `opacity: 0` until
        // the pointer is inside the node, so the pre-mount DOM is never visible, and the
        // `mouseenter` fires on the whole node — long before the pointer reaches the 7px handle.
        //
        // Parking the rail also needs `width: 100%`: without the ADS tooltip's wrappers (stretched
        // by `pragmaticResizerStylesForTooltip`) it would size to its content as a flex item.
        rail.style.width = '100%';
        tooltipContainer.appendChild(rail);
        return {
            handle: handle,
            rail: rail,
            tooltipAnchor: // Exposed so the rail's hover listeners can position and open the tooltip.
            tooltipAnchor,
            handleHitBox: handleHitBox,
            mountTooltip: mountTooltip,
            destroyTooltip: ()=>{
                // Re-read is safe: the gate is fixed for the page, so it matches what `mountTooltip`
                // saw. At cleanup, keep this body and delete the control arm below.
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                    // May never have mounted, and there is no portal to remove either way.
                    if (vanillaTooltip) {
                        vanillaTooltip.destroy();
                        vanillaTooltip = undefined;
                    }
                    isTooltipMounted = false;
                    return;
                }
                // The tooltip mounts on first hover, so `destroyTooltip` can be reached without
                // anything having been mounted.
                if (!isTooltipMounted) return;
                nodeViewPortalProviderAPI.remove(key);
                isTooltipMounted = false;
            }
        };
    };
    const rightHandle = createHandle('right');
    // Remove const leftHandle during 'platform_editor_lovability_resize_dividers_panels' cleanup
    const leftHandle = isLeftResizeHandleDisabled ? undefined : createHandle('left');
    const registerHandle = (handleElement, handleSide)=>{
        return (0, $4Vdlk.draggable)({
            element: handleElement,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cIWiw.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $fGXGw.preventUnhandled).start();
            },
            getInitialData: ()=>({
                    handleSide: handleSide
                }),
            onDragStart (args) {
                state = 'resizing';
                handleElement.classList.add('pm-breakout-resize-handle-container--active');
                // The ADS tooltip hides itself on press; the vanilla one has no pointer-press
                // listener, and its anchor moves with the rail, so it would follow the drag.
                // Tearing it down hides it immediately; the next hover rebuilds it.
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                    rightHandle.destroyTooltip();
                    leftHandle?.destroyTooltip();
                }
                onDragStart(args);
            },
            onDrag: onDrag,
            onDrop (args) {
                (0, $fGXGw.preventUnhandled).stop();
                state = 'default';
                handleElement.classList.remove('pm-breakout-resize-handle-container--active');
                onDrop(args);
            }
        });
    };
    /**
   * Parks the anchor where the pointer entered the rail, then opens the tooltip. The anchor is
   * `pointer-events: none`, so the rail's hover listeners drive it. `offsetY` is already in the
   * anchor's coordinate space, so no layout read is needed.
   *
   * Positions on enter only, matching the ADS tooltip as observed — though `Tooltip` does bind an
   * `onMouseMove`, so start here if the two arms disagree on placement.
   */ const openTooltipAt = (anchor, event)=>{
        // Only the rail bindings pass an anchor; `target` and the hit boxes do not.
        if (!anchor) return;
        anchor.style.setProperty($5114ca5c92242368$var$tooltipAnchorTopVar, `${event.offsetY}px`);
        anchor.dispatchEvent(new MouseEvent('mouseenter'));
    };
    const closeTooltip = (anchor)=>{
        if (!anchor) return;
        anchor.dispatchEvent(new MouseEvent('mouseleave'));
    };
    const registerEvents = (element, hoverAnchor)=>{
        return [
            (0, $cbY7C.bind)(element, {
                type: 'mouseenter',
                listener: (event)=>{
                    // Mounted on first hover rather than up front, so a handle that is never
                    // hovered costs no portal and no listeners.
                    rightHandle.mountTooltip();
                    leftHandle?.mountTooltip();
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) // After the mount above, so the tooltip always exists to be opened.
                    openTooltipAt(hoverAnchor, event);
                    rightHandle.rail.style.setProperty('opacity', '1');
                    leftHandle?.rail.style.setProperty('opacity', '1');
                }
            }),
            (0, $cbY7C.bind)(element, {
                type: 'mouseleave',
                listener: ()=>{
                    // Ahead of the resize guard below: the ADS tooltip hides whenever the pointer
                    // leaves the rail, including part-way through a resize.
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) closeTooltip(hoverAnchor);
                    if (state === 'resizing') return;
                    rightHandle.rail.style.removeProperty('opacity');
                    leftHandle?.rail.style.removeProperty('opacity');
                }
            })
        ];
    };
    const unbindFns = leftHandle ? // old code - left + right
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(leftHandle.handleHitBox),
        ...registerEvents(rightHandle.rail, rightHandle.tooltipAnchor),
        ...registerEvents(leftHandle.rail, leftHandle.tooltipAnchor)
    ] : // new code - right only
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(rightHandle.rail, rightHandle.tooltipAnchor)
    ];
    const handleElement = 'rail';
    const destroyFns = leftHandle ? // old code - left + right
    [
        registerHandle(rightHandle[handleElement], 'right'),
        registerHandle(leftHandle[handleElement], 'left'),
        rightHandle.destroyTooltip,
        leftHandle.destroyTooltip
    ] : // new code - right only
    [
        registerHandle(rightHandle[handleElement], 'right'),
        rightHandle.destroyTooltip
    ];
    return {
        rightHandle: rightHandle.handle,
        leftHandle: leftHandle?.handle,
        destroy: (isChangeToViewMode)=>{
            destroyFns.forEach((destroyFn)=>destroyFn());
            unbindFns.forEach((unbindFn)=>unbindFn());
            if (isChangeToViewMode) {
                rightHandle.handle.parentElement?.removeChild(rightHandle.handle);
                leftHandle?.handle.parentElement?.removeChild(leftHandle.handle);
            }
        }
    };
};




var $dOBRD = parcelRequire("dOBRD");

const $5c8e412569aaa956$export$6065600df915db53 = 8;


var $cBSrP = parcelRequire("cBSrP");

var $2INqe = parcelRequire("2INqe");







const $b26ea474fd996270$var$WIDTHS = {
    MIN: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    WIDE: (0, $7Y8M5.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $7Y8M5.akEditorFullWidthLayoutWidth),
    MAX: (0, $7Y8M5.akEditorMaxLayoutWidth)
};
const $b26ea474fd996270$export$dd27ecfadfde9946 = {
    lineLengthLeft: 'grid_left',
    lineLengthRight: 'grid_right',
    wideLeft: 'wide_left',
    wideRight: 'wide_right',
    fullWidthLeft: 'full_width_left',
    fullWidthRight: 'full_width_right',
    maxWidthLeft: 'max_width_left',
    maxWidthRight: 'max_width_right'
};
const $b26ea474fd996270$var$SYNC_BLOCK_PADDING = 19;
const $b26ea474fd996270$var$EXTENSION_WRAPPER_PADDING = 20;
const $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $b26ea474fd996270$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $b26ea474fd996270$export$47dec483f7d48a59 = (0, $dOBRD.default)((isResizing, newWidth, getEditorWidth, nodeType)=>{
    const guidelines = [];
    if (!isResizing) return guidelines;
    let innerPaddingOffset = 0;
    if (nodeType) switch(nodeType.name){
        case 'expand':
            innerPaddingOffset = (0, $5c8e412569aaa956$export$6065600df915db53) + (0, $2INqe.resizerHandleThumbWidth) + $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'layoutSection':
            innerPaddingOffset = (0, $cBSrP.LAYOUT_COLUMN_PADDING) + $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'bodiedSyncBlock':
        case 'syncBlock':
            innerPaddingOffset = $b26ea474fd996270$var$SYNC_BLOCK_PADDING;
            break;
        case 'extension':
        case 'multiBodiedExtension':
        case 'bodiedExtension':
            innerPaddingOffset = $b26ea474fd996270$var$EXTENSION_WRAPPER_PADDING;
            break;
        default:
            break;
    }
    const { width: width } = getEditorWidth() || {};
    const padding = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const fullWidth = width ? Math.min($b26ea474fd996270$var$WIDTHS.FULL, width - 2 * padding - (0, $7Y8M5.akEditorGutterPadding)) : undefined;
    const maxWidth = width ? Math.min($b26ea474fd996270$var$WIDTHS.MAX, width - 2 * padding - (0, $7Y8M5.akEditorGutterPadding)) : undefined;
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.lineLengthLeft,
        position: {
            x: -$b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.lineLengthRight,
        position: {
            x: $b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.wideLeft,
        position: {
            x: -$b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.WIDE
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.wideRight,
        position: {
            x: $b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.WIDE
    });
    if (fullWidth) {
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.fullWidthLeft,
            position: {
                x: -$b26ea474fd996270$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.fullWidthRight,
            position: {
                x: $b26ea474fd996270$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
    }
    if (maxWidth) {
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.maxWidthLeft,
            position: {
                x: -$b26ea474fd996270$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.maxWidthRight,
            position: {
                x: $b26ea474fd996270$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
    }
    return guidelines;
});






var $krYZG = parcelRequire("krYZG");

const $16eef43b12a02110$export$29574a7e6ffc8eb4 = (props)=>{
    return props.frameRateSamples.map((frameRateSample, index)=>({
            action: (0, $krYZG.ACTION).RESIZED_PERF_SAMPLING,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                nodeType: props.originalNode.type.name,
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $16eef43b12a02110$export$6b143296f4c6108b = ({ node: node, prevWidth: prevWidth, newWidth: newWidth })=>{
    return {
        action: (0, $krYZG.ACTION).RESIZED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            nodeType: node.type.name,
            prevWidth: prevWidth,
            newWidth: newWidth
        }
    };
};


/**
 * Measure the FPS of a resizing component.
 *
 * This is a simplified version of the `useMeasureFramerate` hook from `editor-plugin-table`.
 * (packages/editor/editor-plugin-table/src/pm-plugins/utils/analytics.ts)
 */ const $30161690decf9e20$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $30161690decf9e20$export$499e6cf908107611 = (config)=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config || {};
    let frameCount = 0;
    let lastTime = 0;
    let timeoutId;
    let frameRateSamples = [];
    const startMeasure = ()=>{
        frameCount = 0;
        lastTime = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 * @returns {number[]} An array of frame rate samples as integers.
	 * @example
	 * const samples = endMeasure(); // [60, 58, 62]
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples;
        frameRateSamples = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount / (deltaTime / 1000));
            frameRateSamples.push(frameRate);
        }
        frameCount = 0;
        lastTime = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 * @example
	 * const animate = () => {
	 *   countFrames();
	 *   requestAnimationFrame(animate);
	 * };
	 */ const countFrames = ()=>{
        if (frameRateSamples.length >= maxSamples && timeoutId) {
            clearTimeout(timeoutId);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime === 0) lastTime = performance.now();
        frameCount++;
        if (timeoutId) clearTimeout(timeoutId);
        if (performance.now() - lastTime > sampleRateMs) sampleFrameRate();
        else timeoutId = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};


const $a7d4f60c53187407$var$RESIZE_RATIO = 2;
const $a7d4f60c53187407$var$SNAP_GAP = 10;
function $a7d4f60c53187407$export$39e6ff87d188b0e6({ initialWidth: initialWidth, location: location, api: api, source: source }) {
    const directionMultiplier = source.data.handleSide === 'left' ? -1 : 1;
    const diffX = (location.current.input.clientX - location.initial.input.clientX) * $a7d4f60c53187407$var$RESIZE_RATIO * directionMultiplier;
    const containerWidth = (0, $f3f9224dd2294dde$export$1a936a589e97b653)(api);
    // the node width may be greater than the container width so we resize using the smaller value
    const proposedWidth = Math.min(initialWidth, containerWidth) + diffX;
    const snapPoints = [
        (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).MIN,
        (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).WIDE,
        Math.min(containerWidth, (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).FULL),
        Math.min(containerWidth, (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).MAX)
    ];
    for (const snapPoint of snapPoints){
        if (snapPoint - $a7d4f60c53187407$var$SNAP_GAP < proposedWidth && snapPoint + $a7d4f60c53187407$var$SNAP_GAP > proposedWidth) return snapPoint;
    }
    return (0, $f3f9224dd2294dde$export$7568354ddf1b7e67)(proposedWidth, containerWidth);
}
function $a7d4f60c53187407$export$d3619fd797e636fb({ dom: dom, view: view, mark: mark, api: api }) {
    let node = null;
    let guidelines = [];
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $30161690decf9e20$export$499e6cf908107611)();
    const getEditorWidth = ()=>{
        return api?.width?.sharedState.currentState();
    };
    return {
        onDragStart: ()=>{
            startMeasure();
            const pos = view.posAtDOM(dom, 0);
            node = view.state.doc.nodeAt(pos);
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                tr.setMeta('is-resizer-resizing', true);
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'UPDATE_BREAKOUT_NODE',
                    data: {
                        node: node,
                        pos: pos,
                        start: pos,
                        depth: 0
                    }
                });
                return tr;
            });
        },
        onDrag: ({ location: location, source: source })=>{
            countFrames();
            const initialWidth = mark.attrs.width;
            const newWidth = $a7d4f60c53187407$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            guidelines = (0, $b26ea474fd996270$export$47dec483f7d48a59)(true, newWidth, getEditorWidth, node?.type);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const activeGuideline = guidelines.find((guideline)=>guideline.active && !guideline.key.startsWith('grid'));
            if (activeGuideline) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'UPDATE_ACTIVE_GUIDELINE_KEY',
                    data: {
                        activeGuidelineKey: activeGuideline.key
                    }
                });
                return tr;
            });
            if (!activeGuideline && api?.breakout.sharedState.currentState()?.activeGuidelineKey) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'CLEAR_ACTIVE_GUIDELINE_KEY'
                });
                return tr;
            });
            // dom is used for width calculations
            dom.style.setProperty((0, $5cef6fba358b19bd$export$4ce5e59f44ac1e3e), `${newWidth}px`);
        },
        onDrop ({ location: location, source: source }) {
            let payloads = [];
            const frameRateSamples = endMeasure();
            payloads = (0, $16eef43b12a02110$export$29574a7e6ffc8eb4)({
                docSize: view.state.doc.nodeSize,
                frameRateSamples: (0, $30161690decf9e20$export$52625746d6329c8a)(frameRateSamples),
                originalNode: node
            });
            const isResizedToFullWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('full_width') && guideline.active);
            const isResizedToMaxWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('max_width') && guideline.active);
            guidelines = (0, $b26ea474fd996270$export$47dec483f7d48a59)(false, 0, getEditorWidth);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const pos = view.posAtDOM(dom, 0);
            const mode = mark.attrs.mode;
            const initialWidth = mark.attrs.width;
            let newWidth = isResizedToFullWidth ? (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).FULL : $a7d4f60c53187407$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            if (isResizedToMaxWidth) newWidth = (0, $f3f9224dd2294dde$export$66c2d241f2aa07a3).MAX;
            const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
            (0, $370b3dd575cda351$export$2347aa63864fccd4)(newWidth, mode, pos, isEditMode)(view.state, view.dispatch);
            dom.style.removeProperty((0, $5cef6fba358b19bd$export$4ce5e59f44ac1e3e));
            if (node) {
                const resizedPayload = (0, $16eef43b12a02110$export$6b143296f4c6108b)({
                    node: node,
                    prevWidth: initialWidth,
                    newWidth: newWidth
                });
                payloads.push(resizedPayload);
            }
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                payloads.forEach((payload)=>{
                    api.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                });
                tr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'RESET_STATE'
                });
                return tr;
            });
        }
    };
}


const $5cef6fba358b19bd$export$4ce5e59f44ac1e3e = '--local-resizing-width';
const $5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH = '7px';
// this function delays the resizer callbacks until the mark view DOM is attached to the DOM
const $5cef6fba358b19bd$var$scheduleResizeHandleSetup = (callback)=>{
    if (typeof window === 'undefined') return ()=>{};
    if (typeof window.requestAnimationFrame === 'function') {
        const frame = window.requestAnimationFrame(callback);
        return ()=>window.cancelAnimationFrame(frame);
    }
    const timeout = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(timeout);
};
class $5cef6fba358b19bd$export$4fb684fac6535bde {
    setupResizerCallbacks(dom, contentDOM, view, mark, api) {
        const callbacks = (0, $a7d4f60c53187407$export$d3619fd797e636fb)({
            dom: dom,
            view: view,
            mark: mark,
            api: api
        });
        const { leftHandle: leftHandle, rightHandle: rightHandle, destroy: destroy } = (0, $5114ca5c92242368$export$2023dee10a108a1)({
            target: contentDOM,
            ...callbacks,
            intl: this.intl,
            nodeViewPortalProviderAPI: this.nodeViewPortalProviderAPI
        });
        if (leftHandle) this.dom.prepend(leftHandle);
        this.dom.appendChild(rightHandle);
        this.destroyFn = destroy;
        this.isResizingInitialised = true;
    }
    setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api) {
        // cancel any pending setup before scheduling a new one
        this.cancelScheduledResizeHandleSetup?.();
        this.cancelScheduledResizeHandleSetup = undefined;
        // if breakout resizing is supported,
        // continue to set up the resizer callbacks
        if (isResizingDividersPanelsEnabled && isResizingExtensionsEnabled) {
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            return;
        }
        // else if breakout resizing is not supported,
        // do NOT set up the resizer callbacks (yet)
        // wait for the mark view DOM to be attached to the DOM first
        this.cancelScheduledResizeHandleSetup = $5cef6fba358b19bd$var$scheduleResizeHandleSetup(()=>{
            this.cancelScheduledResizeHandleSetup = undefined;
            if (view.isDestroyed || !dom.isConnected) return;
            const pos = view.posAtDOM(dom, 0);
            const nodeName = view.state.doc.nodeAt(pos)?.type.name;
            // if the node is a panel or a rule but resizing is not supported, do NOT set up the resizer callbacks
            // if the node is an extension but resizing is not supported, do NOT set up the resizer callbacks
            if (nodeName && [
                'panel',
                'rule',
                'panel_c1'
            ].includes(nodeName) && !isResizingDividersPanelsEnabled || nodeName && [
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ].includes(nodeName) && !isResizingExtensionsEnabled || this.isResizingInitialised) return;
            // else, continue to set up the resizer callbacks
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        });
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        this.destroyFn?.();
        this.unsubscribeToViewModeChange?.();
        this.cancelScheduledResizeHandleSetup?.();
    }
    /**
   * Wrap node view in a resizing mark view
   * @param {Mark} mark - The breakout mark to resize
   * @param {EditorView} view - The editor view
   * @param {ExtractInjectionAPI<BreakoutPlugin> | undefined} api - The pluginInjectionAPI
   * @param {Function} getIntl - () => IntlShape
   * @param {PortalProviderAPI} - The nodeViewPortalProviderAPI
   * @example
   * ```ts
   * ```
   */ constructor(mark, view, api, getIntl, nodeViewPortalProviderAPI){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        this.destroyFn = void 0;
        this.cancelScheduledResizeHandleSetup = void 0;
        this.intl = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.unsubscribeToViewModeChange = void 0;
        this.isResizingInitialised = false;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        const isRemoveLeftResizeHandleEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const isResizingDividersPanelsEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        const isResizingExtensionsEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
        // DOM styles
        // Keep a three-column grid even when the left resize handle is disabled. The empty
        // left track preserves the original content alignment without translating `contentDOM`,
        // so floating UI anchored to the node (for example block drag handles) keeps its position.
        dom.style.transform = 'none';
        dom.style.display = 'grid';
        dom.style.justifyContent = 'center';
        // contentDOM styles
        contentDOM.style.gridColumn = '2';
        contentDOM.style.zIndex = '1';
        if (mark.attrs.width) dom.style.gridTemplateColumns = isResizingDividersPanelsEnabled || isResizingExtensionsEnabled || isRemoveLeftResizeHandleEnabled ? // new code - phantom left track + content + right handle
        `${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH} max(var(--ak-editor--breakout-min-width), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) ${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH}` : // old code - left handle + content + right handle
        `auto max(var(--ak-editor--breakout-min-width), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) auto`;
        else {
            if (isResizingDividersPanelsEnabled || isResizingExtensionsEnabled || isRemoveLeftResizeHandleEnabled) dom.style.gridTemplateColumns = `${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH} auto ${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH}`;
            if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.view = view;
        this.mark = mark;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        const isLiveViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (!isLiveViewMode) (0, $iDrrr.fg)('platform_editor_lovability_resize_gracefully') || (0, $iDrrr.fg)('platform_editor_lovability_resize_exts_gracefully') ? this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api) : this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        this.unsubscribeToViewModeChange = api?.editorViewMode?.sharedState.onChange((sharedState)=>{
            if (sharedState.nextSharedState?.mode !== sharedState.prevSharedState?.mode) {
                if ((0, $iDrrr.fg)('platform_editor_lovability_resize_gracefully') || (0, $iDrrr.fg)('platform_editor_lovability_resize_exts_gracefully')) {
                    if (sharedState.nextSharedState?.mode === 'view') {
                        this.cancelScheduledResizeHandleSetup?.();
                        this.cancelScheduledResizeHandleSetup = undefined;
                        if (this.isResizingInitialised) {
                            this.destroyFn?.(true);
                            this.isResizingInitialised = false;
                        }
                    } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api);
                } else if (sharedState.nextSharedState?.mode === 'view' && this.isResizingInitialised) {
                    this.destroyFn?.(true);
                    this.isResizingInitialised = false;
                } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            }
        });
    }
}



const $8091fd80d3a27677$var$addBreakoutToResizableNode = ({ node: node, pos: pos, newState: newState, newTr: newTr, breakoutResizableNodes: breakoutResizableNodes, isFullWidthEnabled: isFullWidthEnabled, isMaxWidthEnabled: isMaxWidthEnabled })=>{
    let updatedDocChanged = false;
    let updatedTr = newTr;
    const $pos = newState.doc.resolve(pos);
    const isTopLevelNode = $pos?.depth === 0;
    if (breakoutResizableNodes.has(node.type) && isTopLevelNode) {
        const { breakout: breakout } = newState.schema.marks;
        const { expand: expand } = newState.schema.nodes;
        const breakoutMark = node.marks.find((mark)=>mark.type === breakout);
        const isExpand = node.type === expand;
        if (!breakoutMark) {
            const width = isMaxWidthEnabled ? (0, $7Y8M5.akEditorMaxWidthLayoutWidth) : isFullWidthEnabled ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : (0, $7Y8M5.akEditorDefaultLayoutWidth);
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
                const marks = breakout.create({
                    width: width
                }).addToSet(node.marks);
                updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, marks);
            } else updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width
                })
            ]);
            if (isExpand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        } else if (breakoutMark?.attrs.width === null || breakoutMark?.attrs.width === undefined) {
            const mode = breakoutMark.attrs.mode;
            // if breakout is present on node, but page appearance is 'full width' force width to full width to maintain backwards compatibility
            const width = isMaxWidthEnabled ? (0, $7Y8M5.akEditorMaxWidthLayoutWidth) : isFullWidthEnabled || mode === 'full-width' ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : (0, $7Y8M5.akEditorCalculatedWideLayoutWidth);
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
                const marks = breakout.create({
                    width: width
                }).addToSet(node.marks);
                updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, marks);
            } else updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width,
                    mode: mode
                })
            ]);
            if (isExpand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        }
    }
    return {
        updatedTr: updatedTr,
        updatedDocChanged: updatedDocChanged
    };
};
const $8091fd80d3a27677$export$ca33a310187a5f87 = new (0, $kCECX.PluginKey)('breakout-resizing');
const $8091fd80d3a27677$var$pluginState = {
    init () {
        return {
            breakoutNode: undefined,
            activeGuidelineLabel: undefined
        };
    },
    apply (tr, pluginState) {
        const meta = tr.getMeta($8091fd80d3a27677$export$ca33a310187a5f87);
        if (meta) switch(meta.type){
            case 'UPDATE_BREAKOUT_NODE':
                return {
                    ...pluginState,
                    breakoutNode: meta.data
                };
            case 'UPDATE_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: meta.data.activeGuidelineKey
                };
            case 'CLEAR_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: undefined
                };
            case 'RESET_STATE':
                return {
                    activeGuidelineLabel: undefined,
                    breakoutNode: undefined
                };
        }
        return pluginState;
    }
};
const $8091fd80d3a27677$var$requestIdleCallbackWithFallback = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(callback);
    else // fallback to requestAnimationFrame for Safari
    requestAnimationFrame(callback);
};
const $8091fd80d3a27677$export$522e3e76a011a0b1 = (api, getIntl, nodeViewPortalProviderAPI, options)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $8091fd80d3a27677$export$ca33a310187a5f87,
        state: $8091fd80d3a27677$var$pluginState,
        props: {
            markViews: {
                breakout: (mark, view)=>{
                    return new (0, $5cef6fba358b19bd$export$4fb684fac6535bde)(mark, view, api, getIntl, nodeViewPortalProviderAPI);
                }
            },
            handleKeyDown: (0, $0f6d40dbf214f8ed$export$bab59f27a7347e45)(api)
        },
        view: (editorView)=>{
            const isPageLoadNormalizationEnabled = (0, $ieeJu.expValEquals)('platform_editor_add_breakout_marks_on_page_load', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
            const isRuleAndPanelResizingEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
            if (!isPageLoadNormalizationEnabled && !isRuleAndPanelResizingEnabled) return {};
            /**
       * This performs a one-time scan of the document to add breakout marks
       * to nodes that don't have them. It's designed to run only once per
       * editor instance to avoid performance issues.
       */ const normalizeBreakoutResizableNodes = ()=>{
                if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return;
                const isFullWidthEnabled = !(options?.allowBreakoutButton === true);
                const isMaxWidthEnabled = options?.appearance === 'max';
                const { state: state } = editorView;
                const breakoutResizableNodes = (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $7p4vo.getBreakoutResizableNodeTypesNew)(state.schema) : (0, $8aEKG.getBreakoutResizableNodeTypes)(state.schema, isRuleAndPanelResizingEnabled);
                let newTr = state.tr;
                let hasDocChanged = false;
                // scan the document for top-level resizable nodes
                state.doc.forEach((node, pos)=>{
                    if (!breakoutResizableNodes.has(node.type)) return;
                    const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $8091fd80d3a27677$var$addBreakoutToResizableNode({
                        node: node,
                        pos: pos,
                        newState: state,
                        newTr: newTr,
                        breakoutResizableNodes: breakoutResizableNodes,
                        isFullWidthEnabled: isFullWidthEnabled,
                        isMaxWidthEnabled: isMaxWidthEnabled
                    });
                    newTr = updatedTr;
                    hasDocChanged = hasDocChanged || updatedDocChanged;
                });
                if (hasDocChanged) editorView.dispatch(newTr.setMeta('addToHistory', false));
            };
            $8091fd80d3a27677$var$requestIdleCallbackWithFallback(normalizeBreakoutResizableNodes);
            const unsubscribeFromViewMode = api?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState?.mode === 'edit') $8091fd80d3a27677$var$requestIdleCallbackWithFallback(normalizeBreakoutResizableNodes);
            });
            return {
                destroy: ()=>{
                    unsubscribeFromViewMode?.();
                }
            };
        },
        appendTransaction (transactions, oldState, newState) {
            if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return;
            let newTr = newState.tr;
            let hasDocChanged = false;
            const isRuleAndPanelResizingEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
            const breakoutResizableNodes = (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $7p4vo.getBreakoutResizableNodeTypesNew)(newState.schema) : (0, $8aEKG.getBreakoutResizableNodeTypes)(newState.schema, isRuleAndPanelResizingEnabled);
            const isFullWidthEnabled = !(options?.allowBreakoutButton === true);
            const isMaxWidthEnabled = options?.appearance === 'max';
            const isPageLoadNormalizationEnabled = (0, $ieeJu.expValEquals)('platform_editor_add_breakout_marks_on_page_load', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
            if (!isPageLoadNormalizationEnabled && !isRuleAndPanelResizingEnabled && (0, $6SJ6d.isReplaceDocOperation)(transactions, oldState)) newState.doc.forEach((node, pos)=>{
                const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $8091fd80d3a27677$var$addBreakoutToResizableNode({
                    node: node,
                    pos: pos,
                    newState: newState,
                    newTr: newTr,
                    breakoutResizableNodes: breakoutResizableNodes,
                    isFullWidthEnabled: isFullWidthEnabled,
                    isMaxWidthEnabled: isMaxWidthEnabled
                });
                newTr = updatedTr;
                hasDocChanged = hasDocChanged || updatedDocChanged;
            });
            else transactions.forEach((tr)=>{
                const isAddingResizableNodes = tr.steps.some((step)=>(0, $6MtNT.stepAddsOneOf)(step, breakoutResizableNodes));
                if (isAddingResizableNodes) {
                    const changedNodes = (0, $6SJ6d.getChangedNodes)(tr);
                    changedNodes.forEach(({ node: node, pos: pos })=>{
                        const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $8091fd80d3a27677$var$addBreakoutToResizableNode({
                            node: node,
                            pos: pos,
                            newState: newState,
                            newTr: newTr,
                            breakoutResizableNodes: breakoutResizableNodes,
                            isFullWidthEnabled: isFullWidthEnabled,
                            isMaxWidthEnabled: isMaxWidthEnabled
                        });
                        newTr = updatedTr;
                        hasDocChanged = hasDocChanged || updatedDocChanged;
                    });
                }
            });
            if (hasDocChanged) // This transaction normalizes a newly inserted node to the editor's default breakout
            // width. It is not a user resize and must not become an undo step — in particular, a
            // source synced block can be deleted permanently before Undo reaches this normalization.
            return newTr.setMeta('addToHistory', false);
        }
    });
};






var $bjg0G = parcelRequire("bjg0G");




const $40620c4942718f97$var$supportedNodesForBreakout = [
    'codeBlock',
    'layoutSection',
    'expand'
];
const $40620c4942718f97$var$supportedNodesForBreakoutAdvancedLayouts = [
    'codeBlock',
    'expand'
];
function $40620c4942718f97$export$2e02ca5ba4632d0a(node) {
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) return $40620c4942718f97$var$supportedNodesForBreakoutAdvancedLayouts.indexOf(node.type.name) !== -1;
    return $40620c4942718f97$var$supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}


function $3881b65b874c8445$export$b3e00d6ce0602166(selection) {
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const supportsBreakout = (0, $40620c4942718f97$export$2e02ca5ba4632d0a)(selection.node);
        if (supportsBreakout) return {
            pos: selection.from,
            start: selection.from,
            node: selection.node,
            // If a selected expand is in a doc, the depth of that expand is 0. Therefore
            // we don't need to subtract 1 or instantly return false if the depth is 0
            depth: selection.$anchor.depth
        };
    }
    const breakoutNode = (0, $bjg0G.findParentNode)((0, $40620c4942718f97$export$2e02ca5ba4632d0a))(selection);
    if (!breakoutNode || breakoutNode.depth === 0) // If this node doesn't exist or the only supporting node is the document
    // (with depth 0), then we're not inside a node that supports breakout
    return undefined;
    return {
        node: breakoutNode.node,
        start: breakoutNode.start,
        pos: breakoutNode.pos,
        depth: breakoutNode.depth - 1
    };
}



function $a2cf882edcb3c89a$export$7293881dc293b44d(state) {
    const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
    if (!node) return;
    const breakoutMark = node.node.marks.find((m)=>m.type.name === 'breakout');
    if (!breakoutMark) return;
    return breakoutMark.attrs.mode;
}





parcelRequire("cozmU");


var $aiyg1 = parcelRequire("aiyg1");


var $7XIuB = parcelRequire("7XIuB");







const $582d6f147f320fca$var$GUIDELINE_KEY_TO_LAYOUT = {
    wide_left: 'wide',
    wide_right: 'wide',
    full_width_left: 'full-width',
    full_width_right: 'full-width',
    max_width_left: 'max',
    max_width_right: 'max'
};
const $582d6f147f320fca$export$ee321e647107007d = ({ api: api, editorView: editorView, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const breakoutNode = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'breakout.breakoutNode');
    const activeGuidelineKey = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'breakout.activeGuidelineKey');
    if (!breakoutNode || !activeGuidelineKey) return null;
    const element = (0, $bjg0G.findDomRefAtPos)(breakoutNode.pos, editorView.domAtPos.bind(editorView));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7XIuB.default), {
        target: element && element instanceof HTMLElement ? element : undefined,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        alignY: "bottom",
        alignX: "center",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: $582d6f147f320fca$var$GUIDELINE_KEY_TO_LAYOUT[activeGuidelineKey]
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");











var $ldbHR = parcelRequire("ldbHR");


var $keRDK = parcelRequire("keRDK");

var $3LJVu = parcelRequire("3LJVu");











var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");


var $jp2Q3 = parcelRequire("jp2Q3");












function $f7a09a3667270750$export$8adb30fdfe0dc8a3(isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const marks = node.node.marks.filter((m)=>m.type.name !== 'breakout');
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        if (node.node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}













function $947054a48b58065b$export$835e4fcd1fc926bc(mode, isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        let tr;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
            const marks = state.schema.marks.breakout.create({
                mode: mode
            }).addToSet(node.node.marks);
            tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        } else tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
            state.schema.marks.breakout.create({
                mode: mode
            })
        ]);
        if (node.node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}




function $2dbd0737d1a59e22$export$caf83e14f3995804(state) {
    if (!state.schema.marks.breakout) return false;
    const supportedNodeParent = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
    if (!supportedNodeParent) return false;
    // At the moment we can only breakout when the depth is 0, ie. doc is the only node
    // that supports breakout. This *could* change though.
    const parent = state.selection.$from.node(supportedNodeParent.depth);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}



const $0fd7dd3657f1434d$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
        background: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-icon, #292A2E)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon, #292A2E)"} !important`
        }
    }
});
const $0fd7dd3657f1434d$var$toolbarButtonNarrowScreenStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/design-system/no-nested-styles,  @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            visibility: 'hidden',
            opacity: 0
        }
    }
});
function $0fd7dd3657f1434d$var$getBreakoutNodeElement(pluginState, selection, editorView) {
    if (!pluginState.breakoutNode) return undefined;
    if (selection instanceof (0, $kCECX.NodeSelection) && (0, $40620c4942718f97$export$2e02ca5ba4632d0a)(selection.node)) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $bjg0G.findDomRefAtPos)(selection.from, editorView.domAtPos.bind(editorView));
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $bjg0G.findParentDomRefOfType)(pluginState.breakoutNode.node.type, editorView.domAtPos.bind(editorView))(selection);
}
const $0fd7dd3657f1434d$var$LayoutButton = ({ intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isLivePage: isLivePage, isBreakoutNodePresent: isBreakoutNodePresent, breakoutMode: breakoutModeProp, api: api })=>{
    const handleClick = (0, $cozmU.useCallback)((breakoutMode)=>{
        if (!editorView) return;
        const { state: state, dispatch: dispatch } = editorView;
        const breakoutNode = (0, $b9859c35f29c69d8$export$f05434c51e3762e)(state)?.breakoutNode;
        if ([
            'wide',
            'full-width'
        ].indexOf(breakoutMode) !== -1) {
            (0, $947054a48b58065b$export$835e4fcd1fc926bc)(breakoutMode, isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    mode: breakoutMode,
                    nodeType: breakoutNode?.node.type.name
                }
            });
        } else {
            (0, $f7a09a3667270750$export$8adb30fdfe0dc8a3)(isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    mode: 'center',
                    nodeType: breakoutNode?.node.type.name
                }
            });
        }
    }, [
        api?.analytics?.actions,
        editorView,
        isLivePage
    ]);
    if (!editorView) return null;
    if (!isBreakoutNodePresent || !(0, $2dbd0737d1a59e22$export$caf83e14f3995804)(editorView.state)) return null;
    const breakoutMode = breakoutModeProp;
    const titleMessage = (0, $3LJVu.getTitle)(breakoutMode);
    const title = formatMessage(titleMessage);
    const nextBreakoutMode = (0, $keRDK.getNextBreakoutMode)(breakoutMode);
    const belowOtherPopupsZIndex = (0, $jp2Q3.layers).layer() - 1;
    const pluginState = (0, $b9859c35f29c69d8$export$f05434c51e3762e)(editorView.state);
    if (!pluginState) return null;
    let element = $0fd7dd3657f1434d$var$getBreakoutNodeElement(pluginState, editorView.state.selection, editorView);
    if (!element) return null;
    const closestEl = element.querySelector(`.${(0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM}`);
    if (closestEl && closestEl.firstChild) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    element = closestEl.firstChild;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        ariaLabel: title,
        target: element,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            5,
            0
        ],
        alignY: "start",
        alignX: "end",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        zIndex: belowOtherPopupsZIndex
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $0fd7dd3657f1434d$var$toolbarButtonWrapperStyles,
            (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $0fd7dd3657f1434d$var$toolbarButtonNarrowScreenStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        title: title,
        testId: titleMessage.id,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>handleClick(nextBreakoutMode),
        iconBefore: breakoutMode === 'full-width' ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
            label: title,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
            label: title,
            spacing: "spacious"
        })
    })));
};
$0fd7dd3657f1434d$var$LayoutButton.displayName = 'LayoutButton';
const $0fd7dd3657f1434d$var$_default_1 = (0, $kSwu1.injectIntl)($0fd7dd3657f1434d$var$LayoutButton);
var $0fd7dd3657f1434d$export$2e2bcd8739ae039 = $0fd7dd3657f1434d$var$_default_1;


class $267f2cb62f6991f2$var$BreakoutView {
    constructor(/**
   * Note: this is actually a PMMark -- however our version
   * of the prosemirror and prosemirror types mean using PMNode
   * is not problematic.
   */ mark, view, appearance){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        dom.style.transform = 'none';
        dom.style.display = 'flex';
        dom.style.justifyContent = 'center';
        contentDOM.style.transition = `min-width 0.5s ${0, $7Y8M5.akEditorSwoopCubicBezier}`;
        if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
            if (mark.attrs.width) contentDOM.style.minWidth = `min(${mark.attrs.width}px, calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
            else {
                // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
                if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                if (mark.attrs.mode === 'wide') {
                    if (appearance && appearance === 'full-width' && (0, $jkcNT.editorExperiment)('single_column_layouts', true) && true) contentDOM.style.minWidth = `min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
                    else contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                }
            }
        } else {
            // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
            if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'wide') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
    }
}
function $267f2cb62f6991f2$var$shouldPluginStateUpdate(newBreakoutNode, currentBreakoutNode) {
    if (newBreakoutNode && currentBreakoutNode) return newBreakoutNode !== currentBreakoutNode;
    return newBreakoutNode || currentBreakoutNode ? true : false;
}
function $267f2cb62f6991f2$var$createPlugin(api, { dispatch: dispatch }, appearance) {
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
            },
            apply (tr, pluginState) {
                const breakoutNode = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(tr.selection);
                if ($267f2cb62f6991f2$var$shouldPluginStateUpdate(breakoutNode, pluginState.breakoutNode)) {
                    const nextPluginState = {
                        ...pluginState,
                        breakoutNode: breakoutNode
                    };
                    dispatch((0, $b9859c35f29c69d8$export$18d4026d1ea86bb1), nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            }
        },
        key: (0, $b9859c35f29c69d8$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                // Note: When we upgrade to prosemirror 1.27.2 -- we should
                // move this to markViews.
                // See the following link for more details:
                // https://prosemirror.net/docs/ref/#view.EditorProps.nodeViews.
                breakout: (mark, view)=>{
                    return new $267f2cb62f6991f2$var$BreakoutView(mark, view, appearance);
                }
            }
        }
    });
}
const $267f2cb62f6991f2$var$LayoutButtonWrapper = ({ api: api, editorView: editorView, boundariesElement: boundariesElement, scrollableElement: scrollableElement, mountPoint: mountPoint })=>{
    const { editorDisabled: editorDisabled, isDragging: isDragging, isPMDragging: isPMDragging, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'editorDisabled',
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging,
            isPMDragging: states.blockControlsState?.isPMDragging,
            mode: states.editorViewModeState?.mode,
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const [breakoutNodePresent, setBreakoutNodePresent] = (0, $cozmU.useState)(false);
    const [breakoutMode, setBreakoutMode] = (0, $cozmU.useState)(editorView ? (0, $a2cf882edcb3c89a$export$7293881dc293b44d)(editorView.state) : undefined);
    (0, $1KOhB.usePluginStateEffect)(api, [
        'breakout'
    ], ({ breakoutState: breakoutState })=>{
        if (!editorView) return;
        if (breakoutState?.breakoutNode && !breakoutNodePresent) setBreakoutNodePresent(true);
        if (!breakoutState?.breakoutNode && breakoutNodePresent) setBreakoutNodePresent(false);
        const nextBreakoutMode = (0, $a2cf882edcb3c89a$export$7293881dc293b44d)(editorView.state);
        if (nextBreakoutMode !== breakoutMode) setBreakoutMode(nextBreakoutMode);
    });
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    if (interactionState === 'hasNotHadInteraction') return null;
    if (isDragging || isPMDragging) {
        if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) return null;
    }
    const isViewMode = mode === 'view';
    const isEditMode = mode === 'edit';
    return !isViewMode && editorDisabled === false ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0fd7dd3657f1434d$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isLivePage: isEditMode,
        isBreakoutNodePresent: breakoutNodePresent,
        breakoutMode: breakoutMode,
        api: api
    }) : null;
};
const $267f2cb62f6991f2$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return [
                {
                    name: 'breakout-resizing',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $8091fd80d3a27677$export$522e3e76a011a0b1)(api, getIntl, nodeViewPortalProviderAPI, options)
                }
            ];
            return [
                {
                    name: 'breakout',
                    plugin: (props)=>$267f2cb62f6991f2$var$createPlugin(api, props, options?.appearance)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $acWDI.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                const resizingPluginState = (0, $8091fd80d3a27677$export$ca33a310187a5f87).getState(editorState);
                if (!resizingPluginState) return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
                return resizingPluginState;
            }
            const pluginState = (0, $b9859c35f29c69d8$export$18d4026d1ea86bb1).getState(editorState);
            if (!pluginState) return {
                breakoutNode: undefined
            };
            return pluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $582d6f147f320fca$export$ee321e647107007d), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
            // This is a bit crappy, but should be resolved once we move to a static schema.
            if (options && !options.allowBreakoutButton) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($267f2cb62f6991f2$var$LayoutButtonWrapper, {
                api: api,
                mountPoint: popupsMountPoint,
                editorView: editorView,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["breakoutPlugin"] = $267f2cb62f6991f2$export$f56f43f1e6905418;

});

parcelRegister("cud1R", function(module, exports) {

var $c94QJ = parcelRequire("c94QJ");


var $ldqjS = parcelRequire("ldqjS");


var $4EksL = parcelRequire("4EksL");


var $77KCc = parcelRequire("77KCc");


var $44cyU = parcelRequire("44cyU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

function $b58cd291d696d4e1$export$317bc7037b2c3692() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $b58cd291d696d4e1$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $b58cd291d696d4e1$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, $b58cd291d696d4e1$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.shiftTab).common, $b58cd291d696d4e1$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.tab).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveLeft).common, $b58cd291d696d4e1$var$gapCursorSelectLeftParentMediaSingle, list);
    return (0, $44cyU.keymap)(list);
}
const $b58cd291d696d4e1$var$createNewParagraphBelowCaption = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) return (0, $77KCc.createNewParagraphBelow)(state, dispatch);
    return false;
};
const $b58cd291d696d4e1$var$getOutOfCaption = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        if (dispatch) {
            const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(caption.pos + caption.node.nodeSize)));
            dispatch(tr);
        }
        return true;
    }
    return false;
};
const $b58cd291d696d4e1$var$selectParentMediaSingle = (state, dispatch)=>{
    if ((0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection)) {
        const mediaSingleParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent) {
            if (dispatch) {
                const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(mediaSingleParent.pos)));
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
const $b58cd291d696d4e1$var$gapCursorSelectLeftParentMediaSingle = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        const mediaSingleParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent && state.selection.empty && state.tr.doc.resolve(state.selection.from).parentOffset === 0) {
            const gapCursorSelection = (0, $4EksL.GapCursorSelection).findFrom(state.tr.doc.resolve(mediaSingleParent.pos), 0, false);
            if (gapCursorSelection) {
                if (dispatch) {
                    const tr = state.tr.setSelection(gapCursorSelection);
                    dispatch(tr);
                }
                return true;
            }
        }
    }
    return false;
};



var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");





var $4o0zT = parcelRequire("4o0zT");


var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $4iudd = parcelRequire("4iudd");


var $g9sVl = parcelRequire("g9sVl");


var $4aRaM = parcelRequire("4aRaM");


var $88npU = parcelRequire("88npU");

class $72bcb949a9452632$export$77884ce9af78bb82 extends (0, $4aRaM.SelectionBasedNodeView) {
    createDomRef() {
        const domRef = ((0, $1hQ0e.getDocument)() ?? document).createElement('figcaption');
        domRef.setAttribute('data-caption', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = ((0, $1hQ0e.getDocument)() ?? document).createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'caption-wrapper';
        dom.setAttribute('contenteditable', this.pluginInjectionApi?.editorDisabled?.sharedState.currentState()?.editorDisabled ? 'false' : 'true');
        return {
            dom: dom
        };
    }
    // ED-24114: We need to ignore mutations that are not related to the caption node
    // since these mutations can cause an infinite loop in React 18 when using createRoot
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    handleEditorDisabledChanged() {
        if (this.pluginInjectionApi?.editorDisabled) this.cleanupEditorDisabledListener = this.pluginInjectionApi.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    render(_props, forwardRef) {
        const children = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $88npU.default), {
            selected: this.insideSelection(),
            hasContent: this.node.content.childCount > 0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9sVl.NodeViewContentHole), {
                ref: forwardRef
            })
        });
        if (!this.intl || !(0, $4iudd.isSSR)()) return children;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
            value: this.intl,
            children: children
        });
    }
    viewShouldUpdate(nextNode) {
        if (this.node.childCount !== nextNode.childCount) return true;
        const newSelected = this.insideSelection();
        const selectedStateChange = this.selected !== newSelected;
        this.selected = newSelected;
        return selectedStateChange;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, pluginInjectionApi, intl){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate);
        this.selected = this.insideSelection();
        this.cleanupEditorDisabledListener = void 0;
        this.pluginInjectionApi = void 0;
        this.intl = void 0;
        this.pluginInjectionApi = pluginInjectionApi;
        this.intl = intl;
        this.handleEditorDisabledChanged();
    }
}
function $72bcb949a9452632$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl) {
    return (node, view, getPos)=>{
        return new $72bcb949a9452632$export$77884ce9af78bb82(node, view, getPos, portalProviderAPI, eventDispatcher, {}, undefined, undefined, pluginInjectionApi, intl).init();
    };
}



var $aPdNQ = parcelRequire("aPdNQ");

/**
 * DOM spec for the caption node view.
 */ function $6ea7b36fc592eee2$var$toDOM(node) {
    return [
        'figcaption',
        {
            'data-caption': 'true',
            'data-media-caption': 'true',
            'data-testid': 'media-caption',
            ...node.attrs.localId ? {
                'data-local-id': node.attrs.localId
            } : {}
        },
        [
            'div',
            {
                class: 'captionView-content-wrap'
            },
            0
        ]
    ];
}
function $6ea7b36fc592eee2$var$createCaptionDOM(node) {
    return (0, $aPdNQ.DOMSerializer).renderSpec(document, $6ea7b36fc592eee2$var$toDOM(node));
}
class $6ea7b36fc592eee2$export$77884ce9af78bb82 {
    update(node, _decorations, _innerDecorations) {
        if (node.type !== this.node.type) return false;
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    constructor(node){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.node = node;
        const { dom: dom, contentDOM: contentDOM } = $6ea7b36fc592eee2$var$createCaptionDOM(node);
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}
function $6ea7b36fc592eee2$export$f551073b73ccec19() {
    return (node)=>{
        return new $6ea7b36fc592eee2$export$77884ce9af78bb82(node);
    };
}





const $46ec7991c9b12058$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('caption');


const $0c92a5e9920b7504$var$fireAnalytics = (tr, action, analyticsApi)=>{
    analyticsApi?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CAPTION
    })(tr);
};
var $0c92a5e9920b7504$export$2e2bcd8739ae039 = (portalProviderAPI, eventDispatcher, providerFactory, dispatch, pluginInjectionApi, intl)=>{
    const analyticsApi = pluginInjectionApi?.analytics?.actions;
    return new (0, $kpCD8.SafePlugin)({
        appendTransaction (transactions, oldState, newState) {
            // only run for transactions that change selection
            if (!transactions.find((tr)=>tr.selectionSet)) return;
            const newSelection = !newState.selection.eq(oldState.selection);
            const findCaption = (0, $bjg0G.findParentNodeOfType)(oldState.schema.nodes.caption);
            const oldSelectionCaption = findCaption(oldState.selection);
            const { tr: tr } = newState;
            // if selecting away from caption, or selecting a different caption
            if (newSelection && oldSelectionCaption) {
                if (oldSelectionCaption.node.childCount === 0) {
                    tr.delete(oldSelectionCaption.start - 1, oldSelectionCaption.start);
                    tr.setMeta('scrollIntoView', false);
                    $0c92a5e9920b7504$var$fireAnalytics(tr, (0, $krYZG.ACTION).DELETED, analyticsApi);
                    return tr;
                } else {
                    $0c92a5e9920b7504$var$fireAnalytics(tr, (0, $krYZG.ACTION).EDITED, analyticsApi);
                    return tr;
                }
            }
        },
        key: (0, $46ec7991c9b12058$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                caption: (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (0, $6ea7b36fc592eee2$export$f551073b73ccec19)() : (0, $72bcb949a9452632$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl)
            }
        }
    });
};


const $a7f8921f2a545142$var$captionPlugin = ({ api: api })=>{
    return {
        name: 'caption',
        nodes () {
            return [
                {
                    name: 'caption',
                    node: (0, $c94QJ.caption)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'caption',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>(0, $0c92a5e9920b7504$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, getIntl())
                },
                {
                    name: 'captionKeymap',
                    plugin: (0, $b58cd291d696d4e1$export$317bc7037b2c3692)
                }
            ];
        }
    };
};
var $a7f8921f2a545142$export$2e2bcd8739ae039 = $a7f8921f2a545142$var$captionPlugin;
module.exports["default"] = $a7f8921f2a545142$export$2e2bcd8739ae039;

});

parcelRegister("40ukF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $bI2nS = parcelRequire("bI2nS");


var $jGK9e = parcelRequire("jGK9e");


var $k3XQC = parcelRequire("k3XQC");


var $ao034 = parcelRequire("ao034");


var $2WEO5 = parcelRequire("2WEO5");


var $cMyWi = parcelRequire("cMyWi");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $mW7G5 = parcelRequire("mW7G5");


var $azoPw = parcelRequire("azoPw");


var $8Dx7s = parcelRequire("8Dx7s");




const $dc39c5d622176d3d$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $azoPw.blockCardWithLocalId) : (0, $azoPw.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};


/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $dtmRZ = parcelRequire("dtmRZ");





var $7Y8M5 = parcelRequire("7Y8M5");




// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $75ce2aa51e74c7ef$var$LINE_LENGTH = 760;
const $75ce2aa51e74c7ef$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $dtmRZ.embedCardWithLocalId) : (0, $dtmRZ.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $8Dx7s.convertToInlineCss)({
                    margin: $75ce2aa51e74c7ef$var$calcMargin(layout),
                    width: `${Math.ceil($75ce2aa51e74c7ef$var$calcPxFromPct(width / 100, $75ce2aa51e74c7ef$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $75ce2aa51e74c7ef$var$float(layout)
                }),
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};



var $dYkuB = parcelRequire("dYkuB");







const $7e11113c0b6b9b64$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $dYkuB.inlineCardWithLocalId) : (0, $dYkuB.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $8Dx7s.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: "var(--ds-link, #1868DB)",
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};



var $kCECX = parcelRequire("kCECX");

const $ab0973bc4ada0879$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('cardPlugin');


const $28eb8ceae9a9c979$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1), action);
};
const $28eb8ceae9a9c979$export$2b7045d36e3e01d4 = (url)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $28eb8ceae9a9c979$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $28eb8ceae9a9c979$export$af5afab36c1f83f6 = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $28eb8ceae9a9c979$export$3301f76e6efaf85e = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $28eb8ceae9a9c979$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $28eb8ceae9a9c979$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $28eb8ceae9a9c979$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f = (url, attributes)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_RESOLVED_TOOLBAR_ATTRIBUTES',
            url: url,
            attributes: attributes
        });
const $28eb8ceae9a9c979$export$c9a25858ed46807c = (layout)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $28eb8ceae9a9c979$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$83c364d103479f90 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$bd1cd60a9b31da5e = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$2c79f54b873d04be = (modalType)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $28eb8ceae9a9c979$export$e545bc176b552938 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $28eb8ceae9a9c979$export$a2922c2e95ff48f7 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $28eb8ceae9a9c979$export$53e36aa41bbce673 = (tr, datasourceStash)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $28eb8ceae9a9c979$export$4b1fde77584594b5 = (tr, url)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });



var $3u5lg = parcelRequire("3u5lg");


var $73a6g = parcelRequire("73a6g");


var $krYZG = parcelRequire("krYZG");

var $gjFO5 = parcelRequire("gjFO5");

var $eaCAt = parcelRequire("eaCAt");


var $2HZqG = parcelRequire("2HZqG");


var $9bUBT = parcelRequire("9bUBT");


var $fRYCB = parcelRequire("fRYCB");

var $4wRTw = parcelRequire("4wRTw");

var $6SJ6d = parcelRequire("6SJ6d");

var $5Qi6J = parcelRequire("5Qi6J");








var $2Ldzs = parcelRequire("2Ldzs");


var $jkcNT = parcelRequire("jkcNT");




var $hXiLX = parcelRequire("hXiLX");


var $h6b2D = parcelRequire("h6b2D");

function $0462314fb21236fe$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $hXiLX.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}



var $aPdNQ = parcelRequire("aPdNQ");





var $k92Y1 = parcelRequire("k92Y1");








var $b1qV0 = parcelRequire("b1qV0");


const $50d9c959a343ad0a$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $50d9c959a343ad0a$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) return $50d9c959a343ad0a$export$71376de76fa352d1(state.selection.node.type);
};
const $50d9c959a343ad0a$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $50d9c959a343ad0a$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $50d9c959a343ad0a$export$a6fcef6250c64f76 = (node, info)=>$50d9c959a343ad0a$export$fe497395c317d106($50d9c959a343ad0a$export$15bc29504ff06986(node), info);
const $50d9c959a343ad0a$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $50d9c959a343ad0a$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $50d9c959a343ad0a$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $k92Y1.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $50d9c959a343ad0a$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $50d9c959a343ad0a$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $50d9c959a343ad0a$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $50d9c959a343ad0a$export$48ba7bd006cffb5e(node.attrs);
};
const $50d9c959a343ad0a$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $50d9c959a343ad0a$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $50d9c959a343ad0a$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $50d9c959a343ad0a$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $kCECX.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};


/**
 * Attempt to replace the link into the respective card.
 */ function $ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $73a6g.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $0462314fb21236fe$export$f85e921f66e987fa)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $ff2860869594b73b$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>(editorState, dispatch)=>{
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        let cardAdf = null;
        // If an embed card transformer is provided and the resolved card is an embedCard,
        // attempt to transform it into an alternative node representation first.
        if (cardData.type === 'embedCard' && embedCardNodeTransformer && (0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) {
            const transformResult = embedCardNodeTransformer(schema, cardData.attrs);
            // The transformer may return a Promise for async transformations (e.g. short-link expansion).
            // When async, we snapshot the current requests and positions now (before any dispatch),
            // then insert the resolved node and clean up the queue in one transaction once the
            // Promise settles. This avoids the stale-editorState problem: rather than re-running
            // replaceQueuedUrlWithCard with an outdated state snapshot, we capture what we need
            // immediately and apply a targeted insert when ready.
            if (transformResult instanceof Promise) {
                // Snapshot requests now, while the queue still contains this URL.
                const pendingRequests = [
                    ...requests
                ];
                transformResult.then((resolvedNode)=>{
                    if (!dispatch) return;
                    // Build a fresh transaction (editorState is the snapshot at call-time; positions
                    // are mapped through it). For the async case we fall back to cardData if the
                    // transform returned nothing, mirroring what the sync path would do.
                    const asyncCardAdf = resolvedNode ? resolvedNode : (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
                    const asyncTr = editorState.tr;
                    if (asyncCardAdf) pendingRequests.forEach((request)=>$ff2860869594b73b$var$replaceLinksToCards(asyncTr, asyncCardAdf, schema, request));
                    dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(url)((0, $2Ldzs.closeHistory)(asyncTr)));
                });
                return true;
            }
            cardAdf = transformResult ?? null;
        }
        if (!cardAdf) cardAdf = (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $4wRTw.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $2HZqG.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(url)((0, $2Ldzs.closeHistory)(tr)));
        return true;
    };
const $ff2860869594b73b$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $krYZG.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $28eb8ceae9a9c979$export$2b7045d36e3e01d4)(request.url)(tr));
        return true;
    };
/**
 * Per-node walker shared by `queueCardsFromChangedTr` and
 * `queueCardsFromRange`. Pushes a smart-link resolution request for every
 * text node carrying a qualifying `link` mark.
 *
 * Returning `true`/`false` follows the ProseMirror `nodesBetween`/
 * `nodesBetweenChanged` walker contract: `true` to descend into children,
 * `false` to skip subtree.
 */ const $ff2860869594b73b$var$collectLinkRequest = (requests, node, pos, options)=>{
    if (!node.isText) return true;
    const linkMark = node.marks.find((mark)=>mark.type === options.linkMarkType);
    if (linkMark) {
        if (!(0, $0462314fb21236fe$export$f85e921f66e987fa)(node, options.normalizeLinkText)) return false;
        requests.push({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: options.appearance,
            compareLinkText: options.normalizeLinkText,
            source: options.source,
            analyticsAction: options.analyticsAction,
            sourceEvent: options.sourceEvent
        });
    }
    return false;
};
const $ff2860869594b73b$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$86b4b08ffadfa0a6 = (state, tr, from, to, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    const clampedFrom = Math.max(0, from);
    const clampedTo = Math.min(tr.doc.content.size, to);
    if (clampedFrom < clampedTo) tr.doc.nodesBetween(clampedFrom, clampedTo, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $0462314fb21236fe$export$f85e921f66e987fa)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(tr);
};
const $ff2860869594b73b$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $krYZG.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $9bUBT.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $krYZG.ACTION).CHANGED_TYPE
    });
    return (0, $28eb8ceae9a9c979$export$5312e3a17c3f6d3)(requests)(state.tr);
};
const $ff2860869594b73b$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $gjFO5.SMART_LINK_TYPE).URL,
                    previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $ff2860869594b73b$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $50d9c959a343ad0a$export$a5ff7aecd33e6813)(state);
        const tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, href, href);
        $ff2860869594b73b$export$717aabd99c4fc685(state, tr, (0, $krYZG.INPUT_METHOD).MANUAL, (0, $krYZG.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $ff2860869594b73b$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                action: (0, $krYZG.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.unlinkPayload)((0, $krYZG.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $ff2860869594b73b$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $ff2860869594b73b$export$c8301558911030d4(state, (0, $krYZG.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                    action: (0, $krYZG.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $ff2860869594b73b$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock');
        const { from: from, to: to } = state.selection;
        const nodeType = $ff2860869594b73b$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        // If switching to embed appearance, attempt to use a registered transform command
        // to create an alternative node representation (e.g. a native embed).
        if (appearance === 'embed' && (selectedNode.attrs.url || selectedNode.attrs.data?.url)) {
            const cardState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
            const createEmbedCardTransformCommand = cardState?.embedCardTransformers?.createEmbedCardTransformCommand;
            if (createEmbedCardTransformCommand) {
                const transformCommand = createEmbedCardTransformCommand({
                    editorAnalyticsApi: editorAnalyticsApi,
                    augmentTransaction: (augmentTr)=>{
                        $ff2860869594b73b$var$updateDatasourceStash(augmentTr, selectedNode);
                        editorAnalyticsApi?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CHANGED_TYPE,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                newType: appearance,
                                previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
                            }
                        })(augmentTr);
                        (0, $2HZqG.addLinkMetadata)(state.selection, augmentTr, {
                            action: (0, $krYZG.ACTION).CHANGED_TYPE
                        });
                    }
                });
                if (transformCommand(state, dispatch)) return true;
            }
        }
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).CHANGED_TYPE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type)
            }
        })(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: (0, $krYZG.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $ff2860869594b73b$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            const isParametersChange = (0, $iDrrr.fg)('platform_lp_sllv_preserve_assets_columns') && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(oldAttrs.datasource.parameters, newAttrs.datasource.parameters);
            if (isColumnChange || isUrlChange || isParametersChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $28eb8ceae9a9c979$export$4b1fde77584594b5)(tr, node.attrs.url);
    } else (0, $28eb8ceae9a9c979$export$e545bc176b552938)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $28eb8ceae9a9c979$export$e545bc176b552938)(tr);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $50d9c959a343ad0a$export$962cfe99b8da8614)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $ff2860869594b73b$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $50d9c959a343ad0a$export$962cfe99b8da8614)(selectedNode) && !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $28eb8ceae9a9c979$export$53e36aa41bbce673)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};



var $8dxef = parcelRequire("8dxef");


var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");





var $bjg0G = parcelRequire("bjg0G");

const $1ddf8f052569320c$var$lookupPixel = 10;
const $1ddf8f052569320c$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $bjg0G.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $1ddf8f052569320c$var$lookupPixel : coord.bottom + $1ddf8f052569320c$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $bjg0G.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $1ddf8f052569320c$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $1ddf8f052569320c$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $kCECX.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $1ddf8f052569320c$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $8dxef.getBrowserInfo)();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $44cyU.keymap)(list);
}



var $LQnOI = parcelRequire("LQnOI");


var $4iudd = parcelRequire("4iudd");


var $3k3tn = parcelRequire("3k3tn");


var $kpCD8 = parcelRequire("kpCD8");

const $64861730f5bb867e$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $64861730f5bb867e$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';









var $bwuOg = parcelRequire("bwuOg");











var $03RpJ = parcelRequire("03RpJ");





var $Igylv = parcelRequire("Igylv");


var $1jz5K = parcelRequire("1jz5K");

var $KTiWz = parcelRequire("KTiWz");





var $iIYTj = parcelRequire("iIYTj");


var $l8wPz = parcelRequire("l8wPz");


var $QXwxo = parcelRequire("QXwxo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $6U5OC = parcelRequire("6U5OC");


var $3F4bj = parcelRequire("3F4bj");


var $h9Lux = parcelRequire("h9Lux");


var $aK1EY = parcelRequire("aK1EY");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $9f1Yt = parcelRequire("9f1Yt");

const $704a7a694f09cf02$export$2a29ca11e08dc129 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const Provider = cardContext.Provider;
    let t1;
    if ($[0] !== Provider || $[1] !== cardContext.value || $[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Provider, {
            value: cardContext.value
        }, children);
        $[0] = Provider;
        $[1] = cardContext.value;
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Provider, {
        value: cardContext.value
    }, children);
};














const $a975770660f37109$export$797e3658f090919c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    if (!cardContext?.value) return null;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};








/* eslint-disable @repo/internal/react/no-class-components */ 









var $fbHl6 = parcelRequire("fbHl6");


class $2a1fa379fa79b714$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $73a6g.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}





parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $6pnwK = parcelRequire("6pnwK");


const $82719199149a05f4$export$f05434c51e3762e = (editorState)=>(0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
const $82719199149a05f4$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            })),
        resolvedInlineSmartLinks: pluginState.resolvedInlineSmartLinks?.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $82719199149a05f4$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$82719199149a05f4$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $82719199149a05f4$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;


const $82bb9aba23fa33e9$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $82719199149a05f4$export$f05434c51e3762e)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
        data: analyticsData,
        children: children
    });
};


const $22640694ffeeb016$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $22640694ffeeb016$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $22640694ffeeb016$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $a975770660f37109$export$797e3658f090919c), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $704a7a694f09cf02$export$2a29ca11e08dc129), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aK1EY.DatasourceTableViewWithWrappers), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                onWrappedColumnsChange: (0, $iDrrr.fg)('platform_lp_sllv_table_settings_menu') ? this.handleWrappedColumnsChange : undefined,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.handleWrappedColumnsChange = (wrappedColumnKeys)=>{
            const { columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
class $22640694ffeeb016$export$9dd55813d0ee0514 extends (0, $Igylv.default) {
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2a1fa379fa79b714$export$76664c71b9b1a689), {
            unsupportedComponent: (0, $3F4bj.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $64861730f5bb867e$export$32f80df830e375f6),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $h9Lux.calcBreakoutWidth)(attrs.layout || (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($22640694ffeeb016$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.tableWidth = void 0;
        this.isNodeNested = void 0;
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
}







parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");







function $59ddef7452a84f28$export$d59258481d10b16b({ smartCardContext: smartCardContext, children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)()) return children;
    if (!intl || !smartCardContext) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cMyWi.SmartCardContext).Provider, {
            value: smartCardContext,
            children: children
        })
    });
}















var $3k5Tv = parcelRequire("3k5Tv");





var $i1t43 = parcelRequire("i1t43");







parcelRequire("cozmU");




const $83d2b8785968bed7$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children(cardContext)
    });
};


const $537b6f07c48b0136$var$fatalErrorPositionMap = new Map();
const $537b6f07c48b0136$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        return {
            mode: states.editorViewModeState?.mode
        };
    });
    const onClick = (0, $cozmU.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $537b6f07c48b0136$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(this.props.node);
            if (url && !(0, $73a6g.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    href: url,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $8aG6j.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $82719199149a05f4$export$f05434c51e3762e)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($537b6f07c48b0136$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $83d2b8785968bed7$export$722ea04dd4ef208e), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $8aG6j.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $537b6f07c48b0136$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $ff2860869594b73b$export$56a04318a610dc7c)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                if (url && pos) $537b6f07c48b0136$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}


class $6ee1e0f18b66d961$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt,
                    hideIconLoadingSkeleton: true
                }, url),
                this.gapCursorSpan()
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).BLOCK,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $8aG6j.jsx)(cardContext.Provider, {
                    value: cardContext.value,
                    children: cardInner
                }) : data ? cardInner : null
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        };
        this.removeCardDispatched = false;
        this.gapCursorSpan = ()=>{
            const browser = (0, $8dxef.getBrowserInfo)();
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
    }
}
const $6ee1e0f18b66d961$var$WrappedBlockCard = (0, $537b6f07c48b0136$export$60332b2344f7fe41)($6ee1e0f18b66d961$export$780882fb750d3c8d, (0, $KTiWz.default));
class $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0 extends (0, $Igylv.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $50d9c959a343ad0a$export$962cfe99b8da8614)(currentNode);
        const isNewNodeDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($6ee1e0f18b66d961$var$WrappedBlockCard, {
                node: this.node,
                view: this.view,
                getPos: this.getPos,
                actionOptions: actionOptions,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $03RpJ.default)();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $6ee1e0f18b66d961$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $22640694ffeeb016$export$9dd55813d0ee0514)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };















var $1A89X = parcelRequire("1A89X");


var $8kONW = parcelRequire("8kONW");










var $aHoC6 = parcelRequire("aHoC6");




var $4Qu9h = parcelRequire("4Qu9h");


var $4mCw6 = parcelRequire("4mCw6");

var $jsWW5 = parcelRequire("jsWW5");








var $8m50u = parcelRequire("8m50u");







var $11zX6 = parcelRequire("11zX6");








var $anBbz = parcelRequire("anBbz");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $89gPK = parcelRequire("89gPK");

var $b8ZJI = parcelRequire("b8ZJI");

var $76kDm = parcelRequire("76kDm");

var $e3qgT = parcelRequire("e3qgT");

var $bfl0n = parcelRequire("bfl0n");

var $fb9eF = parcelRequire("fb9eF");

var $3GQSw = parcelRequire("3GQSw");

var $h5qPS = parcelRequire("h5qPS");

var $34CLe = parcelRequire("34CLe");
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hNvnn = parcelRequire("hNvnn");

const $5cc79e9089d815ff$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("&>div{", (0, $hNvnn.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");


















var $ieeJu = parcelRequire("ieeJu");

// Layouts where the left handle is the only resize handle today.
// These must keep the left handle.
// Remove during 'platform_editor_lovability_resize_dividers_panels' cleanup
const $a88eb3a81715ccd0$var$leftHandleOnlyLayouts = [
    'wrap-right',
    'align-end'
];
class $a88eb3a81715ccd0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $34CLe.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $34CLe.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
        else return 0, $7Y8M5.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $e3qgT.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $e3qgT.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $7Y8M5.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $11zX6.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $7Y8M5.akEditorMediaResizeHandlerPadding)
        };
        const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const enable = {};
        (0, $bfl0n.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && !$a88eb3a81715ccd0$var$leftHandleOnlyLayouts.includes(layout)) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $fb9eF.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $5cc79e9089d815ff$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3GQSw.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            onResizeStart: this.handleResizeStart,
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $76kDm.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $89gPK.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $b8ZJI.calcMediaPxWidth)({
                origWidth: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.handleResizeStart = ()=>{
            const { view: view, getPos: getPos } = this.props;
            if (typeof getPos === 'function') {
                const pos = getPos();
                if (typeof pos === 'number') {
                    const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                }
            }
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $89gPK.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}
$a88eb3a81715ccd0$export$2e2bcd8739ae039.defaultProps = {
    aspectRatio: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT)
};





const $dc083a8e67906b16$export$d79f14ec3c108fc0 = (url)=>{
    if (url && (0, $8kONW.isConfluenceSlideUrl)(url) && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true)) // Slides have a 16:9 canvas
    return 16 / 9;
    return undefined;
};
const $dc083a8e67906b16$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $dc083a8e67906b16$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $dc083a8e67906b16$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aHoC6.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a88eb3a81715ccd0$export$2e2bcd8739ae039), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $dc083a8e67906b16$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }, url) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $11zX6.EmbedResizeMessageListener), {
                embedIframeRef: this.embedIframeRef,
                onHeightUpdate: this.onHeightUpdate,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$var$CardInner, {
                    pluginInjectionApi: pluginInjectionApi,
                    smartCard: smartCard,
                    hasPreview: hasPreview,
                    getPosSafely: this.getPosSafely,
                    view: view,
                    getLineLength: this.getLineLength,
                    eventDispatcher: this.props.eventDispatcher,
                    updateSize: this.updateSize,
                    getPos: getPos,
                    aspectRatio: aspectRatio,
                    allowResizing: allowResizing,
                    heightAlone: heightAlone,
                    cardProps: cardProps,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                })
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = void 0;
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: resolvedAspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            const aspectRatio = $dc083a8e67906b16$export$d79f14ec3c108fc0(url) ?? resolvedAspectRatio;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT), (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        /**
     * Defers line-length measurement until the embed card DOM has fully rendered.
     *
     * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
     * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
     * Measuring at that moment would cache the bogus width and break resize calculations.
     * Scheduling a measurement on the next animation frame ensures layout has
     * settled. We then force the node view to re-render so `getLineLength`
     * re-runs and captures the correct width.
     */ this.scheduleLineLengthRemeasureRaf = (0, $LQnOI.default)((view)=>{
            if (view) this.forceUpdate();
        });
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $4mCw6.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        };
        /**
     * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
     * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
     * we will show embed window of appropriate size and avoid unnecessary content jumping.
     */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.removeCardDispatched = false;
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
}
const $dc083a8e67906b16$export$a2e44368c194a658 = (props)=>{
    const width = (0, $4Qu9h.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ee1e0f18b66d961$export$780882fb750d3c8d), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $dc083a8e67906b16$var$WrappedEmbedCardWithCondition = (0, $8m50u.componentWithCondition)(()=>(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $dc083a8e67906b16$export$a2e44368c194a658, $dc083a8e67906b16$export$61b2782f78272a37);
const $dc083a8e67906b16$var$WrappedEmbedCard = (0, $537b6f07c48b0136$export$60332b2344f7fe41)($dc083a8e67906b16$var$WrappedEmbedCardWithCondition, (0, $KTiWz.default));
class $dc083a8e67906b16$export$6789d7ecdc77631b extends (0, $Igylv.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($dc083a8e67906b16$var$WrappedEmbedCard, {
                node: this.node,
                view: this.view,
                eventDispatcher: eventDispatcher,
                getPos: this.getPos,
                allowResizing: allowResizing,
                fullWidthMode: fullWidthMode,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $03RpJ.default)();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $dc083a8e67906b16$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        return new $dc083a8e67906b16$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };

































var $b2XFx = parcelRequire("b2XFx");





var $8OcYi = parcelRequire("8OcYi");


var $esGL2 = parcelRequire("esGL2");


var $4aNe4 = parcelRequire("4aNe4");

var $7jfHQ = parcelRequire("7jfHQ");

var $i4lJP = parcelRequire("i4lJP");


var $f21H2 = parcelRequire("f21H2");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 













var $f9XbP = parcelRequire("f9XbP");

const $215d271c3bef94e8$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $215d271c3bef94e8$export$4521957a9ae858f5 = 'discovered';
const $215d271c3bef94e8$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $215d271c3bef94e8$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $215d271c3bef94e8$export$2cf27d95188f1c13 = 86400000;
const $215d271c3bef94e8$var$storageClient = new (0, $f9XbP.StorageClient)($215d271c3bef94e8$export$c0fd7e3ed450d078);
const $215d271c3bef94e8$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $215d271c3bef94e8$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $215d271c3bef94e8$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $215d271c3bef94e8$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $215d271c3bef94e8$var$storageClient.setItemWithExpiry(key, $215d271c3bef94e8$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};


const $699123311af2c8a1$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $cozmU.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $cozmU.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $cozmU.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $cozmU.useMemo)(()=>isPulseEnabled && !(0, $215d271c3bef94e8$export$f029a1bf9ca298da)((0, $215d271c3bef94e8$export$b1ab83c904a5352e)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $699123311af2c8a1$export$2e2bcd8739ae039 = $699123311af2c8a1$var$useLinkUpgradeDiscoverability;










var $9DHhW = parcelRequire("9DHhW");

/* Pulse.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");




const $c8934d820601fbf2$var$pulseKeyframes = null;
const $c8934d820601fbf2$var$pulseStyles = null;
const $c8934d820601fbf2$var$commonStyles = null;
const $c8934d820601fbf2$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $cozmU.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $hekY6.default)([
            "_3iDTPbS8kF",
            pulseStarted.current && "",
            pulseStarted.current && "_0bjKvDzXzM _2OUyjtJ2Jm _1gBibyTOhH _0nFVCGiKXs _43vdfT87jn _03m2ny7LI7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onAnimationIteration: stopPropagation,
        onAnimationStart: stopPropagation
    }, children));
};



const $61088fb587c1a22d$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $215d271c3bef94e8$export$f029a1bf9ca298da)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $cozmU.useCallback)(()=>{
        if (!discovered) (0, $215d271c3bef94e8$export$6b9d1ae5ec92c88e)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c8934d820601fbf2$export$927d63e2511364c0), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};


function $030ee9b1d7c0f9ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $030ee9b1d7c0f9ec$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $030ee9b1d7c0f9ec$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, url: url, appearance: appearance })=>{
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $699123311af2c8a1$export$2e2bcd8739ae039)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $215d271c3bef94e8$export$f029a1bf9ca298da)((0, $215d271c3bef94e8$export$b1ab83c904a5352e))) (0, $215d271c3bef94e8$export$6b9d1ae5ec92c88e)((0, $215d271c3bef94e8$export$613f4cbb1d6327d6));
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: shouldShowLinkPulse && $030ee9b1d7c0f9ec$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                attributes: (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $61088fb587c1a22d$export$1f5748a1623673d7), {
            localStorageKey: (0, $215d271c3bef94e8$export$613f4cbb1d6327d6),
            localStorageKeyExpirationInMs: (0, $215d271c3bef94e8$export$2cf27d95188f1c13),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, children))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        children,
        isInline,
        placeholderUniqId
    ]);
};









var $gybyF = parcelRequire("gybyF");

const $92832cf5d4953875$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $gybyF.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $cozmU.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $cozmU.useCallback)(()=>{
        try {
            preview?.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children({
            canPreview: !!preview,
            invokePreview: invokePreview
        })
    });
};




































parcelRequire("cozmU");










var $jU5kz = parcelRequire("jU5kz");

var $gjTdl = parcelRequire("gjTdl");





var $83k8i = parcelRequire("83k8i");



var $2xhuI = parcelRequire("2xhuI");

var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");


var $l3s1y = parcelRequire("l3s1y");


var $g6uqx = parcelRequire("g6uqx");





var $jaFVy = parcelRequire("jaFVy");











var $eDtFr = parcelRequire("eDtFr");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");


var $V3JOP = parcelRequire("V3JOP");


var $11OF7 = parcelRequire("11OF7");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $4hfky = parcelRequire("4hfky");








var $gbf0M = parcelRequire("gbf0M");


var $bI14T = parcelRequire("bI14T");


var $4ez2K = parcelRequire("4ez2K");






parcelRequire("cozmU");


var $3PHGt = parcelRequire("3PHGt");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");

const $ca4324df41e9ccf2$var$wrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $ca4324df41e9ccf2$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kA6Zo.Flex), {
        xcss: $ca4324df41e9ccf2$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))), {
            label: props?.label
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


const $7ee17a04603997de$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $cozmU.useState)(undefined);
    const [parameters, setParameters] = (0, $cozmU.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $cozmU.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};


function $fee70d3190aaad52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fee70d3190aaad52$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $cozmU.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $ff2860869594b73b$export$113cdaf1b279f308)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $k3XQC.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
        css: $fee70d3190aaad52$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ca4324df41e9ccf2$export$8819453811a57211), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $fee70d3190aaad52$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)($fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};

















var $3FyXx = parcelRequire("3FyXx");





var $2VYYv = parcelRequire("2VYYv");







function $49f259ed34811056$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3FyXx.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $49f259ed34811056$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $28eb8ceae9a9c979$export$bd1cd60a9b31da5e)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($49f259ed34811056$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $28eb8ceae9a9c979$export$bd1cd60a9b31da5e)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $iEFx5.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $49f259ed34811056$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $kCECX.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $28eb8ceae9a9c979$export$83c364d103479f90)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $49f259ed34811056$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(view.state));
            return /*#__PURE__*/ (0, $8aG6j.jsx)($49f259ed34811056$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $krYZG.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $ff2860869594b73b$export$884fcee347ca969b)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $49f259ed34811056$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker, linkPickerOptions)=>{
    if (!showLinkingToolbar) return {};
    return {
        height: linkPickerOptions?.popupHeight ?? (lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX)),
        width: linkPickerOptions?.popupWidth ?? (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        // forcePlacement is always true to prevent the popup from rendering off-screen
        forcePlacement: true
    };
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
















var $huoxr = parcelRequire("huoxr");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");





var $9d7Pd = parcelRequire("9d7Pd");












var $4EZEs = parcelRequire("4EZEs");


const $e5629c0e58eb7677$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $4EZEs.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $3u1Hp = parcelRequire("3u1Hp");

const $a8f1460a9920d336$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $3u1Hp.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





































const $57525b57aab09e0a$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $57525b57aab09e0a$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e5629c0e58eb7677$export$687401cc190b9ec3)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                ariaLabel: areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $57525b57aab09e0a$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $57525b57aab09e0a$export$2e2bcd8739ae039 = $57525b57aab09e0a$var$EditToolbarButtonPresentation;


const $f6409fd8f1fd2ba8$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $cozmU.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $e5629c0e58eb7677$export$687401cc190b9ec3)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $50d9c959a343ad0a$export$bab6ff782a349bd3)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $f6409fd8f1fd2ba8$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $57525b57aab09e0a$export$2e2bcd8739ae039), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $cozmU.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $a8f1460a9920d336$export$25222ec28f4cbba5)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $57525b57aab09e0a$export$2e2bcd8739ae039), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};




































var $gxKDp = parcelRequire("gxKDp");

const $fff22d9fe7ec96c7$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





var $7joZr = parcelRequire("7joZr");




function $a737b0b67ea1264f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $a737b0b67ea1264f$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $a737b0b67ea1264f$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $a737b0b67ea1264f$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: disabled ? $a737b0b67ea1264f$var$disallowedWrapperStyle : $a737b0b67ea1264f$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $a737b0b67ea1264f$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $a737b0b67ea1264f$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $a737b0b67ea1264f$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $lOiVq.jsx)($a737b0b67ea1264f$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            css: disabled ? $a737b0b67ea1264f$var$buttonStyleNoneEvent : $a737b0b67ea1264f$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};








var $iso5o = parcelRequire("iso5o");










class $311c13dda34631e5$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83d2b8785968bed7$export$722ea04dd4ef208e), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $bI2nS.messages).embed),
                onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $bI2nS.messages).block),
                onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $bI2nS.messages).url),
                    onClick: (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $krYZG.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $bI2nS.messages).inline),
                    onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a737b0b67ea1264f$export$41ba5f90e13b0c51), {
                options: options.map((option)=>(0, $fff22d9fe7ec96c7$export$9de0d67eaa25f178)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $cc2f82b3700a9ffb$export$ddeab6943680f5be)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url || '', currentAppearance || null, cardContext?.store);
                return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gBjHb.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61088fb587c1a22d$export$1f5748a1623673d7), {
                        localStorageKey: (0, $215d271c3bef94e8$export$b1ab83c904a5352e),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                }));
            }
            return LinkToolbarButtons;
        };
    }
}
const $311c13dda34631e5$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $2xhuI.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        return intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $2xhuI.default).defaultBlockNode)
        });
    }
};


function $61781900f6775ac5$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        ]
    });
}

































parcelRequire("cozmU");











parcelRequire("cozmU");




const $4047da273e09ef71$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};




















var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");








parcelRequire("cozmU");






















const $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9 = {
    title: (0, $bI2nS.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))
};
const $ced5d6f40b3ce51c$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $ff2860869594b73b$export$113cdaf1b279f308)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))({
            label: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle)
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle));
};



const $8f28eb0ccb03280c$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $bI2nS.messages).embed),
        onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $311c13dda34631e5$export$74e77d31eb18de27)(editorState, intl),
        description: (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $bI2nS.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $bI2nS.messages).block),
        onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $311c13dda34631e5$export$74e77d31eb18de27)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $bI2nS.messages).url),
            onClick: (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $krYZG.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $bI2nS.messages).inline),
            onClick: (0, $ff2860869594b73b$export$a188ef61ddbb94f)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $4047da273e09ef71$export$1405b80fcb4301ca)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $6IL1T.default), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                            iconBefore: option.icon,
                            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            description: option.description,
                            shouldDescriptionWrap: true,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ced5d6f40b3ce51c$export$b08a863b9d82986d), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            'href' in settingsConfig && settingsConfig.href && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: settingsConfig.href,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $iEFx5.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $8f28eb0ccb03280c$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $8aG6j.jsx)($8f28eb0ccb03280c$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9) : (0, $gxKDp.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};


const $f03f24584f0ca413$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const containerRef = (0, $cozmU.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            // eslint-disable-line no-unused-vars
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $gxKDp.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: title
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                arrowKeyNavigationProviderOptions: {
                    type: (0, $9RT19.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8f28eb0ccb03280c$export$6ce0ca681c51cdfb), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                })
            }),
            !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar)) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar))
            })
        ]
    });
};
const $f03f24584f0ca413$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($f03f24584f0ca413$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};



















const $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b = ({ url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorView: editorView, onClick: onClick, title: title })=>{
    const destinationUrl = (0, $f21H2.useSmartLinkDestinationUrl)(url);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick(editorView.state, editorView.dispatch);
    }, [
        editorView,
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "hyperlink-open-link",
        title: title,
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: ""
        }),
        href: destinationUrl,
        target: "_blank",
        onClick: handleClick,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};





parcelRequire("cozmU");











var $gDx2k = parcelRequire("gDx2k");








var $iMnC5 = parcelRequire("iMnC5");



var $1l0kj = parcelRequire("1l0kj");













var $1f3d721a90b66bdf$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $1f3d721a90b66bdf$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});


function $735ee273a357b497$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $735ee273a357b497$export$26ada819291bd8df = (node)=>{
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type)) return true;
    return $735ee273a357b497$var$hasLinkMark(node);
};
function $735ee273a357b497$export$d3d4c2526aede29a(node) {
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE;
    if ($735ee273a357b497$export$26ada819291bd8df(node)) return (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK;
    return null;
}
function $735ee273a357b497$export$599e1b655555ab1d(node) {
    const appearance = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $735ee273a357b497$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $735ee273a357b497$var$hasLinkMark = (node)=>{
    return !!$735ee273a357b497$var$getLinkMark(node);
};
function $735ee273a357b497$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $735ee273a357b497$var$getLinkMark(node)?.attrs?.href;
}
const $735ee273a357b497$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $735ee273a357b497$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $735ee273a357b497$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $735ee273a357b497$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($735ee273a357b497$export$94df0e59ebebf4a7(a.node) !== $735ee273a357b497$export$94df0e59ebebf4a7(b.node) || $735ee273a357b497$export$599e1b655555ab1d(a.node) !== $735ee273a357b497$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};


const $d66c3a4348634727$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $bI14T.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
    const cardState = store?.getState()[url];
    if (cardState) {
        const ari = (0, $4aNe4.getObjectAri)(cardState.details);
        const name = (0, $i4lJP.getObjectName)(cardState.details);
        const iconUrl = (0, $7jfHQ.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && isPreviewPanelAvailable?.({
            ari: ari
        });
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) openPreviewPanel({
                url: url,
                ari: ari,
                name: name || '',
                iconUrl: iconUrl,
                panelData: {
                    embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                }
            });
            editorAnalyticsApi?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, display, store)
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $91WyP.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            as: "span",
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
                    label: "",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                })
            ]
        });
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            gap: "space.050",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hfky.default), {
                testId: "open-preview-panel-floating-toolbar-button",
                onClick: handleOpenGlancePanelClick,
                icon: icon,
                title: title,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        });
    }
    return null;
};


















const $32749362d6e128b7$var$areResolvedAttributesEqual = (current, next)=>current?.displayCategory === next?.displayCategory && current?.extensionKey === next?.extensionKey && current?.status === next?.status && current?.statusDetails === next?.statusDetails;
/**
 * Handles firing the toolbar viewed event
 */ const $32749362d6e128b7$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext, editorView: editorView })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $cozmU.useEffect)(()=>{
        const resolvedAttributes = (0, $50d9c959a343ad0a$export$a0e5429851d8d8a9)(url, display, store);
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...resolvedAttributes,
                display: display
            }
        }).fire('media');
        if (!editorView) return;
        const currentResolvedAttributes = (0, $82719199149a05f4$export$f05434c51e3762e)(editorView.state)?.resolvedToolbarAttributesByUrl[url];
        if ($32749362d6e128b7$var$areResolvedAttributesEqual(currentResolvedAttributes, resolvedAttributes)) return;
        editorView.dispatch((0, $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f)(url, resolvedAttributes)(editorView.state.tr));
    }, [
        createAnalyticsEvent,
        display,
        editorView,
        url,
        store
    ]);
    return null;
};
const $32749362d6e128b7$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $8aG6j.jsx)($32749362d6e128b7$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext,
            editorView: editorView
        }) : null
    });
};


const $cc2f82b3700a9ffb$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $gjTdl.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $bjg0G.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $krYZG.ACTION).DELETED
    });
const $cc2f82b3700a9ffb$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod, resolvedAttributes)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod, resolvedAttributes))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics = (editorAnalyticsApi, inputMethod, resolvedAttributes = {})=>(state, dispatch)=>{
        const linkAnalyticsRecorded = $cc2f82b3700a9ffb$export$7ee76be08aa43a42(editorAnalyticsApi, inputMethod, resolvedAttributes)(state, dispatch);
        if (!linkAnalyticsRecorded) return false;
        editorAnalyticsApi?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).OPEN_LINK,
            attributes: {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
        return true;
    };
const $cc2f82b3700a9ffb$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $64861730f5bb867e$export$863ae87a9d233606) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $bI2nS.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $l3s1y.richMediaClassName)}`);
                    if (!(0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $cc2f82b3700a9ffb$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $49f259ed34811056$export$acaefd190fd8ff4d)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled, linkPickerOptions)
        };
    };
};
const $cc2f82b3700a9ffb$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $gjTdl.commandWithMetadata)((0, $ff2860869594b73b$export$23c9e012c8c1ce24)(text, editorAnalyticsApi), {
        action: (0, $krYZG.ACTION).UNLINK
    });
    return ()=>false;
};
const $cc2f82b3700a9ffb$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $jU5kz.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $jU5kz.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $cc2f82b3700a9ffb$var$withToolbarMetadata = (command)=>(0, $gjTdl.commandWithMetadata)(command, {
        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
    });
const $cc2f82b3700a9ffb$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $cc2f82b3700a9ffb$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $50d9c959a343ad0a$export$15bc29504ff06986)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $73a6g.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $50d9c959a343ad0a$export$a6fcef6250c64f76)(node, (0, $50d9c959a343ad0a$export$f3f2332ef0853029)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
        const currentAppearance = (0, $50d9c959a343ad0a$export$71376de76fa352d1)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
        const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $49f259ed34811056$export$dec3901e38d4e7ff)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $cc2f82b3700a9ffb$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                    showTitle: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $jaFVy.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d66c3a4348634727$export$9ed3225219cdbbe9), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ];
            const resolvedToolbarAttributes = url ? pluginState?.resolvedToolbarAttributesByUrl[url] ?? {} : {};
            const openLinkToolbarItemFallback = {
                id: 'editor.link.openLink',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                metadata: metadata,
                className: 'hyperlink-open-link',
                title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                href: url,
                target: '_blank'
            };
            const openLinkToolbarItem = {
                type: 'custom',
                fallback: [
                    openLinkToolbarItemFallback
                ],
                render: (editorView)=>editorView && url ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b), {
                        url: url,
                        title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                        editorView: editorView,
                        onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }) : null
            };
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                {
                    type: 'separator'
                },
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $2xhuI.default).remove),
                    onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $cc2f82b3700a9ffb$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        }, "link-appearance")
                } : (0, $8f28eb0ccb03280c$export$1faf5b64d0bbe935)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                                    label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $7Y8M5.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $2xhuI.default).delete),
                                onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                    label: intl.formatMessage((0, $2xhuI.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $cc2f82b3700a9ffb$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $cc2f82b3700a9ffb$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).settingsLink),
        onClick: $cc2f82b3700a9ffb$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $9bUBT.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $cc2f82b3700a9ffb$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    toolbarItems.push(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(node?.attrs?.url, currentAppearance ?? 'url'));
    const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $311c13dda34631e5$export$2a8c6fb42753b13e), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fee70d3190aaad52$export$76de8066d79563a4), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $8f28eb0ccb03280c$export$1faf5b64d0bbe935)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
    const pluginState = (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(state);
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $49f259ed34811056$export$c389e1daeae312a9)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        const openLinkToolbarItemFallback = {
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
            onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
            href: node.attrs.url,
            target: '_blank'
        };
        toolbarItems.push({
            type: 'custom',
            fallback: [
                openLinkToolbarItemFallback
            ],
            render: (editorView)=>editorView ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b), {
                    url: node.attrs.url,
                    title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                    editorView: editorView,
                    onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }) : null
        });
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $2xhuI.default).remove),
        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                            label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $2xhuI.default).delete),
                        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: intl.formatMessage((0, $2xhuI.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $cc2f82b3700a9ffb$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $cc2f82b3700a9ffb$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6409fd8f1fd2ba8$export$4f24788e7d04736b), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                showTitle: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            const hyperlinkAppearance = [
                (0, $f03f24584f0ca413$export$5b48c4cfa5ad82e1)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $32749362d6e128b7$export$998ac2a59a1547dd), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61781900f6775ac5$export$33d351e602b13f5c), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $cc2f82b3700a9ffb$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) return [
            {
                type: 'separator'
            },
            $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };


const $197bf7f94b28aafe$export$aff6291803939b05 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $cozmU.useRef)((0, $03RpJ.default)());
    const removeCardDispatched = (0, $cozmU.useRef)(false);
    const { getState: getSmartlinkState } = cardContext?.value?.store || {};
    const cardState = getSmartlinkState?.()[url || ''];
    (0, $cozmU.useEffect)(()=>{
        const id = refId.current;
        removeCardDispatched.current = false;
        return ()=>{
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_inline_card_dispatch_guard') && removeCardDispatched.current) return;
            removeCardDispatched.current = true;
            const { tr: tr } = view.state;
            (0, $28eb8ceae9a9c979$export$3301f76e6efaf85e)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $cozmU.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $1jz5K.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $cozmU.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $LQnOI.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $28eb8ceae9a9c979$export$af5afab36c1f83f6)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $cozmU.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $cozmU.useCallback)((event, data)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $cc2f82b3700a9ffb$export$7ee76be08aa43a42)(editorAnalyticsApi, (0, $krYZG.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open(data?.destinationUrl ?? url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $cozmU.useMemo)(()=>{
        if ((isPageSSRed || cardState) && url) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QXwxo.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        }, url);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardState
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $8aG6j.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});


const $83775087cda75ea7$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $83775087cda75ea7$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isInserted, setIsInserted] = (0, $cozmU.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $cozmU.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const destinationUrl = (0, $f21H2.useSmartLinkDestinationUrl)(node.attrs.url);
    const onResolve = (0, $cozmU.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
        if (metadata && metadata.type === 'REGISTER') (0, $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $cozmU.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $cozmU.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $83775087cda75ea7$var$selector);
    const floatingToolbarNode = selection instanceof (0, $kCECX.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node;
    const innerCardWithOpenButtonOverlay = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2XFx.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            destinationUrl: destinationUrl,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                provider: provider,
                pluginInjectionApi: pluginInjectionApi,
                disablePreviewPanel: true
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi,
        destinationUrl
    ]);
    const innerCardOriginal = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $cozmU.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless;
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view') {
        const url = node.attrs.url;
        const cardState = cardContext?.value?.store?.getState()[url];
        if (cardState) {
            const ari = (0, $4aNe4.getObjectAri)(cardState.details);
            const name = (0, $i4lJP.getObjectName)(cardState.details);
            const iconUrl = (0, $7jfHQ.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
                ari: ari
            });
            const openPreviewPanel = cardContext?.value?.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                const store = cardContext?.value?.store;
                const urlState = store?.getState()[url || ''];
                if (pluginInjectionApi?.analytics?.actions) pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HOVER_LABEL,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        previewType: previewType,
                        destinationProduct: urlState?.details?.meta?.product ?? null,
                        destinationSubproduct: urlState?.details?.meta?.subproduct ?? null
                    }
                });
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $92832cf5d4953875$export$a43fddf3dfb4c066), {
                url: url,
                appearance: "inline",
                children: ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                    const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                    // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                    // otherwise a use can click on smartlink itself to open the link in a new tab.
                    const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                    // When inside preview panel iframe, hide the overlay button
                    const isInPreviewPanel = (0, $esGL2.isWithinPreviewPanelIFrame)();
                    const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                    if (isPreviewAvailable) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b2XFx.default), {
                        isVisible: isResolvedViewRendered,
                        url: url,
                        destinationUrl: destinationUrl,
                        compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
                        view: view,
                        showPanelButton: showPanelButton,
                        showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: (event)=>{
                            if (isPreviewPanelAvailable) {
                                event.preventDefault();
                                openPreviewPanel?.({
                                    url: url,
                                    ari: ari || '',
                                    name: name || '',
                                    iconUrl: iconUrl,
                                    panelData: {
                                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                                    }
                                });
                                firePreviewPanelClickEvent({
                                    previewType: 'panel'
                                });
                            } else if (isPreviewModalAvailable) {
                                event.preventDefault();
                                invokePreview?.();
                                firePreviewPanelClickEvent({
                                    previewType: 'modal'
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                            node: node,
                            view: view,
                            getPos: getPos,
                            useAlternativePreloader: useAlternativePreloader,
                            actionOptions: actionOptions,
                            onResolve: onResolve,
                            onClick: onClick,
                            cardContext: cardContext,
                            isHovered: isHovered,
                            isPageSSRed: isPageSSRed,
                            provider: provider,
                            pluginInjectionApi: pluginInjectionApi,
                            showHoverPreview: mode === 'view' && showHoverPreview,
                            disablePreviewPanel: true
                        })
                    });
                    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $197bf7f94b28aafe$export$aff6291803939b05), {
                        node: node,
                        view: view,
                        getPos: getPos,
                        useAlternativePreloader: useAlternativePreloader,
                        actionOptions: actionOptions,
                        onResolve: onResolve,
                        onClick: onClick,
                        cardContext: cardContext,
                        isHovered: isHovered,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        pluginInjectionApi: pluginInjectionApi,
                        showHoverPreview: mode === 'view' && showHoverPreview
                    });
                }
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $030ee9b1d7c0f9ec$export$cc11bcf19366e14b), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});


const $04040245a0d353eb$var$WrappedInlineCardWithAwareness = (0, $537b6f07c48b0136$export$60332b2344f7fe41)((0, $83775087cda75ea7$export$2b341c5236b55a2), (0, $3F4bj.default));
const $04040245a0d353eb$var$selectorWithCard = (states)=>({
        mode: states.editorViewModeState?.mode,
        resolvedInlineSmartLinks: states.cardState?.resolvedInlineSmartLinks
    });
function $04040245a0d353eb$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, intl: intl, smartCardContext: smartCardContext } = props;
    const { mode: mode, resolvedInlineSmartLinks: resolvedInlineSmartLinks } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode',
        'card'
    ], $04040245a0d353eb$var$selectorWithCard);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $8aG6j.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    (0, $cozmU.useEffect)(()=>{
        provider?.then((providerInstance)=>{
            providerInstance.refreshCache?.(props.node);
        });
    }, [
        provider,
        props.node
    ]);
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const isChangeboardTarget = linkPosition !== undefined && resolvedInlineSmartLinks?.[0]?.pos === linkPosition;
    const inlineCardContent = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($04040245a0d353eb$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $50d9c959a343ad0a$export$ea8b03e32bcc0b2d)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            CompetitorPromptComponent
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $59ddef7452a84f28$export$d59258481d10b16b), {
        intl: intl,
        smartCardContext: smartCardContext,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).INLINE,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
            isChangeboardTarget: isChangeboardTarget,
            children: inlineCardContent
        })
    });
}
const $04040245a0d353eb$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };



const $5a0a9ec159d3141a$export$cd3f6a9b84ab8435 = (props)=>{
    return (0, $04040245a0d353eb$export$ebfb9e1798b8aa0e)(props);
};



var $73Kv0 = parcelRequire("73Kv0");


var $kVd8s = parcelRequire("kVd8s");





var $brzQy = parcelRequire("brzQy");


var $gWBVp = parcelRequire("gWBVp");

var $2w79Z = parcelRequire("2w79Z");


var $eOaGc = parcelRequire("eOaGc");





const $0689742eae39d3a4$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $0689742eae39d3a4$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $0689742eae39d3a4$var$isTransactionResolveReplace(tr);
    const isAutoConvert = $0689742eae39d3a4$var$isAutoConvertTr(tr);
    // History
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $0689742eae39d3a4$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $eOaGc.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $735ee273a357b497$export$c63a892fcfc539bc)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $735ee273a357b497$export$c63a892fcfc539bc)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $735ee273a357b497$export$dbc52ec0d340ce50)(before, oldStart, oldEnd, (node)=>!!(0, $735ee273a357b497$export$d3d4c2526aede29a)(node)));
            // Inserted
            insertedInRange.push(...(0, $735ee273a357b497$export$dbc52ec0d340ce50)(after, newStart, newEnd, (node)=>!!(0, $735ee273a357b497$export$d3d4c2526aede29a)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $0689742eae39d3a4$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet.
		 * Also skip when the transaction is an auto-convert
		 * (e.g. a pasted link being converted to a native embed extension),
		 * because the link is being converted, not deleted by the user.
		 */ if (!isResolveReplace && !isAutoConvert) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $0689742eae39d3a4$var$getResolvePositions(tr, state);
        inserted.push(...(0, $735ee273a357b497$export$7ea2145b3909e5c6)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $735ee273a357b497$export$1f3592a520a7960d)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $0689742eae39d3a4$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(removed[i].node);
            const currentSubject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(inserted[i].node);
            if ($0689742eae39d3a4$var$isDatasourceUpgrade(previousSubject, currentSubject) || $0689742eae39d3a4$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $0689742eae39d3a4$var$UPDATE_ACTIONS = [
    (0, $krYZG.ACTION).CHANGED_TYPE,
    (0, $krYZG.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $0689742eae39d3a4$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $0689742eae39d3a4$var$UPDATE_ACTIONS.includes(action);
    });
};
const $0689742eae39d3a4$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $0689742eae39d3a4$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    return $0689742eae39d3a4$var$isMetadataQueue(pluginMeta);
};
const $0689742eae39d3a4$var$isMetadataQueue = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $0689742eae39d3a4$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    return $0689742eae39d3a4$var$isMetadataResolve(pluginMeta);
};
/**
 * Checks if the transaction is an auto-convert action
 * (e.g. a pasted link being converted to a native embed extension node).
 * In this case the link removal should not be tracked as a deletion.
 */ const $0689742eae39d3a4$var$isAutoConvertTr = (tr)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        return step.getMetadata().cardAction === 'AUTO_CONVERT';
    });
};
const $0689742eae39d3a4$var$isMetadataResolve = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $0689742eae39d3a4$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $0689742eae39d3a4$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    if (!$0689742eae39d3a4$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $0689742eae39d3a4$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $82719199149a05f4$export$f05434c51e3762e)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
    if (!$0689742eae39d3a4$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $0689742eae39d3a4$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $82719199149a05f4$export$f05434c51e3762e)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $0689742eae39d3a4$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE && currentSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK;
const $0689742eae39d3a4$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK && currentSubject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE;
function $0689742eae39d3a4$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $kVd8s.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
        const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $0689742eae39d3a4$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $735ee273a357b497$export$599e1b655555ab1d)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $735ee273a357b497$export$d3d4c2526aede29a)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED);
        pushEvents(inserted, (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}






const $763d543a43740aab$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];


const $d456c0380d476625$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $bjg0G.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $d456c0380d476625$export$8467cbb601c13bfc = (layout)=>{
    return (0, $763d543a43740aab$export$3f155c85880510c8).some((l)=>l === layout);
};





const $9a3e82568f11edf8$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $9a3e82568f11edf8$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $9a3e82568f11edf8$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $9a3e82568f11edf8$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $9a3e82568f11edf8$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $9a3e82568f11edf8$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $9a3e82568f11edf8$var$setResolvedToolbarAttributes = (state, action)=>{
    return {
        ...state,
        resolvedToolbarAttributesByUrl: {
            ...state.resolvedToolbarAttributesByUrl,
            [action.url]: action.attributes
        }
    };
};
const $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $9a3e82568f11edf8$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $9a3e82568f11edf8$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $9a3e82568f11edf8$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $9a3e82568f11edf8$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $9a3e82568f11edf8$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $9a3e82568f11edf8$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $9a3e82568f11edf8$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $9a3e82568f11edf8$var$queue(state, action);
        case 'SET_PROVIDER':
            return $9a3e82568f11edf8$var$setProvider(state, action);
        case 'RESOLVE':
            return $9a3e82568f11edf8$var$resolve(state, action);
        case 'REGISTER':
            return $9a3e82568f11edf8$var$register(state, action);
        case 'REMOVE_CARD':
            return $9a3e82568f11edf8$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $9a3e82568f11edf8$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setDatasourceTableRef(state, action);
        case 'SET_RESOLVED_TOOLBAR_ATTRIBUTES':
            return $9a3e82568f11edf8$var$setResolvedToolbarAttributes(state, action);
        case 'SET_CARD_LAYOUT':
            return $9a3e82568f11edf8$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $9a3e82568f11edf8$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $9a3e82568f11edf8$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$removeDatasourceStash(state, action);
    }
};









const $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $2w79Z.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $1552bb88269ab2b0$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>{
    const isEmbedFriendlyLocation = $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($1552bb88269ab2b0$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer), $1552bb88269ab2b0$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $1552bb88269ab2b0$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $k3XQC.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $1552bb88269ab2b0$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer)=>(resolvedCard)=>{
        $1552bb88269ab2b0$var$updateCardType(resolvedCard, options);
        (0, $ff2860869594b73b$export$78f5a0da64579d3e)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)(view.state, view.dispatch);
        return resolvedCard;
    };
const $1552bb88269ab2b0$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $ff2860869594b73b$export$2bb01cc4a12e0b44)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $1552bb88269ab2b0$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $28eb8ceae9a9c979$export$1572b3eade6662f9)(cardProvider)(state.tr));
    });
};




const $ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
// Only the first resolved inline smart link is needed for PO spotlight targeting
const $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS = 1;
const $ce69229594a80c43$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $82719199149a05f4$export$f05434c51e3762e)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $28eb8ceae9a9c979$export$a2922c2e95ff48f7)(tr);
        view.dispatch(tr);
    }
};
const $ce69229594a80c43$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, smartCardContext: smartCardContext, embedCardTransformers: embedCardTransformers } = options;
        const intl = pmPluginFactoryParams.getIntl();
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $3k3tn.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $04040245a0d353eb$export$2626b4e17577ac62),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : CompetitorPrompt,
                intl: intl,
                smartCardContext: smartCardContext
            }
        });
        return new (0, $kpCD8.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        resolvedToolbarAttributesByUrl: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        embedCardTransformers: embedCardTransformers,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $82719199149a05f4$export$be237c815d2927d4)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $ab0973bc4ada0879$export$18d4026d1ea86bb1));
                    if (cardPluginEvents) {
                        const events = (0, $0689742eae39d3a4$export$c985b35883eaea59)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $kCECX.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    const newState = (0, $9a3e82568f11edf8$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    // Track the first resolved inline smart link for PO spotlight DOM targeting
                    if (meta.type === 'RESOLVE' && pluginState?.requests?.length) {
                        const resolvedRequest = pluginState.requests.find((req)=>req.url === meta.url);
                        if (resolvedRequest?.appearance === 'inline') {
                            if ((newState.resolvedInlineSmartLinks?.length ?? 0) < $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS) newState.resolvedInlineSmartLinks = [
                                ...newState.resolvedInlineSmartLinks ?? [],
                                {
                                    pos: resolvedRequest.pos,
                                    url: resolvedRequest.url,
                                    source: resolvedRequest.source
                                }
                            ];
                        }
                    }
                    if (!enableInlineUpgradeFeatures) return newState;
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $215d271c3bef94e8$export$f029a1bf9ca298da)($ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $50d9c959a343ad0a$export$290208dc31723a19)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $50d9c959a343ad0a$export$b31d21baab1bb9f)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $1552bb88269ab2b0$export$96766f42428c9e7f)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $82719199149a05f4$export$f05434c51e3762e)(view.state);
                        const oldState = (0, $82719199149a05f4$export$f05434c51e3762e)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $bjg0G.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $64861730f5bb867e$export$32f80df830e375f6)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $d456c0380d476625$export$8467cbb601c13bfc)(node.attrs.layout) ? node.attrs.layout : (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $28eb8ceae9a9c979$export$dd3435a1df9b2a3f)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $28eb8ceae9a9c979$export$f9c5be16586d220a)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $82719199149a05f4$export$cd9326e2f6dc42c0)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $LQnOI.default)(()=>(0, $1552bb88269ab2b0$export$2007d0af08977743)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined, currentState?.embedCardTransformers?.embedCardNodeTransformer));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $5a0a9ec159d3141a$export$cd3f6a9b84ab8435)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $6ee1e0f18b66d961$export$8c11099266e71f4)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    }),
                    embedCard: (0, $dc083a8e67906b16$export$86904605fa83de6c)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1)
        });
    };




const $e998f3a2cd995bba$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};












var $joG9X = parcelRequire("joG9X");





var $kkIPZ = parcelRequire("kkIPZ");





var $lMCnP = parcelRequire("lMCnP");





















const $9d9da0fd42d14aef$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $9d9da0fd42d14aef$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $cozmU.useCallback)(()=>{
        dispatch((0, $28eb8ceae9a9c979$export$e545bc176b552938)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $9d9da0fd42d14aef$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $9d9da0fd42d14aef$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $7ee17a04603997de$export$d01c44dffc996c80)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $9d9da0fd42d14aef$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $cozmU.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $ff2860869594b73b$export$113cdaf1b279f308)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $ff2860869594b73b$export$7f7b236478a618df)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $9d9da0fd42d14aef$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $9d9da0fd42d14aef$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};


const $0b5999f9a6963362$var$selector = (states)=>{
    return {
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $0b5999f9a6963362$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $bI14T.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $0b5999f9a6963362$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $0b5999f9a6963362$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2a1fa379fa79b714$export$76664c71b9b1a689), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d9da0fd42d14aef$export$95702e90d329951a), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $0b5999f9a6963362$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a975770660f37109$export$797e3658f090919c), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b5999f9a6963362$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $0b5999f9a6963362$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $lMCnP.JiraIssuesConfigModalWithWrappers),
        datasourceId: (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $kkIPZ.ConfluenceSearchConfigModalWithWrappers),
        datasourceId: (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $joG9X.AssetsConfigModalWithWrappers),
        datasourceId: (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $0b5999f9a6963362$export$2e2bcd8739ae039 = $0b5999f9a6963362$var$SafeModalWithState;















var $dgpXm = parcelRequire("dgpXm");





var $2iGHk = parcelRequire("2iGHk");








var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $d6a5e4838fef7689$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("9PQ2A"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};









/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $46b2e73c10a9bafa$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $46b2e73c10a9bafa$export$8793fab959da70d1 = $46b2e73c10a9bafa$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $krYZG.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $krYZG.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $krYZG.INPUT_METHOD).AUTO_DETECT:
        case (0, $krYZG.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $krYZG.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $krYZG.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $krYZG.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$df2aa842dc5172b0 = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $krYZG.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $krYZG.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$1cf3d8365b174bde = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $krYZG.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $46b2e73c10a9bafa$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $dgpXm.default) ? metadata.sourceEvent : null;
};


function $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $60ed0d15f281c988$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $dgpXm.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $60ed0d15f281c988$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $dgpXm.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $60ed0d15f281c988$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $60ed0d15f281c988$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $d6a5e4838fef7689$export$c82e48d9fd97c55b)();
    const eventHandlers = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
   * Subscribe to datasource events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};






var $8hDyr = parcelRequire("8hDyr");




/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $5981dd7300ead08c$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $5981dd7300ead08c$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
   * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
   * to defer any heavy operations involving network
   *
   * The callbacks themselves should not be deferred, they should be called syncronously the moment
   * the events take place.
   */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $8hDyr.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const creationMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const updateMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const updateType = (0, $46b2e73c10a9bafa$export$df2aa842dc5172b0)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $1f3d721a90b66bdf$export$e39a34cfd532e15).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $735ee273a357b497$export$94df0e59ebebf4a7)(node);
                if (!url) return;
                const display = (0, $735ee273a357b497$export$599e1b655555ab1d)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const deleteMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const deleteType = (0, $46b2e73c10a9bafa$export$1cf3d8365b174bde)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
   * Subscribe to link events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};


class $2b23ce52995f75a4$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        if (!this.props.editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $704a7a694f09cf02$export$2a29ca11e08dc129), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a975770660f37109$export$797e3658f090919c), {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $82bb9aba23fa33e9$export$b49e513cc101a4b6), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5981dd7300ead08c$export$aa142efb89c75ed5), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $60ed0d15f281c988$export$bddcbec746c26287), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}






var $19KQj = parcelRequire("19KQj");


const $9643dc942ac34a79$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $19KQj.useSmartLinkEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!events || !editorView) return;
        editorView.dispatch((0, $28eb8ceae9a9c979$export$55288255874724a1)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $7XIuB = parcelRequire("7XIuB");


var $ldbHR = parcelRequire("ldbHR");


var $keRDK = parcelRequire("keRDK");

var $3LJVu = parcelRequire("3LJVu");


var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");







const $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: `${"var(--ds-background-neutral, #0515240F)"}`,
    color: `${"var(--ds-icon, #292A2E)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, #292A2E)"} !important`
    }
});
const $b4dc197bbbd70ac9$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $keRDK.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $cozmU.useMemo)(()=>{
        return formatMessage((0, $3LJVu.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        testId: testId,
        css: $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
            label: title
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
            label: title
        })
    }));
};
const $b4dc197bbbd70ac9$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $b4dc197bbbd70ac9$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $b4dc197bbbd70ac9$var$selector);
    const isDatasource = (0, $50d9c959a343ad0a$export$962cfe99b8da8614)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $28eb8ceae9a9c979$export$c9a25858ed46807c)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)($b4dc197bbbd70ac9$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $d456c0380d476625$export$8467cbb601c13bfc)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
const $b4dc197bbbd70ac9$var$_default_1 = (0, $kSwu1.injectIntl)($b4dc197bbbd70ac9$var$LayoutButtonWrapper);
var $b4dc197bbbd70ac9$export$2e2bcd8739ae039 = $b4dc197bbbd70ac9$var$_default_1;


/* PasteDisplayAsMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $w6R6I = parcelRequire("w6R6I");











var $3nacY = parcelRequire("3nacY");

var $bFSJa = parcelRequire("bFSJa");











var $jgJIe = parcelRequire("jgJIe");

var $lslMH = parcelRequire("lslMH");

var $kwf4Z = parcelRequire("kwf4Z");


var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");









var $hBYtq = parcelRequire("hBYtq");





const $b980ccc002387570$var$getUrlFromTextLinkNode = (node)=>{
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = node.marks[0].attrs?.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $b980ccc002387570$var$getUrlFromCardNode = (node)=>{
    if (node.type.name !== 'inlineCard' && node.type.name !== 'blockCard' && node.type.name !== 'embedCard') return undefined;
    const url = node.attrs?.url ?? node.attrs?.data?.url;
    return typeof url === 'string' ? url : undefined;
};
const $b980ccc002387570$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
const $b980ccc002387570$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $b980ccc002387570$var$getUrlFromTextLinkNode(topNode) ?? $b980ccc002387570$var$getUrlFromCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $b980ccc002387570$var$significantChildren(topNode.content);
    if (children.length !== 1) return undefined;
    return $b980ccc002387570$var$getUrlFromTextLinkNode(children[0]) ?? $b980ccc002387570$var$getUrlFromCardNode(children[0]);
};









var $2sp5n = parcelRequire("2sp5n");

const $e7a83f0b8653a414$export$a990e9e9e93229aa = (node)=>node?.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && typeof node.attrs?.extensionKey === 'string' && node.attrs.extensionKey.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY));
const $e7a83f0b8653a414$export$98ee8d0cf866fa75 = (node)=>{
    const parameters = node.attrs?.parameters;
    const macroParamUrl = parameters?.macroParams?.url;
    const url = (macroParamUrl && typeof macroParamUrl === 'object' && 'value' in macroParamUrl ? macroParamUrl.value : macroParamUrl) ?? parameters?.macroMetadata?.url;
    return typeof url === 'string' ? url : undefined;
};
const $e7a83f0b8653a414$var$canReplaceNodeWith = (view, pos, nodeType)=>{
    if (!nodeType) return false;
    try {
        const $pos = view.state.doc.resolve(pos);
        const index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, nodeType);
    } catch  {
        return false;
    }
};
const $e7a83f0b8653a414$export$36c7c06292ba7472 = ({ editorView: editorView, pos: pos, appearance: appearance })=>{
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = editorView.state.schema.nodes;
    if (appearance === 'block') return $e7a83f0b8653a414$var$canReplaceNodeWith(editorView, pos, blockCard);
    if (appearance === 'inline' && !inlineCard) return false;
    if (appearance === 'url' && !editorView.state.schema.marks.link) return false;
    return $e7a83f0b8653a414$var$canReplaceNodeWith(editorView, pos, paragraph);
};
const $e7a83f0b8653a414$export$127d7a4a58bf6ed2 = ({ editorView: editorView, pos: pos, node: node, appearance: appearance, url: url, editorAnalyticsApi: editorAnalyticsApi })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = state.schema.nodes;
    const { link: link } = state.schema.marks;
    if (!(0, $73a6g.isSafeUrl)(url)) return false;
    let content;
    if (appearance === 'url' && link && paragraph) content = paragraph.create(null, state.schema.text(url, [
        link.create({
            href: url
        })
    ]));
    else if (appearance === 'inline' && inlineCard && paragraph) content = paragraph.create(null, inlineCard.create({
        url: url
    }));
    else if (appearance === 'block' && blockCard) content = blockCard.create({
        url: url
    });
    if (!content) return false;
    try {
        const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).CHANGED_TYPE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: 'nativeEmbed'
            }
        })(tr);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};



const $ec88e53192e5c284$export$96b638002b74480f = [
    'url',
    'inline',
    'block',
    'embed'
];
const $ec88e53192e5c284$var$cardAtPos = (node, pos)=>{
    switch(node?.type.name){
        case 'inlineCard':
            return {
                appearance: 'inline',
                pos: pos
            };
        case 'blockCard':
            return {
                appearance: 'block',
                pos: pos
            };
        case 'embedCard':
            return {
                appearance: 'embed',
                pos: pos
            };
        default:
            return (0, $e7a83f0b8653a414$export$a990e9e9e93229aa)(node) ? {
                appearance: 'embed',
                isNativeEmbed: true,
                pos: pos
            } : undefined;
    }
};
const $ec88e53192e5c284$var$getNodeUrl = (node)=>{
    if ((0, $e7a83f0b8653a414$export$a990e9e9e93229aa)(node)) return (0, $e7a83f0b8653a414$export$98ee8d0cf866fa75)(node);
    const attrs = node.attrs;
    const url = attrs?.url ?? attrs?.data?.url;
    return typeof url === 'string' ? url : undefined;
};
const $ec88e53192e5c284$export$bfdec0913b4999e8 = (state, pasteStartPos, pasteEndPos, pastedUrl)=>{
    const docContentSize = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, docContentSize));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, docContentSize));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    try {
        const candidateAt = (pos)=>{
            if (pos < 0 || pos >= docContentSize) return undefined;
            const node = state.doc.nodeAt(pos);
            const card = $ec88e53192e5c284$var$cardAtPos(node, pos);
            return node && card ? {
                card: card,
                url: $ec88e53192e5c284$var$getNodeUrl(node)
            } : undefined;
        };
        const adjacent = [
            candidateAt(from - 1),
            candidateAt(from)
        ].filter((candidate)=>Boolean(candidate));
        const inRange = [];
        state.doc.nodesBetween(from, to, (node, pos)=>{
            const card = $ec88e53192e5c284$var$cardAtPos(node, pos);
            if (card) {
                inRange.push({
                    card: card,
                    url: $ec88e53192e5c284$var$getNodeUrl(node)
                });
                return false;
            }
            return true;
        });
        if (pastedUrl) {
            const match = [
                ...adjacent,
                ...inRange
            ].find((candidate)=>candidate.url === pastedUrl);
            if (match) return match.card;
        }
        if (from === to) {
            const [firstAdjacent] = adjacent;
            if (firstAdjacent) return firstAdjacent.card;
        }
        return inRange[inRange.length - 1]?.card;
    } catch  {
        return undefined;
    }
};


const $7e51d18aba717b05$export$3360e99680efcdd8 = 'smart-link-display-as-paste-menu-section';
const $7e51d18aba717b05$var$styles = {
    appearanceBox: "_0bjKvDKTcp _0KLXrunmFW _3138422ADO _0adFHs2ADO _1DCdHi2ADO _2XsHFM2ADO _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    iconWrapper: "_3iDTPbgBM8 _2iEGP2UfmU _39xV02N91d",
    iconButton: "_0bjKvDKTcp _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _1UtDYzy7kJ _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    iconButtonSelected: "_0bjKvDKTcp _3vBAKHrzt2 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0KLXruY9q9 _1UtDYzy7kJ _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d _1eOmH6sumd _3gzVzLXsxn",
    iconButtonDisabled: "_0bjKvDKTcp _3vBAKHhQC5 _3hxITi6wH8 _2V7sgONvrM _0hPCNLDIqT _0KLXruVrZW _1UtDYzot27 _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _39xV02N91d"
};
const $7e51d18aba717b05$var$AppearanceOptionIconButton = ({ appearance: appearance, currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, Icon: Icon, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $7e51d18aba717b05$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: label,
            position: "bottom",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($7e51d18aba717b05$var$styles.iconButton, isDisabled && $7e51d18aba717b05$var$styles.iconButtonDisabled, !isDisabled && currentAppearance === appearance && $7e51d18aba717b05$var$styles.iconButtonSelected),
                "aria-label": label,
                "aria-pressed": currentAppearance === appearance,
                isDisabled: isDisabled,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                    label: label
                })
            })
        })
    });
};
const $7e51d18aba717b05$var$InlineAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "inline",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$BlockAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "block",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$EmbedAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "embed",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$getCurrentPastedSlice = (api)=>{
    const apiWithPaste = api;
    const pasteState = apiWithPaste?.paste?.sharedState.currentState();
    const slice = pasteState?.lastContentPasted?.pastedSlice;
    return slice;
};
const $7e51d18aba717b05$var$getCardUrlAtPasteRange = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos })=>{
    const cardAtPasteRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteStartPos, pasteEndPos);
    if (!cardAtPasteRange) return undefined;
    const node = editorView.state.doc.nodeAt(cardAtPasteRange.pos);
    if (!node) return undefined;
    if (cardAtPasteRange.isNativeEmbed) return (0, $e7a83f0b8653a414$export$98ee8d0cf866fa75)(node);
    const maybeAttrs = node.attrs;
    const maybeUrl = maybeAttrs?.url ?? maybeAttrs?.data?.url;
    return typeof maybeUrl === 'string' ? maybeUrl : undefined;
};
const $7e51d18aba717b05$export$790142d87e85490c = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, targetPos: targetPos })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const maxPos = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, maxPos));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, maxPos));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    const isTargetPosInBounds = targetPos !== undefined && targetPos >= 0 && targetPos <= state.doc.content.size;
    try {
        const nextSelection = isTargetPosInBounds && targetPos !== undefined ? (0, $kCECX.NodeSelection).create(state.doc, targetPos) : (0, $kCECX.TextSelection).create(state.doc, from, to);
        const tr = state.tr.setSelection(nextSelection);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};
const $7e51d18aba717b05$export$1c4f761565a0a1c6 = (editorView)=>{
    const { state: state } = editorView;
    const linkMarkType = state.schema.marks.link;
    if (!linkMarkType) return;
    let firstLinkRange;
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        if (firstLinkRange || !node.isText) return;
        if (linkMarkType.isInSet(node.marks)) firstLinkRange = {
            from: pos,
            to: pos + node.nodeSize
        };
    });
    return firstLinkRange;
};
const $7e51d18aba717b05$export$50ed46eb055a4a90 = ({ editorView: editorView, targetPos: targetPos })=>{
    if (targetPos !== undefined || (0, $9bUBT.getActiveLinkMark)(editorView.state)) return;
    const firstLinkRange = $7e51d18aba717b05$export$1c4f761565a0a1c6(editorView);
    if (!firstLinkRange) return;
    const linkRangeSelectionTr = editorView.state.tr.setSelection((0, $kCECX.TextSelection).create(editorView.state.doc, firstLinkRange.from, firstLinkRange.to));
    editorView.dispatch(linkRangeSelectionTr);
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const toolbarDropdownMenu = (0, $kwf4Z.useToolbarDropdownMenu)();
    const smartCardContext = (0, $9f1Yt.useSmartCardContext)();
    const frameRef = (0, $cozmU.useRef)(null);
    const isApplyingRef = (0, $cozmU.useRef)(false);
    const apiWithPasteOptionsToolbar = api;
    const pasteRange = (0, $3k5Tv.useSharedPluginStateWithSelector)(apiWithPasteOptionsToolbar, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return pluginState ? {
            pasteEndPos: pluginState.pasteEndPos,
            pasteStartPos: pluginState.pasteStartPos
        } : undefined;
    }); // Subscribe to card state so the menu re-renders when resolved card metadata updates.
    (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], (states)=>{
        return states.cardState;
    });
    const pastedLinkUrlFromSlice = (0, $b980ccc002387570$export$6f4c320e305ef7dc)($7e51d18aba717b05$var$getCurrentPastedSlice(api));
    const pastedLinkUrlFromCard = editorView && pasteRange ? $7e51d18aba717b05$var$getCardUrlAtPasteRange({
        editorView: editorView,
        pasteStartPos: pasteRange.pasteStartPos,
        pasteEndPos: pasteRange.pasteEndPos
    }) : undefined;
    const pastedLinkUrl = pastedLinkUrlFromSlice ?? pastedLinkUrlFromCard;
    const pastedLinkUrlState = pastedLinkUrl ? smartCardContext.value?.store?.getState()?.[pastedLinkUrl] : undefined;
    const hasResolvedSmartLinkData = Boolean(pastedLinkUrlState?.details);
    const cardAtPasteRange = editorView && pasteRange ? (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteRange.pasteStartPos, pasteRange.pasteEndPos, pastedLinkUrl) : undefined;
    const currentAppearance = editorView && pasteRange ? cardAtPasteRange?.appearance ?? 'url' : undefined; // A 1P link that resolves to an embed is inserted as a native embed, not an embedCard.
    // It displays as an embed, but the card commands cannot change its appearance.
    const isNativeEmbedPaste = Boolean(cardAtPasteRange?.isNativeEmbed);
    const handleClick = (0, $cozmU.useCallback)((appearance)=>()=>{
            if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance || isApplyingRef.current) return;
            isApplyingRef.current = true;
            const { state: state, dispatch: dispatch } = editorView;
            const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteRange;
            const cardAtRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(state, pasteStartPos, pasteEndPos, pastedLinkUrl);
            if (cardAtRange?.isNativeEmbed) {
                const nativeEmbedNode = state.doc.nodeAt(cardAtRange.pos); // 'embed' is what a native embed already displays as, so there is nothing to apply.
                if (nativeEmbedNode && appearance !== 'embed') (0, $e7a83f0b8653a414$export$127d7a4a58bf6ed2)({
                    editorView: editorView,
                    pos: cardAtRange.pos,
                    node: nativeEmbedNode,
                    appearance: appearance,
                    url: pastedLinkUrl,
                    editorAnalyticsApi: api?.analytics?.actions
                });
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            if (appearance === 'url') {
                if (cardAtRange) (0, $ff2860869594b73b$export$3f14f692ecc2a0d9)(pastedLinkUrl, pastedLinkUrl, true, state.doc.nodeAt(cardAtRange.pos) ?? undefined, cardAtRange.pos, api?.analytics?.actions)(state, dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            const targetPos = cardAtRange?.pos;
            const targetNodeAttrs = targetPos === undefined ? undefined : state.doc.nodeAt(targetPos)?.attrs;
            const targetNodeUrl = targetNodeAttrs?.url ?? targetNodeAttrs?.data?.url;
            const isRecoveredAdjacentPastedCard = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) && targetPos === pasteStartPos - 1 && pasteStartPos === pasteEndPos && targetNodeUrl === pastedLinkUrl;
            if (targetPos !== undefined && targetPos < pasteStartPos && !isRecoveredAdjacentPastedCard) {
                isApplyingRef.current = false;
                return;
            }
            const didApplySelection = $7e51d18aba717b05$export$790142d87e85490c({
                editorView: editorView,
                pasteStartPos: pasteStartPos,
                pasteEndPos: pasteEndPos,
                targetPos: targetPos
            });
            if (!didApplySelection) {
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            $7e51d18aba717b05$export$50ed46eb055a4a90({
                editorView: editorView,
                targetPos: targetPos
            });
            frameRef.current = requestAnimationFrame(()=>{
                frameRef.current = null;
                (0, $ff2860869594b73b$export$a188ef61ddbb94f)(appearance, api?.analytics?.actions)(editorView.state, editorView.dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
            });
        }, [
        api,
        currentAppearance,
        editorView,
        pasteRange,
        pastedLinkUrl,
        toolbarDropdownMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
            isApplyingRef.current = false;
        };
    }, []);
    if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance) return null;
    const preview = allowEmbeds && pastedLinkUrl && smartCardContext.value?.extractors.getPreview(pastedLinkUrl, 'web');
    const blockCardNodeType = editorView.state.schema.nodes.blockCard;
    const embedCardNodeType = editorView.state.schema.nodes.embedCard;
    const isBlockSupportedFromAppearanceContext = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isEmbedSupportedFromAppearanceContext = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isSmartLinkConvertible = hasResolvedSmartLinkData;
    const isBlockSupportedFromSelection = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), undefined);
    const isEmbedSupportedFromSelection = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), undefined); // A native embed is replaced in place, so support depends on what its own position
    // accepts rather than on the current selection or on an embed preview being available.
    const nativeEmbedPos = isNativeEmbedPaste ? cardAtPasteRange?.pos : undefined;
    const isSupportedForNativeEmbed = (appearance)=>nativeEmbedPos !== undefined && (0, $e7a83f0b8653a414$export$36c7c06292ba7472)({
            editorView: editorView,
            pos: nativeEmbedPos,
            appearance: appearance
        });
    const isInlineSupported = isNativeEmbedPaste ? isSupportedForNativeEmbed('inline') : true;
    const isBlockSupported = isNativeEmbedPaste ? allowBlockCards && isSupportedForNativeEmbed('block') : Boolean(isBlockSupportedFromAppearanceContext || isBlockSupportedFromSelection);
    const isEmbedSupported = // Whatever was pasted already displays this way, so the option must stay selectable.
    currentAppearance === 'embed' || Boolean(isEmbedSupportedFromAppearanceContext || isEmbedSupportedFromSelection);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        xcss: $7e51d18aba717b05$var$styles.appearanceBox,
        gap: "space.050",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$AppearanceOptionIconButton, {
                appearance: "url",
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste && !isSupportedForNativeEmbed('url'),
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).url.title),
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
                onClick: handleClick('url')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$InlineAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste ? !isInlineSupported : !isSmartLinkConvertible,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).inline.title),
                onClick: handleClick('inline')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$BlockAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isBlockSupported || !isNativeEmbedPaste && !isSmartLinkConvertible,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).block.title),
                onClick: handleClick('block')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$EmbedAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isEmbedSupported,
                label: intl.formatMessage((0, $gxKDp.appearancePropsMap).embed.title),
                onClick: handleClick('embed')
            })
        ]
    });
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuSection = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        title: intl.formatMessage({
            defaultMessage: "Display as",
            id: "fabric.editor.pasteDisplayAsMenu.displayAs"
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView, {
            api: api,
            allowBlockCards: allowBlockCards,
            allowEmbeds: allowEmbeds
        })
    });
};
const $7e51d18aba717b05$export$996593790cad4497 = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, getEditorView: getEditorView, smartCardClientRef: smartCardClientRef })=>{
    const smartlinkAsyncHidden = async (context)=>{
        const { pastedUrl: pastedUrl } = context;
        if (!pastedUrl) return false;
        const isEnabled = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true);
        const smartCardClient = smartCardClientRef?.current;
        if (!isEnabled || !smartCardClient) return true;
        try {
            const response = await smartCardClient.fetchData(pastedUrl);
            return response.meta?.access !== 'granted';
        } catch  {
            // Network / auth errors → hide
            return true;
        }
    };
    return [
        {
            type: 'menu-section',
            key: $7e51d18aba717b05$export$3360e99680efcdd8,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: 60
                }
            ],
            isAsyncHidden: smartlinkAsyncHidden,
            isHidden: ()=>{
                if (!(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                const apiWithPasteOptionsToolbar = api;
                const pasteRange = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                const editorView = getEditorView();
                if (!editorView || !pasteRange) return true;
                 // Slice-shape check — delegated to the toolbar plugin's shared
                // `notSingleLinkRule` via the structural cast (see note above).
                const rules = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
                if (!rules || rules.notSingleLinkRule()) return true;
                const urlFromSlice = (0, $b980ccc002387570$export$6f4c320e305ef7dc)($7e51d18aba717b05$var$getCurrentPastedSlice(api));
                if (urlFromSlice) return false;
                 // Fallback: plain-text URL paste that the card plugin already resolved into a card node in the doc.
                const urlFromCard = $7e51d18aba717b05$var$getCardUrlAtPasteRange({
                    editorView: editorView,
                    pasteStartPos: pasteRange.pasteStartPos,
                    pasteEndPos: pasteRange.pasteEndPos
                });
                return !urlFromCard;
            },
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($7e51d18aba717b05$var$PasteDisplayAsMenuSection, {
                    api: api,
                    allowBlockCards: allowBlockCards,
                    allowEmbeds: allowEmbeds
                })
        }
    ];
};











const $2ba419bd96369939$var$PreAuthValuePropositionModal = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6XuGW")).then((module)=>({
            default: module.PreAuthValuePropositionModal
        })));
const $2ba419bd96369939$var$getNewSmartLinkUrl = (event)=>{
    if (event.subject !== (0, $1f3d721a90b66bdf$export$97c6cb64ce06a88a).LINK || event.data.isUndo || event.data.isRedo || (0, $735ee273a357b497$export$599e1b655555ab1d)(event.data.node) === 'url') return;
    if (event.event === (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).CREATED || event.event === (0, $1f3d721a90b66bdf$export$e39a34cfd532e15).UPDATED && event.data.previousDisplay === 'url') return (0, $735ee273a357b497$export$94df0e59ebebf4a7)(event.data.node);
};
const $2ba419bd96369939$var$ModalListener = ({ api: api, cardPluginEvents: cardPluginEvents })=>{
    const [url, setUrl] = (0, $cozmU.useState)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    // While the pre-auth modal is visible, use 'overlayOpen' to suppress the floating toolbar.
    // Jira portals editor popups above its issue dialog, so the toolbar would otherwise appear
    // above the modal blanket. Keep it available while link eligibility is still being checked.
    // On close or unmount, restore the previous intent unless another interaction has changed it.
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen || !api?.userIntent) return;
        const previousIntent = api.userIntent.sharedState.currentState()?.currentUserIntent ?? 'default';
        api.core.actions.execute(api.userIntent.commands.setCurrentUserIntent('overlayOpen'));
        return ()=>{
            if (api.userIntent?.sharedState.currentState()?.currentUserIntent === 'overlayOpen') api.core.actions.execute(api.userIntent.commands.setCurrentUserIntent(previousIntent));
        };
    }, [
        api,
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>cardPluginEvents.subscribe((event)=>{
            const newSmartLinkUrl = $2ba419bd96369939$var$getNewSmartLinkUrl(event);
            if (newSmartLinkUrl) setUrl((currentUrl)=>currentUrl ?? newSmartLinkUrl);
        }), [
        cardPluginEvents
    ]);
    const onFinished = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setUrl(undefined);
    }, []);
    return url ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($2ba419bd96369939$var$PreAuthValuePropositionModal, {
            url: url,
            onFinished: onFinished,
            onOpenChange: setIsOpen
        }, url)
    }) : null;
};
const $2ba419bd96369939$export$79a277fe892e4f35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($2ba419bd96369939$var$ModalListener);





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");



























var $7LGcP = parcelRequire("7LGcP");


var $8kUOZ = parcelRequire("8kUOZ");


var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $9wgTc = parcelRequire("9wgTc");


var $437ur = parcelRequire("437ur");


var $ds2zu = parcelRequire("ds2zu");


var $f1iv3 = parcelRequire("f1iv3");





const $0298a869cdc628ef$export$19175c221bcdac39 = ({ previewImageUrls: previewImageUrls, type: type })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const isJira = type === 'jira';
    const isConfluenceSearch = type === 'confluence-search';
    const description = formatMessage(isJira ? (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription : isConfluenceSearch ? (0, $bI2nS.messages).datasourceConfluenceSearchDescription : (0, $bI2nS.messages).datasourceAssetsObjectsDescription);
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage(isJira ? (0, $lPJNC.messages).previewAttributionJira : isConfluenceSearch ? (0, $lPJNC.messages).previewAttributionConfluence : (0, $lPJNC.messages).previewAttributionAssets),
                ...(isJira || isConfluenceSearch) && {
                    icon: isJira ? (0, $8kUOZ.JiraAttributionIcon) : (0, $7LGcP.ConfluenceAttributionIcon)
                }
            }
        } : undefined, [
        formatMessage,
        isConfluenceSearch,
        isJira,
        previewImageUrls
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)(type)(tr);
        return tr;
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: description,
        iconBefore: isJira ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            label: ""
        }) : isConfluenceSearch ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
            label: ""
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($437ur))), {
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(isJira ? (0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue : isConfluenceSearch ? (0, $bI2nS.messages).datasourceConfluenceSearch : (0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability)
    });
};


const $321aa0c1b5706dd4$var$datasourcePreviewImageUrlsByKey = {
    [(0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIM.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLA.png'
    },
    [(0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIK.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMD.png'
    },
    [(0, $dCkbP.ASSETS_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ2.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM6.png'
    }
};
const $321aa0c1b5706dd4$export$7da4affb2ef3577f = ({ api: api, options: options })=>{
    if (!options.allowDatasource) return [];
    const components = [
        {
            key: (0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key,
            type: (0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                    type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                    rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription),
                    keywords: [
                        'jira'
                    ],
                    title: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                    api: api,
                    previewImageUrls: $321aa0c1b5706dd4$var$datasourcePreviewImageUrlsByKey[(0, $dCkbP.JIRA_WORK_ITEMS_MENU_ITEM).key],
                    type: "jira"
                })
        }
    ];
    if ((0, $k3XQC.canRenderDatasource)((0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) components.push({
        key: (0, $dCkbP.ASSETS_MENU_ITEM).key,
        type: (0, $dCkbP.ASSETS_MENU_ITEM).type,
        parents: [
            {
                key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.ASSETS_MENU_ITEM).key]
            }
        ],
        match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsDescription),
                keywords: [
                    'assets'
                ],
                title: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability)
            })),
        component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                api: api,
                previewImageUrls: $321aa0c1b5706dd4$var$datasourcePreviewImageUrlsByKey[(0, $dCkbP.ASSETS_MENU_ITEM).key],
                type: "assets"
            })
    });
    if ((0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)((0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID))) components.push({
        key: (0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key,
        type: (0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).type,
        parents: [
            {
                key: (0, $dCkbP.DATA_AND_CHARTS_SECTION).key,
                type: (0, $dCkbP.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $dXqu3.DATA_AND_CHARTS_SECTION_RANK)[(0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key]
            }
        ],
        match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearchDescription),
                keywords: [
                    'confluence'
                ],
                title: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearch)
            })),
        component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0298a869cdc628ef$export$19175c221bcdac39), {
                api: api,
                previewImageUrls: $321aa0c1b5706dd4$var$datasourcePreviewImageUrlsByKey[(0, $dCkbP.CONFLUENCE_LIST_MENU_ITEM).key],
                type: "confluence-search"
            })
    });
    return components;
};



const $d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync = ({ clientRef: clientRef })=>{
    const smartCardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    (0, $cozmU.useEffect)(()=>{
        clientRef.current = smartCardContext?.connections?.client;
    }, [
        clientRef,
        smartCardContext?.connections?.client
    ]);
    return null;
};
const $d58cf3f7a16e5010$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $e998f3a2cd995bba$export$5115a388c364848d)();
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    let instanceEmbedCardTransformers = options.embedCardTransformers;
    let editorViewForPasteMenu;
    const pasteMenuSmartCardClientRef = {
        current: undefined
    };
    const pasteMenuVariant = (0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    const shouldRegisterPasteDisplayAsMenu = options.enablePasteDisplayAsMenu && [
        'hasSpellingAndGrammar',
        'hasAltAiActions'
    ].includes(pasteMenuVariant);
    if (shouldRegisterPasteDisplayAsMenu) api?.uiControlRegistry?.actions.register((0, $7e51d18aba717b05$export$996593790cad4497)({
        api: api,
        allowBlockCards: options.onlyInlineCards ? false : options.allowBlockCards ?? true,
        allowEmbeds: options.onlyInlineCards ? false : options.allowEmbeds,
        getEditorView: ()=>editorViewForPasteMenu,
        smartCardClientRef: pasteMenuSmartCardClientRef
    }));
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $321aa0c1b5706dd4$export$7da4affb2ef3577f)({
        api: api,
        options: options
    }));
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $ab0973bc4ada0879$export$18d4026d1ea86bb1).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $7e11113c0b6b9b64$export$290edac762b9f37c)()
                }
            ];
            // `onlyInlineCards` is a hard gate: when set, blockCard/embedCard
            // stay out of the schema regardless of allowBlockCards/allowEmbeds.
            if (options.onlyInlineCards) return nodes;
            nodes.push({
                name: 'blockCard',
                node: (0, $dc39c5d622176d3d$export$f664dd11022c8749)()
            });
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $75ce2aa51e74c7ef$export$f8faabd3267a007e)()
            });
            return nodes;
        },
        pmPlugins () {
            // onlyInlineCards forces block/embed off regardless of caller-passed flags,
            // keeping the schema gate (in nodes()) and the runtime gate in sync.
            const allowBlockCards = options.onlyInlineCards ? false : options.allowBlockCards ?? true;
            const allowEmbeds = options.onlyInlineCards ? false : options.allowEmbeds;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $ce69229594a80c43$export$ae829ec7b2625219)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowEmbeds: allowEmbeds,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        embedCardTransformers: instanceEmbedCardTransformers,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $1ddf8f052569320c$export$fc7a7a088775f35d)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            editorViewForPasteMenu = editorView;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    (0, $iDrrr.fg)('platform_sl_3p_preauth_value_modal_killswitch') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2ba419bd96369939$export$79a277fe892e4f35), {
                        api: api,
                        cardPluginEvents: cardPluginEvents
                    }) : null,
                    shouldRegisterPasteDisplayAsMenu && /*#__PURE__*/ (0, $8aG6j.jsx)($d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync, {
                        clientRef: pasteMenuSmartCardClientRef
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9643dc942ac34a79$export$e7d7ea2bc9a806d9), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2b23ce52995f75a4$export$c083a9ed3df8f5ac), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4dc197bbbd70ac9$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0b5999f9a6963362$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        commands: {
            queueCardsFromRange: (from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)=>({ tr: tr })=>(0, $ff2860869594b73b$export$86b4b08ffadfa0a6)(// Synthesise the minimal EditorState shape the impl actually reads.
                    {
                        schema: tr.doc.type.schema,
                        selection: tr.selection
                    }, tr, from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $28eb8ceae9a9c979$export$1572b3eade6662f9)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $28eb8ceae9a9c979$export$bd1cd60a9b31da5e,
            queueCardsFromChangedTr: $ff2860869594b73b$export$f17c48478174211e,
            queueCardsFromRange: $ff2860869594b73b$export$86b4b08ffadfa0a6,
            registerEmbedCardTransformer: (transformers)=>{
                instanceEmbedCardTransformers = transformers;
            },
            resolveShortLinkUrl: async (url)=>{
                if (!options.provider) return undefined;
                try {
                    const provider = await options.provider;
                    // EditorCardProvider holds a CardClient instance internally. We access it
                    // directly to call fetchData, which gives us the raw ORS JSON-LD response
                    // including the canonical url field — something provider.resolve() does not
                    // surface. This is intentionally a structural cast rather than a typed
                    // dependency on EditorCardProvider's private API.
                    const clientHolder = provider;
                    const client = clientHolder.cardClient;
                    if (!client) return undefined;
                    const response = await client.fetchData(url);
                    // ORS returns a JsonLd.Response whose data union includes BaseData,
                    // BaseCollectionData, and BaseCollectionPage. We only care about the
                    // `url` field which is present on BaseData (Primitives.Object). Cast
                    // to a minimal shape rather than accessing through the full union type.
                    const data = response?.data;
                    if (!data) return undefined;
                    const urlField = data.url;
                    // Property<string | Link> can be a string, a Link object, or an array.
                    // Short-link responses always return a plain string URL.
                    if (typeof urlField === 'string' && urlField !== url) return urlField;
                    // Fallback: Link object shape with href or @id
                    if (urlField && typeof urlField === 'object' && !Array.isArray(urlField)) {
                        const linkObj = urlField;
                        const id = linkObj['@id'] ?? linkObj['href'];
                        if (typeof id === 'string' && id !== url) return id;
                    }
                } catch  {
                // Swallow errors — callers handle undefined
                }
                return undefined;
            },
            getStartingToolbarItems: (0, $cc2f82b3700a9ffb$export$bb790f15a666b7f0)(options, api),
            getEndingToolbarItems: (0, $cc2f82b3700a9ffb$export$d5ca70670b9f6b9)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $cc2f82b3700a9ffb$export$4850df084251d287)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertArray = [];
                    if (!options.allowDatasource) return quickInsertArray;
                    quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue),
                        description: formatMessage((0, $iDrrr.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'jira'
                        ],
                        featured: true,
                        priority: 500,
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceJiraIssue), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('jira')(tr);
                            return tr;
                        }
                    });
                    if ((0, $k3XQC.canRenderDatasource)((0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability),
                        description: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'assets'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceAssetsObjects), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('assets')(tr);
                            return tr;
                        }
                    });
                    if ((0, $50d9c959a343ad0a$export$c677d64dd26b7aa2)((0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearch),
                        description: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearchDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'confluence'
                        ],
                        featured: true,
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDatasourceConfluenceSearch), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $28eb8ceae9a9c979$export$2c79f54b873d04be)('confluence-search')(tr);
                            return tr;
                        }
                    });
                    return quickInsertArray;
                }
            }
        }
    };
};
module.exports["cardPlugin"] = $d58cf3f7a16e5010$export$2a6748328f902e16;

});

parcelRegister("brzQy", function(module, exports) {

var $73Kv0 = parcelRequire("73Kv0");

function $b5456d47f1a39227$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
module.exports["getLinkMetadataFromTransaction"] = $b5456d47f1a39227$export$3aba02526a1e2e78;

});

parcelRegister("9PQ2A", function(module, exports) {

let $72913eab3481b937$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $72913eab3481b937$var$load("b8Pmw"),
    $72913eab3481b937$var$load("bRI8E"),
    $72913eab3481b937$var$load("7A87G"),
    $72913eab3481b937$var$load("axcf5")
]).then(()=>parcelRequire('aWop1'));

});

parcelRegister("6XuGW", function(module, exports) {

let $51100f7e89960611$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51100f7e89960611$var$load("aiepK").then(()=>parcelRequire('eFLGY'));

});

parcelRegister("l5MIu", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $iDrrr = parcelRequire("iDrrr");


var $l5MIu = parcelRequire("l5MIu");

const $a046056e2fb9f0f3$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $l5MIu.pluginKey), {
        changed: true
    });


const $88c05f26a72cea2c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('contextPanelPluginKey');
function $88c05f26a72cea2c$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $kpCD8.SafePlugin)({
        key: $88c05f26a72cea2c$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($88c05f26a72cea2c$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                    const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                    if (contentsLengthChanged || contentChanged) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($88c05f26a72cea2c$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $88c05f26a72cea2c$export$773ed6f43b4b1d8f = ({ config: config })=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $a046056e2fb9f0f3$export$6fbe08f3dbfbccb2),
            showPanel: config?.objectSideBar.showPanel && (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? (panel, behavior, panelWidth)=>config.objectSideBar.showPanel(panel, behavior, panelWidth) : undefined,
            closePanel: config?.objectSideBar.closePanel && (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? ()=>config.objectSideBar.closePanel() : undefined,
            closePanelById: config?.objectSideBar.closePanelById && (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? (id)=>config.objectSideBar.closePanelById(id) : undefined
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $88c05f26a72cea2c$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$88c05f26a72cea2c$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });
module.exports["pluginKey"] = $88c05f26a72cea2c$export$18d4026d1ea86bb1;
module.exports["contextPanelPlugin"] = $88c05f26a72cea2c$export$773ed6f43b4b1d8f;

});

parcelRegister("f2WDp", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $44cyU = parcelRequire("44cyU");


var $5Qi6J = parcelRequire("5Qi6J");


var $2Ldzs = parcelRequire("2Ldzs");


var $kCECX = parcelRequire("kCECX");

const $5b133ffbe6102189$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('customAutoformatPlugin');
const $5b133ffbe6102189$export$f05434c51e3762e = (editorState)=>$5b133ffbe6102189$export$18d4026d1ea86bb1.getState(editorState);
const $5b133ffbe6102189$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($5b133ffbe6102189$export$18d4026d1ea86bb1, action);
};


const $c66352c5e58ad2b4$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $5Qi6J.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $c66352c5e58ad2b4$export$44515d004ac96c3b = (docText, match)=>{
    const REPLACEMENT_CHARACTER = '\ufffc';
    const docTextStartChar = docText[0];
    const docTextEndSlice = docText.slice(1);
    const matchStartChar = match[0][0];
    const matchEndSlice = match[0].slice(1);
    const slicesMatch = docTextEndSlice === matchEndSlice;
    const isAlternator = docTextStartChar === '|';
    const isObjReplaceChar = matchStartChar === REPLACEMENT_CHARACTER;
    return slicesMatch && isAlternator && isObjReplaceChar;
};
const $c66352c5e58ad2b4$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            const canAutoformatAfterSoftbreak = $c66352c5e58ad2b4$export$44515d004ac96c3b(docText, match);
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0] || canAutoformatAfterSoftbreak) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $2Ldzs.closeHistory)(tr));
    });
};


const $91a3efca43475222$var$MAX_MATCH = 500;
const $91a3efca43475222$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $91a3efca43475222$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};


const $f9b725b9553a4181$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $f9b725b9553a4181$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $f9b725b9553a4181$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $f9b725b9553a4181$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};


const $27481858f0f4c10f$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $f9b725b9553a4181$export$b373f08cf72033a1)(state, action);
        case 'resolved':
            return (0, $f9b725b9553a4181$export$d06d16b20ced9190)(state, action);
        case 'finish':
            return (0, $f9b725b9553a4181$export$5953b28951b32649)(state, action);
        case 'setProvider':
            return (0, $f9b725b9553a4181$export$1572b3eade6662f9)(state, action);
        default:
            return state;
    }
};
var $27481858f0f4c10f$export$2e2bcd8739ae039 = $27481858f0f4c10f$var$reduce;



const $48a603f91372504c$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $5b133ffbe6102189$export$18d4026d1ea86bb1));
                if (!meta) return remappedPluginState;
                return (0, $27481858f0f4c10f$export$2e2bcd8739ae039)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $91a3efca43475222$export$2b7343a2464fe84e)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $91a3efca43475222$export$2b7343a2464fe84e)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            /**
               * On Shift + Enter, after the first word an Object Replacement Character (/ufffc) is added.
               * We still want to match strings that start with an Object Replacement Character.
               */ // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchTyping: new RegExp('(\\s+|^|\\ufffc)' + rule + '(\\s|,|\\.)$'),
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $c66352c5e58ad2b4$export$c95e7d405e6ed1df)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            return {
                update (view) {
                    const currentState = (0, $5b133ffbe6102189$export$f05434c51e3762e)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $c66352c5e58ad2b4$export$e9a01ad76956fe83)(view, currentState);
                }
            };
        },
        key: (0, $5b133ffbe6102189$export$18d4026d1ea86bb1)
    });
};
const $48a603f91372504c$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $48a603f91372504c$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>$48a603f91372504c$export$1572b3eade6662f9(provider)(tr));
    });
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $48a603f91372504c$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $5b133ffbe6102189$export$f05434c51e3762e)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                previousProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$48a603f91372504c$export$1572b3eade6662f9(provider)(tr)) ?? false;
            }
        }
    };
};
module.exports["customAutoformatPlugin"] = $48a603f91372504c$export$aa4fc86248a63de6;

});

parcelRegister("7gk7g", function(module, exports) {

var $kHCzj = parcelRequire("kHCzj");

const $3e0cec82cb591abf$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $kHCzj.dataConsumer)
                }
            ];
        }
    });
module.exports["dataConsumerPlugin"] = $3e0cec82cb591abf$export$1dc90efb79c37811;

});

parcelRegister("4y9hw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eRn3r = parcelRequire("eRn3r");


var $eq809 = parcelRequire("eq809");


var $krYZG = parcelRequire("krYZG");


var $4y8CY = parcelRequire("4y8CY");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $e4nz6 = parcelRequire("e4nz6");


var $gZpSA = parcelRequire("gZpSA");


var $bjg0G = parcelRequire("bjg0G");


var $eDtFr = parcelRequire("eDtFr");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");





var $fRYCB = parcelRequire("fRYCB");

var $efgwK = parcelRequire("efgwK");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");





var $9aR69 = parcelRequire("9aR69");




const $d6888e0cf750b9a1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('datePlugin');


const $00d64b18d9375627$export$e029667a62135fd0 = (isQuickInsertAction)=>(state)=>{
        const tr = state.tr;
        const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = state.schema.nodes.date.createChecked({
            timestamp: (0, $efgwK.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $aPdNQ.Fragment).fromArray([
            dateNode,
            state.schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), newPluginState);
    };
const $00d64b18d9375627$export$1a697965b9ed5436 = (isQuickInsertAction)=>(tr)=>{
        const schema = tr.doc.type.schema;
        const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = schema.nodes.date.createChecked({
            timestamp: (0, $efgwK.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $aPdNQ.Fragment).fromArray([
            dateNode,
            schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), newPluginState);
    };
const $00d64b18d9375627$export$ba69c8aeb784b528 = ()=>(state, dispatch)=>{
        const pluginState = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state);
        if (!pluginState || pluginState.showDatePickerAt === null) return false;
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            focusDateInput: true
        });
        dispatch(tr);
        return true;
    };
const $00d64b18d9375627$export$70b286c4fa24838 = (showDatePickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: showDatePickerAt
        }));
        return true;
    };
const $00d64b18d9375627$export$a903d799de0e4474 = ()=>(state, dispatch)=>{
        const { showDatePickerAt: showDatePickerAt } = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state) || {};
        if (!dispatch) return false;
        const tr = showDatePickerAt ? state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        }).setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showDatePickerAt + 2))) : state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            isNew: false
        });
        dispatch(tr);
        return false;
    };
const $00d64b18d9375627$export$7c3e79dfb4962626 = ({ date: date, pluginInjectionApi: pluginInjectionApi })=>{
    pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).COMMITTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DATE,
        attributes: {
            commitMethod: (0, $krYZG.INPUT_METHOD).BLUR,
            isValid: date !== undefined,
            isToday: (0, $9aR69.isToday)(date)
        }
    });
    return $00d64b18d9375627$export$a903d799de0e4474();
};
const $00d64b18d9375627$export$621a48d450e82cf = ()=>(state, dispatch)=>{
        const { $from: $from } = state.selection;
        const node = state.doc.nodeAt($from.pos);
        if (node && node.type.name === state.schema.nodes.date.name) {
            const showDatePickerAt = $from.pos;
            if (dispatch) dispatch(state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                showDatePickerAt: showDatePickerAt
            }).setSelection((0, $kCECX.NodeSelection).create(state.doc, showDatePickerAt)));
        }
        return false;
    };





















const $eb817c60451a2df5$export$8993b403eaf979d2 = (pluginInjectionApi)=>({ tr: tr })=>{
        const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
        if (!showDatePickerAt) return tr;
        tr.delete(showDatePickerAt, showDatePickerAt + 1).setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        });
        return tr;
    };
const $eb817c60451a2df5$export$b606a931fa97541b = (pluginInjectionApi)=>({ date: date, inputMethod: inputMethod, commitMethod: commitMethod, enterPressed: enterPressed = true })=>({ tr: tr })=>{
            const { schema: schema } = tr.doc.type;
            let timestamp;
            if (date) timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
            else timestamp = (0, $efgwK.todayTimestampInUTC)();
            if (inputMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            if (commitMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).COMMITTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DATE,
                attributes: {
                    commitMethod: commitMethod,
                    isValid: date !== undefined,
                    isToday: (0, $9aR69.isToday)(date)
                }
            })(tr);
            const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
            if (!showDatePickerAt) {
                const dateNode = schema.nodes.date.createChecked({
                    timestamp: timestamp
                });
                const textNode = schema.text(' ');
                const fragment = (0, $aPdNQ.Fragment).fromArray([
                    dateNode,
                    textNode
                ]);
                const { from: from, to: to } = tr.selection;
                const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
                if (!insertable) {
                    const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
                    tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
                } else tr.replaceWith(from, to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, from));
                if (tr.docChanged) tr.scrollIntoView().setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                    isNew: true
                });
                return tr;
            }
            if (tr.doc.nodeAt(showDatePickerAt)) {
                if (enterPressed) // Setting selection to outside the date node causes showDatePickerAt
                // to be set to null by the PM plugin (onSelectionChanged), which will
                // immediately close the datepicker once a valid date is typed in.
                // Adding this check forces it to stay open until the user presses Enter.
                tr = tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(showDatePickerAt + 2)));
                tr = tr.setNodeMarkup(showDatePickerAt, schema.nodes.date, {
                    timestamp: timestamp
                }).setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                    isNew: false
                }).scrollIntoView();
                if (!enterPressed) tr = tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, showDatePickerAt));
            }
            return tr;
        };





var $eBSR7 = parcelRequire("eBSR7");






var $kpCD8 = parcelRequire("kpCD8");


var $cI8RZ = parcelRequire("cI8RZ");






var $kSwu1 = parcelRequire("kSwu1");


var $8dxef = parcelRequire("8dxef");


var $8Dx7s = parcelRequire("8Dx7s");





var $fngNp = parcelRequire("fngNp");










const $32f222708c1a1235$export$55a93796ef2674d = (timestamp, intl, state, pos)=>{
    if (!state) return {
        color: undefined,
        displayString: (0, $efgwK.timestampToString)(timestamp, intl)
    };
    const { doc: doc, selection: selection } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    // We fall back to selection.$from even though it does not cover all use cases
    // eg. upon Editor init, selection is at the start, not at the Date node
    const $nodePos = typeof pos === 'number' ? doc.resolve(pos) : selection.$from;
    const parent = $nodePos.parent;
    let withinIncompleteTask = parent.type === taskItem && parent.attrs.state !== 'DONE';
    // If there is blockTaskItem in the schema and it's not nested in an incomplete task item,
    // check if it's nested in an incomplete block task item
    if (blockTaskItem && !withinIncompleteTask) {
        const blockTaskItemParent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($nodePos, blockTaskItem);
        // If nested in a blockTaskItem that is incomplete
        if (blockTaskItemParent) withinIncompleteTask = blockTaskItemParent.node.attrs.state !== 'DONE';
    }
    const color = withinIncompleteTask && (0, $efgwK.isPastDate)(timestamp) ? 'red' : undefined;
    const displayString = withinIncompleteTask ? (0, $efgwK.timestampToTaskContext)(timestamp, intl) : (0, $efgwK.timestampToString)(timestamp, intl);
    return {
        displayString: displayString,
        color: color
    };
};


let $ff58016aca28f78a$var$intlRef;
const $ff58016aca28f78a$export$dfa8d249b3ff4cf7 = (node)=>{
    $ff58016aca28f78a$var$intlRef = $ff58016aca28f78a$var$intlRef || (0, $kSwu1.createIntl)({
        locale: document.documentElement.lang || 'en-US'
    });
    const timestamp = node.attrs.timestamp;
    const displayString = (0, $efgwK.timestampToString)(timestamp, $ff58016aca28f78a$var$intlRef);
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        'aria-busy': 'true'
    };
    const attrs = {
        style: (0, $8Dx7s.convertToInlineCss)({
            // Taken from @atlaskit/date Component
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text, #292A2E)",
            borderRadius: "var(--ds-radius-small, 4px)",
            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
            margin: '0 1px'
        })
    };
    return [
        'span',
        wrapperAttrs,
        [
            'span',
            attrs,
            displayString
        ]
    ];
};
const $ff58016aca28f78a$export$3bf4edf3398258cf = (node, state, getPos, intl)=>{
    const timestamp = node.attrs.timestamp;
    const pos = getPos?.();
    const { displayString: displayString, color: color } = (0, $32f222708c1a1235$export$55a93796ef2674d)(timestamp, intl, state, pos);
    const nodeWrapperAttrs = {
        contenteditable: 'false',
        timestamp: timestamp,
        class: 'dateView-content-wrap inlineNodeView',
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-name': 'date',
        'data-prosemirror-node-inline': 'true',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        draggable: 'true'
    };
    if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) nodeWrapperAttrs['data-local-id'] = node.attrs.localId;
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp
    };
    const attrs = {
        class: !color ? '' : `date-node-color-${color}`,
        style: `white-space: unset`
    };
    return [
        'span',
        nodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            wrapperAttrs,
            [
                'span',
                attrs,
                displayString
            ]
        ],
        (0, $8dxef.getBrowserInfo)().android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $3705bb10050f2b09$export$9e959fa2f3aa27d3 {
    /**
   *
   * @param node
   * @param decorations
   * @example
   */ update(node, decorations) {
        // we're only interested in two scenarios to trigger a DOM update:
        // 		1. the date value (timestamp) has changed
        // 		2. A wrapping taskitem state (if present) has changed
        // in all other cases, we tell prosemirror to ignore DOM updates
        // if new changes are added to the DOM structure, they will need to be
        // coded here
        const hasDateChanged = node.attrs.timestamp !== this.node.attrs.timestamp;
        const parentTaskState = $3705bb10050f2b09$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
        const parentTaskStateChanged = parentTaskState !== this.parentTaskState;
        // update local state after comparisons ...
        this.parentTaskState = parentTaskState;
        this.node = node;
        const skipProseMirrorDomUpdate = !hasDateChanged && !parentTaskStateChanged;
        return skipProseMirrorDomUpdate;
    }
    static getParentTaskState(decorations) {
        const parentTaskDecoration = decorations.find((d)=>{
            return d.spec.dataTaskNodeCheckState !== undefined;
        });
        return parentTaskDecoration?.spec?.dataTaskNodeCheckState ?? '';
    }
    /**
   *
   * @param node
   * @param view
   * @param getPos
   * @param intl
   * @param decorations
   * @example
   */ constructor(node, view, getPos, intl, decorations){
        this.dom = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.parentTaskState = '';
        this.node = node;
        this.intl = intl;
        this.view = view;
        this.getPos = getPos;
        const spec = (0, $ff58016aca28f78a$export$3bf4edf3398258cf)(node, this.view.state, this.getPos, this.intl);
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom.addEventListener('click', (event)=>{
            event.stopImmediatePropagation();
            const { state: state, dispatch: dispatch } = this.view;
            (0, $00d64b18d9375627$export$70b286c4fa24838)(state.selection.from)(state, dispatch);
        });
        this.parentTaskState = $3705bb10050f2b09$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
    }
}






function $afd1413c588653ab$export$1650419e431d3ba3(pluginState, meta) {
    // If the same nodeview is clicked twice, calendar should close
    if (meta.showDatePickerAt === pluginState.showDatePickerAt) return {
        ...pluginState,
        showDatePickerAt: null
    };
    const { showDatePickerAt: showDatePickerAt, isNew: isNew } = pluginState;
    const { showDatePickerAt: showDatePickerAtMeta } = meta;
    // If date picker position has changed, it is no longer new
    if (showDatePickerAt && showDatePickerAtMeta && showDatePickerAt !== showDatePickerAtMeta && isNew) return {
        ...pluginState,
        ...meta,
        isNew: false
    };
    return {
        ...pluginState,
        ...meta
    };
}
function $afd1413c588653ab$export$83e1f26587c4acd2(tr, pluginState) {
    if (!pluginState.showDatePickerAt) return pluginState;
    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.showDatePickerAt);
    return {
        showDatePickerAt: deleted ? null : pos,
        isNew: pluginState.isNew,
        isDateEmpty: pluginState.isDateEmpty,
        focusDateInput: pluginState.focusDateInput,
        isInitialised: pluginState.isInitialised
    };
}
function $afd1413c588653ab$export$8a0edcfd4a8a0397(tr, pluginState) {
    if (tr.docChanged && $afd1413c588653ab$var$isDateNodeSelection(tr.selection)) return {
        ...pluginState,
        isQuickInsertAction: false,
        showDatePickerAt: tr.selection.from
    };
    else if (!$afd1413c588653ab$var$isDateNodeSelection(tr.selection) && !pluginState.isQuickInsertAction) {
        if (pluginState.showDatePickerAt) return {
            showDatePickerAt: null,
            isNew: false,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return pluginState;
    }
    return pluginState;
}
const $afd1413c588653ab$var$isDateNodeSelection = (selection)=>{
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const nodeTypeName = selection.node.type.name;
        return nodeTypeName === 'date';
    }
    return false;
};


const $ab0059a8179173ac$var$dest = (0, $cI8RZ.pluginFactory)((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), (0, $afd1413c588653ab$export$1650419e431d3ba3), {
    mapping: $afd1413c588653ab$export$83e1f26587c4acd2,
    onSelectionChanged: $afd1413c588653ab$export$8a0edcfd4a8a0397
});
const $ab0059a8179173ac$var$createPluginState = $ab0059a8179173ac$var$dest.createPluginState;
const $ab0059a8179173ac$export$f05434c51e3762e = $ab0059a8179173ac$var$dest.getPluginState;
const $ab0059a8179173ac$var$createPlugin = (pmPluginFactoryParams)=>{
    const { dispatch: dispatch } = pmPluginFactoryParams;
    const newPluginState = {
        showDatePickerAt: null,
        isNew: false,
        isDateEmpty: false,
        focusDateInput: false,
        isInitialised: true
    };
    return new (0, $kpCD8.SafePlugin)({
        state: $ab0059a8179173ac$var$createPluginState(dispatch, newPluginState),
        key: (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                date: (node, view, getPos, decorations)=>{
                    return new (0, $3705bb10050f2b09$export$9e959fa2f3aa27d3)(node, view, getPos, pmPluginFactoryParams.getIntl(), decorations);
                }
            }
        }
    });
};
var $ab0059a8179173ac$export$2e2bcd8739ae039 = $ab0059a8179173ac$var$createPlugin;


function $80232891f60757aa$export$e832373cff8dec22() {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.enter).common, (state, dispatch)=>{
        const datePlugin = (0, $ab0059a8179173ac$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (!datePlugin.showDatePickerAt) {
            (0, $00d64b18d9375627$export$621a48d450e82cf)()(state, dispatch);
            return true;
        }
        (0, $00d64b18d9375627$export$a903d799de0e4474)()(state, dispatch);
        return true;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch)=>{
        const datePlugin = (0, $ab0059a8179173ac$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (datePlugin.showDatePickerAt) {
            (0, $00d64b18d9375627$export$ba69c8aeb784b528)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $eBSR7.keymap)(list);
}
var $80232891f60757aa$export$2e2bcd8739ae039 = $80232891f60757aa$export$e832373cff8dec22;







parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");





var $cozmU = parcelRequire("cozmU");











var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $824lD = parcelRequire("824lD");


const $320d211daaeacc1d$export$972b9154c8ac4509 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert, source: source })=>{
        const tr = (0, $00d64b18d9375627$export$1a697965b9ed5436)(true)(insert(undefined));
        api?.analytics?.actions?.attachAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
            attributes: {
                inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).dateDescription),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: "//",
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).date)
    });
};


const $b48ae810281a361a$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNK.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJO.png'
};
const $b48ae810281a361a$export$e10c9b6465ac6d4a = ({ api: api })=>[
        {
            key: (0, $dCkbP.DATE_MENU_ITEM).key,
            type: (0, $dCkbP.DATE_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.DATE_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).dateDescription),
                    keywords: [
                        'calendar',
                        'day',
                        'time',
                        'today',
                        '/'
                    ],
                    shortcut: '//',
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).date)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $320d211daaeacc1d$export$972b9154c8ac4509), {
                    api: api,
                    previewImageUrls: $b48ae810281a361a$var$previewImageUrls
                })
        }
    ];



const $a7a03d9dfd431126$var$loadDatePicker = ()=>(parcelRequire("2CdFW")).then((mod)=>mod.default);

const $a7a03d9dfd431126$var$DatePickerLazy = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("2CdFW")).then((mod)=>mod.default));
const $a7a03d9dfd431126$var$DatePickerLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "g560h",
    name: "DatePickerLoadable",
    loader: $a7a03d9dfd431126$var$loadDatePicker,
    loading: ()=>null
});
const $a7a03d9dfd431126$var$DatePicker = (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a7a03d9dfd431126$var$DatePickerLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsx)($a7a03d9dfd431126$var$DatePickerLoadable, {
        ...props
    });
$a7a03d9dfd431126$var$DatePicker.preload = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $a7a03d9dfd431126$var$DatePickerLazy.preload() : $a7a03d9dfd431126$var$DatePickerLoadable.preload();
function $a7a03d9dfd431126$var$getDateNode(editorView, showDatePickerAt) {
    if (!editorView) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $bjg0G.findDomRefAtPos)(showDatePickerAt, domAtPos);
    // Resolves ED-23702 for when the date is wrapped in an inline comment
    const dateNode = element?.classList.contains((0, $e4nz6.DateSharedCssClassName).DATE_CONTAINER) ? element : element?.querySelector(`.${(0, $e4nz6.DateSharedCssClassName).DATE_CONTAINER}`);
    return dateNode || element;
}
function $a7a03d9dfd431126$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi, weekStartDay: weekStartDay }) {
    const { editorDisabledState: editorDisabledState, dateState: dateState } = (0, $4y8CY.useSharedPluginState)(dependencyApi, [
        'date',
        'editorDisabled'
    ]);
    if (!dateState?.showDatePickerAt || editorDisabledState?.editorDisabled) return null;
    const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = dateState;
    const dateNode = $a7a03d9dfd431126$var$getDateNode(editorView, showDatePickerAt);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($a7a03d9dfd431126$var$DatePicker, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: dateNode,
        isNew: isNew,
        autoFocus: focusDateInput,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDelete: ()=>{
            if (!editorView) return;
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$8993b403eaf979d2)(dependencyApi));
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSelect: (date, commitMethod)=>{
            // Undefined means couldn't parse date, null means invalid (out of bounds) date
            if (date === undefined || date === null) return;
            if (!editorView) return;
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                commitMethod: commitMethod
            }));
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onTextChanged: (date)=>{
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                enterPressed: false
            }));
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePicker: ()=>{
            if (!editorView) return;
            (0, $00d64b18d9375627$export$a903d799de0e4474)()(editorView.state, editorView.dispatch);
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePickerWithAnalytics: ({ date: date })=>{
            if (!editorView) return;
            (0, $00d64b18d9375627$export$7c3e79dfb4962626)({
                date: date
            })(editorView.state, editorView.dispatch);
            editorView.focus();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        weekStartDay: weekStartDay
    }, showDatePickerAt);
}
const $a7a03d9dfd431126$var$datePlugin = ({ config: config = {}, api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $b48ae810281a361a$export$e10c9b6465ac6d4a)({
        api: api
    }));
    return {
        name: 'date',
        getSharedState (editorState) {
            if (!editorState) return {
                showDatePickerAt: null,
                isNew: false,
                focusDateInput: false,
                isInitialised: true
            };
            const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput, isInitialised: isInitialised } = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(editorState) || {};
            return {
                showDatePickerAt: showDatePickerAt,
                isNew: !!isNew,
                focusDateInput: !!focusDateInput,
                isInitialised: !!isInitialised
            };
        },
        commands: {
            insertDate: (0, $eb817c60451a2df5$export$b606a931fa97541b)(api),
            deleteDate: (0, $eb817c60451a2df5$export$8993b403eaf979d2)(api)
        },
        nodes () {
            return [
                {
                    name: 'date',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $eq809.dateWithLocalId) : (0, $eq809.date)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'date',
                    plugin: (pmPluginFactoryParams)=>{
                        $a7a03d9dfd431126$var$DatePicker.preload();
                        return (0, $ab0059a8179173ac$export$2e2bcd8739ae039)(pmPluginFactoryParams);
                    }
                },
                {
                    name: 'dateKeymap',
                    plugin: ()=>{
                        $a7a03d9dfd431126$var$DatePicker.preload();
                        return (0, $80232891f60757aa$export$2e2bcd8739ae039)();
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($a7a03d9dfd431126$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                weekStartDay: config.weekStartDay
            });
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'date',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).date),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).dateDescription),
                            priority: 800,
                            keywords: [
                                'calendar',
                                'day',
                                'time',
                                'today',
                                '/'
                            ],
                            keyshortcut: '//',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDate), {}),
                            action (insert, state, source) {
                                const tr = (0, $00d64b18d9375627$export$e029667a62135fd0)(true)(state);
                                api?.analytics?.actions?.attachAnalyticsEvent?.({
                                    action: (0, $krYZG.ACTION).INSERTED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                                    attributes: {
                                        inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                    }
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CLICKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'date'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Date floating toolbar',
                    nodeType: [
                        state.schema.nodes.date
                    ],
                    getDomRef: (editorView)=>{
                        const dateState = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state);
                        const datePosition = dateState?.showDatePickerAt;
                        if (!datePosition) return undefined;
                        const domAtPos = editorView.domAtPos.bind(editorView);
                        const domRef = (0, $bjg0G.findDomRefAtPos)(datePosition, domAtPos);
                        const isHTMLElement = (element)=>{
                            return element instanceof HTMLElement;
                        };
                        if (isHTMLElement(domRef)) return domRef;
                        return undefined;
                    },
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Date floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && isViewMode() && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark;
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-date-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                                    description: intl.formatMessage((0, $83k8i.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
var $a7a03d9dfd431126$export$2e2bcd8739ae039 = $a7a03d9dfd431126$var$datePlugin;
module.exports["default"] = $a7a03d9dfd431126$export$2e2bcd8739ae039;

});

parcelRegister("9aR69", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");


var $58FyF = parcelRequire("58FyF");


var $fDAOo = parcelRequire("fDAOo");

var $b28e2808f9377f51$exports = {};
$parcel$export($b28e2808f9377f51$exports, "af", () => (parcelRequire("jdAIP")).default);
$parcel$export($b28e2808f9377f51$exports, "ar", () => (parcelRequire("lTSBl")).default);
$parcel$export($b28e2808f9377f51$exports, "arDZ", () => (parcelRequire("b7b2O")).default);
$parcel$export($b28e2808f9377f51$exports, "arEG", () => (parcelRequire("aAFll")).default);
$parcel$export($b28e2808f9377f51$exports, "arMA", () => (parcelRequire("aDiMe")).default);
$parcel$export($b28e2808f9377f51$exports, "arSA", () => (parcelRequire("cSVQD")).default);
$parcel$export($b28e2808f9377f51$exports, "arTN", () => (parcelRequire("c4IgH")).default);
$parcel$export($b28e2808f9377f51$exports, "az", () => (parcelRequire("f9xPZ")).default);
$parcel$export($b28e2808f9377f51$exports, "be", () => (parcelRequire("jmsQ6")).default);
$parcel$export($b28e2808f9377f51$exports, "beTarask", () => (parcelRequire("jhqet")).default);
$parcel$export($b28e2808f9377f51$exports, "bg", () => (parcelRequire("gCI9G")).default);
$parcel$export($b28e2808f9377f51$exports, "bn", () => (parcelRequire("gbABh")).default);
$parcel$export($b28e2808f9377f51$exports, "bs", () => (parcelRequire("gBLDk")).default);
$parcel$export($b28e2808f9377f51$exports, "ca", () => (parcelRequire("dNzyu")).default);
$parcel$export($b28e2808f9377f51$exports, "cs", () => (parcelRequire("8EGKX")).default);
$parcel$export($b28e2808f9377f51$exports, "cy", () => (parcelRequire("kLhpw")).default);
$parcel$export($b28e2808f9377f51$exports, "da", () => (parcelRequire("fIezj")).default);
$parcel$export($b28e2808f9377f51$exports, "de", () => (parcelRequire("d42EV")).default);
$parcel$export($b28e2808f9377f51$exports, "deAT", () => (parcelRequire("jiiAs")).default);
$parcel$export($b28e2808f9377f51$exports, "el", () => (parcelRequire("8RXQT")).default);
$parcel$export($b28e2808f9377f51$exports, "enAU", () => (parcelRequire("lGPlu")).default);
$parcel$export($b28e2808f9377f51$exports, "enCA", () => (parcelRequire("2Y0P5")).default);
$parcel$export($b28e2808f9377f51$exports, "enGB", () => (parcelRequire("8HKXv")).default);
$parcel$export($b28e2808f9377f51$exports, "enIE", () => (parcelRequire("hWN4g")).default);
$parcel$export($b28e2808f9377f51$exports, "enIN", () => (parcelRequire("kuDO4")).default);
$parcel$export($b28e2808f9377f51$exports, "enNZ", () => (parcelRequire("5FUh4")).default);
$parcel$export($b28e2808f9377f51$exports, "enUS", () => (parcelRequire("clx8d")).default);
$parcel$export($b28e2808f9377f51$exports, "enZA", () => (parcelRequire("aSFVd")).default);
$parcel$export($b28e2808f9377f51$exports, "eo", () => (parcelRequire("6unLC")).default);
$parcel$export($b28e2808f9377f51$exports, "es", () => (parcelRequire("gDEfH")).default);
$parcel$export($b28e2808f9377f51$exports, "et", () => (parcelRequire("czJqG")).default);
$parcel$export($b28e2808f9377f51$exports, "eu", () => (parcelRequire("jlS2G")).default);
$parcel$export($b28e2808f9377f51$exports, "faIR", () => (parcelRequire("eXL8E")).default);
$parcel$export($b28e2808f9377f51$exports, "fi", () => (parcelRequire("dqZrE")).default);
$parcel$export($b28e2808f9377f51$exports, "fr", () => (parcelRequire("k64l1")).default);
$parcel$export($b28e2808f9377f51$exports, "frCA", () => (parcelRequire("lFkXa")).default);
$parcel$export($b28e2808f9377f51$exports, "frCH", () => (parcelRequire("2p0ts")).default);
$parcel$export($b28e2808f9377f51$exports, "fy", () => (parcelRequire("aa0X5")).default);
$parcel$export($b28e2808f9377f51$exports, "gd", () => (parcelRequire("inBOb")).default);
$parcel$export($b28e2808f9377f51$exports, "gl", () => (parcelRequire("2gRR9")).default);
$parcel$export($b28e2808f9377f51$exports, "gu", () => (parcelRequire("lgykd")).default);
$parcel$export($b28e2808f9377f51$exports, "he", () => (parcelRequire("114nq")).default);
$parcel$export($b28e2808f9377f51$exports, "hi", () => (parcelRequire("68vmh")).default);
$parcel$export($b28e2808f9377f51$exports, "hr", () => (parcelRequire("c4pIC")).default);
$parcel$export($b28e2808f9377f51$exports, "ht", () => (parcelRequire("h3dgf")).default);
$parcel$export($b28e2808f9377f51$exports, "hu", () => (parcelRequire("5ykSD")).default);
$parcel$export($b28e2808f9377f51$exports, "hy", () => (parcelRequire("kOmGW")).default);
$parcel$export($b28e2808f9377f51$exports, "id", () => (parcelRequire("1ZhxU")).default);
$parcel$export($b28e2808f9377f51$exports, "is", () => (parcelRequire("5OgtV")).default);
$parcel$export($b28e2808f9377f51$exports, "it", () => (parcelRequire("9YZs4")).default);
$parcel$export($b28e2808f9377f51$exports, "itCH", () => (parcelRequire("56vLn")).default);
$parcel$export($b28e2808f9377f51$exports, "ja", () => (parcelRequire("lwYCg")).default);
$parcel$export($b28e2808f9377f51$exports, "jaHira", () => (parcelRequire("O69wG")).default);
$parcel$export($b28e2808f9377f51$exports, "ka", () => (parcelRequire("bDc9o")).default);
$parcel$export($b28e2808f9377f51$exports, "kk", () => (parcelRequire("5U0go")).default);
$parcel$export($b28e2808f9377f51$exports, "km", () => (parcelRequire("kNEVA")).default);
$parcel$export($b28e2808f9377f51$exports, "kn", () => (parcelRequire("dv5xe")).default);
$parcel$export($b28e2808f9377f51$exports, "ko", () => (parcelRequire("458wa")).default);
$parcel$export($b28e2808f9377f51$exports, "lb", () => (parcelRequire("a6iKE")).default);
$parcel$export($b28e2808f9377f51$exports, "lt", () => (parcelRequire("9Z9AE")).default);
$parcel$export($b28e2808f9377f51$exports, "lv", () => (parcelRequire("hskCx")).default);
$parcel$export($b28e2808f9377f51$exports, "mk", () => (parcelRequire("678Ci")).default);
$parcel$export($b28e2808f9377f51$exports, "mn", () => (parcelRequire("2QzpI")).default);
$parcel$export($b28e2808f9377f51$exports, "ms", () => (parcelRequire("5CNN8")).default);
$parcel$export($b28e2808f9377f51$exports, "mt", () => (parcelRequire("3SSHw")).default);
$parcel$export($b28e2808f9377f51$exports, "nb", () => (parcelRequire("3y6aU")).default);
$parcel$export($b28e2808f9377f51$exports, "nl", () => (parcelRequire("i6MM7")).default);
$parcel$export($b28e2808f9377f51$exports, "nlBE", () => (parcelRequire("3OBut")).default);
$parcel$export($b28e2808f9377f51$exports, "nn", () => (parcelRequire("blOmo")).default);
$parcel$export($b28e2808f9377f51$exports, "oc", () => (parcelRequire("h5aPN")).default);
$parcel$export($b28e2808f9377f51$exports, "pl", () => (parcelRequire("353ym")).default);
$parcel$export($b28e2808f9377f51$exports, "pt", () => (parcelRequire("8a7P0")).default);
$parcel$export($b28e2808f9377f51$exports, "ptBR", () => (parcelRequire("lBaG3")).default);
$parcel$export($b28e2808f9377f51$exports, "ro", () => (parcelRequire("29kXF")).default);
$parcel$export($b28e2808f9377f51$exports, "ru", () => (parcelRequire("gYfFg")).default);
$parcel$export($b28e2808f9377f51$exports, "sk", () => (parcelRequire("l2mTu")).default);
$parcel$export($b28e2808f9377f51$exports, "sl", () => (parcelRequire("bKFGE")).default);
$parcel$export($b28e2808f9377f51$exports, "sq", () => (parcelRequire("bL8hA")).default);
$parcel$export($b28e2808f9377f51$exports, "sr", () => (parcelRequire("1iyef")).default);
$parcel$export($b28e2808f9377f51$exports, "srLatn", () => (parcelRequire("6AuV3")).default);
$parcel$export($b28e2808f9377f51$exports, "sv", () => (parcelRequire("hVF75")).default);
$parcel$export($b28e2808f9377f51$exports, "ta", () => (parcelRequire("iZ7nC")).default);
$parcel$export($b28e2808f9377f51$exports, "te", () => (parcelRequire("cz4ad")).default);
$parcel$export($b28e2808f9377f51$exports, "th", () => (parcelRequire("9B6Ao")).default);
$parcel$export($b28e2808f9377f51$exports, "tr", () => (parcelRequire("azkPO")).default);
$parcel$export($b28e2808f9377f51$exports, "ug", () => (parcelRequire("fJC8B")).default);
$parcel$export($b28e2808f9377f51$exports, "uk", () => (parcelRequire("baKKw")).default);
$parcel$export($b28e2808f9377f51$exports, "uz", () => (parcelRequire("74d4N")).default);
$parcel$export($b28e2808f9377f51$exports, "uzCyrl", () => (parcelRequire("f2nvb")).default);
$parcel$export($b28e2808f9377f51$exports, "vi", () => (parcelRequire("28ZKr")).default);
$parcel$export($b28e2808f9377f51$exports, "zhCN", () => (parcelRequire("8tIg4")).default);
$parcel$export($b28e2808f9377f51$exports, "zhHK", () => (parcelRequire("l8E94")).default);
$parcel$export($b28e2808f9377f51$exports, "zhTW", () => (parcelRequire("bOvA7")).default);
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

var $jdAIP = parcelRequire("jdAIP");


var $lTSBl = parcelRequire("lTSBl");


var $b7b2O = parcelRequire("b7b2O");


var $aAFll = parcelRequire("aAFll");


var $aDiMe = parcelRequire("aDiMe");


var $cSVQD = parcelRequire("cSVQD");


var $c4IgH = parcelRequire("c4IgH");


var $f9xPZ = parcelRequire("f9xPZ");


var $jmsQ6 = parcelRequire("jmsQ6");


var $jhqet = parcelRequire("jhqet");


var $gCI9G = parcelRequire("gCI9G");


var $gbABh = parcelRequire("gbABh");


var $gBLDk = parcelRequire("gBLDk");


var $dNzyu = parcelRequire("dNzyu");


var $8EGKX = parcelRequire("8EGKX");


var $kLhpw = parcelRequire("kLhpw");


var $fIezj = parcelRequire("fIezj");


var $d42EV = parcelRequire("d42EV");


var $jiiAs = parcelRequire("jiiAs");


var $8RXQT = parcelRequire("8RXQT");


var $lGPlu = parcelRequire("lGPlu");


var $2Y0P5 = parcelRequire("2Y0P5");


var $8HKXv = parcelRequire("8HKXv");


var $hWN4g = parcelRequire("hWN4g");


var $kuDO4 = parcelRequire("kuDO4");


var $5FUh4 = parcelRequire("5FUh4");


var $clx8d = parcelRequire("clx8d");


var $aSFVd = parcelRequire("aSFVd");


var $6unLC = parcelRequire("6unLC");


var $gDEfH = parcelRequire("gDEfH");


var $czJqG = parcelRequire("czJqG");


var $jlS2G = parcelRequire("jlS2G");


var $eXL8E = parcelRequire("eXL8E");


var $dqZrE = parcelRequire("dqZrE");


var $k64l1 = parcelRequire("k64l1");


var $lFkXa = parcelRequire("lFkXa");


var $2p0ts = parcelRequire("2p0ts");


var $aa0X5 = parcelRequire("aa0X5");


var $inBOb = parcelRequire("inBOb");


var $2gRR9 = parcelRequire("2gRR9");


var $lgykd = parcelRequire("lgykd");


var $114nq = parcelRequire("114nq");


var $68vmh = parcelRequire("68vmh");


var $c4pIC = parcelRequire("c4pIC");


var $h3dgf = parcelRequire("h3dgf");


var $5ykSD = parcelRequire("5ykSD");


var $kOmGW = parcelRequire("kOmGW");


var $1ZhxU = parcelRequire("1ZhxU");


var $5OgtV = parcelRequire("5OgtV");


var $9YZs4 = parcelRequire("9YZs4");


var $56vLn = parcelRequire("56vLn");


var $lwYCg = parcelRequire("lwYCg");


var $O69wG = parcelRequire("O69wG");


var $bDc9o = parcelRequire("bDc9o");


var $5U0go = parcelRequire("5U0go");


var $kNEVA = parcelRequire("kNEVA");


var $dv5xe = parcelRequire("dv5xe");


var $458wa = parcelRequire("458wa");


var $a6iKE = parcelRequire("a6iKE");


var $9Z9AE = parcelRequire("9Z9AE");


var $hskCx = parcelRequire("hskCx");


var $678Ci = parcelRequire("678Ci");


var $2QzpI = parcelRequire("2QzpI");


var $5CNN8 = parcelRequire("5CNN8");


var $3SSHw = parcelRequire("3SSHw");


var $3y6aU = parcelRequire("3y6aU");


var $i6MM7 = parcelRequire("i6MM7");


var $3OBut = parcelRequire("3OBut");


var $blOmo = parcelRequire("blOmo");


var $h5aPN = parcelRequire("h5aPN");


var $353ym = parcelRequire("353ym");


var $8a7P0 = parcelRequire("8a7P0");


var $lBaG3 = parcelRequire("lBaG3");


var $29kXF = parcelRequire("29kXF");


var $gYfFg = parcelRequire("gYfFg");


var $l2mTu = parcelRequire("l2mTu");


var $bKFGE = parcelRequire("bKFGE");


var $bL8hA = parcelRequire("bL8hA");


var $1iyef = parcelRequire("1iyef");


var $6AuV3 = parcelRequire("6AuV3");


var $hVF75 = parcelRequire("hVF75");


var $iZ7nC = parcelRequire("iZ7nC");


var $cz4ad = parcelRequire("cz4ad");


var $9B6Ao = parcelRequire("9B6Ao");


var $azkPO = parcelRequire("azkPO");


var $fJC8B = parcelRequire("fJC8B");


var $baKKw = parcelRequire("baKKw");


var $74d4N = parcelRequire("74d4N");


var $f2nvb = parcelRequire("f2nvb");


var $28ZKr = parcelRequire("28ZKr");


var $8tIg4 = parcelRequire("8tIg4");


var $l8E94 = parcelRequire("l8E94");


var $bOvA7 = parcelRequire("bOvA7");




var $gd5kZ = parcelRequire("gd5kZ");

function $9eee334da367dc09$var$isDigit(c) {
    if (c === undefined) return false;
    return c >= '0' && c <= '9';
}
/**
 * Check if cursor is in first segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $9eee334da367dc09$var$isCursorInFirstDateSegment(cursorPos, date) {
    let posCounter = cursorPos - 1;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter >= 0 && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$9eee334da367dc09$var$isDigit(c)) isAdjacent = false;
        posCounter -= 1;
    }
    return isAdjacent;
}
/**
 * Check if cursor is in last segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $9eee334da367dc09$var$isCursorInLastDateSegment(cursorPos, date) {
    let posCounter = cursorPos;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter < strippedDate.length && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$9eee334da367dc09$var$isDigit(c)) isAdjacent = false;
        posCounter += 1;
    }
    return isAdjacent;
}
function $9eee334da367dc09$export$6e7fa6d67147cb9e(date) {
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
}
function $9eee334da367dc09$export$ff5a653e9ab9c0bc(position, date, locale) {
    if (position > date.length) return undefined;
    const placeholder = $9eee334da367dc09$export$a785060aa48542fa(locale);
    if (!placeholder) return undefined;
    // The placeholder without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPlaceholder = placeholder.replace(/[^ymd]+$/g, '');
    const keyToSegment = {
        d: 'day',
        m: 'month',
        y: 'year'
    };
    const firstSegment = keyToSegment[strippedPlaceholder[0]];
    const lastSegment = keyToSegment[strippedPlaceholder[strippedPlaceholder.length - 1]];
    const allPossibleSegments = [
        'day',
        'month',
        'year'
    ];
    const middleSegment = allPossibleSegments.filter((s)=>s !== firstSegment && s !== lastSegment)[0];
    if ($9eee334da367dc09$var$isCursorInFirstDateSegment(position, date)) return firstSegment;
    if ($9eee334da367dc09$var$isCursorInLastDateSegment(position, date)) return lastSegment;
    return middleSegment;
}
function $9eee334da367dc09$export$a785060aa48542fa(locale) {
    const uniqueDateType = {
        day: 7,
        month: 1,
        year: 1992
    };
    const localisedDateString = (0, $gd5kZ.formatDateType)(uniqueDateType, locale);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const shortDateFormat = localisedDateString.replace(/\d+/g, (str)=>{
        if (!str) return '';
        // Ignored via go/ees005
        // eslint-disable-next-line no-var
        var num = parseInt(str);
        switch(num % 100){
            case 92:
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                return str.replace(/.{1}/g, 'y');
            case 1:
                return str.length === 1 ? 'm' : 'mm';
            case 7:
                return str.length === 1 ? 'd' : 'dd';
        }
        return '';
    });
    return shortDateFormat;
}
function $9eee334da367dc09$export$6c4de3b0bb035f06(date, activeSegment, adjustment) {
    const originalDate = (0, $gd5kZ.dateTypeToDate)(date);
    const newDate = activeSegment === 'day' ? (0, $gkHoc.default)(originalDate, adjustment) : activeSegment === 'month' ? (0, $58FyF.default)(originalDate, adjustment) : (0, $fDAOo.default)(originalDate, adjustment);
    return (0, $gd5kZ.dateToDateType)(newDate);
}
function $9eee334da367dc09$export$629b0a497aa65267(date) {
    const today = new Date();
    return date !== undefined && today.getDate() === date.day && date.month === today.getMonth() + 1 && date.year === today.getFullYear();
}
function $9eee334da367dc09$export$1f30ec7fd3ecab15(localeString) {
    let dfLocaleString = localeString;
    const [lang, region] = localeString.split('-');
    if (region) {
        if (lang.toLocaleLowerCase() === region.toLocaleLowerCase()) dfLocaleString = lang;
        else dfLocaleString = `${lang}${region}`;
    }
    return $b28e2808f9377f51$exports[dfLocaleString];
}
module.exports["isDatePossiblyValid"] = $9eee334da367dc09$export$6e7fa6d67147cb9e;
module.exports["findDateSegmentByPosition"] = $9eee334da367dc09$export$ff5a653e9ab9c0bc;
module.exports["adjustDate"] = $9eee334da367dc09$export$6c4de3b0bb035f06;
module.exports["isToday"] = $9eee334da367dc09$export$629b0a497aa65267;
module.exports["getDFLocale"] = $9eee334da367dc09$export$1f30ec7fd3ecab15;

});

parcelRegister("czJqG", function(module, exports) {
var $e477044a82bd2f96$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $e477044a82bd2f96$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $e477044a82bd2f96$var$formatDistanceLocale[token].withPreposition : $e477044a82bd2f96$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $e477044a82bd2f96$export$2e2bcd8739ae039 = $e477044a82bd2f96$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e9682331b99adc7a$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $e9682331b99adc7a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e9682331b99adc7a$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $e9682331b99adc7a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e9682331b99adc7a$export$2e2bcd8739ae039 = $e9682331b99adc7a$var$formatLong;


var $50c37fe5632e4e2c$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $50c37fe5632e4e2c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $50c37fe5632e4e2c$var$formatRelativeLocale[token];
};
var $50c37fe5632e4e2c$export$2e2bcd8739ae039 = $50c37fe5632e4e2c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $c2f490467cae760e$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $c2f490467cae760e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $c2f490467cae760e$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $c2f490467cae760e$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $c2f490467cae760e$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $c2f490467cae760e$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $c2f490467cae760e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $c2f490467cae760e$var$localize = {
    ordinalNumber: $c2f490467cae760e$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c2f490467cae760e$export$2e2bcd8739ae039 = $c2f490467cae760e$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e53174e3f19300de$var$matchOrdinalNumberPattern = /^\d+\./i;
var $e53174e3f19300de$var$parseOrdinalNumberPattern = /\d+/i;
var $e53174e3f19300de$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $e53174e3f19300de$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $e53174e3f19300de$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $e53174e3f19300de$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e53174e3f19300de$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $e53174e3f19300de$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e53174e3f19300de$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $e53174e3f19300de$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $e53174e3f19300de$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $e53174e3f19300de$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $e53174e3f19300de$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e53174e3f19300de$var$matchOrdinalNumberPattern,
        parsePattern: $e53174e3f19300de$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e53174e3f19300de$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e53174e3f19300de$export$2e2bcd8739ae039 = $e53174e3f19300de$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $927bfe400ba2cf06$var$locale = {
    code: 'et',
    formatDistance: (0, $e477044a82bd2f96$export$2e2bcd8739ae039),
    formatLong: (0, $e9682331b99adc7a$export$2e2bcd8739ae039),
    formatRelative: (0, $50c37fe5632e4e2c$export$2e2bcd8739ae039),
    localize: (0, $c2f490467cae760e$export$2e2bcd8739ae039),
    match: (0, $e53174e3f19300de$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $927bfe400ba2cf06$export$2e2bcd8739ae039 = $927bfe400ba2cf06$var$locale;
module.exports["default"] = $927bfe400ba2cf06$export$2e2bcd8739ae039;

});

parcelRegister("5OgtV", function(module, exports) {
var $994385883795466b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $994385883795466b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $994385883795466b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $994385883795466b$export$2e2bcd8739ae039 = $994385883795466b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $38d726d96347f28c$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $38d726d96347f28c$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $38d726d96347f28c$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $38d726d96347f28c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $38d726d96347f28c$export$2e2bcd8739ae039 = $38d726d96347f28c$var$formatLong;


var $550bfc8a2a2f3ad6$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $550bfc8a2a2f3ad6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $550bfc8a2a2f3ad6$var$formatRelativeLocale[token];
};
var $550bfc8a2a2f3ad6$export$2e2bcd8739ae039 = $550bfc8a2a2f3ad6$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b48435fc1d309782$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $b48435fc1d309782$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $b48435fc1d309782$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $b48435fc1d309782$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $b48435fc1d309782$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $b48435fc1d309782$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $b48435fc1d309782$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b48435fc1d309782$var$localize = {
    ordinalNumber: $b48435fc1d309782$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b48435fc1d309782$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b48435fc1d309782$export$2e2bcd8739ae039 = $b48435fc1d309782$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6ac48a920acd9ffb$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $6ac48a920acd9ffb$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $6ac48a920acd9ffb$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $6ac48a920acd9ffb$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $6ac48a920acd9ffb$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $6ac48a920acd9ffb$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $6ac48a920acd9ffb$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $6ac48a920acd9ffb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $6ac48a920acd9ffb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $6ac48a920acd9ffb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $6ac48a920acd9ffb$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $6ac48a920acd9ffb$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $6ac48a920acd9ffb$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6ac48a920acd9ffb$var$matchOrdinalNumberPattern,
        parsePattern: $6ac48a920acd9ffb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6ac48a920acd9ffb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6ac48a920acd9ffb$export$2e2bcd8739ae039 = $6ac48a920acd9ffb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $43ae68338c4c54ac$var$locale = {
    code: 'is',
    formatDistance: (0, $994385883795466b$export$2e2bcd8739ae039),
    formatLong: (0, $38d726d96347f28c$export$2e2bcd8739ae039),
    formatRelative: (0, $550bfc8a2a2f3ad6$export$2e2bcd8739ae039),
    localize: (0, $b48435fc1d309782$export$2e2bcd8739ae039),
    match: (0, $6ac48a920acd9ffb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $43ae68338c4c54ac$export$2e2bcd8739ae039 = $43ae68338c4c54ac$var$locale;
module.exports["default"] = $43ae68338c4c54ac$export$2e2bcd8739ae039;

});

parcelRegister("8a7P0", function(module, exports) {
var $3ff0692d74bc5277$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $3ff0692d74bc5277$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3ff0692d74bc5277$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $3ff0692d74bc5277$export$2e2bcd8739ae039 = $3ff0692d74bc5277$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $44e6e748316960cd$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $44e6e748316960cd$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $44e6e748316960cd$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $44e6e748316960cd$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $44e6e748316960cd$export$2e2bcd8739ae039 = $44e6e748316960cd$var$formatLong;


var $4cdce5567d10ad59$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $4cdce5567d10ad59$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $4cdce5567d10ad59$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $4cdce5567d10ad59$export$2e2bcd8739ae039 = $4cdce5567d10ad59$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $398d9757f859a3bb$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $398d9757f859a3bb$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $398d9757f859a3bb$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $398d9757f859a3bb$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $398d9757f859a3bb$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $398d9757f859a3bb$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $398d9757f859a3bb$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $398d9757f859a3bb$var$localize = {
    ordinalNumber: $398d9757f859a3bb$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $398d9757f859a3bb$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $398d9757f859a3bb$export$2e2bcd8739ae039 = $398d9757f859a3bb$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0fb8ee16ab0196f1$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $0fb8ee16ab0196f1$var$parseOrdinalNumberPattern = /\d+/i;
var $0fb8ee16ab0196f1$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $0fb8ee16ab0196f1$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $0fb8ee16ab0196f1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $0fb8ee16ab0196f1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0fb8ee16ab0196f1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $0fb8ee16ab0196f1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0fb8ee16ab0196f1$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $0fb8ee16ab0196f1$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $0fb8ee16ab0196f1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $0fb8ee16ab0196f1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $0fb8ee16ab0196f1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0fb8ee16ab0196f1$var$matchOrdinalNumberPattern,
        parsePattern: $0fb8ee16ab0196f1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0fb8ee16ab0196f1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0fb8ee16ab0196f1$export$2e2bcd8739ae039 = $0fb8ee16ab0196f1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $5f15531e3796708e$var$locale = {
    code: 'pt',
    formatDistance: (0, $3ff0692d74bc5277$export$2e2bcd8739ae039),
    formatLong: (0, $44e6e748316960cd$export$2e2bcd8739ae039),
    formatRelative: (0, $4cdce5567d10ad59$export$2e2bcd8739ae039),
    localize: (0, $398d9757f859a3bb$export$2e2bcd8739ae039),
    match: (0, $0fb8ee16ab0196f1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5f15531e3796708e$export$2e2bcd8739ae039 = $5f15531e3796708e$var$locale;
module.exports["default"] = $5f15531e3796708e$export$2e2bcd8739ae039;

});

parcelRegister("29kXF", function(module, exports) {
var $4bbd032ac2ace480$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $4bbd032ac2ace480$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4bbd032ac2ace480$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $4bbd032ac2ace480$export$2e2bcd8739ae039 = $4bbd032ac2ace480$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $aca251c5c37b5e7b$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $aca251c5c37b5e7b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aca251c5c37b5e7b$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $aca251c5c37b5e7b$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aca251c5c37b5e7b$export$2e2bcd8739ae039 = $aca251c5c37b5e7b$var$formatLong;


var $ac1d87a10abd6524$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $ac1d87a10abd6524$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ac1d87a10abd6524$var$formatRelativeLocale[token];
};
var $ac1d87a10abd6524$export$2e2bcd8739ae039 = $ac1d87a10abd6524$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $d9c1c4a82ab82481$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $d9c1c4a82ab82481$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $d9c1c4a82ab82481$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $d9c1c4a82ab82481$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $d9c1c4a82ab82481$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $d9c1c4a82ab82481$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $d9c1c4a82ab82481$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $d9c1c4a82ab82481$var$localize = {
    ordinalNumber: $d9c1c4a82ab82481$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d9c1c4a82ab82481$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d9c1c4a82ab82481$export$2e2bcd8739ae039 = $d9c1c4a82ab82481$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $62e0192087014382$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $62e0192087014382$var$parseOrdinalNumberPattern = /\d+/i;
var $62e0192087014382$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $62e0192087014382$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $62e0192087014382$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $62e0192087014382$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $62e0192087014382$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $62e0192087014382$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $62e0192087014382$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $62e0192087014382$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $62e0192087014382$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $62e0192087014382$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $62e0192087014382$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $62e0192087014382$var$matchOrdinalNumberPattern,
        parsePattern: $62e0192087014382$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $62e0192087014382$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $62e0192087014382$export$2e2bcd8739ae039 = $62e0192087014382$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $190cae8838e8779e$var$locale = {
    code: 'ro',
    formatDistance: (0, $4bbd032ac2ace480$export$2e2bcd8739ae039),
    formatLong: (0, $aca251c5c37b5e7b$export$2e2bcd8739ae039),
    formatRelative: (0, $ac1d87a10abd6524$export$2e2bcd8739ae039),
    localize: (0, $d9c1c4a82ab82481$export$2e2bcd8739ae039),
    match: (0, $62e0192087014382$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $190cae8838e8779e$export$2e2bcd8739ae039 = $190cae8838e8779e$var$locale;
module.exports["default"] = $190cae8838e8779e$export$2e2bcd8739ae039;

});

parcelRegister("l2mTu", function(module, exports) {
function $818fdfa92abff722$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $818fdfa92abff722$var$declension(scheme, count, time) {
    var group = $818fdfa92abff722$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $818fdfa92abff722$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $818fdfa92abff722$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $818fdfa92abff722$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $818fdfa92abff722$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $818fdfa92abff722$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $818fdfa92abff722$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $818fdfa92abff722$var$extractPreposition(token) || '';
    var key = $818fdfa92abff722$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $818fdfa92abff722$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $818fdfa92abff722$var$prefixPreposition(preposition) + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $818fdfa92abff722$var$prefixPreposition(preposition) + 'o ' + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'future');
    else return $818fdfa92abff722$var$prefixPreposition(preposition) + 'pred ' + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'past');
};
var $818fdfa92abff722$export$2e2bcd8739ae039 = $818fdfa92abff722$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $59460d050055fa70$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $59460d050055fa70$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $59460d050055fa70$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $59460d050055fa70$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $59460d050055fa70$export$2e2bcd8739ae039 = $59460d050055fa70$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $3008a450de1e7950$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $3008a450de1e7950$var$_lastWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $3008a450de1e7950$var$thisWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $3008a450de1e7950$var$_nextWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $3008a450de1e7950$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $3008a450de1e7950$var$thisWeek(day);
        else return $3008a450de1e7950$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $3008a450de1e7950$var$thisWeek(day);
        else return $3008a450de1e7950$var$_nextWeek(day);
    },
    other: 'P'
};
var $3008a450de1e7950$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3008a450de1e7950$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $3008a450de1e7950$export$2e2bcd8739ae039 = $3008a450de1e7950$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $95698432c7fba7c7$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $95698432c7fba7c7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $95698432c7fba7c7$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $95698432c7fba7c7$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $95698432c7fba7c7$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $95698432c7fba7c7$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $95698432c7fba7c7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $95698432c7fba7c7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $95698432c7fba7c7$var$localize = {
    ordinalNumber: $95698432c7fba7c7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $95698432c7fba7c7$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $95698432c7fba7c7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $95698432c7fba7c7$export$2e2bcd8739ae039 = $95698432c7fba7c7$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $677b4734872d1549$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $677b4734872d1549$var$parseOrdinalNumberPattern = /\d+/i;
var $677b4734872d1549$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $677b4734872d1549$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $677b4734872d1549$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $677b4734872d1549$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $677b4734872d1549$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $677b4734872d1549$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $677b4734872d1549$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $677b4734872d1549$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $677b4734872d1549$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $677b4734872d1549$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $677b4734872d1549$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $677b4734872d1549$var$matchOrdinalNumberPattern,
        parsePattern: $677b4734872d1549$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $677b4734872d1549$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $677b4734872d1549$export$2e2bcd8739ae039 = $677b4734872d1549$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $f50b8b2a828eb3c5$var$locale = {
    code: 'sk',
    formatDistance: (0, $818fdfa92abff722$export$2e2bcd8739ae039),
    formatLong: (0, $59460d050055fa70$export$2e2bcd8739ae039),
    formatRelative: (0, $3008a450de1e7950$export$2e2bcd8739ae039),
    localize: (0, $95698432c7fba7c7$export$2e2bcd8739ae039),
    match: (0, $677b4734872d1549$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f50b8b2a828eb3c5$export$2e2bcd8739ae039 = $f50b8b2a828eb3c5$var$locale;
module.exports["default"] = $f50b8b2a828eb3c5$export$2e2bcd8739ae039;

});

parcelRegister("gd5kZ", function(module, exports) {

var $3vMGL = parcelRequire("3vMGL");

function $1b0e5ffb828996fc$export$9f54bd296c9b15c8(dateString, locale) {
    try {
        const l10n = (0, $3vMGL.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
}
function $1b0e5ffb828996fc$export$c1b0befbc45d5daf(date, locale) {
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $3vMGL.createLocalizationProvider)(locale);
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
}
function $1b0e5ffb828996fc$export$2071e1c033c380c7(date) {
    const { day: day, month: month, year: year } = date;
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return dateObj;
}
function $1b0e5ffb828996fc$export$e657ff381fe1e42a(date) {
    const dateObj = {
        day: date.getDate(),
        // The JS Date api represents month as a number between 0-11 :)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return dateObj;
}
module.exports["parseDateType"] = $1b0e5ffb828996fc$export$9f54bd296c9b15c8;
module.exports["formatDateType"] = $1b0e5ffb828996fc$export$c1b0befbc45d5daf;
module.exports["dateTypeToDate"] = $1b0e5ffb828996fc$export$2071e1c033c380c7;
module.exports["dateToDateType"] = $1b0e5ffb828996fc$export$e657ff381fe1e42a;

});

parcelRegister("2CdFW", function(module, exports) {

let $1e79bd117ae72163$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e79bd117ae72163$var$load("6C7Vr"),
    $1e79bd117ae72163$var$load("43ghN")
]).then(()=>parcelRequire('gu9AW'));

});

parcelRegister("k8SUN", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $chuMh = parcelRequire("chuMh");


var $7RQ8H = parcelRequire("7RQ8H");


var $krYZG = parcelRequire("krYZG");


var $jGK9e = parcelRequire("jGK9e");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $gx3UZ = parcelRequire("gx3UZ");


var $dX4zl = parcelRequire("dX4zl");


var $4o0zT = parcelRequire("4o0zT");


var $8QOo3 = parcelRequire("8QOo3");




parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");








var $dVKvM = parcelRequire("dVKvM");


var $26gmS = parcelRequire("26gmS");

const $2b7ab0141b432875$var$NODE_NAME = 'expand';
const $2b7ab0141b432875$var$ExpandBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.expand, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $2b7ab0141b432875$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26gmS))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand)
    });
};
const $2b7ab0141b432875$export$43e1eed033b6f3d3 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($2b7ab0141b432875$var$ExpandBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");





var $cozmU = parcelRequire("cozmU");








var $3k5Tv = parcelRequire("3k5Tv");





var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");








var $iDrrr = parcelRequire("iDrrr");


var $1A89X = parcelRequire("1A89X");




var $iLcY8 = parcelRequire("iLcY8");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $6DhDg = parcelRequire("6DhDg");


var $bjg0G = parcelRequire("bjg0G");

const $2edcbf582ab2a883$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $bjg0G.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};






var $kCECX = parcelRequire("kCECX");





var $4IGja = parcelRequire("4IGja");




const $54fefa0e11c7e40c$export$62b7afc61dbab067 = (state)=>(0, $bjg0G.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);



var $cI8RZ = parcelRequire("cI8RZ");




var $4a6536f156a9e236$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};


const $e948c98b413f4071$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('expandPlugin');
const $e948c98b413f4071$var$dest = (0, $cI8RZ.pluginFactory)($e948c98b413f4071$export$18d4026d1ea86bb1, (0, $4a6536f156a9e236$export$2e2bcd8739ae039));
const $e948c98b413f4071$export$656c7661095efe2e = $e948c98b413f4071$var$dest.createPluginState;
const $e948c98b413f4071$export$8d4021544bdece00 = $e948c98b413f4071$var$dest.createCommand;
const $e948c98b413f4071$export$f05434c51e3762e = $e948c98b413f4071$var$dest.getPluginState;


const $a8a297951f644d31$export$491ffa7e89016e5c = (ref)=>(0, $e948c98b413f4071$export$8d4021544bdece00)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a8a297951f644d31$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $kCECX.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $a8a297951f644d31$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) return false;
        return $a8a297951f644d31$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $a8a297951f644d31$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage) tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $a8a297951f644d31$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage) tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage ? isExpandedNext === true : isExpandedNext === false && (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state)) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $eaLat.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $iLcY8.PLATFORMS).WEB,
                    mode: (0, $iLcY8.MODE).EDITOR,
                    expanded: __livePage ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $a8a297951f644d31$export$b7c6a6a1365fc215 = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $4IGja.findTable)(state.selection);
    const isSelectionInExpand = (0, $54fefa0e11c7e40c$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $a8a297951f644d31$export$4782944d4b10fd76 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $a8a297951f644d31$export$b7c6a6a1365fc215(state);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $bjg0G.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $dX4zl.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT_ID).EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $a8a297951f644d31$export$982de01464f3ba33 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        return $a8a297951f644d31$export$4782944d4b10fd76(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $a8a297951f644d31$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $a8a297951f644d31$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $a8a297951f644d31$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        const iconContainer = expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $a8a297951f644d31$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kCECX.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $a8a297951f644d31$export$6f1dc7179cebfcb1 = (_selection)=>({ tr: _tr })=>{
        // this action exists so that we can keep the plugin types consistent across the
        // the legacy expand plugin and the single player expand plugin until
        // we will remove the legacy expand plugin
        return null;
    };


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");





































const $0c982aa6ebb943ef$export$b7c6a6a1365fc215 = (state, setExpandedState = true, addLocalId)=>{
    const { expand: expand, nestedExpand: nestedExpand, paragraph: paragraph } = state.schema.nodes;
    const isSelectionInTable = !!(0, $4IGja.findTable)(state.selection);
    const isSelectionInExpand = (0, $54fefa0e11c7e40c$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? expandType.createAndFill(addLocalId ? {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, $03RpJ.default)()
    } : {}, // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    paragraph.createAndFill(addLocalId ? {
        localId: (0, $03RpJ.default)()
    } : {})) : expandType.createAndFill({});
    if (setExpandedState) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $8QOo3.expandedState).set(expandNode, true);
    return expandNode;
};
const $0c982aa6ebb943ef$export$b07fdfa9172394f4 = (state, node)=>{
    const tr = (0, $dX4zl.createWrapSelectionTransaction)({
        state: state,
        type: node.type,
        nodeAttributes: node.attrs
    });
    const wrapperNode = (0, $bjg0G.findParentNodeOfType)(node.type)(tr.selection);
    if (wrapperNode) (0, $8QOo3.expandedState).set(wrapperNode.node, true);
    return tr;
};
const $0c982aa6ebb943ef$export$4782944d4b10fd76 = (api)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $0c982aa6ebb943ef$export$b7c6a6a1365fc215(state, false, !!api?.localId);
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $bjg0G.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $8QOo3.expandedState).set(expandNode, true);
            } else {
                tr = (0, $dX4zl.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type,
                    ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                        nodeAttributes: expandNode.attrs
                    }
                });
                const wrapperNode = (0, $bjg0G.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $8QOo3.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT_ID).EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (dispatch) {
                api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $0c982aa6ebb943ef$export$982de01464f3ba33 = (api)=>(state, dispatch)=>{
        return $0c982aa6ebb943ef$export$4782944d4b10fd76(api)((0, $krYZG.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $0c982aa6ebb943ef$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) return false;
        return $0c982aa6ebb943ef$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $0c982aa6ebb943ef$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $kCECX.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $0c982aa6ebb943ef$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kCECX.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $0c982aa6ebb943ef$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $8QOo3.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $8QOo3.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $eaLat.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $iLcY8.PLATFORMS).WEB,
                    mode: (0, $iLcY8.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            tr.setMeta('scrollIntoView', false);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $0c982aa6ebb943ef$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $0c982aa6ebb943ef$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $0c982aa6ebb943ef$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $0c982aa6ebb943ef$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        const iconContainer = expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $0c982aa6ebb943ef$export$6f1dc7179cebfcb1 = (selection)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        // if match is inside a nested expand, open the nested expand
        const nestedExpandNode = (0, $bjg0G.findParentNodeOfType)(nestedExpand)(selection);
        if (nestedExpandNode) {
            const expanded = (0, $8QOo3.expandedState).get(nestedExpandNode.node) ?? false;
            if (!expanded) (0, $8QOo3.expandedState).set(nestedExpandNode.node, true);
        }
        // if match is (also) inside an expand, open the expand
        const expandNode = (0, $bjg0G.findParentNodeOfType)(expand)(selection);
        if (expandNode) {
            const expanded = (0, $8QOo3.expandedState).get(expandNode.node) ?? false;
            if (!expanded) (0, $8QOo3.expandedState).set(expandNode.node, true);
        }
        return tr;
    };


const $52e093939a4eb20f$export$cedec9fb8118a90 = ({ api: api, isLegacy: isLegacy, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const { editorDisabled: editorDisabled, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorDisabled',
        'editorViewMode'
    ], (states)=>({
            editorDisabled: states.editorDisabledState?.editorDisabled,
            mode: states.editorViewModeState?.mode
        }));
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        const { state: state } = editorView;
        const node = isLegacy ? (0, $a8a297951f644d31$export$b7c6a6a1365fc215)(state) : (0, $0c982aa6ebb943ef$export$b7c6a6a1365fc215)(state, undefined, !!api?.localId);
        if (!node) return false;
        const tr = state.selection.empty ? insert(node) : isLegacy || !(0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $dX4zl.createWrapSelectionTransaction)({
            state: state,
            type: node.type
        }) : (0, $0c982aa6ebb943ef$export$b07fdfa9172394f4)(state, node);
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).EXPAND,
            attributes: {
                inputMethod: isLegacy ? (0, $krYZG.INPUT_METHOD).QUICK_INSERT : source
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api,
        isLegacy
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26gmS))), {
            label: ""
        }),
        isDisabled: editorDisabled || mode === 'view',
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand)
    });
};


const $422ae31eb69956e6$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKK.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH5.png'
};
const $422ae31eb69956e6$export$1d1b9ecd50e3e86c = ({ api: api, isLegacy: isLegacy })=>[
        {
            key: (0, $dCkbP.EXPAND_MENU_ITEM).key,
            type: (0, $dCkbP.EXPAND_MENU_ITEM).type,
            parents: [
                {
                    ...(0, $dCkbP.STRUCTURE_SECTION),
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.EXPAND_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
                    keywords: [
                        'accordion',
                        'collapse'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $52e093939a4eb20f$export$cedec9fb8118a90), {
                    api: api,
                    isLegacy: isLegacy,
                    previewImageUrls: $422ae31eb69956e6$var$previewImageUrls
                })
        }
    ];







var $ldqjS = parcelRequire("ldqjS");




var $1JP3v = parcelRequire("1JP3v");





var $2w79Z = parcelRequire("2w79Z");

var $9gS7U = parcelRequire("9gS7U");


var $44cyU = parcelRequire("44cyU");





var $5PIOe = parcelRequire("5PIOe");





const $1c0cfc448d4795e0$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $1c0cfc448d4795e0$var$isExpandSelected = (selection)=>selection instanceof (0, $kCECX.NodeSelection) && $1c0cfc448d4795e0$var$isExpandNode(selection.node);
function $1c0cfc448d4795e0$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($1c0cfc448d4795e0$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($1c0cfc448d4795e0$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($1c0cfc448d4795e0$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $a8a297951f644d31$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kCECX.TextSelection) && !(0, $5PIOe.isInTable)(state)) {
                const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $a8a297951f644d31$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9gS7U.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a8a297951f644d31$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $8QOo3.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$1c0cfc448d4795e0$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kCECX.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $a8a297951f644d31$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}



var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");





var $aPdNQ = parcelRequire("aPdNQ");


var $fud2r = parcelRequire("fud2r");

const $8d532e37d2ea1d00$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $fud2r.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};


var $jPUdw = parcelRequire("jPUdw");








parcelRequire("cozmU");





var $iqS60 = parcelRequire("iqS60");


var $eRJEr = parcelRequire("eRJEr");












var $cSuwJ = parcelRequire("cSuwJ");


var $btvbC = parcelRequire("btvbC");




var $5Md1j = parcelRequire("5Md1j");














var $8mvho = parcelRequire("8mvho");


var $1Iyfh = parcelRequire("1Iyfh");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $5SGpQ = parcelRequire("5SGpQ");








var $7Y8M5 = parcelRequire("7Y8M5");


var $aDSIl = parcelRequire("aDSIl");


var $lpNn5 = parcelRequire("lpNn5");

const $ed3672d169ecbf92$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { label: label } = this.props;
            return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                content: label,
                position: "top",
                tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)(WrapperComponent, this.props)));
        }
        constructor(props){
            super(props);
        }
    };
};
const $ed3672d169ecbf92$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = props;
    const useTheme = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $7Y8M5.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const label = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6DhDg.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $ed3672d169ecbf92$var$ButtonWithTooltip = $ed3672d169ecbf92$export$9a7250d72c34c156($ed3672d169ecbf92$export$aa86be27b687b166);
const $ed3672d169ecbf92$var$ButtonWithoutTooltip = $ed3672d169ecbf92$export$aa86be27b687b166;
const $ed3672d169ecbf92$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($ed3672d169ecbf92$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $cSuwJ.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($ed3672d169ecbf92$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};


function $c178cc331d60d3f0$var$buildExpandClassName(type, expanded) {
    return `${(0, $6DhDg.expandClassNames).prefix} ${(0, $6DhDg.expandClassNames).type(type)} ${expanded ? (0, $6DhDg.expandClassNames).expanded : ''}`;
}
function $c178cc331d60d3f0$export$4bb8383fcf1d1fef(title, intl) {
    const safeTitle = title.trim() || intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabelUntitled) || (0, $cSuwJ.messages).expandBodyAriaLabelUntitled.defaultMessage;
    return intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabel, {
        title: safeTitle
    }) || (0, $cSuwJ.messages).expandBodyAriaLabel.defaultMessage.replace('{title}', safeTitle);
}
const $c178cc331d60d3f0$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $c178cc331d60d3f0$var$buildExpandClassName(node.type.name, __livePage ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $6DhDg.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $6DhDg.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $6DhDg.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $6DhDg.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandArialabel) || (0, $cSuwJ.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $cSuwJ.messages).expandPlaceholderText) || (0, $cSuwJ.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            (0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') ? 'section' : 'div',
            {
                // prettier-ignore
                class: `${(0, $6DhDg.expandClassNames).content} ${(__livePage ? !node.attrs.__expanded : node.attrs.__expanded) ? '' : (0, $6DhDg.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...!(0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabelOriginal) || (0, $cSuwJ.messages).expandBodyAriaLabelOriginal.defaultMessage
                },
                ...(0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') && {
                    'aria-label': $c178cc331d60d3f0$export$4bb8383fcf1d1fef(node.attrs.title ?? '', intl),
                    'aria-description': intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaDescription) || (0, $cSuwJ.messages).expandBodyAriaDescription.defaultMessage,
                    'aria-roledescription': intl?.formatMessage((0, $cSuwJ.messages).expandBodyRoleDescription) ?? (0, $cSuwJ.messages).expandBodyRoleDescription.defaultMessage
                }
            },
            0
        ]
    ];
class $c178cc331d60d3f0$export$e6a0ba759c3724b0 {
    initHandlers() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            this.updateDisplayStyle(this.node);
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $ed3672d169ecbf92$export$e20de71cd82a9fe9), {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            }), this.icon, this.renderKey);
    }
    updateDisplayStyle(node) {
        const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
        if (this.content) {
            if (isCollapsed) this.content.classList.add((0, $6DhDg.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $6DhDg.expandClassNames).contentCollapsed);
        }
        // Collapsed vs expanded changes the reserved height, so re-apply the intrinsic-size estimate.
        if (this.dom) (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $5Md1j.estimateExpandIntrinsicHeight)(node, !isCollapsed)
            }));
    }
    isLimitedModeEnabled() {
        // Read from `this.view.state` via the exposed plugin key rather than the shared state's
        // `enabled`, which reads a stale `false` during initial EditorView construction (the injection
        // API's editor state isn't wired up yet).
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        return Boolean(this.api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey?.getState(this.view.state)?.enabled);
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // Re-apply in case limited mode flipped from disabled→enabled after the document loaded
            // (the flip is transaction-driven, so this update() fires once it becomes enabled).
            const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
            (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                    height: (0, $5Md1j.estimateExpandIntrinsicHeight)(node, !isCollapsed)
                }));
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $6DhDg.expandClassNames).expanded);
                    this.renderIcon(this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
                this.updateDisplayStyle(node);
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2')) {
                if (this.node.attrs.title !== node.attrs.title && this.content) this.content.setAttribute('aria-label', $c178cc331d60d3f0$export$4bb8383fcf1d1fef(node.attrs.title ?? '', this.intl));
            }
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            this.nodeViewPortalProviderAPI.remove(this.renderKey);
        }
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $a8a297951f644d31$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $iqS60.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $a8a297951f644d31$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a8a297951f644d31$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in legacyExpand, please also update the implementation in singlePlayerExpand
            if ((0, $ieeJu.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        const { state: state } = this.view;
                        this.view.focus();
                        this.api?.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, pos));
                            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                                const command = this.api?.blockControls?.commands.showControlAtPosition(pos, (0, $eRJEr.BLOCK_CONTROLS_DRAG_HANDLE), {
                                    isFocused: true
                                });
                                if (command) return command({
                                    tr: tr
                                });
                                return null;
                            }
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = dom.getAttribute('data-node-anchor');
                                    if (anchorName) {
                                        const command = this.api?.blockControls?.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            const keyName_result = (0, $iqS60.keyName)(event);
            switch(keyName_result){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteExpand = (_event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode)) (0, $a8a297951f644d31$export$ea222cb41be5bea0)(this.api?.analytics?.actions)(pos, expandNode)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a8a297951f644d31$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $eaLat.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $kCECX.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).End,
                    selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start,
                        selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $1Iyfh.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $8mvho.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        const { dom: _dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $c178cc331d60d3f0$var$toDOM(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = _dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).content}`);
        (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $5Md1j.estimateExpandIntrinsicHeight)(this.node, !this.isCollapsed())
            }));
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, $03RpJ.default)();
        this.renderIcon(this.intl);
        this.initHandlers();
    }
}
function $c178cc331d60d3f0$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $c178cc331d60d3f0$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}



function $5f72d7874b639371$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $5f72d7874b639371$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $e948c98b413f4071$export$656c7661095efe2e)(dispatch, {});
    const isMobile = false;
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        key: (0, $e948c98b413f4071$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                expand: (0, $c178cc331d60d3f0$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $c178cc331d60d3f0$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $5f72d7874b639371$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $5f72d7874b639371$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $5f72d7874b639371$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput);
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $6DhDg.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $5f72d7874b639371$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($5f72d7874b639371$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                    if (node) {
                        const expandRef = (0, $bjg0G.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $e948c98b413f4071$export$f05434c51e3762e)(state).expandRef !== expandRef) (0, $a8a297951f644d31$export$491ffa7e89016e5c)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $5f72d7874b639371$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $8d532e37d2ea1d00$export$447e90e618548243)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $jPUdw.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}



var $2xhuI = parcelRequire("2xhuI");


var $iDfTs = parcelRequire("iDfTs");



const $407719543fd209a1$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        // JST-1060364: We are observing this crashing the editor where the `expandPlugin` doesn't exist
        // in the editor (resulting in `Cannot destructure property 'expandRef' of ...`).
        // For now let's add a null check to ensure we don't crash while we investigate further.
        const { expandRef: expandRef } = (0, $e948c98b413f4071$export$f05434c51e3762e)(state) ?? {};
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                        onClick: (0, $a8a297951f644d31$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $2xhuI.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $f981a0fe8af5b8e6$var$EXPAND_NODE_NAME = 'expand';
let $f981a0fe8af5b8e6$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $2b7ab0141b432875$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($f981a0fe8af5b8e6$var$EXPAND_NODE_NAME))
        }
    ]);
    if (isRegisteredSlashCommandEnabled && options.allowInsertion === true) api?.uiControlRegistry?.actions.register((0, $422ae31eb69956e6$export$1d1b9ecd50e3e86c)({
        api: api,
        isLegacy: true
    }));
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $chuMh.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $7RQ8H.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $a8a297951f644d31$export$982de01464f3ba33)(api?.analytics?.actions),
            insertExpandWithInputMethod: (0, $a8a297951f644d31$export$4782944d4b10fd76)(api?.analytics?.actions)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $a8a297951f644d31$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $8QOo3.toggleExpandRange
        },
        getSharedState () {
            return {
                allowInsertion: options?.allowInsertion ?? true
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $5f72d7874b639371$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $1c0cfc448d4795e0$export$e4ebafd8ecd98be0)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $407719543fd209a1$export$86ce8f8241c20a3)(api),
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if (options && options.allowInsertion !== true) return [];
                    return [
                        {
                            id: 'expand',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
                            keywords: [
                                'accordion',
                                'collapse'
                            ],
                            priority: 600,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconExpand), {}),
                            action (insert, state) {
                                const node = (0, $a8a297951f644d31$export$b7c6a6a1365fc215)(state);
                                if (!node) return false;
                                const tr = state.selection.empty ? insert(node) : (0, $dX4zl.createWrapSelectionTransaction)({
                                    state: state,
                                    type: node.type
                                });
                                api?.analytics?.actions.attachAnalyticsEvent({
                                    action: (0, $krYZG.ACTION).INSERTED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).EXPAND,
                                    attributes: {
                                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ];
                }
            }
        }
    };
};





parcelRequire("cozmU");




































































const $93876d773a1ca2f9$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $93876d773a1ca2f9$var$isExpandSelected = (selection)=>selection instanceof (0, $kCECX.NodeSelection) && $93876d773a1ca2f9$var$isExpandNode(selection.node);
function $93876d773a1ca2f9$export$e4ebafd8ecd98be0(api) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($93876d773a1ca2f9$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($93876d773a1ca2f9$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($93876d773a1ca2f9$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $0c982aa6ebb943ef$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kCECX.TextSelection) && !(0, $5PIOe.isInTable)(state)) {
                const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $0c982aa6ebb943ef$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $8QOo3.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9gS7U.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $8QOo3.isExpandCollapsed)(expandBefore.node)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $8QOo3.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $8QOo3.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $8QOo3.isExpandCollapsed)(expandBefore.node)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$93876d773a1ca2f9$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kCECX.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}


















var $8nvEM = parcelRequire("8nvEM");







parcelRequire("cozmU");


















































/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 























function $d87386a2132b5ed7$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: props.label,
            position: "top",
            tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)(Component, props)));
    };
}
const $d87386a2132b5ed7$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $7Y8M5.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const { intl: intl, expanded: expanded } = props;
    const label = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6DhDg.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $d87386a2132b5ed7$var$ButtonWithTooltip = $d87386a2132b5ed7$var$withTooltip($d87386a2132b5ed7$export$aca20190620a52ea);
const $d87386a2132b5ed7$var$ButtonWithoutTooltip = $d87386a2132b5ed7$export$aca20190620a52ea;
const $d87386a2132b5ed7$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($d87386a2132b5ed7$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $cSuwJ.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($d87386a2132b5ed7$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

















const $6441cef4343e79ca$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $6DhDg.expandClassNames).prefix} ${(0, $6DhDg.expandClassNames).type(type)} ${expanded ? (0, $6DhDg.expandClassNames).expanded : ''}`;
};
const $6441cef4343e79ca$export$4bb8383fcf1d1fef = (title, intl)=>{
    const safeTitle = title.trim() || intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabelUntitled) || (0, $cSuwJ.messages).expandBodyAriaLabelUntitled.defaultMessage;
    return intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabel, {
        title: safeTitle
    }) || (0, $cSuwJ.messages).expandBodyAriaLabel.defaultMessage.replace('{title}', safeTitle);
};
const $6441cef4343e79ca$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $6441cef4343e79ca$export$f7373e0b2eb22549(node.type.name, (0, $8QOo3.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $6DhDg.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $6DhDg.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $6DhDg.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $6DhDg.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandArialabel) || (0, $cSuwJ.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $cSuwJ.messages).expandPlaceholderText) || (0, $cSuwJ.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            (0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') ? 'section' : 'div',
            {
                // prettier-ignore
                class: `${(0, $6DhDg.expandClassNames).content} ${(0, $8QOo3.expandedState).get(node) ? '' : (0, $6DhDg.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...!(0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabelOriginal) || (0, $cSuwJ.messages).expandBodyAriaLabelOriginal.defaultMessage
                },
                ...(0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') && {
                    'aria-label': $6441cef4343e79ca$export$4bb8383fcf1d1fef(node.attrs.title ?? '', intl),
                    'aria-description': intl?.formatMessage((0, $cSuwJ.messages).expandBodyAriaDescription) || (0, $cSuwJ.messages).expandBodyAriaDescription.defaultMessage,
                    'aria-roledescription': intl?.formatMessage((0, $cSuwJ.messages).expandBodyRoleDescription) ?? (0, $cSuwJ.messages).expandBodyRoleDescription.defaultMessage
                }
            },
            0
        ]
    ];








// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
const $b87e4c2ed4bd3870$var$darkModeSearchMatchClass = 'search-match-dark';
const $b87e4c2ed4bd3870$var$searchMatchExpandTitleClass = 'search-match-expand-title';
const $b87e4c2ed4bd3870$var$selectedSearchMatchClass = 'selected-search-match';
const $b87e4c2ed4bd3870$export$60784e18d5db1cae = (state)=>{
    const nestedOrParentExpand = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
    // If it's nested expand, we should check if its parent expand is collapsed.
    // If the parent expand is collapsed, the nested expand is not visible,
    // so it could not be selected.
    // In this case, we return the parent expand node instead of the nested expand node.
    if (nestedOrParentExpand?.node.type === state.schema.nodes.nestedExpand) {
        const parentExpand = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
        if (parentExpand && (0, $8QOo3.isExpandCollapsed)(parentExpand.node)) return parentExpand;
    }
    return nestedOrParentExpand;
};
const $b87e4c2ed4bd3870$export$ce3a0b3822605e07 = [
    $b87e4c2ed4bd3870$var$darkModeSearchMatchClass,
    $b87e4c2ed4bd3870$var$searchMatchExpandTitleClass,
    $b87e4c2ed4bd3870$var$selectedSearchMatchClass
];


class $6a4fe46449c2f369$export$e6a0ba759c3724b0 {
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // Sync up the aria-label with the current expand title.
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_expand_content_a11y_2') && this.node.attrs.title !== node.attrs.title && this.content) this.content.setAttribute('aria-label', (0, $6441cef4343e79ca$export$4bb8383fcf1d1fef)(node.attrs.title ?? '', this.intl));
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $8QOo3.expandedState).get(this.node);
                if (wasExpanded) (0, $8QOo3.expandedState).set(node, wasExpanded);
            }
            this.node = node;
            // Re-apply in case limited mode flipped from disabled→enabled after the document loaded
            // (the flip is transaction-driven, so this update() fires once it becomes enabled).
            (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                    height: (0, $5Md1j.estimateExpandIntrinsicHeight)(this.node, !(0, $8QOo3.isExpandCollapsed)(this.node))
                }));
            const currentExpanded = (0, $8QOo3.expandedState).get(node) ?? false;
            const hasChanged = this.isExpanded.expanded !== currentExpanded && this.isExpanded.localId === node.attrs.localId;
            if (hasChanged) {
                this.updateExpandToggleIcon(node);
                this.updateDisplayStyle(node);
            }
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $8QOo3.expandedState).get(node) ? (0, $8QOo3.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            const classes = this.dom.className.split(' ');
            // find & replace styles might be applied to the expand title and we need to keep them
            const findReplaceDecorationsApplied = classes.filter((className)=>(0, $b87e4c2ed4bd3870$export$ce3a0b3822605e07).includes(className)).join(' ');
            this.dom.className = findReplaceDecorationsApplied ? (0, $6441cef4343e79ca$export$f7373e0b2eb22549)(node.type.name, expanded) + ` ${findReplaceDecorationsApplied}` : (0, $6441cef4343e79ca$export$f7373e0b2eb22549)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            this.renderIcon(this.icon ?? null, (0, $8QOo3.expandedState).get(node) ?? false);
        }
        this.updateExpandBodyContentEditable();
        this.isExpanded = {
            expanded: expanded ?? false,
            localId: node.attrs.localId
        };
    }
    isLimitedModeEnabled() {
        // Read from `this.view.state` via the exposed plugin key rather than the shared state's
        // `enabled`, which reads a stale `false` during initial EditorView construction (the injection
        // API's editor state isn't wired up yet).
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        return Boolean(this.api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey?.getState(this.view.state)?.enabled);
    }
    updateDisplayStyle(node) {
        if (this.content) {
            if ((0, $8QOo3.isExpandCollapsed)(node)) this.content.classList.add((0, $6DhDg.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $6DhDg.expandClassNames).contentCollapsed);
        }
        // Collapsed vs expanded changes the reserved height, so re-apply the intrinsic-size estimate.
        (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $5Md1j.estimateExpandIntrinsicHeight)(node, !(0, $8QOo3.isExpandCollapsed)(node))
            }));
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    destroy() {
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        this.nodeViewPortalProviderAPI.remove(this.renderKey);
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange, isExpanded = {
        expanded: false
    }){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.isExpanded = isExpanded;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $0c982aa6ebb943ef$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $iqS60.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if ((0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $0c982aa6ebb943ef$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0c982aa6ebb943ef$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in singlePlayer expand, please also update the implementation in legacyExpand
            if ((0, $ieeJu.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        const { state: state } = this.view;
                        this.view.focus();
                        this.api?.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, pos));
                            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                                const command = this.api?.blockControls?.commands.showControlAtPosition(pos, (0, $eRJEr.BLOCK_CONTROLS_DRAG_HANDLE), {
                                    isFocused: true
                                });
                                if (command) return command({
                                    tr: tr
                                });
                                return null;
                            }
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? dom.getAttribute('data-node-anchor') : dom.getAttribute('data-drag-handler-anchor-name');
                                    if (anchorName) {
                                        const command = this.api?.blockControls?.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            switch((0, $iqS60.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode)) (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(this.api?.analytics?.actions)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0c982aa6ebb943ef$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $8QOo3.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $eaLat.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $kCECX.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).End,
                    selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start,
                        selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $1Iyfh.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $8mvho.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $8QOo3.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.renderIcon = (icon, expanded)=>{
            if (!icon) return;
            this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d87386a2132b5ed7$export$5663c8f5aeb8c1c4), {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                }), icon, this.renderKey);
        };
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        this.isExpanded.expanded = (0, $8QOo3.expandedState).get(_node) ?? false;
        this.isExpanded.localId = _node.attrs.localId;
        const editorDisabled = api?.editorDisabled?.sharedState.currentState()?.editorDisabled;
        const { dom: _dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $6441cef4343e79ca$export$289411c5a7970646)(_node, this.__livePage, this.intl, editorDisabled, !editorDisabled && !(0, $8QOo3.isExpandCollapsed)(_node)));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = _dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleContainer}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, $03RpJ.default)();
        this.content = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).content}`);
        if (!(0, $8QOo3.expandedState).has(this.node)) (0, $8QOo3.expandedState).set(this.node, false);
        (0, $5Md1j.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $5Md1j.estimateExpandIntrinsicHeight)(this.node, !(0, $8QOo3.isExpandCollapsed)(this.node))
            }));
        this.renderIcon(this.icon, !(0, $8QOo3.isExpandCollapsed)(this.node));
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) {
            if ((0, $4o0zT.isExperimentEnabled)('cc_editor_limited_mode_perf_improvements')) {
                if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
                this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
                    const editorDisabled = sharedState.nextSharedState.editorDisabled;
                    if (this.input) {
                        if (editorDisabled) this.input.setAttribute('readonly', 'true');
                        else this.input.removeAttribute('readonly');
                    }
                    const nextContentEditableValue = this.getContentEditable(this.node) ? 'true' : 'false';
                    if (this.content && this.content.getAttribute('contenteditable') !== nextContentEditableValue) this.content.setAttribute('contenteditable', nextContentEditableValue);
                });
            } else this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
                const editorDisabled = sharedState.nextSharedState.editorDisabled;
                if (this.input) {
                    if (editorDisabled) this.input.setAttribute('readonly', 'true');
                    else this.input.removeAttribute('readonly');
                }
                if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            });
        }
    }
}
function $6a4fe46449c2f369$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $6a4fe46449c2f369$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}


const $f72d3c01a1d68f80$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('expandPlugin');
function $f72d3c01a1d68f80$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $f72d3c01a1d68f80$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $kpCD8.SafePlugin)({
        key: $f72d3c01a1d68f80$export$18d4026d1ea86bb1,
        state: {
            init () {
                return (0, $8nvEM.DecorationSet).empty;
            },
            apply (tr, decorationSet) {
                const meta = tr.getMeta((0, $8QOo3.TOGGLE_EXPAND_RANGE_META_KEY));
                if (meta && meta.positions.length > 0) {
                    // Add node decorations for each expand node that was toggled.
                    // ExpandNodeView.update() uses these decorations to detect it needs to
                    // visually open or close, even when expandedState was set before the
                    // transaction replaced the node objects.
                    // We do NOT map or carry forward existing decorations — we start fresh
                    // each time the meta is present.
                    const decorations = meta.positions.map((pos)=>(0, $8nvEM.Decoration).node(pos, pos + (tr.doc.nodeAt(pos)?.nodeSize ?? 0), {}, {
                            forceExpandOpen: meta.open
                        }));
                    return (0, $8nvEM.DecorationSet).create(tr.doc, decorations);
                }
                // Map existing decorations through document changes.
                // They will be naturally cleared when they no longer match any node
                // (e.g. if the expand is deleted), or on the next toggleExpandRange call.
                return decorationSet.map(tr.mapping, tr.doc);
            }
        },
        props: {
            decorations (state) {
                return $f72d3c01a1d68f80$export$18d4026d1ea86bb1.getState(state);
            },
            nodeViews: {
                expand: (0, $6a4fe46449c2f369$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $6a4fe46449c2f369$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput);
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $6DhDg.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $f72d3c01a1d68f80$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($f72d3c01a1d68f80$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        }
    });
};
function $f72d3c01a1d68f80$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $8d532e37d2ea1d00$export$447e90e618548243)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $jPUdw.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}













const $52f36ed40f63035d$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const selectedExpandNode = (0, $b87e4c2ed4bd3870$export$60784e18d5db1cae)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>// Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $bjg0G.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                        onClick: (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $2xhuI.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $5073fc174b6771a9$var$EXPAND_NODE_NAME = 'expand';
let $5073fc174b6771a9$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $2b7ab0141b432875$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($5073fc174b6771a9$var$EXPAND_NODE_NAME))
        }
    ]);
    if (isRegisteredSlashCommandEnabled && options.allowInsertion === true) api?.uiControlRegistry?.actions.register((0, $422ae31eb69956e6$export$1d1b9ecd50e3e86c)({
        api: api,
        isLegacy: false
    }));
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $chuMh.expandWithNestedExpandLocalId) : (0, $chuMh.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $7RQ8H.nestedExpandWithLocalId) : (0, $7RQ8H.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $0c982aa6ebb943ef$export$982de01464f3ba33)(api),
            insertExpandWithInputMethod: (0, $0c982aa6ebb943ef$export$4782944d4b10fd76)(api)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $0c982aa6ebb943ef$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $8QOo3.toggleExpandRange
        },
        getSharedState () {
            return {
                allowInsertion: options?.allowInsertion ?? true
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $f72d3c01a1d68f80$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $93876d773a1ca2f9$export$e4ebafd8ecd98be0)(api)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $52f36ed40f63035d$export$86ce8f8241c20a3)(api),
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if (options && options.allowInsertion !== true) return [];
                    return [
                        {
                            id: 'expand',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
                            keywords: [
                                'accordion',
                                'collapse'
                            ],
                            priority: 600,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconExpand), {}),
                            action (insert, state, source) {
                                const node = (0, $0c982aa6ebb943ef$export$b7c6a6a1365fc215)(state, undefined, !!api?.localId);
                                if (!node) return false;
                                const tr = state.selection.empty ? insert(node) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $0c982aa6ebb943ef$export$b07fdfa9172394f4)(state, node) : (0, $dX4zl.createWrapSelectionTransaction)({
                                    state: state,
                                    type: node.type
                                });
                                api?.analytics?.actions.attachAnalyticsEvent({
                                    action: (0, $krYZG.ACTION).INSERTED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).EXPAND,
                                    attributes: {
                                        inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ];
                }
            }
        }
    };
};


let $20d6b4b6e3117d77$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options?.__livePage) return (0, $5073fc174b6771a9$export$a4a90f0c2a6f7a01)({
        config: options,
        api: api
    });
    else {
        if ((0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) return (0, $5073fc174b6771a9$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
        else return (0, $f981a0fe8af5b8e6$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
    }
};
module.exports["expandPlugin"] = $20d6b4b6e3117d77$export$a4a90f0c2a6f7a01;

});

parcelRegister("dGnqc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $6OREF = parcelRequire("6OREF");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $4o0zT = parcelRequire("4o0zT");

var $24df8e09ab5ab032$export$29dff82773c5f10f = /*#__PURE__*/ function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
    return FindReplaceActionTypes;
}({});



var $cI8RZ = parcelRequire("cI8RZ");

var $gLqwM = parcelRequire("gLqwM");














const $84528c133539f16c$export$e7697da71e34f0a6 = new (0, $kCECX.PluginKey)('findReplace');


const $1165d80eb39a2324$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $8nvEM.DecorationSet).empty,
    shouldMatchCase: false
};
const $1165d80eb39a2324$export$ae829ec7b2625219 = (dispatch, getIntl, api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $84528c133539f16c$export$e7697da71e34f0a6),
        state: (0, $4981acfba9bf358a$export$656c7661095efe2e)(dispatch, ()=>({
                ...$1165d80eb39a2324$export$d4c72bab9d6cc13a,
                getIntl: getIntl,
                api: api
            })),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });
};




const $a28db421455a435a$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE:
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE:
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).CANCEL:
                const { getIntl: getIntl, api: api } = state;
                return {
                    ...getInitialState(),
                    getIntl: getIntl,
                    api: api
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $a28db421455a435a$export$2e2bcd8739ae039 = $a28db421455a435a$var$reducer;



var $5X6fy = parcelRequire("5X6fy");


var $efgwK = parcelRequire("efgwK");








var $cLgZp = parcelRequire("cLgZp");


var $cRgxl = parcelRequire("cRgxl");


var $caelp = parcelRequire("caelp");


var $gqUuL = parcelRequire("gqUuL");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $517b5dd498d7c267$export$cec6db4af40340f0 = 'search-match';
const $517b5dd498d7c267$export$a19ecadc9ecc39b1 = 'search-match-text';
const $517b5dd498d7c267$export$bf208a338b2a2f1f = 'selected-search-match';
const $517b5dd498d7c267$export$bb09fa712812841f = 'search-match-block';
const $517b5dd498d7c267$export$99146b4c1ad5837a = 'search-match-block-selected';
const $517b5dd498d7c267$export$6cc90c491f952538 = 'search-match-dark';
const $517b5dd498d7c267$export$2414358ab66f419a = 'search-match-expand-title';


function $445be20723a3c870$export$4391514644a718d(nodes) {
    let result = '';
    for (const node of nodes){
        if ((node.type === 'expand' || node.type === 'nestedExpand') && node.attrs?.title) result += node.attrs.title;
        if (node.text != null) // Inline text node — concatenate directly (text already carries its own whitespace)
        result += node.text;
        else if (node.content) {
            // Block-level node — add a space separator to prevent false matches across block boundaries
            if (result.length > 0) result += ' ';
            result += $445be20723a3c870$export$4391514644a718d(node.content);
        }
    }
    return result;
}
function $445be20723a3c870$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $445be20723a3c870$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end, canReplace: canReplace, nodeType: nodeType }, i)=>$445be20723a3c870$export$83df86cadabd260({
            start: start,
            end: end,
            canReplace: canReplace,
            nodeType: nodeType
        }, i === selectedIndex));
const $445be20723a3c870$var$isElement = (nodeType)=>[
        'blockCard',
        'embedCard',
        'inlineCard',
        'status',
        'mention',
        'date',
        'syncBlock'
    ].includes(nodeType || '');
const $445be20723a3c870$var$isExpandTitle = (match)=>[
        'expand',
        'nestedExpand'
    ].includes(match.nodeType || '') && !match.canReplace;
const $445be20723a3c870$export$83df86cadabd260 = (match, isSelected)=>{
    const { start: start, end: end, nodeType: nodeType } = match;
    const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
    if ($445be20723a3c870$var$isElement(nodeType)) {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$bb09fa712812841f), {
            [(0, $517b5dd498d7c267$export$99146b4c1ad5837a)]: isSelected,
            [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
        });
        return (0, $8nvEM.Decoration).node(start, end, {
            class: className
        });
    } else if ($445be20723a3c870$var$isExpandTitle(match)) {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$2414358ab66f419a), {
            [(0, $517b5dd498d7c267$export$bf208a338b2a2f1f)]: isSelected,
            [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
        });
        return (0, $8nvEM.Decoration).node(start, end, {
            class: className
        });
    } else {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$a19ecadc9ecc39b1), {
            [(0, $517b5dd498d7c267$export$bf208a338b2a2f1f)]: isSelected,
            [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
        });
        return (0, $8nvEM.Decoration).inline(start, end, {
            class: className
        });
    }
};
function $445be20723a3c870$export$f4585c00f32d9257({ content: content, searchText: searchText, shouldMatchCase: shouldMatchCase, contentIndex: contentIndex = 0, getIntl: getIntl, api: api }) {
    const matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectTextMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text } = textGrouping;
        const { pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end,
                canReplace: true,
                nodeType: 'text'
            });
            index = text.indexOf(searchText, end);
        }
    };
    const collectNodeMatch = (textGrouping, node)=>{
        if (!textGrouping) return;
        const { pos: pos } = textGrouping;
        let { text: text } = textGrouping;
        if (node.type.name === 'status' && shouldMatchCase) text = text.toUpperCase();
        else if (!shouldMatchCase) {
            text = text.toLowerCase();
            searchText = searchText.toLowerCase();
        }
        const index = text.indexOf(searchText);
        if (index !== -1) matches.push({
            start: pos,
            end: pos + node.nodeSize,
            canReplace: false,
            nodeType: node.type.name
        });
    };
    const collectCardTitleMatch = (node, pos)=>{
        const cards = api?.card?.sharedState.currentState()?.cards;
        if (cards) {
            const relevantCard = cards.find((card)=>card.url === node.attrs.url);
            const title = relevantCard?.title;
            if (relevantCard) {
                if (title) collectNodeMatch({
                    text: title,
                    pos: pos
                }, node);
                else // when there is no title, e.g. in an error case like unauthorized
                // the link card just shows the entire url as the title in inline card
                if (node.type.name === 'inlineCard') collectNodeMatch({
                    text: node.attrs.url,
                    pos: pos
                }, node);
            }
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text = textGrouping.text + node.text;
            } else {
                collectTextMatch(textGrouping);
                textGrouping = null;
                switch(node.type.name){
                    case 'status':
                        collectNodeMatch({
                            text: node.attrs.text,
                            pos: pos
                        }, node);
                        break;
                    case 'date':
                        collectNodeMatch({
                            text: (0, $efgwK.timestampToString)(node.attrs.timestamp, getIntl ? getIntl() : null),
                            pos: pos
                        }, node);
                        break;
                    case 'expand':
                    case 'nestedExpand':
                        collectNodeMatch({
                            text: node.attrs.title,
                            pos: pos
                        }, node);
                        break;
                    case 'mention':
                        let text;
                        if (node.attrs.text) text = node.attrs.text;
                        else {
                            // the text may be sanitised from the node for privacy reasons
                            // so we need to use the mentionProvider to resolve it
                            const mentionProvider = api?.mention?.sharedState.currentState()?.mentionProvider;
                            if ((0, $cRgxl.isResolvingMentionProvider)(mentionProvider)) {
                                const nameDetail = mentionProvider.resolveMentionName(node.attrs.id);
                                if ((0, $cLgZp.isPromise)(nameDetail)) text = '@...';
                                else if (nameDetail.status === (0, $caelp.MentionNameStatus).OK) text = `@${nameDetail.name || ''}`;
                                else text = '@_|unknown|_';
                            }
                        }
                        if (text) collectNodeMatch({
                            text: text,
                            pos: pos
                        }, node);
                        break;
                    case 'inlineCard':
                    case 'blockCard':
                    case 'embedCard':
                        collectCardTitleMatch(node, pos);
                        break;
                    case 'syncBlock':
                        {
                            const syncBlockStore = api?.syncedBlock?.sharedState.currentState()?.syncBlockStore;
                            const instance = syncBlockStore?.referenceManager.getFromCache(node.attrs.resourceId);
                            const adfContent = instance?.data?.content;
                            if (adfContent && adfContent.length > 0) {
                                const text = $445be20723a3c870$export$4391514644a718d(adfContent);
                                if (text) collectNodeMatch({
                                    text: text,
                                    pos: pos
                                }, node);
                            }
                            break;
                        }
                    default:
                        break;
                }
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectTextMatch, manually collectTextMatch
        if (textGrouping) collectTextMatch(textGrouping);
    }
    return matches;
}
function $445be20723a3c870$export$6df7393992287695(selectionPos, matches) {
    const forwardMatchIndex = matches.findIndex((match)=>match.start >= selectionPos);
    if (forwardMatchIndex === -1) // if there are no forward matches, it must be the last match
    return matches.length > 0 ? matches.length - 1 : 0;
    else if (forwardMatchIndex === 0) return forwardMatchIndex;
    const backwardMatchIndex = forwardMatchIndex - 1;
    const forwardMatchPos = matches[forwardMatchIndex].start;
    const backwardMatchPos = matches[backwardMatchIndex].start;
    if (forwardMatchPos - selectionPos < selectionPos - backwardMatchPos) return forwardMatchIndex;
    else return backwardMatchIndex;
}
function $445be20723a3c870$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $445be20723a3c870$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $445be20723a3c870$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $445be20723a3c870$var$isSyncBlock = (match)=>match.nodeType === 'syncBlock';
const $445be20723a3c870$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) {
        if ($445be20723a3c870$var$isExpandTitle(matches[index]) || $445be20723a3c870$var$isSyncBlock(matches[index])) return (0, $kCECX.NodeSelection).create(doc, matches[index].start);
        return (0, $kCECX.TextSelection).create(doc, matches[index].start + offset);
    }
    return selection;
};
const $445be20723a3c870$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $445be20723a3c870$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    const lostDecorations = $445be20723a3c870$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $445be20723a3c870$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$445be20723a3c870$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $445be20723a3c870$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $445be20723a3c870$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $445be20723a3c870$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $445be20723a3c870$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $445be20723a3c870$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $445be20723a3c870$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};
function $445be20723a3c870$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}


const $4981acfba9bf358a$var$handleDocChanged = (tr, pluginState)=>{
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $gLqwM.stepHasSlice))) return pluginState;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, decorationSet: decorationSet, matches: matches, shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = pluginState;
    const newMatches = (0, $445be20723a3c870$export$f4585c00f32d9257)({
        content: tr.doc,
        searchText: findText,
        shouldMatchCase: shouldMatchCase,
        getIntl: getIntl,
        api: api
    });
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end),
            canReplace: match.canReplace,
            nodeType: match.nodeType
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $8nvEM.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $gLqwM.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $445be20723a3c870$export$7d11bfeb87290a13)(match, step, tr) && !(0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $445be20723a3c870$export$bb98a54aeaa7e0c0)(mappedMatches.filter((match)=>(0, $445be20723a3c870$export$7d11bfeb87290a13)(match, step, tr) && !!(0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $445be20723a3c870$export$2393fad6cd7faeee)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $445be20723a3c870$export$6df7393992287695)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $445be20723a3c870$export$b5b5304233807f24)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $445be20723a3c870$export$2393fad6cd7faeee)(0, [
        newSelectedMatch
    ]));
    const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, newMatches);
    api?.expand?.commands.toggleExpandWithMatch(newSelection)({
        tr: tr
    });
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const $4981acfba9bf358a$var$dest = (0, $cI8RZ.pluginFactory)((0, $84528c133539f16c$export$e7697da71e34f0a6), (0, $a28db421455a435a$export$2e2bcd8739ae039)(()=>(0, $1165d80eb39a2324$export$d4c72bab9d6cc13a)), {
    onDocChanged: $4981acfba9bf358a$var$handleDocChanged
});
const $4981acfba9bf358a$export$8d4021544bdece00 = $4981acfba9bf358a$var$dest.createCommand;
const $4981acfba9bf358a$export$f05434c51e3762e = $4981acfba9bf358a$var$dest.getPluginState;
const $4981acfba9bf358a$export$656c7661095efe2e = $4981acfba9bf358a$var$dest.createPluginState;





// max number of decorations to apply at once
const $741d4c9951586a77$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $741d4c9951586a77$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $741d4c9951586a77$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
   * Applies the decorations needed for the current search results
   * It does so async, splitting them up into batches to help with performance
   */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $741d4c9951586a77$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $741d4c9951586a77$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $741d4c9951586a77$var$posIncrement));
        } else {
            after = Math.min(after + $741d4c9951586a77$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $741d4c9951586a77$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            const matchesToDecorate = matchesBetween.slice(counter, counter + $741d4c9951586a77$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $741d4c9951586a77$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $741d4c9951586a77$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $445be20723a3c870$export$2393fad6cd7faeee)(useSelectionIndex ? selectionIndex % $741d4c9951586a77$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $741d4c9951586a77$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $741d4c9951586a77$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $741d4c9951586a77$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
   * Calculates Prosemirror start and end positions we want to apply the decorations
   * between
   * Also calculates the positions the are the start and end of the user's viewport
   * so we can apply decorations there first and work outwards
   */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: 0,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return startPos ? startPos.pos : 0;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
   * Util to batch function calls by animation frames
   * A counter will start at 0 and increment by provided value until reaches limit
   * Passed in fn receives the counter as a param, return false to skip waiting
   * for the animation frame for the next call
   */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
    constructor(){
        this.rafId = void 0;
        this.addDecorations = void 0;
        this.removeDecorations = void 0;
    }
}
const $741d4c9951586a77$var$batchDecorations = new $741d4c9951586a77$var$BatchDecorations();
var $741d4c9951586a77$export$2e2bcd8739ae039 = $741d4c9951586a77$var$batchDecorations;


const $4a0f603b6c72d7f3$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            if (view) {
                let targetPos = tr.selection.anchor;
                let coords = view.coordsAtPos(targetPos);
                // If element is not visible (coords are invalid), try parent nodes
                if (coords.top === coords.bottom || coords.top === 0) {
                    const $pos = tr.selection.$anchor;
                    let depth = $pos.depth;
                    while(depth > 0 && (coords.top === coords.bottom || coords.top === 0)){
                        targetPos = $pos.before(depth);
                        coords = view.coordsAtPos(targetPos);
                        depth--;
                    }
                }
                // Find the closest scrollable parent element
                let scrollParent = view.dom;
                while(scrollParent && scrollParent !== document.documentElement){
                    const style = window.getComputedStyle(scrollParent);
                    const overflowY = style.overflowY;
                    const overflowX = style.overflowX;
                    const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowX === 'auto' || overflowX === 'scroll') && (scrollParent.scrollHeight > scrollParent.clientHeight || scrollParent.scrollWidth > scrollParent.clientWidth);
                    if (isScrollable) break;
                    scrollParent = scrollParent.parentElement;
                }
                // Scroll to center the content
                if (scrollParent && scrollParent !== document.documentElement) {
                    const parentRect = scrollParent.getBoundingClientRect();
                    const scrollTop = scrollParent.scrollTop + coords.top - parentRect.top - parentRect.height / 2 + (coords.bottom - coords.top) / 2;
                    scrollParent.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth'
                    });
                }
            } else tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);


const $598aa076e480bbc7$export$234c45b355edd85b = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $kCECX.TextSelection) && !selection.empty) {
            findText = (0, $445be20723a3c870$export$93850515e4be65a3)(selection);
            const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
            matches = (0, $445be20723a3c870$export$f4585c00f32d9257)({
                content: state.doc,
                searchText: findText,
                shouldMatchCase: shouldMatchCase,
                getIntl: getIntl,
                api: api
            });
            index = (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches);
        }
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $598aa076e480bbc7$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $445be20723a3c870$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        const index = (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $741d4c9951586a77$export$2e2bcd8739ae039).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$598aa076e480bbc7$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$598aa076e480bbc7$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $445be20723a3c870$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        if (matches.length > 0) {
            const index = (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches);
            const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, index, matches);
            api?.expand?.commands.toggleExpandWithMatch(newSelection)({
                tr: tr
            });
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) api?.blockCollapse?.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                tr: tr
            });
            return tr.setSelection(newSelection);
        }
        return tr;
    }));
const $598aa076e480bbc7$export$ebdf538520f8717 = (editorView)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>$598aa076e480bbc7$var$findInDirection(state, 'next'), (tr, state)=>{
        const { matches: matches, index: index, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $445be20723a3c870$export$7db462fe6be63e0)(searchIndex, matches.length);
        const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) api?.blockCollapse?.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $598aa076e480bbc7$export$eef4841c27f82c55 = (editorView)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>$598aa076e480bbc7$var$findInDirection(state, 'previous'), (tr, state)=>{
        const { matches: matches, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches, true);
        const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) api?.blockCollapse?.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $598aa076e480bbc7$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length) : (0, $445be20723a3c870$export$9041fedbf960fcef)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $598aa076e480bbc7$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_NEXT : (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $598aa076e480bbc7$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const { findText: findText, matches: matches } = pluginState;
        let { decorationSet: decorationSet, index: index } = pluginState;
        decorationSet = $598aa076e480bbc7$var$updateSelectedHighlight(state, (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $445be20723a3c870$export$b5b5304233807f24)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        if (matches[index]) {
            if (!matches[index].canReplace) return tr;
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length);
            tr.insertText(replaceText, start, end);
            const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length);
            tr.setSelection(newSelection);
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) api?.blockCollapse?.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                tr: tr
            });
        }
        return tr;
    }));
const $598aa076e480bbc7$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        pluginState.matches.forEach((match)=>{
            if (!match.canReplace) return tr;
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $598aa076e480bbc7$export$e17d1d1acde229e1 = (decorations)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $598aa076e480bbc7$export$f9e1c8eeab9872dc = (decorations)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorations, state.doc)
        };
    });
const $598aa076e480bbc7$export$58f3f9b95b84be3c = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)(()=>{
        (0, $741d4c9951586a77$export$2e2bcd8739ae039).stop();
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).CANCEL
        };
    });
const $598aa076e480bbc7$export$2cc7ff91bcacba5e = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).BLUR
    });
const $598aa076e480bbc7$export$4e987d48fa8a04d7 = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).TOGGLE_MATCH_CASE
    });
const $598aa076e480bbc7$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    const { index: index, matches: matches } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    let { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $445be20723a3c870$export$83df86cadabd260)(currentSelectedMatch)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $445be20723a3c870$export$83df86cadabd260)(nextSelectedMatch, true)
    ]);
    return decorationSet;
};






var $eEdSM = parcelRequire("eEdSM");





const $af555752df8e1a48$export$f4a2dfcbc300db1a = (editorAnalyticsAPI, editorViewModeAPI)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, (state)=>({
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                action: (0, $krYZG.ACTION).ACTIVATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $kCECX.TextSelection) && !state.selection.empty ? (0, $krYZG.INPUT_METHOD).PREFILL : (0, $krYZG.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod,
                    editorViewMode: editorViewModeAPI?.sharedState.currentState()?.mode ?? 'edit'
                }
            }))((0, $598aa076e480bbc7$export$234c45b355edd85b)());
const $af555752df8e1a48$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT
        })((0, $598aa076e480bbc7$export$71aa6c912b956294)(editorView, containerElement, keyword));
const $af555752df8e1a48$export$da0da8f66917d4cd = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$ebdf538520f8717)(editorView));
    };
const $af555752df8e1a48$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$eef4841c27f82c55)(editorView));
const $af555752df8e1a48$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).REPLACED_ONE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$77ad94ebf1c2b9ed)(replaceText));
const $af555752df8e1a48$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).REPLACED_ALL,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT
        })((0, $598aa076e480bbc7$export$b8b3234b4edfc4c2)(replaceText));
const $af555752df8e1a48$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            action: (0, $krYZG.ACTION).DEACTIVATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$58f3f9b95b84be3c)());






var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


const $37f4965a84915678$var$activateFindReplace = (editorAnalyticsAPI, editorViewModeAPI)=>(state, dispatch)=>{
        (0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(editorAnalyticsAPI, editorViewModeAPI)({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $37f4965a84915678$var$keymapPlugin = (editorAnalyticsAPI, editorViewModeAPI)=>{
    const list = {};
    if ((0, $ldqjS.find).common) (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.find).common, $37f4965a84915678$var$activateFindReplace(editorAnalyticsAPI, editorViewModeAPI), list);
    return (0, $44cyU.keymap)(list);
};
var $37f4965a84915678$export$2e2bcd8739ae039 = $37f4965a84915678$var$keymapPlugin;





var $cbY7C = parcelRequire("cbY7C");














/**
 * Whether the event came from a field the user is typing into. `Mod-f` belongs to
 * that field, not to us.
 */ const $0483d2a34ac3caab$var$isFromTextEntry = (event)=>{
    const target = event.target;
    return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
};
const $0483d2a34ac3caab$var$activateInViewMode = (api)=>(state, dispatch)=>{
        // In edit mode `./keymap.ts` already handles `Mod-f`. Handling it here as well
        // would activate the dialog twice from a single keypress.
        if (api?.editorViewMode?.sharedState.currentState()?.mode !== 'view') return false;
        (0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(api?.analytics?.actions, api?.editorViewMode)({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $0483d2a34ac3caab$export$6a234c24ec1250da = (api)=>{
    const bindings = {};
    if ((0, $ldqjS.find).common) (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.find).common, $0483d2a34ac3caab$var$activateInViewMode(api), bindings);
    const handleKeydown = (0, $44cyU.keydownHandler)(bindings);
    return new (0, $kpCD8.SafePlugin)({
        view: (view)=>{
            const unbind = (0, $cbY7C.bind)(view.root, {
                type: 'keydown',
                listener: (event)=>{
                    // `view.root` is `Document | ShadowRoot`, so the binding widens the event.
                    if (!(event instanceof KeyboardEvent) || $0483d2a34ac3caab$var$isFromTextEntry(event)) return;
                    if (handleKeydown(view, event)) // Without this the browser find bar opens on top of our dialog.
                    event.preventDefault();
                }
            });
            return {
                destroy: unbind
            };
        }
    });
};






var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");





var $isuYJ = parcelRequire("isuYJ");






parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");





var $9RT19 = parcelRequire("9RT19");

var $fPv5h = parcelRequire("fPv5h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $dN8GG = parcelRequire("dN8GG");

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $55fM8 = parcelRequire("55fM8");


var $LQnOI = parcelRequire("LQnOI");











var $kB5K2 = parcelRequire("kB5K2");


var $bRHnZ = parcelRequire("bRHnZ");


var $4yg9g = parcelRequire("4yg9g");








var $1sCHt = parcelRequire("1sCHt");





var $lpNn5 = parcelRequire("lpNn5");

class $b1d94a1a5a6440d3$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                description: title,
                keymap: (0, $ldqjS.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top',
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                id: "afterInputSection",
                label: title,
                appearance: appearance,
                testId: title,
                ref: this.buttonRef,
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                        ...iconProps,
                        size: iconSize
                    }),
                isDisabled: disabled,
                onClick: this.handleClick,
                isSelected: isPressed,
                ...pressedProps
            })
        });
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}
$b1d94a1a5a6440d3$export$d7a26608845e3a06.defaultProps = {
    keymapDescription: 'no-keymap',
    appearance: 'subtle'
};


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






function $232a1fdaa735ceb2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $232a1fdaa735ceb2$var$fontSize = 14;
const $232a1fdaa735ceb2$export$2413e968422424ec = /*#__PURE__*/ (0, $lOiVq.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${"var(--ds-border, #0B120E24)"}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: "var(--ds-border-width, 1px)"
});
const $232a1fdaa735ceb2$export$491e6397d7c1480b = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $232a1fdaa735ceb2$export$263284dac1af2f8a = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $232a1fdaa735ceb2$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $232a1fdaa735ceb2$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $232a1fdaa735ceb2$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $lOiVq.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14)
});
const $232a1fdaa735ceb2$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $lOiVq.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${36 / $232a1fdaa735ceb2$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px'
    }
});
const $232a1fdaa735ceb2$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $232a1fdaa735ceb2$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $232a1fdaa735ceb2$export$df58af0590d04217 = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $232a1fdaa735ceb2$export$1e2581329286cf31 = /*#__PURE__*/ (0, $lOiVq.css)({
    color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    fontSize: `${(0, $7Y8M5.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $232a1fdaa735ceb2$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $232a1fdaa735ceb2$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $232a1fdaa735ceb2$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $lOiVq.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $232a1fdaa735ceb2$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};


const $124ea01dd37cfcb5$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $124ea01dd37cfcb5$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) // Wait for findTextfieldRef to become available then focus
        setTimeout(()=>{
            this.focusFindTextfield();
        }, 100);
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        // focus on update if find text did not change
        if (this.props.findText === this.state?.localFindText) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $dN8GG.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$d449744ea6979b42)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $232a1fdaa735ceb2$export$1e2581329286cf31),
                (0, $232a1fdaa735ceb2$export$3fc34436808d2893)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$24f07703e9463557)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
            title: this.matchCase,
            appearance: "default",
            icon: this.matchCaseIconEle,
            iconLabel: this.matchCase,
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                (0, $232a1fdaa735ceb2$export$4fcc6c669daa3229),
                (0, $232a1fdaa735ceb2$export$1c21208bb1fdf473)
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$7910eaff0a3df2fc)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kB5K2.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
    constructor(props){
        super(props);
        this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.isComposing = false;
        this.find = void 0;
        this.noResultsFound = void 0;
        this.matchCase = void 0;
        this.syncFindText = (onSynced)=>{
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== this.state?.localFindText) this.updateFindValue(this.props.findText || '', onSynced);
        };
        this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        };
        this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        };
        // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((value)=>{
            this.props.onFind(value);
        }, $124ea01dd37cfcb5$export$c7a15a679416091a);
        this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        };
        // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $LQnOI.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        });
        this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        };
        this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        };
        this.handleFindNextClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleCompositionStart = ()=>{
            this.isComposing = true;
            this.debouncedFind.cancel();
        };
        this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleMatchCaseClick = ()=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        };
        this.matchCaseIconEle = (iconProps)=>{
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bRHnZ))), {
                label: iconProps.label,
                size: "small"
            });
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $dN8GG.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $dN8GG.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $dN8GG.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $124ea01dd37cfcb5$var$_default_1 = (0, $kSwu1.injectIntl)($124ea01dd37cfcb5$var$Find);
var $124ea01dd37cfcb5$export$2e2bcd8739ae039 = $124ea01dd37cfcb5$var$_default_1;












var $ad7Ou = parcelRequire("ad7Ou");








var $5ZC7N = parcelRequire("5ZC7N");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");




var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");







const $fe33dd93a90a0b71$var$SPACE_REGEX = / /u;
const $fe33dd93a90a0b71$var$replaceContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100'
});
const $fe33dd93a90a0b71$var$replaceWithLabelStyle = (0, $buxP3.xcss)({
    paddingBottom: 'space.050'
});
const $fe33dd93a90a0b71$var$actionButtonContainerStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.200'
});
// Without the replace field above it, the button row needs no separating space.
const $fe33dd93a90a0b71$var$findOnlyActionButtonContainerStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.0'
});
const $fe33dd93a90a0b71$var$actionButtonParentInlineStyles = (0, $buxP3.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    gap: 'space.075'
});
const $fe33dd93a90a0b71$var$actionButtonInlineStyles = (0, $buxP3.xcss)({
    gap: 'space.075'
});
const $fe33dd93a90a0b71$var$closeButtonInlineStyles = (0, $buxP3.xcss)({
    marginRight: 'auto'
});
const $fe33dd93a90a0b71$var$Replace = ({ allowReplace: allowReplace = true, canReplace: canReplace, replaceText: initialReplaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, onReplaceTextfieldRefSet: onReplaceTextfieldRefSet, onArrowUp: onArrowUp, onCancel: onCancel, count: count, onFindNext: onFindNext, onFindPrev: onFindPrev, dispatchAnalyticsEvent: dispatchAnalyticsEvent, setFindTyped: setFindTyped, findTyped: findTyped, focusToolbarButton: focusToolbarButton, intl: { formatMessage: formatMessage } })=>{
    const [replaceText, setReplaceText] = (0, $cozmU.useState)(initialReplaceText || '');
    const [isComposing, setIsComposing] = (0, $cozmU.useState)(false);
    const [isHelperMessageVisible, setIsHelperMessageVisible] = (0, $cozmU.useState)(false);
    const [fakeSuccessReplacementMessageUpdate, setFakeSuccessReplacementMessageUpdate] = (0, $cozmU.useState)(false);
    const [replaceCount, setReplaceCount] = (0, $cozmU.useState)(0);
    const replaceTextfieldRef = (0, $cozmU.useRef)(null);
    const successReplacementMessageRef = (0, $cozmU.useRef)(null);
    const replaceWith = formatMessage((0, $dN8GG.findReplaceMessages).replaceWith);
    const replaceAll = formatMessage((0, $dN8GG.findReplaceMessages).replaceAll);
    const findPrevious = formatMessage((0, $dN8GG.findReplaceMessages).findPrevious);
    const closeFindReplaceDialog = formatMessage((0, $dN8GG.findReplaceMessages).closeFindReplaceDialog);
    (0, $cozmU.useEffect)(()=>{
        onReplaceTextfieldRefSet(replaceTextfieldRef);
    }, [
        onReplaceTextfieldRefSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        setReplaceText(initialReplaceText || '');
    }, [
        initialReplaceText
    ]);
    const skipWhileComposing = (fn)=>{
        if (!isComposing) fn();
    };
    const triggerSuccessReplacementMessageUpdate = (currentReplaceCount)=>{
        if (replaceCount === currentReplaceCount) setFakeSuccessReplacementMessageUpdate(!fakeSuccessReplacementMessageUpdate);
        if (successReplacementMessageRef.current) {
            const ariaLiveRegion = successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion?.removeAttribute('aria-live');
            ariaLiveRegion?.setAttribute('aria-live', 'polite');
        }
    };
    const handleReplaceClick = ()=>skipWhileComposing(()=>{
            onReplace({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON,
                replaceText: replaceText
            });
            triggerSuccessReplacementMessageUpdate(1);
            setIsHelperMessageVisible(true);
            setReplaceCount(1);
            setFindTyped(false);
        });
    const handleReplaceChange = (event)=>skipWhileComposing(()=>{
            updateReplaceValue(event.target.value);
        });
    const updateReplaceValue = (text)=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).CHANGED_REPLACEMENT_TEXT,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG
        });
        setReplaceText(text);
    };
    const handleReplaceKeyDown = (event)=>skipWhileComposing(()=>{
            if (event.key === 'Enter') onReplace({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD,
                replaceText: replaceText
            });
            else if (event.key === 'ArrowUp') onArrowUp();
        });
    const handleReplaceAllClick = ()=>skipWhileComposing(()=>{
            onReplaceAll({
                replaceText: replaceText
            });
            setIsHelperMessageVisible(true);
            if (count.totalReplaceable) {
                triggerSuccessReplacementMessageUpdate(count.totalReplaceable);
                setReplaceCount(count.totalReplaceable);
            } else {
                triggerSuccessReplacementMessageUpdate(count.total);
                setReplaceCount(count.total);
            }
            setFindTyped(false);
        });
    const handleCompositionStart = ()=>{
        setIsComposing(true);
    };
    const handleCompositionEnd = (event)=>{
        setIsComposing(false);
        // type for React.CompositionEvent doesn't set type for target correctly
        updateReplaceValue(event.target.value);
    };
    const clearSearch = ()=>{
        onCancel({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
        focusToolbarButton();
    };
    const handleFindNextClick = ()=>{
        if (!isComposing) onFindNext({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
    };
    const handleFindPrevClick = ()=>{
        if (!isComposing) onFindPrev({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
    };
    const resultsReplace = formatMessage((0, $dN8GG.findReplaceMessages).replaceSuccess, {
        numberOfMatches: replaceCount
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
        xcss: $fe33dd93a90a0b71$var$replaceContainerStyles,
        children: [
            allowReplace && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                        xcss: $fe33dd93a90a0b71$var$replaceWithLabelStyle,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6Pqow.Text), {
                            id: "replace-text-field-label",
                            size: "medium",
                            weight: "bold",
                            color: "color.text.subtle",
                            children: replaceWith
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4yg9g.default), {
                        name: "replace",
                        "aria-labelledby": "replace-text-field-label",
                        testId: "replace-field",
                        appearance: "standard",
                        defaultValue: replaceText,
                        ref: replaceTextfieldRef,
                        autoComplete: "off",
                        onChange: handleReplaceChange,
                        onKeyDown: handleReplaceKeyDown,
                        onCompositionStart: handleCompositionStart,
                        onCompositionEnd: handleCompositionEnd
                    }),
                    isHelperMessageVisible && !findTyped && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        ref: successReplacementMessageRef,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5ZC7N.ValidMessage), {
                            testId: "message-success-replacement",
                            children: fakeSuccessReplacementMessageUpdate ? resultsReplace.replace($fe33dd93a90a0b71$var$SPACE_REGEX, '\u00a0') : resultsReplace
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
                xcss: allowReplace ? $fe33dd93a90a0b71$var$actionButtonContainerStyles : $fe33dd93a90a0b71$var$findOnlyActionButtonContainerStyles,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                    xcss: $fe33dd93a90a0b71$var$actionButtonParentInlineStyles,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $kz1Yj.Inline), {
                            xcss: $fe33dd93a90a0b71$var$actionButtonInlineStyles,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
                                    title: formatMessage((0, $dN8GG.findReplaceMessages).findNext),
                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: formatMessage((0, $dN8GG.findReplaceMessages).findNext),
                                    keymapDescription: 'Enter',
                                    onClick: handleFindNextClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
                                    title: findPrevious,
                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: findPrevious,
                                    keymapDescription: 'Shift Enter',
                                    onClick: handleFindPrevClick,
                                    disabled: count.total <= 1
                                }),
                                allowReplace && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                            testId: 'Replace',
                                            id: "replace-button",
                                            onClick: handleReplaceClick,
                                            isDisabled: !canReplace,
                                            children: formatMessage((0, $dN8GG.findReplaceMessages).replace)
                                        }),
                                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                            appearance: "primary",
                                            testId: replaceAll,
                                            id: "replaceAll-button",
                                            onClick: handleReplaceAllClick,
                                            isDisabled: count.totalReplaceable === 0,
                                            children: replaceAll
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kz1Yj.Inline), {
                            xcss: $fe33dd93a90a0b71$var$closeButtonInlineStyles,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                                appearance: "subtle",
                                testId: closeFindReplaceDialog,
                                onClick: clearSearch,
                                children: closeFindReplaceDialog
                            })
                        })
                    ]
                })
            })
        ]
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $fe33dd93a90a0b71$var$_default_1 = (0, $kSwu1.injectIntl)($fe33dd93a90a0b71$var$Replace);
var $fe33dd93a90a0b71$export$2e2bcd8739ae039 = $fe33dd93a90a0b71$var$_default_1;



// Magic number taken from ./FindReplaceToolbarButton.tsx
const $b4ec49486aa4f539$var$dropdownWidth = 382;
// Without replace the find row is the widest row, so the popup would size to it and
// change width as the match counter appears. Pin it to the width the dropdown reserves.
const $b4ec49486aa4f539$var$findOnlyWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$b4ec49486aa4f539$var$dropdownWidth}px`,
    maxWidth: '100%'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b4ec49486aa4f539$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { findText: findText, count: count, isReplaceable: isReplaceable, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase, intl: intl, allowReplace: allowReplace = true } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            role: 'dialog',
            "aria-label": intl?.formatMessage(allowReplace ? (0, $dN8GG.findReplaceMessages).findReplaceDialogAriaLabel : (0, $dN8GG.findReplaceMessages).findDialogAriaLabel),
            "aria-modal": false,
            ref: this.modalRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $232a1fdaa735ceb2$export$491e6397d7c1480b),
                (0, $232a1fdaa735ceb2$export$263284dac1af2f8a),
                !allowReplace && $b4ec49486aa4f539$var$findOnlyWidthStyles
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $124ea01dd37cfcb5$export$2e2bcd8739ae039), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), allowReplace && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("hr", {
            role: "presentation",
            css: (0, $232a1fdaa735ceb2$export$2413e968422424ec),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fe33dd93a90a0b71$export$2e2bcd8739ae039), {
            allowReplace: allowReplace,
            canReplace: !!isReplaceable,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        }));
    }
    constructor(props){
        super(props);
        this.findTextfield = null;
        this.replaceTextfield = null;
        this.modalRef = void 0;
        this.state = {
            findTyped: false
        };
        this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        };
        this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        };
        this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        };
        this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        };
        this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
var $b4ec49486aa4f539$export$2e2bcd8739ae039 = $b4ec49486aa4f539$var$FindReplace;


const $42f82f57d853bd28$var$findReplaceWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
// Magic number taken from ../FindReplaceToolbarButton.tsx
const $42f82f57d853bd28$var$dropdownWidthNewDesign = 382;
const $42f82f57d853bd28$var$FindReplaceDropdown = (props)=>{
    const { findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, popupsMountPoint: popupsMountPoint, numReplaceable: numReplaceable, onCancel: onCancel } = props;
    if (!popupsMountPoint) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPv5h.default), {
        target: popupsMountPoint,
        mountTo: popupsMountPoint,
        forcePlacement: true,
        alignX: 'right',
        alignY: 'start',
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            4,
            0
        ],
        isOpen: isActive,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        handleEscapeKeydown: ()=>{
            if (isActive) onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
            });
        },
        fitWidth: $42f82f57d853bd28$var$dropdownWidthNewDesign,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: true
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            xcss: $42f82f57d853bd28$var$findReplaceWrapperStyles,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4ec49486aa4f539$export$2e2bcd8739ae039), {
                findText: findText,
                replaceText: replaceText,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                count: {
                    index: index,
                    total: numMatches,
                    totalReplaceable: numReplaceable
                },
                ...props
            })
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $42f82f57d853bd28$var$_default_1 = (0, $kSwu1.injectIntl)($42f82f57d853bd28$var$FindReplaceDropdown);
var $42f82f57d853bd28$export$2e2bcd8739ae039 = $42f82f57d853bd28$var$_default_1;


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






















var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");





var $hAgam = parcelRequire("hAgam");





function $a7db1f69e2740b4a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $a7db1f69e2740b4a$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $lOiVq.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $7Y8M5.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $a7db1f69e2740b4a$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $lOiVq.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $a7db1f69e2740b4a$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $a7db1f69e2740b4a$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $a7db1f69e2740b4a$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $a7db1f69e2740b4a$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a7db1f69e2740b4a$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, numReplaceable: numReplaceable, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $dN8GG.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $7Y8M5.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $ldqjS.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $a7db1f69e2740b4a$var$toolbarButtonWrapper,
                takeFullWidth && $a7db1f69e2740b4a$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes') && $a7db1f69e2740b4a$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fPv5h.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $a7db1f69e2740b4a$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes') ? /*#__PURE__*/ (0, $lOiVq.jsx)($a7db1f69e2740b4a$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $ldqjS.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $ldqjS.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $a7db1f69e2740b4a$var$wrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b4ec49486aa4f539$export$2e2bcd8739ae039), {
            findText: findText,
            replaceText: replaceText,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            count: {
                index: index,
                total: numMatches,
                totalReplaceable: numReplaceable
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            openedByClick: false
        };
        this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        };
        this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        };
        this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $a7db1f69e2740b4a$var$_default_1 = (0, $kSwu1.injectIntl)($a7db1f69e2740b4a$var$FindReplaceToolbarButton);
var $a7db1f69e2740b4a$export$2e2bcd8739ae039 = $a7db1f69e2740b4a$var$_default_1;


// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $1a2838ce98d682a4$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $cozmU.useState)(api?.findReplace?.sharedState.currentState());
    (0, $cozmU.useLayoutEffect)(()=>{
        const unsub = api?.findReplace?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $1a2838ce98d682a4$var$useEditorViewMode = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_collapsible_headings', 'isEnabled', false), (api)=>(0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode), ()=>undefined);
const $1a2838ce98d682a4$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden, doesNotHaveButton: doesNotHaveButton })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { findReplaceState: findReplaceState } = $1a2838ce98d682a4$var$useSharedPluginStateNoDebounce(api);
    const editorViewMode = $1a2838ce98d682a4$var$useEditorViewMode(api);
    const allowReplace = editorViewMode !== 'view';
    const shouldMatchCase = findReplaceState?.shouldMatchCase;
    const isActive = findReplaceState?.isActive;
    const findText = findReplaceState?.findText;
    const replaceText = findReplaceState?.replaceText;
    const index = findReplaceState?.index;
    const matches = findReplaceState?.matches;
    const shouldFocus = findReplaceState?.shouldFocus;
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement?.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch, editorView);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(editorAnalyticsAPI, api?.editorViewMode)({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$a1f845c5f9c28dec)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$da0da8f66917d4cd)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$67b10f9d7f5c44e1)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$95c81501036a7f64)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$99b6462294b19fcd)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $598aa076e480bbc7$export$2cc7ff91bcacba5e)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $af555752df8e1a48$export$330be886194dc3c6)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $598aa076e480bbc7$export$4e987d48fa8a04d7)());
    };
    if (shouldMatchCase === undefined || isActive === undefined || findText === undefined || replaceText === undefined || index === undefined || matches === undefined || shouldFocus === undefined) return null;
    const DropDownComponent = doesNotHaveButton ? (0, $42f82f57d853bd28$export$2e2bcd8739ae039) : (0, $a7db1f69e2740b4a$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $8aG6j.jsx)(DropDownComponent, {
        shouldMatchCase: shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: isActive,
        findText: findText,
        index: index,
        numMatches: matches.length,
        isReplaceable: matches[index]?.canReplace,
        numReplaceable: // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        matches.filter((match)=>match.canReplace === true).length,
        replaceText: replaceText,
        shouldFocus: shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden,
        allowReplace: allowReplace
    });
};
const $1a2838ce98d682a4$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($1a2838ce98d682a4$var$FindReplaceToolbarButtonWithState);
var $1a2838ce98d682a4$export$2e2bcd8739ae039 = $1a2838ce98d682a4$var$_default_1;


const $9494488bedef6698$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const toolbarButtonRegisteredExternally = {
        current: false
    };
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        const isButtonHidden = (0, $iDrrr.fg)('platform_editor_toolbar_responsive_fixes') ? toolbarSize < (0, $6OREF.ToolbarSize).XL : false;
        if (props?.twoLineEditorToolbar) return null;
        else if (toolbarButtonRegisteredExternally.current && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return null;
        else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props?.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            const plugins = [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $1165d80eb39a2324$export$ae829ec7b2625219)(dispatch, getIntl, api)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>(0, $37f4965a84915678$export$2e2bcd8739ae039)(api?.analytics?.actions, api?.editorViewMode)
                }
            ];
            if (api?.editorViewMode && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_collapsible_headings', 'isEnabled', false)) plugins.push({
                name: 'findReplaceViewModeShortcut',
                plugin: ()=>(0, $0483d2a34ac3caab$export$6a234c24ec1250da)(api)
            });
            if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'findReplaceEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $kpCD8.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $84528c133539f16c$export$e7697da71e34f0a6).getState(editorState) || undefined;
        },
        actions: {
            registerToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                toolbarButtonRegisteredExternally.current = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1');
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            },
            activateFindReplace: (triggerMethod)=>{
                if (!editorViewRef.current) return false;
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                if (api?.analytics?.actions) (0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(api?.analytics?.actions, api?.editorViewMode)({
                    triggerMethod: triggerMethod || (0, $krYZG.TRIGGER_METHOD).EXTERNAL
                })(state, dispatch);
                else (0, $598aa076e480bbc7$export$234c45b355edd85b)()(state, dispatch);
                return true;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        contentComponent: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
            if (toolbarButtonRegisteredExternally.current || !editorView) return null;
            const popupsMountPointEl = popupsMountPoint || // eslint-disable-next-line @atlaskit/editor/no-as-casting
            wrapperElement?.querySelector("[data-editor-container='true']");
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPointEl,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined,
                isToolbarReducedSpacing: false,
                editorView: editorView,
                containerElement: containerElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                takeFullWidth: props?.takeFullWidth,
                api: api,
                doesNotHaveButton: true
            });
        } : undefined
    };
};
module.exports["findReplacePlugin"] = $9494488bedef6698$export$e5ceda4aabe9bb08;

});

parcelRegister("7iL2d", function(module, exports) {

var $hwsSH = parcelRequire("hwsSH");

/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $2nOF5 = parcelRequire("2nOF5");


var $kpCD8 = parcelRequire("kpCD8");


var $6SJ6d = parcelRequire("6SJ6d");


var $kCECX = parcelRequire("kCECX");

const $7520d54e0c00d1c9$var$pluginKey = new (0, $kCECX.PluginKey)('fragmentMarkConsistencyPlugin');
const $7520d54e0c00d1c9$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $7520d54e0c00d1c9$export$ae829ec7b2625219 = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        key: $7520d54e0c00d1c9$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $7520d54e0c00d1c9$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $6SJ6d.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $2nOF5.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });


const $83d7c6d60a9cd975$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $hwsSH.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $7520d54e0c00d1c9$export$ae829ec7b2625219)(dispatch)
                }
            ];
        }
    });
module.exports["fragmentPlugin"] = $83d7c6d60a9cd975$export$36fc1707093eff41;

});

parcelRegister("eHllO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");







const $eb5db962d31ab635$export$a18117c61b4f3090 = '--guideline-offset-x';
const $eb5db962d31ab635$export$343adffee41775d9 = '--guideline-offset-y';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports




var $11HKG = parcelRequire("11HKG");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



const $dd37751fa808002e$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $dd37751fa808002e$var$getXPosition = (pixel)=>$dd37751fa808002e$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $eb5db962d31ab635$export$a18117c61b4f3090}, '0px'))` : 'unset';
const $dd37751fa808002e$var$getYPosition = (pixel)=>$dd37751fa808002e$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $eb5db962d31ab635$export$343adffee41775d9}, '0px'))` : 'unset';
const $dd37751fa808002e$export$a5b21f38d58b1de0 = (pos)=>{
    return (0, $11HKG.isVerticalPosition)(pos) ? {
        left: $dd37751fa808002e$var$getXPosition(pos.x),
        top: $dd37751fa808002e$var$getYPosition(pos.y?.start),
        height: pos.y ? `${pos.y.end - pos.y.start}px` : '100%'
    } : {
        top: $dd37751fa808002e$var$getYPosition(pos.y),
        left: $dd37751fa808002e$var$getXPosition(pos.x?.start),
        width: pos.x ? `${pos.x.end - pos.x.start}px` : '100%'
    };
};


function $4b69c2b3133f681e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b69c2b3133f681e$var$basicGuidelineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    zIndex: 0,
    opacity: 1,
    transition: 'border-color 0.15s linear, opacity 0.15s linear',
    borderColor: `${"var(--ds-border-disabled, #0515240F)"}`,
    borderStyle: 'solid'
});
const $4b69c2b3133f681e$var$verticalStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: `0 0 0 ${"var(--ds-border-width, 1px)"}`,
    width: '1px',
    height: '100%'
});
const $4b69c2b3133f681e$var$horizontalStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: `${"var(--ds-border-width, 1px)"} 0 0 0`,
    width: '100%',
    height: '1px'
});
const $4b69c2b3133f681e$var$activeGuidelineStyles = {
    name: "uh8fzh",
    styles: "border-color:var(--ds-border-focused, #4688EC);&:before, &:after{background-color:var(--ds-border-focused, #4688EC);}"
};
const $4b69c2b3133f681e$var$hiddenGuidelineStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $4b69c2b3133f681e$var$dashedGuidelineStyles = {
    name: "10ikx64",
    styles: "border-style:dashed"
};
const $4b69c2b3133f681e$var$verticalCapStyles = {
    name: "4o8hyx",
    styles: "&:before, &:after{background-color:var(--ds-border-disabled, #0515240F);content:\"\";position:absolute;height:5px;width:1px;transform:translateY(-50%);}&:after{right:0;}"
};
const $4b69c2b3133f681e$var$horizontalCapStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `${"var(--ds-border-disabled, #0515240F)"}`,
        content: '""',
        position: 'absolute',
        height: '1px',
        width: '5px',
        transform: 'translateX(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        bottom: 0
    }
});
const $4b69c2b3133f681e$export$1f92f20006072ef = (props)=>{
    const { position: position, active: active, show: show = true, styles: styles = {} } = props;
    const isVerticalPos = (0, $11HKG.isVerticalPosition)(position);
    const { lineStyle: lineStyle, color: color, capStyle: capStyle } = styles;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $4b69c2b3133f681e$var$basicGuidelineStyles,
            isVerticalPos ? $4b69c2b3133f681e$var$verticalStyles : $4b69c2b3133f681e$var$horizontalStyles,
            capStyle === 'line' && (isVerticalPos ? $4b69c2b3133f681e$var$horizontalCapStyles : $4b69c2b3133f681e$var$verticalCapStyles),
            active && $4b69c2b3133f681e$var$activeGuidelineStyles,
            !show && $4b69c2b3133f681e$var$hiddenGuidelineStyles,
            lineStyle === 'dashed' && $4b69c2b3133f681e$var$dashedGuidelineStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...color && {
                borderColor: `${color}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $dd37751fa808002e$export$a5b21f38d58b1de0)(position)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "guideline"
    });
};


const $f1525283be4414dc$var$guidelineContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'fixed',
    height: '100vh',
    width: '100%',
    display: 'grid',
    pointerEvents: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px`
});
const $f1525283be4414dc$export$e0b9e5fb6186afa = (props)=>{
    const { guidelines: guidelines, height: height, updateRect: updateRect } = props;
    const [offset, setOffset] = (0, $cozmU.useState)(0);
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        const rect = ref?.current?.getBoundingClientRect();
        if (rect) {
            const centerOffset = rect.width / 2 - 0.5;
            // X pixels from guideline container left to editor center.
            if (offset !== centerOffset) setOffset(centerOffset);
            updateRect({
                top: rect.top,
                left: rect.left
            });
        }
    }, [
        updateRect,
        offset
    ]);
    const style = {
        [(0, $eb5db962d31ab635$export$a18117c61b4f3090)]: `${offset}px`,
        [(0, $eb5db962d31ab635$export$343adffee41775d9)]: `0px`,
        height: height
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        css: $f1525283be4414dc$var$guidelineContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "guidelineContainer"
    }, guidelines.map((guideline)=>{
        const { key: key, ...guidelineProps } = guideline;
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4b69c2b3133f681e$export$1f92f20006072ef), {
            key: key,
            ...guidelineProps
        });
    }));
};


const $43a0cb3d15cb661f$var$guidelineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    transform: `scale(1)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: `${(0, $7Y8M5.akEditorGridLineZIndex)};`,
    display: 'flex',
    justifyContent: 'center'
});
const $43a0cb3d15cb661f$var$key = new (0, $kCECX.PluginKey)('guidelinePlugin');
const $43a0cb3d15cb661f$var$displayGuideline = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($43a0cb3d15cb661f$var$key, props);
        dispatch(tr);
        return true;
    };
const $43a0cb3d15cb661f$export$f040258c471d4154 = {
    guidelines: []
};
const $43a0cb3d15cb661f$var$guidelinePMPlugin = new (0, $kpCD8.SafePlugin)({
    key: $43a0cb3d15cb661f$var$key,
    state: {
        init () {
            return $43a0cb3d15cb661f$export$f040258c471d4154;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($43a0cb3d15cb661f$var$key);
            if (nextPluginState) return {
                ...currentPluginState,
                ...nextPluginState
            };
            return currentPluginState;
        }
    }
});
const $43a0cb3d15cb661f$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        lineLength: states.widthState?.lineLength,
        guidelines: states.guidelineState?.guidelines,
        rect: states.guidelineState?.rect
    };
};
const $43a0cb3d15cb661f$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, lineLength: lineLength, guidelines: guidelines, rect: rect } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width',
        'guideline'
    ], $43a0cb3d15cb661f$var$selector);
    if (!width || !lineLength || !guidelines || guidelines.length === 0) return null;
    const updateRect = ({ top: top, left: left })=>{
        const { dispatch: dispatch, state: state } = editorView;
        const { top: prevTop, left: prevLeft } = rect || {};
        if (prevTop !== top || prevLeft !== left) {
            const tr = state.tr.setMeta($43a0cb3d15cb661f$var$key, {
                rect: {
                    top: top,
                    left: left
                }
            });
            dispatch(tr);
            return true;
        }
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $43a0cb3d15cb661f$var$guidelineStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1525283be4414dc$export$e0b9e5fb6186afa), {
        guidelines: guidelines,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        height: editorView.dom.scrollHeight,
        width: width,
        editorWidth: lineLength,
        updateRect: updateRect
    }));
};
const $43a0cb3d15cb661f$export$63925ade01f824c4 = ({ config: options, api: api })=>({
        name: 'guideline',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $43a0cb3d15cb661f$var$key.getState(editorState) || null;
        },
        actions: {
            displayGuideline: $43a0cb3d15cb661f$var$displayGuideline
        },
        pmPlugins () {
            return [
                {
                    name: 'guideline',
                    plugin: ()=>$43a0cb3d15cb661f$var$guidelinePMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $lOiVq.jsx)($43a0cb3d15cb661f$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    });
module.exports["guidelinePlugin"] = $43a0cb3d15cb661f$export$63925ade01f824c4;

});

parcelRegister("laiso", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $ldqjS = parcelRequire("ldqjS");


var $gx3UZ = parcelRequire("gx3UZ");


var $kyJuy = parcelRequire("kyJuy");


var $doGhB = parcelRequire("doGhB");

const $0e12e5ac318d5e6c$export$2dac2f8389fd3a8c = (tr)=>{
    return tr.setMeta((0, $doGhB.pluginKey), true);
};
const $0e12e5ac318d5e6c$export$c54ba5c26d7768da = (tr)=>{
    return tr.setMeta((0, $doGhB.pluginKey), false);
};



var $8WPM6 = parcelRequire("8WPM6");








var $44cyU = parcelRequire("44cyU");







const $6f4c7a169db14fa2$export$e832373cff8dec22 = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.openHelp).common, (state, dispatch)=>{
        const { tr: tr } = state;
        const isVisible = tr.getMeta((0, $doGhB.pluginKey));
        if (!isVisible) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BUTTON_HELP,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            })(tr);
            (0, $8WPM6.openHelpCommand)(tr, dispatch);
        }
        return true;
    }, list);
    return (0, $44cyU.keymap)(list);
};



var $kpCD8 = parcelRequire("kpCD8");




function $7bb274d36fcc30fd$export$ae829ec7b2625219(dispatch, imageEnabled, aiEnabled) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $doGhB.pluginKey),
        state: {
            init () {
                return {
                    isVisible: false,
                    imageEnabled: imageEnabled,
                    aiEnabled: aiEnabled
                };
            },
            apply (tr, _value, state) {
                const isVisible = tr.getMeta((0, $doGhB.pluginKey));
                const currentState = (0, $doGhB.pluginKey).getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    const newState = {
                        ...currentState,
                        isVisible: isVisible
                    };
                    dispatch((0, $doGhB.pluginKey), newState);
                    return newState;
                }
                return currentState;
            }
        }
    });
}








parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eRn3r = parcelRequire("eRn3r");


var $4o0zT = parcelRequire("4o0zT");


const $cfc768ba6073843a$var$HelpDialogLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "O45fG",
    name: "HelpDialogLoadable",
    loader: ()=>(parcelRequire("9PAwP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $cfc768ba6073843a$var$HelpDialogLazy = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("9PAwP")).then((mod)=>mod.default));
const $cfc768ba6073843a$export$e97fc21b7bb6adc7 = (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($cfc768ba6073843a$var$HelpDialogLazy, {
            ...props
        })
    }) : /* eslint-disable-next-line react/jsx-props-no-spreading -- forward the loader props to the dialog */ /*#__PURE__*/ (0, $8aG6j.jsx)($cfc768ba6073843a$var$HelpDialogLoadable, {
        ...props
    });
$cfc768ba6073843a$export$e97fc21b7bb6adc7.preload = ()=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $cfc768ba6073843a$var$HelpDialogLazy.preload() : $cfc768ba6073843a$var$HelpDialogLoadable.preload();


/**
 * Normalise the caller-supplied config into a single, predictable shape.
 * – Boolean → "image uploads on/off", AI always off
 * – Object  → pick the two feature flags with sane defaults (both false)
 */ function $58d137eaf76fe45b$var$parseFeatureConfig(config) {
    if (typeof config === 'boolean') return {
        imageUploadProviderExists: config,
        aiEnabled: false
    };
    // Object path – ensure we never return undefined
    const { imageUploadProviderExists: imageUploadProviderExists = false, aiEnabled: aiEnabled = false } = config ?? {};
    return {
        imageUploadProviderExists: imageUploadProviderExists,
        aiEnabled: aiEnabled
    };
}
const $58d137eaf76fe45b$export$b3faa25d392107e4 = ({ config: config, api: api })=>{
    const { imageUploadProviderExists: imageUploadProviderExists, aiEnabled: aiEnabled } = $58d137eaf76fe45b$var$parseFeatureConfig(config);
    return {
        name: 'helpDialog',
        pmPlugins () {
            return [
                {
                    name: 'helpDialog',
                    plugin: ({ dispatch: dispatch })=>(0, $7bb274d36fcc30fd$export$ae829ec7b2625219)(dispatch, imageUploadProviderExists, aiEnabled)
                },
                {
                    name: 'helpDialogKeymap',
                    plugin: ()=>(0, $6f4c7a169db14fa2$export$e832373cff8dec22)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'helpdialog',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).help),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).helpDescription),
                        keywords: [
                            '?'
                        ],
                        priority: 4000,
                        keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.openHelp)),
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: "",
                                color: "currentColor",
                                spacing: "spacious"
                            }),
                        action (insert) {
                            const tr = insert('');
                            (0, $8WPM6.openHelpCommand)(tr);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).HELP_OPENED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).HELP,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HELP_QUICK_INSERT,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfc768ba6073843a$export$e97fc21b7bb6adc7), {
                pluginInjectionApi: api,
                editorView: editorView,
                quickInsertEnabled: !!api?.quickInsert
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $doGhB.pluginKey).getState(editorState) || null;
        },
        actions: {
            openHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $0e12e5ac318d5e6c$export$2dac2f8389fd3a8c)(tr));
            },
            closeHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $0e12e5ac318d5e6c$export$c54ba5c26d7768da)(tr));
            }
        }
    };
};
module.exports["helpDialogPlugin"] = $58d137eaf76fe45b$export$b3faa25d392107e4;

});

parcelRegister("8WPM6", function(module, exports) {

var $doGhB = parcelRequire("doGhB");

const $f953e0d84362cf43$export$e7832c5f11de3579 = (tr, dispatch)=>{
    tr = tr.setMeta((0, $doGhB.pluginKey), true);
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
const $f953e0d84362cf43$export$fd5f4180482ea9ed = (tr, dispatch)=>{
    tr = tr.setMeta((0, $doGhB.pluginKey), false);
    dispatch(tr);
};
module.exports["openHelpCommand"] = $f953e0d84362cf43$export$e7832c5f11de3579;
module.exports["closeHelpCommand"] = $f953e0d84362cf43$export$fd5f4180482ea9ed;

});

parcelRegister("9PAwP", function(module, exports) {

let $728536472a23e9d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728536472a23e9d4$var$load("hIr7E").then(()=>parcelRequire('3vA6q'));

});

parcelRegister("4exuQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $6OV8L = parcelRequire("6OV8L");


var $6UUJT = parcelRequire("6UUJT");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $72OpT = parcelRequire("72OpT");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");




var $gjFO5 = parcelRequire("gjFO5");


var $eEdSM = parcelRequire("eEdSM");


var $fud2r = parcelRequire("fud2r");

var $7SvWS = parcelRequire("7SvWS");

var $iLrhi = parcelRequire("iLrhi");


var $aPdNQ = parcelRequire("aPdNQ");





var $eOaGc = parcelRequire("eOaGc");










const $bbeac3462dd7561c$export$2583e740deddd6d = 3;
const $bbeac3462dd7561c$export$92f9af977c85ea46 = 5;
const $bbeac3462dd7561c$export$a9683f74b118e94b = 5;
const $bbeac3462dd7561c$export$f501538bec3afd75 = 'top';
const $bbeac3462dd7561c$export$faa6744ce57d263b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};





const $4b9fd8b3928d914b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('layout');


const $c44623e798e01dfd$var$roundLayoutColumnWidth = (width)=>Number(width.toFixed(2));
const $c44623e798e01dfd$var$sumWidths = (widths)=>widths.reduce((sum, width)=>sum + width, 0);
const $c44623e798e01dfd$var$normaliseWidthsTotal = (widths, totalWidth, minWidth)=>{
    const roundedWidths = widths.map($c44623e798e01dfd$var$roundLayoutColumnWidth);
    const remainder = $c44623e798e01dfd$var$roundLayoutColumnWidth(totalWidth - $c44623e798e01dfd$var$sumWidths(roundedWidths));
    if (remainder === 0 || roundedWidths.length === 0) return roundedWidths;
    let adjustmentIndex = 0;
    roundedWidths.forEach((width, index)=>{
        if (width > roundedWidths[adjustmentIndex]) adjustmentIndex = index;
    });
    const adjustedWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(roundedWidths[adjustmentIndex] + remainder);
    if (adjustedWidth < minWidth) return roundedWidths;
    return roundedWidths.map((width, index)=>index === adjustmentIndex ? adjustedWidth : width);
};
const $c44623e798e01dfd$var$isValidWidth = (width)=>Number.isFinite(width) && width > 0;
const $c44623e798e01dfd$var$redistributeWithMinimumWidth = ({ minWidth: minWidth, totalWidth: totalWidth, weights: weights })=>{
    if (weights.length * minWidth > totalWidth) return;
    const widths = Array(weights.length).fill(0);
    const clampedIndexes = new Set();
    let remainingWidth = totalWidth;
    let remainingWeight = $c44623e798e01dfd$var$sumWidths(weights);
    while(clampedIndexes.size < weights.length){
        const remainingWidthForPass = remainingWidth;
        const remainingWeightForPass = remainingWeight;
        const indexesToClamp = [];
        weights.forEach((weight, index)=>{
            if (clampedIndexes.has(index)) return;
            const proportionalWidth = remainingWeightForPass > 0 ? weight / remainingWeightForPass * remainingWidthForPass : 0;
            if (proportionalWidth < minWidth) indexesToClamp.push(index);
        });
        if (indexesToClamp.length === 0) break;
        indexesToClamp.forEach((index)=>{
            widths[index] = minWidth;
            clampedIndexes.add(index);
            remainingWidth -= minWidth;
            remainingWeight -= weights[index];
        });
    }
    weights.forEach((weight, index)=>{
        if (!clampedIndexes.has(index)) widths[index] = remainingWeight > 0 ? weight / remainingWeight * remainingWidth : minWidth;
    });
    return widths;
};
const $c44623e798e01dfd$export$e260f2e2ca90998a = (selectedWidths)=>{
    const count = selectedWidths.length;
    if (count < 2) return undefined;
    const selectedTotal = $c44623e798e01dfd$var$sumWidths(selectedWidths);
    const equalWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(selectedTotal / count);
    return {
        selectedTotal: selectedTotal,
        equalWidth: equalWidth
    };
};
function $c44623e798e01dfd$export$3cbb23b573ffb2e9(selectedWidths, distribution = $c44623e798e01dfd$export$e260f2e2ca90998a(selectedWidths)) {
    if (!distribution || selectedWidths.length < 2) return false;
    const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
    const lastColWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(selectedTotal - equalWidth * (selectedWidths.length - 1));
    return selectedWidths.slice(0, -1).every((width)=>width === equalWidth) && selectedWidths[selectedWidths.length - 1] === lastColWidth;
}
const $c44623e798e01dfd$export$7a23b11013fe122c = (currentWidths, removeIndex, minWidth)=>{
    if (currentWidths.length === 0 || removeIndex < 0 || removeIndex >= currentWidths.length || !$c44623e798e01dfd$var$isValidWidth(minWidth)) return currentWidths;
    if (currentWidths.some((width)=>!$c44623e798e01dfd$var$isValidWidth(width))) return currentWidths.filter((_, i)=>i !== removeIndex);
    const remainingWidths = currentWidths.filter((_, i)=>i !== removeIndex);
    if (remainingWidths.length === 0) return remainingWidths;
    const currentTotalWidth = $c44623e798e01dfd$var$sumWidths(currentWidths);
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const redistributed = $c44623e798e01dfd$var$redistributeWithMinimumWidth({
        weights: remainingWidths,
        totalWidth: targetTotalWidth,
        minWidth: minWidth
    });
    if (!redistributed) {
        const equalWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(targetTotalWidth / remainingWidths.length);
        return $c44623e798e01dfd$var$normaliseWidthsTotal(Array(remainingWidths.length).fill(equalWidth), targetTotalWidth, minWidth);
    }
    return $c44623e798e01dfd$var$normaliseWidthsTotal(redistributed, targetTotalWidth, minWidth);
};
const $c44623e798e01dfd$export$3d07e1109dd4c8ac = (currentWidths, insertIndex, maxColumns, minWidth)=>{
    if (currentWidths.length === 0 || !Number.isInteger(maxColumns) || maxColumns <= 0 || currentWidths.length >= maxColumns || insertIndex < 0 || insertIndex > currentWidths.length || !$c44623e798e01dfd$var$isValidWidth(minWidth) || currentWidths.some((width)=>!$c44623e798e01dfd$var$isValidWidth(width))) return currentWidths;
    const currentTotalWidth = $c44623e798e01dfd$var$sumWidths(currentWidths);
    if (!$c44623e798e01dfd$var$isValidWidth(currentTotalWidth)) return currentWidths;
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const newColumnWidth = Math.max(minWidth, $c44623e798e01dfd$var$roundLayoutColumnWidth(targetTotalWidth / (currentWidths.length + 1)));
    const existingColumnsTotalWidth = targetTotalWidth - newColumnWidth;
    if (existingColumnsTotalWidth < currentWidths.length * minWidth) return currentWidths;
    const redistributedExistingWidths = $c44623e798e01dfd$var$redistributeWithMinimumWidth({
        weights: currentWidths,
        totalWidth: existingColumnsTotalWidth,
        minWidth: minWidth
    });
    if (!redistributedExistingWidths) return currentWidths;
    const nextWidths = [
        ...redistributedExistingWidths
    ];
    nextWidths.splice(insertIndex, 0, newColumnWidth);
    return $c44623e798e01dfd$var$normaliseWidthsTotal(nextWidths, targetTotalWidth, minWidth);
};









const $165a594884c31a30$var$findLayoutSectionFromSelection = (selection)=>{
    const { layoutSection: layoutSection } = selection.$from.doc.type.schema.nodes;
    // NodeSelection on the layoutSection node itself
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type === layoutSection) return {
        node: selection.node,
        pos: selection.from
    };
    return (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection);
};
const $165a594884c31a30$var$findLayoutColumnsFromLayoutSection = (layoutSectionNode, layoutSectionPos = 0)=>{
    return (0, $bjg0G.findChildrenByType)(layoutSectionNode, layoutSectionNode.type.schema.nodes.layoutColumn).map(({ node: node, pos: pos })=>({
            node: node,
            pos: pos + layoutSectionPos + 1
        }));
};
const $165a594884c31a30$var$getSelectedLayoutColumns = (selection, isColumnSelected)=>{
    const layoutSection = $165a594884c31a30$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const { node: layoutSectionNode, pos: layoutSectionPos } = layoutSection;
    const allLayoutColumns = $165a594884c31a30$var$findLayoutColumnsFromLayoutSection(layoutSectionNode, layoutSectionPos);
    if (!allLayoutColumns.length) return undefined;
    let startIndex = -1;
    let endIndex = -1;
    const selectedLayoutColumns = allLayoutColumns.filter((column, index)=>{
        if (isColumnSelected(column, index)) {
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            return true;
        }
        return false;
    });
    return {
        layoutSectionNode: layoutSectionNode,
        layoutSectionPos: layoutSectionPos,
        selectedLayoutColumns: selectedLayoutColumns,
        startIndex: startIndex,
        endIndex: endIndex
    };
};
const $165a594884c31a30$export$d9c5d9ac81e1479b = (selection)=>{
    return $165a594884c31a30$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        // NodeSelection on a layout column is clearly selected.
        if (selection instanceof (0, $kCECX.NodeSelection) && selection.node === node) return true;
        // For TextSelection, only count columns that are fully contained within the selection
        // (not partial text selections inside a column).
        const nodeEndPos = pos + node.nodeSize;
        return !selection.empty && selection.from <= pos && selection.to >= nodeEndPos;
    });
};
const $165a594884c31a30$export$1ba40f8dfd76f1b5 = (selection)=>{
    return $165a594884c31a30$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        if (selection instanceof (0, $kCECX.NodeSelection) && selection.node === node) return true;
        const nodeEndPos = pos + node.nodeSize;
        return selection.empty ? selection.from > pos && selection.from < nodeEndPos : selection.from < nodeEndPos && selection.to > pos;
    });
};
const $165a594884c31a30$export$1f0e4d47b1eb0108 = (selection)=>{
    const layoutSection = $165a594884c31a30$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const layoutColumns = $165a594884c31a30$var$findLayoutColumnsFromLayoutSection(layoutSection.node, layoutSection.pos);
    if (!layoutColumns?.length) return undefined;
    return {
        layoutSectionNode: layoutSection.node,
        layoutSectionPos: layoutSection.pos,
        selectedLayoutColumns: layoutColumns,
        startIndex: 0,
        endIndex: layoutColumns.length - 1
    };
};
const $165a594884c31a30$export$3645821254ad9933 = (layoutColumn)=>layoutColumn ? layoutColumn.attrs.valign ?? (0, $bbeac3462dd7561c$export$f501538bec3afd75) : undefined;
const $165a594884c31a30$export$22b40f2459c71fe8 = (selection, anchorPosFromHandle)=>{
    const selectedLayoutColumns = $165a594884c31a30$export$d9c5d9ac81e1479b(selection);
    if (!selectedLayoutColumns) return undefined;
    const clickedSelectedColumn = selectedLayoutColumns.selectedLayoutColumns.find(({ pos: pos })=>pos === anchorPosFromHandle);
    return clickedSelectedColumn?.pos ?? selectedLayoutColumns.selectedLayoutColumns[0]?.pos;
};


const $20de433b9f6c9d19$export$6ff908759d68cbdd = [
    'single'
];
const $20de433b9f6c9d19$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $20de433b9f6c9d19$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $20de433b9f6c9d19$var$getWidthsForPreset = (presetLayout)=>{
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
        case 'three_left_sidebars':
            return [
                25,
                25,
                50
            ];
        case 'three_right_sidebars':
            return [
                50,
                25,
                25
            ];
        case 'four_equal':
            return [
                25,
                25,
                25,
                25
            ];
        case 'five_equal':
            return [
                20,
                20,
                20,
                20,
                20
            ];
    }
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
    return [];
};
const $20de433b9f6c9d19$var$isValidLayoutWidthDistributions = (layoutSection)=>{
    let totalWidth = 0;
    let hasInvalidWidth = false;
    (0, $fud2r.mapChildren)(layoutSection, (column)=>column.attrs.width).forEach((width)=>{
        if (typeof width === 'number' && isFinite(width) && width > 0 && width <= 100) totalWidth += width;
        else hasInvalidWidth = true;
    });
    return !hasInvalidWidth && Math.round(totalWidth) === 100;
};
const $20de433b9f6c9d19$export$e406155610be725b = (section)=>{
    const widths = (0, $fud2r.mapChildren)(section, (column)=>column.attrs.width).join(',');
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
        switch(widths){
            case '100':
                return 'single';
            case '33.33,33.33,33.33':
                return 'three_equal';
            case '25,50,25':
                return 'three_with_sidebars';
            case '50,25,25':
                return 'three_right_sidebars';
            case '25,25,50':
                return 'three_left_sidebars';
            case '50,50':
                return 'two_equal';
            case '33.33,66.66':
                return 'two_left_sidebar';
            case '66.66,33.33':
                return 'two_right_sidebar';
            case '25,25,25,25':
                return 'four_equal';
            case '20,20,20,20,20':
                return 'five_equal';
        }
        return;
    }
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $20de433b9f6c9d19$var$isLayoutOutOfSync = (node, presetLayout)=>{
    return node.childCount !== $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout).length;
};
const $20de433b9f6c9d19$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $20de433b9f6c9d19$var$isLayoutOutOfSync(maybeLayoutSection, current) && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) return $20de433b9f6c9d19$var$getDefaultPresetLayout(maybeLayoutSection);
    if (maybeLayoutSection && $20de433b9f6c9d19$export$e406155610be725b(maybeLayoutSection)) return $20de433b9f6c9d19$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $20de433b9f6c9d19$export$af0aef1ee58dfcf = (state, numberOfColumns = 2)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    const columns = (0, $aPdNQ.Fragment).fromArray(Array.from({
        length: numberOfColumns
    }, ()=>layoutColumn.createAndFill({
            width: (0, $bbeac3462dd7561c$export$faa6744ce57d263b)[numberOfColumns]
        })));
    return layoutSection.createAndFill(undefined, columns);
};
const $20de433b9f6c9d19$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $aPdNQ.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $20de433b9f6c9d19$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $bjg0G.safeInsert)($20de433b9f6c9d19$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $20de433b9f6c9d19$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: inputMethod,
                columnCount: (0, $iDrrr.fg)('platform_editor_column_count_analytics') ? 2 : undefined
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })((state, dispatch)=>{
            if (dispatch) dispatch((0, $bjg0G.safeInsert)($20de433b9f6c9d19$export$24df8f7ba30643b8(state))(state.tr));
            return true;
        });
/**
 * Add a column to the right of existing layout
 */ function $20de433b9f6c9d19$var$addColumn(schema, pos) {
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', false)) return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill(undefined));
    };
}
function $20de433b9f6c9d19$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        // check if the column only contains a paragraph with a placeholder text
        // if so, remove the whole column, otherwise just remove the paragraph
        if ((0, $iLrhi.isEmptyDocument)(column)) {
            const fromPos = (0, $jkcNT.editorExperiment)('single_column_layouts', true) ? columnPos : columnPos - 1;
            tr.replaceRange(tr.mapping.map(fromPos), tr.mapping.map(insideRightEdgePos), (0, $aPdNQ.Slice).empty);
        } else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $aPdNQ.Slice).empty);
    };
}
const $20de433b9f6c9d19$var$fromTwoColsToThree = $20de433b9f6c9d19$var$addColumn;
const $20de433b9f6c9d19$var$fromOneColToTwo = $20de433b9f6c9d19$var$addColumn;
const $20de433b9f6c9d19$var$fromTwoColsToOne = $20de433b9f6c9d19$var$removeLastColumnInLayout;
const $20de433b9f6c9d19$var$fromThreeColsToTwo = $20de433b9f6c9d19$var$removeLastColumnInLayout;
const $20de433b9f6c9d19$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
        $20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
    };
};
const $20de433b9f6c9d19$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $20de433b9f6c9d19$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $20de433b9f6c9d19$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
const $20de433b9f6c9d19$var$increaseColumns = (schema, pos, newColumnsNumber = 1)=>{
    return (tr)=>{
        for(let i = 0; i < newColumnsNumber; i++)$20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
    };
};
const $20de433b9f6c9d19$var$decreaseColumns = (node, insideRightEdgePos, columnsNumberToRemove = 1)=>{
    return (tr)=>{
        let endPos = insideRightEdgePos;
        let lastColumn = node.content.lastChild;
        for(let i = 0; i < columnsNumberToRemove; i++){
            lastColumn && $20de433b9f6c9d19$var$removeLastColumnInLayout(lastColumn, endPos - lastColumn.nodeSize, endPos)(tr);
            endPos -= lastColumn?.nodeSize || 0;
            lastColumn = node.content.child(node.childCount - i - 2);
        }
    };
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $20de433b9f6c9d19$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($20de433b9f6c9d19$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $20de433b9f6c9d19$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($20de433b9f6c9d19$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $20de433b9f6c9d19$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($20de433b9f6c9d19$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $20de433b9f6c9d19$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($20de433b9f6c9d19$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $20de433b9f6c9d19$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($20de433b9f6c9d19$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $20de433b9f6c9d19$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($20de433b9f6c9d19$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $20de433b9f6c9d19$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $20de433b9f6c9d19$var$forceColumnStructureNew(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    const columnChange = $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout).length - numCols;
    if (columnChange > 0) $20de433b9f6c9d19$var$increaseColumns(state.schema, insideRightEdgeOfLayoutSection, columnChange)(tr);
    else if (columnChange < 0) $20de433b9f6c9d19$var$decreaseColumns(node, insideRightEdgeOfLayoutSection, -columnChange)(tr);
    return tr;
}
function $20de433b9f6c9d19$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $fud2r.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $20de433b9f6c9d19$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(node, state.schema, $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout)));
}
function $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    const forceColumnStructureFn = (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $20de433b9f6c9d19$var$forceColumnStructureNew : $20de433b9f6c9d19$var$forceColumnStructure;
    let tr = forceColumnStructureFn(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $20de433b9f6c9d19$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $kCECX.NodeSelection) ? new (0, $kCECX.NodeSelection)(selectionPos$) : new (0, $kCECX.TextSelection)(selectionPos$));
}
const $20de433b9f6c9d19$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
            if (pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            if (selectedLayout === layout && node.childCount > 1) return false;
            const tr = $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $20de433b9f6c9d19$var$formatLayoutName(selectedLayout),
                        newLayout: $20de433b9f6c9d19$var$formatLayoutName(layout)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $20de433b9f6c9d19$var$layoutNeedChanges(node) {
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) // Custom widths that sum to 100% are valid and should not be forced back to presets.
    return !$20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node);
    return !$20de433b9f6c9d19$export$e406155610be725b(node);
}
const $20de433b9f6c9d19$var$getDefaultPresetLayout = (layoutNode)=>{
    const layoutColumnCount = layoutNode.childCount;
    if (layoutColumnCount <= 1) return 'single';
    switch(layoutColumnCount){
        case 1:
            return 'single';
        case 2:
            return 'two_equal';
        case 3:
            return 'three_equal';
        case 4:
            return 'four_equal';
        case 5:
            return 'five_equal';
        default:
            return 'five_equal';
    }
};
function $20de433b9f6c9d19$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$20de433b9f6c9d19$var$layoutNeedChanges(node)) return;
        const presetLayout = (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $20de433b9f6c9d19$var$getDefaultPresetLayout(node) : node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $20de433b9f6c9d19$var$columnWidth(node, schema, $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $aPdNQ.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $20de433b9f6c9d19$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $7SvWS.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($20de433b9f6c9d19$var$layoutNeedChanges(node)) change = $20de433b9f6c9d19$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $20de433b9f6c9d19$var$layoutNeedChanges(node)) change = $20de433b9f6c9d19$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $20de433b9f6c9d19$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node) {
            if (node.childCount !== $20de433b9f6c9d19$var$getWidthsForPreset(selectedLayout).length) {
                // Valid custom widths may use a different column count from the selected preset.
                if ((0, $jkcNT.editorExperiment)('advanced_layouts', true) && $20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node)) return;
                return $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
            }
            if (!$20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node) && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) return $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
        }
    }
    return;
};
const $20de433b9f6c9d19$export$7472487719e2c16f = (editorAnalyticsAPI, inputMethod)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                const tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).DELETED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $20de433b9f6c9d19$var$formatLayoutName(selectedLayout),
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $20de433b9f6c9d19$var$formatLayoutName = (layout)=>{
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) switch(layout){
        case 'single':
            return (0, $gjFO5.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $gjFO5.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
        case 'four_equal':
            return (0, $gjFO5.LAYOUT_TYPE).FOUR_COLS_EQUAL;
        case 'five_equal':
            return (0, $gjFO5.LAYOUT_TYPE).FIVE_COLS_EQUAL;
    }
    switch(layout){
        case 'single':
            return (0, $gjFO5.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $gjFO5.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};
const $20de433b9f6c9d19$export$7304947c445e7dbb = 'layoutColumnInsert';
const $20de433b9f6c9d19$var$getPreviousLayoutColumnValign = (selectedLayoutColumns)=>{
    const firstValign = (0, $165a594884c31a30$export$3645821254ad9933)(selectedLayoutColumns[0]?.node);
    const hasMixedValign = selectedLayoutColumns.some(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) !== firstValign);
    return hasMixedValign ? 'mixed' : firstValign ?? (0, $bbeac3462dd7561c$export$f501538bec3afd75);
};
const $20de433b9f6c9d19$var$hasLayoutColumnContent = (node)=>!(0, $iLrhi.isEmptyDocument)(node);
/**
 * Remaps a selection through a position mapping, preserving its type. Used after replacing a
 * layout section's contents so the selection stays in its column instead of being mapped out
 * of the layout. Returns `undefined` if no valid selection can be derived (NodeSelection
 * whose node is no longer selectable falls back to a nearby caret).
 */ const $20de433b9f6c9d19$var$remapSelectionThroughMapping = (selection, mapping, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const mappedPos = clamp(mapping.map(selection.from));
        const nodeAtPos = doc.nodeAt(mappedPos);
        if (nodeAtPos && (0, $kCECX.NodeSelection).isSelectable(nodeAtPos)) return (0, $kCECX.NodeSelection).create(doc, mappedPos);
        return (0, $kCECX.TextSelection).findFrom(doc.resolve(mappedPos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $kCECX.TextSelection)) {
        const mappedFrom = clamp(mapping.map(selection.from));
        const mappedTo = clamp(mapping.map(selection.to));
        try {
            return (0, $kCECX.TextSelection).create(doc, mappedFrom, mappedTo);
        } catch  {
            return undefined;
        }
    }
    return undefined;
};
const $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection = (tr, api)=>{
    const insertMeta = tr.getMeta($20de433b9f6c9d19$export$7304947c445e7dbb);
    if (insertMeta) {
        const mapping = insertMeta.side === 'left' ? new (0, $eOaGc.Mapping)([
            new (0, $eOaGc.StepMap)([
                insertMeta.insertedColumnPos,
                0,
                insertMeta.insertedColumnNodeSize
            ])
        ]) : new (0, $eOaGc.Mapping)();
        api?.blockControls?.commands.mapPreservedSelection(mapping)({
            tr: tr
        });
        return;
    }
    // Width and alignment updates should keep original layout column selection unchanged.
    if (tr.getMeta('scrollIntoView') === false && tr.docChanged) api?.blockControls?.commands.mapPreservedSelection(new (0, $eOaGc.Mapping)())({
        tr: tr
    });
};
function $20de433b9f6c9d19$export$1e9b718436507bc8() {
    return (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? (0, $bbeac3462dd7561c$export$92f9af977c85ea46) : (0, $bbeac3462dd7561c$export$2583e740deddd6d);
}
const $20de433b9f6c9d19$var$insertLayoutColumnAt = (side, editorAnalyticsAPI, inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$1ba40f8dfd76f1b5)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const selectedColumnIndex = side === 'left' ? startIndex : endIndex;
        const selectedColumnCount = selectedLayoutColumns.length;
        if (layoutSectionNode.childCount >= $20de433b9f6c9d19$export$1e9b718436507bc8()) return null;
        const insertIndex = side === 'left' ? selectedColumnIndex : selectedColumnIndex + 1;
        const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributedWidths = (0, $c44623e798e01dfd$export$3d07e1109dd4c8ac)(existingWidths, insertIndex, $20de433b9f6c9d19$export$1e9b718436507bc8(), (0, $bbeac3462dd7561c$export$a9683f74b118e94b));
        if (redistributedWidths === existingWidths) return null;
        const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes;
        const newColumn = layoutColumn.createAndFill({
            width: redistributedWidths[insertIndex]
        });
        if (!newColumn) return null;
        const updatedColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index === insertIndex) updatedColumns.push(newColumn);
            updatedColumns.push(column);
        });
        if (insertIndex === layoutSectionNode.childCount) updatedColumns.push(newColumn);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $aPdNQ.Fragment).fromArray(updatedColumns));
        let insertedColumnOffset = 0;
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < insertIndex) insertedColumnOffset += column.nodeSize;
        });
        const insertedColumnPos = layoutSectionPos + 1 + insertedColumnOffset;
        tr.setMeta($20de433b9f6c9d19$export$7304947c445e7dbb, {
            insertedColumnNodeSize: newColumn.nodeSize,
            insertedColumnPos: insertedColumnPos,
            side: side
        });
        // Capture the selection before the section content is replaced (the replace below maps
        // it out of the layout by default). The menu path restores its own preserved selection
        // afterwards, so this restoration only matters for the cursor-in-column case.
        const originalSelection = tr.selection;
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributedWidths));
        // Inserting left shifts positions at/after the new column right by its size; inserting
        // right leaves them unchanged. Remap the original selection through that mapping.
        const insertMapping = side === 'left' ? new (0, $eOaGc.Mapping)([
            new (0, $eOaGc.StepMap)([
                insertedColumnPos,
                0,
                newColumn.nodeSize
            ])
        ]) : new (0, $eOaGc.Mapping)();
        const restoredSelection = $20de433b9f6c9d19$var$remapSelectionThroughMapping(originalSelection, insertMapping, tr.doc);
        if (restoredSelection) tr.setSelection(restoredSelection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                endIndex: endIndex,
                inputMethod: inputMethod,
                newColumnCount: redistributedWidths.length,
                previousColumnCount: layoutSectionNode.childCount,
                selectedCount: selectedColumnCount,
                side: side,
                startIndex: startIndex
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$7dcaf37842fa555e = ({ side: side, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        const result = $20de433b9f6c9d19$var$insertLayoutColumnAt(side, editorAnalyticsAPI, inputMethod)({
            tr: tr
        });
        if (result) $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
        return result;
    };
const $20de433b9f6c9d19$export$4bf533320bf88c4 = ({ valign: valign, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
        if (!selectedLayoutColumnsResult) return null;
        const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const previousValign = $20de433b9f6c9d19$var$getPreviousLayoutColumnValign(selectedLayoutColumns);
        const columnsToUpdate = selectedLayoutColumns.filter(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) !== valign);
        if (columnsToUpdate.length === 0) return null;
        const updatedColumnCount = columnsToUpdate.length;
        columnsToUpdate.forEach(({ node: node, pos: pos })=>{
            tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                valign: valign
            });
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                columnCount: layoutSectionNode.childCount,
                endIndex: endIndex,
                inputMethod: inputMethod,
                previousValign: previousValign,
                selectedCount: selectedLayoutColumns.length,
                startIndex: startIndex,
                updatedCount: updatedColumnCount,
                valign: valign
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
        return tr;
    };
const $20de433b9f6c9d19$export$3155fb5f705eeef0 = (editorAnalyticsAPI, api)=>({ inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU, target: target = 'selectedColumns' } = {})=>({ tr: tr })=>{
            const selectedLayoutColumnsResult = target === 'allColumns' ? (0, $165a594884c31a30$export$1f0e4d47b1eb0108)(tr.selection) : (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
            if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length < 2) return null;
            const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
            const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
            const selectedWidths = selectedLayoutColumns.map(({ node: node })=>node.attrs.width);
            const distribution = (0, $c44623e798e01dfd$export$e260f2e2ca90998a)(selectedWidths);
            if (!distribution) return null;
            const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
            if ((0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)(selectedWidths, distribution)) return null;
            // Build new widths array: selected columns get equal share, unselected unchanged.
            // Assign rounded (2dp) equal widths to all selected cols except the last, which absorbs
            // the rounding remainder so the sum of selected widths equals selectedTotal exactly.
            let assignedToSelected = 0;
            let selectedAssignedCount = 0;
            const newWidths = existingWidths.map((w, idx)=>{
                if (idx < startIndex || idx > endIndex) return w;
                selectedAssignedCount += 1;
                if (selectedAssignedCount < selectedLayoutColumns.length) {
                    assignedToSelected += equalWidth;
                    return equalWidth;
                }
                // Last selected column: absorb the remainder to avoid drift
                return Number((selectedTotal - assignedToSelected).toFixed(2));
            });
            // Apply widths via setNodeMarkup per selected column — keeps nodes in place (preserves identity, marks, decorations)
            selectedLayoutColumns.forEach(({ node: node, pos: pos }, i)=>{
                const colIdx = startIndex + i;
                tr.setNodeMarkup(pos, node.type, {
                    ...node.attrs,
                    width: newWidths[colIdx]
                });
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    columnCount: layoutSectionNode.childCount,
                    endIndex: endIndex,
                    inputMethod: inputMethod,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex,
                    target: target
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            tr.setMeta('scrollIntoView', false);
            $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
            return tr;
        };
const $20de433b9f6c9d19$export$f9a5c2c84987525d = (options)=>({ tr: tr })=>{
        tr.setMeta('toggleLayoutColumnMenu', options);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$21f559cd4fbd479 = (show)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
        const positions = show ? selectedLayoutColumnsResult?.selectedLayoutColumns.map(({ pos: pos })=>pos) ?? [] : null;
        tr.setMeta('layoutColumnDangerPreview', positions);
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$b3b830a5fba26889 = ({ inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU } = {}, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        // Only delete columns that are explicitly selected (a column NodeSelection or a selection
        // fully containing columns). This stops a bare caret inside a column — including inside
        // nested content such as a table — from deleting the whole column via the delete shortcut.
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
        const hadContent = selectedLayoutColumns.some(({ node: node })=>$20de433b9f6c9d19$var$hasLayoutColumnContent(node));
        const emitDeleteColumnAnalytics = (newColumnCount)=>{
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    endIndex: endIndex,
                    hadContent: hadContent,
                    inputMethod: inputMethod,
                    newColumnCount: newColumnCount,
                    previousColumnCount: layoutSectionNode.childCount,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
        };
        // If all columns are selected, remove the entire layoutSection
        if (selectedLayoutColumns.length === layoutSectionNode.childCount) {
            tr.delete(layoutSectionPos, layoutSectionPos + layoutSectionNode.nodeSize);
            emitDeleteColumnAnalytics(0);
            tr.setMeta('scrollIntoView', false);
            api?.blockControls?.commands.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        }
        // Build new column list without the selected columns
        const remainingColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < startIndex || index > endIndex) remainingColumns.push(column);
        });
        // Redistribute widths proportionally among remaining columns using shared utility
        const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributed = selectedLayoutColumns.map((_, i)=>startIndex + i)// Delete highest indices first so lower original indices still point at the same columns
        // as each redistribution step shrinks the widths array.
        .reverse().reduce((widths, selectedIndex)=>(0, $c44623e798e01dfd$export$7a23b11013fe122c)(widths, selectedIndex, (0, $bbeac3462dd7561c$export$a9683f74b118e94b)), existingWidths);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $aPdNQ.Fragment).fromArray(remainingColumns));
        // A text selection can fully contain columns. Restore its caret in a remaining column;
        // block controls own the landing for a column NodeSelection.
        const hadTextSelection = tr.selection instanceof (0, $kCECX.TextSelection);
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributed));
        // Keep a text selection within the layout after the selected columns are removed.
        const remainingColumnCount = remainingColumns.length;
        if (hadTextSelection && remainingColumnCount > 0) {
            const targetColumnIndex = Math.min(startIndex, remainingColumnCount - 1);
            const updatedSectionNode = tr.doc.nodeAt(layoutSectionPos);
            if (updatedSectionNode) {
                let columnOffset = 1;
                for(let columnIndex = 0; columnIndex < targetColumnIndex; columnIndex++)columnOffset += updatedSectionNode.child(columnIndex).nodeSize;
                // +1 to land inside the column's first child rather than on the column boundary.
                const caretPos = layoutSectionPos + columnOffset + 1;
                if (caretPos >= 0 && caretPos <= tr.doc.content.size) {
                    const caretSelection = (0, $kCECX.TextSelection).findFrom(tr.doc.resolve(caretPos), 1, true);
                    if (caretSelection) tr.setSelection(caretSelection);
                }
            }
        }
        emitDeleteColumnAnalytics(redistributed.length);
        tr.setMeta('scrollIntoView', false);
        api?.blockControls?.commands.stopPreservingSelection()({
            tr: tr
        });
        return tr;
    };






var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


const $85a43829160bedc9$var$bindLayoutColumnShortcut = (shortcut, command, list)=>{
    if (!shortcut) return;
    (0, $ldqjS.bindKeymapWithEditorCommand)(shortcut, command, list);
};
/**
 * Creates shortcut handlers for layout column actions.
 */ function $85a43829160bedc9$var$keymapPlugin({ api: api }) {
    const list = {};
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnBefore).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'left',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnBeforeVO).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'left',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnAfter).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'right',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnAfterVO).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'right',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.deleteColumn).common, (0, $20de433b9f6c9d19$export$b3b830a5fba26889)({
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    return (0, $eBSR7.keymap)(list);
}
var $85a43829160bedc9$export$2e2bcd8739ae039 = $85a43829160bedc9$var$keymapPlugin;






var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");

var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $dTPhv = parcelRequire("dTPhv");


var $44cyU = parcelRequire("44cyU");











var $8nvEM = parcelRequire("8nvEM");






var $cbY7C = parcelRequire("cbY7C");














/**
 * Re-creates a selection at the same positions against the resized document. A resize only
 * changes width attrs (not node count, order, or size), so the original positions are still
 * valid. Returns `undefined` if no valid selection can be made.
 */ const $0ab5832e42b8afea$var$remapResizeSelection = (selection, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const pos = clamp(selection.from);
        const nodeAtPos = doc.nodeAt(pos);
        if (nodeAtPos && (0, $kCECX.NodeSelection).isSelectable(nodeAtPos)) return (0, $kCECX.NodeSelection).create(doc, pos);
        return (0, $kCECX.TextSelection).findFrom(doc.resolve(pos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $kCECX.TextSelection)) try {
        return (0, $kCECX.TextSelection).create(doc, clamp(selection.from), clamp(selection.to));
    } catch  {
        return undefined;
    }
    return undefined;
};
// Class names for the column resize divider widget — must stay in sync with layout.ts in editor-core
const $0ab5832e42b8afea$var$layoutColumnDividerClassName = 'layout-column-divider';
const $0ab5832e42b8afea$var$layoutColumnDividerRailClassName = 'layout-column-divider-rail';
const $0ab5832e42b8afea$var$layoutColumnDividerThumbClassName = 'layout-column-divider-thumb';
// Module-level drag state so it survives widget DOM recreation during transactions.
let $0ab5832e42b8afea$var$dragState = null;
/**
 * Dispatches a single undoable ProseMirror transaction to commit the final
 * column widths after a drag completes.
 */ const $0ab5832e42b8afea$var$dispatchColumnWidths = (view, sectionPos, leftColIndex, leftWidth, rightWidth, editorAnalyticsAPI)=>{
    const { state: state } = view;
    const sectionNode = state.doc.nodeAt(sectionPos);
    if (!sectionNode) return;
    const { layoutColumn: layoutColumn } = state.schema.nodes;
    const tr = state.tr;
    const newColumns = [];
    sectionNode.forEach((child, _offset, index)=>{
        if (child.type === layoutColumn) {
            let newWidth = child.attrs.width;
            if (index === leftColIndex) newWidth = Number(leftWidth.toFixed(2));
            else if (index === leftColIndex + 1) newWidth = Number(rightWidth.toFixed(2));
            newColumns.push(layoutColumn.create({
                ...child.attrs,
                width: newWidth
            }, child.content, child.marks));
        } else newColumns.push(child);
    });
    // Capture the selection before the replace below, which otherwise maps the caret out of
    // the layout to the following paragraph. Restored at the same positions afterwards.
    const selectionBeforeResize = state.selection;
    tr.replaceWith(sectionPos + 1, sectionPos + sectionNode.nodeSize - 1, (0, $aPdNQ.Fragment).from(newColumns));
    tr.setMeta('layoutColumnResize', true);
    tr.setMeta('scrollIntoView', false);
    if (selectionBeforeResize) {
        const restoredSelection = $0ab5832e42b8afea$var$remapResizeSelection(selectionBeforeResize, tr.doc);
        if (restoredSelection) tr.setSelection(restoredSelection);
    }
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).DRAGGED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
        attributes: {
            columnCount: sectionNode.childCount,
            leftColumnIndex: leftColIndex,
            leftColumnWidth: Number(leftWidth.toFixed(2)),
            rightColumnWidth: Number(rightWidth.toFixed(2)),
            inputMethod: (0, $krYZG.INPUT_METHOD).DRAG
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    view.dispatch(tr);
};
/**
 * Calculates new column widths from the current mouse X position during drag.
 * Uses the columns-only width cached at mousedown — no layout reflow.
 *
 * The denominator is `columnsWidth` (the total flex container width minus
 * divider widgets and flex gaps) so that a 1 px mouse movement corresponds
 * to the exact same visual shift in the column boundary, eliminating the
 * few-pixel drift that occurred when using the full section width.
 */ const $0ab5832e42b8afea$var$calcDragWidths = (clientX)=>{
    if (!$0ab5832e42b8afea$var$dragState) return null;
    const { columnsWidth: columnsWidth } = $0ab5832e42b8afea$var$dragState;
    if (columnsWidth === 0) return null;
    const deltaX = clientX - $0ab5832e42b8afea$var$dragState.startX;
    const combinedWidth = $0ab5832e42b8afea$var$dragState.startLeftWidth + $0ab5832e42b8afea$var$dragState.startRightWidth;
    const deltaPercent = deltaX / columnsWidth * 100;
    let leftWidth = $0ab5832e42b8afea$var$dragState.startLeftWidth + deltaPercent;
    let rightWidth = $0ab5832e42b8afea$var$dragState.startRightWidth - deltaPercent;
    if (leftWidth < (0, $bbeac3462dd7561c$export$a9683f74b118e94b)) {
        leftWidth = (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
        rightWidth = combinedWidth - (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
    } else if (rightWidth < (0, $bbeac3462dd7561c$export$a9683f74b118e94b)) {
        rightWidth = (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
        leftWidth = combinedWidth - (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
    }
    return {
        leftWidth: leftWidth,
        rightWidth: rightWidth
    };
};
const $0ab5832e42b8afea$var$onDragMouseMove = (e)=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    // If the mouse button was released outside the window (e.g. over browser chrome
    // or an iframe), we won't receive a mouseup on ownerDoc. Detect this by checking
    // whether any button is still held — if not, treat it as a drag end.
    if (e.buttons === 0) {
        $0ab5832e42b8afea$var$onDragEnd(e.clientX);
        return;
    }
    // Always capture the latest clientX so the rAF callback uses the most recent
    // mouse position. Previously, intermediate positions were dropped when an rAF
    // was already scheduled, causing the column boundary to lag behind the cursor.
    $0ab5832e42b8afea$var$dragState.lastClientX = e.clientX;
    // If a paint frame is already scheduled it will pick up lastClientX — no need
    // to schedule another one.
    if ($0ab5832e42b8afea$var$dragState.rafId !== null) return;
    $0ab5832e42b8afea$var$dragState.rafId = requestAnimationFrame(()=>{
        if (!$0ab5832e42b8afea$var$dragState) return;
        $0ab5832e42b8afea$var$dragState.rafId = null;
        const widths = $0ab5832e42b8afea$var$calcDragWidths($0ab5832e42b8afea$var$dragState.lastClientX);
        if (!widths) return;
        // Write flex-basis directly onto the column elements' inline styles for immediate
        // visual feedback. This beats PM's own inline flex-basis value without dispatching
        // any PM transaction — keeping drag completely off the ProseMirror render path.
        // The LayoutColumnView.ignoreMutation implementation ensures PM's MutationObserver
        // does not revert these style changes mid-drag.
        $0ab5832e42b8afea$var$dragState.hasDragged = true;
        $0ab5832e42b8afea$var$dragState.leftColEl.style.flexBasis = `${widths.leftWidth}%`;
        $0ab5832e42b8afea$var$dragState.rightColEl.style.flexBasis = `${widths.rightWidth}%`;
    });
};
/**
 * Shared teardown for all drag-end paths (mouseup, missed mouseup detected via
 * e.buttons===0 on mousemove, window blur, and visibilitychange). Commits the
 * final column widths if a real drag occurred.
 */ const $0ab5832e42b8afea$var$onDragEnd = (clientX)=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    const { view: view, sectionPos: sectionPos, leftColIndex: leftColIndex, leftColEl: leftColEl, rightColEl: rightColEl, hasDragged: hasDragged, rafId: rafId, startLeftWidth: startLeftWidth, startRightWidth: startRightWidth, unbindListeners: unbindListeners, editorAnalyticsAPI: editorAnalyticsAPI } = $0ab5832e42b8afea$var$dragState;
    unbindListeners();
    // Cancel any pending rAF so a stale frame doesn't write styles after teardown.
    if (rafId !== null) cancelAnimationFrame(rafId);
    const ownerDoc = view.dom.ownerDocument;
    ownerDoc.body.style.userSelect = '';
    ownerDoc.body.style.cursor = '';
    const widths = $0ab5832e42b8afea$var$calcDragWidths(clientX);
    $0ab5832e42b8afea$var$dragState = null;
    if (!hasDragged) // The user clicked without dragging — no flex-basis overrides were written,
    // so there is nothing to clean up and no transaction to dispatch.
    return;
    // Clear the drag-time flex-basis overrides. The PM transaction below will
    // write the committed widths back into the node attrs and re-render the DOM.
    leftColEl.style.flexBasis = '';
    rightColEl.style.flexBasis = '';
    if (widths && (widths.leftWidth !== startLeftWidth || widths.rightWidth !== startRightWidth)) $0ab5832e42b8afea$var$dispatchColumnWidths(view, sectionPos, leftColIndex, widths.leftWidth, widths.rightWidth, editorAnalyticsAPI);
};
const $0ab5832e42b8afea$var$onDragMouseUp = (e)=>{
    $0ab5832e42b8afea$var$onDragEnd(e.clientX);
};
/**
 * Called when the window loses focus (blur) or the tab becomes hidden
 * (visibilitychange). In either case the user can't be dragging anymore,
 * so we commit the drag at the last known mouse position.
 */ const $0ab5832e42b8afea$var$onDragCancel = ()=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    // Commit at the last captured mouse position rather than startX, so the
    // columns stay where the user last saw them.
    $0ab5832e42b8afea$var$onDragEnd($0ab5832e42b8afea$var$dragState.lastClientX);
};
/**
 * Resolves the layout section a divider sits in and which pair of columns it separates.
 *
 * This is derived from the widget's own live position, which ProseMirror keeps up to date. That is
 * what lets the decoration key omit the section position: the key previously embedded it, so
 * inserting a single character above a layout changed the key of every divider below and forced
 * ProseMirror to destroy and rebuild all of them.
 */ const $0ab5832e42b8afea$var$resolveDividerTarget = (view, getPos)=>{
    const pos = getPos();
    if (pos === undefined) return null;
    // The widget is anchored at the position of the column it precedes, which resolves to a
    // position directly inside the layout section.
    const $pos = view.state.doc.resolve(pos);
    const colIndex = $pos.index();
    if ($pos.parent.type !== view.state.schema.nodes.layoutSection || colIndex < 1) return null;
    return {
        sectionNode: $pos.parent,
        sectionPos: $pos.before(),
        leftColIndex: colIndex - 1
    };
};
/**
 * Creates a column divider widget DOM element with drag-to-resize interaction for
 * the adjacent layout columns. During drag, flex-basis is mutated directly on the
 * column DOM elements for zero-overhead visual feedback (no PM transactions).
 * A single undoable PM transaction is dispatched on mouseup to commit the final widths.
 */ const $0ab5832e42b8afea$var$createColumnDividerWidget = (view, getPos, editorAnalyticsAPI)=>{
    const ownerDoc = view.dom.ownerDocument;
    // Outer container: wide transparent hit area for easy grabbing, zero flex footprint
    const divider = ownerDoc.createElement('div');
    divider.classList.add($0ab5832e42b8afea$var$layoutColumnDividerClassName);
    divider.contentEditable = 'false';
    // Rail: styled via layoutColumnDividerStyles in layout.ts
    const rail = ownerDoc.createElement('div');
    rail.classList.add($0ab5832e42b8afea$var$layoutColumnDividerRailClassName);
    divider.appendChild(rail);
    // Thumb: styled via layoutColumnDividerStyles in layout.ts
    const thumb = ownerDoc.createElement('div');
    thumb.classList.add($0ab5832e42b8afea$var$layoutColumnDividerThumbClassName);
    rail.appendChild(thumb);
    const unbindMouseDown = (0, $cbY7C.bind)(divider, {
        type: 'mousedown',
        listener: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const resolved = $0ab5832e42b8afea$var$resolveDividerTarget(view, getPos);
            if (!resolved) return;
            const { sectionNode: sectionNode, leftColIndex: leftColIndex, sectionPos: resolvedSectionPos } = resolved;
            // Get the initial widths of the two adjacent columns
            let leftCol = null;
            let rightCol = null;
            sectionNode.forEach((child, _offset, index)=>{
                if (index === leftColIndex) leftCol = child;
                if (index === leftColIndex + 1) rightCol = child;
            });
            if (!leftCol || !rightCol) return;
            const sectionElement = divider.closest('[data-layout-section]');
            if (!(sectionElement instanceof HTMLElement)) return;
            // Capture the two adjacent column DOM elements upfront so mousemove can
            // mutate their flex-basis directly without any PM transaction overhead.
            // Query by data-layout-column-index (stamped by LayoutColumnView) rather than
            // relying on positional order of [data-layout-column] elements, which would
            // break if the DOM structure or ordering ever changes.
            const leftColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex}"]`);
            const rightColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex + 1}"]`);
            if (!leftColEl || !rightColEl) return;
            const unbindMove = (0, $cbY7C.bind)(ownerDoc, {
                type: 'mousemove',
                listener: $0ab5832e42b8afea$var$onDragMouseMove
            });
            const unbindUp = (0, $cbY7C.bind)(ownerDoc, {
                type: 'mouseup',
                listener: $0ab5832e42b8afea$var$onDragMouseUp
            });
            // If the user releases the mouse outside the browser window (e.g. over the
            // OS desktop) and then brings the cursor back, we won't get a mouseup on
            // ownerDoc. Listening on window for blur and on the document for
            // visibilitychange catches tab switches and window focus loss respectively.
            const unbindBlur = (0, $cbY7C.bind)(ownerDoc.defaultView ?? window, {
                type: 'blur',
                listener: $0ab5832e42b8afea$var$onDragCancel
            });
            const unbindVisibility = (0, $cbY7C.bind)(ownerDoc, {
                type: 'visibilitychange',
                listener: $0ab5832e42b8afea$var$onDragCancel
            });
            // Compute the width available to columns only (excluding divider widgets and
            // flex gaps). Using this as the denominator ensures that a 1 px mouse delta
            // translates to the exact pixel shift on the column boundary.
            const sectionRect = sectionElement.getBoundingClientRect();
            const dividers = sectionElement.querySelectorAll(`.${$0ab5832e42b8afea$var$layoutColumnDividerClassName}`);
            let dividersWidth = 0;
            dividers.forEach((d)=>{
                dividersWidth += d.getBoundingClientRect().width;
            });
            // Account for CSS gap between flex children. The gap is applied between
            // every pair of direct children (columns + divider widgets).
            const computedGap = parseFloat(getComputedStyle(sectionElement).gap || '0');
            const childCount = sectionElement.children.length;
            const totalGap = childCount > 1 ? computedGap * (childCount - 1) : 0;
            const columnsWidth = sectionRect.width - dividersWidth - totalGap;
            $0ab5832e42b8afea$var$dragState = {
                editorAnalyticsAPI: editorAnalyticsAPI,
                hasDragged: false,
                lastClientX: e.clientX,
                rafId: null,
                view: view,
                sectionPos: resolvedSectionPos,
                leftColIndex: leftColIndex,
                leftColEl: leftColEl,
                rightColEl: rightColEl,
                startX: e.clientX,
                startLeftWidth: leftCol.attrs.width,
                startRightWidth: rightCol.attrs.width,
                columnsWidth: columnsWidth,
                sectionElement: sectionElement,
                unbindListeners: ()=>{
                    unbindMove();
                    unbindUp();
                    unbindBlur();
                    unbindVisibility();
                }
            };
            ownerDoc.body.style.userSelect = 'none';
            ownerDoc.body.style.cursor = 'col-resize';
        }
    });
    return {
        target: divider,
        destroy: unbindMouseDown
    };
};
const $0ab5832e42b8afea$export$b54a43c7f9b448fd = (state, view, editorAnalyticsAPI)=>{
    const decorations = [];
    if (!view) return decorations;
    const { layoutSection: layoutSection, bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    let sectionIndex = 0;
    state.doc.descendants((node, pos)=>{
        if (node.type === layoutSection) {
            // This layout's ordinal in the document, used below as a position-independent key.
            const sectionOrdinal = sectionIndex++;
            // Walk through layout column children and add dividers between them
            node.forEach((_, offset, index)=>{
                // Add a divider widget BEFORE every column except the first
                if (index > 0) {
                    const widgetPos = pos + offset + 1; // position at the start of this column
                    // Keyed by the layout's ordinal rather than its position, so an edit elsewhere in
                    // the document doesn't invalidate it. A position-derived key changed on every
                    // keystroke above a layout, making the regenerated DecorationSet compare unequal
                    // and forcing ProseMirror to destroy and rebuild every divider below the edit. The
                    // widget resolves its own section from `getPos` (see `resolveDividerTarget`), so it
                    // stays correct wherever it ends up.
                    //
                    // `toDOM` must also stay lazy: most of the `Decoration`s returned here are matched
                    // by key against the previous set and discarded without ever being rendered.
                    // Building the widget eagerly would create three elements and bind a `mousedown`
                    // listener per divider per call, and the discarded ones never receive `destroy`.
                    let unbindMouseDown;
                    decorations.push((0, $8nvEM.Decoration).widget(widgetPos, (widgetView, getPos)=>{
                        const { target: target, destroy: destroy } = $0ab5832e42b8afea$var$createColumnDividerWidget(widgetView, getPos, editorAnalyticsAPI);
                        unbindMouseDown = destroy;
                        return target;
                    }, {
                        side: -1,
                        // place before the position
                        key: `layout-col-divider-${sectionOrdinal}-${index}`,
                        ignoreSelection: true,
                        destroy: ()=>{
                            unbindMouseDown?.();
                            unbindMouseDown = undefined;
                        }
                    }));
                }
            });
            return false; // don't descend into children
        }
        // A `layoutSection` is only valid as a direct child of `doc` or `bodiedSyncBlock`, so there
        // is nothing to find anywhere else. The unrestricted walk visited every node in the
        // document — every table cell, list item and text node — on every `decorations(state)` read.
        return node.type === bodiedSyncBlock;
    });
    return decorations;
};





var $4iudd = parcelRequire("4iudd");














var $ieeJu = parcelRequire("ieeJu");





var $cozmU = parcelRequire("cozmU");





var $3k5Tv = parcelRequire("3k5Tv");


var $Igylv = parcelRequire("Igylv");

var $g9sVl = parcelRequire("g9sVl");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $7Y8M5 = parcelRequire("7Y8M5");











var $cBSrP = parcelRequire("cBSrP");


var $8dxef = parcelRequire("8dxef");


var $aWssQ = parcelRequire("aWssQ");


var $aiyg1 = parcelRequire("aiyg1");
















const $b84766e5f44e23e9$export$6cdb476c834bc60 = 8;
const $b84766e5f44e23e9$var$GUIDELINE_KEYS = {
    lineLength: 'grid',
    wide: 'wide',
    fullWidth: 'full_width'
};
const $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS = {
    lineLength: 'center',
    wide: 'wide',
    fullWidth: 'full-width'
};
const $b84766e5f44e23e9$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $b84766e5f44e23e9$export$54a1e15ba45852e2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreakoutGuidelines(getEditorWidth, isResizing, t0) {
    const $ = (0, $bDgLe.c)(38);
    const dynamicFullWidthGuidelineOffset = t0 === undefined ? 0 : t0;
    let t1;
    if ($[0] !== getEditorWidth) {
        t1 = getEditorWidth();
        $[0] = getEditorWidth;
        $[1] = t1;
    } else t1 = $[1];
    const widthState = t1;
    let t2;
    bb0: {
        if (!isResizing) {
            let t3;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {};
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[3] !== widthState) {
            t3 = widthState || {};
            $[3] = widthState;
            $[4] = t3;
        } else t3 = $[4];
        const { width: width, lineLength: lineLength } = t3;
        let t4;
        if ($[5] !== lineLength) {
            t4 = lineLength ? Math.round(lineLength * (0, $7Y8M5.breakoutWideScaleRatio)) : undefined;
            $[5] = lineLength;
            $[6] = t4;
        } else t4 = $[6];
        const wideCalWithRatio = t4;
        let t5;
        if ($[7] !== wideCalWithRatio) {
            t5 = (0, $jkcNT.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
            $[7] = wideCalWithRatio;
            $[8] = t5;
        } else t5 = $[8];
        const wide = t5;
        let t6;
        if ($[9] !== width) {
            t6 = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                exposure: true
            }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
            $[9] = width;
            $[10] = t6;
        } else t6 = $[10];
        const padding = t6;
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : undefined;
        let t7;
        if ($[11] !== lineLength) {
            t7 = (0, $jkcNT.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength;
            $[11] = lineLength;
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== fullWidth || $[14] !== t7 || $[15] !== wide) {
            t8 = {
                wide: wide,
                fullWidth: fullWidth,
                lineLength: t7
            };
            $[13] = fullWidth;
            $[14] = t7;
            $[15] = wide;
            $[16] = t8;
        } else t8 = $[16];
        t2 = t8;
    }
    const { lineLength: lineLength_0, wide: wide_0, fullWidth: fullWidth_0 } = t2;
    let t3;
    bb1: {
        if (!fullWidth_0 || !wide_0 || !lineLength_0 || fullWidth_0 <= ((0, $jkcNT.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength_0)) {
            t3 = null;
            break bb1;
        }
        if (fullWidth_0 - wide_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) {
            let t4;
            if ($[17] !== fullWidth_0 || $[18] !== lineLength_0 || $[19] !== wide_0) {
                t4 = {
                    lineLength: lineLength_0,
                    wide: wide_0,
                    fullWidth: fullWidth_0
                };
                $[17] = fullWidth_0;
                $[18] = lineLength_0;
                $[19] = wide_0;
                $[20] = t4;
            } else t4 = $[20];
            t3 = t4;
            break bb1;
        }
        if (fullWidth_0 <= wide_0 && fullWidth_0 - lineLength_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) {
            let t4;
            if ($[21] !== fullWidth_0 || $[22] !== lineLength_0) {
                t4 = {
                    lineLength: lineLength_0,
                    fullWidth: fullWidth_0
                };
                $[21] = fullWidth_0;
                $[22] = lineLength_0;
                $[23] = t4;
            } else t4 = $[23];
            t3 = t4;
            break bb1;
        }
        t3 = null;
    }
    const defaultSnappingWidths = t3;
    let t4;
    bb2: {
        if (!isResizing || !defaultSnappingWidths) {
            t4 = null;
            break bb2;
        }
        let t5;
        if ($[24] !== defaultSnappingWidths) {
            t5 = {
                x: Object.values(defaultSnappingWidths)
            };
            $[24] = defaultSnappingWidths;
            $[25] = t5;
        } else t5 = $[25];
        t4 = t5;
    }
    const snaps = t4;
    const [currentLayout, setCurrentLayout] = (0, $cozmU.useState)(null);
    let t5;
    if ($[26] !== currentLayout || $[27] !== defaultSnappingWidths) {
        bb3: {
            const guidelines = [];
            if (!defaultSnappingWidths) {
                t5 = guidelines;
                break bb3;
            }
            Object.entries(defaultSnappingWidths).map((t6)=>{
                const [key, value] = t6;
                if (value) {
                    guidelines.push({
                        key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_left`,
                        position: {
                            x: -$b84766e5f44e23e9$var$roundToNearest(value / 2)
                        },
                        active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                    });
                    guidelines.push({
                        key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_right`,
                        position: {
                            x: $b84766e5f44e23e9$var$roundToNearest(value / 2)
                        },
                        active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                    });
                }
            });
            t5 = guidelines;
        }
        $[26] = currentLayout;
        $[27] = defaultSnappingWidths;
        $[28] = t5;
    } else t5 = $[28];
    const guidelines_0 = t5;
    let t6;
    if ($[29] !== fullWidth_0 || $[30] !== lineLength_0 || $[31] !== wide_0) {
        t6 = (newWidth)=>{
            if (typeof newWidth !== "number") {
                setCurrentLayout(null);
                return;
            }
            if (lineLength_0 && Math.abs(newWidth - lineLength_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout("center");
            else {
                if (wide_0 && Math.abs(newWidth - wide_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout("wide");
                else if (fullWidth_0 && (fullWidth_0 + (0, $7Y8M5.akEditorGutterPadding) - newWidth < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth_0)) setCurrentLayout("full-width");
                else setCurrentLayout(null);
            }
        };
        $[29] = fullWidth_0;
        $[30] = lineLength_0;
        $[31] = wide_0;
        $[32] = t6;
    } else t6 = $[32];
    const setCurrentWidth = t6;
    let t7;
    if ($[33] !== currentLayout || $[34] !== guidelines_0 || $[35] !== setCurrentWidth || $[36] !== snaps) {
        t7 = {
            snaps: snaps,
            currentLayout: currentLayout,
            guidelines: guidelines_0,
            setCurrentWidth: setCurrentWidth
        };
        $[33] = currentLayout;
        $[34] = guidelines_0;
        $[35] = setCurrentWidth;
        $[36] = snaps;
        $[37] = t7;
    } else t7 = $[37];
    return t7;
} : function useBreakoutGuidelines(getEditorWidth, isResizing, dynamicFullWidthGuidelineOffset = 0) {
    const widthState = getEditorWidth();
    const { lineLength: lineLength_0, wide: wide_0, fullWidth: fullWidth_0 } = (0, $cozmU.useMemo)(()=>{
        if (!isResizing) return {};
        const { width: width, lineLength: lineLength } = widthState || {};
        const wideCalWithRatio = lineLength ? Math.round(lineLength * (0, $7Y8M5.breakoutWideScaleRatio)) : undefined;
        // When page is full width, lineLength from widthState can be much wider than 760.
        // But the lineLength variable here is being used like a const 760.
        // when the page is full width, the calculation of wide is wrong.
        // Actuall the wide is the wide breakout point, which is
        const wide = (0, $jkcNT.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
        const padding = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : undefined;
        return {
            wide: wide,
            fullWidth: fullWidth,
            // When page is full width, lineLength from widthState can be much wider than 760.
            // But the lineLength variable here is being used like a const 760.
            lineLength: (0, $jkcNT.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength
        };
    }, [
        widthState,
        isResizing,
        dynamicFullWidthGuidelineOffset
    ]);
    // calculate snapping width
    const defaultSnappingWidths = (0, $cozmU.useMemo)(()=>{
        if (!fullWidth_0 || !wide_0 || !lineLength_0 || fullWidth_0 <= ((0, $jkcNT.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength_0)) return null;
        if (fullWidth_0 - wide_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) return {
            lineLength: lineLength_0,
            wide: wide_0,
            fullWidth: fullWidth_0
        };
        if (fullWidth_0 <= wide_0 && fullWidth_0 - lineLength_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) return {
            lineLength: lineLength_0,
            fullWidth: fullWidth_0
        };
        return null;
    }, [
        fullWidth_0,
        lineLength_0,
        wide_0
    ]);
    const snaps = (0, $cozmU.useMemo)(()=>{
        if (!isResizing || !defaultSnappingWidths) return null;
        return {
            x: Object.values(defaultSnappingWidths)
        };
    }, [
        defaultSnappingWidths,
        isResizing
    ]);
    // calculate guidelines, and calculate which lines are active
    const [currentLayout, setCurrentLayout] = (0, $cozmU.useState)(null);
    const guidelines_0 = (0, $cozmU.useMemo)(()=>{
        const guidelines = [];
        if (!defaultSnappingWidths) return guidelines;
        Object.entries(defaultSnappingWidths).map(([key, value])=>{
            if (value) {
                guidelines.push({
                    key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_left`,
                    position: {
                        x: -$b84766e5f44e23e9$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                });
                guidelines.push({
                    key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_right`,
                    position: {
                        x: $b84766e5f44e23e9$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                });
            }
        });
        return guidelines;
    }, [
        defaultSnappingWidths,
        currentLayout
    ]);
    const setCurrentWidth = (0, $cozmU.useCallback)((newWidth)=>{
        if (typeof newWidth !== 'number') {
            setCurrentLayout(null);
            return;
        }
        if (lineLength_0 && Math.abs(newWidth - lineLength_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout('center');
        else if (wide_0 && Math.abs(newWidth - wide_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout('wide');
        else if (fullWidth_0 && // we only allow snap from one side, so we don't use Math.abs here
        (fullWidth_0 + (0, $7Y8M5.akEditorGutterPadding) - newWidth < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth_0)) setCurrentLayout('full-width');
        else setCurrentLayout(null);
    }, [
        lineLength_0,
        wide_0,
        fullWidth_0
    ]);
    return {
        snaps: snaps,
        currentLayout: currentLayout,
        guidelines: guidelines_0,
        setCurrentWidth: setCurrentWidth
    };
};


const $e61d807cbad078b7$var$breakoutSupportedNodes = [
    'layoutSection',
    'expand',
    'codeBlock'
];
const $e61d807cbad078b7$var$getHandleStyle = (node, hidden)=>{
    const layoutMarginOffset = 12;
    if (hidden) return {
        left: {
            display: 'none'
        },
        right: {
            display: 'none'
        }
    };
    switch(node){
        case 'codeBlock':
            return {
                left: {
                    left: '-12px'
                },
                right: {
                    right: '-12px'
                }
            };
        // expand and layout section elements have a negative margin applied
        default:
            const handleOffset = (0, $cBSrP.LAYOUT_SECTION_MARGIN) * 2 + layoutMarginOffset;
            return {
                left: {
                    left: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                },
                right: {
                    right: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                }
            };
    }
};
const $e61d807cbad078b7$export$256eed97177e990e = (mutation)=>{
    if (mutation.target instanceof Element) return mutation.target.classList.contains('resizer-item') || mutation.type === 'attributes' && mutation.attributeName === 'style';
    return mutation.type === 'attributes' && mutation.attributeName === 'style';
};
const $e61d807cbad078b7$var$resizingStyles = {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'grid'
};
// Apply grid to stop drag handles rendering inside .resizer-item affecting its height
const $e61d807cbad078b7$var$defaultStyles = {
    display: 'grid'
};
const $e61d807cbad078b7$var$RESIZE_STEP_VALUE = 10;
const $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES = {
    left: true,
    right: true
};
/**
 * BreakoutResizer is a common component used to resize nodes that support the 'Breakout' mark, so it requires
 * correct ADF support.
 *
 * use experiment platform_editor_advanced_layouts
 * @param root0
 * @param root0.editorView
 * @param root0.nodeType
 * @param root0.getPos
 * @param root0.getRef
 * @param root0.disabled
 * @param root0.getEditorWidth
 * @param root0.parentRef
 * @param root0.displayGuidelines
 * @param root0.editorAnalyticsApi
 * @param root0.displayGapCursor
 * @param root0.onResizeStart
 * @param root0.dynamicFullWidthGuidelineOffset
 * @param root0.hidden Hide the resizer handles without outright unrendering them
 * @returns BreakoutResizer component
 * @example
 */ const $e61d807cbad078b7$export$d6c278682f48fbc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: t1 } = t0;
    const hidden = t1 === undefined ? false : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            minWidth: undefined,
            maxWidth: undefined,
            isResizing: false
        };
        $[0] = t2;
    } else t2 = $[0];
    const [t3, setResizingState] = (0, $cozmU.useState)(t2);
    const { minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing } = t3;
    const areResizeMetaKeysPressed = (0, $cozmU.useRef)(false);
    const resizerRef = (0, $cozmU.useRef)(null);
    let t4;
    if ($[1] !== isResizing) {
        t4 = isResizing && (0, $jkcNT.editorExperiment)("single_column_layouts", true);
        $[1] = isResizing;
        $[2] = t4;
    } else t4 = $[2];
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $b84766e5f44e23e9$export$54a1e15ba45852e2)(getEditorWidth, t4, dynamicFullWidthGuidelineOffset);
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $8dxef.getBrowserInfo)();
        $[3] = t5;
    } else t5 = $[3];
    const browser = t5;
    let t6;
    let t7;
    if ($[4] !== displayGuidelines || $[5] !== guidelines) {
        t6 = ()=>{
            if (displayGuidelines) displayGuidelines(guidelines || []);
        };
        t7 = [
            displayGuidelines,
            guidelines
        ];
        $[4] = displayGuidelines;
        $[5] = guidelines;
        $[6] = t6;
        $[7] = t7;
    } else {
        t6 = $[6];
        t7 = $[7];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[8] !== editorView.state.doc || $[9] !== editorView.state.selection || $[10] !== getPos) {
        bb0: {
            const pos = getPos();
            if (pos === undefined) {
                t8 = false;
                break bb0;
            }
            const node = editorView.state.doc.nodeAt(pos);
            if (node === null) {
                t8 = false;
                break bb0;
            }
            const endPos = pos + node.nodeSize;
            const startPos = pos;
            const { $from: $from, $to: $to } = editorView.state.selection;
            t8 = $from.pos >= startPos && endPos >= $to.pos;
        }
        $[8] = editorView.state.doc;
        $[9] = editorView.state.selection;
        $[10] = getPos;
        $[11] = t8;
    } else t8 = $[11];
    const isSelectionInNode = t8;
    let t9;
    if ($[12] !== displayGapCursor || $[13] !== editorView || $[14] !== getEditorWidth || $[15] !== onResizeStart) {
        t9 = ()=>{
            onResizeStart?.();
            let newMinWidth;
            let newMaxWidth;
            const widthState = getEditorWidth();
            const { dispatch: dispatch, state: state } = editorView;
            displayGapCursor(false);
            if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
                const padding = widthState.width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                    exposure: true
                }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
                newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $7Y8M5.akEditorGutterPadding), (0, $7Y8M5.akEditorFullWidthLayoutWidth));
                newMinWidth = Math.min(widthState.lineLength, (0, $7Y8M5.akEditorDefaultLayoutWidth), newMaxWidth);
            }
            setResizingState({
                isResizing: true,
                minWidth: newMinWidth,
                maxWidth: newMaxWidth
            });
            dispatch(state.tr.setMeta("is-resizer-resizing", true));
        };
        $[12] = displayGapCursor;
        $[13] = editorView;
        $[14] = getEditorWidth;
        $[15] = onResizeStart;
        $[16] = t9;
    } else t9 = $[16];
    const handleResizeStart = t9;
    let t10;
    if ($[17] !== setCurrentWidth) {
        t10 = (originalState, delta)=>{
            if ((0, $jkcNT.editorExperiment)("single_column_layouts", true)) {
                const newWidth = originalState.width + delta.width;
                setCurrentWidth(newWidth);
            }
        };
        $[17] = setCurrentWidth;
        $[18] = t10;
    } else t10 = $[18];
    const handleResize = t10;
    let t11;
    if ($[19] !== currentLayout || $[20] !== displayGapCursor || $[21] !== editorAnalyticsApi || $[22] !== editorView || $[23] !== getPos || $[24] !== setCurrentWidth) {
        t11 = (originalState_0, delta_0)=>{
            const newWidth_0 = originalState_0.width + delta_0.width;
            const pos_0 = getPos();
            if (pos_0 === undefined) return;
            const { state: state_0, dispatch: dispatch_0 } = editorView;
            const { breakout: breakout } = state_0.schema.marks;
            const node_0 = state_0.doc.nodeAt(pos_0);
            const newTr = state_0.tr;
            if (node_0 && $e61d807cbad078b7$var$breakoutSupportedNodes.includes(node_0.type.name)) {
                if (currentLayout && [
                    "wide",
                    "full-width"
                ].includes(currentLayout) && (0, $jkcNT.editorExperiment)("single_column_layouts", true)) newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                    breakout.create({
                        mode: currentLayout,
                        width: null
                    })
                ]);
                else {
                    const newBreakoutWidth = Math.max(newWidth_0, (0, $7Y8M5.akEditorDefaultLayoutWidth));
                    newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                        breakout.create({
                            width: newBreakoutWidth
                        })
                    ]);
                    const breakoutResizePayload = {
                        action: (0, $krYZG.ACTION).RESIZED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            nodeType: node_0.type.name,
                            prevWidth: originalState_0.width,
                            newWidth: newBreakoutWidth
                        }
                    };
                    editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
                }
            }
            newTr.setMeta("is-resizer-resizing", false).setMeta("scrollIntoView", false);
            displayGapCursor(true);
            dispatch_0(newTr);
            setResizingState({
                isResizing: false,
                minWidth: undefined,
                maxWidth: undefined
            });
            setCurrentWidth(null);
        };
        $[19] = currentLayout;
        $[20] = displayGapCursor;
        $[21] = editorAnalyticsApi;
        $[22] = editorView;
        $[23] = getPos;
        $[24] = setCurrentWidth;
        $[25] = t11;
    } else t11 = $[25];
    const handleResizeStop = t11;
    let t12;
    if ($[26] !== editorView) {
        t12 = ()=>{
            editorView?.focus();
        };
        $[26] = editorView;
        $[27] = t12;
    } else t12 = $[27];
    const handleEscape = t12;
    let t13;
    if ($[28] !== handleResizeStop || $[29] !== maxWidth || $[30] !== minWidth || $[31] !== parentRef) {
        t13 = (step)=>{
            if (!parentRef) return;
            const resizerItem = parentRef.closest(".resizer-item");
            if (!(resizerItem instanceof HTMLElement)) return;
            const newWidth_1 = resizerItem.offsetWidth + step;
            if (maxWidth && newWidth_1 > maxWidth || minWidth && newWidth_1 < minWidth) return;
            handleResizeStop({
                width: resizerItem.offsetWidth,
                x: 0,
                y: 0,
                height: 0
            }, {
                width: step,
                height: 0
            });
        };
        $[28] = handleResizeStop;
        $[29] = maxWidth;
        $[30] = minWidth;
        $[31] = parentRef;
        $[32] = t13;
    } else t13 = $[32];
    const handleLayoutSizeChangeOnKeypress = t13;
    let t14;
    if ($[33] !== handleEscape || $[34] !== handleLayoutSizeChangeOnKeypress) {
        t14 = (event)=>{
            const isBracketKey = event.code === "BracketRight" || event.code === "BracketLeft";
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
            if (event.altKey && metaKey) {
                if (isBracketKey) {
                    event.preventDefault();
                    handleLayoutSizeChangeOnKeypress(event.code === "BracketRight" ? $e61d807cbad078b7$var$RESIZE_STEP_VALUE : -$e61d807cbad078b7$var$RESIZE_STEP_VALUE);
                }
            } else if (!areResizeMetaKeysPressed.current) handleEscape();
        };
        $[33] = handleEscape;
        $[34] = handleLayoutSizeChangeOnKeypress;
        $[35] = t14;
    } else t14 = $[35];
    const resizeHandleKeyDownHandler = t14;
    let t15;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (event_0)=>{
            if (event_0.altKey || event_0.metaKey) areResizeMetaKeysPressed.current = false;
        };
        $[36] = t15;
    } else t15 = $[36];
    const resizeHandleKeyUpHandler = t15;
    let t16;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (event_1)=>{
            if (!resizerRef.current) return;
            const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
            const metaKey_0 = browser.mac ? event_1.metaKey : event_1.ctrlKey;
            const isTargetResizeHandle = event_1.target instanceof HTMLElement && event_1.target.classList.contains("resizer-handle-thumb");
            if (event_1.altKey && event_1.shiftKey && metaKey_0 && event_1.code === "KeyR" || isTargetResizeHandle && (event_1.altKey || metaKey_0 || event_1.shiftKey)) {
                event_1.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        };
        $[37] = t16;
    } else t16 = $[37];
    const resizerGlobalKeyDownHandler = t16;
    let t17;
    let t18;
    if ($[38] !== editorView || $[39] !== resizeHandleKeyDownHandler) {
        t17 = ()=>{
            if (!resizerRef.current || !editorView) return;
            const resizeHandleThumbEl_0 = resizerRef.current.getResizerThumbEl();
            if (!resizeHandleThumbEl_0) return;
            const editorViewDom = editorView.dom;
            const unbindEditorViewDom = (0, $cbY7C.bind)(editorViewDom, {
                type: "keydown",
                listener: resizerGlobalKeyDownHandler
            });
            const unbindResizeHandle = (0, $cbY7C.bindAll)(resizeHandleThumbEl_0, [
                {
                    type: "keydown",
                    listener: resizeHandleKeyDownHandler
                },
                {
                    type: "keyup",
                    listener: resizeHandleKeyUpHandler
                }
            ]);
            return ()=>{
                unbindEditorViewDom();
                unbindResizeHandle();
            };
        };
        t18 = [
            editorView,
            resizerGlobalKeyDownHandler,
            resizeHandleKeyDownHandler,
            resizeHandleKeyUpHandler
        ];
        $[38] = editorView;
        $[39] = resizeHandleKeyDownHandler;
        $[40] = t17;
        $[41] = t18;
    } else {
        t17 = $[40];
        t18 = $[41];
    }
    (0, $cozmU.useLayoutEffect)(t17, t18);
    if (disabled) {
        let t19;
        if ($[42] !== getRef) {
            t19 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                "data-testid": "breakout-resizer-editor-view-wrapper",
                ref: (ref)=>getRef && getRef(ref)
            });
            $[42] = getRef;
            $[43] = t19;
        } else t19 = $[43];
        return t19;
    }
    let t19;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = (0, $4o0zT.isExperimentEnabled)("platform_editor_perf_lint_cleanup") ? $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES : {
            left: true,
            right: true
        };
        $[44] = t19;
    } else t19 = $[44];
    const t20 = snaps || undefined;
    let t21;
    if ($[45] !== hidden || $[46] !== nodeType) {
        t21 = $e61d807cbad078b7$var$getHandleStyle(nodeType, hidden);
        $[45] = hidden;
        $[46] = nodeType;
        $[47] = t21;
    } else t21 = $[47];
    const t22 = isResizing ? $e61d807cbad078b7$var$resizingStyles : $e61d807cbad078b7$var$defaultStyles;
    let t23;
    if ($[48] !== currentLayout) {
        t23 = currentLayout && (0, $jkcNT.editorExperiment)("single_column_layouts", true) && [
            "full-width",
            "wide"
        ].includes(currentLayout || "") && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: currentLayout
        });
        $[48] = currentLayout;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== getRef || $[51] !== handleResize || $[52] !== handleResizeStart || $[53] !== handleResizeStop || $[54] !== isSelectionInNode || $[55] !== maxWidth || $[56] !== minWidth || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t23) {
        t24 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aWssQ.default), {
            ref: resizerRef,
            enable: t19,
            snap: t20,
            snapGap: (0, $b84766e5f44e23e9$export$6cdb476c834bc60),
            handleStyles: t21,
            minWidth: minWidth,
            maxWidth: maxWidth,
            style: t22,
            handleResizeStart: handleResizeStart,
            handleResizeStop: handleResizeStop,
            handleResize: handleResize,
            childrenDOMRef: getRef,
            resizeRatio: 2,
            isHandleVisible: isSelectionInNode,
            handleSize: "clamped",
            handleHighlight: "full-height",
            handlePositioning: "adjacent",
            handleAlignmentMethod: "sticky",
            labelComponent: t23
        });
        $[50] = getRef;
        $[51] = handleResize;
        $[52] = handleResizeStart;
        $[53] = handleResizeStop;
        $[54] = isSelectionInNode;
        $[55] = maxWidth;
        $[56] = minWidth;
        $[57] = t20;
        $[58] = t21;
        $[59] = t22;
        $[60] = t23;
        $[61] = t24;
    } else t24 = $[61];
    return t24;
} : ({ editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: hidden = false })=>{
    const [{ minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing }, setResizingState] = (0, $cozmU.useState)({
        minWidth: undefined,
        maxWidth: undefined,
        isResizing: false
    });
    const areResizeMetaKeysPressed = (0, $cozmU.useRef)(false);
    const resizerRef = (0, $cozmU.useRef)(null);
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $b84766e5f44e23e9$export$54a1e15ba45852e2)(getEditorWidth, isResizing && (0, $jkcNT.editorExperiment)('single_column_layouts', true), dynamicFullWidthGuidelineOffset);
    const browser = (0, $8dxef.getBrowserInfo)();
    (0, $cozmU.useEffect)(()=>{
        if (displayGuidelines) displayGuidelines(guidelines || []);
    }, [
        displayGuidelines,
        guidelines
    ]);
    // Relying on re-renders caused by selection changes inside/around node
    const isSelectionInNode = (0, $cozmU.useMemo)(()=>{
        const pos = getPos();
        if (pos === undefined) return false;
        const node = editorView.state.doc.nodeAt(pos);
        if (node === null) return false;
        const endPos = pos + node.nodeSize;
        const startPos = pos;
        const { $from: $from, $to: $to } = editorView.state.selection;
        return $from.pos >= startPos && endPos >= $to.pos;
    }, [
        editorView.state.doc,
        editorView.state.selection,
        getPos
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        onResizeStart?.();
        let newMinWidth;
        let newMaxWidth;
        const widthState = getEditorWidth();
        const { dispatch: dispatch, state: state } = editorView;
        displayGapCursor(false);
        if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
            const padding = widthState.width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
            newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $7Y8M5.akEditorGutterPadding), (0, $7Y8M5.akEditorFullWidthLayoutWidth));
            newMinWidth = Math.min(widthState.lineLength, (0, $7Y8M5.akEditorDefaultLayoutWidth), newMaxWidth);
        }
        setResizingState({
            isResizing: true,
            minWidth: newMinWidth,
            maxWidth: newMaxWidth
        });
        dispatch(state.tr.setMeta('is-resizer-resizing', true));
    }, [
        onResizeStart,
        getEditorWidth,
        editorView,
        displayGapCursor
    ]);
    const handleResize = (0, $cozmU.useCallback)((originalState, delta)=>{
        if ((0, $jkcNT.editorExperiment)('single_column_layouts', true)) {
            const newWidth = originalState.width + delta.width;
            setCurrentWidth(newWidth);
        }
    }, [
        setCurrentWidth
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((originalState_0, delta_0)=>{
        const newWidth_0 = originalState_0.width + delta_0.width;
        const pos_0 = getPos();
        if (pos_0 === undefined) return;
        const { state: state_0, dispatch: dispatch_0 } = editorView;
        const { breakout: breakout } = state_0.schema.marks;
        const node_0 = state_0.doc.nodeAt(pos_0);
        const newTr = state_0.tr;
        if (node_0 && $e61d807cbad078b7$var$breakoutSupportedNodes.includes(node_0.type.name)) {
            if (currentLayout && [
                'wide',
                'full-width'
            ].includes(currentLayout) && (0, $jkcNT.editorExperiment)('single_column_layouts', true)) newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                breakout.create({
                    mode: currentLayout,
                    width: null
                })
            ]);
            else {
                const newBreakoutWidth = Math.max(newWidth_0, (0, $7Y8M5.akEditorDefaultLayoutWidth));
                newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                    breakout.create({
                        width: newBreakoutWidth
                    })
                ]);
                const breakoutResizePayload = {
                    action: (0, $krYZG.ACTION).RESIZED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: node_0.type.name,
                        prevWidth: originalState_0.width,
                        newWidth: newBreakoutWidth
                    }
                };
                editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
            }
        }
        newTr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
        displayGapCursor(true);
        dispatch_0(newTr);
        setResizingState({
            isResizing: false,
            minWidth: undefined,
            maxWidth: undefined
        });
        setCurrentWidth(null);
    }, [
        getPos,
        editorView,
        displayGapCursor,
        setCurrentWidth,
        currentLayout,
        editorAnalyticsApi
    ]);
    const handleEscape = (0, $cozmU.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleLayoutSizeChangeOnKeypress = (0, $cozmU.useCallback)((step)=>{
        if (!parentRef) return;
        const resizerItem = parentRef.closest('.resizer-item');
        if (!(resizerItem instanceof HTMLElement)) return;
        const newWidth_1 = resizerItem.offsetWidth + step;
        if (maxWidth && newWidth_1 > maxWidth || minWidth && newWidth_1 < minWidth) return;
        handleResizeStop({
            width: resizerItem.offsetWidth,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        handleResizeStop,
        maxWidth,
        minWidth,
        parentRef
    ]);
    const resizeHandleKeyDownHandler = (0, $cozmU.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleLayoutSizeChangeOnKeypress(event.code === 'BracketRight' ? $e61d807cbad078b7$var$RESIZE_STEP_VALUE : -$e61d807cbad078b7$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleLayoutSizeChangeOnKeypress,
        browser
    ]);
    const resizeHandleKeyUpHandler = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.altKey || event_0.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    const resizerGlobalKeyDownHandler = (0, $cozmU.useCallback)((event_1)=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const metaKey_0 = browser.mac ? event_1.metaKey : event_1.ctrlKey;
        const isTargetResizeHandle = event_1.target instanceof HTMLElement && event_1.target.classList.contains('resizer-handle-thumb');
        if (event_1.altKey && event_1.shiftKey && metaKey_0 && event_1.code === 'KeyR' || isTargetResizeHandle && (event_1.altKey || metaKey_0 || event_1.shiftKey)) {
            event_1.preventDefault();
            if (!resizeHandleThumbEl) return;
            resizeHandleThumbEl.focus();
            resizeHandleThumbEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, [
        resizerRef,
        browser
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resizerRef.current || !editorView) return;
        const resizeHandleThumbEl_0 = resizerRef.current.getResizerThumbEl();
        if (!resizeHandleThumbEl_0) return;
        const editorViewDom = editorView.dom;
        const unbindEditorViewDom = (0, $cbY7C.bind)(editorViewDom, {
            type: 'keydown',
            listener: resizerGlobalKeyDownHandler
        });
        const unbindResizeHandle = (0, $cbY7C.bindAll)(resizeHandleThumbEl_0, [
            {
                type: 'keydown',
                listener: resizeHandleKeyDownHandler
            },
            {
                type: 'keyup',
                listener: resizeHandleKeyUpHandler
            }
        ]);
        return ()=>{
            unbindEditorViewDom();
            unbindResizeHandle();
        };
    }, [
        editorView,
        resizerGlobalKeyDownHandler,
        resizeHandleKeyDownHandler,
        resizeHandleKeyUpHandler
    ]);
    if (disabled) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "breakout-resizer-editor-view-wrapper",
        ref: (ref)=>getRef && getRef(ref)
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aWssQ.default), {
        ref: resizerRef,
        enable: (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES : {
            left: true,
            right: true
        },
        snap: snaps || undefined,
        snapGap: (0, $b84766e5f44e23e9$export$6cdb476c834bc60),
        handleStyles: $e61d807cbad078b7$var$getHandleStyle(nodeType, hidden),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: isResizing ? $e61d807cbad078b7$var$resizingStyles : $e61d807cbad078b7$var$defaultStyles,
        handleResizeStart: handleResizeStart,
        handleResizeStop: handleResizeStop,
        handleResize: handleResize,
        childrenDOMRef: getRef,
        resizeRatio: 2,
        isHandleVisible: isSelectionInNode,
        handleSize: "clamped",
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleAlignmentMethod: "sticky",
        labelComponent: currentLayout && (0, $jkcNT.editorExperiment)('single_column_layouts', true) && [
            'full-width',
            'wide'
        ].includes(currentLayout || '') && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: currentLayout
        })
    });
};



var $4Qu9h = parcelRequire("4Qu9h");































const $85a81c71b94ef05b$export$9adba9ade368b431 = (state)=>{
    const { schema: { nodes: { layoutSection: layoutSection, layoutColumn: layoutColumn } }, selection: selection } = state;
    const isLayoutColumn = (0, $jkcNT.editorExperiment)('advanced_layouts', true) && (0, $bjg0G.findSelectedNodeOfType)([
        layoutColumn
    ])(selection);
    // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
    return isLayoutColumn ? undefined : (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection) || (0, $bjg0G.findSelectedNodeOfType)([
        layoutSection
    ])(selection);
};
/**
 * The depth of the layout column inside the layout section.
 * As per the current implementation, the layout column ALWAYS has a depth of 1.
 */ const $85a81c71b94ef05b$var$LAYOUT_COLUMN_DEPTH = 1;
const $85a81c71b94ef05b$export$c13dbc07830c6c42 = (view, posOfLayout, childIndex = 0)=>{
    const $maybeLayoutSection = view.state.doc.resolve(posOfLayout);
    if ($maybeLayoutSection.nodeAfter?.type.name === 'layoutSection') {
        const layoutSectionNode = $maybeLayoutSection.nodeAfter;
        // check if the childIndex is valid
        if (childIndex < 0 || childIndex >= layoutSectionNode.childCount) return;
        const childPos = $maybeLayoutSection.posAtIndex(childIndex, $85a81c71b94ef05b$var$LAYOUT_COLUMN_DEPTH);
        const tr = view.state.tr;
        const $selectionPos = tr.doc.resolve(childPos);
        if (layoutSectionNode.firstChild?.type.name === 'paragraph') view.dispatch(tr.setSelection((0, $kCECX.TextSelection).near($selectionPos)));
        else view.dispatch(tr.setSelection((0, $4EksL.GapCursorSelection).near($selectionPos)));
        return tr;
    }
};
/**
 * These node views can fill a layout column while leaving visually blank space that ProseMirror
 * cannot map to a document position. Interactive atomic nodes must receive clicks normally.
 */ const $85a81c71b94ef05b$var$supportsBlankSpaceGapCursorFallback = (node)=>node?.type.name === 'mediaSingle' || node?.type.name === 'expand';
const $85a81c71b94ef05b$export$a03ac666480b47d9 = (view, event)=>{
    // Resolve the column from the DOM target so it works even when posAtCoords returns null
    // (nothing rendered at the clicked Y).
    const target = event.target;
    const columnEl = target?.closest('[data-layout-column]');
    if (!columnEl) return undefined;
    let columnStartPos;
    try {
        columnStartPos = view.posAtDOM(columnEl, 0);
    } catch  {
        return undefined;
    }
    // posAtDOM resolves at varying depths, so walk up to find the layoutColumn.
    const $columnStart = view.state.doc.resolve(columnStartPos);
    let depth = -1;
    for(let d = $columnStart.depth; d >= 0; d--)if ($columnStart.node(d).type.name === 'layoutColumn') {
        depth = d;
        break;
    }
    if (depth < 0) return undefined;
    const columnNode = $columnStart.node(depth);
    if (columnNode.childCount === 0) return undefined;
    const columnContentStart = $columnStart.start(depth);
    const columnEndPos = $columnStart.end(depth);
    const getChildDom = (nodePos)=>{
        try {
            const dom = view.nodeDOM(nodePos);
            return dom instanceof Element ? dom : null;
        } catch  {
            return null;
        }
    };
    const valign = columnNode.attrs?.valign;
    const isNonTopAligned = valign && valign !== 'top';
    // Use the column rect (not child rects) for above/below detection: it stays stable as
    // gap-cursor widgets shift child DOM positions between repeated clicks.
    const columnRect = columnEl.getBoundingClientRect();
    // Click ABOVE the first child (only for middle/bottom-aligned columns).
    const firstChildPos = columnContentStart;
    const firstChildDom = getChildDom(firstChildPos);
    if (isNonTopAligned && firstChildDom) {
        const rect = firstChildDom.getBoundingClientRect();
        if (event.clientY < rect.top && event.clientY >= columnRect.top) return {
            pos: firstChildPos,
            side: 'left'
        };
    }
    // Click BELOW the last child (for any column alignment).
    const lastChild = columnNode.lastChild;
    const lastChildEndPos = columnEndPos;
    const lastChildStartPos = lastChild ? lastChildEndPos - lastChild.nodeSize : columnContentStart;
    const lastChildDom = lastChild ? getChildDom(lastChildStartPos) : null;
    if (lastChild && lastChildDom) {
        const rect = lastChildDom.getBoundingClientRect();
        if (event.clientY > rect.bottom && event.clientY <= columnRect.bottom) return {
            pos: lastChildEndPos,
            side: 'right'
        };
    }
    // Fallback: click lands ON a single atomic child that fills the column (mediaSingle/expand),
    // so the above/below checks never fired.
    if (columnNode.childCount === 1) {
        const onlyChild = columnNode.firstChild;
        const shouldHandleAtomicChild = (0, $ieeJu.expValEquals)('platform_editor_layout_column_selection_fix', 'isEnabled', true) ? $85a81c71b94ef05b$var$supportsBlankSpaceGapCursorFallback(onlyChild) : onlyChild?.type.name !== 'paragraph' && onlyChild?.type.name !== 'panel';
        if (onlyChild && shouldHandleAtomicChild) {
            // A caption is editable content inside a mediaSingle, not blank layout space. The
            // image bounds below intentionally exclude the caption so clicks beside the image
            // can place a gap cursor; bail out before that check when the click is on a caption.
            const target = event.target;
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_fix_edit_media_caption_in_layout') && target?.closest('[data-caption]')) return undefined;
            // Bail when the click is on the child's own content. For media the wrapper is full-width
            // so test against the <img> rect; resolve it only for a direct mediaSingle child (else
            // getContentRect could grab an image nested in an expand and break its toggle).
            const contentRect = onlyChild.type.name === 'mediaSingle' ? $85a81c71b94ef05b$var$getContentRect(firstChildDom) : null;
            if (contentRect) {
                const insideImage = event.clientX >= contentRect.left && event.clientX <= contentRect.right && event.clientY >= contentRect.top && event.clientY <= contentRect.bottom;
                if (insideImage) return undefined;
            } else {
                // Other atomics: bail when posAtCoords resolves strictly inside the node range.
                let coordPos = null;
                try {
                    coordPos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                } catch  {
                    coordPos = null;
                }
                if (coordPos && coordPos.pos > firstChildPos && coordPos.pos < lastChildEndPos) return undefined;
            }
            // Fire when the child DOM is resolvable, or when it's null (media not yet loaded) but
            // the click target is the column itself (no node view intercepted it).
            const targetEl = event.target;
            const targetIsColumn = targetEl === columnEl;
            const shouldUseFallback = firstChildDom !== null || targetIsColumn;
            if (shouldUseFallback) {
                const side = $85a81c71b94ef05b$var$getGapCursorSideForBlankSpaceClick(firstChildDom, columnRect, event.clientX, event.clientY);
                return side === 'left' ? {
                    pos: firstChildPos,
                    side: 'left'
                } : {
                    pos: lastChildEndPos,
                    side: 'right'
                };
            }
        }
    }
    return undefined;
};
/**
 * The tight `<img>` content rect (or `null`). The outer wrapper often fills the whole column
 * width, so the `<img>` rect is needed to tell "beside the image" from "on the image".
 */ const $85a81c71b94ef05b$var$getContentRect = (firstChildDom)=>{
    const img = firstChildDom?.querySelector('img');
    return img ? img.getBoundingClientRect() : null;
};
/**
 * Which side of an atomic child a blank-space click belongs to. Prefers the tight content (image)
 * rect when available — using its midpoint so it's direction-agnostic (handles RTL right-aligned
 * images) — otherwise falls back to the column's vertical midpoint.
 */ const $85a81c71b94ef05b$var$getGapCursorSideForBlankSpaceClick = (firstChildDom, columnRect, clientX, clientY)=>{
    const contentRect = $85a81c71b94ef05b$var$getContentRect(firstChildDom);
    if (contentRect) {
        if (clientY < contentRect.top) return 'left';
        if (clientY > contentRect.bottom) return 'right';
        if (clientX < (contentRect.left + contentRect.right) / 2) return 'left';
        return 'right';
    }
    const columnMidY = columnRect.top + columnRect.height / 2;
    return clientY < columnMidY ? 'left' : 'right';
};
const $85a81c71b94ef05b$export$8c1438c11cd047f3 = (view, gapTarget)=>{
    const { pos: pos, side: side } = gapTarget;
    const { doc: doc } = view.state;
    try {
        const $pos = doc.resolve(pos);
        const childNode = side === 'left' ? $pos.nodeAfter : $pos.nodeBefore;
        return childNode?.type.name === 'paragraph';
    } catch  {
        return false;
    }
};





parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");




function $6eaaa6e4602fe34a$export$f101bb1d69aeca23({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.RawIntlProvider), {
        value: intl,
        children: children
    });
}



var $2w79Z = parcelRequire("2w79Z");

const $806c13047233bb2c$export$9c5c526818396ae1 = (node)=>{
    if (!node) return false;
    // fast check
    // each column should have size 2 from layoutcolumn and 2 from empty paragraph
    if (node.content.size / node.childCount !== 4) return false;
    let isEmpty = true;
    node.content.forEach((maybelayoutColumn)=>{
        if (maybelayoutColumn.type.name !== 'layoutColumn' || maybelayoutColumn.childCount > 1 || !(0, $2w79Z.isEmptyParagraph)(maybelayoutColumn.firstChild)) isEmpty = false;
    });
    return isEmpty;
};


const $c3f861a49670d256$var$layoutDynamicFullWidthGuidelineOffset = 16;
const $c3f861a49670d256$var$isBreakoutAvailable = (schema)=>{
    return Boolean(schema.marks.breakout);
};
const $c3f861a49670d256$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $c3f861a49670d256$var$LayoutBreakoutResizer = ({ pluginInjectionApi: pluginInjectionApi, forwardRef: forwardRef, getPos: getPos, view: view, parentRef: parentRef })=>{
    const { editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled'
    ], $c3f861a49670d256$var$selector);
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const getEditorWidth = ()=>{
        return pluginInjectionApi?.width?.sharedState.currentState();
    };
    const displayGapCursor = (0, $cozmU.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const displayGuidelines = (0, $cozmU.useCallback)((guidelines)=>{
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: guidelines
        });
    }, [
        pluginInjectionApi,
        view
    ]);
    // we want to hide the floating toolbar for other nodes.
    // e.g. info panel inside the current layout section
    const selectIntoCurrentLayout = (0, $cozmU.useCallback)(()=>{
        const pos = getPos();
        if (pos === undefined) return;
        // put the selection into the first column of the layout
        (0, $85a81c71b94ef05b$export$c13dbc07830c6c42)(view, pos, 0);
    }, [
        getPos,
        view
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e61d807cbad078b7$export$d6c278682f48fbc4), {
        getRef: forwardRef,
        getPos: getPos,
        editorView: view,
        nodeType: "layoutSection",
        getEditorWidth: getEditorWidth,
        disabled: (0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) ? true : editorDisabled === true || !$c3f861a49670d256$var$isBreakoutAvailable(view.state.schema),
        hidden: interactionState === 'hasNotHadInteraction',
        parentRef: parentRef,
        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
        displayGuidelines: (0, $jkcNT.editorExperiment)('single_column_layouts', true) ? displayGuidelines : undefined,
        displayGapCursor: displayGapCursor,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onResizeStart: ()=>{
            selectIntoCurrentLayout();
        },
        dynamicFullWidthGuidelineOffset: $c3f861a49670d256$var$layoutDynamicFullWidthGuidelineOffset
    });
};
const $c3f861a49670d256$var$toDOM = (node)=>[
        'div',
        {
            class: 'layout-section-container'
        },
        [
            'div',
            {
                'data-layout-section': true,
                ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                    'data-local-id': node.attrs.localId
                }
            },
            0
        ]
    ];
class $c3f861a49670d256$export$8bfc7bdc15be731c extends (0, $Igylv.default) {
    /**
   * getContentDOM
   * @example
   * @returns
   */ getContentDOM() {
        // Build the layout DOM via the schema's toDOM spec. This is the same
        // path used in both CSR and SSR — the only SSR-specific concern is
        // re-attaching `contentDOM` (= the `[data-layout-section]` element)
        // after the portal's renderToStaticMarkup + innerHTML write detaches
        // it. We handle that by stamping `data-ssr-content-dom-ref` on the
        // outer container so `ReactNodeView.init()` can find a re-attach
        // target inside `domRef` after the portal write.
        const { dom: container, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $c3f861a49670d256$var$toDOM(this.node));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.layoutDOM = container.querySelector('[data-layout-section]');
        this.layoutDOM.setAttribute('data-column-rule-style', this.node.attrs.columnRuleStyle);
        this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) this.layoutDOM.setAttribute('data-local-id', this.node.attrs.localId);
        // SSR streaming re-attach note:
        // In SSR, `init()` appends `container` into `domRef`; the portal's
        // renderToStaticMarkup + innerHTML write then wipes `domRef`,
        // detaching the entire subtree (with PM-serialized children inside
        // `[data-layout-section]`). React's `render()` emits a
        // `<NodeViewContentHole/>` placeholder inside `domRef`; the SSR
        // re-attach logic in `init()` finds it via `[data-ssr-content-dom-ref]`
        // and calls `_handleRef`, which appends `contentDOMWrapper` (the
        // detached `container`) back inside the placeholder. The end result
        // is `domRef > NodeViewContentHole > layout-section-container >
        // [data-layout-section] > [data-layout-column] children` — the
        // layout DOM contract is preserved.
        return {
            dom: container,
            contentDOM: contentDOM
        };
    }
    /**
   * setDomAttrs
   * @param node
   * @param element
   * @example
   */ setDomAttrs(node, _element) {
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle);
    }
    /**
   * render
   * @param props
   * @param forwardRef
   * @example
   * @returns
   */ render(props, forwardRef) {
        this.isEmpty = (0, $806c13047233bb2c$export$9c5c526818396ae1)(this.node);
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        // SSR streaming path: render only a `<NodeViewContentHole/>` placeholder
        // so ReactNodeView.init()'s SSR re-attach logic can find the marker
        // (`data-ssr-content-dom-ref`) and re-append the detached
        // contentDOMWrapper — which is the FULL layout structure
        // (`layout-section-container > [data-layout-section] > children`) built
        // in `getContentDOM` via DOMSerializer.renderSpec. This avoids
        // duplicating layout structure between getContentDOM and render(), which
        // previously caused an extra wrapping div between `[data-layout-section]`
        // and the `[data-layout-column]` children and broke the flex layout.
        //
        // The BreakoutResizer is intentionally omitted in SSR — it relies on
        // browser-only APIs and contributes no useful static markup. The
        // LayoutSSRReactContextsProvider wraps the placeholder to inject the
        // editor's IntlShape, defending against any descendants that call
        // `useIntl()` during renderToStaticMarkup.
        if ((0, $4iudd.isSSR)()) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6eaaa6e4602fe34a$export$f101bb1d69aeca23), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9sVl.NodeViewContentHole), {
                ref: forwardRef
            })
        });
        if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)($c3f861a49670d256$var$LayoutBreakoutResizer, {
            pluginInjectionApi: props.pluginInjectionApi,
            forwardRef: forwardRef,
            getPos: props.getPos,
            view: props.view,
            parentRef: this.layoutDOM
        });
    }
    /**
   * ignoreMutation
   * @param mutation
   * @example
   * @returns
   */ ignoreMutation(mutation) {
        return (0, $e61d807cbad078b7$export$256eed97177e990e)(mutation);
    }
    /**
   * constructor
   * @param props
   * @param props.node
   * @param props.view
   * @param props.getPos
   * @param props.portalProviderAPI
   * @param props.eventDispatcher
   * @param props.pluginInjectionApi
   * @param props.options
   * @param props.intl
   * @example
   */ constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.layoutDOM = void 0;
        this.isEmpty = void 0;
        this.intl = void 0;
        this.isEmpty = (0, $806c13047233bb2c$export$9c5c526818396ae1)(this.node);
        this.options = props.options;
        this.intl = props.intl;
    }
}










const $bf0d35adcaabaf9b$var$toDOM = (node, isEmpty)=>{
    const computedEmpty = isEmpty ?? (0, $806c13047233bb2c$export$9c5c526818396ae1)(node);
    return [
        'div',
        {
            class: 'layoutSectionView-content-wrap'
        },
        [
            'div',
            {
                class: 'layout-section-container'
            },
            [
                'div',
                {
                    'data-layout-section': true,
                    // `?? ''` keeps unset attributes out of the DOM as `"null"`, which adf-schema's`parseDOM`
                    // reads back as a truthy string.
                    'data-column-rule-style': node.attrs.columnRuleStyle ?? '',
                    'data-empty-layout': String(computedEmpty),
                    ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                        'data-local-id': node.attrs.localId ?? ''
                    }
                },
                0
            ]
        ]
    ];
};
class $bf0d35adcaabaf9b$export$8bfc7bdc15be731c {
    update(node) {
        if (node.attrs.columnRuleStyle !== this.node.attrs.columnRuleStyle) this.contentDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle ?? '');
        const isEmpty = (0, $806c13047233bb2c$export$9c5c526818396ae1)(node);
        if ((0, $iDrrr.fg)('platform_editor_vanilla_node_views_patch_1')) // Cache isEmpty so update() does not call isEmptyLayout on the previous node.
        {
            if (isEmpty !== this.isEmpty) {
                this.contentDOM.setAttribute('data-empty-layout', String(isEmpty));
                this.isEmpty = isEmpty;
            }
        } else if (isEmpty !== (0, $806c13047233bb2c$export$9c5c526818396ae1)(this.node)) this.contentDOM.setAttribute('data-empty-layout', String(isEmpty));
        if ((0, $iDrrr.fg)('platform_editor_adf_with_localid') && node.attrs.localId !== this.node.attrs.localId) this.contentDOM.setAttribute('data-local-id', node.attrs.localId ?? '');
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        return (0, $e61d807cbad078b7$export$256eed97177e990e)(mutation);
    }
    constructor(node){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.isEmpty = void 0;
        const isEmpty = (0, $iDrrr.fg)('platform_editor_vanilla_node_views_patch_1') ? (0, $806c13047233bb2c$export$9c5c526818396ae1)(node) : undefined;
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $bf0d35adcaabaf9b$var$toDOM(node, isEmpty));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.node = node;
        this.isEmpty = isEmpty;
    }
}


const $263e2eabc1c558a4$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('layoutResizingPlugin');
/**
 * Minimal node view for layoutColumn that delegates all DOM serialization to the
 * NodeSpec's own toDOM, but overrides ignoreMutation to suppress style attribute
 * mutations from ProseMirror's MutationObserver.
 *
 * This is necessary so that direct inline style mutations during column drag
 * (e.g. setting flex-basis to give real-time visual feedback without dispatching
 * PM transactions) are not "corrected" back by ProseMirror's DOM reconciliation.
 */ const $263e2eabc1c558a4$var$isLayoutElementLike = (element)=>{
    if ((0, $4iudd.isSSR)()) {
        // In SSR environments, `HTMLElement` is undefined globally so a plain
        // `instanceof HTMLElement` check is always `false`. That makes the
        // `DOMSerializer.renderSpec(...)` result get rejected by the guard below and
        // the NodeView falls back to a bare `<div>`, losing every schema-defined
        // attribute (`data-layout-column`, `style="flex-basis:..."`,
        // `data-column-width`, plus the inner `<div data-layout-content="true">`
        // wrapper) and breaking the layout's flex sizing in SSR output.
        //
        // To unblock SSR without changing CSR semantics, we gate the check:
        // - In SSR, use a duck-typed check that mirrors `safe-plugin`'s `isHTMLElement`.
        // - Everywhere else, keep the original `instanceof HTMLElement` check exactly
        //   as it was so we don't accidentally widen acceptance in CSR.
        if (element === null || element === undefined) return false;
        return typeof element === 'object' && 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    return element instanceof HTMLElement;
};
class $263e2eabc1c558a4$var$LayoutColumnView {
    ignoreMutation(mutation) {
        // Ignore style attribute mutations — these are direct DOM writes during column drag
        // (setting flex-basis for real-time resize feedback). Without this, PM's
        // MutationObserver would immediately revert our style changes.
        return mutation.type === 'attributes' && mutation.attributeName === 'style';
    }
    constructor(node, view, getPos){
        this.dom = void 0;
        this.contentDOM = void 0;
        // Use the NodeSpec's own toDOM to produce the correct DOM structure and attributes.
        const nodeType = view.state.schema.nodes[node.type.name];
        // Fallback: create a plain div so PM always has a valid DOM node to work with.
        // This path should never be reached in practice — layoutColumn always has a toDOM.
        if (!nodeType.spec.toDOM) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, nodeType.spec.toDOM(node));
        if (!$263e2eabc1c558a4$var$isLayoutElementLike(dom) || !$263e2eabc1c558a4$var$isLayoutElementLike(contentDOM)) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        this.dom = dom;
        this.contentDOM = contentDOM;
        // Stamp the column's index within its parent section onto the DOM element so that
        // column-resize-divider can query columns by index rather than relying on positional
        // order of [data-layout-column] elements (which could break if the DOM structure changes).
        const pos = getPos();
        if (pos !== undefined) {
            const $pos = view.state.doc.resolve(pos);
            this.dom.setAttribute('data-layout-column-index', String($pos.index()));
        }
    }
}
var $263e2eabc1c558a4$export$2e2bcd8739ae039 = (options, pluginInjectionApi, portalProviderAPI, eventDispatcher, intl)=>new (0, $kpCD8.SafePlugin)({
        key: $263e2eabc1c558a4$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                layoutSection: (node, view, getPos)=>{
                    // Both experiments are required: the vanilla view renders no React, so it
                    // cannot mount the <LayoutBreakoutResizer> that LayoutSectionView.render()
                    // returns. That resizer is only redundant once
                    // `platform_editor_breakout_resizing` is on (render() returns null and
                    // breakout resizing is handled by the pragmatic resizer in
                    // editor-plugin-breakout). Taking the vanilla path while that experiment is
                    // off would silently remove the breakout drag handles.
                    if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1')) return new (0, $bf0d35adcaabaf9b$export$8bfc7bdc15be731c)(node);
                    return new (0, $c3f861a49670d256$export$8bfc7bdc15be731c)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        options: options,
                        intl: intl
                    }).init();
                },
                layoutColumn: (node, view, getPos)=>new $263e2eabc1c558a4$var$LayoutColumnView(node, view, getPos)
            }
        }
    });




const $d12416bdd3b8a88f$export$cfaf3f619f4fde4d = 'two_equal';
/**
 * Shared blank-space gap cursor placement, used by both `handleClick` and `handleClickOn`
 * (the latter catches clicks on atomic node views that stop propagation before `handleClick`).
 * Returns `true` when it placed a selection and consumed the click, else `false`.
 */ const $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor = (view, event)=>{
    if (!(0, $jkcNT.editorExperiment)('advanced_layouts', true)) return false;
    const gapTarget = (0, $85a81c71b94ef05b$export$a03ac666480b47d9)(view, event);
    if (gapTarget === undefined) return false;
    const $pos = view.state.doc.resolve(gapTarget.pos);
    // A paragraph child takes a TextSelection (caret at the edge) rather than a gap cursor.
    const isParagraphTarget = (0, $85a81c71b94ef05b$export$8c1438c11cd047f3)(view, gapTarget);
    const nextSelection = isParagraphTarget ? (0, $kCECX.TextSelection).near($pos, gapTarget.side === 'left' ? 1 : -1) : new (0, $4EksL.GapCursorSelection)($pos, gapTarget.side === 'left' ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT);
    // Idempotency guard: `mousedown` already placed this selection, but the browser still
    // fires `mouseup`, so `handleClick`/`handleClickOn` re-run for the same click. Consume it
    // without re-dispatching (which would add a redundant undo entry).
    if (view.state.selection.eq(nextSelection)) return true;
    view.dispatch(view.state.tr.setSelection(nextSelection).scrollIntoView());
    return true;
};
const $d12416bdd3b8a88f$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $d12416bdd3b8a88f$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const section = (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const column = (0, $bjg0G.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $kCECX.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
const $d12416bdd3b8a88f$var$getNodeDecoration = (pos, node)=>[
        (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
const $d12416bdd3b8a88f$var$getDangerPreviewDecorations = (state, positions)=>positions?.flatMap((pos)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return [];
        return [
            (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                class: 'layout-column-danger-preview'
            })
        ];
    }) ?? [];
const $d12416bdd3b8a88f$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $85a81c71b94ef05b$export$9adba9ade368b431)(state);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $20de433b9f6c9d19$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, $d12416bdd3b8a88f$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout,
        isResizing: false,
        isLayoutColumnMenuOpen: false,
        layoutColumnMenuOpenedViaKeyboard: false,
        layoutColumnMenuAnchorPos: undefined,
        dangerPreviewLayoutColumnPositions: undefined
    };
};
const $d12416bdd3b8a88f$var$fireLayoutColumnMenuOpenedAnalytics = (editorAnalyticsAPI, state, openedViaKeyboard)=>{
    const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(state.selection);
    if (!selectedLayoutColumnsResult) return;
    const { layoutSectionNode: layoutSectionNode, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
    editorAnalyticsAPI?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).OPENED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT_COLUMN_MENU,
        attributes: {
            columnCount: layoutSectionNode.childCount,
            endIndex: endIndex,
            inputMethod: openedViaKeyboard ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE,
            selectedCount: selectedLayoutColumns.length,
            startIndex: startIndex
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    });
};
const $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState = (pluginState, action)=>{
    switch(action.type){
        case 'toggleLayoutColumnMenu':
            {
                const { anchorPos: anchorPos, isOpen: isOpen, openedViaKeyboard: openedViaKeyboard } = action.meta;
                // `isOpen` provided: use directly (legacy). Omitted: toggle off only when re-clicking
                // the already-open column; otherwise open for the clicked column.
                const isSameColumnAsOpenMenu = pluginState.isLayoutColumnMenuOpen && anchorPos !== undefined && anchorPos === pluginState.layoutColumnMenuAnchorPos;
                const nextIsOpen = isOpen ?? !isSameColumnAsOpenMenu;
                return {
                    ...pluginState,
                    isLayoutColumnMenuOpen: nextIsOpen,
                    layoutColumnMenuOpenedViaKeyboard: nextIsOpen ? openedViaKeyboard ?? false : false,
                    layoutColumnMenuAnchorPos: nextIsOpen ? anchorPos : undefined,
                    dangerPreviewLayoutColumnPositions: nextIsOpen ? pluginState.dangerPreviewLayoutColumnPositions : undefined
                };
            }
        case 'setDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: action.positions
            };
        case 'clearDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: undefined
            };
        case 'setResizeState':
            return {
                ...pluginState,
                isResizing: action.isResizing
            };
        case 'syncSelectionState':
            {
                const maybeLayoutSection = (0, $85a81c71b94ef05b$export$9adba9ade368b431)(action.state);
                return {
                    ...pluginState,
                    pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                    selectedLayout: (0, $20de433b9f6c9d19$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    pluginState.selectedLayout)
                };
            }
    }
};
// To prevent a single-column layout,
// if a user attempts to delete a layout column and
// we will force remove the content instead.
// There are some edge cases where user can delete a layout column
// see packages/editor/editor-plugin-layout-tests/src/__tests__/unit/delete.ts
const $d12416bdd3b8a88f$var$handleDeleteLayoutColumn = (state, dispatch)=>{
    const sel = state.selection;
    if (sel instanceof (0, $kCECX.NodeSelection) && sel.node.type.name === 'layoutColumn' && sel.$from.parent.type.name === 'layoutSection' && sel.$from.parent.childCount === 2 && dispatch && (0, $jkcNT.editorExperiment)('advanced_layouts', true) && !(0, $jkcNT.editorExperiment)('single_column_layouts', true)) {
        const tr = state.tr;
        const layoutContentFragment = sel.$from.parentOffset === 0 ? (0, $aPdNQ.Fragment).from(sel.$from.parent.lastChild?.content) : (0, $aPdNQ.Fragment).from(sel.$from.parent.firstChild?.content);
        const parent = (0, $bjg0G.findParentNodeClosestToPos)(sel.$from, (node)=>{
            return node.type.name === 'layoutSection';
        });
        if (parent) {
            const layoutSectionPos = tr.mapping.map(parent.pos);
            const layoutSectionNodeSize = parent.node.nodeSize;
            dispatch(state.tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment));
            return true;
        }
        return false;
    }
    return false;
};
var $d12416bdd3b8a88f$export$2e2bcd8739ae039 = (options, editorAnalyticsAPI)=>{
    // Store a reference to the EditorView so widget decorations can dispatch transactions
    let editorViewRef;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1),
        view (view) {
            editorViewRef = view;
            return {
                update (updatedView) {
                    editorViewRef = updatedView;
                },
                destroy () {
                    editorViewRef = undefined;
                }
            };
        },
        state: {
            init: (_, state)=>$d12416bdd3b8a88f$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, oldState, newState)=>{
                let nextPluginState = pluginState;
                const columnMenuMeta = tr.getMeta('toggleLayoutColumnMenu');
                const dangerPreviewMeta = tr.getMeta('layoutColumnDangerPreview');
                if (columnMenuMeta) {
                    const wasLayoutColumnMenuOpen = nextPluginState.isLayoutColumnMenuOpen;
                    nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                        meta: columnMenuMeta,
                        type: 'toggleLayoutColumnMenu'
                    });
                    if (!wasLayoutColumnMenuOpen && nextPluginState.isLayoutColumnMenuOpen) $d12416bdd3b8a88f$var$fireLayoutColumnMenuOpenedAnalytics(editorAnalyticsAPI, newState, columnMenuMeta.openedViaKeyboard);
                }
                if (tr.getMeta('layoutColumnDangerPreview') !== undefined) nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    positions: dangerPreviewMeta ?? undefined,
                    type: 'setDangerPreview'
                });
                if (tr.docChanged) nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    type: 'clearDangerPreview'
                });
                const isResizing = (0, $jkcNT.editorExperiment)('single_column_layouts', true) ? tr.getMeta('is-resizer-resizing') ?? (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(oldState)?.isResizing : false;
                nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    isResizing: isResizing,
                    type: 'setResizeState'
                });
                if (tr.docChanged || tr.selectionSet) return $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    state: newState,
                    type: 'syncSelectionState'
                });
                return nextPluginState;
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
                const isLayoutResizingPluginAvailable = (0, $263e2eabc1c558a4$export$18d4026d1ea86bb1).get(state) !== undefined;
                if ((0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutResizingPluginAvailable) {
                    const dividerDecorations = (0, $0ab5832e42b8afea$export$b54a43c7f9b448fd)(state, editorViewRef, editorAnalyticsAPI);
                    const selectedDecorations = layoutState.pos !== null ? $d12416bdd3b8a88f$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    const dangerPreviewDecorations = $d12416bdd3b8a88f$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                    const allDecorations = [
                        ...selectedDecorations,
                        ...dividerDecorations,
                        ...dangerPreviewDecorations
                    ];
                    if (allDecorations.length > 0) return (0, $8nvEM.DecorationSet).create(state.doc, allDecorations);
                    return undefined;
                }
                const dangerPreviewDecorations = $d12416bdd3b8a88f$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                if (layoutState.pos !== null || dangerPreviewDecorations.length > 0) {
                    const selectedDecorations = layoutState.pos !== null ? $d12416bdd3b8a88f$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    return (0, $8nvEM.DecorationSet).create(state.doc, [
                        ...selectedDecorations,
                        ...dangerPreviewDecorations
                    ]);
                }
                return undefined;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Tab: (0, $dTPhv.filter)($d12416bdd3b8a88f$var$isWholeSelectionInsideLayoutColumn, $d12416bdd3b8a88f$var$moveCursorToNextColumn),
                'Mod-Backspace': $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                'Mod-Delete': $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                Backspace: $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                Delete: $d12416bdd3b8a88f$var$handleDeleteLayoutColumn
            }),
            handleDOMEvents: {
                // Place the gap cursor on `mousedown` (not `mouseup`) so the caret never flashes
                // inside a nested editable child first.
                mousedown (view, event) {
                    const target = event.target;
                    if (target?.hasAttribute('data-layout-section')) return false;
                    if ($d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event)) {
                        event.preventDefault();
                        // `preventDefault()` blocks the editor focus that makes the gap cursor blink,
                        // so restore it here. The `handleClick`/`handleClickOn` paths don't need this.
                        if (!view.hasFocus()) view.focus();
                        return true;
                    }
                    return false;
                }
            },
            handleClickOn: (()=>{
                const selectionClickHandler = (0, $lp7sw.createSelectionClickHandler)([
                    'layoutColumn'
                ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                    useLongPressSelection: options.useLongPressSelection || false,
                    getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
                });
                return (view, pos, node, nodePos, event, direct)=>{
                    // Fallback for clicks on an atomic node view that the mousedown hook missed.
                    const target = event.target;
                    if (!target?.hasAttribute('data-layout-section') && $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event)) return true;
                    return selectionClickHandler(view, pos, node, nodePos, event, direct);
                };
            })(),
            handleClick (view, _pos, event) {
                // Fallback for clicks the mousedown interceptor missed.
                const target = event.target;
                if (target?.hasAttribute('data-layout-section')) return false;
                return $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event);
            }
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            const changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                // Skip fixing column sizes for column resize drag transactions
                if (prevTr.getMeta('layoutColumnResize')) return;
                // Layout column insert actions already recalculate column widths and need their own
                // selection mapping; avoid a follow-up normalisation transaction that can remap it.
                if (prevTr.getMeta((0, $20de433b9f6c9d19$export$7304947c445e7dbb))) return;
                const change = (0, $20de433b9f6c9d19$export$ea5c48c44d467c6)(prevTr, newState);
                if (change) changes.push(change);
            });
            if ((0, $jkcNT.editorExperiment)('advanced_layouts', true) && changes.length === 1) {
                const change = changes[0];
                // When editorExperiment('single_column_layouts', true) is on
                // delete can create a single column layout
                // otherwise we replace the single column layout with its content
                if (!(0, $jkcNT.editorExperiment)('single_column_layouts', true) && change.slice.content.childCount === 1 && change.slice.content.firstChild?.type.name === 'layoutColumn' && change.slice.content.firstChild?.attrs.width === (0, $bbeac3462dd7561c$export$faa6744ce57d263b)[1]) {
                    const tr = newState.tr;
                    const { content: content } = change.slice.content.firstChild;
                    tr.replaceWith(change.from - 1, change.to, content);
                    return tr;
                }
            }
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $20de433b9f6c9d19$export$35e1f731e4a1d52)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $kCECX.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });
};




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");










const $46d3039b880758a7$var$PLACEHOLDER_SELECTOR = '.ProseMirror-focused .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)';
const $46d3039b880758a7$var$layoutColumnDangerPreviewStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-column].layout-column-danger-preview': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
        boxShadow: `inset 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::before': {
            visibility: 'hidden'
        }
    }
});
const $46d3039b880758a7$var$getPlaceholderStyle = (message)=>{
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $lOiVq.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`${$46d3039b880758a7$var$PLACEHOLDER_SELECTOR}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-subtlest, #6B6E76)",
                pointerEvents: 'none'
            }
        }
    });
    return /*#__PURE__*/ (0, $lOiVq.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '.ProseMirror .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-disabled, #080F214A)",
                font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                marginTop: "var(--ds-space-050, 4px)",
                pointerEvents: 'none'
            }
        }
    });
};
const $46d3039b880758a7$export$cc5403d58ddfa812 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderStyle = (0, $cozmU.useMemo)(()=>{
        const placeholderText = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $72OpT.toolbarMessages).controlslayoutPlaceholder : (0, $72OpT.toolbarMessages).layoutPlaceholder;
        return $46d3039b880758a7$var$getPlaceholderStyle(formatMessage(placeholderText));
    }, [
        formatMessage
    ]);
    const globalStyles = (0, $cozmU.useMemo)(()=>[
            placeholderStyle,
            $46d3039b880758a7$var$layoutColumnDangerPreviewStyle
        ], [
        placeholderStyle
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: globalStyles
    });
};


/* LayoutBlockMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");








var $3FYPH = parcelRequire("3FYPH");


var $dVKvM = parcelRequire("dVKvM");


var $eQpqk = parcelRequire("eQpqk");

const $d682813aeb2e73a4$var$styles = {
    svgOverflow: "_4xp0cqYvD1 _2QhaXDYvD1"
};
const $d682813aeb2e73a4$var$NODE_NAME = 'layoutSection';
const $d682813aeb2e73a4$var$LayoutBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.layoutSection, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $d682813aeb2e73a4$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $d682813aeb2e73a4$var$styles.svgOverflow
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
                label: "",
                size: "small"
            })
        }),
        children: formatMessage((0, $3FYPH.messages).layout)
    });
};
const $d682813aeb2e73a4$export$83047c2fe2258f8 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($d682813aeb2e73a4$var$LayoutBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};












var $b2omX = parcelRequire("b2omX");





var $kAPZe = parcelRequire("kAPZe");


var $7XIuB = parcelRequire("7XIuB");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");


var $9Muxb = parcelRequire("9Muxb");


var $3v5aK = parcelRequire("3v5aK");





var $kwf4Z = parcelRequire("kwf4Z");


var $dQMlg = parcelRequire("dQMlg");















var $uyXFl = parcelRequire("uyXFl");


var $jgJIe = parcelRequire("jgJIe");


var $dQrHJ = parcelRequire("dQrHJ");




















var $iDfTs = parcelRequire("iDfTs");



var $i9j2V = parcelRequire("i9j2V");





const $f7560e5d01f47387$export$b5775257132e9ca7 = (api)=>(0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], ({ selectionState: selectionState })=>{
        const selectedLayoutColumns = selectionState?.selection && (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(selectionState.selection);
        return selectedLayoutColumns?.selectedLayoutColumns.length ? selectedLayoutColumns : undefined;
    });


const $228ccbfff683bd0e$export$5829d448eda3ac0f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const setDangerPreview = (0, $cozmU.useCallback)((show)=>{
        api?.core?.actions.execute(api?.layout?.commands.setLayoutColumnDangerPreview(show));
    }, [
        api
    ]);
    const showDangerPreview = (0, $cozmU.useCallback)(()=>{
        setDangerPreview(true);
    }, [
        setDangerPreview
    ]);
    const hideDangerPreview = (0, $cozmU.useCallback)(()=>{
        setDangerPreview(false);
    }, [
        setDangerPreview
    ]);
    const onClick = (0, $cozmU.useCallback)(()=>{
        const deleteCommand = api?.layout?.commands.deleteLayoutColumn({
            inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api?.core?.actions.execute((props)=>{
            const tr = deleteCommand?.(props);
            if (!tr) return tr ?? null;
            api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    if (selectedLayoutColumns === undefined) return null;
    const selectedColumnCount = selectedLayoutColumns.selectedLayoutColumns.length;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.deleteColumn)),
        onClick: onClick,
        onFocus: showDangerPreview,
        onMouseEnter: showDangerPreview,
        onBlur: hideDangerPreview,
        onMouseLeave: hideDangerPreview,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.deleteColumn)) ?? ''
        }),
        children: formatMessage((0, $72OpT.toolbarMessages).deleteColumn, {
            count: selectedColumnCount
        })
    });
};


















var $eh9HJ = parcelRequire("eh9HJ");





const $9befd911426fdde2$export$38f325b1b0b6a59f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumnsResult = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const { selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult ?? {};
    const handleClick = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute((props)=>{
            const tr = api?.layout?.commands.distributeLayoutColumns({
                inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
            })(props);
            if (!tr) return null;
            const closedTr = api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return closedTr ?? tr;
        });
    }, [
        api
    ]);
    const isAlreadyUniform = (0, $cozmU.useMemo)(()=>{
        if (!selectedLayoutColumns || selectedLayoutColumns.length < 2) return false;
        const selectedWidths = selectedLayoutColumns.map((col)=>col.node.attrs.width);
        return (0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)(selectedWidths);
    }, [
        selectedLayoutColumns
    ]);
    if (selectedLayoutColumns === undefined || selectedLayoutColumns.length < 2) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isDisabled: isAlreadyUniform,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $72OpT.toolbarMessages).distributeColumns)
    });
};





















var $jWZGH = parcelRequire("jWZGH");

var $eehur = parcelRequire("eehur");







const $778bf6704af08265$var$INSERT_COLUMN_OPTIONS = {
    left: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWZGH))),
        label: (0, $72OpT.toolbarMessages).addColumnLeft,
        side: 'left'
    },
    right: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eehur))),
        label: (0, $72OpT.toolbarMessages).addColumnRight,
        side: 'right'
    }
};
const $778bf6704af08265$export$81334f287bddf48 = ({ api: api, side: side })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Icon: Icon, label: label } = $778bf6704af08265$var$INSERT_COLUMN_OPTIONS[side];
    const shortcut = side === 'left' ? (0, $ldqjS.addColumnBefore) : (0, $ldqjS.addColumnAfter);
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const columnCount = selectedLayoutColumns?.layoutSectionNode?.childCount ?? 0;
    const maxColumnCount = (0, $20de433b9f6c9d19$export$1e9b718436507bc8)();
    const canInsertColumn = selectedLayoutColumns !== undefined && columnCount < maxColumnCount;
    const onClick = (0, $cozmU.useCallback)(()=>{
        const insertCommand = api?.layout?.commands.insertLayoutColumn({
            side: side,
            inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api?.core?.actions.execute((props)=>{
            const tr = insertCommand?.(props);
            if (!tr) return tr ?? null;
            api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        side
    ]);
    if (!canInsertColumn) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)(shortcut) ?? ''
        }),
        onClick: onClick,
        children: formatMessage(label)
    });
};


const $28d0336eb9b11f85$export$9d94e89ca7612d27 = {
    type: 'menu',
    key: 'layout-column-menu'
};
const $28d0336eb9b11f85$export$eb99a60802d2824d = {
    type: 'menu-section',
    key: 'layout-column-menu-section'
};
const $28d0336eb9b11f85$export$75dfb738e6f28040 = {
    type: 'menu-section',
    key: 'layout-column-vertical-align-menu-section'
};
const $28d0336eb9b11f85$export$4586103d528537d = {
    type: 'menu-section',
    key: 'layout-column-danger-section'
};
const $28d0336eb9b11f85$export$5a7b98ab4e990db4 = {
    [$28d0336eb9b11f85$export$eb99a60802d2824d.key]: 100,
    [$28d0336eb9b11f85$export$4586103d528537d.key]: 200
};
const $28d0336eb9b11f85$export$b015955eb6c647e8 = {
    type: 'nested-menu',
    key: 'layout-column-menu-vertical-align-menu'
};
const $28d0336eb9b11f85$export$3e4da34ad142735a = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-left-item'
};
const $28d0336eb9b11f85$export$167d9b289da7ec90 = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-right-item'
};
const $28d0336eb9b11f85$export$3497442ae78aae72 = {
    type: 'menu-item',
    key: 'layout-column-menu-distribute-columns-item'
};
const $28d0336eb9b11f85$export$e9b3f7442c87b29e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-top-item'
};
const $28d0336eb9b11f85$export$1031423c8b45d874 = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-middle-item'
};
const $28d0336eb9b11f85$export$afcf8724bfd1844e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-bottom-item'
};
const $28d0336eb9b11f85$export$d75dc9d2c2174014 = {
    type: 'menu-item',
    key: 'layout-column-menu-delete-item'
};
const $28d0336eb9b11f85$export$c1497fcad4589239 = {
    [$28d0336eb9b11f85$export$b015955eb6c647e8.key]: 100,
    [$28d0336eb9b11f85$export$3e4da34ad142735a.key]: 200,
    [$28d0336eb9b11f85$export$167d9b289da7ec90.key]: 300,
    [$28d0336eb9b11f85$export$3497442ae78aae72.key]: 400
};
const $28d0336eb9b11f85$export$179c00b952ce20ad = {
    [$28d0336eb9b11f85$export$d75dc9d2c2174014.key]: 100
};
const $28d0336eb9b11f85$export$3094a3221df5ea5d = {
    [$28d0336eb9b11f85$export$75dfb738e6f28040.key]: 100
};
const $28d0336eb9b11f85$export$9767915495221593 = {
    [$28d0336eb9b11f85$export$e9b3f7442c87b29e.key]: 100,
    [$28d0336eb9b11f85$export$1031423c8b45d874.key]: 200,
    [$28d0336eb9b11f85$export$afcf8724bfd1844e.key]: 300
};
















// Disable no-re-export here, this is a useful mapping file for icon lookup used in multiple places
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $372k4 = parcelRequire("372k4");


var $2v0Un = parcelRequire("2v0Un");


var $j0Bn2 = parcelRequire("j0Bn2");

const $997a4dc2b55c47ef$export$ca3f839074508470 = {
    top: (0, (/*@__PURE__*/$parcel$interopDefault($j0Bn2))),
    middle: (0, (/*@__PURE__*/$parcel$interopDefault($2v0Un))),
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($372k4)))
};


const $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c = ({ api: api, label: label, value: value })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const isSelected = selectedLayoutColumns?.selectedLayoutColumns.every(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) === value) ?? false;
    const Icon = (0, $997a4dc2b55c47ef$export$ca3f839074508470)[value];
    const onClick = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(api?.layout?.commands.setLayoutColumnValign({
            valign: value
        }));
    }, [
        api,
        value
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: "",
            size: "small"
        }),
        isSelected: isSelected,
        onClick: onClick,
        role: "menuitemradio",
        children: formatMessage(label)
    });
};















var $97uS1 = parcelRequire("97uS1");

var $gk3KR = parcelRequire("gk3KR");




const $c1b8ce3f8bcd5031$export$711d24ebe8961c4c = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const currentValign = (0, $cozmU.useMemo)(()=>{
        const selectedColumns = selectedLayoutColumns?.selectedLayoutColumns;
        const firstColumn = selectedColumns?.[0];
        const firstValign = (0, $165a594884c31a30$export$3645821254ad9933)(firstColumn?.node);
        if (!firstValign || !selectedColumns?.every(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) === firstValign)) return undefined;
        return firstValign;
    }, [
        selectedLayoutColumns
    ]);
    const TriggerIcon = currentValign ? (0, $997a4dc2b55c47ef$export$ca3f839074508470)[currentValign] : (0, $997a4dc2b55c47ef$export$ca3f839074508470).middle;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(TriggerIcon, {
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $97uS1.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $72OpT.toolbarMessages).alignColumn),
        children: children
    });
};


const $ebaa5b0b8f496848$var$LayoutColumnMenuContainer = ({ children: children })=>{
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQrHJ.ToolbarMenuContainer), {
        ref: setOutsideClickTargetRef,
        children: children
    });
};
const $ebaa5b0b8f496848$export$ebf2330b4a9986ef = {
    'menu-section': ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
            children: children
        })
};
const $ebaa5b0b8f496848$export$dd3a9dfb7a54acb6 = ({ api: api })=>{
    return [
        {
            ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
            component: $ebaa5b0b8f496848$var$LayoutColumnMenuContainer
        },
        {
            ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
                    rank: (0, $28d0336eb9b11f85$export$5a7b98ab4e990db4)[(0, $28d0336eb9b11f85$export$eb99a60802d2824d).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$3e4da34ad142735a),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $778bf6704af08265$export$81334f287bddf48), {
                    api: api,
                    side: "left"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$3e4da34ad142735a).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$167d9b289da7ec90),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $778bf6704af08265$export$81334f287bddf48), {
                    api: api,
                    side: "right"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$167d9b289da7ec90).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$3497442ae78aae72),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9befd911426fdde2$export$38f325b1b0b6a59f), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$3497442ae78aae72).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$b015955eb6c647e8),
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1b8ce3f8bcd5031$export$711d24ebe8961c4c), {
                    api: api,
                    children: children
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$b015955eb6c647e8).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$b015955eb6c647e8),
                    rank: (0, $28d0336eb9b11f85$export$3094a3221df5ea5d)[(0, $28d0336eb9b11f85$export$75dfb738e6f28040).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$e9b3f7442c87b29e),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnTop,
                    value: "top"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$e9b3f7442c87b29e).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$1031423c8b45d874),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnMiddle,
                    value: "middle"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$1031423c8b45d874).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$afcf8724bfd1844e),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnBottom,
                    value: "bottom"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$afcf8724bfd1844e).key]
                }
            ]
        },
        // --- Danger section (Delete column) ---
        {
            ...(0, $28d0336eb9b11f85$export$4586103d528537d),
            component: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
                    rank: (0, $28d0336eb9b11f85$export$5a7b98ab4e990db4)[(0, $28d0336eb9b11f85$export$4586103d528537d).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$d75dc9d2c2174014),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $228ccbfff683bd0e$export$5829d448eda3ac0f), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$4586103d528537d),
                    rank: (0, $28d0336eb9b11f85$export$179c00b952ce20ad)[(0, $28d0336eb9b11f85$export$d75dc9d2c2174014).key]
                }
            ]
        }
    ];
};



const $ddefb01754ec395f$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $ddefb01754ec395f$var$TOOLBAR_MENU_SELECTOR = '[data-toolbar-component="menu"]';
const $ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
const $ddefb01754ec395f$var$LAYOUT_COLUMN_MENU_POPUP_OFFSET_BELOW = [
    0,
    2
];
/**
 * Returns the drag handle button for the selected layout column.
 */ const $ddefb01754ec395f$var$getLayoutColumnMenuTarget = (editorView, selection, anchorPosFromHandle)=>{
    const anchorPos = selection && (0, $165a594884c31a30$export$22b40f2459c71fe8)(selection, anchorPosFromHandle);
    if (anchorPos === undefined) return null;
    const columnDomRef = editorView.nodeDOM(anchorPos);
    if (!(columnDomRef instanceof HTMLElement)) return null;
    const dragHandleContainer = columnDomRef.parentElement?.querySelector(':scope > [data-blocks-drag-handle-container]');
    return dragHandleContainer?.querySelector((0, $kAPZe.DRAG_HANDLE_SELECTOR));
};
const $ddefb01754ec395f$var$focusTrap = {
    initialFocus: undefined
};
const $ddefb01754ec395f$export$7050b81bb37a7c70 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function LayoutColumnMenu({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement }) {
    const { isLayoutColumnMenuOpen: isLayoutColumnMenuOpen, layoutColumnMenuAnchorPos: layoutColumnMenuAnchorPos, openedViaKeyboard: openedViaKeyboard, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'layout',
        'selection'
    ], (states)=>({
            isLayoutColumnMenuOpen: states.layoutState?.isLayoutColumnMenuOpen ?? false,
            layoutColumnMenuAnchorPos: states.layoutState?.layoutColumnMenuAnchorPos,
            openedViaKeyboard: states.layoutState?.layoutColumnMenuOpenedViaKeyboard ?? false,
            selection: states.selectionState?.selection
        }));
    const closeLayoutColumnMenu = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(api?.layout?.commands.toggleLayoutColumnMenu({
            isOpen: false
        }));
    }, [
        api
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        if (event.target instanceof Element && (event.target.closest($ddefb01754ec395f$var$TOOLBAR_MENU_SELECTOR) || event.target.closest($ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR))) return;
        // Clicking a drag handle should let the drag handle's own click handler
        // update selection/menu state. Treating it as a generic outside click
        // races that transaction and can immediately close the layout column menu.
        if (event.target instanceof Element && event.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR))) return;
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleArrowKeyNavigationClose = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const shouldDisableArrowKeyNavigation = (0, $cozmU.useCallback)((event)=>{
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.closest($ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR) !== null;
    }, []);
    const menuWrapperRef = (0, $cozmU.useRef)(null);
    const handleMenuKeyDown = (0, $cozmU.useCallback)((event)=>{
        // Keep menu keyboard events scoped to the menu while preserving Escape and
        // ArrowUp/ArrowDown handling from Popup and ArrowKeyNavigationProvider.
        if (event.key !== 'Escape' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') event.stopPropagation();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const menuWrapper = menuWrapperRef.current;
        if (!isLayoutColumnMenuOpen || !menuWrapper) return;
        return (0, $cbY7C.bind)(menuWrapper, {
            type: 'keydown',
            listener: handleMenuKeyDown
        });
    }, [
        handleMenuKeyDown,
        isLayoutColumnMenuOpen
    ]);
    const components = api?.uiControlRegistry?.actions.getComponents((0, $28d0336eb9b11f85$export$9d94e89ca7612d27).key) ?? [];
    const hasValidMenuSelection = !(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') || selection !== undefined && (0, $165a594884c31a30$export$22b40f2459c71fe8)(selection, layoutColumnMenuAnchorPos) !== undefined;
    const legacyTarget = (0, $cozmU.useMemo)(()=>isLayoutColumnMenuOpen && !(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? $ddefb01754ec395f$var$getLayoutColumnMenuTarget(editorView, selection, layoutColumnMenuAnchorPos) : null, [
        editorView,
        isLayoutColumnMenuOpen,
        layoutColumnMenuAnchorPos,
        selection
    ]);
    const surfaceTargetRef = (0, $cozmU.useRef)(null);
    const surfaceAnchorPosRef = (0, $cozmU.useRef)(undefined);
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') || !isLayoutColumnMenuOpen) {
        surfaceTargetRef.current = null;
        surfaceAnchorPosRef.current = undefined;
    } else if (!surfaceTargetRef.current || surfaceAnchorPosRef.current !== layoutColumnMenuAnchorPos) {
        surfaceTargetRef.current = (0, $b2omX.surfaceDragHandleElementStore).get(editorView) ?? surfaceTargetRef.current;
        surfaceAnchorPosRef.current = layoutColumnMenuAnchorPos;
    }
    const target = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? surfaceTargetRef.current : legacyTarget;
    const hasValidTarget = target instanceof HTMLElement;
    (0, $cozmU.useEffect)(()=>{
        if (isLayoutColumnMenuOpen && (!hasValidMenuSelection || !hasValidTarget || components.length === 0)) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu,
        components.length,
        hasValidMenuSelection,
        hasValidTarget,
        isLayoutColumnMenuOpen
    ]);
    if (!isLayoutColumnMenuOpen || !hasValidMenuSelection || components.length === 0 || !hasValidTarget) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ddefb01754ec395f$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        preventOverflow: true,
        stick: true,
        offset: $ddefb01754ec395f$var$LAYOUT_COLUMN_MENU_POPUP_OFFSET_BELOW,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: closeLayoutColumnMenu,
        focusTrap: openedViaKeyboard ? $ddefb01754ec395f$var$focusTrap : undefined,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: menuWrapperRef,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
                api: api,
                userIntent: "layoutColumnMenuPopupOpen",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kwf4Z.ToolbarDropdownMenuProvider), {
                    isOpen: isLayoutColumnMenuOpen,
                    setIsOpen: handleSetIsOpen,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                        handleClose: handleArrowKeyNavigationClose,
                        disableArrowKeyNavigation: shouldDisableArrowKeyNavigation,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQMlg.SurfaceRenderer), {
                            components: components,
                            fallbacks: (0, $ebaa5b0b8f496848$export$ebf2330b4a9986ef),
                            surface: (0, $28d0336eb9b11f85$export$9d94e89ca7612d27)
                        })
                    })
                })
            })
        })
    });
});






parcelRequire("cozmU");







var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");

















var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $3ymEf = parcelRequire("3ymEf");


var $bhIPc = parcelRequire("bhIPc");


var $fHdH6 = parcelRequire("fHdH6");





var $4exuQ = parcelRequire("4exuQ");


const $692f7a95e62d14f5$var$icons = {
    2: (0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))),
    3: (0, (/*@__PURE__*/$parcel$interopDefault($fHdH6))),
    4: (0, (/*@__PURE__*/$parcel$interopDefault($bhIPc))),
    5: (0, (/*@__PURE__*/$parcel$interopDefault($3ymEf)))
};
const $692f7a95e62d14f5$export$dfc1bab297c2a456 = ({ api: api, columnCount: columnCount, previewImageUrls: previewImageUrls, title: title })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const Icon = $692f7a95e62d14f5$var$icons[columnCount];
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(editorView.state, columnCount));
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                columnCount: columnCount,
                inputMethod: source
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        (0, $4exuQ.selectIntoLayoutSection)(tr);
        return tr;
    }, [
        api,
        columnCount
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
            numberOfColumns: columnCount
        }),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(title)
    });
};


const $5328f1c8a168c7c2$var$layoutItems = [
    {
        columnCount: 2,
        description: (0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $dCkbP.TWO_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'two column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMM.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJY.png'
        },
        title: (0, $72OpT.toolbarMessages).twoColumnsAdvancedLayout
    },
    {
        columnCount: 3,
        description: (0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $dCkbP.THREE_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'three column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNM.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK3.png'
        },
        title: (0, $72OpT.toolbarMessages).threeColumnsAdvancedLayout
    },
    {
        columnCount: 4,
        description: (0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $dCkbP.FOUR_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'four column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNI.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK5.png'
        },
        title: (0, $72OpT.toolbarMessages).fourColumns
    },
    {
        columnCount: 5,
        description: (0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $dCkbP.FIVE_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'five column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNO.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJV.png'
        },
        title: (0, $72OpT.toolbarMessages).fiveColumns
    }
];
const $5328f1c8a168c7c2$export$ab30cc6fee54f4aa = ({ api: api })=>$5328f1c8a168c7c2$var$layoutItems.map(({ columnCount: columnCount, description: description, item: item, keyword: keyword, previewImageUrls: previewImageUrls, title: title })=>({
            key: item.key,
            type: item.type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[item.key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(description, {
                        numberOfColumns: columnCount
                    }),
                    keywords: [
                        'layout',
                        'column',
                        'section',
                        'col',
                        keyword
                    ],
                    title: formatMessage(title)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $692f7a95e62d14f5$export$dfc1bab297c2a456), {
                    api: api,
                    columnCount: columnCount,
                    previewImageUrls: previewImageUrls,
                    title: title
                })
        }));





parcelRequire("cozmU");





var $2xhuI = parcelRequire("2xhuI");




var $g6uqx = parcelRequire("g6uqx");








var $fHs3z = parcelRequire("fHs3z");





var $8p5GO = parcelRequire("8p5GO");





var $5skpJ = parcelRequire("5skpJ");





var $fWx9I = parcelRequire("fWx9I");


var $8AMT2 = parcelRequire("8AMT2");









/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








function $17a886394e2f3375$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $17a886394e2f3375$var$wrapperStyle = {
    name: "dzd8y1",
    styles: "padding:0 4px"
};
const $17a886394e2f3375$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $17a886394e2f3375$var$wrapperStyle
    }, children);
};
const $17a886394e2f3375$export$3cfd1ab6a9856e7e = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($17a886394e2f3375$var$Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ymEf))), {
        label: ""
    }));
};
const $17a886394e2f3375$export$38b01bd15f6a5487 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($17a886394e2f3375$var$Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bhIPc))), {
        label: ""
    }));
};





parcelRequire("cozmU");


var $ctpKQ = parcelRequire("ctpKQ");

const $edfa58548f6e7d13$export$4518caee70c71b2e = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctpKQ))), {
        ...props
    });
};





parcelRequire("cozmU");


var $4dPfL = parcelRequire("4dPfL");

const $77daa6a3fae9f080$export$36efe6f2091df089 = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4dPfL))), {
        ...props
    });
};


const $34cb090319fea2f7$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $72OpT.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eQpqk)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $72OpT.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHdH6)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $72OpT.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8p5GO)))
    },
    ...$34cb090319fea2f7$var$LAYOUT_TYPES
];
const $34cb090319fea2f7$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $72OpT.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8AMT2)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $72OpT.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fWx9I)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5skpJ)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $72OpT.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8AMT2)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $72OpT.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fWx9I)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5skpJ)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $77daa6a3fae9f080$export$36efe6f2091df089),
        iconFallback: (0, $77daa6a3fae9f080$export$36efe6f2091df089)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $edfa58548f6e7d13$export$4518caee70c71b2e),
        iconFallback: (0, $edfa58548f6e7d13$export$4518caee70c71b2e)
    }
];
const $34cb090319fea2f7$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        iconFallback: item.iconFallback,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $34cb090319fea2f7$export$cbec87ad92a1069a = 'Layout floating controls';
const $34cb090319fea2f7$var$iconPlaceholder = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
    label: ""
}); // TODO: ED-25466 - Replace with proper icon
const $34cb090319fea2f7$var$getLayoutColumnsIcons = (colCount)=>{
    if (!(0, $jkcNT.editorExperiment)('single_column_layouts', true) && !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return undefined;
    switch(colCount){
        case 1:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8p5GO))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHdH6))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17a886394e2f3375$export$38b01bd15f6a5487), {});
        case 5:
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $17a886394e2f3375$export$3cfd1ab6a9856e7e), {});
        default:
            return undefined;
    }
};
const $34cb090319fea2f7$var$getLayoutColumnWidths = (node)=>{
    return node.children.map((child)=>child.attrs.width);
};
const $34cb090319fea2f7$var$getAdvancedLayoutItems = ({ addSidebarLayouts: addSidebarLayouts, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, node: node, nodeType: nodeType, separator: separator, deleteButton: deleteButton, currentLayout: currentLayout, allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout })=>{
    const numberOfColumns = node.content.childCount || 2;
    const distributionOptions = numberOfColumns === 2 ? $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION : numberOfColumns === 3 ? $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION : [];
    const columnOptions = [
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 2
            }),
            //'2-columns',
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(2) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('two_equal'),
            selected: numberOfColumns === 2
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 3
            }),
            //'3-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(3) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('three_equal'),
            selected: numberOfColumns === 3
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 4
            }),
            //'4-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(4) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('four_equal'),
            selected: numberOfColumns === 4
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 5
            }),
            //'5-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(5) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('five_equal'),
            selected: numberOfColumns === 5
        }
    ];
    const dropdownOptions = [
        ...allowAdvancedSingleColumnLayout ? [
            {
                title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                    count: 1
                }),
                //'1-columns',
                icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(1) || $34cb090319fea2f7$var$iconPlaceholder,
                onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('single'),
                selected: numberOfColumns === 1
            }
        ] : [],
        ...columnOptions
    ];
    const distributeColumnsButton = numberOfColumns > 1 ? {
        disabled: (0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)($34cb090319fea2f7$var$getLayoutColumnWidths(node)),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))),
        onClick: (editorState, dispatch)=>{
            const tr = (0, $20de433b9f6c9d19$export$3155fb5f705eeef0)(editorAnalyticsAPI)({
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                target: 'allColumns'
            })({
                tr: editorState.tr
            });
            if (!tr) return false;
            dispatch?.(tr);
            return true;
        },
        testId: 'layout-distribute-columns',
        title: intl.formatMessage((0, $72OpT.toolbarMessages).distributeColumns),
        type: 'button'
    } : undefined;
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: numberOfColumns
            }),
            //`${numberOfColumns}-columns`,
            options: dropdownOptions,
            showSelected: true,
            testId: 'column-options-button'
        },
        ...distributionOptions.length > 0 || distributeColumnsButton ? [
            separator
        ] : [],
        ...addSidebarLayouts ? distributionOptions.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : [],
        ...distributeColumnsButton ? [
            distributeColumnsButton
        ] : []
    ];
};
const $34cb090319fea2f7$var$fullHeightSeparator = {
    type: 'separator',
    fullHeight: true
};
const $34cb090319fea2f7$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api)=>{
    const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    const node = state.doc.nodeAt(pos);
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    if (node) {
        const currentLayout = (0, $20de433b9f6c9d19$export$e406155610be725b)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            testId: (0, $2xhuI.default).remove.id,
            title: intl.formatMessage((0, $2xhuI.default).remove),
            onClick: (0, $20de433b9f6c9d19$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            tabIndex: null
        };
        const copyButton = {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: nodeType
                }
            ]
        };
        const layoutTypes = allowSingleColumnLayout ? $34cb090319fea2f7$var$LAYOUT_TYPES_WITH_SINGLE_COL : $34cb090319fea2f7$var$LAYOUT_TYPES;
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'layout-overflow-dropdown-trigger';
        const overflowMenu = {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                    onClick: ()=>{
                        api?.core?.actions.execute(// @ts-ignore
                        api?.floatingToolbar?.commands.copyNode(nodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
                },
                {
                    title: intl.formatMessage((0, $2xhuI.default).delete),
                    onClick: (0, $20de433b9f6c9d19$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        };
        return {
            title: $34cb090319fea2f7$export$cbec87ad92a1069a,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $bjg0G.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $72OpT.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...(0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $34cb090319fea2f7$var$getAdvancedLayoutItems({
                    addSidebarLayouts: addSidebarLayouts,
                    intl: intl,
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    nodeType: nodeType,
                    node: node,
                    separator: separator,
                    deleteButton: deleteButton,
                    currentLayout: currentLayout,
                    allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout
                }) : [
                    ...layoutTypes.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                    ...addSidebarLayouts ? $34cb090319fea2f7$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
                ],
                ...toolbarFlagsEnabled ? [
                    $34cb090319fea2f7$var$fullHeightSeparator,
                    overflowMenu
                ] : [
                    separator,
                    copyButton,
                    separator,
                    deleteButton
                ]
            ],
            scrollable: true
        };
    }
    return;
};


const $da7a0fed9b537896$var$LAYOUT_SECTION_NODE_NAME = 'layoutSection';
const $da7a0fed9b537896$export$abf76f127fb6937c = (tr)=>{
    if (!(0, $jkcNT.editorExperiment)('single_column_layouts', true)) return tr;
    const { layoutSection: layoutSection, paragraph: paragraph } = tr.doc.type.schema.nodes;
    const nodeWithPos = (0, $bjg0G.findParentNode)((node)=>node.type === layoutSection)(tr.selection);
    if (!nodeWithPos || !nodeWithPos.node || nodeWithPos.node.type.name !== 'layoutSection' || nodeWithPos.node.firstChild?.firstChild?.type !== paragraph) return tr;
    // set text selection at the beginning of the layout section
    // will set the selection to the first column
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, nodeWithPos.pos));
    return tr;
};
const $da7a0fed9b537896$export$2229806460c545ea = ({ config: options = {}, api: api })=>{
    const isAdvancedLayoutEnabled = (0, $jkcNT.editorExperiment)('advanced_layouts', true);
    const allowAdvancedSingleColumnLayout = isAdvancedLayoutEnabled && (0, $jkcNT.editorExperiment)('single_column_layouts', true, {
        exposure: true
    });
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') && isAdvancedLayoutEnabled;
    api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]
            },
            component: (0, $d682813aeb2e73a4$export$83047c2fe2258f8)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($da7a0fed9b537896$var$LAYOUT_SECTION_NODE_NAME))
        }
    ]);
    api?.uiControlRegistry?.actions.register((0, $ebaa5b0b8f496848$export$dd3a9dfb7a54acb6)({
        api: api
    }));
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $5328f1c8a168c7c2$export$ab30cc6fee54f4aa)({
        api: api
    }));
    return {
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $6OV8L.layoutSectionWithSingleColumnLocalId) : (0, $6OV8L.layoutSectionWithSingleColumn) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $6OV8L.layoutSectionWithLocalId) : (0, $6OV8L.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $6UUJT.layoutColumnWithLocalId) : (0, $6UUJT.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'layout',
                    plugin: ()=>(0, $d12416bdd3b8a88f$export$2e2bcd8739ae039)(options, api?.analytics?.actions)
                }
            ];
            plugins.push({
                name: 'layoutKeymap',
                plugin: ()=>(0, $85a43829160bedc9$export$2e2bcd8739ae039)({
                        api: api
                    })
            });
            if ((options.editorAppearance === 'full-page' || options.editorAppearance === 'full-width' || options.editorAppearance === 'max') && api && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) plugins.push({
                name: 'layoutResizing',
                plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>(0, $263e2eabc1c558a4$export$2e2bcd8739ae039)(options, api, portalProviderAPI, eventDispatcher, getIntl())
            });
            return plugins;
        },
        actions: {
            insertLayoutColumns: (0, $20de433b9f6c9d19$export$3517c001098bb0a9)(api?.analytics?.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const layoutState = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
                if (!layoutState) return undefined;
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout, isResizing: isResizing } = layoutState;
                const shouldHideToolbar = isResizing && (0, $jkcNT.editorExperiment)('single_column_layouts', true);
                if (pos !== null && !shouldHideToolbar) return (0, $34cb090319fea2f7$export$6dd6ab35df8f7f86)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: isRegisteredSlashCommandEnabled ? undefined : ({ formatMessage: formatMessage })=>{
                const withInsertLayoutAnalytics = (tr, columnCount)=>{
                    api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).INSERTED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
                        attributes: {
                            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                            columnCount: columnCount
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK
                    })(tr);
                    return tr;
                };
                if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
                    const createAdvancedColumnLayoutOption = ({ columnCount: columnCount, descriptionColumnCount: descriptionColumnCount, icon: Icon, id: id, keyword: keyword, title: title })=>({
                            id: id,
                            title: title,
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: descriptionColumnCount
                            }),
                            keywords: [
                                'layout',
                                'column',
                                'section',
                                'col',
                                keyword
                            ],
                            priority: 1100,
                            icon: Icon,
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, columnCount));
                                if ((0, $iDrrr.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, columnCount);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        });
                    const advancedSingleColumnOption = allowAdvancedSingleColumnLayout ? [
                        {
                            id: 'onecolumnlayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).singleColumnAdvancedLayout),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).singleColumnsDescriptionAdvancedLayout),
                            keywords: [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'single column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconOneColumnLayout), {}),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 1));
                                if ((0, $iDrrr.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 1);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        }
                    ] : [];
                    return [
                        createAdvancedColumnLayoutOption({
                            columnCount: 2,
                            descriptionColumnCount: 'two',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconTwoColumnLayout), {}),
                            id: 'twocolumnslayout',
                            keyword: 'two column',
                            title: formatMessage((0, $72OpT.toolbarMessages).twoColumnsAdvancedLayout)
                        }),
                        ...advancedSingleColumnOption,
                        createAdvancedColumnLayoutOption({
                            columnCount: 3,
                            descriptionColumnCount: 'three',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconThreeColumnLayout), {}),
                            id: 'threecolumnslayout',
                            keyword: 'three column',
                            title: formatMessage((0, $72OpT.toolbarMessages).threeColumnsAdvancedLayout)
                        }),
                        createAdvancedColumnLayoutOption({
                            columnCount: 4,
                            descriptionColumnCount: 'four',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconFourColumnLayout), {}),
                            id: 'fourcolumnslayout',
                            keyword: 'four column',
                            title: formatMessage((0, $72OpT.toolbarMessages).fourColumns)
                        }),
                        createAdvancedColumnLayoutOption({
                            columnCount: 5,
                            descriptionColumnCount: 'five',
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconFiveColumnLayout), {}),
                            id: 'fivecolumnslayout',
                            keyword: 'five column',
                            title: formatMessage((0, $72OpT.toolbarMessages).fiveColumns)
                        })
                    ];
                } else return [
                    {
                        id: 'layout',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconLayout), {}),
                        action (insert, state) {
                            const tr = insert((0, $20de433b9f6c9d19$export$24df8f7ba30643b8)(state));
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $46d3039b880758a7$export$cc5403d58ddfa812), {}) : null,
                    editorView ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ddefb01754ec395f$export$7050b81bb37a7c70), {
                        api: api,
                        editorView: editorView,
                        mountTo: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement
                    }) : null
                ]
            });
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(editorState);
        },
        commands: {
            deleteLayoutColumn: (options)=>(0, $20de433b9f6c9d19$export$b3b830a5fba26889)(options, api?.analytics?.actions, api),
            distributeLayoutColumns: (options)=>(0, $20de433b9f6c9d19$export$3155fb5f705eeef0)(api?.analytics?.actions, api)(options),
            insertLayoutColumn: (options)=>(0, $20de433b9f6c9d19$export$7dcaf37842fa555e)(options, api?.analytics?.actions, api),
            setLayoutColumnDangerPreview: $20de433b9f6c9d19$export$21f559cd4fbd479,
            setLayoutColumnValign: (options)=>(0, $20de433b9f6c9d19$export$4bf533320bf88c4)(options, api?.analytics?.actions, api),
            toggleLayoutColumnMenu: $20de433b9f6c9d19$export$f9a5c2c84987525d
        }
    };
};
module.exports["selectIntoLayoutSection"] = $da7a0fed9b537896$export$abf76f127fb6937c;
module.exports["layoutPlugin"] = $da7a0fed9b537896$export$2229806460c545ea;

});

parcelRegister("jeuMk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $7XIUO = parcelRequire("7XIUO");


var $7Tmz1 = parcelRequire("7Tmz1");


var $i6nlo = parcelRequire("i6nlo");


var $aIF2y = parcelRequire("aIF2y");


var $jVdlG = parcelRequire("jVdlG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $5HBT9 = parcelRequire("5HBT9");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lhCmf = parcelRequire("lhCmf");

const $0bd0a15a02ed16c1$var$IconCustomPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconCustomPanel() {
    const $ = (0, $bDgLe.c)(48);
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    let t0;
    if ($[0] !== iconThemed) {
        t0 = iconThemed({
            light: "#fff",
            dark: "#161A1D"
        });
        $[0] = iconThemed;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
            width: "40",
            height: "40",
            fill: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== iconThemed) {
        t2 = iconThemed({
            light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
        });
        $[4] = iconThemed;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
            fill: t2
        });
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== iconThemed) {
        t4 = iconThemed({
            light: "#6E5DC6",
            dark: "#9F8FEF"
        });
        $[8] = iconThemed;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
            fill: t4
        });
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== iconThemed) {
        t6 = iconThemed({
            light: "#E34935",
            dark: "#EF5C48"
        });
        $[12] = iconThemed;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
            fill: t6
        });
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== iconThemed) {
        t8 = iconThemed({
            light: "#D97008",
            dark: "#F18D13"
        });
        $[16] = iconThemed;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
            fill: t8
        });
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== iconThemed) {
        t10 = iconThemed({
            light: "#E2B203",
            dark: "#E2B203"
        });
        $[20] = iconThemed;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
            fill: t10
        });
        $[22] = t10;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== iconThemed) {
        t12 = iconThemed({
            light: "#6A9A23",
            dark: "#82B536"
        });
        $[24] = iconThemed;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
            fill: t12
        });
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== iconThemed) {
        t14 = iconThemed({
            light: "#0055CC",
            dark: "#579DFF"
        });
        $[28] = iconThemed;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== t14) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
            fill: t14
        });
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== t11 || $[33] !== t13 || $[34] !== t15 || $[35] !== t5 || $[36] !== t7 || $[37] !== t9) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            clipPath: "url(#clip0)",
            children: [
                t5,
                t7,
                t9,
                t11,
                t13,
                t15
            ]
        });
        $[32] = t11;
        $[33] = t13;
        $[34] = t15;
        $[35] = t5;
        $[36] = t7;
        $[37] = t9;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== iconThemed) {
        t17 = iconThemed({
            light: "#fff",
            dark: "#fff"
        });
        $[39] = iconThemed;
        $[40] = t17;
    } else t17 = $[40];
    let t18;
    if ($[41] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                id: "clip0",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    width: "8",
                    height: "8",
                    fill: t17,
                    transform: "translate(12 16)"
                })
            })
        });
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== t1 || $[44] !== t16 || $[45] !== t18 || $[46] !== t3) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            focusable: "false",
            "aria-hidden": true,
            children: [
                t1,
                t3,
                t16,
                t18
            ]
        });
        $[43] = t1;
        $[44] = t16;
        $[45] = t18;
        $[46] = t3;
        $[47] = t19;
    } else t19 = $[47];
    return t19;
} : function IconCustomPanel() {
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                width: "40",
                height: "40",
                fill: iconThemed({
                    light: '#fff',
                    dark: '#161A1D'
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
                fill: iconThemed({
                    light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
                    dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
                        fill: iconThemed({
                            light: '#6E5DC6',
                            dark: '#9F8FEF'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
                        fill: iconThemed({
                            light: '#E34935',
                            dark: '#EF5C48'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
                        fill: iconThemed({
                            light: '#D97008',
                            dark: '#F18D13'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
                        fill: iconThemed({
                            light: '#E2B203',
                            dark: '#E2B203'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
                        fill: iconThemed({
                            light: '#6A9A23',
                            dark: '#82B536'
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
                        fill: iconThemed({
                            light: '#0055CC',
                            dark: '#579DFF'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: iconThemed({
                            light: '#fff',
                            dark: '#fff'
                        }),
                        transform: "translate(12 16)"
                    })
                })
            })
        ]
    });
};
var $0bd0a15a02ed16c1$export$2e2bcd8739ae039 = $0bd0a15a02ed16c1$var$IconCustomPanel;


var $jGK9e = parcelRequire("jGK9e");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $8tXCb = parcelRequire("8tXCb");


var $dX4zl = parcelRequire("dX4zl");


var $57Rmq = parcelRequire("57Rmq");




const $f6f8e68e864361ee$export$80e77a5be96b2b61 = ({ state: state, attributes: attributes, api: api, typeAheadInsert: typeAheadInsert, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).QUICK_INSERT })=>{
    const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(state.selection.$from) : state.schema.nodes.panel;
    let tr;
    if (state.selection.empty) {
        const node = panelNodeType.createAndFill({
            ...attributes
        });
        if (!node) return false;
        tr = typeAheadInsert ? typeAheadInsert(node) : (0, $8tXCb.insertSelectedItem)(node)(state, state.tr, state.selection.head)?.scrollIntoView();
    } else tr = (0, $dX4zl.createWrapSelectionTransaction)({
        state: state,
        type: panelNodeType,
        nodeAttributes: {
            ...attributes
        }
    });
    if (tr) api?.analytics?.actions.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: attributes.panelType
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    return tr ?? false;
};



var $2w79Z = parcelRequire("2w79Z");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");





var $45O09 = parcelRequire("45O09");


var $lqPdm = parcelRequire("lqPdm");


var $kCECX = parcelRequire("kCECX");





var $7Y8M5 = parcelRequire("7Y8M5");







const $53df13cea42d9a29$export$e58edb186cf54d62 = (nodeName)=>{
    return (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        'panel',
        'panel_c1'
    ].includes(nodeName) : nodeName === 'panel';
};
const $53df13cea42d9a29$export$24b1da61c87aac35 = (nodes)=>{
    const { panel: panel, panel_c1: panel_c1 } = nodes;
    return (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1
    ] : [
        panel
    ];
};
const $53df13cea42d9a29$export$ddbd7c123a514b96 = (state, selection)=>{
    return (0, $bjg0G.findSelectedNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection) || (0, $bjg0G.findParentNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection);
};
const $53df13cea42d9a29$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $jVdlG.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = typeof panelColor === 'string' && (0, $lqPdm.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const isCustomPanelWithColor = typeof panelColor === 'string' && isCustomPanel;
    const style = [
        `${isCustomPanelWithColor ? `background-color: ${panelBackgroundColor};` : ''}`,
        // When table-in-panel is enabled, set --table-container-bg so that table
        // masking elements (sticky-header mask, column-controls wrapper) blend with
        // the custom panel background instead of showing opaque white.
        `${isCustomPanelWithColor && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `${0, $7Y8M5.akEditorTableContainerBg}: ${panelBackgroundColor};` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $45O09.PanelSharedCssClassName).prefix}${!hasIcon ? ` ${(0, $45O09.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $jVdlG.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    // Required for parseDOM to correctly parse custom panel when NodeView DOM is copied directly
    // Schema's parseDOM expects data-panel-icon on all custom panels, not just ones with color
    if (isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-icon': panelIcon
    };
    if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) panelAttrs = {
        ...panelAttrs,
        'data-local-id': attrs.localId
    };
    const iconDiv = [
        'div',
        // EDITOR-266 This fixes an issue in LCM where if you have nested panels
        // The icon colour will be overridden by the parent panel style, this is used to create a more specific css selector
        {
            class: (0, $45O09.PanelSharedCssClassName).icon,
            'data-panel-type': panelType || (0, $jVdlG.PanelType).INFO
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $45O09.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $53df13cea42d9a29$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($53df13cea42d9a29$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $bjg0G.findParentNode)((node)=>$53df13cea42d9a29$export$e58edb186cf54d62(node.type.name))(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode?.node.copy();
        const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? oldPanelNode?.node.type ?? schema.nodes.panel : schema.nodes.panel;
        const newPanelNode = panelNodeType.create({
            ...clonedPanelNode?.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $kCECX.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $53df13cea42d9a29$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $kCECX.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $bjg0G.findParentNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(newState.schema.nodes))(oldState.tr.selection);
    const isparentTypeDecision = (0, $bjg0G.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && isParentTypePanel?.node.childCount === 1 && (isparentTypeDecision?.node.childCount === 1 || isNodeTypeRuleOrCodeBlock));
};


function $0653049125c911cf$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $bjg0G.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $0653049125c911cf$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $0653049125c911cf$var$findParentNode(selection, nodeType);
    return parentNode && (0, $2w79Z.isEmptyNode)(schema)(parentNode);
}
function $0653049125c911cf$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup, extension: extension } = nodes;
            const panelNodeTypes = (0, $53df13cea42d9a29$export$24b1da61c87aac35)(nodes);
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType && (0, $53df13cea42d9a29$export$e58edb186cf54d62)(previousNodeType.name);
            const isParentNodeAPanel = (0, $53df13cea42d9a29$export$e58edb186cf54d62)(parentNodeType.name);
            const nodeBeforePanel = $previousPos?.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // identifies if new position after backspace is at the start of a non-bodied extension node
            const isPreviousPosAtExtension = $previousPos.nodeAfter?.type === extension;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel && !isPreviousPosAtExtension || panelNodeTypes.some((type)=>$0653049125c911cf$var$isInsideAnEmptyNode(selection, type, state.schema)) || (0, $bjg0G.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia && !isPreviousPosAtExtension || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel?.type?.spec?.isolating && (0, $bjg0G.hasParentNodeOfType)(panelNodeTypes)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $bjg0G.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (!(0, $53df13cea42d9a29$export$e58edb186cf54d62)(nodeType.name)) return false;
            return true;
        }
    };
    return (0, $44cyU.keymap)(keymaps);
}
var $0653049125c911cf$export$2e2bcd8739ae039 = $0653049125c911cf$export$e832373cff8dec22;






var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");







parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");














var $cozmU = parcelRequire("cozmU");


var $6OpMl = parcelRequire("6OpMl");





var $2DBsV = parcelRequire("2DBsV");

const $a6e94e2cea024cb0$var$EmojiNodeFunctional = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(23);
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    let t0;
    if ($[0] !== fallback || $[1] !== id || $[2] !== shortName) {
        t0 = {
            shortName: shortName,
            id: id,
            fallback: fallback
        };
        $[0] = fallback;
        $[1] = id;
        $[2] = shortName;
        $[3] = t0;
    } else t0 = $[3];
    const emojiId = t0;
    let t1;
    if ($[4] !== emojiProvider) {
        t1 = Promise.resolve(emojiProvider);
        $[4] = emojiProvider;
        $[5] = t1;
    } else t1 = $[5];
    const emojiProviderResolver = t1;
    const customFallback = (0, $iDrrr.fg)("platform_editor_custom_emoji_unicode_fallback") && !(0, $2DBsV.isSingleEmoji)(fallback || shortName) ? "\uFFFD" : undefined;
    if (allowTextFallback && !emojiProvider) {
        const t2 = fallback || shortName;
        const t3 = customFallback || fallback || shortName;
        let t4;
        if ($[6] !== id || $[7] !== shortName || $[8] !== t2 || $[9] !== t3) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": t2,
                children: t3
            });
            $[6] = id;
            $[7] = shortName;
            $[8] = t2;
            $[9] = t3;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
    if (!emojiProvider) return null;
    const t2 = emojiProviderResolver;
    let t3;
    if ($[11] !== fallback || $[12] !== id || $[13] !== resourceConfig?.optimisticImageApi || $[14] !== shortName) {
        t3 = resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        });
        $[11] = fallback;
        $[12] = id;
        $[13] = resourceConfig?.optimisticImageApi;
        $[14] = shortName;
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== customFallback || $[17] !== emojiId || $[18] !== fitToHeight || $[19] !== showTooltip || $[20] !== t2 || $[21] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6OpMl.default), {
            emojiId: emojiId,
            emojiProvider: t2,
            showTooltip: showTooltip,
            fitToHeight: fitToHeight,
            optimistic: true,
            customFallback: customFallback,
            optimisticImageURL: t3,
            editorEmoji: true,
            renderUnicodeEmojiAsImage: false
        });
        $[16] = customFallback;
        $[17] = emojiId;
        $[18] = fitToHeight;
        $[19] = showTooltip;
        $[20] = t2;
        $[21] = t3;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $cozmU.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $cozmU.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    const customFallback = (0, $iDrrr.fg)('platform_editor_custom_emoji_unicode_fallback') && !(0, $2DBsV.isSingleEmoji)(fallback || shortName) ? '\uFFFD' : undefined;
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        children: customFallback || fallback || shortName
    });
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6OpMl.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        customFallback: customFallback,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true,
        renderUnicodeEmojiAsImage: false
    });
};
const $a6e94e2cea024cb0$var$EmojiNode = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers } = t0;
    let t1;
    if ($[0] !== allowTextFallback || $[1] !== emojiProvider || $[2] !== fallback || $[3] !== fitToHeight || $[4] !== id || $[5] !== providers || $[6] !== resourceConfig || $[7] !== shortName || $[8] !== showTooltip) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a6e94e2cea024cb0$var$EmojiNodeFunctional, {
            allowTextFallback: allowTextFallback,
            shortName: shortName,
            id: id,
            fallback: fallback,
            fitToHeight: fitToHeight,
            showTooltip: showTooltip,
            resourceConfig: resourceConfig,
            emojiProvider: emojiProvider,
            providers: providers
        });
        $[0] = allowTextFallback;
        $[1] = emojiProvider;
        $[2] = fallback;
        $[3] = fitToHeight;
        $[4] = id;
        $[5] = providers;
        $[6] = resourceConfig;
        $[7] = shortName;
        $[8] = showTooltip;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($a6e94e2cea024cb0$var$EmojiNodeFunctional, {
        allowTextFallback: allowTextFallback,
        shortName: shortName,
        id: id,
        fallback: fallback,
        fitToHeight: fitToHeight,
        showTooltip: showTooltip,
        resourceConfig: resourceConfig,
        emojiProvider: emojiProvider,
        providers: providers
    });
};
const $a6e94e2cea024cb0$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($a6e94e2cea024cb0$var$EmojiNode);
var $a6e94e2cea024cb0$export$2e2bcd8739ae039 = $a6e94e2cea024cb0$var$_default_1;



var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");





var $aPdNQ = parcelRequire("aPdNQ");





var $dVbiN = parcelRequire("dVbiN");





// SVG path data extracted from panel icon components
const $2fed7b38d07e9fc1$var$PANEL_ICON_PATHS = {
    [(0, $jVdlG.PanelType).INFO]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z',
    [(0, $jVdlG.PanelType).NOTE]: 'M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z',
    [(0, $jVdlG.PanelType).SUCCESS]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z',
    [(0, $jVdlG.PanelType).WARNING]: 'M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z',
    [(0, $jVdlG.PanelType).ERROR]: 'M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z'
};
function $2fed7b38d07e9fc1$export$b4e58f62136fde82(panelType, container) {
    if (!panelType || !$2fed7b38d07e9fc1$var$PANEL_ICON_PATHS[panelType]) return null;
    const doc = container.ownerDocument;
    const svgNS = 'http://www.w3.org/2000/svg';
    // Create wrapper span (mimics PanelInfoIcon structure see editor-common/src/icons/shared/PanelInfoIcon.tsx)
    const span = doc.createElement('span');
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', `${panelType} panel`);
    // Create SVG element
    const svg = doc.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', svgNS);
    svg.setAttribute('role', 'presentation');
    svg.style.pointerEvents = 'none';
    // Create path element
    const path = doc.createElementNS(svgNS, 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute('d', $2fed7b38d07e9fc1$var$PANEL_ICON_PATHS[panelType]);
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    span.appendChild(svg);
    container.appendChild(span);
    return svg;
}


const $a2d4b5a427286cae$export$4641b622f6c36f58 = {
    info: (0, $f1UXy.PanelInfoIcon),
    success: (0, $f1UXy.PanelSuccessIcon),
    note: (0, $f1UXy.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))),
    warning: (0, $f1UXy.PanelWarningIcon),
    error: (0, $f1UXy.PanelErrorIcon),
    custom: (0, $f1UXy.PanelInfoIcon)
};
const $a2d4b5a427286cae$var$selector = (states)=>{
    return {
        emojiState: states.emojiState
    };
};
const $a2d4b5a427286cae$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const { emojiState: emojiState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'emoji'
    ], $a2d4b5a427286cae$var$selector);
    const emojiProvider = emojiState?.emojiProvider;
    if (allowCustomPanel && panelIcon && panelType === (0, $jVdlG.PanelType).CUSTOM) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a6e94e2cea024cb0$export$2e2bcd8739ae039), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $7Y8M5.akEditorCustomIconSize)
    });
    const Icon = $a2d4b5a427286cae$export$4641b622f6c36f58[panelType];
    return Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
        label: `${panelType} panel`
    }) : null;
};
class $a2d4b5a427286cae$var$PanelNodeView {
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
    destroy() {
        const panelAttrs = this.node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $jVdlG.PanelType).INFO,
            (0, $jVdlG.PanelType).NOTE,
            (0, $jVdlG.PanelType).SUCCESS,
            (0, $jVdlG.PanelType).WARNING,
            (0, $jVdlG.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // Only remove Portal if it was used (for custom emoji panels)
        if (!isStandardPanel) this.nodeViewPortalProviderAPI.remove(this.key);
    }
    constructor(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory){
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.providerFactory = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.pluginOptions = void 0;
        this.key = void 0;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.key = (0, $03RpJ.default)();
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $53df13cea42d9a29$export$4dbd81d91bb3604b)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.icon = this.dom.querySelector(`.${(0, $45O09.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        const panelAttrs = node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $jVdlG.PanelType).INFO,
            (0, $jVdlG.PanelType).NOTE,
            (0, $jVdlG.PanelType).SUCCESS,
            (0, $jVdlG.PanelType).WARNING,
            (0, $jVdlG.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // For standard panels (info, note, success, warning, error), render icon directly as native DOM
        // This avoids Portal rendering delays that cause flickering on SSR and page transitions
        if (isStandardPanel) (0, $2fed7b38d07e9fc1$export$b4e58f62136fde82)(panelAttrs.panelType, this.icon);
        else this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)($a2d4b5a427286cae$export$2ba98455e5e9d756, {
                pluginInjectionApi: api,
                allowCustomPanel: pluginOptions.allowCustomPanel,
                panelAttributes: panelAttrs,
                providerFactory: this.providerFactory
            }), this.icon, this.key);
    }
}
const $a2d4b5a427286cae$export$544c25cc15cdca2 = (pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)=>(node, view, getPos)=>{
        return new $a2d4b5a427286cae$var$PanelNodeView(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory);
    };





const $9ca011f9b0d77a22$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('panelPlugin');



const $fcdfc49b894c1d9d$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api, nodeViewPortalProviderAPI)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $9ca011f9b0d77a22$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $53df13cea42d9a29$export$1c3f791fb2a5168)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $a2d4b5a427286cae$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory),
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                    panel_c1: (0, $a2d4b5a427286cae$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)
                } : {}
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                'panel',
                'panel_c1'
            ] : [
                'panel'
            ], (target)=>!!target.closest(`.${(0, $45O09.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};





parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");











var $dVKvM = parcelRequire("dVKvM");


var $a1ZzW = parcelRequire("a1ZzW");




const $b14b76f6df90ebf6$var$NODE_NAME = 'panel';
const $b14b76f6df90ebf6$var$PanelBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(tr.selection.$from) : tr.doc.type.schema.nodes.panel;
            const command = api?.blockMenu?.commands.transformNode(panelNodeType, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $b14b76f6df90ebf6$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $5HBT9.messages).panel)
    });
};
const $b14b76f6df90ebf6$export$33a19cd537147781 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($b14b76f6df90ebf6$var$PanelBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};





parcelRequire("cozmU");








var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $3xwCI = parcelRequire("3xwCI");


var $icqAo = parcelRequire("icqAo");


var $i1agE = parcelRequire("i1agE");


var $iZMIZ = parcelRequire("iZMIZ");





var $iUgig = parcelRequire("iUgig");














var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


const $ff926929a7622be1$var$getPanelAttributes = (panelType)=>panelType === (0, $jVdlG.PanelType).CUSTOM ? {
        panelType: panelType,
        panelIcon: ':rainbow:',
        panelIconId: '1f308',
        panelIconText: "\uD83C\uDF08",
        // Custom panel color is stored in ADF, not applied as UI styling.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        panelColor: '#E6FCFF'
    } : {
        panelType: panelType
    };
const $ff926929a7622be1$export$2c24fd862570d204 = ({ api: api, description: description, icon: Icon, panelType: panelType, previewImageUrls: previewImageUrls, title: title })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>(0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
            api: api,
            attributes: $ff926929a7622be1$var$getPanelAttributes(panelType),
            inputMethod: source,
            state: editorView.state,
            typeAheadInsert: insert
        }), [
        api,
        panelType
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage(description),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(title)
    });
};


const $c17383943131fdf5$var$standardPanelItems = [
    {
        description: (0, $5HBT9.messages).infoPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))),
        keywords: [
            'panel'
        ],
        menuItem: (0, $dCkbP.INFO_PANEL_MENU_ITEM),
        panelType: (0, $jVdlG.PanelType).INFO,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKL.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHA.png'
        },
        title: (0, $5HBT9.messages).infoPanel
    },
    {
        description: (0, $5HBT9.messages).notePanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iUgig))),
        menuItem: (0, $dCkbP.NOTE_PANEL_MENU_ITEM),
        panelType: (0, $jVdlG.PanelType).NOTE,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKJ.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHB.png'
        },
        title: (0, $5HBT9.messages).notePanel
    },
    {
        description: (0, $5HBT9.messages).successPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))),
        keywords: [
            'tip'
        ],
        menuItem: (0, $dCkbP.SUCCESS_PANEL_MENU_ITEM),
        panelType: (0, $jVdlG.PanelType).SUCCESS,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKP.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH6.png'
        },
        title: (0, $5HBT9.messages).successPanel
    },
    {
        description: (0, $5HBT9.messages).warningPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i1agE))),
        menuItem: (0, $dCkbP.WARNING_PANEL_MENU_ITEM),
        panelType: (0, $jVdlG.PanelType).WARNING,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKO.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHC.png'
        },
        title: (0, $5HBT9.messages).warningPanel
    },
    {
        description: (0, $5HBT9.messages).errorPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($icqAo))),
        menuItem: (0, $dCkbP.ERROR_PANEL_MENU_ITEM),
        panelType: (0, $jVdlG.PanelType).ERROR,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKQ.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH1.png'
        },
        title: (0, $5HBT9.messages).errorPanel
    }
];
const $c17383943131fdf5$var$customPanelItem = {
    description: (0, $5HBT9.messages).customPanelDescription,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xwCI))),
    menuItem: (0, $dCkbP.CUSTOM_PANEL_MENU_ITEM),
    panelType: (0, $jVdlG.PanelType).CUSTOM,
    previewImageUrls: {
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKN.png',
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHD.png'
    },
    title: (0, $5HBT9.messages).customPanel
};
const $c17383943131fdf5$export$805344db6eac4db2 = ({ api: api, allowCustomPanel: allowCustomPanel, allowCustomPanelEdit: allowCustomPanelEdit })=>{
    const allPanelItems = [
        ...$c17383943131fdf5$var$standardPanelItems,
        ...allowCustomPanel && allowCustomPanelEdit ? [
            $c17383943131fdf5$var$customPanelItem
        ] : []
    ];
    return allPanelItems.map(({ description: description, icon: icon, keywords: keywords, menuItem: menuItem, panelType: panelType, previewImageUrls: previewImageUrls, title: title })=>({
            key: menuItem.key,
            type: menuItem.type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[menuItem.key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(description),
                    keywords: keywords,
                    title: formatMessage(title)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $ff926929a7622be1$export$2c24fd862570d204), {
                    api: api,
                    description: description,
                    icon: icon,
                    panelType: panelType,
                    previewImageUrls: previewImageUrls,
                    title: title
                })
        }));
};





parcelRequire("cozmU");








var $eEdSM = parcelRequire("eEdSM");


var $2xhuI = parcelRequire("2xhuI");

var $2DRge = parcelRequire("2DRge");





var $g6uqx = parcelRequire("g6uqx");


var $kQOs5 = parcelRequire("kQOs5");
const $ada50ba998f74379$export$4c05e6c3475702fb = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: "var(--ds-border, #0B120E24)"
    }));

const $a984700607f727e3$export$5e21fcae2a26e059 = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Subtle blue',
        value: '#DEEBFF'
    },
    {
        label: 'Subtle teal',
        value: '#E6FCFF'
    },
    {
        label: 'Subtle green',
        value: '#E3FCEF'
    },
    {
        label: 'Subtle lime',
        value: '#EFFFD6'
    },
    {
        label: 'Subtle yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Subtle orange',
        value: '#FFF5DB'
    },
    {
        label: 'Subtle red',
        value: '#FFEBE6'
    },
    {
        label: 'Subtle magenta',
        value: '#FFECF8'
    },
    {
        label: 'Subtle purple',
        value: '#EAE6FF'
    },
    {
        label: 'Gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Lime',
        value: '#D3F1A7'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Orange',
        value: '#FCE4A6'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Magenta',
        value: '#FDD0EC'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Bold gray',
        value: '#B7B9BE'
    },
    {
        label: 'Bold blue',
        value: '#ADCBFB'
    },
    {
        label: 'Bold teal',
        value: '#B1E4F7'
    },
    {
        label: 'Bold green',
        value: '#97EDC9'
    },
    {
        label: 'Bold lime',
        value: '#BDE97C'
    },
    {
        label: 'Bold yellow',
        value: '#EFDD4E'
    },
    {
        label: 'Bold orange',
        value: '#FBD779'
    },
    {
        label: 'Bold red',
        value: '#FFB8B2'
    },
    {
        label: 'Bold magenta',
        value: '#FCB6E1'
    },
    {
        label: 'Bold purple',
        value: '#E3BDFA'
    }
].map((color)=>({
        ...color,
        border: "var(--ds-border, #0B120E24)"
    }));









var $fHs3z = parcelRequire("fHs3z");


var $5avUB = parcelRequire("5avUB");


var $iDfTs = parcelRequire("iDfTs");


var $bAlk9 = parcelRequire("bAlk9");


var $iDtkd = parcelRequire("iDtkd");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");




















const $1167f0e0875411c4$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        const panelNodeTypes = (0, $53df13cea42d9a29$export$24b1da61c87aac35)(nodes);
        let deleteTr = tr;
        if ((0, $bjg0G.findSelectedNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $bjg0G.removeSelectedNode)(tr);
        else if ((0, $bjg0G.findParentNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $bjg0G.removeParentNodeOfType)(panelNodeTypes)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $1167f0e0875411c4$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
            if (panelNode === undefined) return false;
            const newType = panelType;
            const previousType = panelNode.node.attrs.panelType;
            let newTr;
            const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelNode.node.type : nodes.panel;
            if (allowCustomPanel) {
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $45O09.getPanelTypeBackgroundNoTokens)(previousType);
                const previousIcon = panelNode.node.attrs.panelIcon;
                const previousIconId = panelNode.node.attrs.panelIconId;
                const previousIconText = panelNode.node.attrs.panelIconText;
                const newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                panelType: panelType
            });
            const payload = {
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $kCECX.NodeSelection) && (0, $53df13cea42d9a29$export$e58edb186cf54d62)(state.selection.node.type.name) ? newTr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };













var $dPtk6 = parcelRequire("dPtk6");














const $42ac95b32e1cc263$var$panelTitleAndIcon = {
    [(0, $jVdlG.PanelType).INFO]: {
        title: (0, $2DRge.panelMessages).info,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz)))({
            label: 'info-icon',
            color: "var(--ds-icon-information, #357DE8)"
        })
    },
    [(0, $jVdlG.PanelType).NOTE]: {
        title: (0, $2DRge.panelMessages).note,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDtkd)))({
            label: 'note-icon',
            color: "var(--ds-icon-discovery, #AF59E1)"
        })
    },
    [(0, $jVdlG.PanelType).SUCCESS]: {
        title: (0, $2DRge.panelMessages).success,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R)))({
            label: 'success-icon',
            color: "var(--ds-icon-success, #6A9A23)"
        })
    },
    [(0, $jVdlG.PanelType).WARNING]: {
        title: (0, $2DRge.panelMessages).warning,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1)))({
            label: 'warning-icon',
            color: "var(--ds-icon-warning, #E06C00)"
        })
    },
    [(0, $jVdlG.PanelType).ERROR]: {
        title: (0, $2DRge.panelMessages).error,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5avUB)))({
            label: 'error-icon',
            color: "var(--ds-icon-danger, #C9372C)"
        })
    },
    [(0, $jVdlG.PanelType).CUSTOM]: {
        title: (0, $2DRge.panelMessages).custom,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6)))({
            label: 'custom-icon'
        })
    }
};
const $42ac95b32e1cc263$export$b79ba0272604ac1c = ({ activePanelType: activePanelType, editorAnalyticsAPI: editorAnalyticsAPI, formatMessage: formatMessage })=>{
    const dropdownOptions = [
        {
            id: 'editor.panel.info',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).INFO].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).INFO),
            selected: activePanelType === (0, $jVdlG.PanelType).INFO,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).INFO].title)
        },
        {
            id: 'editor.panel.note',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).NOTE].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).NOTE),
            selected: activePanelType === (0, $jVdlG.PanelType).NOTE,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).NOTE].title)
        },
        {
            id: 'editor.panel.success',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).SUCCESS].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).SUCCESS),
            selected: activePanelType === (0, $jVdlG.PanelType).SUCCESS,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).SUCCESS].title)
        },
        {
            id: 'editor.panel.warning',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).WARNING].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).WARNING),
            selected: activePanelType === (0, $jVdlG.PanelType).WARNING,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).WARNING].title)
        },
        {
            id: 'editor.panel.error',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).ERROR].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).ERROR),
            selected: activePanelType === (0, $jVdlG.PanelType).ERROR,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).ERROR].title)
        }
    ];
    const selectedPanelType = activePanelType || (0, $jVdlG.PanelType).INFO;
    const selectedTitleAndIcon = $42ac95b32e1cc263$var$panelTitleAndIcon[selectedPanelType] || $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).CUSTOM];
    return {
        id: 'panel-type-dropdown',
        testId: 'panel-type-dropdown-trigger',
        type: 'dropdown',
        options: dropdownOptions,
        showSelected: true,
        iconBefore: ()=>selectedTitleAndIcon.icon,
        title: formatMessage(selectedTitleAndIcon.title)
    };
};


const $9daf5d2579659285$export$f17692e562e3afad = {
    [(0, $jVdlG.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $jVdlG.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $jVdlG.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $jVdlG.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $jVdlG.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $jVdlG.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $9daf5d2579659285$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state, api)=>{
    const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // TODO: ED-14403 - investigate why these titles are not getting translated for the tooltips
    const items = areAllNewToolbarFlagsDisabled ? [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).INFO),
            selected: activePanelType === (0, $jVdlG.PanelType).INFO,
            title: formatMessage((0, $2DRge.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDtkd))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).NOTE),
            selected: activePanelType === (0, $jVdlG.PanelType).NOTE,
            title: formatMessage((0, $2DRge.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).SUCCESS),
            selected: activePanelType === (0, $jVdlG.PanelType).SUCCESS,
            title: formatMessage((0, $2DRge.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).WARNING),
            selected: activePanelType === (0, $jVdlG.PanelType).WARNING,
            title: formatMessage((0, $2DRge.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5avUB))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).ERROR),
            selected: activePanelType === (0, $jVdlG.PanelType).ERROR,
            title: formatMessage((0, $2DRge.panelMessages).error),
            tabIndex: null
        }
    ] : [
        (0, $42ac95b32e1cc263$export$b79ba0272604ac1c)({
            activePanelType: activePanelType,
            editorAnalyticsAPI: editorAnalyticsAPI,
            formatMessage: formatMessage
        }),
        ...Boolean(api?.toolbar) ? [] : [
            {
                type: 'separator'
            }
        ]
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $45O09.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $9daf5d2579659285$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $krYZG.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $krYZG.ACTION).CHANGED_ICON,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (activePanelType === (0, $jVdlG.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $krYZG.ACTION).REMOVE_ICON,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $jVdlG.PanelType).CUSTOM ? activePanelColor || (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).INFO) : (0, $45O09.getPanelTypeBackgroundNoTokens)(activePanelType);
        const isNewPanelPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
        const colorPalette = isNewPanelPaletteEnabled ? (0, $a984700607f727e3$export$5e21fcae2a26e059) : (0, $ada50ba998f74379$export$4c05e6c3475702fb);
        const defaultPalette = colorPalette.find((item)=>item.value === panelColor) || {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Custom',
            value: panelColor,
            border: (0, $kQOs5.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $2DRge.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: colorPalette,
                cols: isNewPanelPaletteEnabled ? 10 : undefined,
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $2DRge.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $jVdlG.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAlk9))), {
                        spacing: 'spacious',
                        label: ''
                    }),
                onClick: removeEmoji(),
                title: formatMessage((0, $2xhuI.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (areAllNewToolbarFlagsDisabled) {
        if (state) {
            items.push({
                type: 'separator'
            });
            items.push({
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: formatMessage,
                        nodeType: panelNodeType
                    }
                ]
            });
        }
        items.push({
            type: 'separator'
        }, {
            id: 'editor.panel.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    spacing: 'spacious',
                    label: ''
                }),
            onClick: (0, $1167f0e0875411c4$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration?.(panelNodeType, true),
            onMouseLeave: hoverDecoration?.(panelNodeType, false),
            onFocus: hoverDecoration?.(panelNodeType, true),
            onBlur: hoverDecoration?.(panelNodeType, false),
            title: formatMessage((0, $2xhuI.default).remove),
            tabIndex: null
        });
    } else {
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'panel-overflow-dropdown-trigger';
        const overflowMenuConfig = [
            {
                type: 'separator',
                fullHeight: true
            },
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: formatMessage((0, $2xhuI.default).copyToClipboard),
                        onClick: ()=>{
                            api?.core?.actions.execute(// @ts-ignore
                            api?.floatingToolbar?.commands.copyNode(panelNodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
                    },
                    {
                        title: formatMessage((0, $2xhuI.default).delete),
                        onClick: (0, $1167f0e0875411c4$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
                        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    return items;
};
const $9daf5d2579659285$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
    if (panelObject) {
        const nodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelObject.node.type : state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $jVdlG.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $9daf5d2579659285$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api?.decorations?.actions.hoverDecoration, api?.analytics?.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state, (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? api : undefined);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $bjg0G.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $2DRge.panelMessages).panelsGroup)
        };
    }
    return;
};


const $de4ab4eb6d060862$var$PANEL_NODE_NAME = 'panel';
const $de4ab4eb6d060862$var$panelPlugin = ({ config: { allowCustomPanel: allowCustomPanel = false, allowCustomPanelEdit: allowCustomPanelEdit = false } = {}, api: api })=>{
    api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]
            },
            component: (0, $b14b76f6df90ebf6$export$33a19cd537147781)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($de4ab4eb6d060862$var$PANEL_NODE_NAME))
        }
    ]);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $c17383943131fdf5$export$805344db6eac4db2)({
        allowCustomPanel: allowCustomPanel,
        allowCustomPanelEdit: allowCustomPanelEdit,
        api: api
    }));
    return {
        name: 'panel',
        nodes () {
            if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) return [
                {
                    name: 'panel',
                    node: {
                        ...(0, $aIF2y.extendedPanelWithLocalId)(!!allowCustomPanel),
                        definingAsContext: true
                    }
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: {
                            ...(0, $i6nlo.extendedPanelC1WithLocalId)(!!allowCustomPanel),
                            definingAsContext: true
                        }
                    }
                ] : []
            ];
            return [
                {
                    name: 'panel',
                    node: (0, $7XIUO.extendedPanel)(!!allowCustomPanel)
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: (0, $7Tmz1.extendedPanelC1)(!!allowCustomPanel)
                    }
                ] : []
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $fcdfc49b894c1d9d$export$ae829ec7b2625219)(dispatch, providerFactory, {
                            allowCustomPanel: allowCustomPanel,
                            allowCustomPanelEdit: allowCustomPanelEdit
                        }, api, nodeViewPortalProviderAPI)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $0653049125c911cf$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                return function(state, dispatch) {
                    const tr = (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                        state: state,
                        attributes: {
                            panelType: (0, $jVdlG.PanelType).INFO
                        },
                        api: api,
                        inputMethod: inputMethod
                    });
                    if (!tr) return false;
                    if (dispatch) dispatch(tr);
                    return true;
                };
            }
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertOptions = [
                        {
                            id: 'infopanel',
                            title: formatMessage((0, $5HBT9.messages).infoPanel),
                            keywords: [
                                'panel'
                            ],
                            description: formatMessage((0, $5HBT9.messages).infoPanelDescription),
                            priority: 800,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconPanel), {}),
                            action (typeAheadInsert, state) {
                                return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $jVdlG.PanelType).INFO
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'notepanel',
                            title: formatMessage((0, $5HBT9.messages).notePanel),
                            description: formatMessage((0, $5HBT9.messages).notePanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconPanelNote), {}),
                            action (typeAheadInsert, state) {
                                return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $jVdlG.PanelType).NOTE
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'successpanel',
                            title: formatMessage((0, $5HBT9.messages).successPanel),
                            description: formatMessage((0, $5HBT9.messages).successPanelDescription),
                            keywords: [
                                'tip'
                            ],
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconPanelSuccess), {}),
                            action (typeAheadInsert, state) {
                                return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $jVdlG.PanelType).SUCCESS
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'warningpanel',
                            title: formatMessage((0, $5HBT9.messages).warningPanel),
                            description: formatMessage((0, $5HBT9.messages).warningPanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconPanelWarning), {}),
                            action (typeAheadInsert, state) {
                                return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $jVdlG.PanelType).WARNING
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'errorpanel',
                            title: formatMessage((0, $5HBT9.messages).errorPanel),
                            description: formatMessage((0, $5HBT9.messages).errorPanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconPanelError), {}),
                            action (typeAheadInsert, state) {
                                return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $jVdlG.PanelType).ERROR
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        }
                    ];
                    if (allowCustomPanel && allowCustomPanelEdit) quickInsertOptions.push({
                        id: 'custompanel',
                        title: formatMessage((0, $5HBT9.messages).customPanel),
                        description: formatMessage((0, $5HBT9.messages).customPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $0bd0a15a02ed16c1$export$2e2bcd8739ae039), {}),
                        action (typeAheadInsert, state) {
                            return (0, $f6f8e68e864361ee$export$80e77a5be96b2b61)({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).CUSTOM,
                                    panelIcon: ':rainbow:',
                                    panelIconId: '1f308',
                                    panelIconText: "\uD83C\uDF08",
                                    // Ignored via go/ees007
                                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                                    // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                    panelColor: '#E6FCFF'
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    });
                    return quickInsertOptions;
                }
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $9daf5d2579659285$export$86ce8f8241c20a3)(state, intl, {
                    allowCustomPanel: allowCustomPanel,
                    allowCustomPanelEdit: allowCustomPanelEdit
                }, providerFactory, api)
        }
    };
};
var $de4ab4eb6d060862$export$2e2bcd8739ae039 = $de4ab4eb6d060862$var$panelPlugin;
module.exports["default"] = $de4ab4eb6d060862$export$2e2bcd8739ae039;

});

parcelRegister("4Bdub", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $mW7G5 = parcelRequire("mW7G5");


var $krYZG = parcelRequire("krYZG");

var $fAWGo = parcelRequire("fAWGo");


var $eEdSM = parcelRequire("eEdSM");

var $a576dcc6a24ebd21$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
    return PastePluginActionTypes;
}({});



var $cI8RZ = parcelRequire("cI8RZ");



var $kCECX = parcelRequire("kCECX");

const $fda2da217123fc9d$export$2b71482310d8c520 = new (0, $kCECX.PluginKey)('paste-options');
var $fda2da217123fc9d$export$ec4e67a10e59fca = /*#__PURE__*/ function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
    return ToolbarDropdownOption;
}({});


const $feee454b9de5f38d$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $feee454b9de5f38d$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $feee454b9de5f38d$export$78dda1ebb9a1ea84 = 'text-highlight';
const $feee454b9de5f38d$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $feee454b9de5f38d$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $feee454b9de5f38d$export$220f0307408bc0c = 'akEditor';
const $feee454b9de5f38d$export$299d35c5583816ad = 'paste-options-testid';
const $feee454b9de5f38d$export$d1234a98f427930 = 'paste-options$';
const $feee454b9de5f38d$export$b7100f42dfe6c945 = 8;
const $feee454b9de5f38d$export$6b0e62d36c2a26b4 = 24;



const $63429698745499e9$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                showLegacyOptions: action.data.showLegacyOptions,
                pasteAncestorNodeNames: action.data.pasteAncestorNodeNames,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};


const $4f5b30d8bf5b9b95$var$dest = (0, $cI8RZ.pluginFactory)((0, $fda2da217123fc9d$export$2b71482310d8c520), (0, $63429698745499e9$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($4f5b30d8bf5b9b95$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $4f5b30d8bf5b9b95$export$656c7661095efe2e = $4f5b30d8bf5b9b95$var$dest.createPluginState;
const $4f5b30d8bf5b9b95$export$8d4021544bdece00 = $4f5b30d8bf5b9b95$var$dest.createCommand;
const $4f5b30d8bf5b9b95$export$f05434c51e3762e = $4f5b30d8bf5b9b95$var$dest.getPluginState;
const $4f5b30d8bf5b9b95$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $feee454b9de5f38d$export$d1234a98f427930));
    if (meta && meta.type === (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT) return true;
    return false;
};



var $6gBg9 = parcelRequire("6gBg9");


var $jv11C = parcelRequire("jv11C");


var $h6b2D = parcelRequire("h6b2D");


var $c9zHD = parcelRequire("c9zHD");


var $aPdNQ = parcelRequire("aPdNQ");





var $eOaGc = parcelRequire("eOaGc");


var $4o0zT = parcelRequire("4o0zT");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3c979cd9cda14083$var$ESCAPE_LINKS_URL_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/;
function $3c979cd9cda14083$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $3c979cd9cda14083$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        return str.match($3c979cd9cda14083$var$ESCAPE_LINKS_URL_REGEX) ? `<${str}>` : str;
    });
}
const $3c979cd9cda14083$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $3c979cd9cda14083$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $3c979cd9cda14083$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        const marks = node.marks?.map((mark)=>mark.type.name);
        hasLinkMark = marks?.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1ec7a1cc42b08d91$var$CODE_BLOCK_FENCE_REGEX = /```/;
const $1ec7a1cc42b08d91$export$f9baf8679201c53f = (tr, pluginState, markdownToPmConverter)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $1ec7a1cc42b08d91$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection, markdownToPmConverter);
    if (!markdownSlice) return tr;
    $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $1ec7a1cc42b08d91$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $1ec7a1cc42b08d91$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $1ec7a1cc42b08d91$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $aPdNQ.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $aPdNQ.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eOaGc.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode?.type.createAndFill();
    const isLastNodeEmpty = emptyNodeReference?.nodeSize === lastInsertNode?.nodeSize;
    const isStepSplitingTarget = !lastInsertNode?.isLeaf && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kCECX.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1ec7a1cc42b08d91$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eOaGc.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1ec7a1cc42b08d91$export$3f1f93abf0f3a57(text, schema, selection, markdownToPmConverter) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        let textInput = text;
        const textSplitByCodeBlock = textInput.split($1ec7a1cc42b08d91$var$CODE_BLOCK_FENCE_REGEX);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const doc = markdownToPmConverter && (0, $4o0zT.isExperimentEnabled)('platform_editor_paste_as_md_use_gfm') ? schema.nodes.doc.createAndFill({}, markdownToPmConverter({
            markdown: textInput,
            schema: schema
        })) : new (0, $c9zHD.MarkdownTransformer)(schema, (0, $h6b2D.md)).parse((0, $3c979cd9cda14083$export$8acd10161c5f8b07)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === doc.content.firstChild?.type;
        const canMergeOpenEnd = targetOpenEndNode.type === doc.content.lastChild?.type;
        const $start = (0, $kCECX.Selection).atStart(doc).$from;
        const $end = (0, $kCECX.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return (0, $6gBg9.normalizeMarkdownCodeBlockAttrsInSlice)(new (0, $aPdNQ.Slice)(doc.content, openStart, openEnd), schema);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}



const $d4c269fd41087652$export$1ad95a504fba561e = (lastContentPasted, selectedOption, showLegacyOptions = true, pasteAncestorNodeNames = [])=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text ?? '',
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos,
                showLegacyOptions: showLegacyOptions,
                pasteAncestorNodeNames: pasteAncestorNodeNames
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText) return tr;
        return (0, $1ec7a1cc42b08d91$export$60ca0c8603a51ef1)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, plaintextTransformer);
};
const $d4c269fd41087652$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize, invokedFrom)=>()=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).PASTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                type: (0, $fAWGo.PasteTypes).plain,
                content: (0, $fAWGo.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($d4c269fd41087652$export$ff80cd8c68a7a6ad());
    };
const $d4c269fd41087652$export$405f0689dadde83d = ()=>{
    return $d4c269fd41087652$export$3367fb592cb1ac64();
};
const $d4c269fd41087652$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText) return tr;
        return (0, $1ec7a1cc42b08d91$export$da9c2ff7c79a9eab)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, transformer);
};
const $d4c269fd41087652$export$849d50d444ed50f8 = (editorAnalyticsAPI, invokedFrom)=>()=>{
        const payloadCallback = (state)=>{
            const pastePluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
            return {
                action: (0, $krYZG.ACTION).PASTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                    type: (0, $fAWGo.PasteTypes).richText,
                    content: (0, $fAWGo.PasteContents).text,
                    pasteSize: pastePluginState.richTextSlice?.size || 0,
                    invokedFrom: invokedFrom
                }
            };
        };
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payloadCallback)($d4c269fd41087652$export$50a682c7628ffa4e());
    };
const $d4c269fd41087652$export$f22e171f994ad9d1 = (markdownToPmConverter)=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown) return tr;
        return (0, $1ec7a1cc42b08d91$export$f9baf8679201c53f)(tr, pluginState, markdownToPmConverter);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, markdownTransformer);
};
const $d4c269fd41087652$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize, invokedFrom, markdownToPmConverter)=>()=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).PASTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                type: (0, $fAWGo.PasteTypes).markdown,
                content: (0, $fAWGo.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($d4c269fd41087652$export$f22e171f994ad9d1(markdownToPmConverter));
    };
const $d4c269fd41087652$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$70777665aad0464c = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(view.state);
    if (pluginState.showToolbar) $d4c269fd41087652$export$70777665aad0464c()(view.state, view.dispatch);
};



var $kpCD8 = parcelRequire("kpCD8");





var $8nvEM = parcelRequire("8nvEM");





const $7e1bf35df5b7b5d8$var$MODIFIER_KEYS = new Set([
    'Shift',
    'Control',
    'Alt',
    'Meta',
    // Cmd on Mac, Win on Windows
    'CapsLock',
    'NumLock',
    'ScrollLock',
    'Fn',
    'FnLock'
]);
function $7e1bf35df5b7b5d8$var$isModifierKey(event) {
    return $7e1bf35df5b7b5d8$var$MODIFIER_KEYS.has(event.key);
}
function $7e1bf35df5b7b5d8$export$ae829ec7b2625219(dispatch, options) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $fda2da217123fc9d$export$2b71482310d8c520),
        state: (0, $4f5b30d8bf5b9b95$export$656c7661095efe2e)(dispatch, {
            showToolbar: false,
            showLegacyOptions: false,
            pasteAncestorNodeNames: [],
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $8nvEM.DecorationSet).empty,
            richTextSlice: (0, $aPdNQ.Slice).empty,
            selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None
        }),
        view (_editorView) {
            return {
                update (_view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                blur: (view)=>{
                    if (options?.useNewPasteMenu) return false;
                    (0, $d4c269fd41087652$export$8b65e7aad6163588)(view);
                    return false;
                },
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $d4c269fd41087652$export$8b65e7aad6163588)
            },
            handleKeyDown: (view, event)=>{
                // Don't hide toolbar when pressing modifier keys alone (Ctrl, Shift, Alt, Meta/Cmd)
                if ($7e1bf35df5b7b5d8$var$isModifierKey(event)) return false;
                (0, $d4c269fd41087652$export$8b65e7aad6163588)(view);
                return false;
            },
            decorations: (state)=>{
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state) || {};
                const decorationSet = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state)?.highlightDecorationSet ?? (0, $8nvEM.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $8nvEM.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $feee454b9de5f38d$export$78dda1ebb9a1ea84)
                }, {
                    key: (0, $feee454b9de5f38d$export$d829547aa567b0f1)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}






const $29282488bd260ae9$var$hasTableNode = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};
const $29282488bd260ae9$var$isNotProse = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};
const $29282488bd260ae9$export$899f54ccaa7b18cb = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ($29282488bd260ae9$var$isNotProse(pastedText)) return;
    if ($29282488bd260ae9$var$hasTableNode(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $mW7G5.expVal)('platform_editor_paste_actions_menu', 'isEnabled', false);
    } catch  {
        // pasteStartPos may be out of bounds if the document changed between
        // when the paste was recorded and when this effect fires.
        return;
    }
};


// Remove this file when experiment `confluence_editor_paste_3p_link_actions_menu` is cleaned up.




var $aKpkp = parcelRequire("aKpkp");

const $cff27d0b60b42bfa$export$53261c09932390d5 = (pastedSlice)=>{
    if ((0, $aKpkp.isNotSingleLink)(pastedSlice)) return;
    (0, $mW7G5.expVal)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', false);
};


// Remove this file when experiment 'platform_editor_paste_actions_menu_v2' is cleaned up.



const $ccabb917a6ff0a8f$export$44b7f57aaef7c0af = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};


const $6b89ac4b3810071f$export$71535a792a9ee562 = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};


const $471bf21fb11fd74a$export$3bc247e6ff3a4c32 = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ((0, $6b89ac4b3810071f$export$71535a792a9ee562)(pastedText)) return;
    if ((0, $ccabb917a6ff0a8f$export$44b7f57aaef7c0af)(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $mW7G5.expVal)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    } catch  {
        return;
    }
};















var $3nacY = parcelRequire("3nacY");

var $bFSJa = parcelRequire("bFSJa");


var $1jz5K = parcelRequire("1jz5K");

var $7XIuB = parcelRequire("7XIuB");


var $9Muxb = parcelRequire("9Muxb");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kwf4Z = parcelRequire("kwf4Z");








var $3IBFJ = parcelRequire("3IBFJ");





var $GErjr = parcelRequire("GErjr");








const $80d2dc5ef3c83ccc$var$TOP_LEVEL_LIST_NODE_NAMES = [
    'bulletList',
    'orderedList',
    'taskList'
];
/**
 * Pasting markdown lists leaves the cursor at doc > list > listItem > paragraph, so the
 * immediate grandparent is a listItem rather than the doc and the paste options are never
 * offered. Treat a list that is itself a direct child of the doc as top level, while still
 * excluding lists nested in other containers such as tables and panels.
 */ const $80d2dc5ef3c83ccc$var$isInsideTopLevelList = ($from)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_markdown_conversion_improvements')) return false;
    if ($from.depth < 1) return false;
    return $80d2dc5ef3c83ccc$var$TOP_LEVEL_LIST_NODE_NAMES.includes($from.node(1).type.name);
};
const $80d2dc5ef3c83ccc$export$208ad7410c805534 = (state, lastContentPasted)=>{
    /**
   * Conditions for not showing the toolbar:
   * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
   * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
   *    (grandParent node should be root doc for showing up the toolbar)
   * 3. Cursor is inside the codeblock.
   */ const $from = state.selection.$from;
    if ((0, $3c979cd9cda14083$export$ec154944314bb7c)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = $from.parent?.type;
    const grandParentNodeType = $from.node($from.depth - 1)?.type;
    if ((grandParentNodeType?.name === state.schema.nodes.doc.name || $80d2dc5ef3c83ccc$var$isInsideTopLevelList($from)) && parentNodeType.name !== state.schema.nodes.codeBlock?.name && !(0, $3c979cd9cda14083$export$6c3620a9f018c4e)(lastContentPasted.pasteSource) && !(0, $3c979cd9cda14083$export$2d7feffd198c797d)(lastContentPasted.pastedSlice) && !(0, $3c979cd9cda14083$export$e7b0e22080760bf0)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $80d2dc5ef3c83ccc$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI, markdownToPmConverter)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $d4c269fd41087652$export$849d50d444ed50f8)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown,
            onClick: (0, $d4c269fd41087652$export$a1a13c805bf0cea1)(editorAnalyticsAPI, pluginState.plaintext.length, undefined, markdownToPmConverter)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText,
            onClick: (0, $d4c269fd41087652$export$c833704cd36ac295)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $feee454b9de5f38d$export$af443436fa5992cb),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($GErjr))),
        type: 'dropdown',
        testId: (0, $feee454b9de5f38d$export$299d35c5583816ad),
        title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $80d2dc5ef3c83ccc$var$onToggleHandler
    };
};
const $80d2dc5ef3c83ccc$var$onToggleHandler = (state, dispatch)=>{
    return (0, $d4c269fd41087652$export$405f0689dadde83d)()(state, dispatch);
};
const $80d2dc5ef3c83ccc$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI, markdownToPmConverter)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
    const menu = $80d2dc5ef3c83ccc$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI, markdownToPmConverter);
    return {
        title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        className: (0, $feee454b9de5f38d$export$164821e1c3d789fd),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $80d2dc5ef3c83ccc$var$onPositionCalculated
    };
};
const $80d2dc5ef3c83ccc$var$onPositionCalculated = (editorView, _nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="${(0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = toolbar?.offsetParent || editorView.dom;
    const offsetParentRect = offsetParent?.getBoundingClientRect();
    const offsetTop = offsetParentRect?.top || 0;
    const offsetLeft = offsetParentRect?.left || 0;
    const offsetScrollTop = offsetParent?.scrollTop || 0;
    const cursorHeight = $80d2dc5ef3c83ccc$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $80d2dc5ef3c83ccc$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = nodeAtFrom?.nodeType === Node.TEXT_NODE ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom.parentNode : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};





const $af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden = (component, componentsByKey)=>{
    if (component.isHidden?.()) return true;
    return (component.parents ?? []).some((parent)=>{
        const parentComponent = componentsByKey.get(parent.key);
        return parentComponent ? $af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden(parentComponent, componentsByKey) : false;
    });
};
const $af7ce99f0a6e1d0c$export$99cddee748d62c45 = (components, types = [
    'menu-item'
])=>{
    const componentsByKey = new Map(components.map((c)=>[
            c.key,
            c
        ]));
    return components.filter((c)=>types.includes(c.type)).filter((c)=>!$af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden(c, componentsByKey)).map((c)=>c.key);
};
const $af7ce99f0a6e1d0c$export$159affd63ddd230e = (components)=>{
    return $af7ce99f0a6e1d0c$export$99cddee748d62c45(components).length > 0;
};


/* PasteActionsMenuContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $uyXFl = parcelRequire("uyXFl");


var $dQrHJ = parcelRequire("dQrHJ");


var $dQMlg = parcelRequire("dQMlg");





var $iMnC5 = parcelRequire("iMnC5");


var $cVdVi = parcelRequire("cVdVi");

const $f6633e8b9d56106e$export$d62a1f704dc41529 = 3000;
const $f6633e8b9d56106e$var$hasAsyncHidden = (component)=>typeof component.isAsyncHidden === 'function';
const $f6633e8b9d56106e$var$rejectOnTimeout = (promise, timeoutMs)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new Error('isAsyncHidden timeout')), timeoutMs);
    });
    return Promise.race([
        promise.finally(()=>{
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }),
        timeoutPromise
    ]);
};
const $f6633e8b9d56106e$var$evaluateComponentAsyncHidden = async (component, context)=>{
    try {
        const hidden = await $f6633e8b9d56106e$var$rejectOnTimeout(component.isAsyncHidden(context), $f6633e8b9d56106e$export$d62a1f704dc41529);
        return {
            key: component.key,
            hidden: hidden
        };
    } catch  {
        return {
            key: component.key,
            hidden: true
        };
    }
};
async function $f6633e8b9d56106e$export$1e23d15f3989d9b2(components, context) {
    const results = await Promise.all(components.filter($f6633e8b9d56106e$var$hasAsyncHidden).map((component)=>$f6633e8b9d56106e$var$evaluateComponentAsyncHidden(component, context)));
    return Object.fromEntries(results.map(({ key: key, hidden: hidden })=>[
            key,
            hidden
        ]));
}


const $a2f1cb9d719e236e$var$styles = {
    container: "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v"
};
const $a2f1cb9d719e236e$var$pasteMenuSurface = {
    type: (0, $3nacY.PASTE_MENU).type,
    key: (0, $3nacY.PASTE_MENU).key
};
const $a2f1cb9d719e236e$export$41585964872b7c = ({ onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, components: components, contentRef: contentRef, pastedSlice: pastedSlice })=>{
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext)); // Extract the pasted URL (if the pasted content was a single smart link).
    // Uses the reactive pasted slice from the paste plugin state so pastedUrl
    // updates when paste state changes.
    const pastedUrl = (0, $cVdVi.getSingleSmartLinkUrlFromSlice)(pastedSlice); // Components with isAsyncHidden are hidden until the async check resolves.
    // This prevents flash-of-visible content for items that
    // should ultimately be hidden. A generation counter discards stale results.
    const [asyncHiddenResults, setAsyncHiddenResults] = (0, $cozmU.useState)(()=>{
        return Object.fromEntries(components.map((component)=>[
                component.key,
                true
            ]));
    });
    const generationRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const asyncComponents = [];
        for (const component of components)if (typeof component.isAsyncHidden === 'function') asyncComponents.push(component);
        if (asyncComponents.length === 0) {
            setAsyncHiddenResults({});
            return;
        } // Reset: mark all async components as hidden until this round resolves.
        const pending = {};
        for (const c of asyncComponents)pending[c.key] = true;
        setAsyncHiddenResults(pending);
        const generation = ++generationRef.current;
        const context = {
            pastedUrl: pastedUrl
        };
        (0, $f6633e8b9d56106e$export$1e23d15f3989d9b2)(asyncComponents, context).then((results)=>{
            // Discard if a newer effect has already started.
            if (generation === generationRef.current) setAsyncHiddenResults(results);
        });
    }, [
        components,
        pastedUrl
    ]);
    // SurfaceRenderer evaluates isHidden() itself on each component. Override
    // isHidden on async components so SurfaceRenderer sees the resolved value.
    const visibleComponents = components.map((component)=>{
        if (typeof component.isAsyncHidden !== 'function') // No async check — pass through unchanged.
        return component;
        const asyncResult = asyncHiddenResults[component.key];
        return {
            ...component,
            isHidden: ()=>{
                return asyncResult === true || Boolean(component.isHidden?.());
            }
        };
    });
    const mergedRef = (0, $cozmU.useCallback)((node)=>{
        setOutsideClickTargetRef?.(node);
        if (contentRef) contentRef.current = node;
    }, [
        setOutsideClickTargetRef,
        contentRef
    ]);
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_menu_radius_update')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQrHJ.ToolbarMenuContainer), {
        ref: mergedRef,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQMlg.SurfaceRenderer), {
            surface: $a2f1cb9d719e236e$var$pasteMenuSurface,
            components: visibleComponents
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        ref: mergedRef,
        xcss: $a2f1cb9d719e236e$var$styles.container,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dQMlg.SurfaceRenderer), {
            surface: $a2f1cb9d719e236e$var$pasteMenuSurface,
            components: visibleComponents
        })
    });
};


const $af9b39dbd0229b2c$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $af9b39dbd0229b2c$var$isAgentMentionUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $af9b39dbd0229b2c$export$3d56f604f007aa63 = (slice)=>{
    if (!slice) return false;
    let hasAgentMention = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'mention' && $af9b39dbd0229b2c$var$isAgentMentionUserType(node.attrs.userType)) hasAgentMention = true;
    });
    return hasAgentMention;
};
const $af9b39dbd0229b2c$export$fa38ccb7191f761d = (slice)=>(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $af9b39dbd0229b2c$export$3d56f604f007aa63(slice);
const $af9b39dbd0229b2c$export$6b1ad80f8062f971 = (slice)=>(0, $mW7G5.expVal)('platform_editor_fix_link_paste_menu', 'isEnabled', false) && !(0, $aKpkp.isNotSingleLink)(slice ?? undefined);
function $af9b39dbd0229b2c$export$2562999169740ceb(editorView, pos) {
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(pos, editorView.domAtPos.bind(editorView));
        if (domRef instanceof HTMLElement) {
            // Empty blocks render a <br> placeholder whose bounding rect has no
            // meaningful dimensions (height ≈ 0). Using it as the Popup anchor
            // causes the menu to appear at an unexpected position. Walk up to the
            // parent block element so the Popup anchors correctly.
            if (domRef.nodeName === 'BR' && domRef.parentElement) return domRef.parentElement;
            return domRef;
        }
        return null;
    } catch  {
        return null;
    }
}
function $af9b39dbd0229b2c$export$203646a3dfbc94aa(editorView, pos) {
    const $pos = editorView.state.doc.resolve(pos);
    for(let depth = $pos.depth; depth > 0; depth--){
        if ($pos.node(depth).type.name === 'table') return $pos.after(depth);
    }
    return undefined;
}
function $af9b39dbd0229b2c$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos) {
    const endCoords = editorView.coordsAtPos(pasteEndPos);
    let bottom = endCoords.bottom;
    if (tableAfterPos !== undefined) {
        const afterCoords = editorView.coordsAtPos(tableAfterPos);
        bottom = Math.max(bottom, afterCoords.bottom);
    }
    return bottom;
}
function $af9b39dbd0229b2c$export$69f2182d2b29f39f(editorView, pos) {
    try {
        const $pos = editorView.state.doc.resolve(pos);
        // Walk up the document tree from the resolved position's innermost
        // node towards the root. $pos.node(depth) gives the ancestor at each
        // depth; $pos.start(depth) gives the position just inside that ancestor,
        // so `$pos.start(depth) - 1` is the position of the ancestor node itself
        // (which is what nodeDOM expects).
        for(let depth = $pos.depth; depth >= 0; depth--){
            const node = $pos.node(depth);
            if (node.isBlock) {
                const domNode = editorView.nodeDOM($pos.start(depth) - 1);
                if (domNode instanceof HTMLElement) return domNode;
                // depth 0 is the doc node — nodeDOM(–1) won't work, so try
                // the editor's own DOM element as a fallback.
                if (depth === 0 && editorView.dom instanceof HTMLElement) return editorView.dom;
            }
        }
    } catch  {
    // Position may be out of range after a concurrent edit — fall through.
    }
    return null;
}
function $af9b39dbd0229b2c$export$725e0e72f273d89c(editorView, pasteEndPos, targetElement, popupContentRef) {
    return (position)=>{
        const endCoords = editorView.coordsAtPos(pasteEndPos);
        const targetRect = targetElement.getBoundingClientRect();
        // Vertical: center the menu with the line at the paste end position.
        const lineHeight = endCoords.bottom - endCoords.top;
        const lineMidpoint = endCoords.top + lineHeight / 2;
        const menuHeight = popupContentRef.current?.getBoundingClientRect().height ?? lineHeight;
        const menuTop = lineMidpoint - menuHeight / 2;
        const topDelta = menuTop - (targetRect.top + targetRect.height);
        const adjustedTop = (position.top ?? 0) + topDelta;
        // Horizontal: position to the right of the cursor
        const leftDelta = endCoords.right - targetRect.right;
        const adjustedLeft = (position.left ?? 0) + leftDelta;
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
function $af9b39dbd0229b2c$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, targetElement, scrollableElement) {
    // Pre-compute once per render to avoid doc.resolve() on every scroll frame.
    const tableAfterPos = $af9b39dbd0229b2c$export$203646a3dfbc94aa(editorView, pasteEndPos);
    const blockAncestorDOM = $af9b39dbd0229b2c$export$69f2182d2b29f39f(editorView, pasteStartPos);
    return (position)=>{
        const startCoords = editorView.coordsAtPos(pasteStartPos);
        const endBottom = $af9b39dbd0229b2c$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos);
        const targetRect = targetElement.getBoundingClientRect();
        // ── Vertical adjustment ──────────────────────────────────────────
        // The Popup places the menu at the target's bottom edge by default.
        // We shift it up so it aligns with the paste start position.
        // Both coordinates are in viewport space, so the delta is offset-parent agnostic.
        const topDelta = startCoords.top - (targetRect.top + targetRect.height);
        let adjustedTop = (position.top ?? 0) + topDelta;
        // Sticky-top: clamp to the scroll container's top edge when the paste
        // start has scrolled above the visible area, but only while some pasted
        // content is still visible.
        if (scrollableElement) {
            const scrollContainerTop = scrollableElement.getBoundingClientRect().top;
            if (startCoords.top < scrollContainerTop && endBottom > scrollContainerTop) adjustedTop += scrollContainerTop - startCoords.top + (0, $feee454b9de5f38d$export$6b0e62d36c2a26b4);
        }
        // ── Horizontal adjustment ────────────────────────────────────────
        // When pasted content starts with a mark (bold, italic, link …) or
        // an inline node (emoji, smart link, inline image …),
        // findDomRefAtPos returns the narrow inline wrapper element. The
        // Popup's alignX="end" then places the menu at that element's right
        // edge instead of the content area's right edge. We correct this by
        // resolving the nearest block-level ProseMirror ancestor and
        // re-anchoring to its right edge.
        let adjustedLeft = position.left;
        if (blockAncestorDOM && blockAncestorDOM !== targetElement) {
            const blockRect = blockAncestorDOM.getBoundingClientRect();
            // Shift left by the difference between the block's right edge and
            // the inline target's right edge. This mirrors what alignX="end"
            // would have computed if the target were the block element.
            const leftDelta = blockRect.right - targetRect.right;
            adjustedLeft = (position.left ?? 0) + leftDelta;
        }
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
const $af9b39dbd0229b2c$export$8c1ff721ebf4b048 = ({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { lastContentPasted: lastContentPasted } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>({
            lastContentPasted: states.pasteState?.lastContentPasted
        }));
    const sliceForAgentMentionSuppression = lastContentPasted?.sourcePastedSlice;
    const pasteMenuComponents = api?.uiControlRegistry?.actions.getComponents((0, $3nacY.PASTE_MENU).key) ?? [];
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- pasteMenuComponents changes by reference each render; filter is small (< 10 items)
    const aiMenuItems = pasteMenuComponents.filter((c)=>c.type === 'menu-item' && c.parents?.some((p)=>p.key === (0, $3nacY.AI_PASTE_MENU_SECTION).key));
    const visibleAiActionKeys = (0, $af7ce99f0a6e1d0c$export$99cddee748d62c45)(aiMenuItems, [
        'menu-item'
    ]);
    const hasVisibleAiActions = visibleAiActionKeys.length > 0;
    const shouldSuppressPasteActions = (0, $cozmU.useMemo)(()=>{
        const suppressForAgentMention = $af9b39dbd0229b2c$export$fa38ccb7191f761d(sliceForAgentMentionSuppression);
        const suppressForSingleLink = $af9b39dbd0229b2c$export$6b1ad80f8062f971(sliceForAgentMentionSuppression) && !hasVisibleAiActions;
        return suppressForAgentMention || suppressForSingleLink;
    }, [
        sliceForAgentMentionSuppression,
        hasVisibleAiActions
    ]);
    const prevShowToolbarRef = (0, $cozmU.useRef)(false);
    const popupContentRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!lastContentPasted) {
            (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
            return;
        }
        if (shouldSuppressPasteActions) {
            (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
            return;
        }
        let selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None;
        if (!lastContentPasted.isPlainText) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
        else if (lastContentPasted.isShiftPressed) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
        else selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
        const $pos = editorView.state.doc.resolve(lastContentPasted.pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (lastContentPasted.pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const legacyVisible = (0, $80d2dc5ef3c83ccc$export$208ad7410c805534)(editorView.state, lastContentPasted);
        (0, $d4c269fd41087652$export$1ad95a504fba561e)(lastContentPasted, selectedOption, legacyVisible, pasteAncestorNodeNames)(editorView.state, editorView.dispatch);
    }, [
        lastContentPasted,
        shouldSuppressPasteActions,
        editorView
    ]);
    const { showToolbar: isToolbarShown, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            showToolbar: pluginState?.showToolbar ?? false,
            pasteStartPos: pluginState?.pasteStartPos ?? 0,
            pasteEndPos: pluginState?.pasteEndPos ?? 0
        };
    });
    const preventEditorFocusLoss = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        (0, $d4c269fd41087652$export$3367fb592cb1ac64)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((evt)=>{
        if (evt.target instanceof Element) {
            const isInsideNestedDropdown = evt.target.closest('[data-toolbar-nested-dropdown-menu]');
            if (isInsideNestedDropdown) return;
        }
        handleDismiss();
    }, [
        handleDismiss
    ]);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) handleDismiss();
    }, [
        handleDismiss
    ]);
    const shouldRenderToolbar = isToolbarShown && !shouldSuppressPasteActions;
    // Find the actual scroll container using the same utility the Popup's
    // stick prop uses internally. We pass this as the scrollableElement prop
    // so the Popup attaches its built-in scroll listener, which calls
    // scheduledUpdatePosition (RAF-throttled) on each scroll event — triggering
    // onPositionCalculated with fresh viewport coordinates.
    const overflowScrollParent = shouldRenderToolbar ? (0, $1jz5K.findOverflowScrollParent)(editorView.dom) : false;
    const effectiveScrollableElement = overflowScrollParent || scrollableElement;
    const anyComponentVisible = (0, $af7ce99f0a6e1d0c$export$159affd63ddd230e)(pasteMenuComponents);
    // Whether the card plugin's "Display as" section is visible when the menu opens.
    const displayAsVisible = (0, $af7ce99f0a6e1d0c$export$99cddee748d62c45)(pasteMenuComponents, [
        'menu-section'
    ]).includes((0, $3nacY.SMART_LINK_DISPLAY_AS_PASTE_MENU_SECTION).key);
    // Two positioning modes:
    // 1. Inline: no AI actions visible — menu appears to the right of the cursor,
    //    vertically centered with the text line.
    // 2. Block-anchored: AI actions are visible — menu appears at the right edge
    //    of the content block, aligned with paste start.
    (0, $cozmU.useEffect)(()=>{
        if (!prevShowToolbarRef.current && shouldRenderToolbar) editorAnalyticsAPI?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).OPENED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PASTE_ACTIONS_MENU,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                visibleAiActions: visibleAiActionKeys,
                displayAsVisible: displayAsVisible
            }
        });
        prevShowToolbarRef.current = shouldRenderToolbar;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRenderToolbar,
        editorAnalyticsAPI
    ]);
    const useInlinePosition = !hasVisibleAiActions;
    if (!shouldRenderToolbar) return null;
    if (!anyComponentVisible) return null;
    const target = $af9b39dbd0229b2c$export$2562999169740ceb(editorView, useInlinePosition ? pasteEndPos : pasteStartPos);
    if (!target) return null;
    // Choose positioning strategy based on whether the menu appears inline
    // (right of cursor for short pastes) or anchored to the block ancestor
    // (right side of content area for longer pastes / AI actions).
    let positionCalculator;
    try {
        positionCalculator = useInlinePosition ? $af9b39dbd0229b2c$export$725e0e72f273d89c(editorView, pasteEndPos, target, popupContentRef) : $af9b39dbd0229b2c$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, target, effectiveScrollableElement);
    } catch (error) {
        positionCalculator = (position)=>({
                ...position,
                top: position.top ?? 0
            });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)($af9b39dbd0229b2c$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: effectiveScrollableElement,
        minPopupMargin: (0, $feee454b9de5f38d$export$b7100f42dfe6c945),
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        alignX: "end",
        alignY: useInlinePosition ? 'top' : 'bottom',
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ offset: [
            (0, $feee454b9de5f38d$export$b7100f42dfe6c945),
            0
        ],
        onPositionCalculated: positionCalculator,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleDismiss,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bFSJa.EditorToolbarProvider), {
            editorView: editorView,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kwf4Z.ToolbarDropdownMenuProvider), {
                isOpen: isToolbarShown,
                setIsOpen: handleSetIsOpen,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2f1cb9d719e236e$export$41585964872b7c), {
                    onMouseDown: preventEditorFocusLoss,
                    onMouseEnter: handleMouseEnter,
                    components: pasteMenuComponents,
                    contentRef: popupContentRef,
                    pastedSlice: lastContentPasted?.pastedSlice
                })
            })
        })
    });
};


/* PasteMenuComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");










var $hVLmg = parcelRequire("hVLmg");




var $dVKvM = parcelRequire("dVKvM");

var $jgJIe = parcelRequire("jgJIe");

var $gk3KR = parcelRequire("gk3KR");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");










/* PasteOptionsDropdownButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $3vgx3 = parcelRequire("3vgx3");


var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $9eb8f6ded88088d3$export$fb556e4963c45caa = ({ children: children, elemBefore: elemBefore, elemAfter: elemAfter, label: label, testId: testId, tooltipContent: tooltipContent })=>{
    const trigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6t3CY.ToolbarButton), {
            ref: triggerProps.triggerRef,
            isSelected: triggerProps.isSelected,
            "aria-expanded": triggerProps['aria-expanded'],
            "aria-haspopup": triggerProps['aria-haspopup'],
            onClick: triggerProps.onClick,
            testId: testId,
            iconBefore: elemBefore,
            label: label,
            children: elemAfter
        });
        if (tooltipContent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent,
            position: "top",
            children: button
        });
        return button;
    }, [
        testId,
        elemBefore,
        elemAfter,
        label,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        placement: "bottom-start",
        trigger: trigger,
        children: children
    });
};


const $9d04b982b9359ef2$var$nestedMenuStyles = {
    narrowSection: "_2perVWoaux"
};
const $9d04b982b9359ef2$export$ca4999b34e9ed55a = (pasteType, selectedOption)=>{
    switch(pasteType){
        case 'rich-text':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
        case 'markdown':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
        case 'plain-text':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
        default:
            return false;
    }
};
const $9d04b982b9359ef2$var$PasteMenuItem = ({ api: api, pasteType: pasteType, markdownToPmConverter: markdownToPmConverter })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { selectedOption: selectedOption, plaintextLength: plaintextLength, isPlainText: isPlainText } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            selectedOption: pluginState?.selectedOption ?? (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
            plaintextLength: pluginState?.plaintextLength ?? 0,
            isPlainText: pluginState?.isPlainText ?? false
        };
    });
    const getDefaultLabel = (0, $cozmU.useCallback)((type)=>{
        switch(type){
            case 'rich-text':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).richTextAction);
            case 'markdown':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).markdownAction);
            case 'plain-text':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).plainTextAction);
            default:
                return type;
        }
    }, [
        intl
    ]);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (!editorView) return;
        switch(pasteType){
            case 'rich-text':
                (0, $d4c269fd41087652$export$849d50d444ed50f8)(editorAnalyticsAPI, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
            case 'markdown':
                (0, $d4c269fd41087652$export$a1a13c805bf0cea1)(editorAnalyticsAPI, plaintextLength, 'pasteMenu', markdownToPmConverter)()(editorView.state, editorView.dispatch);
                break;
            case 'plain-text':
                (0, $d4c269fd41087652$export$c833704cd36ac295)(editorAnalyticsAPI, plaintextLength, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
        }
    }, [
        editorView,
        editorAnalyticsAPI,
        markdownToPmConverter,
        plaintextLength,
        pasteType
    ]);
    if (pasteType === 'rich-text' && isPlainText) return null;
    const displayLabel = getDefaultLabel(pasteType);
    const isSelected = $9d04b982b9359ef2$export$ca4999b34e9ed55a(pasteType, selectedOption);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        testId: `paste-${pasteType}-menu-item`,
        hasNestedDropdownMenu: true,
        children: displayLabel
    });
};
const $9d04b982b9359ef2$var$PasteOptionsNestedMenu = ({ children: children, hasVisibleAiActions: hasVisibleAiActions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteMenuActionsPasteAs);
    if (!hasVisibleAiActions) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9eb8f6ded88088d3$export$fb556e4963c45caa), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            size: "small",
            label: ""
        }),
        label: label,
        testId: "paste-options-nested-menu",
        tooltipContent: label,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            size: "small",
            label: ""
        }),
        testId: "paste-options-nested-menu",
        text: label,
        children: children
    });
};
const $9d04b982b9359ef2$var$getHasVisibleAiActions = (api)=>{
    const allComponents = api?.uiControlRegistry?.actions.getComponents((0, $3nacY.PASTE_MENU).key) ?? [];
    const aiMenuItems = allComponents.filter((c)=>c.type === 'menu-item' && c.parents?.some((p)=>p.key === (0, $3nacY.AI_PASTE_MENU_SECTION).key));
    return (0, $af7ce99f0a6e1d0c$export$99cddee748d62c45)(aiMenuItems, [
        'menu-item'
    ]).length > 0;
};
const $9d04b982b9359ef2$export$fc33052900084a9d = ({ api: api, markdownToPmConverter: markdownToPmConverter })=>[
        {
            type: (0, $3nacY.PASTE_MENU).type,
            key: (0, $3nacY.PASTE_MENU).key
        },
        {
            type: (0, $3nacY.PASTE_MENU_SECTION).type,
            key: (0, $3nacY.PASTE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: (0, $hVLmg.PASTE_MENU_RANK)[(0, $3nacY.PASTE_MENU_SECTION).key]
                }
            ],
            isHidden: ()=>{
                const pluginState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                return !(pluginState?.showLegacyOptions ?? false);
            },
            component: (props)=>{
                const hasVisibleAiActions = $9d04b982b9359ef2$var$getHasVisibleAiActions(api);
                if (!hasVisibleAiActions) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    padding: "space.100",
                    children: props.children
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                });
            }
        },
        {
            type: (0, $3nacY.PASTE_NESTED_MENU).type,
            key: (0, $3nacY.PASTE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU_SECTION).type,
                    key: (0, $3nacY.PASTE_MENU_SECTION).key,
                    rank: (0, $hVLmg.PASTE_MENU_SECTION_RANK)[(0, $3nacY.PASTE_NESTED_MENU).key]
                }
            ],
            component: (props)=>{
                const hasVisibleAiActions = $9d04b982b9359ef2$var$getHasVisibleAiActions(api);
                return /*#__PURE__*/ (0, $8aG6j.jsx)($9d04b982b9359ef2$var$PasteOptionsNestedMenu, {
                    hasVisibleAiActions: hasVisibleAiActions,
                    children: props.children
                });
            }
        },
        {
            type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
            key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_NESTED_MENU).type,
                    key: (0, $3nacY.PASTE_NESTED_MENU).key,
                    rank: (0, $hVLmg.PASTE_NESTED_MENU_RANK)[(0, $3nacY.PASTE_MENU_NESTED_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: (0, $k12R1.cx)($9d04b982b9359ef2$var$nestedMenuStyles.narrowSection),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
                        children: props.children
                    })
                })
        },
        {
            key: (0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    pasteType: "rich-text"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    markdownToPmConverter: markdownToPmConverter,
                    pasteType: "markdown"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    pasteType: "plain-text"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).key]
                }
            ]
        }
    ];






/**
 * Structural container nodes are nodes whose children are determined by
 * document structure (e.g. list items inside a list, rows inside a table)
 * rather than by content choice. Having different child types inside these
 * nodes does NOT indicate mixed content.
 *
 * All other container nodes (blockTaskItem, blockquote, panel,
 * expand, layoutColumn, tableCell, tableHeader, bodiedExtension, etc.) hold
 * rich block content, so mixed block children inside them IS mixing.
 */ const $fb56a651e80e808e$var$STRUCTURAL_CONTAINERS = new Set([
    'bulletList',
    'orderedList',
    'listItem',
    'taskList',
    'decisionList',
    'table',
    'tableRow'
]);
/**
 * Returns true if a node's direct block-level children include more than one
 * distinct node type — i.e. the children are "mixed".
 */ const $fb56a651e80e808e$var$hasBlockSiblings = (node)=>{
    const types = new Set();
    node.forEach((child)=>{
        if (child.isBlock) types.add(child.type.name);
    });
    return types.size > 1;
};
const $fb56a651e80e808e$export$a88d571ef2c6a298 = (slice)=>{
    if (!slice?.content?.size) return false;
    // Check the top-level children of the slice (Fragment has no parent Node,
    // so we construct a synthetic check by iterating slice.content directly).
    const topLevelTypes = new Set();
    slice.content.forEach((node)=>{
        if (node.isBlock) topLevelTypes.add(node.type.name);
    });
    if (topLevelTypes.size > 1) return true;
    // Walk every descendant node and check its direct block children for mixing,
    // skipping structural containers (their children are structural, not content).
    let mixed = false;
    slice.content.descendants((node)=>{
        if (mixed) return false; // short-circuit once found
        if ($fb56a651e80e808e$var$STRUCTURAL_CONTAINERS.has(node.type.name)) return true; // recurse into but don't check children for mixing
        if ($fb56a651e80e808e$var$hasBlockSiblings(node)) {
            mixed = true;
            return false;
        }
        return true;
    });
    return mixed;
};







/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is shorter than `minChars` characters.
 */ const $0154d77ff4d1c8aa$var$minCharsRule = (minChars)=>(context)=>context.getPlaintextLength() < minChars;
/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is longer than `maxChars` characters.
 */ const $0154d77ff4d1c8aa$var$maxCharsRule = (maxChars)=>(context)=>context.getPlaintextLength() > maxChars;
/**
 * A rule that hides the paste-menu button when the pasted content is plain
 * text (i.e. not rich-text / prose).
 */ const $0154d77ff4d1c8aa$var$notProseRule = (context)=>{
    // The pasted slice being empty or missing indicates plain-text paste.
    const slice = context.getPastedSlice();
    const pastedText = context.getPastedText();
    return slice === undefined && (0, $6b89ac4b3810071f$export$71535a792a9ee562)(pastedText);
};
/**
 * A rule that hides the paste-menu button when the pasted content contains a
 * table node as an ancestor at the insertion point.
 */ const $0154d77ff4d1c8aa$var$containsTableRule = (context)=>(0, $ccabb917a6ff0a8f$export$44b7f57aaef7c0af)(context.getPastedSlice());
/**
 * Returns a rule that hides the paste-menu button when any of the provided
 * node names appear in the ancestor list at the insertion point.
 */ const $0154d77ff4d1c8aa$var$excludedAncestorRule = (excludedNames)=>(context)=>context.getAncestorNodeNames().some((name)=>excludedNames.includes(name));
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * more than one node type (e.g. a mix of paragraphs and headings, or a table
 * with multiple cell types).
 */ const $0154d77ff4d1c8aa$var$hideIfMixedNodesRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return (0, $fb56a651e80e808e$export$a88d571ef2c6a298)(slice);
};
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * only a single node type (e.g. a single paragraph, or a table with only one cell type).
 * This is the inverse of `hideIfMixedNodesRule` and can be used in combination with it
 * to target pastes that contain either exactly one node type or more than one node type.
 */ const $0154d77ff4d1c8aa$var$hideIfSingleNodeRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return !(0, $fb56a651e80e808e$export$a88d571ef2c6a298)(slice);
};
/**
 * A rule that hides the paste-menu button when the paste source is NOT an
 * external application (i.e. the content was pasted from within the Fabric
 * editor or renderer rather than from a third-party source).
 */ const $0154d77ff4d1c8aa$var$notExternalPasteRule = (context)=>{
    const source = context.getPasteSource();
    return source === 'fabric-editor' || source === 'fabric-renderer';
};
/**
 * A rule that hides the paste-menu button when the pasted content is a single
 * standalone link — i.e. a bare URL link (text equals href) alone in a
 * paragraph, or a single inline card (smartlink) alone in a paragraph.
 *
 * Returns `true` (hidden) when the paste is NOT a single link — e.g. a link
 * with a custom label, a link accompanied by other text or sibling nodes, or
 * multiple paragraphs.
 */ const $0154d77ff4d1c8aa$var$notSingleLinkRule = (context)=>(0, $aKpkp.isNotSingleLink)(context.getPastedSlice());
/**
 * A rule that hides the paste-menu button when the pasted content IS a single
 * standalone link (the inverse of `notSingleLinkRule`).
 *
 * Use this to suppress buttons (e.g. Improve Writing, Fix Spelling) that
 * should not appear for single-link pastes.
 */ const $0154d77ff4d1c8aa$var$isSingleLinkRule = (context)=>!(0, $aKpkp.isNotSingleLink)(context.getPastedSlice());
/**
 * Combines multiple context-aware rules with short-circuit evaluation.
 * Returns `true` (hidden) as soon as the first rule returns `true`; returns
 * `false` only when all rules return `false`.
 * Context is injected by `createPasteMenuRuleFactories` — callers never
 * construct or pass a context object.
 */ const $0154d77ff4d1c8aa$var$allRules = (...rules)=>(context)=>{
        for (const rule of rules){
            if (rule(context)) return true;
        }
        return false;
    };
/**
 * Binds a `PasteMenuRuleWithContext` to a context supplier, returning a
 * no-argument `PasteMenuRule` that re-reads the context on every invocation.
 */ const $0154d77ff4d1c8aa$var$bind = (getContext, rule)=>()=>rule(getContext());
const $0154d77ff4d1c8aa$export$aa0980ac1f3ab236 = (getContext)=>({
        allRules: (...rules)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$allRules(...rules)),
        containsTableRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$containsTableRule),
        excludedAncestorRule: (excludedNames)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$excludedAncestorRule(excludedNames)),
        hideIfMixedNodesRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$hideIfMixedNodesRule),
        hideIfSingleNodeRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$hideIfSingleNodeRule),
        isSingleLinkRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$isSingleLinkRule),
        maxCharsRule: (maxChars)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$maxCharsRule(maxChars)),
        minCharsRule: (minChars)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$minCharsRule(minChars)),
        notExternalPasteRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notExternalPasteRule),
        notProseRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notProseRule),
        notSingleLinkRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notSingleLinkRule)
    });


const $d958b60311dd0d3f$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const getPasteMenuContext = ()=>({
            getCurrentPasteRange: ()=>{
                const state = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                if (!state) return undefined;
                return {
                    pasteEndPos: state.pasteEndPos,
                    pasteStartPos: state.pasteStartPos
                };
            },
            getCurrentPastedUrl: ()=>(0, $cVdVi.getSingleSmartLinkUrlFromSlice)(api?.paste?.sharedState.currentState()?.lastContentPasted?.pastedSlice)
        });
    if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) api?.uiControlRegistry?.actions.register((0, $9d04b982b9359ef2$export$fc33052900084a9d)({
        api: api,
        markdownToPmConverter: config?.markdownToPmConverter
    }));
    if (config?.pasteMenuButtonsFactory && config?.usePopupBasedPasteActionsMenu) {
        const rules = (()=>{
            const getContext = ()=>{
                const pasteOptsState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                const pasteState = api?.paste?.sharedState.currentState();
                return {
                    getPlaintextLength: ()=>pasteOptsState?.plaintextLength ?? 0,
                    getAncestorNodeNames: ()=>pasteOptsState?.pasteAncestorNodeNames ?? [],
                    getPastedText: ()=>pasteState?.lastContentPasted?.text ?? '',
                    getPastedSlice: ()=>pasteState?.lastContentPasted?.pastedSlice,
                    getNodeTypes: ()=>[],
                    getPasteSource: ()=>pasteState?.lastContentPasted?.pasteSource
                };
            };
            return (0, $0154d77ff4d1c8aa$export$aa0980ac1f3ab236)(getContext);
        })();
        const productButtons = config.pasteMenuButtonsFactory(rules, getPasteMenuContext());
        api?.uiControlRegistry?.actions.register(productButtons);
    }
    return {
        name: 'pasteOptionsToolbarPlugin',
        actions: {
            getPasteMenuRules: ()=>{
                const getContext = ()=>{
                    const pasteOptsState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                    const pasteState = api?.paste?.sharedState.currentState();
                    return {
                        getPlaintextLength: ()=>pasteOptsState?.plaintextLength ?? 0,
                        getAncestorNodeNames: ()=>pasteOptsState?.pasteAncestorNodeNames ?? [],
                        getPastedText: ()=>pasteState?.lastContentPasted?.text ?? '',
                        getPastedSlice: ()=>pasteState?.lastContentPasted?.pastedSlice,
                        getNodeTypes: ()=>[],
                        getPasteSource: ()=>pasteState?.lastContentPasted?.pasteSource
                    };
                };
                return (0, $0154d77ff4d1c8aa$export$aa0980ac1f3ab236)(getContext);
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $7e1bf35df5b7b5d8$export$ae829ec7b2625219)(dispatch, {
                            useNewPasteMenu: config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)
                        })
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isPlainText: false,
                pasteAncestorNodeNames: [],
                pasteEndPos: 0,
                pasteStartPos: 0,
                plaintextLength: 0,
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
                showLegacyOptions: false,
                showToolbar: false
            };
            const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(editorState);
            return {
                isPlainText: pluginState?.isPlainText ?? false,
                pasteAncestorNodeNames: pluginState?.pasteAncestorNodeNames ?? [],
                pasteEndPos: pluginState?.pasteEndPos ?? 0,
                pasteStartPos: pluginState?.pasteStartPos ?? 0,
                plaintextLength: pluginState?.plaintext.length ?? 0,
                selectedOption: pluginState?.selectedOption ?? (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
                showLegacyOptions: pluginState?.showLegacyOptions ?? false,
                showToolbar: pluginState?.showToolbar ?? false
            };
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                const pastePluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
                if (pastePluginState.showToolbar) return (0, $80d2dc5ef3c83ccc$export$6dd6ab35df8f7f86)(state, intl, editorAnalyticsAPI, config?.markdownToPmConverter);
                return;
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!(config?.usePopupBasedPasteActionsMenu && ((0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) || [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control')))) || !editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af9b39dbd0229b2c$export$8c1ff721ebf4b048), {
                api: api,
                editorView: editorView,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        },
        usePluginHook ({ editorView: editorView }) {
            const { lastContentPasted: lastContentPasted } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
                'paste'
            ], (states)=>({
                    lastContentPasted: states.pasteState?.lastContentPasted
                }));
            (0, $cozmU.useEffect)(()=>{
                if (config?.usePopupBasedPasteActionsMenu && (0, $iDrrr.fg)('platform_editor_paste_actions_menu_exposure')) (0, $29282488bd260ae9$export$899f54ccaa7b18cb)(lastContentPasted?.text?.length ?? 0, editorView.state, lastContentPasted?.pasteStartPos, lastContentPasted?.pasteEndPos, lastContentPasted?.text, lastContentPasted?.pastedSlice);
                // These two need to be seperate to prevent them being dependant on each other
                if (config?.usePopupBasedPasteActionsMenu && (0, $iDrrr.fg)('platform_editor_paste_actions_menu_v2_exposure')) (0, $471bf21fb11fd74a$export$3bc247e6ff3a4c32)(lastContentPasted?.text?.length ?? 0, editorView.state, lastContentPasted?.pasteStartPos, lastContentPasted?.pasteEndPos, lastContentPasted?.text, lastContentPasted?.pastedSlice);
                // Fires only for single-link pastes, matching when the 3p link menu shows.
                if (config?.usePopupBasedPasteActionsMenu) (0, $cff27d0b60b42bfa$export$53261c09932390d5)(lastContentPasted?.pastedSlice);
                if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                if (!lastContentPasted) {
                    (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
                else selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
                if (!(0, $80d2dc5ef3c83ccc$export$208ad7410c805534)(editorView.state, lastContentPasted)) return;
                (0, $d4c269fd41087652$export$1ad95a504fba561e)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};
module.exports["pasteOptionsToolbarPlugin"] = $d958b60311dd0d3f$export$2eabbda136e01363;

});

parcelRegister("cVdVi", function(module, exports) {

var $aKpkp = parcelRequire("aKpkp");

const $0bb2adc6cbf32902$var$getUrlFromTextLinkNode = (node)=>{
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = node.marks[0].attrs?.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $0bb2adc6cbf32902$var$getUrlFromCardNode = (node)=>{
    if (node.type.name !== 'inlineCard' && node.type.name !== 'blockCard' && node.type.name !== 'embedCard') return undefined;
    const url = node.attrs?.url ?? node.attrs?.data?.url;
    return typeof url === 'string' ? url : undefined;
};
const $0bb2adc6cbf32902$var$significantChildren = (node)=>{
    const children = [];
    node.content.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
const $0bb2adc6cbf32902$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || (0, $aKpkp.isNotSingleLink)(slice)) return undefined;
    if (slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $0bb2adc6cbf32902$var$getUrlFromTextLinkNode(topNode) ?? $0bb2adc6cbf32902$var$getUrlFromCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $0bb2adc6cbf32902$var$significantChildren(topNode);
    if (children.length !== 1) return undefined;
    return $0bb2adc6cbf32902$var$getUrlFromTextLinkNode(children[0]) ?? $0bb2adc6cbf32902$var$getUrlFromCardNode(children[0]);
};
module.exports["getSingleSmartLinkUrlFromSlice"] = $0bb2adc6cbf32902$export$6f4c320e305ef7dc;

});

parcelRegister("1K7sQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $59uj0 = parcelRequire("59uj0");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $kpCD8 = parcelRequire("kpCD8");


var $2w79Z = parcelRequire("2w79Z");


var $kCECX = parcelRequire("kCECX");


var $UL6rM = parcelRequire("UL6rM");


var $4o0zT = parcelRequire("4o0zT");




const $802e6d041f58903b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('placeholderTextPlugin');


const $0681165d98d72b2c$export$cf72668e5bda227e = (state, dispatch)=>{
    const tr = state.tr;
    if (!state.selection.empty) tr.deleteSelection();
    tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
        showInsertPanelAt: tr.selection.anchor
    });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
const $0681165d98d72b2c$export$478f9b36a44ad411 = (value)=>(state, dispatch)=>{
        dispatch(state.tr.replaceSelectionWith(state.schema.nodes.placeholder.createChecked({
            text: value
        })).setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
            showInsertPanelAt: null
        }).scrollIntoView());
        return true;
    };
const $0681165d98d72b2c$export$722fce80225bc19b = (state, dispatch)=>{
    dispatch(state.tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
        showInsertPanelAt: null
    }));
    return true;
};



var $aPdNQ = parcelRequire("aPdNQ");





var $8nvEM = parcelRequire("8nvEM");

class $74c182ba2c8524ee$export$9f5092f54ccc15c6 {
    map(mapping) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return new $74c182ba2c8524ee$export$9f5092f54ccc15c6(mapping.map(this.pos));
    }
    resolve(doc) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const $pos = doc.resolve(this.pos);
        return (0, $kCECX.Selection).near($pos);
    }
    constructor(pos){
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
}
class $74c182ba2c8524ee$export$37936ceed0f40761 extends (0, $kCECX.Selection) {
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.$head.pos));
        return new $74c182ba2c8524ee$export$37936ceed0f40761($pos);
    }
    static content() {
        return (0, $aPdNQ.Slice).empty;
    }
    eq(other) {
        return other instanceof $74c182ba2c8524ee$export$37936ceed0f40761 && other.head === this.head;
    }
    toJSON() {
        return {
            type: 'Cursor',
            pos: this.head
        };
    }
    static fromJSON(doc, json) {
        return new $74c182ba2c8524ee$export$37936ceed0f40761(doc.resolve(json.pos));
    }
    getBookmark() {
        return new $74c182ba2c8524ee$export$9f5092f54ccc15c6(this.anchor);
    }
    constructor($pos){
        super($pos, $pos);
    }
}
(0, $kCECX.Selection).jsonID('fake-text-cursor', $74c182ba2c8524ee$export$37936ceed0f40761);
const $74c182ba2c8524ee$export$b8cf92335d1aa4be = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection.empty) {
        const { selection: { $from: $from } } = state;
        dispatch(state.tr.setSelection(new $74c182ba2c8524ee$export$37936ceed0f40761($from)));
    }
};
const $74c182ba2c8524ee$export$b0a69583d8930ac5 = (state, dispatch)=>{
    if (state.selection instanceof $74c182ba2c8524ee$export$37936ceed0f40761) {
        const { $from: $from } = state.selection;
        dispatch(state.tr.setSelection(new (0, $kCECX.TextSelection)($from)));
    }
};
const $74c182ba2c8524ee$export$e3d497d0280bbada = (state)=>{
    if (!(state.selection instanceof $74c182ba2c8524ee$export$37936ceed0f40761)) return null;
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        (0, $8nvEM.Decoration).widget(state.selection.head, node, {
            key: 'Cursor'
        })
    ]);
};



var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");




const $9043b85d85dae09c$var$serializePlaceholderNode = (node)=>{
    const element = document.createElement('span');
    const browser = (0, $8dxef.getBrowserInfo)();
    element.classList.add('pm-placeholder');
    // the inline node api test suite requires the following class name
    element.classList.add('placeholderView-content-wrap');
    element.innerText = (0, $fngNp.ZERO_WIDTH_SPACE);
    const elementChildren = document.createElement('span');
    elementChildren.classList.add('pm-placeholder__text');
    elementChildren.dataset.placeholder = node.attrs.text;
    elementChildren.setAttribute('contenteditable', 'false');
    element.appendChild(elementChildren);
    if (browser.safari) element.appendChild(document.createTextNode((0, $fngNp.ZERO_WIDTH_SPACE)));
    else element.appendChild(document.createElement('wbr'));
    return element;
};
class $9043b85d85dae09c$export$442d0baedc2512a6 {
    stopEvent(e) {
        if (e.type === 'mousedown' && typeof this.getPos === 'function') {
            e.preventDefault();
            const { view: view } = this;
            const startNodePosition = this.getPos();
            if (typeof startNodePosition !== 'number') return false;
            const tr = view.state.tr;
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(startNodePosition)));
            view.dispatch(tr);
            if (!view.hasFocus()) window.requestAnimationFrame(()=>{
                view.focus();
            });
            return true;
        }
        return false;
    }
    ignoreMutation(record) {
        if (typeof this.getPos !== 'function' || record.type !== 'selection') return true;
        const { view: view, node: node } = this;
        const placeholderStartPosition = this.getPos();
        if (typeof placeholderStartPosition !== 'number') return false;
        const placeholderEndPosition = placeholderStartPosition + node.nodeSize;
        const selection = view.state.selection;
        // when the selection is set right after the placeholder.
        // we should let ProseMirror deal with this edge-case
        if (selection.from === placeholderEndPosition) return false;
        const isSelectionAtPlaceholder = selection.from === placeholderStartPosition;
        const isSelectionAfterlaceholder = selection.from > placeholderEndPosition;
        if (isSelectionAtPlaceholder || isSelectionAfterlaceholder) {
            const tr = view.state.tr;
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(placeholderEndPosition)));
            view.dispatch(tr);
            return true;
        }
        return true;
    }
    constructor(node, view, getPos){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = void 0;
        this.dom = $9043b85d85dae09c$var$serializePlaceholderNode(this.node);
        this.getPos = getPos;
    }
}






const $e608286830e672c2$export$fcfa1d7f51efd169 = (selection)=>{
    if (!(selection instanceof (0, $kCECX.TextSelection)) || !selection.$cursor) return false;
    const node = selection.$cursor.doc.nodeAt(selection.$cursor.pos);
    return node?.type.name === 'placeholder';
};






var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $WnqKg = parcelRequire("WnqKg");


var $6BleA = parcelRequire("6BleA");

/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7XIuB = parcelRequire("7XIuB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $0d8c43a0d52ffea3$export$34e0f9847d4c02dd = (height)=>/*#__PURE__*/ (0, $lOiVq.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? `${height}px` : undefined
    });


function $3a915050eccdd184$export$2e2bcd8739ae039({ children: children, target: target, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight = 40, onPositionCalculated: onPositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, className: className, absoluteOffset: absoluteOffset, alignX: alignX, alignY: alignY, zIndex: zIndex }) {
    if (!target) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        absoluteOffset: absoluteOffset,
        alignX: alignX,
        alignY: alignY,
        target: target,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        offset: offset,
        fitWidth: fitWidth,
        fitHeight: fitHeight,
        onPositionCalculated: onPositionCalculated
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $0d8c43a0d52ffea3$export$34e0f9847d4c02dd)(fitHeight),
        "data-testid": "popup-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children));
}


const $b441e757b9165293$var$getCursorHeightFrom = (node)=>parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
const $b441e757b9165293$export$5055c4a13011779 = (editorViewDom, popupsMountPoint)=>popupsMountPoint ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
    popupsMountPoint.offsetParent : // eslint-disable-next-line @atlaskit/editor/no-as-casting
    editorViewDom.offsetParent;
const $b441e757b9165293$export$dcb2d1671e2c93d4 = (node)=>// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    node.nodeType === Node.TEXT_NODE ? node.parentNode : node;
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */ const $b441e757b9165293$var$convertFixedCoordinatesToAbsolutePositioning = (coordinates, offsetParent, cursorHeight)=>{
    const { left: offsetParentLeft, top: offsetParentTop, height: offsetParentHeight } = offsetParent.getBoundingClientRect();
    return {
        left: (coordinates.left ?? 0) - offsetParentLeft,
        right: (coordinates.right ?? 0) - offsetParentLeft,
        top: (coordinates.top ?? 0) - (offsetParentTop - cursorHeight) + offsetParent.scrollTop,
        bottom: offsetParentHeight - ((coordinates.top ?? 0) - (offsetParentTop - cursorHeight) - offsetParent.scrollTop)
    };
};
const $b441e757b9165293$export$499dde0ed160b17d = (offsetParent, node, getCurrentFixedCoordinates)=>(position)=>{
        if (!offsetParent) return position;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = $b441e757b9165293$export$dcb2d1671e2c93d4(node);
        const cursorHeight = $b441e757b9165293$var$getCursorHeightFrom(target);
        const fixedCoordinates = getCurrentFixedCoordinates();
        const absoluteCoordinates = $b441e757b9165293$var$convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
        return {
            left: position.left ? absoluteCoordinates.left : undefined,
            right: position.right ? absoluteCoordinates.right : undefined,
            top: position.top ? absoluteCoordinates.top : undefined,
            bottom: position.bottom ? absoluteCoordinates.bottom : undefined
        };
    };


// eslint-disable-next-line @repo/internal/react/no-class-components
class $4d46e11f337bfddf$var$PlaceholderFloatingToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { getNodeFromPos: getNodeFromPos, showInsertPanelAt: showInsertPanelAt, editorViewDOM: editorViewDOM, popupsMountPoint: popupsMountPoint, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, popupsBoundariesElement: popupsBoundariesElement, intl: { formatMessage: formatMessage } } = this.props;
        const target = getNodeFromPos(showInsertPanelAt);
        const offsetParent = (0, $b441e757b9165293$export$5055c4a13011779)(editorViewDOM, popupsMountPoint);
        const getFixedCoordinates = ()=>getFixedCoordinatesFromPos(showInsertPanelAt);
        const handlePositionCalculated = (0, $b441e757b9165293$export$499dde0ed160b17d)(offsetParent, target, getFixedCoordinates);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3a915050eccdd184$export$2e2bcd8739ae039), {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            target: (0, $b441e757b9165293$export$dcb2d1671e2c93d4)(target),
            onPositionCalculated: handlePositionCalculated,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            fitHeight: 32,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                12
            ],
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6BleA.default), {
                placeholder: formatMessage((0, $WnqKg.placeholderTextMessages).placeholderTextPlaceholder),
                onSubmit: this.handleSubmit,
                onBlur: this.handleBlur,
                autoFocus: true,
                width: 300
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleSubmit = (value)=>{
            if (value) {
                this.props.insertPlaceholder(value);
                this.props.setFocusInEditor();
            } else this.props.hidePlaceholderFloatingToolbar();
        };
        this.handleBlur = ()=>{
            this.props.hidePlaceholderFloatingToolbar();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $4d46e11f337bfddf$var$_default_1 = (0, $kSwu1.injectIntl)($4d46e11f337bfddf$var$PlaceholderFloatingToolbar);
var $4d46e11f337bfddf$export$2e2bcd8739ae039 = $4d46e11f337bfddf$var$_default_1;





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");

















var $I2MTF = parcelRequire("I2MTF");





const $f69b587d389d27a3$export$b5e4dc02b34314b8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView })=>{
        const tr = editorView.state.tr;
        tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
            showInsertPanelAt: tr.selection.anchor
        });
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
            label: ""
        }),
        onSelect: onSelect,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderText)
    });
};


const $58520e9e4a51fe67$export$45d515f9e642ad8b = ({ api: api })=>[
        {
            key: (0, $dCkbP.PLACEHOLDER_TEXT_MENU_ITEM).key,
            type: (0, $dCkbP.PLACEHOLDER_TEXT_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.TEXT_FORMATTING_SECTION).key,
                    type: (0, $dCkbP.TEXT_FORMATTING_SECTION).type,
                    rank: (0, $dXqu3.TEXT_FORMATTING_SECTION_RANK)[(0, $dCkbP.PLACEHOLDER_TEXT_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderTextDescription),
                    keywords: [
                        'placeholder'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderText)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $f69b587d389d27a3$export$b5e4dc02b34314b8), {
                    api: api
                })
        }
    ];


const $54cd7fd764d9ffe7$var$getOpenTypeAhead = (trigger, api)=>{
    const typeAheadHandler = api?.typeAhead?.actions?.findHandlerByTrigger(trigger);
    if (!typeAheadHandler || !typeAheadHandler.id) return null;
    return api?.typeAhead?.actions?.openAtTransaction({
        triggerHandler: typeAheadHandler,
        inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD
    });
};
function $54cd7fd764d9ffe7$export$ae829ec7b2625219(dispatch, options, api) {
    const allowInserting = !!options.allowInserting;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $802e6d041f58903b$export$18d4026d1ea86bb1),
        state: {
            init: ()=>({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting
                }),
            apply: (tr, state)=>{
                const meta = tr.getMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1));
                if (meta && meta.showInsertPanelAt !== undefined) {
                    const newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting
                    };
                    dispatch((0, $802e6d041f58903b$export$18d4026d1ea86bb1), newState);
                    return newState;
                } else if (state.showInsertPanelAt) {
                    const newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting
                    };
                    dispatch((0, $802e6d041f58903b$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            if (transactions.some((txn)=>txn.docChanged)) {
                const didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter === newState.selection.$head.nodeAfter;
                const adjacentNode = newState.selection.$head.nodeAfter;
                const adjacentNodePos = newState.selection.$head.pos;
                const placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode && adjacentNode.type === placeholderNodeType && didPlaceholderExistBeforeTxn) {
                    const { $head: $newHead } = newState.selection;
                    const { $head: $oldHead } = oldState.selection;
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    const cursorMoved = $oldHead.pos < $newHead.pos;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const nodeBeforeHasContent = !(0, $2w79Z.isNodeEmpty)($newHead.nodeBefore);
                    const nodeBeforeIsInline = $newHead.nodeBefore?.type.isInline;
                    if (cursorMoved && (nodeBeforeHasContent || nodeBeforeIsInline)) {
                        const { $from: $from, $to: $to } = (0, $kCECX.NodeSelection).create(newState.doc, adjacentNodePos);
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!(0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && (0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) return newState.tr.setSelection(new (0, $74c182ba2c8524ee$export$37936ceed0f40761)(newState.selection.$from));
            if ((0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && !(0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof (0, $74c182ba2c8524ee$export$37936ceed0f40761)) return newState.tr.setSelection(new (0, $kCECX.TextSelection)(newState.selection.$from));
            }
            return;
        },
        props: {
            decorations: (0, $74c182ba2c8524ee$export$e3d497d0280bbada),
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    const { state: state } = view;
                    if (event instanceof InputEvent && !event.isComposing && event.inputType === 'insertText' && (0, $e608286830e672c2$export$fcfa1d7f51efd169)(view.state.selection)) {
                        event.stopPropagation();
                        event.preventDefault();
                        const startNodePosition = state.selection.from;
                        const content = event.data || '';
                        const tr = view.state.tr;
                        tr.delete(startNodePosition, startNodePosition + 1);
                        const openTypeAhead = $54cd7fd764d9ffe7$var$getOpenTypeAhead(content, api);
                        if (openTypeAhead) openTypeAhead(tr);
                        else tr.insertText(content);
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            nodeViews: {
                placeholder: (node, view, getPos)=>new (0, $9043b85d85dae09c$export$442d0baedc2512a6)(node, view, getPos)
            }
        }
    });
}
function $54cd7fd764d9ffe7$var$ContentComponent({ editorView: editorView, dependencyApi: dependencyApi, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
    const { showInsertPanelAt: showInsertPanelAt } = (0, $3k5Tv.useSharedPluginStateWithSelector)(dependencyApi, [
        'placeholderText'
    ], (states)=>({
            showInsertPanelAt: states.placeholderTextState?.showInsertPanelAt
        }));
    const insertPlaceholderText = (value)=>(0, $0681165d98d72b2c$export$478f9b36a44ad411)(value)(editorView.state, editorView.dispatch);
    const hidePlaceholderToolbar = ()=>(0, $0681165d98d72b2c$export$722fce80225bc19b)(editorView.state, editorView.dispatch);
    const getNodeFromPos = (pos)=>editorView.domAtPos(pos).node;
    const getFixedCoordinatesFromPos = (pos)=>editorView.coordsAtPos(pos);
    const setFocusInEditor = ()=>editorView.focus();
    if (showInsertPanelAt) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4d46e11f337bfddf$export$2e2bcd8739ae039), {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorViewDOM: editorView.dom,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        getFixedCoordinatesFromPos: getFixedCoordinatesFromPos,
        getNodeFromPos: getNodeFromPos,
        hidePlaceholderFloatingToolbar: hidePlaceholderToolbar,
        showInsertPanelAt: showInsertPanelAt,
        insertPlaceholder: insertPlaceholderText,
        setFocusInEditor: setFocusInEditor
    });
    return null;
}
const $54cd7fd764d9ffe7$var$basePlaceholderTextPlugin = ({ api: api, config: options })=>({
        name: 'placeholderText',
        nodes () {
            return [
                {
                    name: 'placeholder',
                    node: (0, $59uj0.placeholder)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholderText',
                    plugin: ({ dispatch: dispatch })=>$54cd7fd764d9ffe7$export$ae829ec7b2625219(dispatch, options, api)
                }
            ];
        },
        actions: {
            showPlaceholderFloatingToolbar: $0681165d98d72b2c$export$cf72668e5bda227e
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { showInsertPanelAt: showInsertPanelAt, allowInserting: allowInserting } = (0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(editorState) || {
                showInsertPanelAt: null
            };
            return {
                showInsertPanelAt: showInsertPanelAt,
                allowInserting: !!allowInserting
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($54cd7fd764d9ffe7$var$ContentComponent, {
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                dependencyApi: api
            });
        }
    });
const $54cd7fd764d9ffe7$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (!options.allowInserting || (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command')) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'placeholderText',
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderText),
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderTextDescription),
                    priority: 1400,
                    keywords: [
                        'placeholder'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
                            label: ""
                        }),
                    action (insert, state) {
                        const tr = state.tr;
                        tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
                            showInsertPanelAt: tr.selection.anchor
                        });
                        api?.analytics?.actions.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).INSERTED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
                            attributes: {
                                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK
                        })(tr);
                        return tr;
                    }
                }
            ]
    };
    return plugin;
};
const $54cd7fd764d9ffe7$var$placeholderTextPlugin = ({ config: options = {}, api: api })=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') && options.allowInserting) api?.uiControlRegistry?.actions.register((0, $58520e9e4a51fe67$export$45d515f9e642ad8b)({
        api: api
    }));
    return $54cd7fd764d9ffe7$var$decorateWithPluginOptions($54cd7fd764d9ffe7$var$basePlaceholderTextPlugin({
        config: options,
        api: api
    }), options, api);
};
var $54cd7fd764d9ffe7$export$2e2bcd8739ae039 = $54cd7fd764d9ffe7$var$placeholderTextPlugin;
module.exports["default"] = $54cd7fd764d9ffe7$export$2e2bcd8739ae039;

});

parcelRegister("3VDvd", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $3brWT = parcelRequire("3brWT");

const $5897a92d13a27703$export$a86035451b36e0f9 = new (0, $kCECX.PluginKey)('scrollIntoViewPlugin');
/**
 * Determines if a transaction contains changes that should trigger scrolling into view.
 * This includes:
 * - Specific step types (Replace, ReplaceAround)
 */ const $5897a92d13a27703$var$hasRelevantChanges = (tr)=>{
    // Check if there are any steps that modified the document
    if (!tr.docChanged) return false;
    // Look for specific types of steps that should trigger scrolling
    const hasRelevantStep = tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    return hasRelevantStep;
};
const $5897a92d13a27703$var$createPlugin = ()=>new (0, $kpCD8.SafePlugin)({
        key: $5897a92d13a27703$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if (($5897a92d13a27703$var$hasRelevantChanges(tr) || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $3brWT.TEXT_INPUT_RULE_TRANSACTION_KEY)) && // ignore appended transactions as they should be treated as side effects
            tr.getMeta('appendedTransaction') === undefined) return newState.tr.scrollIntoView();
        }
    });
const $5897a92d13a27703$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$5897a92d13a27703$var$createPlugin()
                }
            ];
        }
    });
module.exports["scrollIntoViewPlugin"] = $5897a92d13a27703$export$750392944713b1a5;

});

parcelRegister("drevR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $PYwg9 = parcelRequire("PYwg9");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");





var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $gZpSA = parcelRequire("gZpSA");


var $eDtFr = parcelRequire("eDtFr");


var $4o0zT = parcelRequire("4o0zT");


var $2nOF5 = parcelRequire("2nOF5");





var $eEdSM = parcelRequire("eEdSM");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");





var $iDrrr = parcelRequire("iDrrr");

const $0a3bbbbfbf46e4f6$export$ac80046fa87f5a7a = {
    text: '',
    color: 'neutral'
};
const $0a3bbbbfbf46e4f6$export$42634a38572cebab = {
    text: '',
    color: 'neutral',
    style: 'mixedCase'
};
const $0a3bbbbfbf46e4f6$export$f6d65cccf81e7a40 = ()=>(0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $0a3bbbbfbf46e4f6$export$42634a38572cebab : $0a3bbbbfbf46e4f6$export$ac80046fa87f5a7a;
const $0a3bbbbfbf46e4f6$export$bc38267ef98d9f2 = (schema, attrs = {}, marks)=>schema.nodes.status.createChecked({
        ...$0a3bbbbfbf46e4f6$export$f6d65cccf81e7a40(),
        localId: (0, $2nOF5.uuid).generate(),
        ...attrs
    }, null, marks);





const $b900a37c29c42ee1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('statusPlugin');


const $35c8ece4f44259bc$export$83bafcce64b36a62 = (statusNode, tr, annotationMarks)=>{
    const fragment = (0, $aPdNQ.Fragment).fromArray([
        statusNode,
        tr.doc.type.schema.text(' ', annotationMarks)
    ]);
    const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
    if (!insertable) {
        const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
        tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
    } else tr.insert(tr.selection.from, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
    return tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
        showStatusPickerAt: tr.selection.from,
        isNew: true
    }).scrollIntoView();
};
const $35c8ece4f44259bc$export$1cefe804e0e75f6d = (tr)=>{
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
    const statusNode = (0, $0a3bbbbfbf46e4f6$export$bc38267ef98d9f2)(tr.doc.type.schema, {}, annotationMarksForPos);
    return $35c8ece4f44259bc$export$83bafcce64b36a62(statusNode, tr, annotationMarksForPos);
};
const $35c8ece4f44259bc$export$84e57993298e69f2 = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>({ tr: tr })=>{
            const statusTr = $35c8ece4f44259bc$export$1cefe804e0e75f6d(tr);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(statusTr);
            return statusTr;
        };
const $35c8ece4f44259bc$export$dd127eb7207846ef = (status)=>(state, dispatch)=>{
        const { schema: schema } = state;
        const selectedStatus = status ? Object.assign(status, {
            text: status.text.trim(),
            localId: status.localId || (0, $2nOF5.uuid).generate()
        }) : status;
        const statusProps = {
            ...(0, $0a3bbbbfbf46e4f6$export$f6d65cccf81e7a40)(),
            ...selectedStatus
        };
        let tr = state.tr;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
        if (!showStatusPickerAt) {
            // Same behaviour as quick insert (used in createStatus)
            const statusNode = schema.nodes.status.createChecked(statusProps);
            tr = $35c8ece4f44259bc$export$83bafcce64b36a62(statusNode, state.tr);
            if (dispatch) dispatch(tr);
            return true;
        }
        if (state.doc.nodeAt(showStatusPickerAt)) {
            tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps).setSelection((0, $kCECX.NodeSelection).create(tr.doc, showStatusPickerAt)).setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
                showStatusPickerAt: showStatusPickerAt
            }).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $35c8ece4f44259bc$export$2d82855a8f0dcacb = (editorAnalyticsAPI)=>(inputMethod, status)=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).STATUS,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })($35c8ece4f44259bc$export$dd127eb7207846ef(status));
const $35c8ece4f44259bc$export$9bef27b5339b1a7a = (showStatusPickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            showStatusPickerAt: showStatusPickerAt,
            isNew: false
        }));
        return true;
    };
const $35c8ece4f44259bc$export$38345b9b03bc4599 = (showStatusPickerAt)=>({ tr: tr })=>{
        tr.replace(showStatusPickerAt, showStatusPickerAt + 1);
        return tr;
    };
const $35c8ece4f44259bc$export$89aebd528a1fddb6 = ()=>(state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            focusStatusInput: true
        });
        dispatch(tr);
        return true;
    };
const $35c8ece4f44259bc$var$handleClosingByArrows = (closingMethod, state, showStatusPickerAt, tr)=>{
    if (closingMethod === 'arrowLeft') // put cursor right before status Lozenge
    tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt), -1));
    else if (closingMethod === 'arrowRight') // put cursor right after status Lozenge
    tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 1)));
};
const $35c8ece4f44259bc$export$cdfbbd5b38df803 = (closingPayload)=>(editorView)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
        const { closingMethod: closingMethod } = closingPayload || {};
        if (!showStatusPickerAt) return;
        const statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
        if (!statusNode) return;
        let tr = state.tr;
        tr = tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            showStatusPickerAt: null,
            focusStatusInput: false,
            isNew: false
        });
        if (closingMethod) $35c8ece4f44259bc$var$handleClosingByArrows(closingMethod, state, showStatusPickerAt, tr);
        else if (statusNode.attrs.text) // still has content - keep content
        // move selection after status if selection did not change
        {
            if (tr.selection.from === showStatusPickerAt) tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 2)));
        } else // no content - remove node
        tr = tr.delete(showStatusPickerAt, showStatusPickerAt + 1);
        dispatch(tr);
        editorView.focus();
    };






var $44cyU = parcelRequire("44cyU");









const $e5fba860dcc119fa$export$ae039c0c89d3061 = (selection)=>{
    if (selection && selection instanceof (0, $kCECX.NodeSelection)) {
        const nodeSelection = selection;
        if (nodeSelection.node.type.name === 'status') return selection.node.attrs || null;
    }
    return null;
};
const $e5fba860dcc119fa$export$4e209830f320e9a = (node)=>node && (node.text && node.text.trim().length === 0 || node.text === '');
const $e5fba860dcc119fa$export$9a35f63e5088c6ab = (tr, pos)=>tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(pos)));


function $52f20a93e5d9fb1b$export$e832373cff8dec22() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $52f20a93e5d9fb1b$var$consumeKeyEvent, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch)=>{
        const statusPluginState = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state);
        const isStatusNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.status : false;
        if (!isStatusNode) return false;
        if (statusPluginState?.showStatusPickerAt) {
            (0, $35c8ece4f44259bc$export$89aebd528a1fddb6)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
// consume event to prevent status node problems with positioning and selection
const $52f20a93e5d9fb1b$var$consumeKeyEvent = (state, _dispatch)=>!!(0, $e5fba860dcc119fa$export$ae039c0c89d3061)(state.tr.selection);
var $52f20a93e5d9fb1b$export$2e2bcd8739ae039 = $52f20a93e5d9fb1b$export$e832373cff8dec22;



var $kpCD8 = parcelRequire("kpCD8");


var $2w79Z = parcelRequire("2w79Z");





var $4rQbz = parcelRequire("4rQbz");







const $fe95de65db8ec438$export$8a37d2efeae0a4ed = (color)=>color.startsWith('#') ? color.toUpperCase() : color;



var $8dxef = parcelRequire("8dxef");


var $8Dx7s = parcelRequire("8Dx7s");


var $fngNp = parcelRequire("fngNp");





// eg. Version/4.0 Chrome/95.0.4638.50
const $32a8240ea4dc6188$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/u.test(window.navigator.userAgent);
const $32a8240ea4dc6188$export$5318aa2f7ab92c01 = (node)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    const { text: text, color: color, style: style, localId: localId } = node.attrs;
    const dataColor = (0, $fe95de65db8ec438$export$8a37d2efeae0a4ed)(color);
    const editorNodeWrapperAttrs = {
        class: 'statusView-content-wrap inlineNodeView',
        'data-testid': 'statusContainerView',
        'data-prosemirror-node-name': 'status',
        localid: localId,
        // Required for parseDOM to correctly parse status when NodeView DOM is copied directly
        'data-node-type': 'status',
        'data-color': dataColor,
        'data-text': text // Text stored as attribute for parseDOM extraction
    };
    const statusElementAttrs = {
        style: (0, $8Dx7s.convertToInlineCss)($32a8240ea4dc6188$var$isAndroidChromium ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'inline-block !important',
            verticalAlign: 'middle'
        } : {}),
        class: 'status-lozenge-span',
        'data-node-type': 'status',
        'data-color': dataColor,
        'data-style': style
    };
    const lozengeWrapperAttrs = {
        class: 'lozenge-wrapper'
    };
    const lozengeTextAttrs = {
        class: 'lozenge-text',
        style: (0, $8Dx7s.convertToInlineCss)({
            ...(0, $iDrrr.fg)('platform-lozenge-custom-letterspacing') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                letterSpacing: '0.165px'
            } : {},
            ...style !== 'mixedCase' && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                textTransform: 'uppercase'
            } : {}
        })
    };
    return [
        'span',
        editorNodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            statusElementAttrs,
            [
                'span',
                lozengeWrapperAttrs,
                [
                    'span',
                    lozengeTextAttrs,
                    text
                ]
            ]
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $3062ceff56f48f4a$export$54e825089e34a876 {
    setPlaceholder() {
        if (this.textContainer && this.domElement) {
            this.textContainer.textContent = this.intl.formatMessage((0, $4rQbz.messages).placeholder);
            this.domElement.style.setProperty('opacity', '0.83');
        }
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        if (node.type !== this.node.type) return false;
        if (this.textContainer && node.attrs.text !== this.node.attrs.text) {
            this.textContainer.textContent = node.attrs.text;
            // Also update data-text on outer wrapper for parseDOM extraction when copying
            this.domElement?.setAttribute('data-text', node.attrs.text);
        }
        if (this.textContainer && node.attrs.style !== this.node.attrs.style && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) this.textContainer.style.textTransform = node.attrs.style !== 'mixedCase' ? 'uppercase' : '';
        if (node.attrs.color !== this.node.attrs.color) {
            const dataColor = (0, $fe95de65db8ec438$export$8a37d2efeae0a4ed)(node.attrs.color);
            this.box?.setAttribute('data-color', dataColor);
            // Also update data-color on outer wrapper for parseDOM extraction when copying
            this.domElement?.setAttribute('data-color', dataColor);
        }
        if (!node.attrs.text) this.setPlaceholder();
        if (node.attrs.text && this.domElement) this.domElement.style.setProperty('opacity', '1');
        this.node = node;
        return true;
    }
    /**
   *
   * @param node
   * @param intl
   * @example
   */ constructor(node, intl){
        this.dom = void 0;
        this.domElement = void 0;
        this.box = null;
        this.textContainer = null;
        this.node = void 0;
        this.intl = void 0;
        this.node = node;
        this.intl = intl;
        const spec = (0, $32a8240ea4dc6188$export$5318aa2f7ab92c01)(node);
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if (this.domElement) {
            this.box = this.domElement.querySelector('.status-lozenge-span');
            this.textContainer = this.domElement.querySelector('.lozenge-text');
        }
        if (!node.attrs.text) this.setPlaceholder();
    }
}




const $0d68e47196c4702b$var$createPlugin = (pmPluginFactoryParams, options)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    isNew: false,
                    showStatusPickerAt: null,
                    focusStatusInput: false
                }),
            apply (tr, state, oldEditorState) {
                const meta = tr.getMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.showStatusPickerAt);
                    const showStatusPickerAt = deleted ? null : pos;
                    const newState = {
                        ...state,
                        showStatusPickerAt: showStatusPickerAt
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                if (tr.selectionSet) {
                    // Change in selection, while status picker was open, update state, if required.
                    const selectionFrom = tr.selection.from;
                    const nodeAtSelection = tr.doc.nodeAt(selectionFrom);
                    let showStatusPickerAt = null;
                    if (nodeAtSelection && nodeAtSelection.type === oldEditorState.schema.nodes.status && tr.selection instanceof (0, $kCECX.NodeSelection)) showStatusPickerAt = selectionFrom;
                    if (showStatusPickerAt !== state.showStatusPickerAt) {
                        const newState = {
                            ...state,
                            isNew: false,
                            showStatusPickerAt: showStatusPickerAt,
                            focusStatusInput: false
                        };
                        pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                return state;
            }
        },
        filterTransaction: (tr, state)=>{
            // if it is a selection change transaction, and selection changes from node to text
            if (tr.selectionSet && !tr.steps.length && tr.isGeneric && tr.selection instanceof (0, $kCECX.TextSelection) && state.selection instanceof (0, $kCECX.NodeSelection)) {
                const { isNew: isNew, showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
                const nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                // prevent changing node selection to text selection on dom change right after inserting status
                // if newly selected status is selected with status picker opened
                if (isNew && showStatusPickerAt && nodeAtSelection && nodeAtSelection.type === state.schema.nodes.status) return false;
            }
            return true;
        },
        appendTransaction: (transactions, oldEditorState, newEditorState)=>{
            let changed = false;
            const tr = newEditorState.tr;
            /**
			 * When user start creating status, and, when users navigates away
			 *  while empty, then we want to remove empty ("set a status") status.
			 * But when transaction to add empty status happens from undo/redo
			 *  we don't want to remove it.
			 */ if (transactions.find((tr)=>tr.selectionSet && !tr.getMeta((0, $2w79Z.pmHistoryPluginKey)))) {
                const oldStatus = (0, $e5fba860dcc119fa$export$ae039c0c89d3061)(oldEditorState.selection);
                const newStatus = (0, $e5fba860dcc119fa$export$ae039c0c89d3061)(newEditorState.selection);
                if (oldStatus && (newStatus && oldStatus.localId !== newStatus.localId || !newStatus)) {
                    if ((0, $e5fba860dcc119fa$export$4e209830f320e9a)(oldStatus)) {
                        const pos = oldEditorState.selection.from;
                        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + 1));
                        changed = true;
                    }
                }
            }
            return changed ? tr : undefined;
        },
        key: (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                status: (node)=>{
                    return new (0, $3062ceff56f48f4a$export$54e825089e34a876)(node, pmPluginFactoryParams.getIntl());
                }
            }
        }
    });
var $0d68e47196c4702b$export$2e2bcd8739ae039 = $0d68e47196c4702b$var$createPlugin;







var $cozmU = parcelRequire("cozmU");


var $4y8CY = parcelRequire("4y8CY");












var $fB42n = parcelRequire("fB42n");

const $c2056d0558fc8772$export$9e316df46dca86d0 = 20;
const $c2056d0558fc8772$export$33b7003a8d67e410 = 7;
// `color` may be a legacy name or a hex value that render the same hue (e.g. `green` and
// `#D3F1A7` both resolve to `accent-lime`), so the key is built from the resolved appearance
// rather than the raw attribute value — otherwise both variants would surface as suggestions.
const $c2056d0558fc8772$var$getStatusKey = ({ color: color, text: text })=>`${(0, $fB42n.getLozengeAppearance)(color)}:${text.trim().toLowerCase()}`;
const $c2056d0558fc8772$var$getDisplayText = (status, shouldUppercaseText)=>shouldUppercaseText && status.style !== 'mixedCase' ? status.text.toUpperCase() : status.text;
const $c2056d0558fc8772$export$8db4724ea852799d = ({ currentPos: currentPos, currentStatus: currentStatus, doc: doc, limit: limit = $c2056d0558fc8772$export$9e316df46dca86d0, shouldUppercaseText: shouldUppercaseText = false })=>{
    const closestStatusesByKey = new Map();
    const currentStatusKey = $c2056d0558fc8772$var$getStatusKey(currentStatus);
    doc.descendants((node, pos)=>{
        if (node.type.name !== 'status' || pos === currentPos) return;
        const text = typeof node.attrs.text === 'string' ? node.attrs.text.trim() : '';
        if (!text) return;
        const status = {
            color: node.attrs.color,
            localId: node.attrs.localId,
            style: node.attrs.style,
            text: text
        };
        const statusKey = $c2056d0558fc8772$var$getStatusKey(status);
        if (status.localId === currentStatus.localId || statusKey === currentStatusKey) return;
        const existingStatus = closestStatusesByKey.get(statusKey);
        const nextStatus = {
            ...status,
            distance: Math.abs(pos - currentPos),
            displayText: $c2056d0558fc8772$var$getDisplayText(status, shouldUppercaseText)
        };
        if (!existingStatus || nextStatus.distance < existingStatus.distance) closestStatusesByKey.set(statusKey, nextStatus);
    });
    return Array.from(closestStatusesByKey.values()).sort((statusA, statusB)=>{
        if (statusA.distance !== statusB.distance) return statusA.distance - statusB.distance;
        if (statusA.displayText !== statusB.displayText) return statusA.displayText.localeCompare(statusB.displayText);
        return statusA.color.localeCompare(statusB.color);
    }).slice(0, limit).map(({ distance: _distance, ...status })=>status);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $lzgC6 = parcelRequire("lzgC6");


var $1hQ0e = parcelRequire("1hQ0e");





var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $3v5aK = parcelRequire("3v5aK");


var $7Y8M5 = parcelRequire("7Y8M5");





var $2pQiO = parcelRequire("2pQiO");





var $fhdGv = parcelRequire("fhdGv");

/* StatusPicker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");











var $4yg9g = parcelRequire("4yg9g");




const $65a3acb62cce22b1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    neutralColor: {
        id: "fabric.status.color.grey",
        defaultMessage: "Gray"
    },
    purpleColor: {
        id: "fabric.status.color.purple",
        defaultMessage: "Purple"
    },
    blueColor: {
        id: "fabric.status.color.blue",
        defaultMessage: "Blue"
    },
    redColor: {
        id: "fabric.status.color.red",
        defaultMessage: "Red"
    },
    yellowColor: {
        id: "fabric.status.color.yellow",
        defaultMessage: "Yellow"
    },
    greenColor: {
        id: "fabric.status.color.green",
        defaultMessage: "Green"
    },
    tealColor: {
        id: "fabric.status.color.teal",
        defaultMessage: "Teal"
    },
    limeColor: {
        id: "fabric.status.color.lime",
        defaultMessage: "Lime"
    },
    orangeColor: {
        id: "fabric.status.color.orange",
        defaultMessage: "Orange"
    },
    magentaColor: {
        id: "fabric.status.color.magenta",
        defaultMessage: "Magenta"
    },
    statusInputLabel: {
        id: "fabric.status.input.label",
        defaultMessage: "Set a status"
    }
});


/* color-palette.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $IQ4Dz = parcelRequire("IQ4Dz");




/* color.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $eh6Ml = parcelRequire("eh6Ml");


var $hBYtq = parcelRequire("hBYtq");


var $jDboD = parcelRequire("jDboD");





function $a08a82db344faf50$var$_defineProperty(e, r, t) {
    return (r = $a08a82db344faf50$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a08a82db344faf50$var$_toPropertyKey(t) {
    var i = $a08a82db344faf50$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a08a82db344faf50$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a08a82db344faf50$var$styles = {
    button: "_0bjKvDKxmn _30huDKOeNX _4bt5LAnQyn _2WAcuGnQyn _0jFU0VoWWg _39xV02oWWg _0KLXruDMqu _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _3iDTPbvLZJ"
};
const $a08a82db344faf50$var$buttonWrapperStyles = null;
class $a08a82db344faf50$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { tabIndex: tabIndex, backgroundColor: backgroundColor, isSelected: isSelected, borderColor: borderColor, iconColor: iconColor, value: value, setRef: setRef, onKeyDown: onKeyDown } = this.props;
        return /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_0bjKvDgVvo _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _313842Pgdg _0adFHsFQfX _1DCdHiPgdg _2XsHFMFQfX _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2NvrM _1ZnuxbNvrM _1wydGWNvrM _2Zuz6QNvrM _0KOPe2OeNX"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $65a3acb62cce22b1$export$defe85febe8b728c)[(0, $fB42n.getColorLabelKey)(value)], (labels)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                xcss: $a08a82db344faf50$var$styles.button,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                onKeyDown: onKeyDown,
                tabIndex: tabIndex,
                title: labels[0],
                // For button selected (to be precise pressed) or not
                //  use aria-pressed as per
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
                "aria-pressed": isSelected,
                style: {
                    backgroundColor: backgroundColor || 'transparent',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    color: iconColor,
                    borderColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderColor
                },
                ref: setRef
            }, isSelected && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                color: "currentColor",
                label: labels[0]
            }))));
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    constructor(...args){
        super(...args);
        $a08a82db344faf50$var$_defineProperty(this, "hoverStartTime", 0);
        $a08a82db344faf50$var$_defineProperty(this, "onMouseEnter", ()=>{
            this.hoverStartTime = Date.now();
        });
        $a08a82db344faf50$var$_defineProperty(this, "onMouseLeave", ()=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover(this.props.value);
            this.hoverStartTime = 0;
        });
        $a08a82db344faf50$var$_defineProperty(this, "onMouseDown", (e)=>{
            e.preventDefault();
        });
        $a08a82db344faf50$var$_defineProperty(this, "onClick", (e)=>{
            const { onClick: onClick, value: value } = this.props;
            e.preventDefault();
            onClick(value);
        });
    }
}


const $96a1f0b2ea65eaba$var$paletteLegacy = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery, #F8EEFE)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon-discovery, #AF59E1)"
    ],
    [
        'blue',
        "var(--ds-background-information, #E9F2FE)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon-information, #357DE8)"
    ],
    [
        'red',
        "var(--ds-background-danger, #FFECEB)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon-danger, #C9372C)"
    ],
    [
        'yellow',
        "var(--ds-background-warning, #FFF5DB)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon-warning, #E06C00)"
    ],
    [
        'green',
        "var(--ds-background-success, #EFFFD6)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon-success, #6A9A23)"
    ]
];
const $96a1f0b2ea65eaba$var$paletteRefreshed = [
    [
        'neutral',
        "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-pressed, #ADCBFB)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-pressed, #BDE97C)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-pressed, #FBD779)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-pressed, #FFB8B2)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-pressed, #E3BDFA)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon, #292A2E)"
    ]
];
const $96a1f0b2ea65eaba$var$paletteTeam26 = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        '#CACBCF',
        '#63666B',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-subtler, #CFE1FD)",
        '#8FB8F6',
        '#1558BC',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-subtler, #D3F1A7)",
        '#B3DF72',
        '#4C6B1F',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-subtler, #FCE4A6)",
        '#FBC828',
        '#9E4C00',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-subtler, #FFD5D2)",
        '#FD9891',
        '#AE2E24',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-subtler, #EED7FC)",
        '#D8A0F7',
        '#803FA5',
        "var(--ds-icon, #292A2E)"
    ]
];
// and the i18n keys cannot drift apart. See COLORS.
const $96a1f0b2ea65eaba$var$paletteHex = (0, $fB42n.PICKER_SWATCHES).flatMap((value)=>{
    const swatch = (0, $fB42n.COLORS)[value].swatch;
    return swatch ? [
        [
            value,
            swatch.backgroundColor,
            swatch.borderColor,
            (0, $fB42n.SWATCH_ICON_COLOR)
        ]
    ] : [];
}); /** Columns each variant is laid out in; `extended` wraps its ten swatches onto two rows. */ 
const $96a1f0b2ea65eaba$var$variantToCols = {
    default: 7,
    extended: 5
};
const $96a1f0b2ea65eaba$var$getPalette = (colorMode, variant = 'default')=>{
    if (variant === 'extended') return $96a1f0b2ea65eaba$var$paletteHex;
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const isDark = colorMode === 'dark';
        return $96a1f0b2ea65eaba$var$paletteTeam26.map(([colorValue, backgroundColor, lightBorderColor, darkBorderColor, iconColor])=>[
                colorValue,
                backgroundColor,
                isDark ? darkBorderColor : lightBorderColor,
                iconColor
            ]);
    }
    return (0, $iDrrr.fg)('platform-component-visual-refresh') ? $96a1f0b2ea65eaba$var$paletteRefreshed : $96a1f0b2ea65eaba$var$paletteLegacy;
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $96a1f0b2ea65eaba$var$colorPaletteWrapperStyles = null;
const $96a1f0b2ea65eaba$var$colorPaletteRowGapStyles = null;
var $96a1f0b2ea65eaba$export$2e2bcd8739ae039 = ({ cols: cols, onClick: onClick, selectedColor: selectedColor, className: className, onHover: onHover, palette: variant = 'default' })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const palette = $96a1f0b2ea65eaba$var$getPalette(colorMode, variant);
    const resolvedCols = cols ?? $96a1f0b2ea65eaba$var$variantToCols[variant];
    const colorRefs = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        colorRefs.current = colorRefs.current.slice(0, palette.length);
    }, [
        palette.length
    ]);
    const createKeyDownHandler = (0, $cozmU.useCallback)((index)=>(e)=>{
            let newColorIndex = null;
            const nextColor = ()=>index + 1 > palette.length - 1 ? 0 : index + 1;
            const previousColor = ()=>index - 1 < 0 ? palette.length - 1 : index - 1;
            switch(e.key){
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    newColorIndex = nextColor();
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    newColorIndex = previousColor();
                    break;
            }
            if (newColorIndex === null) return;
            colorRefs.current[newColorIndex]?.focus();
        }, [
        colorRefs,
        palette.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_2Zuz6QdnbC _3138422ADO _0adFHs2ADO _1DCdHidnbC _2XsHFM2ADO _3iDTPbQ4SZ _3TGfC9HnLE",
            variant === 'extended' && "_42d1HA1Y8M",
            className
        ]),
        style: {
            maxWidth: resolvedCols * 32
        }
    }, palette.map(([colorValue, backgroundColor, borderColor, iconColor], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a08a82db344faf50$export$2e2bcd8739ae039), {
            key: colorValue,
            value: colorValue,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            iconColor: iconColor,
            onClick: onClick,
            onHover: onHover,
            isSelected: (0, $fB42n.isSwatchSelected)(colorValue, selectedColor),
            tabIndex: i === 0 ? 0 : -1,
            setRef: (el)=>colorRefs.current[i] = el,
            onKeyDown: createKeyDownHandler(i)
        })));
};


function $5a1082336b950663$var$_defineProperty(e, r, t) {
    return (r = $5a1082336b950663$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5a1082336b950663$var$_toPropertyKey(t) {
    var i = $5a1082336b950663$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5a1082336b950663$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $5a1082336b950663$var$fieldTextWrapperStyles = null;
const $5a1082336b950663$var$scrollContainerStyles = null;
const $5a1082336b950663$var$paletteWrapperStyles = null;
const $5a1082336b950663$var$scrollHeightStylesOld = {
    default: "_0NUa3rVJXy",
    extended: "_0NUa3rJgqs"
}; // Remove when cleaning up `platform_editor_status_popup_suggestions_patch_3`: `extended`
// already always uses this value below, and `default` should too, unconditionally.
const $5a1082336b950663$var$scrollHeightStyles = null;
class $5a1082336b950663$var$Picker extends (0, $cozmU.PureComponent) {
    render() {
        const { text: text, selectedColor: selectedColor, onColorClick: onColorClick, onColorHover: onColorHover, intl: intl, scrollableContent: scrollableContent, palette: palette } = this.props;
        const colorPalette = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96a1f0b2ea65eaba$export$2e2bcd8739ae039), {
            key: this.colorPaletteKey,
            onClick: onColorClick,
            onHover: onColorHover,
            selectedColor: selectedColor,
            palette: palette
        });
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: this.fieldTextWrapperKey,
            className: (0, $hekY6.default)([
                "_313842dnbC _1DCdHidnbC _0adFHs2ADO _2XsHFM2ADO _1wOe4kWkXl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            value: text,
            isCompact: true,
            ref: this.handleInputRef,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            spellCheck: false,
            autoComplete: "off",
            "aria-label": intl.formatMessage((0, $65a3acb62cce22b1$export$defe85febe8b728c).statusInputLabel)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3138422ADO"
            ])
        }, colorPalette), scrollableContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-status-picker-scroll-container": true,
            className: (0, $hekY6.default)([
                "_2WAcuGIZbP _2KmZ0yYbGa _39xV02N91d",
                palette === 'extended' || (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_3') ? "_0NUa3roaux" : $5a1082336b950663$var$scrollHeightStylesOld[palette ?? 'default']
            ])
        }, scrollableContent) : null);
    }
    componentDidUpdate() {
        if (this.inputRef && this.props.autoFocus) this.focusInput();
    }
    componentWillUnmount() {
        if (this.autofocusTimeout !== undefined) clearTimeout(this.autofocusTimeout);
    }
    constructor(...args){
        super(...args);
        $5a1082336b950663$var$_defineProperty(this, "inputRef", void 0);
        $5a1082336b950663$var$_defineProperty(this, "autofocusTimeout", void 0);
        $5a1082336b950663$var$_defineProperty(this, "fieldTextWrapperKey", Math.random().toString());
        $5a1082336b950663$var$_defineProperty(this, "colorPaletteKey", Math.random().toString());
        $5a1082336b950663$var$_defineProperty(this, "onChange", (evt)=>{
            // @ts-ignore
            this.props.onTextChanged(evt.target.value);
        });
        $5a1082336b950663$var$_defineProperty(this, "onKeyPress", (event)=>{
            if (event.key === 'Enter') this.props.onEnter();
        });
        $5a1082336b950663$var$_defineProperty(this, "handleInputRef", (ref)=>{
            this.inputRef = ref;
            if (ref && this.props.autoFocus) this.focusInput();
        });
        $5a1082336b950663$var$_defineProperty(this, "focusInput", ()=>{
            if (!this.inputRef) return;
             // Defer to prevent editor scrolling to top
            this.autofocusTimeout = setTimeout(()=>{
                this.inputRef?.focus();
            });
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
$5a1082336b950663$var$_defineProperty($5a1082336b950663$var$Picker, "defaultProps", {
    autoFocus: true
});
const $5a1082336b950663$export$39975ce689bf0105 = (0, $kSwu1.injectIntl)($5a1082336b950663$var$Picker);



var $9GVkD = parcelRequire("9GVkD");


const $03737233c2d85182$export$7787c7adba71b8c3 = 'fabric-elements';
const $03737233c2d85182$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent && payload) {
            const statusPayload = {
                ...payload,
                eventType: 'ui'
            };
            if (!statusPayload.attributes) statusPayload.attributes = {};
            statusPayload.attributes.componentName = 'status';
            createAnalyticsEvent(statusPayload).fire($03737233c2d85182$export$7787c7adba71b8c3);
        }
    };
const $03737233c2d85182$export$69e00be7c24e6455 = (isNew)=>isNew ? 'new' : 'update';


function $7d3151e91594125f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d3151e91594125f$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
var $7d3151e91594125f$export$4182489224ea9c47 = /*#__PURE__*/ function(InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
    return InputMethod;
}({});
var $7d3151e91594125f$export$cc742728d048210b = /*#__PURE__*/ function(closingMethods) {
    closingMethods["ArrowLeft"] = "arrowLeft";
    closingMethods["ArrowRight"] = "arrowRight";
    return closingMethods;
}({});
const $7d3151e91594125f$var$pickerContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase'
    }
});
const $7d3151e91594125f$var$pickerContainerStylesTeam26 = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':focus': {
        outline: 'none'
    }
});
// Remove when cleaning up `platform_editor_status_popup_suggestions_patch_3`: merge
// `paddingBottom: 0` into `pickerContainerStyles`/`pickerContainerStylesTeam26`. The
// scrollable suggestions area already supplies its own trailing padding once actually
// scrolled to the end, so the outer wrapper's own bottom padding is only ever extra
// whitespace below the (fixed-height) scroll box, most visible right under the half-cut
// row when unscrolled.
const $7d3151e91594125f$var$pickerContainerNoBottomPaddingStyles = {
    name: "18g08sj",
    styles: "padding-bottom:0"
};
// Remove when cleaning up `platform_editor_status_popup_suggestions_patch_3`: merge into
// `suggestedStatusesContainerStyles`. Matches the list's own top padding (`space.100`) so the
// gap above the first suggestion and the gap below the last (once scrolled to the true end)
// are the same size.
const $7d3151e91594125f$var$suggestedStatusesContainerAlignedBottomPaddingStyles = {
    name: "oh3jj1",
    styles: "padding-bottom:var(--ds-space-100, 8px)"
};
const $7d3151e91594125f$var$suggestedStatusesContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    gap: "var(--ds-space-100, 8px)",
    margin: 0,
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-050, 4px)"}`
});
// Fixed input plus capped scrolling color controls and suggestions. The ten-color picker is
// taller because it carries a second swatch row.
const $7d3151e91594125f$var$STATUS_PICKER_FIT_HEIGHT = 236;
// Remove when cleaning up `platform_editor_status_popup_suggestions_patch_3`.
const $7d3151e91594125f$var$STATUS_PICKER_FIT_HEIGHT_OLD = 288;
const $7d3151e91594125f$var$STATUS_PICKER_TEN_COLOR_FIT_HEIGHT = 268;
// ColorPalette: swatches per row * 32px slot + 16px inline margin.
const $7d3151e91594125f$var$STATUS_PICKER_CONTENT_WIDTH = 208; // 6 * 32 + 16
const $7d3151e91594125f$var$STATUS_PICKER_TEN_COLOR_CONTENT_WIDTH = 176; // 5 * 32 + 16
const $7d3151e91594125f$var$statusPickerWidthStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    width: `${$7d3151e91594125f$var$STATUS_PICKER_CONTENT_WIDTH}px`
});
const $7d3151e91594125f$var$statusPickerWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    width: `${$7d3151e91594125f$var$STATUS_PICKER_TEN_COLOR_CONTENT_WIDTH}px`
});
// When cleaning up `platform_editor_status_popup_suggestions_patch_1`, merge this into
// `suggestedStatusesContainerStyles` and remove its conditional style array.
const $7d3151e91594125f$var$suggestedStatusesContainerPatchStyles = {
    name: "1papjx",
    styles: "gap:var(--ds-space-050, 4px);padding-left:var(--ds-space-100, 8px)"
};
const $7d3151e91594125f$var$suggestedStatusButtonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: 'transparent',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'pointer',
    justifyContent: 'flex-start',
    padding: 0,
    '&:focus-visible': {
        outline: `2px solid ${"var(--ds-border-focused, #0C66E4)"}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});
// Remove when cleaning up `platform_editor_status_popup_suggestions_patch_1`.
const $7d3151e91594125f$var$suggestedStatusButtonOldStyles = {
    name: "7whenc",
    styles: "display:flex;width:100%"
};
const $7d3151e91594125f$var$suggestedStatusButtonWrapperStyles = {
    name: "zd7plg",
    styles: "align-self:flex-start;border-width:var(--ds-border-width, 1px);border-style:solid;border-color:transparent;border-radius:var(--ds-space-075, 6px);box-sizing:border-box;display:flex;margin-left:var(--ds-space-025, 2px);max-width:100%;padding-block:var(--ds-border-width, 1px);padding-inline:var(--ds-border-width, 1px);&:hover{border-color:var(--ds-border, #091E4224);}"
};
// When cleaning up `platform_editor_status_popup_suggestions_patch_1`, merge this into
// `suggestedStatusButtonStyles` and remove its conditional style array.
const $7d3151e91594125f$var$suggestedStatusButtonPatchStyles = {
    name: "ovk77c",
    styles: "min-width:0"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7d3151e91594125f$var$StatusPickerWithIntl extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    fireStatusPopupOpenedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.startTime = Date.now();
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $03737233c2d85182$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    fireStatusPopupClosedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: this.inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $03737233c2d85182$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    reset() {
        this.startTime = Date.now();
        this.inputMethod = "blur";
    }
    componentDidMount() {
        this.reset();
        this.fireStatusPopupOpenedAnalytics(this.state);
    }
    componentWillUnmount() {
        this.focusTimeout && cancelAnimationFrame(this.focusTimeout);
        this.fireStatusPopupClosedAnalytics(this.state);
        this.startTime = 0;
    }
    componentDidUpdate(prevProps, prevState) {
        const element = this.props.target;
        if (prevProps.target !== element) {
            const newState = this.extractStateFromProps(this.props);
            this.setState(newState);
            this.fireStatusPopupClosedAnalytics(prevState);
            this.reset();
            this.fireStatusPopupOpenedAnalytics(newState);
        }
    }
    extractStateFromProps(props) {
        const { defaultColor: defaultColor, defaultText: defaultText, defaultLocalId: defaultLocalId, isNew: isNew } = props;
        return {
            color: defaultColor || (0, $0a3bbbbfbf46e4f6$export$ac80046fa87f5a7a).color,
            text: defaultText || (0, $0a3bbbbfbf46e4f6$export$ac80046fa87f5a7a).text,
            localId: defaultLocalId,
            isNew: isNew
        };
    }
    setRef(setOutsideClickTargetRef) {
        return (ref)=>{
            setOutsideClickTargetRef(ref);
            this.popupBodyWrapper.current = ref;
        };
    }
    renderWithSetOutsideClickTargetRef(setOutsideClickTargetRef) {
        const { isNew: isNew, focusStatusInput: focusStatusInput, api: api, suggestedStatuses: suggestedStatuses } = this.props;
        const { color: color, text: text } = this.state;
        const suggestionsPatchEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_status_popup_suggestions') && (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_1');
        const isUpdateStatusColorsEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_update_status_colors') || (0, $4o0zT.isExperimentEnabled)('platform_editor_update_status_colors_jira');
        const suggestedStatusList = suggestedStatuses?.length && (0, $4o0zT.isExperimentEnabled)('platform_editor_status_popup_suggestions') ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $7d3151e91594125f$var$suggestedStatusesContainerStyles,
                suggestionsPatchEnabled ? $7d3151e91594125f$var$suggestedStatusesContainerPatchStyles : undefined,
                suggestionsPatchEnabled && (isUpdateStatusColorsEnabled || (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_3')) ? $7d3151e91594125f$var$suggestedStatusesContainerAlignedBottomPaddingStyles : undefined
            ],
            "data-suggested-status-list": true
        }, suggestedStatuses.map((suggestedStatus, index)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: suggestionsPatchEnabled ? $7d3151e91594125f$var$suggestedStatusButtonWrapperStyles : undefined,
                key: `${suggestedStatus.color}:${suggestedStatus.text}`
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                type: "button",
                css: [
                    $7d3151e91594125f$var$suggestedStatusButtonStyles,
                    suggestionsPatchEnabled ? $7d3151e91594125f$var$suggestedStatusButtonPatchStyles : $7d3151e91594125f$var$suggestedStatusButtonOldStyles
                ],
                onClick: ()=>this.onSuggestedStatusClick(suggestedStatus, index + 1),
                onKeyDown: this.handleSuggestedStatusKeyDown,
                "aria-label": suggestedStatus.displayText,
                "data-suggested-status-button": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fhdGv.Status), {
                color: suggestedStatus.color,
                isConstrainedToParent: true,
                text: suggestedStatus.displayText
            }))))) : null;
        const pickerContent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5a1082336b950663$export$39975ce689bf0105), {
            autoFocus: isNew || focusStatusInput,
            selectedColor: color,
            text: text,
            onColorClick: this.onColorClick,
            onColorHover: this.onColorHover,
            onTextChanged: this.onTextChanged,
            onEnter: this.onEnter,
            palette: isUpdateStatusColorsEnabled ? 'extended' : 'default',
            scrollableContent: suggestionsPatchEnabled ? suggestedStatusList : undefined
        }), suggestionsPatchEnabled ? null : suggestedStatusList);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
            api: api,
            userIntent: "statusPickerOpen"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $7d3151e91594125f$var$pickerContainerStylesTeam26 : $7d3151e91594125f$var$pickerContainerStyles,
                suggestionsPatchEnabled && isUpdateStatusColorsEnabled ? $7d3151e91594125f$var$statusPickerWidthStyles : undefined,
                suggestionsPatchEnabled && !isUpdateStatusColorsEnabled ? $7d3151e91594125f$var$statusPickerWidthStylesOld : undefined,
                suggestionsPatchEnabled && !!suggestedStatusList && (isUpdateStatusColorsEnabled || (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_3')) ? $7d3151e91594125f$var$pickerContainerNoBottomPaddingStyles : undefined
            ],
            role: "none",
            ref: this.setRef(setOutsideClickTargetRef),
            onClick: this.handlePopupClick,
            onKeyDown: this.onKeyDown
        }, pickerContent));
    }
    render() {
        const { target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, intl: intl } = this.props;
        if (!editorView?.editable) return null;
        const fitHeight = (0, $4o0zT.isExperimentEnabled)('platform_editor_update_status_colors') || (0, $4o0zT.isExperimentEnabled)('platform_editor_update_status_colors_jira') ? $7d3151e91594125f$var$STATUS_PICKER_TEN_COLOR_FIT_HEIGHT : (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_3') ? $7d3151e91594125f$var$STATUS_PICKER_FIT_HEIGHT : $7d3151e91594125f$var$STATUS_PICKER_FIT_HEIGHT_OLD;
        return target && /*#__PURE__*/ (0, $lOiVq.jsx)($7d3151e91594125f$var$PopupWithListeners, {
            ariaLabel: intl.formatMessage((0, $4rQbz.messages).statusEditorLabel),
            target: target,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                8
            ],
            handleClickOutside: this.handleClickOutside,
            handleEscapeKeydown: this.handleEscapeKeydown,
            zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
            fitHeight: (0, $4o0zT.isExperimentEnabled)('platform_editor_status_popup_suggestions') && (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_1') ? fitHeight : 40,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            closeOnTab: false
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GVkD.default), {
            "aria-atomic": true,
            role: "alert"
        }, intl.formatMessage((0, $4rQbz.messages).statusPickerOpenedAlert)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, this.renderWithSetOutsideClickTargetRef.bind(this)));
    }
    fireSuggestedStatusClickedAnalytics(status, position) {
        this.createStatusAnalyticsAndFireFunc({
            action: 'clicked',
            actionSubject: 'statusSuggestion',
            attributes: {
                color: status.color,
                localId: this.state.localId,
                position: position,
                state: (0, $03737233c2d85182$export$69e00be7c24e6455)(this.props.isNew),
                textLength: status.text ? status.text.length : 0,
                totalSuggestions: this.props.suggestedStatuses?.length ?? 0
            }
        });
    }
    focusAdjacentSuggestedStatus(currentButton, direction) {
        const suggestedStatusButtons = this.popupBodyWrapper.current?.querySelectorAll('button[data-suggested-status-button]');
        if (!suggestedStatusButtons?.length) return;
        const currentIndex = Array.from(suggestedStatusButtons).indexOf(currentButton);
        if (currentIndex < 0) return;
        const nextIndex = (currentIndex + direction + suggestedStatusButtons.length) % suggestedStatusButtons.length;
        suggestedStatusButtons[nextIndex]?.focus();
    }
    constructor(props){
        super(props);
        this.startTime = void 0;
        this.inputMethod = void 0;
        this.createStatusAnalyticsAndFireFunc = void 0;
        this.popupBodyWrapper = void 0;
        this.focusTimeout = void 0;
        this.handleClickOutside = (event)=>{
            event.preventDefault();
            this.inputMethod = "blur";
            const selectedText = window.getSelection();
            if (!selectedText) this.props.closeStatusPicker();
        };
        this.handleEscapeKeydown = (event)=>{
            event.preventDefault();
            this.inputMethod = "escKey";
            this.props.onEnter(this.state);
        };
        this.handleTabPress = (event)=>{
            if (!(0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_status_popup_suggestions', 'isEnabled', false)) {
                /* original tab-navigation behaviour: cycle between color buttons and the input field */ const colorButtons = event.currentTarget.querySelectorAll('button');
                const inputField = event.currentTarget.querySelector('input');
                const activeElement = (0, $1hQ0e.getDocument)()?.activeElement;
                const isInputFocussed = activeElement === inputField;
                const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                    return activeElement === buttonElement;
                });
                if (event?.shiftKey) {
                    /* shift + tab */ if (isInputFocussed) {
                        colorButtons[0].focus();
                        event.preventDefault();
                    }
                    /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
                  To correctly set focus to the input field instead of the first color button we need to set focus manually
                  */ if (isButtonFocussed) {
                        inputField?.focus();
                        event.preventDefault();
                    }
                } else /* tab */ if (isButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
                return;
            }
            const colorButtons = event.currentTarget.querySelectorAll('button:not([data-suggested-status-button])');
            const suggestedStatusButtons = event.currentTarget.querySelectorAll('button[data-suggested-status-button]');
            const inputField = event.currentTarget.querySelector('input');
            const activeElement = (0, $1hQ0e.getDocument)()?.activeElement;
            const isInputFocussed = activeElement === inputField;
            const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            const isSuggestedStatusButtonFocussed = Array.from(suggestedStatusButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            if (event?.shiftKey) {
                /* shift + tab */ if (isInputFocussed) {
                    if (suggestedStatusButtons.length > 0) suggestedStatusButtons[suggestedStatusButtons.length - 1].focus();
                    else colorButtons[0]?.focus();
                    event.preventDefault();
                }
                /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
               To correctly set focus to the input field instead of the first color button we need to set focus manually
               */ if (isButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
                if (isSuggestedStatusButtonFocussed) {
                    colorButtons[colorButtons.length - 1]?.focus();
                    event.preventDefault();
                }
            } else {
                /* tab */ if (isButtonFocussed) {
                    if (suggestedStatusButtons.length > 0) suggestedStatusButtons[0].focus();
                    else inputField?.focus();
                    event.preventDefault();
                }
                if (isSuggestedStatusButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
            }
        };
        this.handleArrow = (event, closingMethod)=>{
            const activeElement = (0, $1hQ0e.getDocument)()?.activeElement;
            if (activeElement === this.popupBodyWrapper.current) {
                event.preventDefault();
                this.popupBodyWrapper?.current?.blur();
                this.props.closeStatusPicker({
                    closingMethod: closingMethod
                });
            }
        };
        this.onKeyDown = (event)=>{
            const isTabPressed = event.key === 'Tab';
            if (isTabPressed) return this.handleTabPress(event);
            if (event.key in $7d3151e91594125f$export$cc742728d048210b) return this.handleArrow(event, $7d3151e91594125f$export$cc742728d048210b[event.key]);
        };
        this.onColorHover = (color)=>{
            this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: this.state.localId,
                    state: (0, $03737233c2d85182$export$69e00be7c24e6455)(this.props.isNew)
                }
            });
        };
        this.onColorClick = (color)=>{
            const { text: text, localId: localId } = this.state;
            if (color === this.state.color) {
                this.createStatusAnalyticsAndFireFunc({
                    action: 'clicked',
                    actionSubject: 'statusColorPicker',
                    attributes: {
                        color: color,
                        localId: localId,
                        state: (0, $03737233c2d85182$export$69e00be7c24e6455)(this.props.isNew)
                    }
                });
                // closes status box and commits colour
                this.onEnter();
            } else {
                this.setState({
                    color: color
                });
                this.props.onSelect({
                    text: text,
                    color: color,
                    localId: localId
                });
            }
        };
        this.onTextChanged = (text)=>{
            const { color: color, localId: localId } = this.state;
            this.setState({
                text: text
            });
            this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId
            }, !!this.props.isNew);
        };
        this.onEnter = ()=>{
            this.inputMethod = "enterKey";
            this.props.onEnter(this.state);
        };
        this.onSuggestedStatusClick = (status, position)=>{
            this.fireSuggestedStatusClickedAnalytics(status, position);
            this.props.onSuggestedStatusClick(status);
        };
        this.handleSuggestedStatusKeyDown = (event)=>{
            // Selection (Enter/Space) is handled natively via the button's onClick.
            // Keydown only drives ArrowUp/ArrowDown navigation between suggestions.
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                this.focusAdjacentSuggestedStatus(event.currentTarget, event.key === 'ArrowDown' ? 1 : -1);
            }
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        this.handlePopupClick = (event)=>event.nativeEvent.stopImmediatePropagation();
        this.state = this.extractStateFromProps(props);
        this.createStatusAnalyticsAndFireFunc = (0, $03737233c2d85182$export$aa98853957f9f5aa)(props.createAnalyticsEvent);
        this.popupBodyWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
const $7d3151e91594125f$export$bcfa9a4744e42b68 = (0, $kSwu1.injectIntl)($7d3151e91594125f$var$StatusPickerWithIntl);
const $7d3151e91594125f$var$_default_1 = (0, $lzgC6.default)()($7d3151e91594125f$export$bcfa9a4744e42b68);
var $7d3151e91594125f$export$2e2bcd8739ae039 = $7d3151e91594125f$var$_default_1;


function $02a272aa3edde94b$export$2dda1e4a1d1f6a81({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, domAtPos: domAtPos }) {
    const { statusState: statusState } = (0, $4y8CY.useSharedPluginState)(api, [
        'status'
    ]);
    const { showStatusPickerAt: showStatusPickerAt } = statusState ?? {};
    const target = (0, $cozmU.useMemo)(()=>// Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        showStatusPickerAt ? (0, $bjg0G.findDomRefAtPos)(showStatusPickerAt, domAtPos) : null, [
        showStatusPickerAt,
        domAtPos
    ]);
    const statusNode = (0, $cozmU.useMemo)(()=>showStatusPickerAt ? editorView.state.doc.nodeAt(showStatusPickerAt) : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps -- preserve original recompute cadence for the ungated path
    [
        showStatusPickerAt,
        editorView
    ]);
    const onSelect = (0, $cozmU.useCallback)((status)=>{
        (0, $35c8ece4f44259bc$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onTextChanged = (0, $cozmU.useCallback)((status)=>{
        (0, $35c8ece4f44259bc$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const closeStatusPicker = (0, $cozmU.useCallback)((closingPayload)=>{
        (0, $35c8ece4f44259bc$export$cdfbbd5b38df803)(closingPayload)(editorView);
    }, [
        editorView
    ]);
    const onEnter = (0, $cozmU.useCallback)(()=>{
        (0, $35c8ece4f44259bc$export$cdfbbd5b38df803)()(editorView);
    }, [
        editorView
    ]);
    const onSuggestedStatusClick = (0, $cozmU.useCallback)((status)=>{
        const currentLocalId = typeof showStatusPickerAt === 'number' ? editorView.state.doc.nodeAt(showStatusPickerAt)?.attrs.localId : undefined;
        const suggestedStatus = {
            color: status.color,
            ...currentLocalId ? {
                localId: currentLocalId
            } : {},
            ...status.style ? {
                style: status.style
            } : {},
            text: status.text
        };
        const didUpdateStatus = (0, $35c8ece4f44259bc$export$dd127eb7207846ef)(suggestedStatus)(editorView.state, editorView.dispatch);
        if (didUpdateStatus) (0, $35c8ece4f44259bc$export$cdfbbd5b38df803)()(editorView);
    }, [
        editorView,
        showStatusPickerAt
    ]);
    const suggestedStatuses = (0, $cozmU.useMemo)(()=>{
        if (typeof showStatusPickerAt !== 'number' || !(0, $4o0zT.isExperimentEnabled)('platform_editor_status_popup_suggestions')) return [];
        // Read the node directly from the current doc so suggestions reflect the latest
        // document state (the memoized `statusNode` intentionally preserves the original
        // recompute cadence for the ungated path).
        const currentNode = editorView.state.doc.nodeAt(showStatusPickerAt);
        if (!currentNode || currentNode.type.name !== 'status') return [];
        const { color: color, localId: localId, text: text } = currentNode.attrs;
        return (0, $c2056d0558fc8772$export$8db4724ea852799d)({
            currentPos: showStatusPickerAt,
            currentStatus: {
                color: color,
                localId: localId,
                text: text
            },
            doc: editorView.state.doc,
            limit: (0, $iDrrr.fg)('platform_editor_status_popup_suggestions_patch_1') ? (0, $c2056d0558fc8772$export$9e316df46dca86d0) : (0, $c2056d0558fc8772$export$33b7003a8d67e410),
            shouldUppercaseText: (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')
        });
    }, [
        showStatusPickerAt,
        editorView.state.doc
    ]);
    if (typeof showStatusPickerAt !== 'number') return null;
    if (!statusNode || statusNode.type.name !== 'status') return null;
    const { text: text, color: color, localId: localId, style: style } = statusNode.attrs;
    const displayText = style !== 'mixedCase' && (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? text.toUpperCase() : text;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7d3151e91594125f$export$2e2bcd8739ae039), {
        isNew: statusState?.isNew,
        focusStatusInput: statusState?.focusStatusInput,
        target: target,
        defaultText: displayText,
        defaultColor: color,
        defaultLocalId: localId,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onSelect: onSelect,
        onTextChanged: onTextChanged,
        closeStatusPicker: closeStatusPicker,
        onEnter: onEnter,
        onSuggestedStatusClick: onSuggestedStatusClick,
        editorView: editorView,
        api: api,
        suggestedStatuses: suggestedStatuses
    });
}





parcelRequire("cozmU");





var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");

















var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $aTF50 = parcelRequire("aTF50");


const $93104b67a0dc6352$export$95fca5d556748032 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        return (0, $35c8ece4f44259bc$export$84e57993298e69f2)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).QUICK_INSERT)({
            tr: tr
        }) ?? tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).statusDescription),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTF50))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status)
    });
};


const $2c87e0addd930db6$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKM.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH8.png'
};
const $2c87e0addd930db6$export$40f4dbe3660e5878 = ({ api: api })=>[
        {
            key: (0, $dCkbP.STATUS_MENU_ITEM).key,
            type: (0, $dCkbP.STATUS_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.STATUS_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).statusDescription),
                    keywords: [
                        'lozenge'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $93104b67a0dc6352$export$95fca5d556748032), {
                    api: api,
                    previewImageUrls: $2c87e0addd930db6$var$previewImageUrls
                })
        }
    ];





parcelRequire("cozmU");











var $dVKvM = parcelRequire("dVKvM");






const $0913f955db616077$var$StatusBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformInlineNode({
                buildInlineNode: (source)=>(0, $0a3bbbbfbf46e4f6$export$bc38267ef98d9f2)(tr.doc.type.schema, {
                        text: source.textContent.trim()
                    }),
                isSuggested: isSuggested,
                targetTypeName: 'status'
            });
            const nextTr = command?.({
                tr: tr
            });
            if (!nextTr?.docChanged) return null;
            api?.analytics?.actions?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).BLOCK_MENU
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(nextTr);
            return nextTr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
                focusStatusInput: true,
                isNew: true,
                showStatusPickerAt: nextTr.selection.from
            });
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTF50))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status)
    });
};
const $0913f955db616077$export$1bc5e7c5f3514477 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $8aG6j.jsx)($0913f955db616077$var$StatusBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};





const $62c5fbb16f942ebd$var$MAX_STATUS_TURN_INTO_CHARS = 30;
const $62c5fbb16f942ebd$var$SUPPORTED_SOURCE_TYPES = new Set([
    'paragraph',
    'heading'
]);
const $62c5fbb16f942ebd$var$getTurnIntoStatusSourceNode = (selection)=>{
    if (!selection || !(selection instanceof (0, $kCECX.NodeSelection))) return null;
    return selection.node;
};
const $62c5fbb16f942ebd$export$62a566bf1e63f1ee = (node)=>{
    if (!node || !$62c5fbb16f942ebd$var$SUPPORTED_SOURCE_TYPES.has(node.type.name)) return false;
    for(let i = 0; i < node.childCount; i++){
        if (!node.child(i).isText) return false;
    }
    return node.textContent.trim().length <= $62c5fbb16f942ebd$var$MAX_STATUS_TURN_INTO_CHARS;
};
const $62c5fbb16f942ebd$export$92eec996e401854b = (selection)=>!$62c5fbb16f942ebd$export$62a566bf1e63f1ee($62c5fbb16f942ebd$var$getTurnIntoStatusSourceNode(selection));


const $673fe1fcd0c9f1e1$export$4c24fc5ab73049c9 = ({ config: options, api: api })=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_turn_into_status')) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key]
            },
            component: (0, $0913f955db616077$export$1bc5e7c5f3514477)(api),
            isHidden: ()=>(0, $62c5fbb16f942ebd$export$92eec996e401854b)(api?.blockControls?.sharedState.currentState()?.preservedSelection)
        }
    ]);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (options?.menuDisabled !== true && isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $2c87e0addd930db6$export$40f4dbe3660e5878)({
        api: api
    }));
    return {
        name: 'status',
        nodes () {
            return [
                {
                    name: 'status',
                    node: (0, $PYwg9.status)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'status',
                    plugin: (pmPluginFactoryParams)=>(0, $0d68e47196c4702b$export$2e2bcd8739ae039)(pmPluginFactoryParams, options)
                },
                {
                    name: 'statusKeymap',
                    plugin: (0, $52f20a93e5d9fb1b$export$e832373cff8dec22)
                }
            ];
        },
        actions: {
            commitStatusPicker: $35c8ece4f44259bc$export$cdfbbd5b38df803,
            updateStatus: (0, $35c8ece4f44259bc$export$2d82855a8f0dcacb)(api?.analytics?.actions)
        },
        commands: {
            removeStatus: $35c8ece4f44259bc$export$38345b9b03bc4599,
            insertStatus: (0, $35c8ece4f44259bc$export$84e57993298e69f2)(api?.analytics?.actions)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state);
            return pluginState ? {
                isNew: pluginState.isNew,
                showStatusPickerAt: pluginState.showStatusPickerAt,
                focusStatusInput: pluginState.focusStatusInput
            } : undefined;
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if (options?.menuDisabled === true) return [];
                    return [
                        {
                            id: 'status',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).statusDescription),
                            priority: 700,
                            keywords: [
                                'lozenge'
                            ],
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconStatus), {}),
                            action (_insert, state) {
                                return (0, $35c8ece4f44259bc$export$84e57993298e69f2)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).QUICK_INSERT)({
                                    tr: state.tr
                                }) ?? state.tr;
                            }
                        }
                    ];
                }
            },
            floatingToolbar (state, intl) {
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                return {
                    title: 'Status floating toolbar',
                    nodeType: state.schema.nodes.status,
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Status floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const hasActiveMark = node.marks.some((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && isViewMode() && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !hasActiveMark;
                        const onCommentClick = (stateFromClickEvent, dispatch)=>{
                            if (!api?.annotation) return true;
                            const command = api.annotation.actions.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                            api?.analytics?.actions?.fireAnalyticsEvent({
                                action: (0, $krYZG.ACTION).CLICKED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                                eventType: (0, $krYZG.EVENT_TYPE).UI,
                                attributes: {
                                    source: 'highlightActionsMenu',
                                    pageMode: 'edit',
                                    sourceNode: 'status'
                                }
                            });
                            return command(stateFromClickEvent, dispatch);
                        };
                        const createCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
                        const commentItems = showAnnotation ? [
                            {
                                type: 'button',
                                title: createCommentMessage,
                                onClick: onCommentClick,
                                showTitle: true,
                                tooltipContent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                                    description: createCommentMessage,
                                    keymap: (0, $ldqjS.addInlineComment)
                                }),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                supportsViewMode: true
                            }
                        ] : [];
                        return [
                            ...commentItems
                        ];
                    }
                };
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            const domAtPos = editorView.domAtPos.bind(editorView);
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $02a272aa3edde94b$export$2dda1e4a1d1f6a81), {
                domAtPos: domAtPos,
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        }
    };
};
module.exports["statusPlugin"] = $673fe1fcd0c9f1e1$export$4c24fc5ab73049c9;

});

parcelRegister("ctVsO", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $c2E4R = parcelRequire("c2E4R");


var $iLrhi = parcelRequire("iLrhi");


var $a33Aa = parcelRequire("a33Aa");

const $5db34782a9e568c4$export$abe7f7e3118e197d = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        view () {
            let aborted = false;
            return {
                update (view, prevState) {
                    if (aborted) // opt out of additional logic if already aborted
                    return;
                    if (!view.state.selection.eq(prevState.selection) && !(0, $c2E4R.atTheBeginningOfDoc)(view.state) && !(0, $iLrhi.isEmptyDocument)(view.state.doc)) {
                        const activeInteraction = (0, $a33Aa.getActiveInteraction)();
                        if (activeInteraction && [
                            'edit-page',
                            'live-edit'
                        ].includes(activeInteraction.ufoName)) (0, $a33Aa.abortAll)('new_interaction', `selection-changed-on-editor-element`);
                        aborted = true;
                    }
                }
            };
        }
    });
};


const $0c2d9c23fee987f5$export$e137bce9a5077ae5 = ()=>({
        name: 'ufo',
        pmPlugins () {
            const isSSR = Boolean(undefined);
            if (isSSR) // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
            return [];
            return [
                {
                    name: 'traceUFOInteractionOnFirstInteraction',
                    plugin: (0, $5db34782a9e568c4$export$abe7f7e3118e197d)
                }
            ];
        }
    });
module.exports["ufoPlugin"] = $0c2d9c23fee987f5$export$e137bce9a5077ae5;

});

parcelRegister("cDpdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


const $2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("1kFCh")));
const $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $2a3e0a8082e0a83e$export$5057fa778edd8de9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, config)=>{
    const $ = (0, $bDgLe.c)(11);
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    let t0;
    if ($[0] !== config || $[1] !== shouldMergeAdditionalPlugins) {
        t0 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        $[0] = config;
        $[1] = shouldMergeAdditionalPlugins;
        $[2] = t0;
    } else t0 = $[2];
    const WrapperComponent = t0;
    let t1;
    if ($[3] !== props) {
        t1 = props ?? {};
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    let linkPickerProps;
    if ($[5] !== t1) {
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...t2 } = t1;
        linkPickerProps = t2;
        $[5] = t1;
        $[6] = linkPickerProps;
    } else linkPickerProps = $[6];
    const t2 = shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS;
    let t3;
    if ($[7] !== WrapperComponent || $[8] !== linkPickerProps || $[9] !== t2) {
        t3 = {
            ...linkPickerProps,
            plugins: t2,
            component: WrapperComponent
        };
        $[7] = WrapperComponent;
        $[8] = linkPickerProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    const WrapperComponent = (0, $cozmU.useMemo)(()=>(props_0)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        }, [
        config,
        shouldMergeAdditionalPlugins
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...linkPickerProps } = props ?? {};
        return {
            ...linkPickerProps,
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props,
        shouldMergeAdditionalPlugins
    ]);
};
module.exports["useLinkPickerEditorProps"] = $2a3e0a8082e0a83e$export$5057fa778edd8de9;

});

parcelRegister("1kFCh", function(module, exports) {

let $0f87f0dc6317444a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f87f0dc6317444a$var$load("hS8gF"),
    $0f87f0dc6317444a$var$load("6wr18"),
    $0f87f0dc6317444a$var$load("ffEVr"),
    $0f87f0dc6317444a$var$load("g8A75"),
    $0f87f0dc6317444a$var$load("4AElS"),
    $0f87f0dc6317444a$var$load("dChty"),
    $0f87f0dc6317444a$var$load("jmTCk"),
    $0f87f0dc6317444a$var$load("fmCjo")
]).then(()=>parcelRequire('et6nL'));

});

parcelRegister("yNGEI", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $809138f2c808c2d9$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
}
module.exports["calcPxFromPct"] = $809138f2c808c2d9$export$e70e278a1f662f8d;

});

parcelRegister("9aSOx", function(module, exports) {
"use strict";
var $6adf91262b04985e$var$__assign = module.exports && module.exports.__assign || function() {
    $6adf91262b04985e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6adf91262b04985e$var$__assign.apply(this, arguments);
};
var $6adf91262b04985e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6adf91262b04985e$var$React = $6adf91262b04985e$var$__importStar((parcelRequire("cozmU")));
var $6adf91262b04985e$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $6adf91262b04985e$var$Resizer(props) {
    return $6adf91262b04985e$var$React.createElement("div", {
        className: props.className || '',
        style: $6adf91262b04985e$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $6adf91262b04985e$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $6adf91262b04985e$var$Resizer;

});

parcelRegister("rOV4B", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");

const $854c0c9c837fb0c6$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption',
    'layoutColumn'
];
const $854c0c9c837fb0c6$export$4b59c90449151b37 = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption'
];
const $854c0c9c837fb0c6$var$IGNORE_NODE_DESCENDANTS = [
    'listItem',
    'taskList',
    'decisionList',
    'mediaSingle'
];
const $854c0c9c837fb0c6$export$9cba0273af9f9727 = [
    'listItem',
    'taskList',
    'decisionList'
];
const $854c0c9c837fb0c6$export$d43a1c4953e0600e = (node)=>{
    // Optimisation to avoid drawing node decorations for empty table cells
    if ([
        'tableCell',
        'tableHeader'
    ].includes(node.type.name)) {
        if (node.childCount === 1 && node.firstChild?.type.name === 'paragraph' && node.firstChild.childCount === 0) return false;
    }
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) return !$854c0c9c837fb0c6$export$9cba0273af9f9727.includes(node.type.name);
    return !$854c0c9c837fb0c6$var$IGNORE_NODE_DESCENDANTS.includes(node.type.name);
};
const $854c0c9c837fb0c6$var$shouldIgnoreNode = (node, ignore_nodes, depth, parent)=>{
    const nodeTypes = node.type.schema.nodes;
    const isTable = node.type.name === nodeTypes?.table?.name;
    const parentIsTable = parent && [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
    const isNestedTable = isTable && parentIsTable;
    if (isNestedTable) return true;
    const isFirstTableRow = parent?.type.name === 'table' && depth === 1 && node === parent.firstChild && 'tableRow' === node.type.name && (0, $jkcNT.editorExperiment)('advanced_layouts', true);
    if (isFirstTableRow) return false;
    const isLegacyContentMacroExtension = node.type.name === 'extension' && node.attrs?.extensionType === 'com.atlassian.confluence.migration' && node.attrs?.extensionKey === 'legacy-content';
    if (isLegacyContentMacroExtension) return true;
    return ignore_nodes.includes(node.type.name);
};
const $854c0c9c837fb0c6$export$562fc95beb8a58d3 = (state, decorations, from, to)=>{
    let newFrom = from;
    let newTo = to;
    // make it non-inclusive
    if (newFrom !== undefined) newFrom++;
    // make it non-inclusive
    if (newTo !== undefined) newTo--;
    // return empty array if range reversed
    if (newFrom !== undefined && newTo !== undefined && newFrom > newTo) return [];
    return decorations.find(newFrom, newTo, (spec)=>spec.type === (0, $9HWym.TYPE_NODE_DEC));
};
const $854c0c9c837fb0c6$export$a3bb13b1e97d70c7 = (newState, from, to)=>{
    const decs = [];
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) return [];
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > newState.doc.nodeSize - 2 ? newState.doc.nodeSize - 2 : to;
    const ignore_nodes = (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? $854c0c9c837fb0c6$export$4b59c90449151b37 : $854c0c9c837fb0c6$var$IGNORE_NODES;
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, _)=>{
        let depth = 0;
        const shouldDescend = $854c0c9c837fb0c6$export$d43a1c4953e0600e(node);
        const anchorName = (0, $9HWym.getNodeAnchor)(node);
        const nodeTypeWithLevel = (0, $9HWym.getNodeTypeWithLevel)(node);
        // Doesn't descend into a node
        if (node.isInline) return false;
        depth = newState.doc.resolve(pos).depth;
        if ($854c0c9c837fb0c6$var$shouldIgnoreNode(node, ignore_nodes, depth, parent)) return shouldDescend; //skip over, don't consider it a valid depth
        const anchorStyles = `anchor-name: ${anchorName};`;
        decs.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            style: anchorStyles,
            ['data-drag-handler-anchor-name']: anchorName,
            ['data-drag-handler-node-type']: nodeTypeWithLevel,
            ['data-drag-handler-anchor-depth']: `${depth}`
        }, {
            type: (0, $9HWym.TYPE_NODE_DEC),
            anchorName: anchorName,
            nodeType: node.type.name,
            nodeTypeWithLevel: nodeTypeWithLevel
        }));
        return shouldDescend && depth < (0, $9HWym.NESTED_DEPTH);
    });
    return decs;
};
module.exports["IGNORE_NODES_NEXT"] = $854c0c9c837fb0c6$export$4b59c90449151b37;
module.exports["IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT"] = $854c0c9c837fb0c6$export$9cba0273af9f9727;
module.exports["findNodeDecs"] = $854c0c9c837fb0c6$export$562fc95beb8a58d3;
module.exports["nodeDecorations"] = $854c0c9c837fb0c6$export$a3bb13b1e97d70c7;

});

parcelRegister("3BXSc", function(module, exports) {

var $LQnOI = parcelRequire("LQnOI");


var $1hQ0e = parcelRequire("1hQ0e");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $4RpM6 = parcelRequire("4RpM6");


var $hiQdW = parcelRequire("hiQdW");


var $kpCD8 = parcelRequire("kpCD8");


var $kAPZe = parcelRequire("kAPZe");


var $g6uqx = parcelRequire("g6uqx");


var $bwJyA = parcelRequire("bwJyA");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $38vK5 = parcelRequire("38vK5");


var $4Vdlk = parcelRequire("4Vdlk");


var $4QfFX = parcelRequire("4QfFX");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $hTjcC = parcelRequire("hTjcC");


var $fKt2m = parcelRequire("fKt2m");


var $rOV4B = parcelRequire("rOV4B");


var $9HWym = parcelRequire("9HWym");


var $j28nv = parcelRequire("j28nv");


var $djgGr = parcelRequire("djgGr");


var $g8ZIt = parcelRequire("g8ZIt");


var $hYw7t = parcelRequire("hYw7t");


var $9UAss = parcelRequire("9UAss");


var $h7MdN = parcelRequire("h7MdN");


var $hwVXJ = parcelRequire("hwVXJ");


var $jdNrc = parcelRequire("jdNrc");


var $d1Uph = parcelRequire("d1Uph");


var $aHnsS = parcelRequire("aHnsS");


var $a4QVD = parcelRequire("a4QVD");


var $bOZni = parcelRequire("bOZni");


var $i2jOy = parcelRequire("i2jOy");


var $bOCgz = parcelRequire("bOCgz");

const $ae8d0893738a17f4$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('blockControls');
const $ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT = 'Editor Blocks Drag Initialization Time';
const $ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT = 'Editor Blocks Drop Initialization Time';
const $ae8d0893738a17f4$var$scheduleCallback = (cb, options)=>{
    return 'requestIdleCallback' in window ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $ae8d0893738a17f4$var$isHTMLElement = (element)=>{
    return element instanceof HTMLElement;
};
const $ae8d0893738a17f4$var$destroyFn = (api, editorView)=>{
    const scrollable = (0, $1hQ0e.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent') ?? null;
    const cleanupFn = [];
    if (scrollable) cleanupFn.push((0, $38vK5.autoScrollForElements)({
        element: scrollable
    }));
    let dragInitializationDuration = 0;
    cleanupFn.push((0, $4Vdlk.monitorForElements)({
        canMonitor: ({ source: source })=>source.data.type === 'element',
        onDrag: ()=>{
            if ((0, $iDrrr.fg)('platform_editor_drag_and_drop_perf_analytics')) {
                if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT, (duration)=>{
                    dragInitializationDuration = duration;
                });
            } else if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT, (duration, startTime)=>{
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).BLOCKS_DRAG_INIT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodesCount: editorView?.state.doc.nodeSize
                    }
                });
            });
        },
        onDragStart: ()=>{
            if ($ae8d0893738a17f4$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', 'unset');
        },
        onDrop: ({ location: location, source: source })=>{
            if ($ae8d0893738a17f4$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', null);
            if ((0, $iDrrr.fg)('platform_editor_drag_and_drop_perf_analytics')) (0, $hiQdW.startMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT);
            if (!api) return;
            api.core?.actions.execute(({ tr: tr })=>{
                const { multiSelectDnD: multiSelectDnD } = api.blockControls?.sharedState.currentState() || {};
                // Restore the users initial Editor selection when the drop completes
                if (multiSelectDnD) {
                    // If the TextSelection between the drag start and end has changed, the document has changed, and we should not reapply the last selection
                    const expandedSelectionUnchanged = multiSelectDnD.textAnchor === tr.selection.anchor && multiSelectDnD.textHead === tr.selection.head;
                    if (expandedSelectionUnchanged) {
                        const $anchor = tr.doc.resolve(multiSelectDnD.userAnchor);
                        const $head = tr.doc.resolve(multiSelectDnD.userHead);
                        if ($head.node() === $anchor.node()) {
                            const $from = $anchor.min($head);
                            (0, $bOZni.selectNode)(tr, $from.pos, $from.node().type.name, api);
                        } else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, multiSelectDnD.userAnchor, multiSelectDnD.userHead));
                    }
                }
                api.selection?.commands.clearManualSelection()({
                    tr: tr
                });
                const { start: start } = source.data;
                // if no drop targets are rendered, assume that drop is invalid
                const lastDragCancelled = location.current.dropTargets.length === 0;
                if (lastDragCancelled) {
                    const position = (0, $i2jOy.getSelectedSlicePosition)(start, tr, api);
                    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, position.from, position.to);
                    const { nodeTypes: nodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    api.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        action: (0, $krYZG.ACTION).CANCELLED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                }
                if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                    ...tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                    isDragging: false,
                    isPMDragging: false,
                    lastDragCancelled: lastDragCancelled
                });
            });
            if ((0, $iDrrr.fg)('platform_editor_drag_and_drop_perf_analytics')) // wait for the idle callback to ensure that the drag operation has completed
            $ae8d0893738a17f4$var$scheduleCallback(()=>{
                if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT, (duration)=>{
                    const isCancelled = location.current.dropTargets.length === 0;
                    api?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).ENDED,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            dragInitializationDuration: dragInitializationDuration,
                            dropProcessingDuration: duration,
                            isCancelled: isCancelled,
                            nodesCount: editorView?.state.doc.nodeSize
                        }
                    });
                });
            });
        }
    }));
    return (0, $4QfFX.combine)(...cleanupFn);
};
const $ae8d0893738a17f4$var$initialState = {
    decorations: (0, $8nvEM.DecorationSet).empty,
    surfaceNodePositions: [],
    activeNode: undefined,
    isDragging: false,
    isMenuOpen: false,
    editorHeight: 0,
    editorWidthLeft: 0,
    editorWidthRight: 0,
    isResizerResizing: false,
    isDocSizeLimitEnabled: null,
    isPMDragging: false,
    multiSelectDnD: undefined,
    lastDragCancelled: false,
    isSelectedViaDragHandle: false
};
const $ae8d0893738a17f4$export$968abecb43309c32 = (state)=>$ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.decorations;
const $ae8d0893738a17f4$var$getDecorationAtPos = (state, decorations, pos, to)=>{
    // Find the newly minted node decs that touch the active node
    const findNewNodeDecs = (0, $rOV4B.findNodeDecs)(state, decorations, pos - 1, to);
    // Find the specific dec that the active node corresponds to
    const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === pos);
    // If multiple decorations at the active node pos, we want the last one
    const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
    return nodeDecAtActivePos;
};
const $ae8d0893738a17f4$export$5635d7ef4b8fee1c = (api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true, anchorRectCache, resizeObserverWidth, pragmaticCleanup, limitedModeTeardown)=>{
    let { activeNode: activeNode, decorations: decorations, isResizerResizing: isResizerResizing, multiSelectDnD: multiSelectDnD } = currentState;
    const { surfaceNodePositions: surfaceNodePositions } = currentState;
    const { editorHeight: editorHeight, editorWidthLeft: editorWidthLeft, editorWidthRight: editorWidthRight, isDragging: isDragging, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, menuTriggerByNode: menuTriggerByNode, blockMenuOptions: blockMenuOptions, isPMDragging: isPMDragging, lastDragCancelled: lastDragCancelled, isSelectedViaDragHandle: isSelectedViaDragHandle } = currentState;
    let isActiveNodeDeleted = false;
    const { from: from, to: to, numReplaceSteps: numReplaceSteps, isAllText: isAllText, isReplacedWithSameSize: isReplacedWithSameSize } = (0, $bOCgz.getTrMetadata)(tr, flags);
    const meta = tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
        // Both arms read `newState` — the state this transaction is producing. Deriving `enabled` from
        // `sharedState.currentState()` instead would resolve against `view.state`, which during `apply` is
        // still the *previous* state, delaying the limited-mode teardown by one transaction.
        //
        // Limited mode can now also be latched at runtime by the performance detector, so the treatment
        // arm considers both reasons rather than just the document one. Identical in the control arm, where
        // the runtime latch can never be set.
        const limitedModeState = api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(newState);
        if (!!limitedModeState?.enabled) {
            /**
       * INFO: This is a duplicate of the logic in destroy(). When we enter limited mode we want to
       * trigger the cleanup logic in destroy().
       */ if (!limitedModeTeardown || !limitedModeTeardown.done) {
                /**
         * Edge-triggered under the experiment: limited mode is a latch, so without this guard the
         * teardown re-runs on every subsequent transaction for the rest of the session — and would
         * re-register the pragmatic monitors if `pragmaticCleanup` ever became re-entrant.
         */ if (limitedModeTeardown) limitedModeTeardown.done = true;
                const editorContentArea = (0, $1hQ0e.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent') ?? null;
                if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
                pragmaticCleanup?.();
            }
            /**
       * Reset rather than freeze. Returning `currentState` here would keep `decorations`,
       * `activeNode` and the multi-select positions from before the latch, while skipping the
       * `tr.mapping` remapping below — so they would silently drift out of sync with the document on
       * every subsequent edit. Nothing renders them in limited mode (`props.decorations` returns
       * early), but stale positions are a latent source of incorrect offsets for anything that reads
       * them, so the safe state is empty.
       */ return {
                ...currentState,
                activeNode: undefined,
                decorations: (0, $8nvEM.DecorationSet).empty,
                multiSelectDnD: undefined
            };
        }
    } else {
        const hasDocumentSizeBreachedThreshold = api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(newState)?.documentSizeBreachesThreshold;
        if (hasDocumentSizeBreachedThreshold) {
            /**
       * INFO: This if statement is a duplicate of the logic in destroy(). When the threshold is breached and we enter limited mode, we want to trigger the cleanup logic in destroy().
       */ const editorContentArea = (0, $1hQ0e.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent') ?? null;
            if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
            pragmaticCleanup?.();
            return currentState;
        }
    }
    // patch_1: DecorationSet.map() validates node decorations as it maps them — one whose range
    // no longer exactly covers a node (e.g. after a split) is dropped rather than left misplaced.
    // Recording that here lets the active-node decoration blocks below re-add only what actually
    // went away, instead of scanning the whole decoration set on every keystroke (VC90).
    // The active-node decorations only exist under the reliable anchor experiment, so the patch is
    // scoped to it as well. No-exposure check as this runs on every document change; the blocks
    // below that consume these flags are already inside an `expValEquals` guard for the same
    // experiment, so the exposure is fired there.
    let activeHandleDecDropped = false;
    let activeQuickInsertDecDropped = false;
    // When steps exist, remap existing decorations, activeNode and multi select positions
    if (tr.docChanged) {
        if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_controls_reliable_anchor_patch_1')) decorations = decorations.map(tr.mapping, tr.doc, {
            onRemove: (spec)=>{
                if (spec?.type === (0, $j28nv.TYPE_ACTIVE_HANDLE_DEC)) activeHandleDecDropped = true;
                else if (spec?.type === (0, $hYw7t.TYPE_ACTIVE_QUICK_INSERT_NODE)) activeQuickInsertDecDropped = true;
            }
        });
        else decorations = decorations.map(tr.mapping, tr.doc);
        // platform_editor_controls note: enables quick insert
        // don't remap activeNode if it's being dragged
        if (!flags.toolbarFlagsEnabled) {
            if (activeNode) {
                const mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
                activeNode = {
                    pos: mappedPos.pos,
                    anchorName: activeNode.anchorName,
                    nodeType: activeNode.nodeType
                };
            }
        } else if (activeNode && meta?.isDragging !== true) {
            let mappedPos;
            const browser = (0, $8dxef.getBrowserInfo)();
            // In safari, when platform_editor_controls is on,
            // sometimes the drag handle for the layout disppears after you click on the handle for a few times
            // Which caused the drag handle onClick event not firing, then block menu wouldn't be opened
            // This is caused by the mappedPos.deletedAfter sometimes returning true in webkit browsers even though the active node still exists
            // This is likely a prosemirror and safari integration bug, but to unblock the issue, we are going to use mappedPos.deleted in safari for now
            if (browser.webkit) {
                mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
            } else {
                mappedPos = tr.mapping.mapResult(activeNode.pos, -1);
                isActiveNodeDeleted = mappedPos.deletedAfter;
            }
            // for editor controls, remap the rootPos as well
            let mappedRootPos;
            if (activeNode.rootPos !== undefined) mappedRootPos = tr.mapping.mapResult(activeNode.rootPos, -1);
            let mappedNodeType = activeNode.nodeType;
            let mappedRootNodeType = activeNode.rootNodeType;
            // Sparse mode does not redraw the old decorations. A block-type transaction may report
            // a text range that excludes the active block position, so always refresh the already
            // active node and root from the new document (for example, paragraph → heading-1).
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                const mappedNode = newState.doc.nodeAt(mappedPos.pos);
                if (mappedNode?.isBlock) mappedNodeType = (0, $9HWym.getNodeTypeWithLevel)(mappedNode);
                const mappedRootNode = mappedRootPos ? mappedRootPos.pos === mappedPos.pos && mappedNode ? mappedNode : newState.doc.nodeAt(mappedRootPos.pos) : undefined;
                if (mappedRootNode?.isBlock) mappedRootNodeType = (0, $9HWym.getNodeTypeWithLevel)(mappedRootNode);
            }
            activeNode = {
                pos: mappedPos.pos,
                anchorName: activeNode.anchorName,
                nodeType: mappedNodeType,
                rootPos: mappedRootPos?.pos ?? activeNode.rootPos,
                rootAnchorName: activeNode.rootAnchorName,
                rootNodeType: mappedRootNodeType
            };
        }
        if (multiSelectDnD) {
            multiSelectDnD.anchor = tr.mapping.map(multiSelectDnD.anchor);
            multiSelectDnD.head = tr.mapping.map(multiSelectDnD.head);
        }
    }
    const resizerMeta = tr.getMeta('is-resizer-resizing');
    isResizerResizing = resizerMeta ?? isResizerResizing;
    const hasJustFinishedResizing = resizerMeta === false;
    multiSelectDnD = meta?.multiSelectDnD ?? multiSelectDnD;
    if (multiSelectDnD) {
        if ((meta?.isDragging ?? isDragging) && (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // When dragging, we want to keep the multiSelectDnD object unless both document and selection
            // has changed, in which case we want to reset it.
            const shouldResetMultiSelectDnD = tr.docChanged && tr.selectionSet && tr.selection.empty;
            multiSelectDnD = shouldResetMultiSelectDnD ? undefined : multiSelectDnD;
        } else multiSelectDnD = meta?.isDragging === false || tr.selection.empty ? undefined : multiSelectDnD;
    }
    const maybeNodeCountChanged = !isAllText && numReplaceSteps > 0;
    let latestActiveNode = meta?.activeNode;
    const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
    if (!latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) latestActiveNode = activeNode;
    // Re-create node decorations
    const isDecSetEmpty = decorations === (0, $8nvEM.DecorationSet).empty;
    const isNodeDecsMissing = isDecSetEmpty || maybeNodeCountChanged || (0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) && hasJustFinishedResizing;
    const shouldRedrawNodeDecs = !isResizerResizing && (isNodeDecsMissing || meta?.isDragging) && // Skip expensive anchor node decoration recalculations when native anchor support is enabled
    !((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'));
    let isActiveNodeModified = false;
    if (api && shouldRedrawNodeDecs) {
        const oldNodeDecs = (0, $rOV4B.findNodeDecs)(newState, decorations, from, to);
        decorations = decorations.remove(oldNodeDecs);
        const newNodeDecs = (0, $rOV4B.nodeDecorations)(newState, isDecSetEmpty ? undefined : from, isDecSetEmpty ? undefined : to);
        decorations = decorations.add(newState.doc, newNodeDecs);
        // platform_editor_controls note: enables quick insert
        if (!flags.toolbarFlagsEnabled) {
            if (latestActiveNode && !isActiveNodeDeleted) {
                // Find the newly minted node decs that touch the active node
                const findNewNodeDecs = (0, $rOV4B.findNodeDecs)(newState, decorations, latestActiveNode.pos - 1, to);
                // Find the specific dec that the active node corresponds to
                const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === latestActiveNode.pos);
                // If multiple decorations at the active node pos, we want the last one
                const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
                // Update the active node anchor-name and type for accurate positioning
                if (nodeDecAtActivePos) {
                    isActiveNodeModified = true;
                    latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                    latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
                }
            }
        } else if (latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) {
            const nodeDecAtActivePos = $ae8d0893738a17f4$var$getDecorationAtPos(newState, decorations, latestActiveNode.pos, to);
            const rootNodeDecAtActivePos = latestActiveNode.rootPos !== undefined ? $ae8d0893738a17f4$var$getDecorationAtPos(newState, decorations, latestActiveNode.rootPos, to) : undefined;
            if (nodeDecAtActivePos || rootNodeDecAtActivePos) isActiveNodeModified = true;
            // Update the active node anchor-name and type for accurate positioning
            if (nodeDecAtActivePos) {
                latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
            }
            if (rootNodeDecAtActivePos) {
                latestActiveNode.rootAnchorName = rootNodeDecAtActivePos.spec.anchorName;
                latestActiveNode.rootNodeType = rootNodeDecAtActivePos.spec.nodeType;
            }
        }
    }
    // Check if editor dimensions have changed
    const editorSizeChanged = meta?.editorHeight !== undefined && meta?.editorHeight !== editorHeight || meta?.editorWidthLeft !== undefined && meta?.editorWidthLeft !== editorWidthLeft || meta?.editorWidthRight !== undefined && meta?.editorWidthRight !== editorWidthRight;
    // Check if there's a new active node, and it differs from the last
    const activeNodeChanged = meta?.activeNode && (meta?.activeNode.pos !== activeNode?.pos && meta?.activeNode.anchorName !== activeNode?.anchorName || meta?.activeNode.handleOptions?.isFocused);
    const rootActiveNodeChanged = meta?.activeNode && meta?.activeNode.rootPos !== activeNode?.rootPos && meta?.activeNode.rootAnchorName !== activeNode?.rootAnchorName;
    // Some browsers don't support anchor positioning, meaning we need to replace the handle when nodes change
    const handleNeedsRedraw = shouldRedrawNodeDecs && !(0, $a4QVD.isAnchorSupported)();
    // Create/recreate handle dec when the active node is missing/changes, or the editor viewport has changed (non-anchor pos workaround)
    const shouldRecreateHandle = latestActiveNode && (activeNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    const shouldRecreateQuickInsertButton = latestActiveNode && (rootActiveNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    // If the active node is missing, we need to remove the handle
    let shouldRemoveHandle = latestActiveNode ? isResizerResizing || isActiveNodeDeleted && !isReplacedWithSameSize || meta?.nodeMoved : true;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) // Remove handle dec when editor is blurred
    shouldRemoveHandle = shouldRemoveHandle || meta?.editorBlurred;
    // In view mode with right-side controls, remove any lingering drag handle decorations
    // (they may carry over from edit mode). Only remove drag handles specifically, not
    // the remix button decorations (those are managed separately via showInViewMode).
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && isViewMode && rightSideControlsEnabled) {
        const allHandleDecs = (0, $j28nv.findHandleDec)(decorations, 0, newState.doc.content.size);
        if (allHandleDecs.length > 0) decorations = decorations.remove(allHandleDecs);
    }
    if (shouldRemoveHandle) {
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const oldHandle = (0, $j28nv.findHandleDec)(decorations, activeNode?.pos, activeNode?.pos);
            decorations = decorations.remove(oldHandle);
        }
        // When removing the handle, also remove the anchor-marker node decorations
        // (data-active-drag-handle / data-active-quick-insert) so the DOM attributes
        // don't linger on nodes that are no longer active.
        // Use full-range search (0..contentSize) rather than a point-range at activeNode.pos/rootPos:
        // after a doc change (e.g. pressing Enter splits a node), DecorationSet.map() can shift the
        // decoration to a different position, so a point-range search would miss it and leave a stale
        // attribute on the wrong DOM node.
        if ((!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') || nodeDecorationRegistry.length > 0) && (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) {
            const oldActiveNodeDec = (0, $j28nv.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveNodeDec);
            const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveQuickInsertDec);
        }
        // nodeDecorationRegistry cleanup (e.g. the legacy Remix button) is independent of the legacy
        // quick-insert button, so this must not be gated by quickInsertButtonEnabled — otherwise a
        // stale decoration is left behind whenever platform_editor_block_control_migration is on.
        if (flags.toolbarFlagsEnabled) {
            // platform_editor_controls note: enables quick insert
            if (quickInsertButtonEnabled) {
                const oldQuickInsertButton = (0, $hYw7t.findQuickInsertInsertButtonDecoration)(decorations, activeNode?.rootPos, activeNode?.rootPos);
                decorations = decorations.remove(oldQuickInsertButton);
            }
            for (const factory of nodeDecorationRegistry){
                const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
            if (rightSideControlsEnabled && isViewMode && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
                for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                    const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                    decorations = decorations.remove(old);
                }
            }
        }
    } else if (api) {
        // The registry surface replaces the legacy drag-handle decorations during migration.
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && shouldRecreateHandle && (!rightSideControlsEnabled || !isViewMode)) {
            const oldHandle = (0, $j28nv.findHandleDec)(decorations, activeNode?.pos, activeNode?.pos);
            decorations = decorations.remove(oldHandle);
            const handleDec = (0, $j28nv.dragHandleDecoration)({
                api: api,
                formatMessage: formatMessage,
                pos: latestActiveNode?.pos,
                anchorName: latestActiveNode?.anchorName,
                nodeType: latestActiveNode?.nodeType,
                handleOptions: latestActiveNode?.handleOptions,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                handleDec
            ]);
        }
        if ((!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') || // nodeDecorationRegistry consumers (e.g. the legacy Remix button) rely
        // on that same anchor-name for their own CSS anchor() positioning, so this must still run
        // when such a consumer exists even if the legacy drag handle itself is disabled.
        nodeDecorationRegistry.length > 0) && (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && latestActiveNode) {
            // patch_1: a plain doc change no longer forces a rescan — map() above has already
            // either kept the decoration correctly positioned or dropped it as invalid, so we
            // only need to act when it was actually dropped.
            const docChangeInvalidatedNodeDec = (0, $iDrrr.fg)('platform_editor_controls_reliable_anchor_patch_1') ? activeHandleDecDropped : tr.docChanged;
            // Recreate the drag handle node decoration when the active node changed,
            // its content was modified, or the document changed.
            // This runs independently of shouldRecreateHandle so that doc changes (like pressing
            // Enter) correctly refresh the decoration even when the handle widget doesn't move.
            // DecorationSet.map() can misplace the decoration after node splits/inserts.
            const needsNodeDecUpdate = activeNodeChanged || isActiveNodeModified || docChangeInvalidatedNodeDec;
            if (needsNodeDecUpdate) {
                const nodeSize = newState.doc.nodeAt(latestActiveNode.pos)?.nodeSize;
                if (nodeSize !== undefined) {
                    // Search the full doc range: after DecorationSet.map(), the decoration may have
                    // shifted away from activeNode?.pos (e.g. a node split moves it to the new paragraph).
                    const oldActiveNodeDec = (0, $j28nv.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const dragHandleDecAlreadyCorrect = oldActiveNodeDec.length === 1 && oldActiveNodeDec[0].from === latestActiveNode.pos && oldActiveNodeDec[0].to === latestActiveNode.pos + nodeSize;
                    if (!dragHandleDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveNodeDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $j28nv.createActiveDragHandleNodeDecoration)(latestActiveNode.pos, nodeSize)
                        ]);
                    }
                }
            }
            // The quick-insert decoration lives on the root node (rootPos), which can change
            // independently of the edit-mode node — e.g. when only editorSizeChanged fires but
            // rootActiveNodeChanged is also true. So we use a separate, broader guard that
            // includes rootActiveNodeChanged to avoid leaving the attribute on a stale root node.
            const needsQuickInsertDecUpdate = activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || ((0, $iDrrr.fg)('platform_editor_controls_reliable_anchor_patch_1') ? activeQuickInsertDecDropped : tr.docChanged);
            if (needsQuickInsertDecUpdate && latestActiveNode.rootPos !== undefined) {
                const rootNodeSize = newState.doc.nodeAt(latestActiveNode.rootPos)?.nodeSize;
                if (rootNodeSize !== undefined) {
                    const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const quickInsertDecAlreadyCorrect = oldActiveQuickInsertDec.length === 1 && oldActiveQuickInsertDec[0].from === latestActiveNode.rootPos && oldActiveQuickInsertDec[0].to === latestActiveNode.rootPos + rootNodeSize;
                    if (!quickInsertDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveQuickInsertDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $hYw7t.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                        ]);
                    }
                }
            }
        }
        if (shouldRecreateQuickInsertButton && latestActiveNode?.rootPos !== undefined && (quickInsertButtonEnabled || nodeDecorationRegistry.length > 0) && // platform_editor_controls note: enables quick insert
        flags.toolbarFlagsEnabled && (!rightSideControlsEnabled || !isViewMode)) {
            if (quickInsertButtonEnabled) {
                const oldQuickInsertButton = (0, $hYw7t.findQuickInsertInsertButtonDecoration)(decorations, activeNode?.rootPos, activeNode?.rootPos);
                decorations = decorations.remove(oldQuickInsertButton);
                const quickInsertButton = (0, $hYw7t.quickInsertButtonDecoration)({
                    api: api,
                    formatMessage: formatMessage,
                    anchorName: latestActiveNode?.anchorName,
                    nodeType: latestActiveNode?.nodeType,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    rootPos: latestActiveNode?.rootPos,
                    rootAnchorName: latestActiveNode?.rootAnchorName,
                    rootNodeType: latestActiveNode?.rootNodeType,
                    anchorRectCache: anchorRectCache,
                    editorState: newState
                });
                decorations = decorations.add(newState.doc, [
                    quickInsertButton
                ]);
            }
            // Update quick insert node decoration when the quick insert button is recreated but
            // the drag handle was NOT recreated (shouldRecreateHandle was false). When
            // shouldRecreateHandle is true, the block above already handles this.
            // Also skip when the needsQuickInsertDecUpdate block above already handled the update
            // (i.e. activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged)
            // — running both would remove and re-add a duplicate decoration.
            if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !shouldRecreateHandle && !(activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged) && latestActiveNode?.rootPos !== undefined) {
                // Use full-range search (0..contentSize) rather than a point-range at activeNode.rootPos:
                // after a doc change, DecorationSet.map() can shift the decoration to a different position,
                // so a point-range search would miss it and leave a stale attribute on the wrong DOM node.
                const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                decorations = decorations.remove(oldActiveQuickInsertDec);
                const rootNodeSize = newState.doc.nodeAt(latestActiveNode.rootPos)?.nodeSize;
                if (rootNodeSize !== undefined) decorations = decorations.add(newState.doc, [
                    (0, $hYw7t.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                ]);
            }
            if (rightSideControlsEnabled) for (const factory of nodeDecorationRegistry){
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
                // determines whether to show the decorations, see malleableUiPlugin.tsx
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
            else for (const factory of nodeDecorationRegistry){
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
        // In view mode (edit/live pages), show right-side controls on block hover (without drag handle or quick insert)
        const rootPos = latestActiveNode?.rootPos;
        // rootPos is computed using the same logic as the floating insert menu, so it always points to a top-level (doc child) block when defined.
        const isDocLevel = rootPos !== undefined && !isNaN(rootPos);
        if (isViewMode && isDocLevel && flags.toolbarFlagsEnabled && rightSideControlsEnabled) {
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const existingAtPos = decorations.find(rootPos, rootPos, (spec)=>spec.type === factory.type);
                // Skip remove/re-add when decoration already exists at correct position - avoids
                // flickering from widget destroy/recreate on every transaction (e.g. on hover).
                if (existingAtPos.length > 0) continue;
                // Remove any stale decoration at a different position (e.g. after moving to another block)
                const stale = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(stale);
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
        } else if (isViewMode && rightSideControlsEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
            // Remove view-mode right-side decorations when no active node
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
    }
    // Drop targets may be missing when the node count is being changed during a drag
    const isDropTargetsMissing = (meta?.isDragging ?? isDragging) && maybeNodeCountChanged && !meta?.nodeMoved;
    // Remove drop target decorations when dragging stops or they need to be redrawn
    if (meta?.isDragging === false || isDropTargetsMissing) {
        const dropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
        decorations = decorations.remove(dropTargetDecs);
    }
    let currentActiveDropTargetNode = isDragging ? currentState.activeDropTargetNode : undefined;
    if (api) {
        if ((0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // If page is updated while dragging (likely by remote updates), we simply remove the drop targets
            // and add them back when the user interacts with the editor again
            if (isDropTargetsMissing) {
                const oldDropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
                decorations = decorations.remove(oldDropTargetDecs);
            }
            if (meta?.activeDropTargetNode) {
                currentActiveDropTargetNode = meta?.activeDropTargetNode;
                const oldDropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
                const { decsToAdd: decsToAdd, decsToRemove: decsToRemove } = (0, $g8ZIt.getActiveDropTargetDecorations)(meta.activeDropTargetNode, newState, api, oldDropTargetDecs, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
                decorations = decorations.remove(decsToRemove);
                if (decsToAdd.length > 0) decorations = decorations.add(newState.doc, decsToAdd);
            }
        } else if (meta?.isDragging || isDropTargetsMissing) {
            // Add drop targets when dragging starts or some are missing
            const decs = (0, $djgGr.dropTargetDecorations)(newState, api, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
            decorations = decorations.add(newState.doc, decs);
        }
    }
    const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(newState.doc);
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && meta?.isDragging === false) decorations = decorations.remove((0, $rOV4B.findNodeDecs)(newState, decorations));
    if (isEmptyDoc && !((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'))) {
        const hasNodeDecoration = !!(0, $rOV4B.findNodeDecs)(newState, decorations).length;
        if (!hasNodeDecoration) decorations = decorations.add(newState.doc, [
            (0, $j28nv.emptyParagraphNodeDecorations)()
        ]);
    }
    let newActiveNode;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) {
        // remove isEmptyDoc check and let decorations render and determine their own visibility
        // In view mode with right-side controls we render node decorations (right-edge button), not the
        // handle - so findHandleDec is always empty. Don't clear activeNode in that case.
        const hasHandleOrViewModeControls = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') || isViewMode && rightSideControlsEnabled || (0, $j28nv.findHandleDec)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length > 0;
        // Keep the registry surface mounted while its Block Menu owns focus.
        const keepActiveNodeForOpenBlockMenu = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && isMenuOpen;
        newActiveNode = meta?.editorBlurred && !keepActiveNodeForOpenBlockMenu || !meta?.activeNode && !hasHandleOrViewModeControls ? null : latestActiveNode;
    } else newActiveNode = isEmptyDoc || !meta?.activeNode && !(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && (0, $j28nv.findHandleDec)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length === 0 ? null : latestActiveNode;
    let isMenuOpenNew = isMenuOpen;
    let nextMenuTriggerByNode = meta?.toggleMenu?.triggerByNode || menuTriggerByNode;
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && tr.docChanged && menuTriggerByNode && !meta?.toggleMenu) {
        const mapped = tr.mapping.mapResult(menuTriggerByNode.pos, 1);
        const mappedRoot = tr.mapping.mapResult(menuTriggerByNode.rootPos ?? menuTriggerByNode.pos, 1);
        if (mapped.deleted || mappedRoot.deleted || !newState.doc.nodeAt(mapped.pos)?.isBlock) {
            nextMenuTriggerByNode = undefined;
            isMenuOpenNew = false;
        } else nextMenuTriggerByNode = {
            ...menuTriggerByNode,
            pos: mapped.pos,
            rootPos: mappedRoot.pos
        };
    }
    if (meta?.closeMenu) isMenuOpenNew = false;
    else if (meta?.toggleMenu) {
        const isSameAnchor = meta?.toggleMenu.anchorName === menuTriggerBy;
        isMenuOpenNew = menuTriggerBy === undefined || isSameAnchor || !isMenuOpen && !isSameAnchor ? !isMenuOpen : isMenuOpen;
    }
    let isSelectedViaDragHandleNew;
    if (flags.toolbarFlagsEnabled) isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined ? meta?.isSelectedViaDragHandle : isSelectedViaDragHandle;
    else isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined && flags.toolbarFlagsEnabled && meta?.isSelectedViaDragHandle;
    return {
        decorations: decorations,
        surfaceNodePositions: surfaceNodePositions,
        activeNode: newActiveNode,
        activeDropTargetNode: currentActiveDropTargetNode,
        isDragging: meta?.isDragging ?? isDragging,
        isMenuOpen: isMenuOpenNew,
        menuTriggerBy: meta?.toggleMenu?.anchorName || menuTriggerBy,
        menuTriggerByNode: nextMenuTriggerByNode,
        blockMenuOptions: {
            canMoveUp: meta?.toggleMenu?.moveUp !== undefined ? meta?.toggleMenu?.moveUp : blockMenuOptions?.canMoveUp,
            canMoveDown: meta?.toggleMenu?.moveDown !== undefined ? meta?.toggleMenu?.moveDown : blockMenuOptions?.canMoveDown,
            openedViaKeyboard: meta?.toggleMenu?.openedViaKeyboard !== undefined ? meta?.toggleMenu?.openedViaKeyboard : blockMenuOptions?.openedViaKeyboard
        },
        editorHeight: meta?.editorHeight ?? editorHeight,
        editorWidthLeft: meta?.editorWidthLeft ?? editorWidthLeft,
        editorWidthRight: meta?.editorWidthRight ?? editorWidthRight,
        isResizerResizing: isResizerResizing,
        isDocSizeLimitEnabled: $ae8d0893738a17f4$var$initialState.isDocSizeLimitEnabled,
        isPMDragging: meta?.isPMDragging ?? isPMDragging,
        multiSelectDnD: multiSelectDnD,
        lastDragCancelled: meta?.lastDragCancelled ?? lastDragCancelled,
        isSelectedViaDragHandle: isSelectedViaDragHandleNew
    };
};
const $ae8d0893738a17f4$export$ae829ec7b2625219 = (api, getIntl, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true)=>{
    const { formatMessage: formatMessage } = getIntl();
    const isAdvancedLayoutEnabled = (0, $jkcNT.editorExperiment)('advanced_layouts', true, {
        exposure: true
    });
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const flags = {
        toolbarFlagsEnabled: toolbarFlagsEnabled
    };
    let anchorRectCache;
    if (!(0, $a4QVD.isAnchorSupported)()) anchorRectCache = new (0, $a4QVD.AnchorRectCache)();
    let resizeObserverWidth;
    let pragmaticCleanup = null;
    // Limited mode is a one-way latch, so its teardown must only run on the transition.
    const limitedModeTeardown = {
        done: false
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $ae8d0893738a17f4$export$df61b30b684217c0,
        state: {
            init: ()=>({
                    ...$ae8d0893738a17f4$var$initialState
                }),
            apply: (tr, currentState, _, newState)=>$ae8d0893738a17f4$export$5635d7ef4b8fee1c(api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled, anchorRectCache, resizeObserverWidth, pragmaticCleanup, limitedModeTeardown)
        },
        props: {
            decorations: (state)=>{
                if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                const isDisabled = api?.editorDisabled?.sharedState.currentState()?.editorDisabled;
                if (isDisabled) {
                    const remixRightSideEnabled = rightSideControlsEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg');
                    // Hide decorations when disabled, except in view mode when right-side controls are enabled
                    if (!remixRightSideEnabled || api?.editorViewMode?.sharedState.currentState()?.mode !== 'view') return;
                }
                let decorationSet = $ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.decorations;
                // In view mode with right-side controls, remove any lingering drag-handle decorations
                // (created in edit mode) that may not have been cleaned up on mode switch.
                if (decorationSet && !(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && rightSideControlsEnabled && api?.editorViewMode?.sharedState.currentState()?.mode === 'view') {
                    const handleDecs = (0, $j28nv.findHandleDec)(decorationSet, 0, state.doc.content.size);
                    if (handleDecs.length > 0) decorationSet = decorationSet.remove(handleDecs);
                }
                return decorationSet;
            },
            handleDOMEvents: {
                drop (view, event) {
                    // Prevent native DnD from triggering if we are in drag
                    const { dispatch: dispatch, dragging: dragging, state: state } = view;
                    const tr = state.tr;
                    let pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(state);
                    const dndDragCancelled = pluginState?.lastDragCancelled;
                    if (pluginState?.isPMDragging || dndDragCancelled) {
                        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            isPMDragging: false,
                            lastDragCancelled: false
                        }));
                    }
                    pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(view.state);
                    if (!(event.target instanceof HTMLElement) || !pluginState?.activeNode) return false;
                    // Currently we can only drag one node at a time
                    // so we only need to check first child
                    const draggable = dragging?.slice.content.firstChild;
                    if (dndDragCancelled || draggable?.type.name === 'layoutColumn') {
                        // we prevent native DnD for layoutColumn to prevent single column layout.
                        event.preventDefault();
                        return false;
                    }
                    const nodeElement = event.target?.closest?.(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
                    if (!nodeElement) return false;
                    // TODO: ED-26959 - Review usage of posAtDOM here
                    const domPos = Math.max(view.posAtDOM(nodeElement, 0) - 1, 0);
                    const nodeTarget = state.doc.nodeAt(domPos);
                    const isSameNode = !!(nodeTarget && draggable?.eq(nodeTarget));
                    if (isSameNode) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                dragenter (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    // Only process dragenter for block control drags.
                    // Other drag types (e.g. table row) should not create
                    // drop target decorations or emit active anchors.
                    if (!$ae8d0893738a17f4$export$df61b30b684217c0.getState(view.state)?.isDragging) return;
                    if ($ae8d0893738a17f4$var$isHTMLElement(event.target) && (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
                        const targetElement = event.target.closest('[data-prosemirror-node-name]');
                        if (targetElement) {
                            const nodeTypeName = targetElement?.getAttribute('data-prosemirror-node-name');
                            const pos = view.posAtDOM(targetElement, -1);
                            const currentActiveDropTargetNode = api?.blockControls.sharedState.currentState()?.activeDropTargetNode;
                            if (currentActiveDropTargetNode?.pos !== pos || currentActiveDropTargetNode?.nodeTypeName !== nodeTypeName) {
                                const activeDropTargetNode = {
                                    pos: pos,
                                    nodeTypeName: nodeTypeName
                                };
                                view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                                    activeDropTargetNode: activeDropTargetNode
                                }));
                            }
                        }
                    } else if (isAdvancedLayoutEnabled) {
                        if ($ae8d0893738a17f4$var$isHTMLElement(event.target)) {
                            const closestParentElement = event.target.closest('[data-drag-handler-anchor-depth="0"]');
                            if (closestParentElement) {
                                const currentAnchor = closestParentElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
                                if (currentAnchor) (0, $d1Uph.defaultActiveAnchorTracker).emit(currentAnchor);
                            }
                        }
                    }
                },
                dragstart (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    (0, $hiQdW.startMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT);
                    if (isAdvancedLayoutEnabled) (0, $d1Uph.defaultActiveAnchorTracker).reset();
                    if ((0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) anchorRectCache?.clear();
                    anchorRectCache?.setEditorView(view);
                    view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                        isPMDragging: true
                    }));
                },
                dragend (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    const { state: state, dispatch: dispatch } = view;
                    if ($ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.isPMDragging) {
                        const tr = state.tr;
                        tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            isPMDragging: false
                        });
                        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr);
                    }
                },
                mouseover: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    // another layer of protection to prevent handling mouseover
                    // when native anchor with dnd is enabled in limited mode
                    // in case there are descripancies between getNodeIdProvider limited mode state
                    if ((0, $4RpM6.getNodeIdProvider)(view)?.isLimitedMode() && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration'))) return;
                    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) (0, $hwVXJ.handleSparseMouseOver)(view, event, api);
                    else (0, $h7MdN.handleMouseOver)(view, event, api);
                    return false;
                },
                mousedown: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    return (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $9UAss.handleMouseDown)(api)(view, event) : undefined;
                },
                keydown (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if (event.shiftKey && event.ctrlKey) //prevent holding down key combo from firing repeatedly
                    {
                        if (!event.repeat && (0, $jdNrc.boundKeydownHandler)(api, formatMessage)(view, event)) {
                            event.preventDefault();
                            return true;
                        }
                    }
                    if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLElement && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isDragHandle = event.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR)) !== null;
                        api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle));
                    }
                    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowUp') && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isBlockMenuOpen = api?.blockControls.sharedState.currentState()?.isMenuOpen;
                        // when block menu is just open, and we press arrow keys, we want to use the arrow keys to navigate the block menu
                        // in this scenario, isSelectedViaDragHandle should not be set to false
                        if (api?.blockControls.sharedState.currentState()?.isSelectedViaDragHandle && !isBlockMenuOpen) api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(false));
                    }
                    return false;
                },
                blur (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
                        // Focus moving into the registry surface remains inside the editor experience.
                        const isChildOfSurface = (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest((0, $hTjcC.BLOCK_CONTROLS_SURFACE_SELECTOR)) !== null;
                        const shouldPreserveRemixInlineDropdownFocus = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[data-editor-remix-inline-dropdown-preserve-focus]') !== null;
                        const isChildOfEditor = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest(`#${(0, $bwJyA.EDIT_AREA_ID)}`) !== null;
                        // don't do anything if the event relatedTarget (the element receiving focus) is a child of the editor
                        // or if the editor has focus
                        if (isChildOfEditor || isChildOfSurface || shouldPreserveRemixInlineDropdownFocus || view.hasFocus()) return false;
                        api?.core?.actions.execute(({ tr: tr })=>{
                            const currMeta = tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
                            tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                                ...currMeta,
                                editorBlurred: true
                            });
                            return tr;
                        });
                        return false;
                    }
                }
            }
        },
        view: (editorView)=>{
            const dom = editorView.dom;
            const editorContentArea = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
            // Use ResizeObserver to observe resizer (scroll-parent typically grows when resizing) and editor width changes
            resizeObserverWidth = new ResizeObserver((0, $LQnOI.default)((entries)=>{
                const pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(editorView.state);
                if (!pluginState?.isDragging) {
                    const isResizerResizing = !!dom.querySelector('.is-resizing');
                    const transaction = editorView.state.tr;
                    let shouldDispatch = false;
                    if (pluginState?.isResizerResizing !== isResizerResizing) {
                        transaction.setMeta('is-resizer-resizing', isResizerResizing);
                        shouldDispatch = true;
                    }
                    // Registry surfaces have their own ResizeObservers and absolute placement.
                    // Width metadata only drives legacy widget recreation.
                    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') && !isResizerResizing) {
                        const editorContentArea = entries[0].target;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthRight = editorContentArea.getBoundingClientRect().right;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthLeft = editorContentArea.getBoundingClientRect().left;
                        transaction.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...transaction.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            editorWidthLeft: editorWidthLeft,
                            editorWidthRight: editorWidthRight
                        });
                        shouldDispatch = true;
                    }
                    if (shouldDispatch) editorView.dispatch(transaction);
                }
            }));
            const shouldObserve = !((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) || !(0, $a4QVD.isAnchorSupported)();
            if (editorContentArea && shouldObserve) resizeObserverWidth.observe(editorContentArea);
            // Start pragmatic monitors
            pragmaticCleanup = $ae8d0893738a17f4$var$destroyFn(api, editorView);
            return {
                destroy () {
                    if (editorContentArea) resizeObserverWidth.unobserve(editorContentArea);
                    pragmaticCleanup?.();
                }
            };
        }
    });
};
const $ae8d0893738a17f4$export$e75bc9902db1596f = (tr)=>{
    return tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
};
module.exports["key"] = $ae8d0893738a17f4$export$df61b30b684217c0;
module.exports["getDecorations"] = $ae8d0893738a17f4$export$968abecb43309c32;
module.exports["createPlugin"] = $ae8d0893738a17f4$export$ae829ec7b2625219;
module.exports["getBlockControlsMeta"] = $ae8d0893738a17f4$export$e75bc9902db1596f;

});

parcelRegister("gxKDp", function(module, exports) {

var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");


var $bI2nS = parcelRequire("bI2nS");

const $ddec03442dd66a9a$export$b5524c7a5a82630a = {
    url: {
        title: (0, $bI2nS.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9)))
    },
    inline: {
        title: (0, $bI2nS.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu)))
    },
    block: {
        title: (0, $bI2nS.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4)))
    },
    embed: {
        title: (0, $bI2nS.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F)))
    }
};
module.exports["appearancePropsMap"] = $ddec03442dd66a9a$export$b5524c7a5a82630a;

});

parcelRegister("jdAIP", function(module, exports) {
var $b2f681feca808083$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var $b2f681feca808083$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b2f681feca808083$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
var $b2f681feca808083$export$2e2bcd8739ae039 = $b2f681feca808083$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $a33e97cd12c23639$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $a33e97cd12c23639$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a33e97cd12c23639$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a33e97cd12c23639$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a33e97cd12c23639$export$2e2bcd8739ae039 = $a33e97cd12c23639$var$formatLong;


var $e0c19184a1b1e296$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $e0c19184a1b1e296$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e0c19184a1b1e296$var$formatRelativeLocale[token];
};
var $e0c19184a1b1e296$export$2e2bcd8739ae039 = $e0c19184a1b1e296$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $451d43700c5ee845$var$eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $451d43700c5ee845$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var $451d43700c5ee845$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $451d43700c5ee845$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var $451d43700c5ee845$var$dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var $451d43700c5ee845$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var $451d43700c5ee845$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var $451d43700c5ee845$var$localize = {
    ordinalNumber: $451d43700c5ee845$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $451d43700c5ee845$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $451d43700c5ee845$export$2e2bcd8739ae039 = $451d43700c5ee845$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $26278ca5bf5af828$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $26278ca5bf5af828$var$parseOrdinalNumberPattern = /\d+/i;
var $26278ca5bf5af828$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $26278ca5bf5af828$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $26278ca5bf5af828$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $26278ca5bf5af828$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $26278ca5bf5af828$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $26278ca5bf5af828$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $26278ca5bf5af828$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $26278ca5bf5af828$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $26278ca5bf5af828$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $26278ca5bf5af828$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $26278ca5bf5af828$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $26278ca5bf5af828$var$matchOrdinalNumberPattern,
        parsePattern: $26278ca5bf5af828$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $26278ca5bf5af828$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $26278ca5bf5af828$export$2e2bcd8739ae039 = $26278ca5bf5af828$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $dfdbb7723bf7ba0f$var$locale = {
    code: 'af',
    formatDistance: (0, $b2f681feca808083$export$2e2bcd8739ae039),
    formatLong: (0, $a33e97cd12c23639$export$2e2bcd8739ae039),
    formatRelative: (0, $e0c19184a1b1e296$export$2e2bcd8739ae039),
    localize: (0, $451d43700c5ee845$export$2e2bcd8739ae039),
    match: (0, $26278ca5bf5af828$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $dfdbb7723bf7ba0f$export$2e2bcd8739ae039 = $dfdbb7723bf7ba0f$var$locale;
module.exports["default"] = $dfdbb7723bf7ba0f$export$2e2bcd8739ae039;

});

parcelRegister("lTSBl", function(module, exports) {
var $dd58201294ace246$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var $dd58201294ace246$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $dd58201294ace246$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $dd58201294ace246$export$2e2bcd8739ae039 = $dd58201294ace246$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f67db57f817b58a2$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $f67db57f817b58a2$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f67db57f817b58a2$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f67db57f817b58a2$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f67db57f817b58a2$export$2e2bcd8739ae039 = $f67db57f817b58a2$var$formatLong;


var $0159922a1f261318$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $0159922a1f261318$var$formatRelative = function formatRelative(token) {
    return $0159922a1f261318$var$formatRelativeLocale[token];
};
var $0159922a1f261318$export$2e2bcd8739ae039 = $0159922a1f261318$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $cd78d92f6f693dd7$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $cd78d92f6f693dd7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $cd78d92f6f693dd7$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $cd78d92f6f693dd7$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $cd78d92f6f693dd7$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $cd78d92f6f693dd7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $cd78d92f6f693dd7$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $cd78d92f6f693dd7$var$localize = {
    ordinalNumber: $cd78d92f6f693dd7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cd78d92f6f693dd7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cd78d92f6f693dd7$export$2e2bcd8739ae039 = $cd78d92f6f693dd7$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $fa1411ccf3e27b3c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fa1411ccf3e27b3c$var$parseOrdinalNumberPattern = /\d+/i;
var $fa1411ccf3e27b3c$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $fa1411ccf3e27b3c$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $fa1411ccf3e27b3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $fa1411ccf3e27b3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fa1411ccf3e27b3c$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $fa1411ccf3e27b3c$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $fa1411ccf3e27b3c$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $fa1411ccf3e27b3c$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $fa1411ccf3e27b3c$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $fa1411ccf3e27b3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $fa1411ccf3e27b3c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fa1411ccf3e27b3c$var$matchOrdinalNumberPattern,
        parsePattern: $fa1411ccf3e27b3c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fa1411ccf3e27b3c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fa1411ccf3e27b3c$export$2e2bcd8739ae039 = $fa1411ccf3e27b3c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $ff1916bb766f416a$var$locale = {
    code: 'ar',
    formatDistance: (0, $dd58201294ace246$export$2e2bcd8739ae039),
    formatLong: (0, $f67db57f817b58a2$export$2e2bcd8739ae039),
    formatRelative: (0, $0159922a1f261318$export$2e2bcd8739ae039),
    localize: (0, $cd78d92f6f693dd7$export$2e2bcd8739ae039),
    match: (0, $fa1411ccf3e27b3c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $ff1916bb766f416a$export$2e2bcd8739ae039 = $ff1916bb766f416a$var$locale;
module.exports["default"] = $ff1916bb766f416a$export$2e2bcd8739ae039;

});

parcelRegister("b7b2O", function(module, exports) {
var $96bcf62034ace16f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $96bcf62034ace16f$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $96bcf62034ace16f$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $96bcf62034ace16f$export$2e2bcd8739ae039 = $96bcf62034ace16f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f248cca0cfb5e781$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $f248cca0cfb5e781$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f248cca0cfb5e781$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f248cca0cfb5e781$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f248cca0cfb5e781$export$2e2bcd8739ae039 = $f248cca0cfb5e781$var$formatLong;


var $79643fe3feaa5518$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $79643fe3feaa5518$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $79643fe3feaa5518$var$formatRelativeLocale[token];
};
var $79643fe3feaa5518$export$2e2bcd8739ae039 = $79643fe3feaa5518$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $d9f580f3b1da0e18$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $d9f580f3b1da0e18$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $d9f580f3b1da0e18$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $d9f580f3b1da0e18$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $d9f580f3b1da0e18$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $d9f580f3b1da0e18$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $d9f580f3b1da0e18$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $d9f580f3b1da0e18$var$localize = {
    ordinalNumber: $d9f580f3b1da0e18$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d9f580f3b1da0e18$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d9f580f3b1da0e18$export$2e2bcd8739ae039 = $d9f580f3b1da0e18$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $fa10b19db80b2e40$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fa10b19db80b2e40$var$parseOrdinalNumberPattern = /\d+/i;
var $fa10b19db80b2e40$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $fa10b19db80b2e40$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $fa10b19db80b2e40$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $fa10b19db80b2e40$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fa10b19db80b2e40$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $fa10b19db80b2e40$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $fa10b19db80b2e40$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $fa10b19db80b2e40$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $fa10b19db80b2e40$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $fa10b19db80b2e40$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $fa10b19db80b2e40$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fa10b19db80b2e40$var$matchOrdinalNumberPattern,
        parsePattern: $fa10b19db80b2e40$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fa10b19db80b2e40$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fa10b19db80b2e40$export$2e2bcd8739ae039 = $fa10b19db80b2e40$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $8178ea531aca906f$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $96bcf62034ace16f$export$2e2bcd8739ae039),
    formatLong: (0, $f248cca0cfb5e781$export$2e2bcd8739ae039),
    formatRelative: (0, $79643fe3feaa5518$export$2e2bcd8739ae039),
    localize: (0, $d9f580f3b1da0e18$export$2e2bcd8739ae039),
    match: (0, $fa10b19db80b2e40$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8178ea531aca906f$export$2e2bcd8739ae039 = $8178ea531aca906f$var$locale;
module.exports["default"] = $8178ea531aca906f$export$2e2bcd8739ae039;

});

parcelRegister("aAFll", function(module, exports) {
var $bf93c12030db218f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var $bf93c12030db218f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bf93c12030db218f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
var $bf93c12030db218f$export$2e2bcd8739ae039 = $bf93c12030db218f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e93788a4172ac6df$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var $e93788a4172ac6df$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e93788a4172ac6df$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e93788a4172ac6df$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e93788a4172ac6df$export$2e2bcd8739ae039 = $e93788a4172ac6df$var$formatLong;


var $59bb8255866cfac9$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $59bb8255866cfac9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $59bb8255866cfac9$var$formatRelativeLocale[token];
};
var $59bb8255866cfac9$export$2e2bcd8739ae039 = $59bb8255866cfac9$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b9687b6ae6b3581b$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $b9687b6ae6b3581b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $b9687b6ae6b3581b$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $b9687b6ae6b3581b$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $b9687b6ae6b3581b$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $b9687b6ae6b3581b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9687b6ae6b3581b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $b9687b6ae6b3581b$var$localize = {
    ordinalNumber: $b9687b6ae6b3581b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b9687b6ae6b3581b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b9687b6ae6b3581b$export$2e2bcd8739ae039 = $b9687b6ae6b3581b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $57a88cc7890775c8$var$matchOrdinalNumberPattern = /^(\d+)/;
var $57a88cc7890775c8$var$parseOrdinalNumberPattern = /\d+/i;
var $57a88cc7890775c8$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $57a88cc7890775c8$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $57a88cc7890775c8$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $57a88cc7890775c8$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $57a88cc7890775c8$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $57a88cc7890775c8$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $57a88cc7890775c8$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $57a88cc7890775c8$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $57a88cc7890775c8$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $57a88cc7890775c8$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $57a88cc7890775c8$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $57a88cc7890775c8$var$matchOrdinalNumberPattern,
        parsePattern: $57a88cc7890775c8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $57a88cc7890775c8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $57a88cc7890775c8$export$2e2bcd8739ae039 = $57a88cc7890775c8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $7b5d56198139aafc$var$locale = {
    code: 'ar-EG',
    formatDistance: (0, $bf93c12030db218f$export$2e2bcd8739ae039),
    formatLong: (0, $e93788a4172ac6df$export$2e2bcd8739ae039),
    formatRelative: (0, $59bb8255866cfac9$export$2e2bcd8739ae039),
    localize: (0, $b9687b6ae6b3581b$export$2e2bcd8739ae039),
    match: (0, $57a88cc7890775c8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7b5d56198139aafc$export$2e2bcd8739ae039 = $7b5d56198139aafc$var$locale;
module.exports["default"] = $7b5d56198139aafc$export$2e2bcd8739ae039;

});

parcelRegister("aDiMe", function(module, exports) {
var $f5b4cf25016bd32b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $f5b4cf25016bd32b$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $f5b4cf25016bd32b$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $f5b4cf25016bd32b$export$2e2bcd8739ae039 = $f5b4cf25016bd32b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $0e807c7d13f46a35$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $0e807c7d13f46a35$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $0e807c7d13f46a35$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0e807c7d13f46a35$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0e807c7d13f46a35$export$2e2bcd8739ae039 = $0e807c7d13f46a35$var$formatLong;


var $8f47874a1b864904$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $8f47874a1b864904$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8f47874a1b864904$var$formatRelativeLocale[token];
};
var $8f47874a1b864904$export$2e2bcd8739ae039 = $8f47874a1b864904$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $24335f6b72b9bbaa$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $24335f6b72b9bbaa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $24335f6b72b9bbaa$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var $24335f6b72b9bbaa$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $24335f6b72b9bbaa$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $24335f6b72b9bbaa$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $24335f6b72b9bbaa$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $24335f6b72b9bbaa$var$localize = {
    ordinalNumber: $24335f6b72b9bbaa$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $24335f6b72b9bbaa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $24335f6b72b9bbaa$export$2e2bcd8739ae039 = $24335f6b72b9bbaa$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $6a06ea1f8e837431$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6a06ea1f8e837431$var$parseOrdinalNumberPattern = /\d+/i;
var $6a06ea1f8e837431$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $6a06ea1f8e837431$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $6a06ea1f8e837431$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $6a06ea1f8e837431$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6a06ea1f8e837431$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $6a06ea1f8e837431$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $6a06ea1f8e837431$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $6a06ea1f8e837431$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $6a06ea1f8e837431$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6a06ea1f8e837431$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6a06ea1f8e837431$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6a06ea1f8e837431$var$matchOrdinalNumberPattern,
        parsePattern: $6a06ea1f8e837431$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6a06ea1f8e837431$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6a06ea1f8e837431$export$2e2bcd8739ae039 = $6a06ea1f8e837431$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $7bdc1c959e26eae3$var$locale = {
    code: 'ar-MA',
    formatDistance: (0, $f5b4cf25016bd32b$export$2e2bcd8739ae039),
    formatLong: (0, $0e807c7d13f46a35$export$2e2bcd8739ae039),
    formatRelative: (0, $8f47874a1b864904$export$2e2bcd8739ae039),
    localize: (0, $24335f6b72b9bbaa$export$2e2bcd8739ae039),
    match: (0, $6a06ea1f8e837431$export$2e2bcd8739ae039),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $7bdc1c959e26eae3$export$2e2bcd8739ae039 = $7bdc1c959e26eae3$var$locale;
module.exports["default"] = $7bdc1c959e26eae3$export$2e2bcd8739ae039;

});

parcelRegister("cSVQD", function(module, exports) {
var $0f295f83b79d9846$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $0f295f83b79d9846$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0f295f83b79d9846$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $0f295f83b79d9846$export$2e2bcd8739ae039 = $0f295f83b79d9846$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $01852b7175515125$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $01852b7175515125$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $01852b7175515125$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $01852b7175515125$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $01852b7175515125$export$2e2bcd8739ae039 = $01852b7175515125$var$formatLong;


var $fa2ddb3d63960783$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $fa2ddb3d63960783$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fa2ddb3d63960783$var$formatRelativeLocale[token];
};
var $fa2ddb3d63960783$export$2e2bcd8739ae039 = $fa2ddb3d63960783$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a0ce5da94bce0308$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $a0ce5da94bce0308$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $a0ce5da94bce0308$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $a0ce5da94bce0308$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $a0ce5da94bce0308$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $a0ce5da94bce0308$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $a0ce5da94bce0308$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $a0ce5da94bce0308$var$localize = {
    ordinalNumber: $a0ce5da94bce0308$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a0ce5da94bce0308$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a0ce5da94bce0308$export$2e2bcd8739ae039 = $a0ce5da94bce0308$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5d376a22169806a1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $5d376a22169806a1$var$parseOrdinalNumberPattern = /\d+/i;
var $5d376a22169806a1$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $5d376a22169806a1$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $5d376a22169806a1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $5d376a22169806a1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5d376a22169806a1$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $5d376a22169806a1$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $5d376a22169806a1$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $5d376a22169806a1$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $5d376a22169806a1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $5d376a22169806a1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $5d376a22169806a1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5d376a22169806a1$var$matchOrdinalNumberPattern,
        parsePattern: $5d376a22169806a1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5d376a22169806a1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5d376a22169806a1$export$2e2bcd8739ae039 = $5d376a22169806a1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $961766977fd63b1b$var$locale = {
    code: 'ar-SA',
    formatDistance: (0, $0f295f83b79d9846$export$2e2bcd8739ae039),
    formatLong: (0, $01852b7175515125$export$2e2bcd8739ae039),
    formatRelative: (0, $fa2ddb3d63960783$export$2e2bcd8739ae039),
    localize: (0, $a0ce5da94bce0308$export$2e2bcd8739ae039),
    match: (0, $5d376a22169806a1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $961766977fd63b1b$export$2e2bcd8739ae039 = $961766977fd63b1b$var$locale;
module.exports["default"] = $961766977fd63b1b$export$2e2bcd8739ae039;

});

parcelRegister("c4IgH", function(module, exports) {
var $08ef092b5db007a9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var $08ef092b5db007a9$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $08ef092b5db007a9$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
var $08ef092b5db007a9$export$2e2bcd8739ae039 = $08ef092b5db007a9$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e63ae226639e18cb$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $e63ae226639e18cb$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e63ae226639e18cb$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e63ae226639e18cb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e63ae226639e18cb$export$2e2bcd8739ae039 = $e63ae226639e18cb$var$formatLong;


var $c648f06e22d2f537$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var $c648f06e22d2f537$var$formatRelative = function formatRelative(token) {
    return $c648f06e22d2f537$var$formatRelativeLocale[token];
};
var $c648f06e22d2f537$export$2e2bcd8739ae039 = $c648f06e22d2f537$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b9926ebd06f12423$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $b9926ebd06f12423$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $b9926ebd06f12423$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $b9926ebd06f12423$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $b9926ebd06f12423$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9926ebd06f12423$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9926ebd06f12423$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $b9926ebd06f12423$var$localize = {
    ordinalNumber: $b9926ebd06f12423$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b9926ebd06f12423$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b9926ebd06f12423$export$2e2bcd8739ae039 = $b9926ebd06f12423$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $bb68f5fe977246c0$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $bb68f5fe977246c0$var$parseOrdinalNumberPattern = /\d+/i;
var $bb68f5fe977246c0$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $bb68f5fe977246c0$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $bb68f5fe977246c0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $bb68f5fe977246c0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bb68f5fe977246c0$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $bb68f5fe977246c0$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $bb68f5fe977246c0$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $bb68f5fe977246c0$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $bb68f5fe977246c0$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $bb68f5fe977246c0$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $bb68f5fe977246c0$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $bb68f5fe977246c0$var$matchOrdinalNumberPattern,
        parsePattern: $bb68f5fe977246c0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $bb68f5fe977246c0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $bb68f5fe977246c0$export$2e2bcd8739ae039 = $bb68f5fe977246c0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $0244c70221cbb5ce$var$locale = {
    code: 'ar-TN',
    formatDistance: (0, $08ef092b5db007a9$export$2e2bcd8739ae039),
    formatLong: (0, $e63ae226639e18cb$export$2e2bcd8739ae039),
    formatRelative: (0, $c648f06e22d2f537$export$2e2bcd8739ae039),
    localize: (0, $b9926ebd06f12423$export$2e2bcd8739ae039),
    match: (0, $bb68f5fe977246c0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0244c70221cbb5ce$export$2e2bcd8739ae039 = $0244c70221cbb5ce$var$locale;
module.exports["default"] = $0244c70221cbb5ce$export$2e2bcd8739ae039;

});

parcelRegister("f9xPZ", function(module, exports) {
var $318b0e24ced65955$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var $318b0e24ced65955$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $318b0e24ced65955$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
var $318b0e24ced65955$export$2e2bcd8739ae039 = $318b0e24ced65955$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $91d2297f88c8a881$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var $91d2297f88c8a881$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $91d2297f88c8a881$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $91d2297f88c8a881$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $91d2297f88c8a881$export$2e2bcd8739ae039 = $91d2297f88c8a881$var$formatLong;


var $6f0e50755c493b9d$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var $6f0e50755c493b9d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6f0e50755c493b9d$var$formatRelativeLocale[token];
};
var $6f0e50755c493b9d$export$2e2bcd8739ae039 = $6f0e50755c493b9d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $2fcb04ac4942286d$var$eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var $2fcb04ac4942286d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $2fcb04ac4942286d$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $2fcb04ac4942286d$var$dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var $2fcb04ac4942286d$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $2fcb04ac4942286d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $2fcb04ac4942286d$var$suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var $2fcb04ac4942286d$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($2fcb04ac4942286d$var$suffixes[a]) return $2fcb04ac4942286d$var$suffixes[a];
    else if ($2fcb04ac4942286d$var$suffixes[b]) return $2fcb04ac4942286d$var$suffixes[b];
    else if (c !== null) return $2fcb04ac4942286d$var$suffixes[c];
    return '';
};
var $2fcb04ac4942286d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $2fcb04ac4942286d$var$getSuffix(number);
    return number + suffix;
};
var $2fcb04ac4942286d$var$localize = {
    ordinalNumber: $2fcb04ac4942286d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2fcb04ac4942286d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2fcb04ac4942286d$export$2e2bcd8739ae039 = $2fcb04ac4942286d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $99da96f1160612a6$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $99da96f1160612a6$var$parseOrdinalNumberPattern = /\d+/i;
var $99da96f1160612a6$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $99da96f1160612a6$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $99da96f1160612a6$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $99da96f1160612a6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $99da96f1160612a6$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $99da96f1160612a6$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $99da96f1160612a6$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $99da96f1160612a6$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $99da96f1160612a6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $99da96f1160612a6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $99da96f1160612a6$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $99da96f1160612a6$var$matchOrdinalNumberPattern,
        parsePattern: $99da96f1160612a6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $99da96f1160612a6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $99da96f1160612a6$export$2e2bcd8739ae039 = $99da96f1160612a6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $b081f1b224bd63bf$var$locale = {
    code: 'az',
    formatDistance: (0, $318b0e24ced65955$export$2e2bcd8739ae039),
    formatLong: (0, $91d2297f88c8a881$export$2e2bcd8739ae039),
    formatRelative: (0, $6f0e50755c493b9d$export$2e2bcd8739ae039),
    localize: (0, $2fcb04ac4942286d$export$2e2bcd8739ae039),
    match: (0, $99da96f1160612a6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $b081f1b224bd63bf$export$2e2bcd8739ae039 = $b081f1b224bd63bf$var$locale;
module.exports["default"] = $b081f1b224bd63bf$export$2e2bcd8739ae039;

});

parcelRegister("jmsQ6", function(module, exports) {
function $a3da41d9a584d47f$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $a3da41d9a584d47f$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $a3da41d9a584d47f$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $a3da41d9a584d47f$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $a3da41d9a584d47f$var$declension(scheme.past, count);
                else return $a3da41d9a584d47f$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $a3da41d9a584d47f$var$declension(scheme.regular, count);
    };
}
var $a3da41d9a584d47f$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $a3da41d9a584d47f$var$formatDistanceLocale = {
    lessThanXSeconds: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $a3da41d9a584d47f$var$halfAMinute,
    lessThanXMinutes: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $a3da41d9a584d47f$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $a3da41d9a584d47f$var$formatDistanceLocale[token](count, options);
};
var $a3da41d9a584d47f$export$2e2bcd8739ae039 = $a3da41d9a584d47f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $d3ea639f741d83a8$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $d3ea639f741d83a8$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $d3ea639f741d83a8$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $d3ea639f741d83a8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $d3ea639f741d83a8$export$2e2bcd8739ae039 = $d3ea639f741d83a8$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $38e85d028b9a6b34$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $38e85d028b9a6b34$var$lastWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $38e85d028b9a6b34$var$thisWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $38e85d028b9a6b34$var$nextWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $38e85d028b9a6b34$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $38e85d028b9a6b34$var$thisWeek(day);
    else return $38e85d028b9a6b34$var$lastWeek(day);
};
var $38e85d028b9a6b34$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $38e85d028b9a6b34$var$thisWeek(day);
    else return $38e85d028b9a6b34$var$nextWeek(day);
};
var $38e85d028b9a6b34$var$formatRelativeLocale = {
    lastWeek: $38e85d028b9a6b34$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $38e85d028b9a6b34$var$nextWeekFormat,
    other: 'P'
};
var $38e85d028b9a6b34$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $38e85d028b9a6b34$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $38e85d028b9a6b34$export$2e2bcd8739ae039 = $38e85d028b9a6b34$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $1d4adbebaa32311b$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $1d4adbebaa32311b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $1d4adbebaa32311b$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $1d4adbebaa32311b$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $1d4adbebaa32311b$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $1d4adbebaa32311b$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $1d4adbebaa32311b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $1d4adbebaa32311b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $1d4adbebaa32311b$var$localize = {
    ordinalNumber: $1d4adbebaa32311b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $1d4adbebaa32311b$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $1d4adbebaa32311b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1d4adbebaa32311b$export$2e2bcd8739ae039 = $1d4adbebaa32311b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b0c34d8f35d5e56e$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $b0c34d8f35d5e56e$var$parseOrdinalNumberPattern = /\d+/i;
var $b0c34d8f35d5e56e$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $b0c34d8f35d5e56e$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $b0c34d8f35d5e56e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $b0c34d8f35d5e56e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b0c34d8f35d5e56e$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $b0c34d8f35d5e56e$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $b0c34d8f35d5e56e$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $b0c34d8f35d5e56e$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $b0c34d8f35d5e56e$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $b0c34d8f35d5e56e$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $b0c34d8f35d5e56e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b0c34d8f35d5e56e$var$matchOrdinalNumberPattern,
        parsePattern: $b0c34d8f35d5e56e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b0c34d8f35d5e56e$export$2e2bcd8739ae039 = $b0c34d8f35d5e56e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $e186714dab88b5a6$var$locale = {
    code: 'be',
    formatDistance: (0, $a3da41d9a584d47f$export$2e2bcd8739ae039),
    formatLong: (0, $d3ea639f741d83a8$export$2e2bcd8739ae039),
    formatRelative: (0, $38e85d028b9a6b34$export$2e2bcd8739ae039),
    localize: (0, $1d4adbebaa32311b$export$2e2bcd8739ae039),
    match: (0, $b0c34d8f35d5e56e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e186714dab88b5a6$export$2e2bcd8739ae039 = $e186714dab88b5a6$var$locale;
module.exports["default"] = $e186714dab88b5a6$export$2e2bcd8739ae039;

});

parcelRegister("jhqet", function(module, exports) {
function $11a20ed43c993415$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $11a20ed43c993415$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $11a20ed43c993415$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $11a20ed43c993415$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $11a20ed43c993415$var$declension(scheme.past, count);
                else return $11a20ed43c993415$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $11a20ed43c993415$var$declension(scheme.regular, count);
    };
}
var $11a20ed43c993415$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $11a20ed43c993415$var$formatDistanceLocale = {
    lessThanXSeconds: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $11a20ed43c993415$var$halfAMinute,
    lessThanXMinutes: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $11a20ed43c993415$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $11a20ed43c993415$var$formatDistanceLocale[token](count, options);
};
var $11a20ed43c993415$export$2e2bcd8739ae039 = $11a20ed43c993415$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $147a7f3db432cf11$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $147a7f3db432cf11$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $147a7f3db432cf11$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $147a7f3db432cf11$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $147a7f3db432cf11$export$2e2bcd8739ae039 = $147a7f3db432cf11$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $85392500641cecfb$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $85392500641cecfb$var$lastWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $85392500641cecfb$var$thisWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $85392500641cecfb$var$nextWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $85392500641cecfb$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $85392500641cecfb$var$thisWeek(day);
    else return $85392500641cecfb$var$lastWeek(day);
};
var $85392500641cecfb$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $85392500641cecfb$var$thisWeek(day);
    else return $85392500641cecfb$var$nextWeek(day);
};
var $85392500641cecfb$var$formatRelativeLocale = {
    lastWeek: $85392500641cecfb$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $85392500641cecfb$var$nextWeekFormat,
    other: 'P'
};
var $85392500641cecfb$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $85392500641cecfb$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $85392500641cecfb$export$2e2bcd8739ae039 = $85392500641cecfb$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $004f37759f8aeb0e$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $004f37759f8aeb0e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $004f37759f8aeb0e$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $004f37759f8aeb0e$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $004f37759f8aeb0e$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $004f37759f8aeb0e$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $004f37759f8aeb0e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $004f37759f8aeb0e$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $004f37759f8aeb0e$var$localize = {
    ordinalNumber: $004f37759f8aeb0e$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $004f37759f8aeb0e$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $004f37759f8aeb0e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $004f37759f8aeb0e$export$2e2bcd8739ae039 = $004f37759f8aeb0e$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $547c4f758a666784$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $547c4f758a666784$var$parseOrdinalNumberPattern = /\d+/i;
var $547c4f758a666784$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $547c4f758a666784$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $547c4f758a666784$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $547c4f758a666784$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $547c4f758a666784$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $547c4f758a666784$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $547c4f758a666784$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $547c4f758a666784$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $547c4f758a666784$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $547c4f758a666784$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $547c4f758a666784$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $547c4f758a666784$var$matchOrdinalNumberPattern,
        parsePattern: $547c4f758a666784$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $547c4f758a666784$export$2e2bcd8739ae039 = $547c4f758a666784$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $e093f41305dfbce7$var$locale = {
    code: 'be-tarask',
    formatDistance: (0, $11a20ed43c993415$export$2e2bcd8739ae039),
    formatLong: (0, $147a7f3db432cf11$export$2e2bcd8739ae039),
    formatRelative: (0, $85392500641cecfb$export$2e2bcd8739ae039),
    localize: (0, $004f37759f8aeb0e$export$2e2bcd8739ae039),
    match: (0, $547c4f758a666784$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e093f41305dfbce7$export$2e2bcd8739ae039 = $e093f41305dfbce7$var$locale;
module.exports["default"] = $e093f41305dfbce7$export$2e2bcd8739ae039;

});

parcelRegister("gCI9G", function(module, exports) {
var $0d0bb21158d046c2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $0d0bb21158d046c2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0d0bb21158d046c2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
var $0d0bb21158d046c2$export$2e2bcd8739ae039 = $0d0bb21158d046c2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $09f10a7e3f806b5a$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $09f10a7e3f806b5a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $09f10a7e3f806b5a$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $09f10a7e3f806b5a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $09f10a7e3f806b5a$export$2e2bcd8739ae039 = $09f10a7e3f806b5a$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

// Adapted from the `ru` translation
var $82cd260365851412$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $82cd260365851412$var$lastWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $82cd260365851412$var$thisWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $82cd260365851412$var$nextWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var $82cd260365851412$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $82cd260365851412$var$thisWeek(day);
    else return $82cd260365851412$var$lastWeek(day);
};
var $82cd260365851412$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $82cd260365851412$var$thisWeek(day);
    else return $82cd260365851412$var$nextWeek(day);
};
var $82cd260365851412$var$formatRelativeLocale = {
    lastWeek: $82cd260365851412$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $82cd260365851412$var$nextWeekFormatToken,
    other: 'P'
};
var $82cd260365851412$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $82cd260365851412$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $82cd260365851412$export$2e2bcd8739ae039 = $82cd260365851412$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $350b305b65b802b8$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $350b305b65b802b8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var $350b305b65b802b8$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $350b305b65b802b8$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var $350b305b65b802b8$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $350b305b65b802b8$var$isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function $350b305b65b802b8$var$isNeuter(unit) {
    return unit === 'quarter';
}
function $350b305b65b802b8$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $350b305b65b802b8$var$isNeuter(unit) ? neuter : $350b305b65b802b8$var$isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var $350b305b65b802b8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $350b305b65b802b8$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var $350b305b65b802b8$var$localize = {
    ordinalNumber: $350b305b65b802b8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $350b305b65b802b8$export$2e2bcd8739ae039 = $350b305b65b802b8$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $486b8cbaa152beed$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $486b8cbaa152beed$var$parseOrdinalNumberPattern = /\d+/i;
var $486b8cbaa152beed$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $486b8cbaa152beed$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $486b8cbaa152beed$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $486b8cbaa152beed$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $486b8cbaa152beed$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $486b8cbaa152beed$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $486b8cbaa152beed$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $486b8cbaa152beed$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $486b8cbaa152beed$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $486b8cbaa152beed$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $486b8cbaa152beed$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $486b8cbaa152beed$var$matchOrdinalNumberPattern,
        parsePattern: $486b8cbaa152beed$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $486b8cbaa152beed$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $486b8cbaa152beed$export$2e2bcd8739ae039 = $486b8cbaa152beed$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $c1a27242d2d22a09$var$locale = {
    code: 'bg',
    formatDistance: (0, $0d0bb21158d046c2$export$2e2bcd8739ae039),
    formatLong: (0, $09f10a7e3f806b5a$export$2e2bcd8739ae039),
    formatRelative: (0, $82cd260365851412$export$2e2bcd8739ae039),
    localize: (0, $350b305b65b802b8$export$2e2bcd8739ae039),
    match: (0, $486b8cbaa152beed$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c1a27242d2d22a09$export$2e2bcd8739ae039 = $c1a27242d2d22a09$var$locale;
module.exports["default"] = $c1a27242d2d22a09$export$2e2bcd8739ae039;

});

parcelRegister("gbABh", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $0e7126715f6352ff$var$numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var $0e7126715f6352ff$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var $0e7126715f6352ff$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var $0e7126715f6352ff$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var $0e7126715f6352ff$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var $0e7126715f6352ff$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var $0e7126715f6352ff$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $0e7126715f6352ff$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var $0e7126715f6352ff$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $0e7126715f6352ff$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return $0e7126715f6352ff$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function $0e7126715f6352ff$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $0e7126715f6352ff$var$numberValues.locale[match];
    });
}
var $0e7126715f6352ff$var$localize = {
    ordinalNumber: $0e7126715f6352ff$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0e7126715f6352ff$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0e7126715f6352ff$export$2e2bcd8739ae039 = $0e7126715f6352ff$var$localize;


var $6361aa5f13e18b9f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var $6361aa5f13e18b9f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6361aa5f13e18b9f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $0e7126715f6352ff$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
var $6361aa5f13e18b9f$export$2e2bcd8739ae039 = $6361aa5f13e18b9f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8b273ede8f784770$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $8b273ede8f784770$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $8b273ede8f784770$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8b273ede8f784770$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8b273ede8f784770$export$2e2bcd8739ae039 = $8b273ede8f784770$var$formatLong;


var $479f3bd97d1a907b$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var $479f3bd97d1a907b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $479f3bd97d1a907b$var$formatRelativeLocale[token];
};
var $479f3bd97d1a907b$export$2e2bcd8739ae039 = $479f3bd97d1a907b$var$formatRelative;




var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0f6d35625cff6b71$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $0f6d35625cff6b71$var$parseOrdinalNumberPattern = /\d+/i;
var $0f6d35625cff6b71$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $0f6d35625cff6b71$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $0f6d35625cff6b71$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $0f6d35625cff6b71$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $0f6d35625cff6b71$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $0f6d35625cff6b71$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $0f6d35625cff6b71$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $0f6d35625cff6b71$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $0f6d35625cff6b71$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $0f6d35625cff6b71$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $0f6d35625cff6b71$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0f6d35625cff6b71$var$matchOrdinalNumberPattern,
        parsePattern: $0f6d35625cff6b71$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0f6d35625cff6b71$export$2e2bcd8739ae039 = $0f6d35625cff6b71$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $bc8a1076b9cb0699$var$locale = {
    code: 'bn',
    formatDistance: (0, $6361aa5f13e18b9f$export$2e2bcd8739ae039),
    formatLong: (0, $8b273ede8f784770$export$2e2bcd8739ae039),
    formatRelative: (0, $479f3bd97d1a907b$export$2e2bcd8739ae039),
    localize: (0, $0e7126715f6352ff$export$2e2bcd8739ae039),
    match: (0, $0f6d35625cff6b71$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bc8a1076b9cb0699$export$2e2bcd8739ae039 = $bc8a1076b9cb0699$var$locale;
module.exports["default"] = $bc8a1076b9cb0699$export$2e2bcd8739ae039;

});

parcelRegister("gBLDk", function(module, exports) {
var $b2d1c943dd63d596$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $b2d1c943dd63d596$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b2d1c943dd63d596$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $b2d1c943dd63d596$export$2e2bcd8739ae039 = $b2d1c943dd63d596$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $7ae381bf48f63a46$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $7ae381bf48f63a46$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7ae381bf48f63a46$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7ae381bf48f63a46$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7ae381bf48f63a46$export$2e2bcd8739ae039 = $7ae381bf48f63a46$var$formatLong;


var $30874e90035a67c1$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $30874e90035a67c1$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $30874e90035a67c1$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $30874e90035a67c1$export$2e2bcd8739ae039 = $30874e90035a67c1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $505521e49905a82d$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var $505521e49905a82d$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $505521e49905a82d$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $505521e49905a82d$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $505521e49905a82d$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $505521e49905a82d$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $505521e49905a82d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $505521e49905a82d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var $505521e49905a82d$var$localize = {
    ordinalNumber: $505521e49905a82d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $505521e49905a82d$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $505521e49905a82d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $505521e49905a82d$export$2e2bcd8739ae039 = $505521e49905a82d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $05712f91748e06c3$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $05712f91748e06c3$var$parseOrdinalNumberPattern = /\d+/i;
var $05712f91748e06c3$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $05712f91748e06c3$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $05712f91748e06c3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $05712f91748e06c3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $05712f91748e06c3$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $05712f91748e06c3$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $05712f91748e06c3$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $05712f91748e06c3$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $05712f91748e06c3$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $05712f91748e06c3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $05712f91748e06c3$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $05712f91748e06c3$var$matchOrdinalNumberPattern,
        parsePattern: $05712f91748e06c3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $05712f91748e06c3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $05712f91748e06c3$export$2e2bcd8739ae039 = $05712f91748e06c3$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $c1750d05a11f40ea$var$locale = {
    code: 'bs',
    formatDistance: (0, $b2d1c943dd63d596$export$2e2bcd8739ae039),
    formatLong: (0, $7ae381bf48f63a46$export$2e2bcd8739ae039),
    formatRelative: (0, $30874e90035a67c1$export$2e2bcd8739ae039),
    localize: (0, $505521e49905a82d$export$2e2bcd8739ae039),
    match: (0, $05712f91748e06c3$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c1750d05a11f40ea$export$2e2bcd8739ae039 = $c1750d05a11f40ea$var$locale;
module.exports["default"] = $c1750d05a11f40ea$export$2e2bcd8739ae039;

});

parcelRegister("dNzyu", function(module, exports) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $59c097a7dfae9738$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $59c097a7dfae9738$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $59c097a7dfae9738$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
var $59c097a7dfae9738$export$2e2bcd8739ae039 = $59c097a7dfae9738$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f1313bdd9c00f010$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $f1313bdd9c00f010$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f1313bdd9c00f010$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f1313bdd9c00f010$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f1313bdd9c00f010$export$2e2bcd8739ae039 = $f1313bdd9c00f010$var$formatLong;


var $bcb7cbecaf482a8f$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $bcb7cbecaf482a8f$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var $bcb7cbecaf482a8f$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $bcb7cbecaf482a8f$var$formatRelativeLocalePlural[token];
    return $bcb7cbecaf482a8f$var$formatRelativeLocale[token];
};
var $bcb7cbecaf482a8f$export$2e2bcd8739ae039 = $bcb7cbecaf482a8f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var $1ce4572d936c96c9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $1ce4572d936c96c9$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var $1ce4572d936c96c9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $1ce4572d936c96c9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var $1ce4572d936c96c9$var$localize = {
    ordinalNumber: $1ce4572d936c96c9$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1ce4572d936c96c9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1ce4572d936c96c9$export$2e2bcd8739ae039 = $1ce4572d936c96c9$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $f06ce2ace064ef8b$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $f06ce2ace064ef8b$var$parseOrdinalNumberPattern = /\d+/i;
var $f06ce2ace064ef8b$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $f06ce2ace064ef8b$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $f06ce2ace064ef8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $f06ce2ace064ef8b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f06ce2ace064ef8b$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $f06ce2ace064ef8b$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $f06ce2ace064ef8b$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $f06ce2ace064ef8b$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $f06ce2ace064ef8b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $f06ce2ace064ef8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $f06ce2ace064ef8b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $f06ce2ace064ef8b$var$matchOrdinalNumberPattern,
        parsePattern: $f06ce2ace064ef8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f06ce2ace064ef8b$export$2e2bcd8739ae039 = $f06ce2ace064ef8b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $a0bb6e8227855700$var$locale = {
    code: 'ca',
    formatDistance: (0, $59c097a7dfae9738$export$2e2bcd8739ae039),
    formatLong: (0, $f1313bdd9c00f010$export$2e2bcd8739ae039),
    formatRelative: (0, $bcb7cbecaf482a8f$export$2e2bcd8739ae039),
    localize: (0, $1ce4572d936c96c9$export$2e2bcd8739ae039),
    match: (0, $f06ce2ace064ef8b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a0bb6e8227855700$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $a0bb6e8227855700$var$locale;
module.exports["default"] = $a0bb6e8227855700$export$2e2bcd8739ae039;

});

parcelRegister("kLhpw", function(module, exports) {
var $6b5eda3b5b84016e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var $6b5eda3b5b84016e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6b5eda3b5b84016e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $6b5eda3b5b84016e$export$2e2bcd8739ae039 = $6b5eda3b5b84016e$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $d5c1809193fbb88c$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d5c1809193fbb88c$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d5c1809193fbb88c$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d5c1809193fbb88c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d5c1809193fbb88c$export$2e2bcd8739ae039 = $d5c1809193fbb88c$var$formatLong;


var $4e79e869dd10c9dd$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var $4e79e869dd10c9dd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4e79e869dd10c9dd$var$formatRelativeLocale[token];
};
var $4e79e869dd10c9dd$export$2e2bcd8739ae039 = $4e79e869dd10c9dd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a78a99035aef8fad$var$eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var $a78a99035aef8fad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a78a99035aef8fad$var$monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var $a78a99035aef8fad$var$dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var $a78a99035aef8fad$var$dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var $a78a99035aef8fad$var$formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var $a78a99035aef8fad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var $a78a99035aef8fad$var$localize = {
    ordinalNumber: $a78a99035aef8fad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a78a99035aef8fad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a78a99035aef8fad$export$2e2bcd8739ae039 = $a78a99035aef8fad$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $72117dbd6520e10a$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $72117dbd6520e10a$var$parseOrdinalNumberPattern = /\d+/i;
var $72117dbd6520e10a$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $72117dbd6520e10a$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $72117dbd6520e10a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $72117dbd6520e10a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $72117dbd6520e10a$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $72117dbd6520e10a$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $72117dbd6520e10a$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $72117dbd6520e10a$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $72117dbd6520e10a$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $72117dbd6520e10a$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $72117dbd6520e10a$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $72117dbd6520e10a$var$matchOrdinalNumberPattern,
        parsePattern: $72117dbd6520e10a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $72117dbd6520e10a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $72117dbd6520e10a$export$2e2bcd8739ae039 = $72117dbd6520e10a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $f1d5b3d786608fdf$var$locale = {
    code: 'cy',
    formatDistance: (0, $6b5eda3b5b84016e$export$2e2bcd8739ae039),
    formatLong: (0, $d5c1809193fbb88c$export$2e2bcd8739ae039),
    formatRelative: (0, $4e79e869dd10c9dd$export$2e2bcd8739ae039),
    localize: (0, $a78a99035aef8fad$export$2e2bcd8739ae039),
    match: (0, $72117dbd6520e10a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f1d5b3d786608fdf$export$2e2bcd8739ae039 = $f1d5b3d786608fdf$var$locale;
module.exports["default"] = $f1d5b3d786608fdf$export$2e2bcd8739ae039;

});

parcelRegister("jiiAs", function(module, exports) {

var $7rt4j = parcelRequire("7rt4j");


var $60sGp = parcelRequire("60sGp");


var $4BSGy = parcelRequire("4BSGy");


var $lT7Hr = parcelRequire("lT7Hr");


var $9v2ZC = parcelRequire("9v2ZC");

var $d509bb718bc58b9c$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $d509bb718bc58b9c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d509bb718bc58b9c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $d509bb718bc58b9c$var$formattingMonthValues = {
    narrow: $d509bb718bc58b9c$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $d509bb718bc58b9c$var$monthValues.wide
};
var $d509bb718bc58b9c$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $d509bb718bc58b9c$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $d509bb718bc58b9c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $d509bb718bc58b9c$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $d509bb718bc58b9c$var$localize = {
    ordinalNumber: $d509bb718bc58b9c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$monthValues,
        formattingValues: $d509bb718bc58b9c$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d509bb718bc58b9c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d509bb718bc58b9c$export$2e2bcd8739ae039 = $d509bb718bc58b9c$var$localize;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $e0be1dc70926ecdd$var$locale = {
    code: 'de-AT',
    formatDistance: (0, $7rt4j.default),
    formatLong: (0, $60sGp.default),
    formatRelative: (0, $4BSGy.default),
    localize: (0, $d509bb718bc58b9c$export$2e2bcd8739ae039),
    match: (0, $lT7Hr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e0be1dc70926ecdd$export$2e2bcd8739ae039 = $e0be1dc70926ecdd$var$locale;
module.exports["default"] = $e0be1dc70926ecdd$export$2e2bcd8739ae039;

});

parcelRegister("8RXQT", function(module, exports) {
var $aa3ed254233a3ddb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var $aa3ed254233a3ddb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $aa3ed254233a3ddb$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
var $aa3ed254233a3ddb$export$2e2bcd8739ae039 = $aa3ed254233a3ddb$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $585f32b0dcabc968$var$dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var $585f32b0dcabc968$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $585f32b0dcabc968$var$dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $585f32b0dcabc968$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $585f32b0dcabc968$export$2e2bcd8739ae039 = $585f32b0dcabc968$var$formatLong;


var $a5e401d1352f6a4f$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var $a5e401d1352f6a4f$var$formatRelative = function formatRelative(token, date) {
    var format = $a5e401d1352f6a4f$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a5e401d1352f6a4f$export$2e2bcd8739ae039 = $a5e401d1352f6a4f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $5ca78e9a2e618269$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var $5ca78e9a2e618269$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var $5ca78e9a2e618269$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var $5ca78e9a2e618269$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var $5ca78e9a2e618269$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var $5ca78e9a2e618269$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var $5ca78e9a2e618269$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var $5ca78e9a2e618269$var$localize = {
    ordinalNumber: $5ca78e9a2e618269$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $5ca78e9a2e618269$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $5ca78e9a2e618269$export$2e2bcd8739ae039 = $5ca78e9a2e618269$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $76af839f7cde7563$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $76af839f7cde7563$var$parseOrdinalNumberPattern = /\d+/i;
var $76af839f7cde7563$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $76af839f7cde7563$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $76af839f7cde7563$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $76af839f7cde7563$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $76af839f7cde7563$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $76af839f7cde7563$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $76af839f7cde7563$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $76af839f7cde7563$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $76af839f7cde7563$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $76af839f7cde7563$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $76af839f7cde7563$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $76af839f7cde7563$var$matchOrdinalNumberPattern,
        parsePattern: $76af839f7cde7563$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $76af839f7cde7563$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $76af839f7cde7563$export$2e2bcd8739ae039 = $76af839f7cde7563$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $6751b35e65cddf94$var$locale = {
    code: 'el',
    formatDistance: (0, $aa3ed254233a3ddb$export$2e2bcd8739ae039),
    formatLong: (0, $585f32b0dcabc968$export$2e2bcd8739ae039),
    formatRelative: (0, $a5e401d1352f6a4f$export$2e2bcd8739ae039),
    localize: (0, $5ca78e9a2e618269$export$2e2bcd8739ae039),
    match: (0, $76af839f7cde7563$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6751b35e65cddf94$export$2e2bcd8739ae039 = $6751b35e65cddf94$var$locale;
module.exports["default"] = $6751b35e65cddf94$export$2e2bcd8739ae039;

});

parcelRegister("lGPlu", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $fcGXP = parcelRequire("fcGXP");

var $d573e6f470cdb3a4$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d573e6f470cdb3a4$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d573e6f470cdb3a4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d573e6f470cdb3a4$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d573e6f470cdb3a4$export$2e2bcd8739ae039 = $d573e6f470cdb3a4$var$formatLong;



var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $fca5596599fc38c5$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $d573e6f470cdb3a4$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $fca5596599fc38c5$export$2e2bcd8739ae039 = $fca5596599fc38c5$var$locale;
module.exports["default"] = $fca5596599fc38c5$export$2e2bcd8739ae039;

});

parcelRegister("2Y0P5", function(module, exports) {

var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");

var $87a8120b7335ef09$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var $87a8120b7335ef09$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $87a8120b7335ef09$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $87a8120b7335ef09$export$2e2bcd8739ae039 = $87a8120b7335ef09$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $623ebfbc3220ddec$var$dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var $623ebfbc3220ddec$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $623ebfbc3220ddec$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $623ebfbc3220ddec$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $623ebfbc3220ddec$export$2e2bcd8739ae039 = $623ebfbc3220ddec$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $2291d2ce867d6353$var$locale = {
    code: 'en-CA',
    formatDistance: (0, $87a8120b7335ef09$export$2e2bcd8739ae039),
    formatLong: (0, $623ebfbc3220ddec$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2291d2ce867d6353$export$2e2bcd8739ae039 = $2291d2ce867d6353$var$locale;
module.exports["default"] = $2291d2ce867d6353$export$2e2bcd8739ae039;

});

parcelRegister("hWN4g", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $hJozw = parcelRequire("hJozw");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $d10dea4df914c5fc$var$locale = {
    code: 'en-IE',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $hJozw.default),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d10dea4df914c5fc$export$2e2bcd8739ae039 = $d10dea4df914c5fc$var$locale;
module.exports["default"] = $d10dea4df914c5fc$export$2e2bcd8739ae039;

});

parcelRegister("kuDO4", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $7676191eec54eace$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var $7676191eec54eace$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $7676191eec54eace$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7676191eec54eace$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7676191eec54eace$export$2e2bcd8739ae039 = $7676191eec54eace$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $eeb57cc39901ab85$var$locale = {
    code: 'en-IN',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $7676191eec54eace$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $eeb57cc39901ab85$export$2e2bcd8739ae039 = $eeb57cc39901ab85$var$locale;
module.exports["default"] = $eeb57cc39901ab85$export$2e2bcd8739ae039;

});

parcelRegister("5FUh4", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $1a31022000d28a51$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $1a31022000d28a51$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1a31022000d28a51$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1a31022000d28a51$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1a31022000d28a51$export$2e2bcd8739ae039 = $1a31022000d28a51$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $421c6f009356ec84$var$locale = {
    code: 'en-NZ',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $1a31022000d28a51$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $421c6f009356ec84$export$2e2bcd8739ae039 = $421c6f009356ec84$var$locale;
module.exports["default"] = $421c6f009356ec84$export$2e2bcd8739ae039;

});

parcelRegister("aSFVd", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $a98717589c893aaa$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $a98717589c893aaa$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a98717589c893aaa$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a98717589c893aaa$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a98717589c893aaa$export$2e2bcd8739ae039 = $a98717589c893aaa$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $7ebf774f233a99c8$var$locale = {
    code: 'en-ZA',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $a98717589c893aaa$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $7ebf774f233a99c8$export$2e2bcd8739ae039 = $7ebf774f233a99c8$var$locale;
module.exports["default"] = $7ebf774f233a99c8$export$2e2bcd8739ae039;

});

parcelRegister("6unLC", function(module, exports) {
var $689caf0ad95d2d80$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var $689caf0ad95d2d80$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $689caf0ad95d2d80$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
var $689caf0ad95d2d80$export$2e2bcd8739ae039 = $689caf0ad95d2d80$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8b770553daaf0f38$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var $8b770553daaf0f38$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8b770553daaf0f38$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $8b770553daaf0f38$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $8b770553daaf0f38$export$2e2bcd8739ae039 = $8b770553daaf0f38$var$formatLong;


var $9520a3db859d8bd3$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var $9520a3db859d8bd3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9520a3db859d8bd3$var$formatRelativeLocale[token];
};
var $9520a3db859d8bd3$export$2e2bcd8739ae039 = $9520a3db859d8bd3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $412c0b8e75f882cc$var$eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var $412c0b8e75f882cc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var $412c0b8e75f882cc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var $412c0b8e75f882cc$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var $412c0b8e75f882cc$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var $412c0b8e75f882cc$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var $412c0b8e75f882cc$var$localize = {
    ordinalNumber: $412c0b8e75f882cc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $412c0b8e75f882cc$export$2e2bcd8739ae039 = $412c0b8e75f882cc$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $b012c69f7af0e1fc$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $b012c69f7af0e1fc$var$parseOrdinalNumberPattern = /\d+/i;
var $b012c69f7af0e1fc$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $b012c69f7af0e1fc$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $b012c69f7af0e1fc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $b012c69f7af0e1fc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b012c69f7af0e1fc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $b012c69f7af0e1fc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b012c69f7af0e1fc$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $b012c69f7af0e1fc$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $b012c69f7af0e1fc$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $b012c69f7af0e1fc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $b012c69f7af0e1fc$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b012c69f7af0e1fc$var$matchOrdinalNumberPattern,
        parsePattern: $b012c69f7af0e1fc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b012c69f7af0e1fc$export$2e2bcd8739ae039 = $b012c69f7af0e1fc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $4b97fb0cc397e588$var$locale = {
    code: 'eo',
    formatDistance: (0, $689caf0ad95d2d80$export$2e2bcd8739ae039),
    formatLong: (0, $8b770553daaf0f38$export$2e2bcd8739ae039),
    formatRelative: (0, $9520a3db859d8bd3$export$2e2bcd8739ae039),
    localize: (0, $412c0b8e75f882cc$export$2e2bcd8739ae039),
    match: (0, $b012c69f7af0e1fc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4b97fb0cc397e588$export$2e2bcd8739ae039 = $4b97fb0cc397e588$var$locale;
module.exports["default"] = $4b97fb0cc397e588$export$2e2bcd8739ae039;

});

parcelRegister("jlS2G", function(module, exports) {
var $4c24c657b2344469$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var $4c24c657b2344469$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4c24c657b2344469$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
var $4c24c657b2344469$export$2e2bcd8739ae039 = $4c24c657b2344469$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $67992f7041fa2751$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var $67992f7041fa2751$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $67992f7041fa2751$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $67992f7041fa2751$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $67992f7041fa2751$export$2e2bcd8739ae039 = $67992f7041fa2751$var$formatLong;


var $f90ff09786de11af$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $f90ff09786de11af$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $f90ff09786de11af$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $f90ff09786de11af$var$formatRelativeLocalePlural[token];
    return $f90ff09786de11af$var$formatRelativeLocale[token];
};
var $f90ff09786de11af$export$2e2bcd8739ae039 = $f90ff09786de11af$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b1d18d2a8570b9d0$var$eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var $b1d18d2a8570b9d0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var $b1d18d2a8570b9d0$var$monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var $b1d18d2a8570b9d0$var$dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var $b1d18d2a8570b9d0$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var $b1d18d2a8570b9d0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var $b1d18d2a8570b9d0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b1d18d2a8570b9d0$var$localize = {
    ordinalNumber: $b1d18d2a8570b9d0$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b1d18d2a8570b9d0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b1d18d2a8570b9d0$export$2e2bcd8739ae039 = $b1d18d2a8570b9d0$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $02b2d46cae29f6e4$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $02b2d46cae29f6e4$var$parseOrdinalNumberPattern = /\d+/i;
var $02b2d46cae29f6e4$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $02b2d46cae29f6e4$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $02b2d46cae29f6e4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $02b2d46cae29f6e4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $02b2d46cae29f6e4$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $02b2d46cae29f6e4$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $02b2d46cae29f6e4$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $02b2d46cae29f6e4$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $02b2d46cae29f6e4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $02b2d46cae29f6e4$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $02b2d46cae29f6e4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $02b2d46cae29f6e4$var$matchOrdinalNumberPattern,
        parsePattern: $02b2d46cae29f6e4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $02b2d46cae29f6e4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $02b2d46cae29f6e4$export$2e2bcd8739ae039 = $02b2d46cae29f6e4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $e169e621ccbf7c3f$var$locale = {
    code: 'eu',
    formatDistance: (0, $4c24c657b2344469$export$2e2bcd8739ae039),
    formatLong: (0, $67992f7041fa2751$export$2e2bcd8739ae039),
    formatRelative: (0, $f90ff09786de11af$export$2e2bcd8739ae039),
    localize: (0, $b1d18d2a8570b9d0$export$2e2bcd8739ae039),
    match: (0, $02b2d46cae29f6e4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e169e621ccbf7c3f$export$2e2bcd8739ae039 = $e169e621ccbf7c3f$var$locale;
module.exports["default"] = $e169e621ccbf7c3f$export$2e2bcd8739ae039;

});

parcelRegister("eXL8E", function(module, exports) {
var $e1f5f92e7462ec6a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var $e1f5f92e7462ec6a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e1f5f92e7462ec6a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
var $e1f5f92e7462ec6a$export$2e2bcd8739ae039 = $e1f5f92e7462ec6a$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $768d64295664928c$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var $768d64295664928c$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $768d64295664928c$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $768d64295664928c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $768d64295664928c$export$2e2bcd8739ae039 = $768d64295664928c$var$formatLong;


var $165a23a1bf205836$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var $165a23a1bf205836$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $165a23a1bf205836$var$formatRelativeLocale[token];
};
var $165a23a1bf205836$export$2e2bcd8739ae039 = $165a23a1bf205836$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $0c75d51c231950f6$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var $0c75d51c231950f6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0c75d51c231950f6$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var $0c75d51c231950f6$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var $0c75d51c231950f6$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $0c75d51c231950f6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $0c75d51c231950f6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $0c75d51c231950f6$var$localize = {
    ordinalNumber: $0c75d51c231950f6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0c75d51c231950f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0c75d51c231950f6$export$2e2bcd8739ae039 = $0c75d51c231950f6$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e106b2c915491db8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $e106b2c915491db8$var$parseOrdinalNumberPattern = /\d+/i;
var $e106b2c915491db8$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $e106b2c915491db8$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $e106b2c915491db8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $e106b2c915491db8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e106b2c915491db8$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $e106b2c915491db8$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $e106b2c915491db8$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $e106b2c915491db8$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $e106b2c915491db8$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $e106b2c915491db8$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $e106b2c915491db8$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e106b2c915491db8$var$matchOrdinalNumberPattern,
        parsePattern: $e106b2c915491db8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e106b2c915491db8$export$2e2bcd8739ae039 = $e106b2c915491db8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $ae4b242194ad94d3$var$locale = {
    code: 'fa-IR',
    formatDistance: (0, $e1f5f92e7462ec6a$export$2e2bcd8739ae039),
    formatLong: (0, $768d64295664928c$export$2e2bcd8739ae039),
    formatRelative: (0, $165a23a1bf205836$export$2e2bcd8739ae039),
    localize: (0, $0c75d51c231950f6$export$2e2bcd8739ae039),
    match: (0, $e106b2c915491db8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $ae4b242194ad94d3$export$2e2bcd8739ae039 = $ae4b242194ad94d3$var$locale;
module.exports["default"] = $ae4b242194ad94d3$export$2e2bcd8739ae039;

});

parcelRegister("lFkXa", function(module, exports) {
// Same as fr

var $9J4Kh = parcelRequire("9J4Kh");


var $drrJx = parcelRequire("drrJx");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");


var $fcGXP = parcelRequire("fcGXP");

var $c978d3e01c1a17a6$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var $c978d3e01c1a17a6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c978d3e01c1a17a6$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c978d3e01c1a17a6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c978d3e01c1a17a6$export$2e2bcd8739ae039 = $c978d3e01c1a17a6$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $fc5dae2d3dae4e08$var$locale = {
    code: 'fr-CA',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $c978d3e01c1a17a6$export$2e2bcd8739ae039),
    formatRelative: (0, $drrJx.default),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fc5dae2d3dae4e08$export$2e2bcd8739ae039 = $fc5dae2d3dae4e08$var$locale;
module.exports["default"] = $fc5dae2d3dae4e08$export$2e2bcd8739ae039;

});

parcelRegister("2p0ts", function(module, exports) {
// Same as fr

var $9J4Kh = parcelRequire("9J4Kh");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");


var $fcGXP = parcelRequire("fcGXP");

var $71891e3ae7b8239f$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $71891e3ae7b8239f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $71891e3ae7b8239f$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $71891e3ae7b8239f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $71891e3ae7b8239f$export$2e2bcd8739ae039 = $71891e3ae7b8239f$var$formatLong;


var $f5f7876a83348f0f$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var $f5f7876a83348f0f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f5f7876a83348f0f$var$formatRelativeLocale[token];
};
var $f5f7876a83348f0f$export$2e2bcd8739ae039 = $f5f7876a83348f0f$var$formatRelative;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $1bfe48bab1fbf1f1$var$locale = {
    code: 'fr-CH',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $71891e3ae7b8239f$export$2e2bcd8739ae039),
    formatRelative: (0, $f5f7876a83348f0f$export$2e2bcd8739ae039),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1bfe48bab1fbf1f1$export$2e2bcd8739ae039 = $1bfe48bab1fbf1f1$var$locale;
module.exports["default"] = $1bfe48bab1fbf1f1$export$2e2bcd8739ae039;

});

parcelRegister("aa0X5", function(module, exports) {
var $fc6edd505d9f3212$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var $fc6edd505d9f3212$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fc6edd505d9f3212$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
var $fc6edd505d9f3212$export$2e2bcd8739ae039 = $fc6edd505d9f3212$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $4e120632c870007e$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $4e120632c870007e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4e120632c870007e$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $4e120632c870007e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4e120632c870007e$export$2e2bcd8739ae039 = $4e120632c870007e$var$formatLong;


var $97b974594ddec5fd$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $97b974594ddec5fd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $97b974594ddec5fd$var$formatRelativeLocale[token];
};
var $97b974594ddec5fd$export$2e2bcd8739ae039 = $97b974594ddec5fd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $f973dfd4f1422b6c$var$eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var $f973dfd4f1422b6c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var $f973dfd4f1422b6c$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var $f973dfd4f1422b6c$var$dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var $f973dfd4f1422b6c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var $f973dfd4f1422b6c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $f973dfd4f1422b6c$var$localize = {
    ordinalNumber: $f973dfd4f1422b6c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $f973dfd4f1422b6c$export$2e2bcd8739ae039 = $f973dfd4f1422b6c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4ac62522d0b02eec$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $4ac62522d0b02eec$var$parseOrdinalNumberPattern = /\d+/i;
var $4ac62522d0b02eec$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $4ac62522d0b02eec$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $4ac62522d0b02eec$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $4ac62522d0b02eec$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4ac62522d0b02eec$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $4ac62522d0b02eec$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $4ac62522d0b02eec$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $4ac62522d0b02eec$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $4ac62522d0b02eec$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $4ac62522d0b02eec$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $4ac62522d0b02eec$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4ac62522d0b02eec$var$matchOrdinalNumberPattern,
        parsePattern: $4ac62522d0b02eec$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4ac62522d0b02eec$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4ac62522d0b02eec$export$2e2bcd8739ae039 = $4ac62522d0b02eec$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $765b939adfae76b5$var$locale = {
    code: 'fy',
    formatDistance: (0, $fc6edd505d9f3212$export$2e2bcd8739ae039),
    formatLong: (0, $4e120632c870007e$export$2e2bcd8739ae039),
    formatRelative: (0, $97b974594ddec5fd$export$2e2bcd8739ae039),
    localize: (0, $f973dfd4f1422b6c$export$2e2bcd8739ae039),
    match: (0, $4ac62522d0b02eec$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $765b939adfae76b5$export$2e2bcd8739ae039 = $765b939adfae76b5$var$locale;
module.exports["default"] = $765b939adfae76b5$export$2e2bcd8739ae039;

});

parcelRegister("inBOb", function(module, exports) {
var $afe280511868369c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $afe280511868369c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $afe280511868369c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
var $afe280511868369c$export$2e2bcd8739ae039 = $afe280511868369c$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e41716130eec6e6f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $e41716130eec6e6f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e41716130eec6e6f$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e41716130eec6e6f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e41716130eec6e6f$export$2e2bcd8739ae039 = $e41716130eec6e6f$var$formatLong;


var $9dfd3f39b2f8b8b1$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var $9dfd3f39b2f8b8b1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9dfd3f39b2f8b8b1$var$formatRelativeLocale[token];
};
var $9dfd3f39b2f8b8b1$export$2e2bcd8739ae039 = $9dfd3f39b2f8b8b1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $3f8e9ab09f860163$var$eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var $3f8e9ab09f860163$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $3f8e9ab09f860163$var$monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var $3f8e9ab09f860163$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var $3f8e9ab09f860163$var$dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var $3f8e9ab09f860163$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var $3f8e9ab09f860163$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var $3f8e9ab09f860163$var$localize = {
    ordinalNumber: $3f8e9ab09f860163$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3f8e9ab09f860163$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3f8e9ab09f860163$export$2e2bcd8739ae039 = $3f8e9ab09f860163$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $84bc5bc1bd588d93$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $84bc5bc1bd588d93$var$parseOrdinalNumberPattern = /\d+/i;
var $84bc5bc1bd588d93$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $84bc5bc1bd588d93$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $84bc5bc1bd588d93$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $84bc5bc1bd588d93$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $84bc5bc1bd588d93$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $84bc5bc1bd588d93$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $84bc5bc1bd588d93$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $84bc5bc1bd588d93$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $84bc5bc1bd588d93$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $84bc5bc1bd588d93$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $84bc5bc1bd588d93$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $84bc5bc1bd588d93$var$matchOrdinalNumberPattern,
        parsePattern: $84bc5bc1bd588d93$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $84bc5bc1bd588d93$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $84bc5bc1bd588d93$export$2e2bcd8739ae039 = $84bc5bc1bd588d93$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $d617b3f522183e80$var$locale = {
    code: 'gd',
    formatDistance: (0, $afe280511868369c$export$2e2bcd8739ae039),
    formatLong: (0, $e41716130eec6e6f$export$2e2bcd8739ae039),
    formatRelative: (0, $9dfd3f39b2f8b8b1$export$2e2bcd8739ae039),
    localize: (0, $3f8e9ab09f860163$export$2e2bcd8739ae039),
    match: (0, $84bc5bc1bd588d93$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d617b3f522183e80$export$2e2bcd8739ae039 = $d617b3f522183e80$var$locale;
module.exports["default"] = $d617b3f522183e80$export$2e2bcd8739ae039;

});

parcelRegister("2gRR9", function(module, exports) {
var $99e0298d8ade624e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var $99e0298d8ade624e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $99e0298d8ade624e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
var $99e0298d8ade624e$export$2e2bcd8739ae039 = $99e0298d8ade624e$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $b34cdad1898f8bc6$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $b34cdad1898f8bc6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b34cdad1898f8bc6$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b34cdad1898f8bc6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b34cdad1898f8bc6$export$2e2bcd8739ae039 = $b34cdad1898f8bc6$var$formatLong;


var $50f5c110f853c3b5$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var $50f5c110f853c3b5$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var $50f5c110f853c3b5$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $50f5c110f853c3b5$var$formatRelativeLocalePlural[token];
    return $50f5c110f853c3b5$var$formatRelativeLocale[token];
};
var $50f5c110f853c3b5$export$2e2bcd8739ae039 = $50f5c110f853c3b5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $cacf44f79fbb79da$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var $cacf44f79fbb79da$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $cacf44f79fbb79da$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var $cacf44f79fbb79da$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var $cacf44f79fbb79da$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var $cacf44f79fbb79da$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var $cacf44f79fbb79da$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $cacf44f79fbb79da$var$localize = {
    ordinalNumber: $cacf44f79fbb79da$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cacf44f79fbb79da$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cacf44f79fbb79da$export$2e2bcd8739ae039 = $cacf44f79fbb79da$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7371370cf9aa28df$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $7371370cf9aa28df$var$parseOrdinalNumberPattern = /\d+/i;
var $7371370cf9aa28df$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $7371370cf9aa28df$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $7371370cf9aa28df$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $7371370cf9aa28df$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7371370cf9aa28df$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $7371370cf9aa28df$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $7371370cf9aa28df$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $7371370cf9aa28df$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $7371370cf9aa28df$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $7371370cf9aa28df$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $7371370cf9aa28df$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7371370cf9aa28df$var$matchOrdinalNumberPattern,
        parsePattern: $7371370cf9aa28df$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7371370cf9aa28df$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7371370cf9aa28df$export$2e2bcd8739ae039 = $7371370cf9aa28df$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $1a76da21f46bddf9$var$locale = {
    code: 'gl',
    formatDistance: (0, $99e0298d8ade624e$export$2e2bcd8739ae039),
    formatLong: (0, $b34cdad1898f8bc6$export$2e2bcd8739ae039),
    formatRelative: (0, $50f5c110f853c3b5$export$2e2bcd8739ae039),
    localize: (0, $cacf44f79fbb79da$export$2e2bcd8739ae039),
    match: (0, $7371370cf9aa28df$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1a76da21f46bddf9$export$2e2bcd8739ae039 = $1a76da21f46bddf9$var$locale;
module.exports["default"] = $1a76da21f46bddf9$export$2e2bcd8739ae039;

});

parcelRegister("lgykd", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $c10c1a6ef4545ea0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var $c10c1a6ef4545ea0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c10c1a6ef4545ea0$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
var $c10c1a6ef4545ea0$export$2e2bcd8739ae039 = $c10c1a6ef4545ea0$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $b8e77e64f6655059$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var $b8e77e64f6655059$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var $b8e77e64f6655059$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var $b8e77e64f6655059$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b8e77e64f6655059$export$2e2bcd8739ae039 = $b8e77e64f6655059$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $33f266e4f0161513$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var $33f266e4f0161513$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $33f266e4f0161513$var$formatRelativeLocale[token];
};
var $33f266e4f0161513$export$2e2bcd8739ae039 = $33f266e4f0161513$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// #1621 - #1630
var $7db9f48c1aa86abc$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $7db9f48c1aa86abc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $7db9f48c1aa86abc$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $7db9f48c1aa86abc$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $7db9f48c1aa86abc$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7db9f48c1aa86abc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7db9f48c1aa86abc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $7db9f48c1aa86abc$var$localize = {
    ordinalNumber: $7db9f48c1aa86abc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7db9f48c1aa86abc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7db9f48c1aa86abc$export$2e2bcd8739ae039 = $7db9f48c1aa86abc$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9416017814d06a96$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $9416017814d06a96$var$parseOrdinalNumberPattern = /\d+/i;
var $9416017814d06a96$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $9416017814d06a96$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $9416017814d06a96$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $9416017814d06a96$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9416017814d06a96$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $9416017814d06a96$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $9416017814d06a96$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $9416017814d06a96$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $9416017814d06a96$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $9416017814d06a96$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $9416017814d06a96$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9416017814d06a96$var$matchOrdinalNumberPattern,
        parsePattern: $9416017814d06a96$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9416017814d06a96$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9416017814d06a96$export$2e2bcd8739ae039 = $9416017814d06a96$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $f7b5b7da971def3e$var$locale = {
    code: 'gu',
    formatDistance: (0, $c10c1a6ef4545ea0$export$2e2bcd8739ae039),
    formatLong: (0, $b8e77e64f6655059$export$2e2bcd8739ae039),
    formatRelative: (0, $33f266e4f0161513$export$2e2bcd8739ae039),
    localize: (0, $7db9f48c1aa86abc$export$2e2bcd8739ae039),
    match: (0, $9416017814d06a96$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f7b5b7da971def3e$export$2e2bcd8739ae039 = $f7b5b7da971def3e$var$locale;
module.exports["default"] = $f7b5b7da971def3e$export$2e2bcd8739ae039;

});

parcelRegister("114nq", function(module, exports) {
var $d40a550254a6a129$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var $d40a550254a6a129$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = $d40a550254a6a129$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
var $d40a550254a6a129$export$2e2bcd8739ae039 = $d40a550254a6a129$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e513144e2c159c76$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var $e513144e2c159c76$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e513144e2c159c76$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e513144e2c159c76$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e513144e2c159c76$export$2e2bcd8739ae039 = $e513144e2c159c76$var$formatLong;


var $2a4fb7c5b982707d$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var $2a4fb7c5b982707d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2a4fb7c5b982707d$var$formatRelativeLocale[token];
};
var $2a4fb7c5b982707d$export$2e2bcd8739ae039 = $2a4fb7c5b982707d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $158ba1ef3de7c8a6$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var $158ba1ef3de7c8a6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var $158ba1ef3de7c8a6$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var $158ba1ef3de7c8a6$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var $158ba1ef3de7c8a6$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var $158ba1ef3de7c8a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var $158ba1ef3de7c8a6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $158ba1ef3de7c8a6$var$localize = {
    ordinalNumber: $158ba1ef3de7c8a6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $158ba1ef3de7c8a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $158ba1ef3de7c8a6$export$2e2bcd8739ae039 = $158ba1ef3de7c8a6$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6339a5836aa9aa57$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $6339a5836aa9aa57$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $6339a5836aa9aa57$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $6339a5836aa9aa57$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $6339a5836aa9aa57$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $6339a5836aa9aa57$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6339a5836aa9aa57$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $6339a5836aa9aa57$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $6339a5836aa9aa57$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $6339a5836aa9aa57$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $6339a5836aa9aa57$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $6339a5836aa9aa57$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $6339a5836aa9aa57$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var $6339a5836aa9aa57$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6339a5836aa9aa57$var$matchOrdinalNumberPattern,
        parsePattern: $6339a5836aa9aa57$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $6339a5836aa9aa57$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6339a5836aa9aa57$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6339a5836aa9aa57$export$2e2bcd8739ae039 = $6339a5836aa9aa57$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $0bd94791b3452e6f$var$locale = {
    code: 'he',
    formatDistance: (0, $d40a550254a6a129$export$2e2bcd8739ae039),
    formatLong: (0, $e513144e2c159c76$export$2e2bcd8739ae039),
    formatRelative: (0, $2a4fb7c5b982707d$export$2e2bcd8739ae039),
    localize: (0, $158ba1ef3de7c8a6$export$2e2bcd8739ae039),
    match: (0, $6339a5836aa9aa57$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0bd94791b3452e6f$export$2e2bcd8739ae039 = $0bd94791b3452e6f$var$locale;
module.exports["default"] = $0bd94791b3452e6f$export$2e2bcd8739ae039;

});

parcelRegister("68vmh", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $b7376d96070ba6ad$var$numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var $b7376d96070ba6ad$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var $b7376d96070ba6ad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $b7376d96070ba6ad$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var $b7376d96070ba6ad$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var $b7376d96070ba6ad$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $b7376d96070ba6ad$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $b7376d96070ba6ad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $b7376d96070ba6ad$export$3e1d599946644f03(number);
};
function $b7376d96070ba6ad$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $b7376d96070ba6ad$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $b7376d96070ba6ad$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $b7376d96070ba6ad$var$numberValues.locale[match];
    });
}
var $b7376d96070ba6ad$var$localize = {
    ordinalNumber: $b7376d96070ba6ad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b7376d96070ba6ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b7376d96070ba6ad$export$2e2bcd8739ae039 = $b7376d96070ba6ad$var$localize;


var $697269c9bc61dfba$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var $697269c9bc61dfba$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $697269c9bc61dfba$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $b7376d96070ba6ad$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
var $697269c9bc61dfba$export$2e2bcd8739ae039 = $697269c9bc61dfba$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e4bedee83ffb3d64$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var $e4bedee83ffb3d64$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var $e4bedee83ffb3d64$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var $e4bedee83ffb3d64$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e4bedee83ffb3d64$export$2e2bcd8739ae039 = $e4bedee83ffb3d64$var$formatLong;


var $dda737b874e7276a$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var $dda737b874e7276a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $dda737b874e7276a$var$formatRelativeLocale[token];
};
var $dda737b874e7276a$export$2e2bcd8739ae039 = $dda737b874e7276a$var$formatRelative;




var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");


var $5c2fb7221e285922$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $5c2fb7221e285922$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $5c2fb7221e285922$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $5c2fb7221e285922$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $5c2fb7221e285922$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $5c2fb7221e285922$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5c2fb7221e285922$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $5c2fb7221e285922$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $5c2fb7221e285922$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $5c2fb7221e285922$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $5c2fb7221e285922$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $5c2fb7221e285922$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $5c2fb7221e285922$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5c2fb7221e285922$var$matchOrdinalNumberPattern,
        parsePattern: $5c2fb7221e285922$var$parseOrdinalNumberPattern,
        valueCallback: (0, $b7376d96070ba6ad$export$b431cabd737c2a)
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5c2fb7221e285922$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5c2fb7221e285922$export$2e2bcd8739ae039 = $5c2fb7221e285922$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $477bd08f7b4eccd7$var$locale = {
    code: 'hi',
    formatDistance: (0, $697269c9bc61dfba$export$2e2bcd8739ae039),
    formatLong: (0, $e4bedee83ffb3d64$export$2e2bcd8739ae039),
    formatRelative: (0, $dda737b874e7276a$export$2e2bcd8739ae039),
    localize: (0, $b7376d96070ba6ad$export$2e2bcd8739ae039),
    match: (0, $5c2fb7221e285922$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $477bd08f7b4eccd7$export$2e2bcd8739ae039 = $477bd08f7b4eccd7$var$locale;
module.exports["default"] = $477bd08f7b4eccd7$export$2e2bcd8739ae039;

});

parcelRegister("c4pIC", function(module, exports) {
var $887b3aabd69f0b31$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $887b3aabd69f0b31$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $887b3aabd69f0b31$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $887b3aabd69f0b31$export$2e2bcd8739ae039 = $887b3aabd69f0b31$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $c652e4da380961d9$var$dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var $c652e4da380961d9$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c652e4da380961d9$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c652e4da380961d9$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c652e4da380961d9$export$2e2bcd8739ae039 = $c652e4da380961d9$var$formatLong;


var $b87cf77a432b4dc3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $b87cf77a432b4dc3$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b87cf77a432b4dc3$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $b87cf77a432b4dc3$export$2e2bcd8739ae039 = $b87cf77a432b4dc3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $69be126a3e0143d8$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var $69be126a3e0143d8$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $69be126a3e0143d8$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var $69be126a3e0143d8$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var $69be126a3e0143d8$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $69be126a3e0143d8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $69be126a3e0143d8$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $69be126a3e0143d8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $69be126a3e0143d8$var$localize = {
    ordinalNumber: $69be126a3e0143d8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $69be126a3e0143d8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $69be126a3e0143d8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $69be126a3e0143d8$export$2e2bcd8739ae039 = $69be126a3e0143d8$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5f08344913d92eb2$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $5f08344913d92eb2$var$parseOrdinalNumberPattern = /\d+/i;
var $5f08344913d92eb2$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $5f08344913d92eb2$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $5f08344913d92eb2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $5f08344913d92eb2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5f08344913d92eb2$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $5f08344913d92eb2$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $5f08344913d92eb2$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $5f08344913d92eb2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $5f08344913d92eb2$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $5f08344913d92eb2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $5f08344913d92eb2$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5f08344913d92eb2$var$matchOrdinalNumberPattern,
        parsePattern: $5f08344913d92eb2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5f08344913d92eb2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5f08344913d92eb2$export$2e2bcd8739ae039 = $5f08344913d92eb2$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $8c99cef5c80e00e5$var$locale = {
    code: 'hr',
    formatDistance: (0, $887b3aabd69f0b31$export$2e2bcd8739ae039),
    formatLong: (0, $c652e4da380961d9$export$2e2bcd8739ae039),
    formatRelative: (0, $b87cf77a432b4dc3$export$2e2bcd8739ae039),
    localize: (0, $69be126a3e0143d8$export$2e2bcd8739ae039),
    match: (0, $5f08344913d92eb2$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8c99cef5c80e00e5$export$2e2bcd8739ae039 = $8c99cef5c80e00e5$var$locale;
module.exports["default"] = $8c99cef5c80e00e5$export$2e2bcd8739ae039;

});

parcelRegister("h3dgf", function(module, exports) {
var $12e9469258421737$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $12e9469258421737$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $12e9469258421737$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $12e9469258421737$export$2e2bcd8739ae039 = $12e9469258421737$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $939a3f00db0f30fb$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $939a3f00db0f30fb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $939a3f00db0f30fb$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $939a3f00db0f30fb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $939a3f00db0f30fb$export$2e2bcd8739ae039 = $939a3f00db0f30fb$var$formatLong;


var $80fc6ed686f906ea$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var $80fc6ed686f906ea$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $80fc6ed686f906ea$var$formatRelativeLocale[token];
};
var $80fc6ed686f906ea$export$2e2bcd8739ae039 = $80fc6ed686f906ea$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $64af0b6c6617128c$var$eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var $64af0b6c6617128c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $64af0b6c6617128c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var $64af0b6c6617128c$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var $64af0b6c6617128c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var $64af0b6c6617128c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var $64af0b6c6617128c$var$localize = {
    ordinalNumber: $64af0b6c6617128c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $64af0b6c6617128c$export$2e2bcd8739ae039 = $64af0b6c6617128c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $f61a10fe7eeb78ff$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $f61a10fe7eeb78ff$var$parseOrdinalNumberPattern = /\d+/i;
var $f61a10fe7eeb78ff$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $f61a10fe7eeb78ff$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $f61a10fe7eeb78ff$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $f61a10fe7eeb78ff$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f61a10fe7eeb78ff$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $f61a10fe7eeb78ff$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $f61a10fe7eeb78ff$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $f61a10fe7eeb78ff$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $f61a10fe7eeb78ff$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $f61a10fe7eeb78ff$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $f61a10fe7eeb78ff$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $f61a10fe7eeb78ff$var$matchOrdinalNumberPattern,
        parsePattern: $f61a10fe7eeb78ff$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f61a10fe7eeb78ff$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f61a10fe7eeb78ff$export$2e2bcd8739ae039 = $f61a10fe7eeb78ff$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $c69d00d5d9b85a64$var$locale = {
    code: 'ht',
    formatDistance: (0, $12e9469258421737$export$2e2bcd8739ae039),
    formatLong: (0, $939a3f00db0f30fb$export$2e2bcd8739ae039),
    formatRelative: (0, $80fc6ed686f906ea$export$2e2bcd8739ae039),
    localize: (0, $64af0b6c6617128c$export$2e2bcd8739ae039),
    match: (0, $f61a10fe7eeb78ff$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c69d00d5d9b85a64$export$2e2bcd8739ae039 = $c69d00d5d9b85a64$var$locale;
module.exports["default"] = $c69d00d5d9b85a64$export$2e2bcd8739ae039;

});

parcelRegister("kOmGW", function(module, exports) {
var $cc3bea7a3c847918$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var $cc3bea7a3c847918$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cc3bea7a3c847918$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
var $cc3bea7a3c847918$export$2e2bcd8739ae039 = $cc3bea7a3c847918$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $fa6c5afafcd1241d$var$dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var $fa6c5afafcd1241d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $fa6c5afafcd1241d$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fa6c5afafcd1241d$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fa6c5afafcd1241d$export$2e2bcd8739ae039 = $fa6c5afafcd1241d$var$formatLong;


var $ca4dd8f7f1cc068b$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var $ca4dd8f7f1cc068b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ca4dd8f7f1cc068b$var$formatRelativeLocale[token];
};
var $ca4dd8f7f1cc068b$export$2e2bcd8739ae039 = $ca4dd8f7f1cc068b$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e5a70dbdbec17b0b$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var $e5a70dbdbec17b0b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var $e5a70dbdbec17b0b$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var $e5a70dbdbec17b0b$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var $e5a70dbdbec17b0b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var $e5a70dbdbec17b0b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var $e5a70dbdbec17b0b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var $e5a70dbdbec17b0b$var$localize = {
    ordinalNumber: $e5a70dbdbec17b0b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e5a70dbdbec17b0b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e5a70dbdbec17b0b$export$2e2bcd8739ae039 = $e5a70dbdbec17b0b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4940c97c17bee60b$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $4940c97c17bee60b$var$parseOrdinalNumberPattern = /\d+/i;
var $4940c97c17bee60b$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $4940c97c17bee60b$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $4940c97c17bee60b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $4940c97c17bee60b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4940c97c17bee60b$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $4940c97c17bee60b$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $4940c97c17bee60b$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $4940c97c17bee60b$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $4940c97c17bee60b$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $4940c97c17bee60b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $4940c97c17bee60b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4940c97c17bee60b$var$matchOrdinalNumberPattern,
        parsePattern: $4940c97c17bee60b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4940c97c17bee60b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4940c97c17bee60b$export$2e2bcd8739ae039 = $4940c97c17bee60b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $f26a144182f8ffd8$var$locale = {
    code: 'hy',
    formatDistance: (0, $cc3bea7a3c847918$export$2e2bcd8739ae039),
    formatLong: (0, $fa6c5afafcd1241d$export$2e2bcd8739ae039),
    formatRelative: (0, $ca4dd8f7f1cc068b$export$2e2bcd8739ae039),
    localize: (0, $e5a70dbdbec17b0b$export$2e2bcd8739ae039),
    match: (0, $4940c97c17bee60b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f26a144182f8ffd8$export$2e2bcd8739ae039 = $f26a144182f8ffd8$var$locale;
module.exports["default"] = $f26a144182f8ffd8$export$2e2bcd8739ae039;

});

parcelRegister("1ZhxU", function(module, exports) {
var $a4b642ca6812ce67$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $a4b642ca6812ce67$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a4b642ca6812ce67$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $a4b642ca6812ce67$export$2e2bcd8739ae039 = $a4b642ca6812ce67$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6eb382ad05339f9e$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $6eb382ad05339f9e$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $6eb382ad05339f9e$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6eb382ad05339f9e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6eb382ad05339f9e$export$2e2bcd8739ae039 = $6eb382ad05339f9e$var$formatLong;


var $7d830fb5166679d6$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var $7d830fb5166679d6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7d830fb5166679d6$var$formatRelativeLocale[token];
};
var $7d830fb5166679d6$export$2e2bcd8739ae039 = $7d830fb5166679d6$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// https://www.unicode.org/cldr/charts/32/summary/id.html
var $1c6f317ec89ef798$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var $1c6f317ec89ef798$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1c6f317ec89ef798$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $1c6f317ec89ef798$var$dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var $1c6f317ec89ef798$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $1c6f317ec89ef798$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $1c6f317ec89ef798$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var $1c6f317ec89ef798$var$localize = {
    ordinalNumber: $1c6f317ec89ef798$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1c6f317ec89ef798$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1c6f317ec89ef798$export$2e2bcd8739ae039 = $1c6f317ec89ef798$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4dbd016405b9659d$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $4dbd016405b9659d$var$parseOrdinalNumberPattern = /\d+/i;
var $4dbd016405b9659d$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $4dbd016405b9659d$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $4dbd016405b9659d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $4dbd016405b9659d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4dbd016405b9659d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $4dbd016405b9659d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4dbd016405b9659d$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $4dbd016405b9659d$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $4dbd016405b9659d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $4dbd016405b9659d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $4dbd016405b9659d$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4dbd016405b9659d$var$matchOrdinalNumberPattern,
        parsePattern: $4dbd016405b9659d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4dbd016405b9659d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4dbd016405b9659d$export$2e2bcd8739ae039 = $4dbd016405b9659d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $1729193190f543bd$var$locale = {
    code: 'id',
    formatDistance: (0, $a4b642ca6812ce67$export$2e2bcd8739ae039),
    formatLong: (0, $6eb382ad05339f9e$export$2e2bcd8739ae039),
    formatRelative: (0, $7d830fb5166679d6$export$2e2bcd8739ae039),
    localize: (0, $1c6f317ec89ef798$export$2e2bcd8739ae039),
    match: (0, $4dbd016405b9659d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1729193190f543bd$export$2e2bcd8739ae039 = $1729193190f543bd$var$locale;
module.exports["default"] = $1729193190f543bd$export$2e2bcd8739ae039;

});

parcelRegister("56vLn", function(module, exports) {

var $ellkl = parcelRequire("ellkl");


var $geJmU = parcelRequire("geJmU");


var $c2vlP = parcelRequire("c2vlP");


var $bk6Tz = parcelRequire("bk6Tz");


var $fcGXP = parcelRequire("fcGXP");

var $3dc391f99be53c03$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $3dc391f99be53c03$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3dc391f99be53c03$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $3dc391f99be53c03$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3dc391f99be53c03$export$2e2bcd8739ae039 = $3dc391f99be53c03$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $3b7626d012109d91$var$locale = {
    code: 'it-CH',
    formatDistance: (0, $ellkl.default),
    formatLong: (0, $3dc391f99be53c03$export$2e2bcd8739ae039),
    formatRelative: (0, $geJmU.default),
    localize: (0, $c2vlP.default),
    match: (0, $bk6Tz.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3b7626d012109d91$export$2e2bcd8739ae039 = $3b7626d012109d91$var$locale;
module.exports["default"] = $3b7626d012109d91$export$2e2bcd8739ae039;

});

parcelRegister("O69wG", function(module, exports) {
var $66027255bb71c244$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var $66027255bb71c244$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $66027255bb71c244$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
var $66027255bb71c244$export$2e2bcd8739ae039 = $66027255bb71c244$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f645f61a599929e8$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $f645f61a599929e8$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $f645f61a599929e8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f645f61a599929e8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f645f61a599929e8$export$2e2bcd8739ae039 = $f645f61a599929e8$var$formatLong;


var $895f09ac55cffb9d$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var $895f09ac55cffb9d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $895f09ac55cffb9d$var$formatRelativeLocale[token];
};
var $895f09ac55cffb9d$export$2e2bcd8739ae039 = $895f09ac55cffb9d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $09200d1d1fa4ae89$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var $09200d1d1fa4ae89$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var $09200d1d1fa4ae89$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var $09200d1d1fa4ae89$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var $09200d1d1fa4ae89$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $09200d1d1fa4ae89$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $09200d1d1fa4ae89$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var $09200d1d1fa4ae89$var$localize = {
    ordinalNumber: $09200d1d1fa4ae89$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $09200d1d1fa4ae89$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $09200d1d1fa4ae89$export$2e2bcd8739ae039 = $09200d1d1fa4ae89$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b7fe29f5ef2935aa$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $b7fe29f5ef2935aa$var$parseOrdinalNumberPattern = /\d+/i;
var $b7fe29f5ef2935aa$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $b7fe29f5ef2935aa$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $b7fe29f5ef2935aa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $b7fe29f5ef2935aa$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $b7fe29f5ef2935aa$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $b7fe29f5ef2935aa$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $b7fe29f5ef2935aa$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $b7fe29f5ef2935aa$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $b7fe29f5ef2935aa$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $b7fe29f5ef2935aa$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $b7fe29f5ef2935aa$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b7fe29f5ef2935aa$var$matchOrdinalNumberPattern,
        parsePattern: $b7fe29f5ef2935aa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b7fe29f5ef2935aa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b7fe29f5ef2935aa$export$2e2bcd8739ae039 = $b7fe29f5ef2935aa$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $09697169fa584236$var$locale = {
    code: 'ja-Hira',
    formatDistance: (0, $66027255bb71c244$export$2e2bcd8739ae039),
    formatLong: (0, $f645f61a599929e8$export$2e2bcd8739ae039),
    formatRelative: (0, $895f09ac55cffb9d$export$2e2bcd8739ae039),
    localize: (0, $09200d1d1fa4ae89$export$2e2bcd8739ae039),
    match: (0, $b7fe29f5ef2935aa$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $09697169fa584236$export$2e2bcd8739ae039 = $09697169fa584236$var$locale;
module.exports["default"] = $09697169fa584236$export$2e2bcd8739ae039;

});

parcelRegister("bDc9o", function(module, exports) {
var $005d7df00ab5c749$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var $005d7df00ab5c749$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $005d7df00ab5c749$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
var $005d7df00ab5c749$export$2e2bcd8739ae039 = $005d7df00ab5c749$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6d0da585d6977313$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var $6d0da585d6977313$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $6d0da585d6977313$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6d0da585d6977313$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6d0da585d6977313$export$2e2bcd8739ae039 = $6d0da585d6977313$var$formatLong;


var $49d1bae32c5d85c1$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var $49d1bae32c5d85c1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $49d1bae32c5d85c1$var$formatRelativeLocale[token];
};
var $49d1bae32c5d85c1$export$2e2bcd8739ae039 = $49d1bae32c5d85c1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $c734bfc73db01838$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var $c734bfc73db01838$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c734bfc73db01838$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var $c734bfc73db01838$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var $c734bfc73db01838$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var $c734bfc73db01838$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var $c734bfc73db01838$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var $c734bfc73db01838$var$localize = {
    ordinalNumber: $c734bfc73db01838$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c734bfc73db01838$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c734bfc73db01838$export$2e2bcd8739ae039 = $c734bfc73db01838$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3d791e7a49c7aa8b$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $3d791e7a49c7aa8b$var$parseOrdinalNumberPattern = /\d+/i;
var $3d791e7a49c7aa8b$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $3d791e7a49c7aa8b$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $3d791e7a49c7aa8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $3d791e7a49c7aa8b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3d791e7a49c7aa8b$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $3d791e7a49c7aa8b$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $3d791e7a49c7aa8b$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $3d791e7a49c7aa8b$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $3d791e7a49c7aa8b$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $3d791e7a49c7aa8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $3d791e7a49c7aa8b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3d791e7a49c7aa8b$var$matchOrdinalNumberPattern,
        parsePattern: $3d791e7a49c7aa8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3d791e7a49c7aa8b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3d791e7a49c7aa8b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3d791e7a49c7aa8b$export$2e2bcd8739ae039 = $3d791e7a49c7aa8b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $877cc31222df215b$var$locale = {
    code: 'ka',
    formatDistance: (0, $005d7df00ab5c749$export$2e2bcd8739ae039),
    formatLong: (0, $6d0da585d6977313$export$2e2bcd8739ae039),
    formatRelative: (0, $49d1bae32c5d85c1$export$2e2bcd8739ae039),
    localize: (0, $c734bfc73db01838$export$2e2bcd8739ae039),
    match: (0, $3d791e7a49c7aa8b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $877cc31222df215b$export$2e2bcd8739ae039 = $877cc31222df215b$var$locale;
module.exports["default"] = $877cc31222df215b$export$2e2bcd8739ae039;

});

parcelRegister("5U0go", function(module, exports) {
var $52b4f252d39cc465$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $52b4f252d39cc465$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var $52b4f252d39cc465$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $52b4f252d39cc465$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $52b4f252d39cc465$var$declension(tokenValue.future, count);
            else return $52b4f252d39cc465$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $52b4f252d39cc465$var$declension(tokenValue.past, count);
            else return $52b4f252d39cc465$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $52b4f252d39cc465$var$declension(tokenValue.regular, count);
};
var $52b4f252d39cc465$export$2e2bcd8739ae039 = $52b4f252d39cc465$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $579428ac7180bb68$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var $579428ac7180bb68$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $579428ac7180bb68$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $579428ac7180bb68$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $579428ac7180bb68$export$2e2bcd8739ae039 = $579428ac7180bb68$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $71f1fe58755fe129$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $71f1fe58755fe129$var$_lastWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $71f1fe58755fe129$var$thisWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $71f1fe58755fe129$var$_nextWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var $71f1fe58755fe129$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $71f1fe58755fe129$var$thisWeek(day);
        else return $71f1fe58755fe129$var$_lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $71f1fe58755fe129$var$thisWeek(day);
        else return $71f1fe58755fe129$var$_nextWeek(day);
    },
    other: 'P'
};
var $71f1fe58755fe129$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $71f1fe58755fe129$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $71f1fe58755fe129$export$2e2bcd8739ae039 = $71f1fe58755fe129$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $ce94cd106747f6bd$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var $ce94cd106747f6bd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var $ce94cd106747f6bd$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var $ce94cd106747f6bd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var $ce94cd106747f6bd$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var $ce94cd106747f6bd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $ce94cd106747f6bd$var$suffixes[number] || $ce94cd106747f6bd$var$suffixes[mod10] || b && $ce94cd106747f6bd$var$suffixes[b] || '';
    return number + suffix;
};
var $ce94cd106747f6bd$var$localize = {
    ordinalNumber: $ce94cd106747f6bd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $ce94cd106747f6bd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $ce94cd106747f6bd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ce94cd106747f6bd$export$2e2bcd8739ae039 = $ce94cd106747f6bd$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $1a36bf9f30a0e53c$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $1a36bf9f30a0e53c$var$parseOrdinalNumberPattern = /\d+/i;
var $1a36bf9f30a0e53c$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $1a36bf9f30a0e53c$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $1a36bf9f30a0e53c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $1a36bf9f30a0e53c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1a36bf9f30a0e53c$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $1a36bf9f30a0e53c$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $1a36bf9f30a0e53c$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $1a36bf9f30a0e53c$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $1a36bf9f30a0e53c$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $1a36bf9f30a0e53c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $1a36bf9f30a0e53c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $1a36bf9f30a0e53c$var$matchOrdinalNumberPattern,
        parsePattern: $1a36bf9f30a0e53c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1a36bf9f30a0e53c$export$2e2bcd8739ae039 = $1a36bf9f30a0e53c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $44c2630ac689a09d$var$locale = {
    code: 'kk',
    formatDistance: (0, $52b4f252d39cc465$export$2e2bcd8739ae039),
    formatLong: (0, $579428ac7180bb68$export$2e2bcd8739ae039),
    formatRelative: (0, $71f1fe58755fe129$export$2e2bcd8739ae039),
    localize: (0, $ce94cd106747f6bd$export$2e2bcd8739ae039),
    match: (0, $1a36bf9f30a0e53c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $44c2630ac689a09d$export$2e2bcd8739ae039 = $44c2630ac689a09d$var$locale;
module.exports["default"] = $44c2630ac689a09d$export$2e2bcd8739ae039;

});

parcelRegister("kNEVA", function(module, exports) {
var $45de21bb0ca0a89b$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var $45de21bb0ca0a89b$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $45de21bb0ca0a89b$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
var $45de21bb0ca0a89b$export$2e2bcd8739ae039 = $45de21bb0ca0a89b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $1a43eee8e3514c2f$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $1a43eee8e3514c2f$var$timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1a43eee8e3514c2f$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1a43eee8e3514c2f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1a43eee8e3514c2f$export$2e2bcd8739ae039 = $1a43eee8e3514c2f$var$formatLong;


var $4913e2b2e49b4a27$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var $4913e2b2e49b4a27$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4913e2b2e49b4a27$var$formatRelativeLocale[token];
};
var $4913e2b2e49b4a27$export$2e2bcd8739ae039 = $4913e2b2e49b4a27$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $fa8bcb65fbc37bbf$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var $fa8bcb65fbc37bbf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var $fa8bcb65fbc37bbf$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var $fa8bcb65fbc37bbf$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var $fa8bcb65fbc37bbf$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $fa8bcb65fbc37bbf$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $fa8bcb65fbc37bbf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $fa8bcb65fbc37bbf$var$localize = {
    ordinalNumber: $fa8bcb65fbc37bbf$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $fa8bcb65fbc37bbf$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $fa8bcb65fbc37bbf$export$2e2bcd8739ae039 = $fa8bcb65fbc37bbf$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $963c43d54611b540$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $963c43d54611b540$var$parseOrdinalNumberPattern = /\d+/i;
var $963c43d54611b540$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $963c43d54611b540$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $963c43d54611b540$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $963c43d54611b540$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $963c43d54611b540$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $963c43d54611b540$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $963c43d54611b540$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $963c43d54611b540$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $963c43d54611b540$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $963c43d54611b540$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $963c43d54611b540$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $963c43d54611b540$var$matchOrdinalNumberPattern,
        parsePattern: $963c43d54611b540$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $963c43d54611b540$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $963c43d54611b540$export$2e2bcd8739ae039 = $963c43d54611b540$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $f24821a5b064f160$var$locale = {
    code: 'km',
    formatDistance: (0, $45de21bb0ca0a89b$export$2e2bcd8739ae039),
    formatLong: (0, $1a43eee8e3514c2f$export$2e2bcd8739ae039),
    formatRelative: (0, $4913e2b2e49b4a27$export$2e2bcd8739ae039),
    localize: (0, $fa8bcb65fbc37bbf$export$2e2bcd8739ae039),
    match: (0, $963c43d54611b540$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f24821a5b064f160$export$2e2bcd8739ae039 = $f24821a5b064f160$var$locale;
module.exports["default"] = $f24821a5b064f160$export$2e2bcd8739ae039;

});

parcelRegister("dv5xe", function(module, exports) {
// note: no implementation for weeks
var $97d24967eacd1186$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $97d24967eacd1186$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $97d24967eacd1186$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $97d24967eacd1186$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $97d24967eacd1186$var$getResultByTense(tokenValue.one, options);
    else result = $97d24967eacd1186$var$getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
var $97d24967eacd1186$export$2e2bcd8739ae039 = $97d24967eacd1186$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6b7efba750647d27$var$dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var $6b7efba750647d27$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var $6b7efba750647d27$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var $6b7efba750647d27$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6b7efba750647d27$export$2e2bcd8739ae039 = $6b7efba750647d27$var$formatLong;


var $edb2f44bce7e28f5$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var $edb2f44bce7e28f5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $edb2f44bce7e28f5$var$formatRelativeLocale[token];
};
var $edb2f44bce7e28f5$export$2e2bcd8739ae039 = $edb2f44bce7e28f5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $776315a63575708a$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var $776315a63575708a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $776315a63575708a$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var $776315a63575708a$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var $776315a63575708a$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $776315a63575708a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $776315a63575708a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var $776315a63575708a$var$localize = {
    ordinalNumber: $776315a63575708a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $776315a63575708a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $776315a63575708a$export$2e2bcd8739ae039 = $776315a63575708a$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7a3fd193d2180ce9$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $7a3fd193d2180ce9$var$parseOrdinalNumberPattern = /\d+/i;
var $7a3fd193d2180ce9$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $7a3fd193d2180ce9$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $7a3fd193d2180ce9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $7a3fd193d2180ce9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7a3fd193d2180ce9$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $7a3fd193d2180ce9$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $7a3fd193d2180ce9$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $7a3fd193d2180ce9$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $7a3fd193d2180ce9$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $7a3fd193d2180ce9$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $7a3fd193d2180ce9$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7a3fd193d2180ce9$var$matchOrdinalNumberPattern,
        parsePattern: $7a3fd193d2180ce9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7a3fd193d2180ce9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7a3fd193d2180ce9$export$2e2bcd8739ae039 = $7a3fd193d2180ce9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $9d4276bb8cd8c998$var$locale = {
    code: 'kn',
    formatDistance: (0, $97d24967eacd1186$export$2e2bcd8739ae039),
    formatLong: (0, $6b7efba750647d27$export$2e2bcd8739ae039),
    formatRelative: (0, $edb2f44bce7e28f5$export$2e2bcd8739ae039),
    localize: (0, $776315a63575708a$export$2e2bcd8739ae039),
    match: (0, $7a3fd193d2180ce9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $9d4276bb8cd8c998$export$2e2bcd8739ae039 = $9d4276bb8cd8c998$var$locale;
module.exports["default"] = $9d4276bb8cd8c998$export$2e2bcd8739ae039;

});

parcelRegister("a6iKE", function(module, exports) {
var $c83f7ecba3f0f0b0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var $c83f7ecba3f0f0b0$var$EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var $c83f7ecba3f0f0b0$var$VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var $c83f7ecba3f0f0b0$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $c83f7ecba3f0f0b0$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $c83f7ecba3f0f0b0$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($c83f7ecba3f0f0b0$var$VOWELS.indexOf(firstLetter) != -1 || $c83f7ecba3f0f0b0$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $c83f7ecba3f0f0b0$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $c83f7ecba3f0f0b0$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $c83f7ecba3f0f0b0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c83f7ecba3f0f0b0$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + ($c83f7ecba3f0f0b0$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + ($c83f7ecba3f0f0b0$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
var $c83f7ecba3f0f0b0$export$2e2bcd8739ae039 = $c83f7ecba3f0f0b0$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $c7c6cd06308059d7$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var $c7c6cd06308059d7$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c7c6cd06308059d7$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c7c6cd06308059d7$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c7c6cd06308059d7$export$2e2bcd8739ae039 = $c7c6cd06308059d7$var$formatLong;


var $e113410456dbcbd3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $e113410456dbcbd3$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $e113410456dbcbd3$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $e113410456dbcbd3$export$2e2bcd8739ae039 = $e113410456dbcbd3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $fca65a60c0cf6d5b$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var $fca65a60c0cf6d5b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var $fca65a60c0cf6d5b$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var $fca65a60c0cf6d5b$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var $fca65a60c0cf6d5b$var$dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var $fca65a60c0cf6d5b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var $fca65a60c0cf6d5b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $fca65a60c0cf6d5b$var$localize = {
    ordinalNumber: $fca65a60c0cf6d5b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $fca65a60c0cf6d5b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $fca65a60c0cf6d5b$export$2e2bcd8739ae039 = $fca65a60c0cf6d5b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e628cc10b21dd87f$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e628cc10b21dd87f$var$parseOrdinalNumberPattern = /\d+/i;
var $e628cc10b21dd87f$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $e628cc10b21dd87f$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $e628cc10b21dd87f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $e628cc10b21dd87f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e628cc10b21dd87f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $e628cc10b21dd87f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e628cc10b21dd87f$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $e628cc10b21dd87f$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $e628cc10b21dd87f$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $e628cc10b21dd87f$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $e628cc10b21dd87f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e628cc10b21dd87f$var$matchOrdinalNumberPattern,
        parsePattern: $e628cc10b21dd87f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e628cc10b21dd87f$export$2e2bcd8739ae039 = $e628cc10b21dd87f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $75a90291e110f884$var$locale = {
    code: 'lb',
    formatDistance: (0, $c83f7ecba3f0f0b0$export$2e2bcd8739ae039),
    formatLong: (0, $c7c6cd06308059d7$export$2e2bcd8739ae039),
    formatRelative: (0, $e113410456dbcbd3$export$2e2bcd8739ae039),
    localize: (0, $fca65a60c0cf6d5b$export$2e2bcd8739ae039),
    match: (0, $e628cc10b21dd87f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $75a90291e110f884$export$2e2bcd8739ae039 = $75a90291e110f884$var$locale;
module.exports["default"] = $75a90291e110f884$export$2e2bcd8739ae039;

});

parcelRegister("9Z9AE", function(module, exports) {
var $54329adf6acb8089$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var $54329adf6acb8089$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var $54329adf6acb8089$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $54329adf6acb8089$var$forms(key)[0] : isFuture ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[2];
};
var $54329adf6acb8089$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + $54329adf6acb8089$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($54329adf6acb8089$var$special(number) ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[0]);
    else {
        if (isFuture) return result + $54329adf6acb8089$var$forms(key)[1];
        else return result + ($54329adf6acb8089$var$special(number) ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[2]);
    }
};
function $54329adf6acb8089$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $54329adf6acb8089$var$forms(key) {
    return $54329adf6acb8089$var$translations[key].split('_');
}
var $54329adf6acb8089$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $54329adf6acb8089$var$translateSeconds,
        other: $54329adf6acb8089$var$translate
    },
    xSeconds: {
        one: $54329adf6acb8089$var$translateSeconds,
        other: $54329adf6acb8089$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xMinutes: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXHours: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xHours: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xDays: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXWeeks: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xWeeks: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXMonths: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xMonths: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    overXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    almostXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    }
};
var $54329adf6acb8089$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $54329adf6acb8089$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $54329adf6acb8089$var$translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
var $54329adf6acb8089$export$2e2bcd8739ae039 = $54329adf6acb8089$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6a75f66e2353f8ff$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var $6a75f66e2353f8ff$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6a75f66e2353f8ff$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6a75f66e2353f8ff$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6a75f66e2353f8ff$export$2e2bcd8739ae039 = $6a75f66e2353f8ff$var$formatLong;


var $a8232bfcb96c009f$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var $a8232bfcb96c009f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a8232bfcb96c009f$var$formatRelativeLocale[token];
};
var $a8232bfcb96c009f$export$2e2bcd8739ae039 = $a8232bfcb96c009f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $401c4b93c50401bc$var$eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var $401c4b93c50401bc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $401c4b93c50401bc$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $401c4b93c50401bc$var$monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var $401c4b93c50401bc$var$formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var $401c4b93c50401bc$var$dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var $401c4b93c50401bc$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var $401c4b93c50401bc$var$dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $401c4b93c50401bc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $401c4b93c50401bc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var $401c4b93c50401bc$var$localize = {
    ordinalNumber: $401c4b93c50401bc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $401c4b93c50401bc$export$2e2bcd8739ae039 = $401c4b93c50401bc$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $89d00f1d25d790b6$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $89d00f1d25d790b6$var$parseOrdinalNumberPattern = /\d+/i;
var $89d00f1d25d790b6$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $89d00f1d25d790b6$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $89d00f1d25d790b6$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $89d00f1d25d790b6$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $89d00f1d25d790b6$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $89d00f1d25d790b6$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $89d00f1d25d790b6$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $89d00f1d25d790b6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $89d00f1d25d790b6$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $89d00f1d25d790b6$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $89d00f1d25d790b6$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $89d00f1d25d790b6$var$matchOrdinalNumberPattern,
        parsePattern: $89d00f1d25d790b6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $89d00f1d25d790b6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $89d00f1d25d790b6$export$2e2bcd8739ae039 = $89d00f1d25d790b6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $74513ff69c3b5b9b$var$locale = {
    code: 'lt',
    formatDistance: (0, $54329adf6acb8089$export$2e2bcd8739ae039),
    formatLong: (0, $6a75f66e2353f8ff$export$2e2bcd8739ae039),
    formatRelative: (0, $a8232bfcb96c009f$export$2e2bcd8739ae039),
    localize: (0, $401c4b93c50401bc$export$2e2bcd8739ae039),
    match: (0, $89d00f1d25d790b6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $74513ff69c3b5b9b$export$2e2bcd8739ae039 = $74513ff69c3b5b9b$var$locale;
module.exports["default"] = $74513ff69c3b5b9b$export$2e2bcd8739ae039;

});

parcelRegister("hskCx", function(module, exports) {
function $c4531ec11ec67017$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var $c4531ec11ec67017$var$formatDistanceLocale = {
    lessThanXSeconds: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var $c4531ec11ec67017$var$formatDistance = function formatDistance(token, count, options) {
    var result = $c4531ec11ec67017$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
var $c4531ec11ec67017$export$2e2bcd8739ae039 = $c4531ec11ec67017$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $70a0c1e25812278d$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var $70a0c1e25812278d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $70a0c1e25812278d$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $70a0c1e25812278d$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $70a0c1e25812278d$export$2e2bcd8739ae039 = $70a0c1e25812278d$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $52283af7c315694c$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var $52283af7c315694c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $gQ473.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $52283af7c315694c$var$weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $gQ473.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $52283af7c315694c$var$weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var $52283af7c315694c$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $52283af7c315694c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $52283af7c315694c$export$2e2bcd8739ae039 = $52283af7c315694c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $94ff1f0d217179ff$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var $94ff1f0d217179ff$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var $94ff1f0d217179ff$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var $94ff1f0d217179ff$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var $94ff1f0d217179ff$var$formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var $94ff1f0d217179ff$var$dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var $94ff1f0d217179ff$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var $94ff1f0d217179ff$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var $94ff1f0d217179ff$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var $94ff1f0d217179ff$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $94ff1f0d217179ff$var$localize = {
    ordinalNumber: $94ff1f0d217179ff$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $94ff1f0d217179ff$export$2e2bcd8739ae039 = $94ff1f0d217179ff$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b0cd0a84d61e0dc1$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $b0cd0a84d61e0dc1$var$parseOrdinalNumberPattern = /\d+/i;
var $b0cd0a84d61e0dc1$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $b0cd0a84d61e0dc1$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $b0cd0a84d61e0dc1$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $b0cd0a84d61e0dc1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $b0cd0a84d61e0dc1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $b0cd0a84d61e0dc1$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $b0cd0a84d61e0dc1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b0cd0a84d61e0dc1$var$matchOrdinalNumberPattern,
        parsePattern: $b0cd0a84d61e0dc1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b0cd0a84d61e0dc1$export$2e2bcd8739ae039 = $b0cd0a84d61e0dc1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $cb550c0314b78ea3$var$locale = {
    code: 'lv',
    formatDistance: (0, $c4531ec11ec67017$export$2e2bcd8739ae039),
    formatLong: (0, $70a0c1e25812278d$export$2e2bcd8739ae039),
    formatRelative: (0, $52283af7c315694c$export$2e2bcd8739ae039),
    localize: (0, $94ff1f0d217179ff$export$2e2bcd8739ae039),
    match: (0, $b0cd0a84d61e0dc1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $cb550c0314b78ea3$export$2e2bcd8739ae039 = $cb550c0314b78ea3$var$locale;
module.exports["default"] = $cb550c0314b78ea3$export$2e2bcd8739ae039;

});

parcelRegister("678Ci", function(module, exports) {
var $38e2b37ba914e452$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $38e2b37ba914e452$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $38e2b37ba914e452$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
var $38e2b37ba914e452$export$2e2bcd8739ae039 = $38e2b37ba914e452$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $868d6b47fbbcda84$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $868d6b47fbbcda84$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $868d6b47fbbcda84$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $868d6b47fbbcda84$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $868d6b47fbbcda84$export$2e2bcd8739ae039 = $868d6b47fbbcda84$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $c07fb254ca400e91$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $c07fb254ca400e91$var$_lastWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $c07fb254ca400e91$var$thisWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $c07fb254ca400e91$var$_nextWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var $c07fb254ca400e91$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $c07fb254ca400e91$var$thisWeek(day);
        else return $c07fb254ca400e91$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $c07fb254ca400e91$var$thisWeek(day);
        else return $c07fb254ca400e91$var$_nextWeek(day);
    },
    other: 'P'
};
var $c07fb254ca400e91$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $c07fb254ca400e91$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $c07fb254ca400e91$export$2e2bcd8739ae039 = $c07fb254ca400e91$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e60acd06b2ad8108$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $e60acd06b2ad8108$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $e60acd06b2ad8108$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $e60acd06b2ad8108$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var $e60acd06b2ad8108$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var $e60acd06b2ad8108$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var $e60acd06b2ad8108$var$localize = {
    ordinalNumber: $e60acd06b2ad8108$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e60acd06b2ad8108$export$2e2bcd8739ae039 = $e60acd06b2ad8108$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $a0ca05f3aabab83f$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $a0ca05f3aabab83f$var$parseOrdinalNumberPattern = /\d+/i;
var $a0ca05f3aabab83f$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $a0ca05f3aabab83f$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $a0ca05f3aabab83f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $a0ca05f3aabab83f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0ca05f3aabab83f$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $a0ca05f3aabab83f$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $a0ca05f3aabab83f$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $a0ca05f3aabab83f$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $a0ca05f3aabab83f$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $a0ca05f3aabab83f$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $a0ca05f3aabab83f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $a0ca05f3aabab83f$var$matchOrdinalNumberPattern,
        parsePattern: $a0ca05f3aabab83f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a0ca05f3aabab83f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a0ca05f3aabab83f$export$2e2bcd8739ae039 = $a0ca05f3aabab83f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $473a149f18af00f6$var$locale = {
    code: 'mk',
    formatDistance: (0, $38e2b37ba914e452$export$2e2bcd8739ae039),
    formatLong: (0, $868d6b47fbbcda84$export$2e2bcd8739ae039),
    formatRelative: (0, $c07fb254ca400e91$export$2e2bcd8739ae039),
    localize: (0, $e60acd06b2ad8108$export$2e2bcd8739ae039),
    match: (0, $a0ca05f3aabab83f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $473a149f18af00f6$export$2e2bcd8739ae039 = $473a149f18af00f6$var$locale;
module.exports["default"] = $473a149f18af00f6$export$2e2bcd8739ae039;

});

parcelRegister("2QzpI", function(module, exports) {
var $e810e4e5450b9d02$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var $e810e4e5450b9d02$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e810e4e5450b9d02$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
var $e810e4e5450b9d02$export$2e2bcd8739ae039 = $e810e4e5450b9d02$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $352dae2a336c4394$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var $352dae2a336c4394$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $352dae2a336c4394$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $352dae2a336c4394$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $352dae2a336c4394$export$2e2bcd8739ae039 = $352dae2a336c4394$var$formatLong;


var $c21320992b3177f4$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var $c21320992b3177f4$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c21320992b3177f4$var$formatRelativeLocale[token];
};
var $c21320992b3177f4$export$2e2bcd8739ae039 = $c21320992b3177f4$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e37ecca7df4d0d01$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var $e37ecca7df4d0d01$var$quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $e37ecca7df4d0d01$var$monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $e37ecca7df4d0d01$var$formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $e37ecca7df4d0d01$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var $e37ecca7df4d0d01$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var $e37ecca7df4d0d01$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var $e37ecca7df4d0d01$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $e37ecca7df4d0d01$var$localize = {
    ordinalNumber: $e37ecca7df4d0d01$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $e37ecca7df4d0d01$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $e37ecca7df4d0d01$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e37ecca7df4d0d01$export$2e2bcd8739ae039 = $e37ecca7df4d0d01$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $97cfa91eb6b85723$var$matchOrdinalNumberPattern = /\d+/i;
var $97cfa91eb6b85723$var$parseOrdinalNumberPattern = /\d+/i;
var $97cfa91eb6b85723$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $97cfa91eb6b85723$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $97cfa91eb6b85723$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $97cfa91eb6b85723$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $97cfa91eb6b85723$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $97cfa91eb6b85723$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $97cfa91eb6b85723$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $97cfa91eb6b85723$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $97cfa91eb6b85723$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $97cfa91eb6b85723$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $97cfa91eb6b85723$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $97cfa91eb6b85723$var$matchOrdinalNumberPattern,
        parsePattern: $97cfa91eb6b85723$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $97cfa91eb6b85723$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $97cfa91eb6b85723$export$2e2bcd8739ae039 = $97cfa91eb6b85723$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $212be88776eaf75b$var$locale = {
    code: 'mn',
    formatDistance: (0, $e810e4e5450b9d02$export$2e2bcd8739ae039),
    formatLong: (0, $352dae2a336c4394$export$2e2bcd8739ae039),
    formatRelative: (0, $c21320992b3177f4$export$2e2bcd8739ae039),
    localize: (0, $e37ecca7df4d0d01$export$2e2bcd8739ae039),
    match: (0, $97cfa91eb6b85723$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $212be88776eaf75b$export$2e2bcd8739ae039 = $212be88776eaf75b$var$locale;
module.exports["default"] = $212be88776eaf75b$export$2e2bcd8739ae039;

});

parcelRegister("5CNN8", function(module, exports) {
var $bbc53934109fa733$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $bbc53934109fa733$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bbc53934109fa733$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $bbc53934109fa733$export$2e2bcd8739ae039 = $bbc53934109fa733$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $37bbceb49b350fc8$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $37bbceb49b350fc8$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $37bbceb49b350fc8$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $37bbceb49b350fc8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $37bbceb49b350fc8$export$2e2bcd8739ae039 = $37bbceb49b350fc8$var$formatLong;


var $b32d1fd63afd0e78$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var $b32d1fd63afd0e78$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b32d1fd63afd0e78$var$formatRelativeLocale[token];
};
var $b32d1fd63afd0e78$export$2e2bcd8739ae039 = $b32d1fd63afd0e78$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $d7391c0bf4ff28af$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var $d7391c0bf4ff28af$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d7391c0bf4ff28af$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var $d7391c0bf4ff28af$var$dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var $d7391c0bf4ff28af$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $d7391c0bf4ff28af$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $d7391c0bf4ff28af$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var $d7391c0bf4ff28af$var$localize = {
    ordinalNumber: $d7391c0bf4ff28af$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d7391c0bf4ff28af$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d7391c0bf4ff28af$export$2e2bcd8739ae039 = $d7391c0bf4ff28af$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $eabc763c6dd11778$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $eabc763c6dd11778$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $eabc763c6dd11778$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $eabc763c6dd11778$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $eabc763c6dd11778$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $eabc763c6dd11778$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $eabc763c6dd11778$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $eabc763c6dd11778$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $eabc763c6dd11778$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $eabc763c6dd11778$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $eabc763c6dd11778$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $eabc763c6dd11778$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $eabc763c6dd11778$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $eabc763c6dd11778$var$matchOrdinalNumberPattern,
        parsePattern: $eabc763c6dd11778$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $eabc763c6dd11778$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $eabc763c6dd11778$export$2e2bcd8739ae039 = $eabc763c6dd11778$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $41871fe51a1f0fa9$var$locale = {
    code: 'ms',
    formatDistance: (0, $bbc53934109fa733$export$2e2bcd8739ae039),
    formatLong: (0, $37bbceb49b350fc8$export$2e2bcd8739ae039),
    formatRelative: (0, $b32d1fd63afd0e78$export$2e2bcd8739ae039),
    localize: (0, $d7391c0bf4ff28af$export$2e2bcd8739ae039),
    match: (0, $eabc763c6dd11778$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $41871fe51a1f0fa9$export$2e2bcd8739ae039 = $41871fe51a1f0fa9$var$locale;
module.exports["default"] = $41871fe51a1f0fa9$export$2e2bcd8739ae039;

});

parcelRegister("3SSHw", function(module, exports) {
var $1b8fb988881d4677$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var $1b8fb988881d4677$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1b8fb988881d4677$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
var $1b8fb988881d4677$export$2e2bcd8739ae039 = $1b8fb988881d4677$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cc0f3d79cd7a78e1$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $cc0f3d79cd7a78e1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cc0f3d79cd7a78e1$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $cc0f3d79cd7a78e1$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cc0f3d79cd7a78e1$export$2e2bcd8739ae039 = $cc0f3d79cd7a78e1$var$formatLong;


var $a8fdaa0ba623362d$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var $a8fdaa0ba623362d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a8fdaa0ba623362d$var$formatRelativeLocale[token];
};
var $a8fdaa0ba623362d$export$2e2bcd8739ae039 = $a8fdaa0ba623362d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $04c04cb13867a139$var$eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var $04c04cb13867a139$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var $04c04cb13867a139$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var $04c04cb13867a139$var$dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var $04c04cb13867a139$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var $04c04cb13867a139$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var $04c04cb13867a139$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $04c04cb13867a139$var$localize = {
    ordinalNumber: $04c04cb13867a139$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $04c04cb13867a139$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $04c04cb13867a139$export$2e2bcd8739ae039 = $04c04cb13867a139$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $99e10bd1e560d471$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $99e10bd1e560d471$var$parseOrdinalNumberPattern = /\d+/i;
var $99e10bd1e560d471$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $99e10bd1e560d471$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $99e10bd1e560d471$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $99e10bd1e560d471$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $99e10bd1e560d471$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $99e10bd1e560d471$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $99e10bd1e560d471$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $99e10bd1e560d471$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $99e10bd1e560d471$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $99e10bd1e560d471$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $99e10bd1e560d471$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $99e10bd1e560d471$var$matchOrdinalNumberPattern,
        parsePattern: $99e10bd1e560d471$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $99e10bd1e560d471$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $99e10bd1e560d471$export$2e2bcd8739ae039 = $99e10bd1e560d471$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $2d40d8bbfdb109fe$var$locale = {
    code: 'mt',
    formatDistance: (0, $1b8fb988881d4677$export$2e2bcd8739ae039),
    formatLong: (0, $cc0f3d79cd7a78e1$export$2e2bcd8739ae039),
    formatRelative: (0, $a8fdaa0ba623362d$export$2e2bcd8739ae039),
    localize: (0, $04c04cb13867a139$export$2e2bcd8739ae039),
    match: (0, $99e10bd1e560d471$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2d40d8bbfdb109fe$export$2e2bcd8739ae039 = $2d40d8bbfdb109fe$var$locale;
module.exports["default"] = $2d40d8bbfdb109fe$export$2e2bcd8739ae039;

});

parcelRegister("3OBut", function(module, exports) {
var $11aacb0c7b81e292$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $11aacb0c7b81e292$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $11aacb0c7b81e292$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $11aacb0c7b81e292$export$2e2bcd8739ae039 = $11aacb0c7b81e292$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $ce23a664b355d3e9$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $ce23a664b355d3e9$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ce23a664b355d3e9$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ce23a664b355d3e9$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ce23a664b355d3e9$export$2e2bcd8739ae039 = $ce23a664b355d3e9$var$formatLong;


var $a094dba7e33d0bfd$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $a094dba7e33d0bfd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a094dba7e33d0bfd$var$formatRelativeLocale[token];
};
var $a094dba7e33d0bfd$export$2e2bcd8739ae039 = $a094dba7e33d0bfd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $50a92d75eb7ce83f$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $50a92d75eb7ce83f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $50a92d75eb7ce83f$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $50a92d75eb7ce83f$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $50a92d75eb7ce83f$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $50a92d75eb7ce83f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $50a92d75eb7ce83f$var$localize = {
    ordinalNumber: $50a92d75eb7ce83f$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $50a92d75eb7ce83f$export$2e2bcd8739ae039 = $50a92d75eb7ce83f$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $901631b0ebb1db4d$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $901631b0ebb1db4d$var$parseOrdinalNumberPattern = /\d+/i;
var $901631b0ebb1db4d$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $901631b0ebb1db4d$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $901631b0ebb1db4d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $901631b0ebb1db4d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $901631b0ebb1db4d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $901631b0ebb1db4d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $901631b0ebb1db4d$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $901631b0ebb1db4d$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $901631b0ebb1db4d$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $901631b0ebb1db4d$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $901631b0ebb1db4d$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $901631b0ebb1db4d$var$matchOrdinalNumberPattern,
        parsePattern: $901631b0ebb1db4d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $901631b0ebb1db4d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $901631b0ebb1db4d$export$2e2bcd8739ae039 = $901631b0ebb1db4d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $2c731f6c6ccdc7d7$var$locale = {
    code: 'nl-BE',
    formatDistance: (0, $11aacb0c7b81e292$export$2e2bcd8739ae039),
    formatLong: (0, $ce23a664b355d3e9$export$2e2bcd8739ae039),
    formatRelative: (0, $a094dba7e33d0bfd$export$2e2bcd8739ae039),
    localize: (0, $50a92d75eb7ce83f$export$2e2bcd8739ae039),
    match: (0, $901631b0ebb1db4d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2c731f6c6ccdc7d7$export$2e2bcd8739ae039 = $2c731f6c6ccdc7d7$var$locale;
module.exports["default"] = $2c731f6c6ccdc7d7$export$2e2bcd8739ae039;

});

parcelRegister("blOmo", function(module, exports) {
var $bb3d2b071e5b0a0b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $bb3d2b071e5b0a0b$var$wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var $bb3d2b071e5b0a0b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bb3d2b071e5b0a0b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $bb3d2b071e5b0a0b$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
var $bb3d2b071e5b0a0b$export$2e2bcd8739ae039 = $bb3d2b071e5b0a0b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $46829a671889ff1b$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $46829a671889ff1b$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $46829a671889ff1b$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $46829a671889ff1b$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $46829a671889ff1b$export$2e2bcd8739ae039 = $46829a671889ff1b$var$formatLong;


var $0d09e7622dee752c$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $0d09e7622dee752c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0d09e7622dee752c$var$formatRelativeLocale[token];
};
var $0d09e7622dee752c$export$2e2bcd8739ae039 = $0d09e7622dee752c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $1e6e9dc176a60a79$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $1e6e9dc176a60a79$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $1e6e9dc176a60a79$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $1e6e9dc176a60a79$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var $1e6e9dc176a60a79$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $1e6e9dc176a60a79$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $1e6e9dc176a60a79$var$localize = {
    ordinalNumber: $1e6e9dc176a60a79$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $1e6e9dc176a60a79$export$2e2bcd8739ae039 = $1e6e9dc176a60a79$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $260157d5bf24e2f9$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $260157d5bf24e2f9$var$parseOrdinalNumberPattern = /\d+/i;
var $260157d5bf24e2f9$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $260157d5bf24e2f9$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $260157d5bf24e2f9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $260157d5bf24e2f9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $260157d5bf24e2f9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $260157d5bf24e2f9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $260157d5bf24e2f9$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $260157d5bf24e2f9$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $260157d5bf24e2f9$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $260157d5bf24e2f9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $260157d5bf24e2f9$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $260157d5bf24e2f9$var$matchOrdinalNumberPattern,
        parsePattern: $260157d5bf24e2f9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $260157d5bf24e2f9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $260157d5bf24e2f9$export$2e2bcd8739ae039 = $260157d5bf24e2f9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $8438b856cdbd5c09$var$locale = {
    code: 'nn',
    formatDistance: (0, $bb3d2b071e5b0a0b$export$2e2bcd8739ae039),
    formatLong: (0, $46829a671889ff1b$export$2e2bcd8739ae039),
    formatRelative: (0, $0d09e7622dee752c$export$2e2bcd8739ae039),
    localize: (0, $1e6e9dc176a60a79$export$2e2bcd8739ae039),
    match: (0, $260157d5bf24e2f9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8438b856cdbd5c09$export$2e2bcd8739ae039 = $8438b856cdbd5c09$var$locale;
module.exports["default"] = $8438b856cdbd5c09$export$2e2bcd8739ae039;

});

parcelRegister("h5aPN", function(module, exports) {
var $ea5fa2bcb921d4c2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var $ea5fa2bcb921d4c2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ea5fa2bcb921d4c2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
var $ea5fa2bcb921d4c2$export$2e2bcd8739ae039 = $ea5fa2bcb921d4c2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $acd0ce0420d6464e$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $acd0ce0420d6464e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $acd0ce0420d6464e$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $acd0ce0420d6464e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $acd0ce0420d6464e$export$2e2bcd8739ae039 = $acd0ce0420d6464e$var$formatLong;


var $9a19abbbfd2e4b84$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var $9a19abbbfd2e4b84$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9a19abbbfd2e4b84$var$formatRelativeLocale[token];
};
var $9a19abbbfd2e4b84$export$2e2bcd8739ae039 = $9a19abbbfd2e4b84$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $993896cb8fef315c$var$eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $993896cb8fef315c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $993896cb8fef315c$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var $993896cb8fef315c$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var $993896cb8fef315c$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $993896cb8fef315c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var $993896cb8fef315c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var $993896cb8fef315c$var$localize = {
    ordinalNumber: $993896cb8fef315c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $993896cb8fef315c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $993896cb8fef315c$export$2e2bcd8739ae039 = $993896cb8fef315c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $a1079df3ee9e0c14$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $a1079df3ee9e0c14$var$parseOrdinalNumberPattern = /\d+/i;
var $a1079df3ee9e0c14$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $a1079df3ee9e0c14$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $a1079df3ee9e0c14$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $a1079df3ee9e0c14$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a1079df3ee9e0c14$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $a1079df3ee9e0c14$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a1079df3ee9e0c14$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $a1079df3ee9e0c14$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $a1079df3ee9e0c14$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $a1079df3ee9e0c14$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $a1079df3ee9e0c14$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $a1079df3ee9e0c14$var$matchOrdinalNumberPattern,
        parsePattern: $a1079df3ee9e0c14$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a1079df3ee9e0c14$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a1079df3ee9e0c14$export$2e2bcd8739ae039 = $a1079df3ee9e0c14$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $c6fb4ec7265e6e58$var$locale = {
    code: 'oc',
    formatDistance: (0, $ea5fa2bcb921d4c2$export$2e2bcd8739ae039),
    formatLong: (0, $acd0ce0420d6464e$export$2e2bcd8739ae039),
    formatRelative: (0, $9a19abbbfd2e4b84$export$2e2bcd8739ae039),
    localize: (0, $993896cb8fef315c$export$2e2bcd8739ae039),
    match: (0, $a1079df3ee9e0c14$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c6fb4ec7265e6e58$export$2e2bcd8739ae039 = $c6fb4ec7265e6e58$var$locale;
module.exports["default"] = $c6fb4ec7265e6e58$export$2e2bcd8739ae039;

});

parcelRegister("bKFGE", function(module, exports) {
function $17de68ded390b230$var$isPluralType(val) {
    return val.one !== undefined;
}
var $17de68ded390b230$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function $17de68ded390b230$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var $17de68ded390b230$var$formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = $17de68ded390b230$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = $17de68ded390b230$var$getFormFromCount(count);
        if ($17de68ded390b230$var$isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
var $17de68ded390b230$export$2e2bcd8739ae039 = $17de68ded390b230$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $ab31f68934a87c9a$var$dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var $ab31f68934a87c9a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ab31f68934a87c9a$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ab31f68934a87c9a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ab31f68934a87c9a$export$2e2bcd8739ae039 = $ab31f68934a87c9a$var$formatLong;


var $dd96cdfd91797cb9$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var $dd96cdfd91797cb9$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $dd96cdfd91797cb9$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $dd96cdfd91797cb9$export$2e2bcd8739ae039 = $dd96cdfd91797cb9$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $31078dbe30a60b94$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var $31078dbe30a60b94$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var $31078dbe30a60b94$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $31078dbe30a60b94$var$dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var $31078dbe30a60b94$var$dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var $31078dbe30a60b94$var$formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var $31078dbe30a60b94$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $31078dbe30a60b94$var$localize = {
    ordinalNumber: $31078dbe30a60b94$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $31078dbe30a60b94$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $31078dbe30a60b94$export$2e2bcd8739ae039 = $31078dbe30a60b94$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $26e2860cd3e3549e$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $26e2860cd3e3549e$var$parseOrdinalNumberPattern = /\d+/i;
var $26e2860cd3e3549e$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $26e2860cd3e3549e$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $26e2860cd3e3549e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $26e2860cd3e3549e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $26e2860cd3e3549e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $26e2860cd3e3549e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $26e2860cd3e3549e$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $26e2860cd3e3549e$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $26e2860cd3e3549e$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $26e2860cd3e3549e$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $26e2860cd3e3549e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $26e2860cd3e3549e$var$matchOrdinalNumberPattern,
        parsePattern: $26e2860cd3e3549e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $26e2860cd3e3549e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $26e2860cd3e3549e$export$2e2bcd8739ae039 = $26e2860cd3e3549e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $88e453c36c670e10$var$locale = {
    code: 'sl',
    formatDistance: (0, $17de68ded390b230$export$2e2bcd8739ae039),
    formatLong: (0, $ab31f68934a87c9a$export$2e2bcd8739ae039),
    formatRelative: (0, $dd96cdfd91797cb9$export$2e2bcd8739ae039),
    localize: (0, $31078dbe30a60b94$export$2e2bcd8739ae039),
    match: (0, $26e2860cd3e3549e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $88e453c36c670e10$export$2e2bcd8739ae039 = $88e453c36c670e10$var$locale;
module.exports["default"] = $88e453c36c670e10$export$2e2bcd8739ae039;

});

parcelRegister("bL8hA", function(module, exports) {
var $b88850c4a5a39786$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var $b88850c4a5a39786$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b88850c4a5a39786$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $b88850c4a5a39786$export$2e2bcd8739ae039 = $b88850c4a5a39786$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $2c21d89f088e6670$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $2c21d89f088e6670$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $2c21d89f088e6670$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2c21d89f088e6670$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2c21d89f088e6670$export$2e2bcd8739ae039 = $2c21d89f088e6670$var$formatLong;


var $fcb260b9dbabf662$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $fcb260b9dbabf662$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fcb260b9dbabf662$var$formatRelativeLocale[token];
};
var $fcb260b9dbabf662$export$2e2bcd8739ae039 = $fcb260b9dbabf662$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $05ffcfbe310acae3$var$eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var $05ffcfbe310acae3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $05ffcfbe310acae3$var$monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var $05ffcfbe310acae3$var$dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var $05ffcfbe310acae3$var$dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $05ffcfbe310acae3$var$formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $05ffcfbe310acae3$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var $05ffcfbe310acae3$var$localize = {
    ordinalNumber: $05ffcfbe310acae3$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $05ffcfbe310acae3$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $05ffcfbe310acae3$export$2e2bcd8739ae039 = $05ffcfbe310acae3$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3c3fffed6cb7350e$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $3c3fffed6cb7350e$var$parseOrdinalNumberPattern = /\d+/i;
var $3c3fffed6cb7350e$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $3c3fffed6cb7350e$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $3c3fffed6cb7350e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $3c3fffed6cb7350e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3c3fffed6cb7350e$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $3c3fffed6cb7350e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $3c3fffed6cb7350e$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $3c3fffed6cb7350e$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $3c3fffed6cb7350e$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $3c3fffed6cb7350e$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $3c3fffed6cb7350e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3c3fffed6cb7350e$var$matchOrdinalNumberPattern,
        parsePattern: $3c3fffed6cb7350e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3c3fffed6cb7350e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3c3fffed6cb7350e$export$2e2bcd8739ae039 = $3c3fffed6cb7350e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $88fa82430361922c$var$locale = {
    code: 'sq',
    formatDistance: (0, $b88850c4a5a39786$export$2e2bcd8739ae039),
    formatLong: (0, $2c21d89f088e6670$export$2e2bcd8739ae039),
    formatRelative: (0, $fcb260b9dbabf662$export$2e2bcd8739ae039),
    localize: (0, $05ffcfbe310acae3$export$2e2bcd8739ae039),
    match: (0, $3c3fffed6cb7350e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $88fa82430361922c$export$2e2bcd8739ae039 = $88fa82430361922c$var$locale;
module.exports["default"] = $88fa82430361922c$export$2e2bcd8739ae039;

});

parcelRegister("1iyef", function(module, exports) {
var $b1a5ec7c73dde335$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var $b1a5ec7c73dde335$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b1a5ec7c73dde335$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
var $b1a5ec7c73dde335$export$2e2bcd8739ae039 = $b1a5ec7c73dde335$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $0001b8e6bbbafa4a$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $0001b8e6bbbafa4a$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $0001b8e6bbbafa4a$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $0001b8e6bbbafa4a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0001b8e6bbbafa4a$export$2e2bcd8739ae039 = $0001b8e6bbbafa4a$var$formatLong;


var $716f8472913c48fe$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var $716f8472913c48fe$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $716f8472913c48fe$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $716f8472913c48fe$export$2e2bcd8739ae039 = $716f8472913c48fe$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b2d55e8f384e317a$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var $b2d55e8f384e317a$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $b2d55e8f384e317a$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $b2d55e8f384e317a$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $b2d55e8f384e317a$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $b2d55e8f384e317a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $b2d55e8f384e317a$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $b2d55e8f384e317a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b2d55e8f384e317a$var$localize = {
    ordinalNumber: $b2d55e8f384e317a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b2d55e8f384e317a$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b2d55e8f384e317a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b2d55e8f384e317a$export$2e2bcd8739ae039 = $b2d55e8f384e317a$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $67771ef1242517f1$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $67771ef1242517f1$var$parseOrdinalNumberPattern = /\d+/i;
var $67771ef1242517f1$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $67771ef1242517f1$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $67771ef1242517f1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $67771ef1242517f1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $67771ef1242517f1$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $67771ef1242517f1$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $67771ef1242517f1$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $67771ef1242517f1$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $67771ef1242517f1$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $67771ef1242517f1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $67771ef1242517f1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $67771ef1242517f1$var$matchOrdinalNumberPattern,
        parsePattern: $67771ef1242517f1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $67771ef1242517f1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $67771ef1242517f1$export$2e2bcd8739ae039 = $67771ef1242517f1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $0f220603889f00e8$var$locale = {
    code: 'sr',
    formatDistance: (0, $b1a5ec7c73dde335$export$2e2bcd8739ae039),
    formatLong: (0, $0001b8e6bbbafa4a$export$2e2bcd8739ae039),
    formatRelative: (0, $716f8472913c48fe$export$2e2bcd8739ae039),
    localize: (0, $b2d55e8f384e317a$export$2e2bcd8739ae039),
    match: (0, $67771ef1242517f1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0f220603889f00e8$export$2e2bcd8739ae039 = $0f220603889f00e8$var$locale;
module.exports["default"] = $0f220603889f00e8$export$2e2bcd8739ae039;

});

parcelRegister("6AuV3", function(module, exports) {
var $ebb18e1a9736c5e5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $ebb18e1a9736c5e5$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ebb18e1a9736c5e5$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
var $ebb18e1a9736c5e5$export$2e2bcd8739ae039 = $ebb18e1a9736c5e5$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8f06af5f6a2580dc$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $8f06af5f6a2580dc$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8f06af5f6a2580dc$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $8f06af5f6a2580dc$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8f06af5f6a2580dc$export$2e2bcd8739ae039 = $8f06af5f6a2580dc$var$formatLong;


var $ec41f18baa0c98de$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $ec41f18baa0c98de$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $ec41f18baa0c98de$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $ec41f18baa0c98de$export$2e2bcd8739ae039 = $ec41f18baa0c98de$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $104f4b796d67c972$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var $104f4b796d67c972$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $104f4b796d67c972$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $104f4b796d67c972$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $104f4b796d67c972$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $104f4b796d67c972$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $104f4b796d67c972$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $104f4b796d67c972$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $104f4b796d67c972$var$localize = {
    ordinalNumber: $104f4b796d67c972$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $104f4b796d67c972$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $104f4b796d67c972$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $104f4b796d67c972$export$2e2bcd8739ae039 = $104f4b796d67c972$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $425dbc81921db028$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $425dbc81921db028$var$parseOrdinalNumberPattern = /\d+/i;
var $425dbc81921db028$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $425dbc81921db028$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $425dbc81921db028$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $425dbc81921db028$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $425dbc81921db028$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $425dbc81921db028$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $425dbc81921db028$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $425dbc81921db028$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $425dbc81921db028$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $425dbc81921db028$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $425dbc81921db028$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $425dbc81921db028$var$matchOrdinalNumberPattern,
        parsePattern: $425dbc81921db028$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $425dbc81921db028$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $425dbc81921db028$export$2e2bcd8739ae039 = $425dbc81921db028$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $013cdf55dcd74a60$var$locale = {
    code: 'sr-Latn',
    formatDistance: (0, $ebb18e1a9736c5e5$export$2e2bcd8739ae039),
    formatLong: (0, $8f06af5f6a2580dc$export$2e2bcd8739ae039),
    formatRelative: (0, $ec41f18baa0c98de$export$2e2bcd8739ae039),
    localize: (0, $104f4b796d67c972$export$2e2bcd8739ae039),
    match: (0, $425dbc81921db028$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $013cdf55dcd74a60$export$2e2bcd8739ae039 = $013cdf55dcd74a60$var$locale;
module.exports["default"] = $013cdf55dcd74a60$export$2e2bcd8739ae039;

});

parcelRegister("iZ7nC", function(module, exports) {
function $a2c784cbbde0fca2$var$isPluralType(val) {
    return val.one !== undefined;
}
var $a2c784cbbde0fca2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var $a2c784cbbde0fca2$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = $a2c784cbbde0fca2$var$formatDistanceLocale[token];
    if (!$a2c784cbbde0fca2$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
var $a2c784cbbde0fca2$export$2e2bcd8739ae039 = $a2c784cbbde0fca2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

// CLDR #1846 - #1849
var $0f4e17aade46fc3e$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var $0f4e17aade46fc3e$var$timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $0f4e17aade46fc3e$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0f4e17aade46fc3e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0f4e17aade46fc3e$export$2e2bcd8739ae039 = $0f4e17aade46fc3e$var$formatLong;


var $d2703bfda6306fbc$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var $d2703bfda6306fbc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d2703bfda6306fbc$var$formatRelativeLocale[token];
};
var $d2703bfda6306fbc$export$2e2bcd8739ae039 = $d2703bfda6306fbc$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $28d90120fe093d15$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var $28d90120fe093d15$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var $28d90120fe093d15$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var $28d90120fe093d15$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var $28d90120fe093d15$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var $28d90120fe093d15$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var $28d90120fe093d15$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $28d90120fe093d15$var$localize = {
    ordinalNumber: $28d90120fe093d15$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $28d90120fe093d15$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $28d90120fe093d15$export$2e2bcd8739ae039 = $28d90120fe093d15$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $c5c84d9dc1e46147$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $c5c84d9dc1e46147$var$parseOrdinalNumberPattern = /\d+/i;
var $c5c84d9dc1e46147$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $c5c84d9dc1e46147$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $c5c84d9dc1e46147$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $c5c84d9dc1e46147$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $c5c84d9dc1e46147$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $c5c84d9dc1e46147$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $c5c84d9dc1e46147$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $c5c84d9dc1e46147$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $c5c84d9dc1e46147$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $c5c84d9dc1e46147$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $c5c84d9dc1e46147$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $c5c84d9dc1e46147$var$matchOrdinalNumberPattern,
        parsePattern: $c5c84d9dc1e46147$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c5c84d9dc1e46147$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c5c84d9dc1e46147$export$2e2bcd8739ae039 = $c5c84d9dc1e46147$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $dd23a600421da365$var$locale = {
    code: 'ta',
    formatDistance: (0, $a2c784cbbde0fca2$export$2e2bcd8739ae039),
    formatLong: (0, $0f4e17aade46fc3e$export$2e2bcd8739ae039),
    formatRelative: (0, $d2703bfda6306fbc$export$2e2bcd8739ae039),
    localize: (0, $28d90120fe093d15$export$2e2bcd8739ae039),
    match: (0, $c5c84d9dc1e46147$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $dd23a600421da365$export$2e2bcd8739ae039 = $dd23a600421da365$var$locale;
module.exports["default"] = $dd23a600421da365$export$2e2bcd8739ae039;

});

parcelRegister("cz4ad", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $c97829d24532b1bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var $c97829d24532b1bc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $c97829d24532b1bc$var$formatDistanceLocale[token].withPreposition : $c97829d24532b1bc$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
var $c97829d24532b1bc$export$2e2bcd8739ae039 = $c97829d24532b1bc$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

// CLDR #1807 - #1811
var $ad642022a6bd54af$var$dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var $ad642022a6bd54af$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var $ad642022a6bd54af$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ad642022a6bd54af$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ad642022a6bd54af$export$2e2bcd8739ae039 = $ad642022a6bd54af$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $2ddaa488616cd720$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var $2ddaa488616cd720$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2ddaa488616cd720$var$formatRelativeLocale[token];
};
var $2ddaa488616cd720$export$2e2bcd8739ae039 = $2ddaa488616cd720$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $d41e3af6d9634a1d$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var $d41e3af6d9634a1d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var $d41e3af6d9634a1d$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var $d41e3af6d9634a1d$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var $d41e3af6d9634a1d$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $d41e3af6d9634a1d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $d41e3af6d9634a1d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var $d41e3af6d9634a1d$var$localize = {
    ordinalNumber: $d41e3af6d9634a1d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d41e3af6d9634a1d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d41e3af6d9634a1d$export$2e2bcd8739ae039 = $d41e3af6d9634a1d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0c0cf53124a7cb5f$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $0c0cf53124a7cb5f$var$parseOrdinalNumberPattern = /\d+/i;
var $0c0cf53124a7cb5f$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $0c0cf53124a7cb5f$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $0c0cf53124a7cb5f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $0c0cf53124a7cb5f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0c0cf53124a7cb5f$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $0c0cf53124a7cb5f$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $0c0cf53124a7cb5f$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $0c0cf53124a7cb5f$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $0c0cf53124a7cb5f$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $0c0cf53124a7cb5f$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $0c0cf53124a7cb5f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0c0cf53124a7cb5f$var$matchOrdinalNumberPattern,
        parsePattern: $0c0cf53124a7cb5f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0c0cf53124a7cb5f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0c0cf53124a7cb5f$export$2e2bcd8739ae039 = $0c0cf53124a7cb5f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $925bfbbb6b5645ba$var$locale = {
    code: 'te',
    formatDistance: (0, $c97829d24532b1bc$export$2e2bcd8739ae039),
    formatLong: (0, $ad642022a6bd54af$export$2e2bcd8739ae039),
    formatRelative: (0, $2ddaa488616cd720$export$2e2bcd8739ae039),
    localize: (0, $d41e3af6d9634a1d$export$2e2bcd8739ae039),
    match: (0, $0c0cf53124a7cb5f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $925bfbbb6b5645ba$export$2e2bcd8739ae039 = $925bfbbb6b5645ba$var$locale;
module.exports["default"] = $925bfbbb6b5645ba$export$2e2bcd8739ae039;

});

parcelRegister("fJC8B", function(module, exports) {
var $e829db4d66c9f675$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var $e829db4d66c9f675$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e829db4d66c9f675$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
var $e829db4d66c9f675$export$2e2bcd8739ae039 = $e829db4d66c9f675$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $70d1647f8fe41014$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $70d1647f8fe41014$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $70d1647f8fe41014$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $70d1647f8fe41014$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $70d1647f8fe41014$export$2e2bcd8739ae039 = $70d1647f8fe41014$var$formatLong;


var $e175164e889defa4$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var $e175164e889defa4$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e175164e889defa4$var$formatRelativeLocale[token];
};
var $e175164e889defa4$export$2e2bcd8739ae039 = $e175164e889defa4$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $4850993d53703564$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var $4850993d53703564$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $4850993d53703564$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var $4850993d53703564$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var $4850993d53703564$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var $4850993d53703564$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var $4850993d53703564$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $4850993d53703564$var$localize = {
    ordinalNumber: $4850993d53703564$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4850993d53703564$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4850993d53703564$export$2e2bcd8739ae039 = $4850993d53703564$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0a8e779d31ea8cea$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0a8e779d31ea8cea$var$parseOrdinalNumberPattern = /\d+/i;
var $0a8e779d31ea8cea$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $0a8e779d31ea8cea$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $0a8e779d31ea8cea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $0a8e779d31ea8cea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0a8e779d31ea8cea$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $0a8e779d31ea8cea$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $0a8e779d31ea8cea$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $0a8e779d31ea8cea$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $0a8e779d31ea8cea$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $0a8e779d31ea8cea$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $0a8e779d31ea8cea$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0a8e779d31ea8cea$var$matchOrdinalNumberPattern,
        parsePattern: $0a8e779d31ea8cea$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0a8e779d31ea8cea$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0a8e779d31ea8cea$export$2e2bcd8739ae039 = $0a8e779d31ea8cea$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $b748a45582dcf19c$var$locale = {
    code: 'ug',
    formatDistance: (0, $e829db4d66c9f675$export$2e2bcd8739ae039),
    formatLong: (0, $70d1647f8fe41014$export$2e2bcd8739ae039),
    formatRelative: (0, $e175164e889defa4$export$2e2bcd8739ae039),
    localize: (0, $4850993d53703564$export$2e2bcd8739ae039),
    match: (0, $0a8e779d31ea8cea$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b748a45582dcf19c$export$2e2bcd8739ae039 = $b748a45582dcf19c$var$locale;
module.exports["default"] = $b748a45582dcf19c$export$2e2bcd8739ae039;

});

parcelRegister("74d4N", function(module, exports) {
var $dc578db66e275af8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var $dc578db66e275af8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $dc578db66e275af8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
var $dc578db66e275af8$export$2e2bcd8739ae039 = $dc578db66e275af8$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cfdda3ed87baaa54$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $cfdda3ed87baaa54$var$timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var $cfdda3ed87baaa54$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $cfdda3ed87baaa54$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $cfdda3ed87baaa54$export$2e2bcd8739ae039 = $cfdda3ed87baaa54$var$formatLong;


var $8560410d7f1753cc$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var $8560410d7f1753cc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8560410d7f1753cc$var$formatRelativeLocale[token];
};
var $8560410d7f1753cc$export$2e2bcd8739ae039 = $8560410d7f1753cc$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $53603606c32ae9de$var$eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var $53603606c32ae9de$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $53603606c32ae9de$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $53603606c32ae9de$var$dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var $53603606c32ae9de$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $53603606c32ae9de$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $53603606c32ae9de$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $53603606c32ae9de$var$localize = {
    ordinalNumber: $53603606c32ae9de$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $53603606c32ae9de$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $53603606c32ae9de$export$2e2bcd8739ae039 = $53603606c32ae9de$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $dd05b0e9278d6956$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $dd05b0e9278d6956$var$parseOrdinalNumberPattern = /\d+/i;
var $dd05b0e9278d6956$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $dd05b0e9278d6956$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $dd05b0e9278d6956$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $dd05b0e9278d6956$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dd05b0e9278d6956$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $dd05b0e9278d6956$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dd05b0e9278d6956$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $dd05b0e9278d6956$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $dd05b0e9278d6956$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $dd05b0e9278d6956$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $dd05b0e9278d6956$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $dd05b0e9278d6956$var$matchOrdinalNumberPattern,
        parsePattern: $dd05b0e9278d6956$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dd05b0e9278d6956$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dd05b0e9278d6956$export$2e2bcd8739ae039 = $dd05b0e9278d6956$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $52530cd208ccbbc3$var$locale = {
    code: 'uz',
    formatDistance: (0, $dc578db66e275af8$export$2e2bcd8739ae039),
    formatLong: (0, $cfdda3ed87baaa54$export$2e2bcd8739ae039),
    formatRelative: (0, $8560410d7f1753cc$export$2e2bcd8739ae039),
    localize: (0, $53603606c32ae9de$export$2e2bcd8739ae039),
    match: (0, $dd05b0e9278d6956$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $52530cd208ccbbc3$export$2e2bcd8739ae039 = $52530cd208ccbbc3$var$locale;
module.exports["default"] = $52530cd208ccbbc3$export$2e2bcd8739ae039;

});

parcelRegister("f2nvb", function(module, exports) {
var $a43b52d6735a2757$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var $a43b52d6735a2757$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a43b52d6735a2757$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
var $a43b52d6735a2757$export$2e2bcd8739ae039 = $a43b52d6735a2757$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $93b03e6985c59e51$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $93b03e6985c59e51$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $93b03e6985c59e51$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $93b03e6985c59e51$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $93b03e6985c59e51$export$2e2bcd8739ae039 = $93b03e6985c59e51$var$formatLong;


var $3c93c08e5f6f548d$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var $3c93c08e5f6f548d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3c93c08e5f6f548d$var$formatRelativeLocale[token];
};
var $3c93c08e5f6f548d$export$2e2bcd8739ae039 = $3c93c08e5f6f548d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $6bea0cc63238eb84$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var $6bea0cc63238eb84$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var $6bea0cc63238eb84$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var $6bea0cc63238eb84$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var $6bea0cc63238eb84$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $6bea0cc63238eb84$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $6bea0cc63238eb84$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $6bea0cc63238eb84$var$localize = {
    ordinalNumber: $6bea0cc63238eb84$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $6bea0cc63238eb84$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
var $6bea0cc63238eb84$export$2e2bcd8739ae039 = $6bea0cc63238eb84$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $2b4f49167631d8c1$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $2b4f49167631d8c1$var$parseOrdinalNumberPattern = /\d+/i;
var $2b4f49167631d8c1$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $2b4f49167631d8c1$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $2b4f49167631d8c1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $2b4f49167631d8c1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2b4f49167631d8c1$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $2b4f49167631d8c1$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $2b4f49167631d8c1$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $2b4f49167631d8c1$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $2b4f49167631d8c1$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $2b4f49167631d8c1$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $2b4f49167631d8c1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $2b4f49167631d8c1$var$matchOrdinalNumberPattern,
        parsePattern: $2b4f49167631d8c1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2b4f49167631d8c1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2b4f49167631d8c1$export$2e2bcd8739ae039 = $2b4f49167631d8c1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $af2945e4fd7e3cab$var$locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, $a43b52d6735a2757$export$2e2bcd8739ae039),
    formatLong: (0, $93b03e6985c59e51$export$2e2bcd8739ae039),
    formatRelative: (0, $3c93c08e5f6f548d$export$2e2bcd8739ae039),
    localize: (0, $6bea0cc63238eb84$export$2e2bcd8739ae039),
    match: (0, $2b4f49167631d8c1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $af2945e4fd7e3cab$export$2e2bcd8739ae039 = $af2945e4fd7e3cab$var$locale;
module.exports["default"] = $af2945e4fd7e3cab$export$2e2bcd8739ae039;

});

parcelRegister("l8E94", function(module, exports) {
var $55026f65778f3fd9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $55026f65778f3fd9$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $55026f65778f3fd9$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $55026f65778f3fd9$export$2e2bcd8739ae039 = $55026f65778f3fd9$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $44f86483cdd479a5$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $44f86483cdd479a5$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $44f86483cdd479a5$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $44f86483cdd479a5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $44f86483cdd479a5$export$2e2bcd8739ae039 = $44f86483cdd479a5$var$formatLong;


var $4001880b7e9a8952$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $4001880b7e9a8952$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4001880b7e9a8952$var$formatRelativeLocale[token];
};
var $4001880b7e9a8952$export$2e2bcd8739ae039 = $4001880b7e9a8952$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $3a77168ee116457b$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $3a77168ee116457b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $3a77168ee116457b$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $3a77168ee116457b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $3a77168ee116457b$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $3a77168ee116457b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $3a77168ee116457b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $3a77168ee116457b$var$localize = {
    ordinalNumber: $3a77168ee116457b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3a77168ee116457b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3a77168ee116457b$export$2e2bcd8739ae039 = $3a77168ee116457b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5afa2632335d5009$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $5afa2632335d5009$var$parseOrdinalNumberPattern = /\d+/i;
var $5afa2632335d5009$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $5afa2632335d5009$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $5afa2632335d5009$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $5afa2632335d5009$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $5afa2632335d5009$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $5afa2632335d5009$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $5afa2632335d5009$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $5afa2632335d5009$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $5afa2632335d5009$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $5afa2632335d5009$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $5afa2632335d5009$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5afa2632335d5009$var$matchOrdinalNumberPattern,
        parsePattern: $5afa2632335d5009$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5afa2632335d5009$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5afa2632335d5009$export$2e2bcd8739ae039 = $5afa2632335d5009$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $f6397c55030101fe$var$locale = {
    code: 'zh-HK',
    formatDistance: (0, $55026f65778f3fd9$export$2e2bcd8739ae039),
    formatLong: (0, $44f86483cdd479a5$export$2e2bcd8739ae039),
    formatRelative: (0, $4001880b7e9a8952$export$2e2bcd8739ae039),
    localize: (0, $3a77168ee116457b$export$2e2bcd8739ae039),
    match: (0, $5afa2632335d5009$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f6397c55030101fe$export$2e2bcd8739ae039 = $f6397c55030101fe$var$locale;
module.exports["default"] = $f6397c55030101fe$export$2e2bcd8739ae039;

});

parcelRegister("26gmS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd8c6d9a48eb8c2ec1d5a30fec88d6dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1878d6a1b5423b21$var$_react = $1878d6a1b5423b21$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1878d6a1b5423b21$var$_iconNew = $1878d6a1b5423b21$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1878d6a1b5423b21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/expand-element
 * Usage guidance:
 * Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1878d6a1b5423b21$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $1878d6a1b5423b21$var$_react.default.createElement($1878d6a1b5423b21$var$_iconNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$1878d6a1b5423b21$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $1878d6a1b5423b21$var$_default = module.exports.default = $1878d6a1b5423b21$var$ExpandElementIcon;

});

parcelRegister("bRHnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d1ae50d8cf3e612b44e567e4a30eb2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a364c786091fd04$var$_react = $8a364c786091fd04$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8a364c786091fd04$var$_iconNew = $8a364c786091fd04$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8a364c786091fd04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-letter-case
 * Usage guidance:
 * Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a364c786091fd04$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $8a364c786091fd04$var$_react.default.createElement($8a364c786091fd04$var$_iconNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$8a364c786091fd04$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $8a364c786091fd04$var$_default = module.exports.default = $8a364c786091fd04$var$TextLetterCaseIcon;

});

parcelRegister("doGhB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $d7c88558fa026ef9$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('helpDialogPlugin');
module.exports["pluginKey"] = $d7c88558fa026ef9$export$18d4026d1ea86bb1;

});

parcelRegister("gjFO5", function(module, exports) {
var $3657d91fd05ab098$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $3657d91fd05ab098$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});
module.exports["LAYOUT_TYPE"] = $3657d91fd05ab098$export$9710eda883ce7be2;
module.exports["SMART_LINK_TYPE"] = $3657d91fd05ab098$export$804a928ffc86c02c;

});

parcelRegister("3ymEf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81306de5aadced8b72071db543605b61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29661d873488d465$var$_react = $29661d873488d465$var$_interopRequireDefault((parcelRequire("cozmU")));

var $29661d873488d465$var$_iconNew = $29661d873488d465$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $29661d873488d465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-five-columns
 * Usage guidance:
 * Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29661d873488d465$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $29661d873488d465$var$_react.default.createElement($29661d873488d465$var$_iconNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$29661d873488d465$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $29661d873488d465$var$_default = module.exports.default = $29661d873488d465$var$LayoutFiveColumnsIcon;

});

parcelRegister("bhIPc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c46fa49e336ada32e735b81e4aa5434>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83740d87d4809498$var$_react = $83740d87d4809498$var$_interopRequireDefault((parcelRequire("cozmU")));

var $83740d87d4809498$var$_iconNew = $83740d87d4809498$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $83740d87d4809498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-four-columns
 * Usage guidance:
 * Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83740d87d4809498$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $83740d87d4809498$var$_react.default.createElement($83740d87d4809498$var$_iconNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$83740d87d4809498$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $83740d87d4809498$var$_default = module.exports.default = $83740d87d4809498$var$LayoutFourColumnsIcon;

});

parcelRegister("ctpKQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16d8836cf8baac0ddc7210e13dc4175>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914c2bc71540bb85$var$_react = $914c2bc71540bb85$var$_interopRequireDefault((parcelRequire("cozmU")));

var $914c2bc71540bb85$var$_iconNew = $914c2bc71540bb85$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $914c2bc71540bb85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-left
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $914c2bc71540bb85$var$_react.default.createElement($914c2bc71540bb85$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $914c2bc71540bb85$var$_default = module.exports.default = $914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon;

});

parcelRegister("4dPfL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20762fd7ff8385df45415d0e63afaff2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31302224f1376c36$var$_react = $31302224f1376c36$var$_interopRequireDefault((parcelRequire("cozmU")));

var $31302224f1376c36$var$_iconNew = $31302224f1376c36$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $31302224f1376c36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-right
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $31302224f1376c36$var$_react.default.createElement($31302224f1376c36$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $31302224f1376c36$var$_default = module.exports.default = $31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon;

});

parcelRegister("icqAo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c275ac7980a0446f7df03013c12225e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3fdf866f6aba1b9$var$_react = $d3fdf866f6aba1b9$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d3fdf866f6aba1b9$var$_iconNew = $d3fdf866f6aba1b9$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d3fdf866f6aba1b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowCancelled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-cancelled
 * Usage guidance:
 * Reserved for representing statuses that indicated work or a process has been cancelled
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3fdf866f6aba1b9$var$StatusWorkflowCancelledIcon = (props)=>/*#__PURE__*/ $d3fdf866f6aba1b9$var$_react.default.createElement($d3fdf866f6aba1b9$var$_iconNew.default, Object.assign({
        name: "StatusWorkflowCancelledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m10.254 1.06A6.501 6.501 0 1 0 3.404 12.6a6.501 6.501 0 0 0 9.193-9.195m-.885 1.946L9.061 8l2.651 2.652-1.06 1.06L8 9.061l-2.65 2.651-1.06-1.06L6.938 8 4.29 5.35l1.06-1.06L8 6.938l2.652-2.65z"/>`
    }, props));
$d3fdf866f6aba1b9$var$StatusWorkflowCancelledIcon.displayName = 'StatusWorkflowCancelledIcon';
var $d3fdf866f6aba1b9$var$_default = module.exports.default = $d3fdf866f6aba1b9$var$StatusWorkflowCancelledIcon;

});

parcelRegister("aKpkp", function(module, exports) {
/**
 * Returns true if the given text node's sole mark is a `link` mark whose href
 * matches the node's text content exactly (i.e. the link label IS the URL).
 * Or if the text content is a parseable URL.
 */ const $6adb54a1a94dcf00$var$isUrlOnlyLinkTextNode = (node)=>{
    if (!node.isText) return false;
    if (node.marks.length !== 1 || node.marks[0].type.name !== 'link') return false;
    const href = node.marks[0].attrs?.href ?? '';
    // Check if the text content is a URL
    const textOfNode = node.text ?? '';
    const parseableUrl = $6adb54a1a94dcf00$var$isParseableUrl(textOfNode);
    return node.text === href || parseableUrl;
};
/**
 * Checks if a given string is parseable as a URL.
 */ const $6adb54a1a94dcf00$var$isParseableUrl = (text)=>{
    if (typeof URL?.canParse === 'function') return URL.canParse(text);
    // Fallback for older environments
    try {
        new URL(text);
        return true;
    } catch (e) {
        return false;
    }
};
const $6adb54a1a94dcf00$var$isSupportedCard = (node)=>node.type.name === 'inlineCard' || node.type.name === 'blockCard' || node.type.name === 'embedCard';
const $6adb54a1a94dcf00$var$transparentSingleChildContainerNodeTypes = new Set([
    'paragraph',
    'listItem',
    'bulletList',
    'orderedList'
]);
/**
 * Returns the children of a Fragment, filtering out whitespace-only text nodes.
 * This handles trailing/leading spaces that browsers sometimes include when
 * copying a link (e.g. `<a href="...">URL</a> `).
 */ const $6adb54a1a94dcf00$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
/**
 * Returns true when the fragment contains exactly one meaningful leaf that
 * satisfies `isSupportedLeaf`.
 *
 * Transparent single-child containers (paragraph, listItem, bulletList, and
 * orderedList) are traversed recursively. Whitespace-only sibling text nodes
 * are ignored at each level.
 */ const $6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf = (fragment, isSupportedLeaf)=>{
    const children = $6adb54a1a94dcf00$var$significantChildren(fragment);
    if (children.length !== 1) return false;
    const [child] = children;
    if (isSupportedLeaf(child)) return true;
    if (!$6adb54a1a94dcf00$var$transparentSingleChildContainerNodeTypes.has(child.type.name)) return false;
    return $6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(child.content, isSupportedLeaf);
};
const $6adb54a1a94dcf00$var$isSingleSmartLinkCard = (slice)=>$6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(slice.content, $6adb54a1a94dcf00$var$isSupportedCard);
const $6adb54a1a94dcf00$var$isSingleBareLink = (slice)=>$6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(slice.content, $6adb54a1a94dcf00$var$isUrlOnlyLinkTextNode);
const $6adb54a1a94dcf00$export$b9183df0a8583e6b = (slice)=>{
    if (!slice || !slice.content.size) // No rich-text slice → plain text paste, not a single link in the relevant sense
    return true;
    return !$6adb54a1a94dcf00$var$isSingleBareLink(slice) && !$6adb54a1a94dcf00$var$isSingleSmartLinkCard(slice);
};
module.exports["isNotSingleLink"] = $6adb54a1a94dcf00$export$b9183df0a8583e6b;

});

parcelRegister("9HWym", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $57Rmq = parcelRequire("57Rmq");


var $ieeJu = parcelRequire("ieeJu");


var $ijJX5 = parcelRequire("ijJX5");


var $SlYRR = parcelRequire("SlYRR");

const $b6f82fec0791dd8e$export$4a66a44681ab4c77 = 'drop-target-decoration';
const $b6f82fec0791dd8e$export$eac9eb77d42744c8 = 'drag-handle';
const $b6f82fec0791dd8e$export$ab0e97a1d4f97633 = 'node-decoration';
const $b6f82fec0791dd8e$export$4a19606d812406a7 = 100;
const $b6f82fec0791dd8e$export$20dcf6d6c6a1b068 = (node)=>{
    const handleId = $b6f82fec0791dd8e$var$ObjHash.getForNode(node);
    return `--node-anchor-${node.type.name}-${handleId}`;
};
const $b6f82fec0791dd8e$var$getSubType = (node)=>{
    if (node.attrs.level) return `-${node.attrs.level}`;
    if ((0, $SlYRR.isFontSizeMarkActive)(node)) return '-small';
    return '';
};
const $b6f82fec0791dd8e$export$b0da2ac7a61aa72c = (node)=>{
    const subType = $b6f82fec0791dd8e$var$getSubType(node);
    const typeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(node.type) : node.type.name;
    return typeName + subType;
};
class $b6f82fec0791dd8e$var$ObjHash {
    static getForNode(node) {
        if (this.caching.has(node)) return this.caching.get(node);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const uniqueId = (0, $03RpJ.default)();
        this.caching.set(node, uniqueId);
        return uniqueId;
    }
}
$b6f82fec0791dd8e$var$ObjHash.caching = new WeakMap();
const $b6f82fec0791dd8e$export$ad2994468d2cac1a = (nodeViewPortalProviderAPI, selector, key)=>{
    // Removing decorations manually instead of using native destroy function in prosemirror API
    // as it was more responsive and causes less re-rendering
    const decorationsToRemove = document.querySelectorAll(`[${selector}="true"]`);
    decorationsToRemove.forEach((el)=>{
        (0, $ijJX5.unmountFromMountPoint)(el);
    });
};
module.exports["TYPE_DROP_TARGET_DEC"] = $b6f82fec0791dd8e$export$4a66a44681ab4c77;
module.exports["TYPE_HANDLE_DEC"] = $b6f82fec0791dd8e$export$eac9eb77d42744c8;
module.exports["TYPE_NODE_DEC"] = $b6f82fec0791dd8e$export$ab0e97a1d4f97633;
module.exports["NESTED_DEPTH"] = $b6f82fec0791dd8e$export$4a19606d812406a7;
module.exports["getNodeAnchor"] = $b6f82fec0791dd8e$export$20dcf6d6c6a1b068;
module.exports["getNodeTypeWithLevel"] = $b6f82fec0791dd8e$export$b0da2ac7a61aa72c;
module.exports["unmountDecorations"] = $b6f82fec0791dd8e$export$ad2994468d2cac1a;

});

parcelRegister("j28nv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $8nvEM = parcelRequire("8nvEM");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $hTjcC = parcelRequire("hTjcC");


var $1uWpr = parcelRequire("1uWpr");


var $9HWym = parcelRequire("9HWym");


var $ijJX5 = parcelRequire("ijJX5");


var $a2W6S = parcelRequire("a2W6S");

const $a198263af814c63a$export$cfa5d510bf083f43 = 'active-drag-handle-node';
const $a198263af814c63a$export$4a4d976428c4c181 = (pos, nodeSize)=>(0, $8nvEM.Decoration).node(pos, pos + nodeSize, {
        [(0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR)]: 'true'
    }, {
        type: $a198263af814c63a$export$cfa5d510bf083f43
    });
const $a198263af814c63a$export$88c77bebe4a56da8 = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $a198263af814c63a$export$cfa5d510bf083f43);
const $a198263af814c63a$export$613641ee4757989 = ()=>{
    const anchorName = `--node-anchor-paragraph-0`;
    const style = `anchor-name: ${anchorName}; margin-top: 0px;`;
    return (0, $8nvEM.Decoration).node(0, 2, {
        style: style,
        ['data-drag-handler-anchor-name']: anchorName
    }, {
        type: (0, $9HWym.TYPE_NODE_DEC)
    });
};
const $a198263af814c63a$export$3ec2b0df4b056a96 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $9HWym.TYPE_HANDLE_DEC));
};
const $a198263af814c63a$export$38a5c9b9faf26cd8 = ({ api: api, formatMessage: formatMessage, pos: pos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, handleOptions: handleOptions, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    (0, $9HWym.unmountDecorations)(nodeViewPortalProviderAPI, 'data-blocks-drag-handle-container', 'data-blocks-drag-handle-key');
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $03RpJ.default)();
    const widgetSpec = (0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -1,
        type: (0, $9HWym.TYPE_HANDLE_DEC),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $9HWym.TYPE_HANDLE_DEC}-${(0, $03RpJ.default)()}`,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $a2W6S.getMatchingBlockMarks)(editorState, pos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ])
    } : {
        side: -1,
        type: (0, $9HWym.TYPE_HANDLE_DEC),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $9HWym.TYPE_HANDLE_DEC}-${(0, $03RpJ.default)()}`,
        marks: (0, $a2W6S.getMatchingBlockMarks)(editorState, pos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ])
    };
    return (0, $8nvEM.Decoration).widget(pos, (view, getPosUnsafe)=>{
        const element = document.createElement('span');
        // inline decoration causes focus issues when refocusing Editor into first line
        element.style.display = 'block';
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) element.setAttribute('data-blocks-decorator-widget', 'true');
        element.setAttribute('data-testid', 'block-ctrl-decorator-widget');
        element.setAttribute('data-blocks-drag-handle-container', 'true');
        element.setAttribute('data-blocks-drag-handle-key', key);
        let isTopLevelNode = true;
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch  {
                // Ignore errors from getPosUnsafe
                return undefined;
            }
        };
        const newPos = getPos();
        if (typeof newPos === 'number') {
            const $pos = view.state.doc.resolve(newPos);
            isTopLevelNode = $pos?.parent.type.name === 'doc';
        }
        /*
     * We disable mouseover event to fix flickering issue on hover
     * However, the tooltip for nested drag handle is no long working.
     */ if (newPos === undefined || !isTopLevelNode) element.onmouseover = (e)=>{
            e.stopPropagation();
        };
        // There are times when global clear: "both" styles are applied to this decoration causing jumpiness
        // due to margins applied to other nodes eg. Headings
        element.style.clear = 'unset';
        // temporarily re-instating ReactDOM.render to fix drag handle focus issue, fix to
        // follow via ED-26546
        // previous under platform_editor_react18_plugin_portalprovider
        // 	nodeViewPortalProviderAPI.render(
        // 		() =>
        // 			createElement(DragHandle, {
        // 				view,
        // 				api,
        // 				formatMessage,
        // 				getPos,
        // 				anchorName,
        // 				nodeType,
        // 				handleOptions,
        // 				isTopLevelNode,
        // 			}),
        // 		element,
        // 		key,
        // 	);
        if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) (0, $ijJX5.renderToMountPoint)((0, $cozmU.createElement)((0, $1uWpr.DragHandleWithVisibility), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        else (0, $ijJX5.renderToMountPoint)((0, $cozmU.createElement)((0, $1uWpr.DragHandle), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        return element;
    }, widgetSpec);
};
module.exports["TYPE_ACTIVE_HANDLE_DEC"] = $a198263af814c63a$export$cfa5d510bf083f43;
module.exports["createActiveDragHandleNodeDecoration"] = $a198263af814c63a$export$4a4d976428c4c181;
module.exports["findActiveDragHandleNodeDec"] = $a198263af814c63a$export$88c77bebe4a56da8;
module.exports["emptyParagraphNodeDecorations"] = $a198263af814c63a$export$613641ee4757989;
module.exports["findHandleDec"] = $a198263af814c63a$export$3ec2b0df4b056a96;
module.exports["dragHandleDecoration"] = $a198263af814c63a$export$38a5c9b9faf26cd8;

});

parcelRegister("djgGr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $03RpJ = parcelRequire("03RpJ");


var $iQ6F7 = parcelRequire("iQ6F7");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $8nvEM = parcelRequire("8nvEM");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $hTjcC = parcelRequire("hTjcC");


var $64pwY = parcelRequire("64pwY");


var $ddJ8T = parcelRequire("ddJ8T");


var $9HWym = parcelRequire("9HWym");


var $icvkv = parcelRequire("icvkv");


var $SlYRR = parcelRequire("SlYRR");

const $3ceda6f169422654$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'layoutColumn',
    'listItem',
    'caption'
];
const $3ceda6f169422654$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
const $3ceda6f169422654$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $3ceda6f169422654$var$getParentTypesWithEndDropTarget = (0, $dOBRD.default)(()=>[
        ...$3ceda6f169422654$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : [],
        'bodiedSyncBlock'
    ]);
const $3ceda6f169422654$var$shouldDescend = (node)=>{
    return ![
        'mediaSingle',
        'paragraph',
        'heading'
    ].includes(node.type.name);
};
const $3ceda6f169422654$var$getNodeMargins = (node)=>{
    if (!node) return (0, $hTjcC.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.nodeMargins)[`heading${node.attrs.level}`] || (0, $hTjcC.nodeMargins)['default'];
    return (0, $hTjcC.nodeMargins)[nodeTypeName] || (0, $hTjcC.nodeMargins)['default'];
};
const $3ceda6f169422654$var$shouldCollapseMargin = (prevNode, nextNode)=>{
    if ((prevNode?.type.name === 'mediaSingle' || nextNode?.type.name === 'mediaSingle') && prevNode?.type.name !== nextNode?.type.name) return false;
    return true;
};
const $3ceda6f169422654$var$getGapAndOffset = (prevNode, nextNode, parentNode)=>{
    if (!prevNode && nextNode) {
        // first node - adjust for bodied containers
        let offset = 0;
        if (parentNode?.type.name === 'bodiedSyncBlock') offset += 4;
        return {
            gap: 0,
            offset: offset
        };
    } else if (prevNode && !nextNode) {
        // last node - adjust for bodied containers
        let offset = 0;
        if (parentNode?.type.name === 'bodiedSyncBlock') offset -= 4;
        return {
            gap: 0,
            offset: offset
        };
    }
    const top = $3ceda6f169422654$var$getNodeMargins(nextNode).top || 4;
    const bottom = $3ceda6f169422654$var$getNodeMargins(prevNode).bottom || 4;
    const gap = $3ceda6f169422654$var$shouldCollapseMargin(prevNode, nextNode) ? Math.max(top, bottom) : top + bottom;
    let offset = top - gap / 2;
    if (prevNode?.type.name === 'mediaSingle' && nextNode?.type.name === 'mediaSingle') offset = -offset;
    else if (prevNode?.type.name && [
        'tableCell',
        'tableHeader'
    ].includes(prevNode?.type.name)) offset = 0;
    return {
        gap: gap,
        offset: offset
    };
};
const $3ceda6f169422654$export$99bd791313c07808 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $9HWym.TYPE_DROP_TARGET_DEC));
};
const $3ceda6f169422654$export$fc632359c395fc7 = (pos, props, nodeViewPortalProviderAPI, side, anchorRectCache, isSameLayout)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $03RpJ.default)();
    return (0, $8nvEM.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const { gap: gap, offset: offset } = $3ceda6f169422654$var$getGapAndOffset(props.prevNode, props.nextNode, props.parentNode);
        element.style.setProperty((0, $64pwY.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $64pwY.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP), `${gap}px`);
        element.style.setProperty('display', 'block');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $64pwY.DropTarget), {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache,
                isSameLayout: isSameLayout
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $9HWym.TYPE_DROP_TARGET_DEC),
        side: side,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $3ceda6f169422654$export$eb62fe530f14234e = (pos, props, nodeViewPortalProviderAPI, anchorRectCache)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $03RpJ.default)();
    return (0, $8nvEM.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const DropTargetLayoutComponent = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? (0, $ddJ8T.DropTargetLayoutNativeAnchorSupport) : (0, $ddJ8T.DropTargetLayout);
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)(DropTargetLayoutComponent, {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $9HWym.TYPE_DROP_TARGET_DEC),
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $3ceda6f169422654$export$248c2f3619ca4fdf = (newState, api, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache, from, to)=>{
    const decs = [];
    const POS_END_OF_DOC = newState.doc.nodeSize - 2;
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > POS_END_OF_DOC ? POS_END_OF_DOC : to;
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && newState.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    anchorRectCache?.clear();
    const prevNodeStack = [];
    const popNodeStack = (depth)=>{
        let result;
        const toDepth = Math.max(depth, 0);
        while(prevNodeStack.length > toDepth)result = prevNodeStack.pop();
        return result;
    };
    const pushNodeStack = (node, depth)=>{
        popNodeStack(depth);
        prevNodeStack.push(node);
    };
    const isAdvancedLayoutsPreRelease2 = (0, $jkcNT.editorExperiment)('advanced_layouts', true);
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = newState.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const parentTypesWithEndDropTarget = $3ceda6f169422654$var$getParentTypesWithEndDropTarget();
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, index)=>{
        let depth = 0;
        // drop target deco at the end position
        let endPos;
        const $pos = newState.doc.resolve(pos);
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, $pos);
        depth = $pos.depth;
        if (isAdvancedLayoutsPreRelease2) {
            if (activeNode?.pos === pos && activeNode.nodeType !== 'layoutColumn') return false;
            if (node.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 && // Not the first node
            (parent?.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout)) // Add drop target for layout columns
            decs.push($3ceda6f169422654$export$eb62fe530f14234e(pos, {
                api: api,
                parent: parent,
                formatMessage: formatMessage
            }, nodeViewPortalProviderAPI, anchorRectCache));
        }
        if (node.isInline || !parent || $3ceda6f169422654$var$DISABLE_CHILD_DROP_TARGET.includes(parent.type.name)) {
            pushNodeStack(node, depth);
            return false;
        }
        if ($3ceda6f169422654$var$IGNORE_NODES.includes(node.type.name)) {
            pushNodeStack(node, depth);
            return $3ceda6f169422654$var$shouldDescend(node); //skip over, don't consider it a valid depth
        }
        // validate all the nodes in the selection instead of just the handle node
        const selectionSlice = newState.doc.slice(selectionFrom, selectionTo, false);
        const selectionSliceChildCount = selectionSlice.content.childCount;
        let canDropSingleNode = true;
        let canDropMultipleNodes = true;
        // when there is only one node in the slice, use the same logic as when multi select is not on
        if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $SlYRR.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $pos);
        else canDropSingleNode = !!(activePMNode && (0, $SlYRR.canMoveNodeToIndex)(parent, index, activePMNode, $pos, node));
        if (!canDropMultipleNodes || !canDropSingleNode) {
            pushNodeStack(node, depth);
            return false; //not valid pos, so nested not valid either
        }
        const parentTypeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(parent.type) : parent.type.name;
        if (parent.lastChild === node && !(0, $2w79Z.isEmptyParagraph)(node) && parentTypesWithEndDropTarget.includes(parentTypeName)) endPos = pos + node.nodeSize;
        const previousNode = popNodeStack(depth); // created scoped variable
        // only table and layout need to render full height drop target
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $2w79Z.isEmptyParagraph)(node);
        decs.push($3ceda6f169422654$export$fc632359c395fc7(pos, {
            api: api,
            prevNode: previousNode,
            nextNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        if (endPos !== undefined) decs.push($3ceda6f169422654$export$fc632359c395fc7(endPos, {
            api: api,
            prevNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'remainingHeight'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache));
        pushNodeStack(node, depth);
        return depth < (0, $9HWym.NESTED_DEPTH) && $3ceda6f169422654$var$shouldDescend(node);
    });
    if (docTo === POS_END_OF_DOC) decs.push($3ceda6f169422654$export$fc632359c395fc7(POS_END_OF_DOC, {
        api: api,
        formatMessage: formatMessage,
        prevNode: newState.doc.lastChild || undefined,
        parentNode: newState.doc
    }, nodeViewPortalProviderAPI, undefined, anchorRectCache));
    return decs;
};
module.exports["findDropTargetDecs"] = $3ceda6f169422654$export$99bd791313c07808;
module.exports["createDropTargetDecoration"] = $3ceda6f169422654$export$fc632359c395fc7;
module.exports["createLayoutDropTargetDecoration"] = $3ceda6f169422654$export$eb62fe530f14234e;
module.exports["dropTargetDecorations"] = $3ceda6f169422654$export$248c2f3619ca4fdf;

});

parcelRegister("g8ZIt", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $iQ6F7 = parcelRequire("iQ6F7");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $bjg0G = parcelRequire("bjg0G");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $djgGr = parcelRequire("djgGr");


var $cX57A = parcelRequire("cX57A");


var $d1Uph = parcelRequire("d1Uph");


var $icvkv = parcelRequire("icvkv");


var $SlYRR = parcelRequire("SlYRR");

/**
 * List of parent node types that can have child nodes
 */ const $4da6fa97a78aba31$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
/**
 * List of node types that does not allow drop targets at before or after the node.
 */ const $4da6fa97a78aba31$var$NODE_WITH_NO_PARENT_POS = [
    'tableCell',
    'tableHeader',
    'layoutColumn'
];
const $4da6fa97a78aba31$var$UNSUPPORTED_LAYOUT_CONTENT = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $4da6fa97a78aba31$var$getContainerNodeTypes = (0, $dOBRD.default)(()=>[
        ...$4da6fa97a78aba31$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : [],
        'bodiedSyncBlock'
    ]);
const $4da6fa97a78aba31$var$isContainerNode = (node)=>{
    const nodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(node.type) : node.type.name;
    return $4da6fa97a78aba31$var$getContainerNodeTypes().includes(nodeName);
};
const $4da6fa97a78aba31$export$40c317c5c02ece25 = (state, node, parent, index, $toPos, activeNode)=>{
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = state.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const selectionSlice = state.doc.slice(selectionFrom, selectionTo, false);
    const selectionSliceChildCount = selectionSlice.content.childCount;
    let canDropSingleNode = true;
    let canDropMultipleNodes = true;
    // when there is only one node in the slice, use the same logic as when multi select is not on
    if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $SlYRR.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $toPos);
    else canDropSingleNode = !!(activePMNode && (0, $SlYRR.canMoveNodeToIndex)(parent, index, activePMNode, $toPos, node));
    if (!canDropMultipleNodes || !canDropSingleNode) return false;
    return true;
};
const $4da6fa97a78aba31$export$181f339130769cb6 = (activeDropTargetNode, state, api, existingDecs, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache)=>{
    const decsToAdd = [];
    let decsToRemove = existingDecs.filter((dec)=>!!dec);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const $toPos = state.doc.resolve(activeDropTargetNode.pos);
    const existingDecsPos = decsToRemove.map((dec)=>dec.from);
    const { parent: parent, index: index, node: node, pos: pos, before: before, after: after, depth: depth } = (0, $cX57A.findSurroundingNodes)(state, $toPos, activeDropTargetNode.nodeTypeName);
    /**
   * If the current node is a container node, we show the drop targets
   * above the first child and below the last child.
   */ if ($4da6fa97a78aba31$var$isContainerNode(node)) {
        const isEmptyContainer = node.childCount === 0 || node.childCount === 1 && (0, $2w79Z.isEmptyParagraph)(node.firstChild);
        // can move to before first child
        const posBeforeFirstChild = pos + 1; // +1 to get the position of the first child
        if (node.firstChild && $4da6fa97a78aba31$export$40c317c5c02ece25(state, node.firstChild, node, 0, state.doc.resolve(posBeforeFirstChild), activeNode)) {
            if (existingDecsPos.includes(posBeforeFirstChild)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posBeforeFirstChild);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posBeforeFirstChild, {
                api: api,
                prevNode: undefined,
                nextNode: node.firstChild,
                parentNode: node,
                formatMessage: formatMessage,
                dropTargetStyle: isEmptyContainer ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, 1, anchorRectCache));
        }
        // can move to after last child
        // if the node is empty, we don't show the drop target at the end of the node
        if (!isEmptyContainer) {
            const posAfterLastChild = pos + node.nodeSize - 1; // -1 to get the position after last child
            if (node.lastChild && $4da6fa97a78aba31$export$40c317c5c02ece25(state, node.lastChild, node, node.childCount - 1, state.doc.resolve(posAfterLastChild), // -1 to get the position after last child
            activeNode)) {
                if (existingDecsPos.includes(posAfterLastChild)) // if the decoration already exists, we don't add it again.
                decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterLastChild);
                else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posAfterLastChild, {
                    api: api,
                    prevNode: node.lastChild,
                    nextNode: undefined,
                    parentNode: node,
                    formatMessage: formatMessage,
                    dropTargetStyle: 'remainingHeight'
                }, nodeViewPortalProviderAPI, -1, anchorRectCache));
            }
        }
    }
    /**
   * Create drop target before and after the current node
   */ if (!$4da6fa97a78aba31$var$NODE_WITH_NO_PARENT_POS.includes(node.type.name)) {
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, $toPos);
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $2w79Z.isEmptyParagraph)(node);
        if ($4da6fa97a78aba31$export$40c317c5c02ece25(state, node, parent, index, $toPos, activeNode)) {
            if (existingDecsPos.includes(pos)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== pos);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(pos, {
                api: api,
                prevNode: before || undefined,
                nextNode: node,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
        // if the node is a container node, we show the drop target after the node
        const posAfterNode = pos + node.nodeSize;
        if ($4da6fa97a78aba31$export$40c317c5c02ece25(state, node, parent, index + 1, state.doc.resolve(posAfterNode), activeNode)) {
            if (existingDecsPos.includes(posAfterNode)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterNode);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posAfterNode, {
                api: api,
                prevNode: node,
                nextNode: after || undefined,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
    }
    let rootNodeWithPos = {
        node: node,
        pos: pos
    };
    // if the current node is not a top level node, we create one for advanced layout drop targets
    if (depth > 1) {
        const root = (0, $cX57A.findSurroundingNodes)(state, state.doc.resolve($toPos.before(2)));
        if (existingDecsPos.includes(root.pos)) // if the decoration already exists, we don't add it again.
        decsToRemove = decsToRemove.filter((dec)=>dec.from !== root.pos);
        else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(root.pos, {
            api: api,
            prevNode: root.before || undefined,
            nextNode: root.node,
            parentNode: state.doc || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, false));
        rootNodeWithPos = {
            node: root.node,
            pos: root.pos
        };
    }
    let anchorEmitNodeWithPos = rootNodeWithPos;
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
        const schema = rootNodeWithPos.node.type.schema;
        const { layoutSection: layoutSection } = schema.nodes;
        const isLayoutSectionChildOfRoot = (0, $bjg0G.findChildrenByType)(rootNodeWithPos.node, layoutSection, false).length > 0;
        if (isLayoutSectionChildOfRoot) {
            // if node has layoutSection as a child, get the layoutSection node and pos
            for(let ancestorDepth = $toPos.depth; ancestorDepth >= 1; ancestorDepth--)if ($toPos.node(ancestorDepth).type.name === 'layoutSection') {
                anchorEmitNodeWithPos = {
                    node: $toPos.node(ancestorDepth),
                    pos: $toPos.before(ancestorDepth)
                };
                break;
            }
        } else anchorEmitNodeWithPos = rootNodeWithPos;
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, state.doc.resolve(anchorEmitNodeWithPos.pos));
        const hasUnsupportedContent = $4da6fa97a78aba31$var$UNSUPPORTED_LAYOUT_CONTENT.includes(activeNode?.nodeType || '');
        if (anchorEmitNodeWithPos.node.type.name === 'layoutSection' && !hasUnsupportedContent) {
            const layoutSectionNode = anchorEmitNodeWithPos.node;
            if (layoutSectionNode.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout) layoutSectionNode.descendants((childNode, childPos, parent, index)=>{
                if (childNode.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 // Not the first node
                ) {
                    const currentPos = anchorEmitNodeWithPos.pos + childPos + 1;
                    if (existingDecsPos.includes(currentPos)) // if the decoration already exists, we don't add it again.
                    decsToRemove = decsToRemove.filter((dec)=>dec.from !== currentPos);
                    else decsToAdd.push((0, $djgGr.createLayoutDropTargetDecoration)(anchorEmitNodeWithPos.pos + childPos + 1, {
                        api: api,
                        parent: parent,
                        formatMessage: formatMessage
                    }, nodeViewPortalProviderAPI, anchorRectCache));
                }
                return false;
            });
        }
    }
    (0, $d1Uph.defaultActiveAnchorTracker).emit((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? api.core.actions.getAnchorIdForNode(anchorEmitNodeWithPos.node, anchorEmitNodeWithPos.pos) || '' : (0, $9HWym.getNodeAnchor)(anchorEmitNodeWithPos.node));
    return {
        decsToAdd: decsToAdd,
        decsToRemove: decsToRemove
    };
};
module.exports["getActiveDropTargetDecorations"] = $4da6fa97a78aba31$export$181f339130769cb6;

});

parcelRegister("hYw7t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $8nvEM = parcelRequire("8nvEM");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $hTjcC = parcelRequire("hTjcC");


var $2ZDdD = parcelRequire("2ZDdD");


var $a2W6S = parcelRequire("a2W6S");

const $d34f0626fb94450e$var$TYPE_QUICK_INSERT = 'INSERT_BUTTON';
const $d34f0626fb94450e$export$706c4878577996f2 = 'active-quick-insert-node';
const $d34f0626fb94450e$export$a6ab3402831bd7d8 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $d34f0626fb94450e$var$TYPE_QUICK_INSERT);
};
const $d34f0626fb94450e$export$5b9210fd80ac3dfb = (pos, nodeSize)=>(0, $8nvEM.Decoration).node(pos, pos + nodeSize, {
        [(0, $hTjcC.ACTIVE_QUICK_INSERT_ATTR)]: 'true'
    }, {
        type: $d34f0626fb94450e$export$706c4878577996f2
    });
const $d34f0626fb94450e$export$678e19285f8625bb = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $d34f0626fb94450e$export$706c4878577996f2);
const $d34f0626fb94450e$export$ab399427af69a61 = ({ api: api, formatMessage: formatMessage, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $03RpJ.default)();
    const cleanupCallbacks = [];
    const widgetSpec = (0, $jkcNT.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -2,
        type: $d34f0626fb94450e$var$TYPE_QUICK_INSERT,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $a2W6S.getMatchingBlockMarks)(editorState, rootPos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]),
        destroy: (_)=>{
            nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    } : {
        side: -2,
        type: $d34f0626fb94450e$var$TYPE_QUICK_INSERT,
        destroy: (_)=>{
            nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    };
    return (0, $8nvEM.Decoration).widget(rootPos, (view, getPos)=>{
        const element = document.createElement('span');
        // inline decoration causes cursor disappear when focusing editor at the first line (e.g. press Tab when title is focused)
        element.style.display = 'block';
        // make sure it does not interfere with elements floating next to each other e.g. paragraph next to image with wrap-right
        element.style.clear = 'unset';
        element.contentEditable = 'false';
        element.setAttribute('data-blocks-quick-insert-container', 'true');
        if ((0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) element.setAttribute('data-blocks-quick-insert-button', 'true');
        element.setAttribute('data-testid', 'block-ctrl-quick-insert-button');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $2ZDdD.QuickInsertWithVisibility), {
                api: api,
                getPos: getPos,
                formatMessage: formatMessage,
                view: view,
                nodeType: nodeType,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, widgetSpec);
};
module.exports["TYPE_ACTIVE_QUICK_INSERT_NODE"] = $d34f0626fb94450e$export$706c4878577996f2;
module.exports["findQuickInsertInsertButtonDecoration"] = $d34f0626fb94450e$export$a6ab3402831bd7d8;
module.exports["createActiveQuickInsertNodeDecoration"] = $d34f0626fb94450e$export$5b9210fd80ac3dfb;
module.exports["findActiveQuickInsertNodeDec"] = $d34f0626fb94450e$export$678e19285f8625bb;
module.exports["quickInsertButtonDecoration"] = $d34f0626fb94450e$export$ab399427af69a61;

});

parcelRegister("9UAss", function(module, exports) {

var $kAPZe = parcelRequire("kAPZe");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");

const $e5dceea5395d1c13$export$b4a93e0b711d8f7 = (api)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        if (!view.editable) {
            const targetPos = view.posAtDOM(event.target, 0);
            // always fetch top level position for mouseDown to avoid drag handle positions being incorrect
            const rootPos = view.state.doc.resolve(targetPos).before(1);
            const rootNode = view.state.doc.nodeAt(rootPos);
            if (!rootNode) return false;
            if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                const anchorName = api?.core.actions.getAnchorIdForNode(rootNode, rootPos);
                // don't show the handles if we can't find an anchor
                if (!anchorName) return false;
                api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, anchorName, rootNode.type.name ?? '', undefined, rootPos, anchorName, rootNode.type.name ?? ''));
            } else api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, '', rootNode.type.name ?? '', undefined, rootPos, '', rootNode.type.name ?? ''));
        } else {
            const isDragHandle = event.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR)) !== null;
            api?.core.actions.execute(({ tr: tr })=>{
                api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle)({
                    tr: tr
                });
                /**
				 * When block menu is enabled, reset intent back to 'default' as editor-plugin-block-menu sets the user intent to 'blockMenuOpen', and setting here
				 * causes flickering as this runs before editor-plugin-block-menu.
				 */ // if target is drag handle, block menu will be opened
                if (!isDragHandle) api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr;
            });
        }
        return false;
    };
module.exports["handleMouseDown"] = $e5dceea5395d1c13$export$b4a93e0b711d8f7;

});

parcelRegister("h7MdN", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $lVAkE = parcelRequire("lVAkE");


var $g6uqx = parcelRequire("g6uqx");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fKt2m = parcelRequire("fKt2m");


var $rOV4B = parcelRequire("rOV4B");


var $6FQH1 = parcelRequire("6FQH1");

const $022924a8fbeb2a1a$var$isEmptyNestedParagraphOrHeading = (target)=>{
    if (target instanceof HTMLHeadingElement || target instanceof HTMLParagraphElement) return !target.parentElement?.classList.contains('ProseMirror') && target.textContent === '';
    return false;
};
const $022924a8fbeb2a1a$var$getNodeSelector = (ignoreNodes, ignoreNodeDescendants)=>{
    const baseSelector = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`;
    if (ignoreNodes.length === 0 && ignoreNodeDescendants.length === 0) return baseSelector;
    const ignoreNodeSelectorList = ignoreNodes.map((node)=>`[data-prosemirror-node-name="${node}"]`);
    const ignoreNodeDescendantsSelectorList = ignoreNodeDescendants.map((node)=>{
        if (node === 'table') // Special case for table to exclude its direct descendants
        return [
            `[data-prosemirror-node-name="tableCell"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableCell"] > *:not([data-node-anchor]) > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > *:not([data-node-anchor]) > [data-node-anchor]`
        ];
        return `[data-prosemirror-node-name="${node}"] [data-node-anchor]`;
    });
    const ignoreSelector = [
        ...ignoreNodeSelectorList,
        ...ignoreNodeDescendantsSelectorList.flat(),
        '[data-prosemirror-node-inline="true"]'
    ].join(', ');
    return `${baseSelector}:not(${ignoreSelector})`;
};
const $022924a8fbeb2a1a$var$getDefaultNodeSelector = (0, $dOBRD.default)(()=>{
    // we don't show handler for node nested in table
    return $022924a8fbeb2a1a$var$getNodeSelector([
        ...(0, $rOV4B.IGNORE_NODES_NEXT),
        'media'
    ], [
        ...(0, $rOV4B.IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT),
        'table'
    ]);
});
/**
 * `panel_c1` is the nestable panel variant and renders the same DOM as `panel`, so it must
 * suppress block controls on its first child too. No-exposure check as this runs on every
 * mouseover.
 */ const $022924a8fbeb2a1a$var$isPanelNodeTypeName = (nodeTypeName)=>{
    if (nodeTypeName === 'panel') return true;
    return nodeTypeName === 'panel_c1' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_controls_reliable_anchor_patch_1');
};
// Block marks (e.g. font-size) wrap paragraphs in an extra div, making parentRootElement
// the mark wrapper instead of the panel content container. When that happens, recalculate
// the index relative to the panel content so the first-child check stays accurate.
const $022924a8fbeb2a1a$var$getBlockMarkPanelIndexAdjustment = (parentRootElement, index)=>{
    if (parentRootElement.classList.contains('fabric-editor-block-mark') && parentRootElement.parentElement) return Array.from(parentRootElement.parentElement.childNodes).indexOf(parentRootElement);
    return index;
};
/**
 * If the hovered element is a paragraph adjacent to a wrapped mediaSingle/embedCard,
 * redirect to the media node so only one drag handle shows (ED-26959).
 */ const $022924a8fbeb2a1a$var$redirectParagraphToWrappedMedia = (rootElement, isNativeAnchorSupported)=>{
    const hoveredNodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootElement) : rootElement.getAttribute('data-drag-handler-node-type');
    if (hoveredNodeType !== 'paragraph') return rootElement;
    const isWrappedMediaEmbedSibling = (sibling)=>{
        if (!sibling || !sibling.getAttribute((0, $fKt2m.getAnchorAttrName)())) return false;
        const siblingType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(sibling) : sibling.getAttribute('data-drag-handler-node-type');
        const siblingLayout = sibling.getAttribute('layout') || '';
        return (siblingType === 'mediaSingle' || siblingType === 'embedCard') && [
            'wrap-left',
            'wrap-right'
        ].includes(siblingLayout);
    };
    const prevSibling = rootElement.previousElementSibling;
    const nextSibling = rootElement.nextElementSibling;
    if (prevSibling && isWrappedMediaEmbedSibling(prevSibling)) return prevSibling;
    else if (nextSibling && isWrappedMediaEmbedSibling(nextSibling)) return nextSibling;
    return rootElement;
};
const $022924a8fbeb2a1a$export$321c2da35903b013 = (view, event, api)=>{
    const { isDragging: isDragging, activeNode: activeNode, isMenuOpen: isMenuOpen, menuTriggerBy: originalAnchorName, blockMenuOptions: blockMenuOptions } = api?.blockControls?.sharedState.currentState() || {};
    const { editorDisabled: editorDisabled } = api?.editorDisabled?.sharedState.currentState() || {
        editorDisabled: false
    };
    const editorViewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
    const isViewMode = editorViewMode === 'view';
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // EDITOR-7926: bail out while a diff is on screen (or a suggestion card is open) so hovering
    // doesn't dispatch showDragHandleAt and cause the drag handle to jitter over the diff.
    const currentUserIntent = api?.userIntent?.sharedState.currentState()?.currentUserIntent;
    const isDisplayingDiff = api?.showDiff?.sharedState.currentState()?.isDisplayingChanges ?? false;
    if (isDisplayingDiff || currentUserIntent === 'reviewing') return false;
    // We shouldn't be firing mouse over transactions when the editor is disabled,
    // except in view mode when right-side controls are enabled (show controls on block hover)
    const rightSideControlsEnabled = api?.blockControls?.sharedState.currentState()?.rightSideControlsEnabled ?? false;
    if (editorDisabled && (!isViewMode || !(rightSideControlsEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')))) return false;
    // If the editor view is not in focus when the block menu is open, do not update the drag handle
    if (!view.hasFocus() && isMenuOpen) return false;
    // Most mouseover events don't fire during drag but some can slip through
    // when the drag begins. This prevents those.
    if (isDragging) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isNativeAnchorSupported = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration');
    if (target?.classList?.contains('ProseMirror')) return false;
    let rootElement = target?.closest(isNativeAnchorSupported ? $022924a8fbeb2a1a$var$getDefaultNodeSelector() : `[data-drag-handler-anchor-name]`);
    // Fallback for table nodes in view mode: the table-anchor-names plugin sets data-node-anchor on
    // the first <tr> element.
    // - When platform_editor_native_anchor_with_dnd is disabled, the primary closest() uses
    //   [data-drag-handler-anchor-name] and misses table rows. Try data-node-anchor via closest().
    // - For wide/max breakout tables, hovering in the left/right margin area of the full-viewport-
    //   width breakout wrapper (ak-editor-breakout-mark) sets event.target to the wrapper div, which
    //   has no anchor attribute. Use querySelector to find the [data-node-anchor] descendant inside.
    // Both cases apply only in view mode with right-side remix controls.
    if (!rootElement && isViewMode && rightSideControlsEnabled) rootElement = target?.closest(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`) ?? (target instanceof HTMLElement ? target.querySelector(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`) : null) ?? null;
    // When hovering over the right-edge button (rendered in a portal outside the block), resolve the
    // block from the container's anchor so activeNode stays set and the button remains visible.
    if (!rootElement && rightSideControlsEnabled && (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg')) {
        const rightEdgeContainer = target?.closest('[data-blocks-right-edge-button-container]');
        if (rightEdgeContainer) {
            const anchor = rightEdgeContainer.getAttribute('data-blocks-right-edge-button-anchor');
            if (anchor) rootElement = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${CSS.escape(anchor)}"]`);
        }
    }
    if (rootElement) {
        // We want to exlude handles from showing for empty paragraph and heading nodes
        if ($022924a8fbeb2a1a$var$isEmptyNestedParagraphOrHeading(rootElement)) return false;
        if (rootElement.getAttribute((0, $fKt2m.getTypeNameAttrName)()) === 'media' && (0, $jkcNT.editorExperiment)('advanced_layouts', true) && !isNativeAnchorSupported) {
            rootElement = rootElement.closest(`[${(0, $fKt2m.getAnchorAttrName)()}][${(0, $fKt2m.getTypeNameAttrName)()}="mediaSingle"]`);
            if (!rootElement) return false;
        }
        const parentElement = rootElement.parentElement?.closest(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
        const parentElementType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(parentElement) : parentElement?.getAttribute('data-drag-handler-node-type');
        if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
            // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
            if (parentElement && parentElementType === 'table') rootElement = parentElement;
            else if (parentElement && parentElementType === 'tableRow') {
                const grandparentElement = parentElement?.parentElement?.closest(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
                const grandparentElementType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(grandparentElement) : grandparentElement?.getAttribute('data-drag-handler-node-type');
                if (grandparentElement && grandparentElementType === 'table') rootElement = grandparentElement;
            }
        } else // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
        if (parentElement && parentElementType === 'table') rootElement = parentElement;
        // A wrapped mediaSingle/embedCard and the paragraph(s) it floats next to both have
        // anchor decorations. If the hovered rootElement is a paragraph whose adjacent DOM sibling
        // is a wrapped mediaSingle/embedCard with an anchor, redirect the handle to the media node
        // so only one handle shows (ED-26959).
        // We check previousElementSibling (wrap-left: media precedes text in DOM) and
        // nextElementSibling (wrap-right: media follows text in DOM).
        // This must happen before anchorName is read so the correct node's handle is shown.
        rootElement = $022924a8fbeb2a1a$var$redirectParagraphToWrappedMedia(rootElement, isNativeAnchorSupported);
        let anchorName;
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            anchorName = rootElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
            // don't show handles if we can't find an anchor
            if (!anchorName) return false;
        } else {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorName = rootElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
            // Fallback for table nodes that only have data-node-anchor (not data-drag-handler-anchor-name).
            if (!anchorName) anchorName = rootElement.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME)) ?? anchorName;
        }
        // No need to update handle position if its already there
        if (activeNode?.anchorName === anchorName) return false;
        const parentRootElement = rootElement.parentElement;
        let pos;
        if (parentRootElement) {
            const childNodes = Array.from(parentRootElement.childNodes);
            const index = childNodes.indexOf(rootElement);
            pos = view.posAtDOM(parentRootElement, index);
            const panelIndex = $022924a8fbeb2a1a$var$getBlockMarkPanelIndexAdjustment(parentRootElement, index);
            // We want to exlude handles showing for first element in a Panel, ignoring widgets like gapcursor
            const firstChildIsWidget = parentRootElement?.children[0]?.classList.contains('ProseMirror-widget');
            if (parentElement && $022924a8fbeb2a1a$var$isPanelNodeTypeName(parentElementType) && !parentElement.classList.contains('ak-editor-panel__no-icon') && (panelIndex === 0 || firstChildIsWidget && panelIndex === 1)) return false;
        } else pos = view.posAtDOM(rootElement, 0);
        const targetPos = view.state.doc.resolve(pos).pos;
        let rootAnchorName;
        let rootNodeType;
        let rootPos;
        // platform_editor_controls note: enables quick insert
        if (toolbarFlagsEnabled) {
            rootPos = view.state.doc.resolve(pos).before(1);
            if (targetPos !== rootPos) {
                const rootDOM = view.nodeDOM(rootPos);
                if (rootDOM instanceof HTMLElement) {
                    rootAnchorName = rootDOM.getAttribute((0, $fKt2m.getAnchorAttrName)()) ?? rootDOM.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME)) ?? undefined;
                    rootNodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootDOM) : // Fallback: breakout mark wrappers have no data-drag-handler-node-type;
                    // use data-prosemirror-node-name instead.
                    rootDOM.getAttribute('data-drag-handler-node-type') ?? (0, $fKt2m.getTypeNameFromDom)(rootDOM);
                }
            }
        }
        const nodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootElement) : // Fallback for table nodes: tr has data-prosemirror-node-name but not data-drag-handler-node-type.
        rootElement.getAttribute('data-drag-handler-node-type') ?? (0, $fKt2m.getTypeNameFromDom)(rootElement);
        if (nodeType) {
            // platform_editor_controls note: enables quick insert
            if (toolbarFlagsEnabled) {
                const preservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection;
                const selection = preservedSelection || view.state.selection;
                const isMultipleSelected = selection && (0, $lVAkE.isMultiBlockSelection)(selection);
                // Only execute when selection is not a multi-selection, block menu is open, and menu is opened via keyboard
                // as when it is a multi-selection, the showDragHandleAt command interfere with selection
                // sometimes makes the multi-selection not continous after block menu is opened with keyboard
                if (!(isMultipleSelected && isMenuOpen && blockMenuOptions?.openedViaKeyboard)) api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
            } else api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType));
            if (isMenuOpen && originalAnchorName && api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen') api?.core?.actions.execute(api?.blockControls?.commands.toggleBlockMenu());
        }
    }
};
module.exports["handleMouseOver"] = $022924a8fbeb2a1a$export$321c2da35903b013;

});

parcelRegister("hwVXJ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $9HWym = parcelRequire("9HWym");

const $25915f7f7caa9762$var$OPAQUE_BLOCKS = new Set([
    'table',
    'bulletList',
    'orderedList',
    'taskList',
    'decisionList',
    'mediaSingle'
]);
const $25915f7f7caa9762$var$EXCLUDED_BLOCKS = new Set([
    'listItem',
    'tableRow',
    'tableCell',
    'tableHeader',
    'caption'
]);
const $25915f7f7caa9762$var$isPanelNodeTypeName = (nodeTypeName)=>nodeTypeName === 'panel' || nodeTypeName === 'panel_c1' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_controls_reliable_anchor_patch_1');
const $25915f7f7caa9762$var$redirectParagraphToWrappedMedia = (view, $target, targetPosition)=>{
    const node = view.state.doc.nodeAt(targetPosition);
    if (!node || node.type.name !== 'paragraph') return {
        position: targetPosition,
        node: node
    };
    const index = $target.index();
    for (const siblingIndex of [
        index - 1,
        index + 1
    ]){
        if (siblingIndex < 0 || siblingIndex >= $target.parent.childCount) continue;
        const sibling = $target.parent.child(siblingIndex);
        if ((sibling.type.name === 'mediaSingle' || sibling.type.name === 'embedCard') && (sibling.attrs.layout === 'wrap-left' || sibling.attrs.layout === 'wrap-right')) return {
            position: siblingIndex < index ? targetPosition - sibling.nodeSize : targetPosition + node.nodeSize,
            node: sibling
        };
    }
    return {
        position: targetPosition,
        node: node
    };
};
const $25915f7f7caa9762$export$7ea5585ad1b8fc3 = (view, event, api)=>{
    const controls = api?.blockControls.sharedState.currentState();
    if (!api || controls?.isDragging || !(event.target instanceof Element) || event.target === view.dom) return false;
    const editorDisabled = api.editorDisabled?.sharedState.currentState()?.editorDisabled ?? false;
    const editorViewMode = api.editorViewMode?.sharedState.currentState()?.mode;
    if (editorDisabled && (editorViewMode !== 'view' || !controls?.rightSideControlsEnabled)) return false;
    const isDisplayingDiff = api.showDiff?.sharedState.currentState()?.isDisplayingChanges ?? false;
    const currentUserIntent = api.userIntent?.sharedState.currentState()?.currentUserIntent;
    if (isDisplayingDiff || currentUserIntent === 'reviewing') return false;
    let position;
    try {
        position = view.posAtDOM(event.target, 0);
    } catch  {
        return false;
    }
    const $pos = view.state.doc.resolve(position);
    let targetPosition;
    let opaque = false;
    for(let depth = 1; depth <= $pos.depth; depth++){
        const node = $pos.node(depth);
        if (!node.isBlock || $25915f7f7caa9762$var$EXCLUDED_BLOCKS.has(node.type.name)) continue;
        targetPosition = $pos.before(depth);
        if ($25915f7f7caa9762$var$OPAQUE_BLOCKS.has(node.type.name)) {
            opaque = true;
            break;
        }
    }
    if (!opaque && $pos.nodeAfter?.isBlock && !$25915f7f7caa9762$var$EXCLUDED_BLOCKS.has($pos.nodeAfter.type.name)) {
        // Browser positions over non-editable node chrome can resolve to the first editable child.
        // Keep the ancestor unless that child actually owns the hovered DOM target.
        const nodeAfterDOM = view.nodeDOM(position);
        if (nodeAfterDOM instanceof Element && nodeAfterDOM.contains(event.target)) targetPosition = position;
    }
    if (targetPosition === undefined) return false;
    const initialNode = view.state.doc.nodeAt(targetPosition);
    if (!initialNode) return false;
    const target = $25915f7f7caa9762$var$redirectParagraphToWrappedMedia(view, view.state.doc.resolve(targetPosition), targetPosition);
    targetPosition = target.position;
    const node = target.node;
    if (!node || controls?.activeNode?.pos === targetPosition) return false;
    const $target = view.state.doc.resolve(targetPosition);
    if ($target.depth > 0 && (node.type.name === 'paragraph' || node.type.name === 'heading') && node.content.size === 0) return false;
    const parentNode = $target.parent;
    const parentPosition = $target.depth > 0 ? $target.before($target.depth) : undefined;
    const parentDOM = parentPosition === undefined ? undefined : view.nodeDOM(parentPosition);
    if ($25915f7f7caa9762$var$isPanelNodeTypeName(parentNode.type.name) && !(parentDOM instanceof HTMLElement && parentDOM.classList.contains('ak-editor-panel__no-icon')) && $target.index() === 0) return false;
    const anchors = controls?.surfaceAnchors;
    const anchorName = anchors?.get(targetPosition) ?? api.core.actions.getAnchorIdForNode(node, targetPosition);
    const rootPos = $target.depth > 0 ? $target.before(1) : targetPosition;
    const rootNode = view.state.doc.nodeAt(rootPos);
    const rootAnchorName = anchors?.get(rootPos) ?? (rootNode ? api.core.actions.getAnchorIdForNode(rootNode, rootPos) : undefined);
    if (!anchorName || !rootNode) return false;
    api.core.actions.execute(api.blockControls.commands.showDragHandleAt(targetPosition, anchorName, (0, $9HWym.getNodeTypeWithLevel)(node), undefined, rootPos, rootAnchorName ?? anchorName, (0, $9HWym.getNodeTypeWithLevel)(rootNode)));
    return false;
};
module.exports["handleSparseMouseOver"] = $25915f7f7caa9762$export$7ea5585ad1b8fc3;

});

parcelRegister("jdNrc", function(module, exports) {

var $ldqjS = parcelRequire("ldqjS");


var $1xYQH = parcelRequire("1xYQH");


var $44cyU = parcelRequire("44cyU");


var $b3nYA = parcelRequire("b3nYA");


var $dhlUl = parcelRequire("dhlUl");

function $b8798c8225018002$var$keymapList(api, formatMessage) {
    const keymapList = {};
    if (api) {
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.showElementDragHandle).common, (state, dispatch, view)=>{
            (0, $dhlUl.showDragHandleAtSelection)(api)(state, dispatch, view);
            //we always want to handle this shortcut to prevent default browser special char insert when option + alphabetical key is used
            return true;
        }, keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveUp).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).UP, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveDown).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).DOWN, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveLeft).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).LEFT, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveRight).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).RIGHT, formatMessage), keymapList);
    }
    return keymapList;
}
const $b8798c8225018002$export$2734319938f9e9db = (api, formatMessage)=>(0, $44cyU.keydownHandler)($b8798c8225018002$var$keymapList(api, formatMessage));
module.exports["boundKeydownHandler"] = $b8798c8225018002$export$2734319938f9e9db;

});

parcelRegister("d1Uph", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $cozmU = parcelRequire("cozmU");


var $jkcNT = parcelRequire("jkcNT");

class $0a2dbdea21e1cb22$export$d16dfd16e2bbb367 {
    getActiveAnchor() {
        return this.lastActiveAnchor;
    }
    subscribe(anchorName, callback) {
        if (this.emitter) this.emitter.on(anchorName, callback);
    }
    unsubscribe(anchorName, callback) {
        if (this.emitter) this.emitter.removeListener(anchorName, callback);
    }
    emit(anchorName) {
        if (this.lastActiveAnchor !== anchorName && this.emitter) {
            this.emitter.emit(this.lastActiveAnchor, false);
            this.emitter.emit(anchorName, true);
            this.lastActiveAnchor = anchorName;
        }
    }
    reset() {
        if (this.emitter) {
            // To prevent any potential memory leaks,
            // we set the event emitter to null and then create a new event emitter.
            this.emitter.removeAllListeners();
            this.emitter = null;
            this.emitter = new (0, $eSa5t.EventEmitter)();
        }
    }
    constructor(){
        this.emitter = void 0;
        this.lastActiveAnchor = '';
        this.emitter = new (0, $eSa5t.EventEmitter)();
    }
}
const $0a2dbdea21e1cb22$export$73b394ea452decfd = new $0a2dbdea21e1cb22$export$d16dfd16e2bbb367();
const $0a2dbdea21e1cb22$export$8f015ea2e0aa57d4 = (anchorName, activeAnchorTracker = $0a2dbdea21e1cb22$export$73b394ea452decfd)=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const onActive = (eventIsActive)=>{
        setIsActive(eventIsActive);
    };
    (0, $cozmU.useEffect)(()=>{
        if (activeAnchorTracker && anchorName && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
            activeAnchorTracker.subscribe(anchorName, onActive);
            if (activeAnchorTracker.getActiveAnchor() === anchorName) setIsActive(true);
            const unsubscribe = ()=>{
                activeAnchorTracker.unsubscribe(anchorName, onActive);
            };
            return unsubscribe;
        }
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    const setActive = (0, $cozmU.useCallback)(()=>{
        activeAnchorTracker.emit(anchorName);
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    return [
        isActive,
        setActive
    ];
};
module.exports["defaultActiveAnchorTracker"] = $0a2dbdea21e1cb22$export$73b394ea452decfd;
module.exports["useActiveAnchorTracker"] = $0a2dbdea21e1cb22$export$8f015ea2e0aa57d4;

});

parcelRegister("aHnsS", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

const $a4ec4184fd7ff62b$export$991fd708287269fd = (tr, inputMethod, fromDepth, fromNodeTypes, toDepth, toNodeType, isSameParent, api, hasSelectedMultipleNodes)=>{
    return api?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).MOVED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
        attributes: {
            nodeDepth: fromDepth,
            nodeTypes: fromNodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            destinationNodeDepth: toDepth,
            destinationNodeType: toNodeType,
            isSameParent: isSameParent,
            inputMethod: inputMethod
        }
    })(tr);
};
const $a4ec4184fd7ff62b$export$9d441c3a20655711 = (tr, api, nodeTypes, hasSelectedMultipleNodes, columnCount)=>{
    api?.analytics?.actions?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP,
            nodeTypes: nodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            columnCount: columnCount
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
};
const $a4ec4184fd7ff62b$export$9f4024dd9bfa7336 = (tr, anchor, head)=>{
    const nodeTypes = [];
    const from = Math.min(anchor, head);
    const to = Math.max(anchor, head);
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (pos < from) // ignore parent node
        return true;
        nodeTypes.push(node.type.name);
        // only care about the top level (relatively in the range) nodes
        return false;
    });
    return {
        nodeTypes: [
            ...new Set(nodeTypes)
        ].sort().join(','),
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};
module.exports["attachMoveNodeAnalytics"] = $a4ec4184fd7ff62b$export$991fd708287269fd;
module.exports["fireInsertLayoutAnalytics"] = $a4ec4184fd7ff62b$export$9d441c3a20655711;
module.exports["getMultiSelectAnalyticsAttributes"] = $a4ec4184fd7ff62b$export$9f4024dd9bfa7336;

});

parcelRegister("a4QVD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $fKt2m = parcelRequire("fKt2m");

const $29a324c3089ed6e2$export$2073a24f9367a16f = (0, $dOBRD.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $29a324c3089ed6e2$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll(`[${(0, $fKt2m.getAnchorAttrName)()}]`) || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute((0, $fKt2m.getAnchorAttrName)());
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $29a324c3089ed6e2$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}
module.exports["isAnchorSupported"] = $29a324c3089ed6e2$export$2073a24f9367a16f;
module.exports["AnchorRectCache"] = $29a324c3089ed6e2$export$e1d230f644ff05aa;

});

parcelRegister("bOZni", function(module, exports) {

var $j8XGH = parcelRequire("j8XGH");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7qyBc = parcelRequire("7qyBc");


var $iDrrr = parcelRequire("iDrrr");

const $d4922fc90af8294c$export$eefc237c5f2aa5b9 = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    // To trigger the annotation floating toolbar for non-selectable node, we need to select inline nodes
    // Find the first inline node in the node
    let inlineNodePos = start;
    let foundInlineNode = false;
    let inlineNodeEndPos = 0;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n, pos)=>{
        if (n.isInline) inlineNodeEndPos = pos + n.nodeSize;
        if (n.isInline && !foundInlineNode) {
            inlineNodePos = pos;
            foundInlineNode = true;
        }
        return true;
    });
    return {
        inlineNodePos: inlineNodePos,
        inlineNodeEndPos: inlineNodeEndPos
    };
};
const $d4922fc90af8294c$export$e7d12bf383139ed5 = (tr, start, nodeSize)=>{
    const $startPos = tr.doc.resolve(start);
    let hasCodeBlock = false;
    tr.doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n)=>{
        if ([
            'codeBlock'
        ].includes(n.type.name)) hasCodeBlock = true;
    });
    return hasCodeBlock;
};
const $d4922fc90af8294c$export$2ad544f897362d62 = (doc, selectionEmpty, start)=>{
    if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) return (0, $j8XGH.getNodeSelectionForPos)(doc, start) || false;
    const node = doc.nodeAt(start);
    const nodeName = node?.type.name;
    // if mediaGroup only has a single child, we want to select the child
    if (nodeName === 'mediaGroup' && node?.childCount === 1) {
        const $mediaStartPos = doc.resolve(start + 1);
        return new (0, $kCECX.NodeSelection)($mediaStartPos);
    }
    return new (0, $kCECX.NodeSelection)(doc.resolve(start));
};
const $d4922fc90af8294c$export$ca798a7e6e94638c = (tr, start)=>{
    return $d4922fc90af8294c$export$2ad544f897362d62(tr.doc, tr.selection.empty, start);
};
const $d4922fc90af8294c$export$cbcb4f775d907a9e = (tr, start, nodeType, api)=>{
    if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) return (0, $j8XGH.selectNodeAtPos)(tr, start, nodeType);
    if (nodeType === 'table') {
        tr = (0, $7qyBc.selectTableClosestToPos)(tr, tr.doc.resolve(start + 1));
        return tr;
    }
    const selection = $d4922fc90af8294c$export$ca798a7e6e94638c(tr, start);
    if (selection) tr.setSelection(selection);
    return tr;
};
const $d4922fc90af8294c$export$4b5c09668d5b4e01 = (tr, start, api)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $kCECX.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    let selection;
    // decisionList node is not selectable, but we want to select the whole node not just text
    // blockQuote is selectable, but we want to set cursor at the inline end Pos instead of the gap cursor as this causes jittering post drop
    if (isNodeSelection && node.type.name !== 'blockquote' || node?.type.name === 'decisionList') {
        selection = new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(start + node.nodeSize), (0, $eaLat.Side).RIGHT);
        tr.setSelection(selection);
        return tr;
    }
    // this is a fix for empty paragraph selection - can safely use start position as the paragraph is empty
    if (node?.type.name === 'paragraph' && node?.childCount === 0 && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) {
        const selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(start));
        tr.setSelection(selection);
        return tr;
    }
    const { inlineNodeEndPos: inlineNodeEndPos } = $d4922fc90af8294c$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
    selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(inlineNodeEndPos));
    tr.setSelection(selection);
    return tr;
};
const $d4922fc90af8294c$export$e89bc339b843c7b = (state, selection, handlePos)=>{
    if (selection.empty) return false;
    let nodeStart;
    const $selectionFrom = selection.$from;
    nodeStart = $selectionFrom.before($selectionFrom.sharedDepth(selection.to) + 1);
    if (nodeStart === $selectionFrom.pos) nodeStart = $selectionFrom.depth ? $selectionFrom.before() : $selectionFrom.pos;
    const $resolvedNodePos = state.doc.resolve(nodeStart);
    if ([
        'tableRow',
        'tableCell',
        'tableHeader'
    ].includes($resolvedNodePos.node().type.name)) {
        const parentNodeFindRes = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes['table'])(selection);
        const tablePos = parentNodeFindRes?.pos;
        nodeStart = typeof tablePos === 'undefined' ? nodeStart : tablePos;
    } else if ([
        'listItem'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before($d4922fc90af8294c$export$3ee0594e8fdf55d5($resolvedNodePos));
    else if ([
        'taskList'
    ].includes($resolvedNodePos.node().type.name)) {
        const listdepth = $d4922fc90af8294c$export$7116b8011b79af5e($resolvedNodePos);
        nodeStart = $resolvedNodePos.before(listdepth);
    } else if ([
        'blockquote'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before();
    return Boolean(handlePos < selection.$to.pos && handlePos >= nodeStart);
};
const $d4922fc90af8294c$export$3ee0594e8fdf55d5 = (itemPos)=>{
    let depth;
    for(let i = itemPos.depth; i > 1; i -= 2){
        const node = itemPos.node(i);
        if (node.type.name === 'listItem') depth = i - 1;
        else break;
    }
    return depth;
};
const $d4922fc90af8294c$export$7116b8011b79af5e = (taskListPos)=>{
    let depth;
    for(let i = taskListPos.depth; i > 0; i--){
        const node = taskListPos.node(i);
        if (node.type.name === 'taskList' || node.type.name === 'taskItem') depth = i;
        else break;
    }
    return depth;
};
module.exports["newGetSelection"] = $d4922fc90af8294c$export$2ad544f897362d62;
module.exports["selectNode"] = $d4922fc90af8294c$export$cbcb4f775d907a9e;
module.exports["setCursorPositionAtMovedNode"] = $d4922fc90af8294c$export$4b5c09668d5b4e01;
module.exports["isHandleCorrelatedToSelection"] = $d4922fc90af8294c$export$e89bc339b843c7b;

});

parcelRegister("i2jOy", function(module, exports) {

var $lwsLh = parcelRequire("lwsLh");


var $lVAkE = parcelRequire("lVAkE");

var $1GYCH = parcelRequire("1GYCH");


var $kCECX = parcelRequire("kCECX");


var $k8Ycp = parcelRequire("k8Ycp");


var $3BXSc = parcelRequire("3BXSc");


var $bOZni = parcelRequire("bOZni");

const $ab609c7acfa1dbd4$export$4e8a3dde481e0452 = (api, pos, tr)=>{
    const pluginState = api?.blockControls?.sharedState.currentState();
    // With move nodes shortcut, we expand selection and move node within one transaction,
    // Hence we also look for `multiSelectDnD` in transaction meta
    const multiSelectDnD = pluginState?.multiSelectDnD ?? tr?.getMeta((0, $3BXSc.key))?.multiSelectDnD;
    if (multiSelectDnD && multiSelectDnD.anchor >= 0 && multiSelectDnD.head >= 0) {
        const multiFrom = Math.min(multiSelectDnD.anchor, multiSelectDnD.head);
        const multiTo = Math.max(multiSelectDnD.anchor, multiSelectDnD.head);
        // We subtract one as the handle position is before the node
        return pos >= multiFrom - 1 && pos < multiTo ? {
            anchor: multiSelectDnD.anchor,
            head: multiSelectDnD.head
        } : {};
    }
    return {};
};
const $ab609c7acfa1dbd4$export$5e3fa240bc795f26 = (handlePos, tr, api)=>{
    const { anchor: anchor, head: head } = $ab609c7acfa1dbd4$export$4e8a3dde481e0452(api, handlePos, tr);
    const inSelection = anchor !== undefined && head !== undefined;
    const from = inSelection ? Math.min(anchor || 0, head || 0) : handlePos;
    const activeNode = tr.doc.nodeAt(handlePos);
    const activeNodeEndPos = handlePos + (activeNode?.nodeSize ?? 1);
    const to = inSelection ? Math.max(anchor || 0, head || 0) : activeNodeEndPos;
    return {
        from: from,
        to: to
    };
};
const $ab609c7acfa1dbd4$export$e21678cf246ba963 = (selection, tr)=>{
    const { preservedSelectionMapping: preservedSelectionMapping } = (0, $3BXSc.getBlockControlsMeta)(tr) || {};
    const mapping = preservedSelectionMapping || tr.mapping;
    const from = mapping.map(selection.from);
    // When lastNodeMustBeParagraph inserts a trailing paragraph exactly at the end boundary
    // of a preserved block selection, keep the mapped end position on the left side of the
    // inserted paragraph so it is not included in the preserved selection.
    const shouldTrimTrailingParagraph = tr.getMeta((0, $lwsLh.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META)) === true;
    const to = shouldTrimTrailingParagraph ? mapping.map(selection.to, -1) : mapping.map(selection.to);
    const isSelectionEmpty = from === to;
    const wasSelectionEmpty = selection.from === selection.to;
    if (isSelectionEmpty && !wasSelectionEmpty) // If selection has become empty i.e. content has been deleted, stop preserving
    return undefined;
    return $ab609c7acfa1dbd4$export$fa43757966d274e3(tr.doc.resolve(from), tr.doc.resolve(to));
};
const $ab609c7acfa1dbd4$var$isInsideEmptyTextblock = ($pos)=>$pos.parent.isTextblock && $pos.parent.content.size === 0;
const $ab609c7acfa1dbd4$var$isAtEndOfParent = ($pos)=>$pos.parentOffset === $pos.parent.content.size;
const $ab609c7acfa1dbd4$var$isAtStartOfParent = ($pos)=>$pos.parentOffset === 0;
const $ab609c7acfa1dbd4$export$59e281d427887933 = ($from, $to)=>{
    const { doc: doc } = $from;
    // Walk $from forward while at end of ancestors
    let adjustedFrom = $from;
    if (!$ab609c7acfa1dbd4$var$isInsideEmptyTextblock($from)) while(adjustedFrom.depth > 0 && $ab609c7acfa1dbd4$var$isAtEndOfParent(adjustedFrom)){
        const nextPos = adjustedFrom.after();
        if (nextPos > doc.content.size || nextPos === adjustedFrom.pos) break;
        adjustedFrom = doc.resolve(nextPos);
    }
    // Walk $to backward while at start of ancestors
    let adjustedTo = $to;
    if (!$ab609c7acfa1dbd4$var$isInsideEmptyTextblock($to)) while(adjustedTo.depth > 0 && $ab609c7acfa1dbd4$var$isAtStartOfParent(adjustedTo)){
        const prevPos = adjustedTo.before();
        if (prevPos < 0 || prevPos === adjustedTo.pos) break;
        adjustedTo = doc.resolve(prevPos);
    }
    return {
        $from: adjustedFrom,
        $to: adjustedTo
    };
};
const $ab609c7acfa1dbd4$export$fa43757966d274e3 = ($from, $to)=>{
    const { doc: doc } = $from;
    const isCollapsed = $from.pos === $to.pos;
    const adjusted = isCollapsed ? {
        $from: $from,
        $to: $to
    } : $ab609c7acfa1dbd4$export$59e281d427887933($from, $to);
    if (!isCollapsed && adjusted.$from.pos >= adjusted.$to.pos) return undefined;
    // expand the selection range to block boundaries, so selection always includes whole nodes
    const expanded = (0, $lVAkE.expandToBlockRange)(adjusted.$from, adjusted.$to);
    // stop preserving if selection becomes invalid
    if (expanded.$from.pos < 0 || expanded.$to.pos > doc.content.size || expanded.$from.pos >= expanded.$to.pos) return undefined;
    // If multiple blocks selected, create TextSelection from start of first node to end of last node
    if (expanded.range && (0, $1GYCH.isMultiBlockRange)(expanded.range)) return new (0, $kCECX.TextSelection)(expanded.$from, expanded.$to);
    const nodeType = doc.nodeAt(expanded.$from.pos)?.type?.name;
    if (!nodeType) return undefined;
    if (nodeType === 'table') return (0, $k8Ycp.getTableSelectionClosesToPos)($from);
    return (0, $bOZni.newGetSelection)(doc, false, expanded.$from.pos) || undefined;
};
module.exports["getMultiSelectionIfPosInside"] = $ab609c7acfa1dbd4$export$4e8a3dde481e0452;
module.exports["getSelectedSlicePosition"] = $ab609c7acfa1dbd4$export$5e3fa240bc795f26;
module.exports["mapPreservedSelection"] = $ab609c7acfa1dbd4$export$e21678cf246ba963;
module.exports["createPreservedSelection"] = $ab609c7acfa1dbd4$export$fa43757966d274e3;
module.exports["adjustSelectionBoundsForEdgePositions"] = $ab609c7acfa1dbd4$export$59e281d427887933;

});

parcelRegister("bOCgz", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");


var $4o0zT = parcelRequire("4o0zT");

const $dafa623a4437f2ee$export$3e44da64b47beb51 = (s)=>{
    const content = s.slice.content.firstChild;
    return s.from === s.to && s.slice.content.childCount === 1 && !!content && !!content.text;
};
const $dafa623a4437f2ee$export$84cb963246195c8 = (s)=>{
    const content = s.slice.content;
    return s.to === s.from + 1 && content.size === 0;
};
/**
 * Check if content being replaced is replaced with another of the same size
 * This can occur on empty docs and 'backspace' is pressed, the paragraph node is re-drawn
 * @param s
 * @returns True if content being replaced is replaced with another of the same size
 */ const $dafa623a4437f2ee$var$isStepContentReplacedWithAnotherOfSameSize = (s)=>{
    if (s instanceof (0, $eOaGc.ReplaceAroundStep)) {
        const replacedContentSize = s.to - s.from;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const insertedContentSize = s.slice.size + (s.gapTo - s.gapFrom);
            return insertedContentSize === replacedContentSize;
        }
        return s.slice.content.size === replacedContentSize;
    }
    return false;
};
const $dafa623a4437f2ee$export$5a67a4a1d2fbf068 = (tr, flags)=>{
    let from;
    let to;
    let numReplaceSteps = 0;
    let isAllText = true;
    let isReplacedWithSameSize = false;
    tr.steps.forEach((s)=>{
        if (s instanceof (0, $eOaGc.ReplaceStep) || s instanceof (0, $eOaGc.ReplaceAroundStep)) {
            if (s instanceof (0, $eOaGc.ReplaceAroundStep) || s instanceof (0, $eOaGc.ReplaceStep) && !$dafa623a4437f2ee$export$3e44da64b47beb51(s) && !$dafa623a4437f2ee$export$84cb963246195c8(s)) isAllText = false;
            // Fixes drag handle and quick insert button overlap issues
            if (flags.toolbarFlagsEnabled) // platform_editor_controls note: fixes drag handle and quick insert button overlap issues
            isReplacedWithSameSize = $dafa623a4437f2ee$var$isStepContentReplacedWithAnotherOfSameSize(s);
            const mappedTo = tr.mapping.map(s.to);
            let $to = s.from + s.slice.size;
            $to = $to > mappedTo ? $to : mappedTo;
            from = from === undefined || from > s.from ? s.from : from;
            to = to === undefined || to < $to ? $to : to;
            numReplaceSteps++;
        }
    });
    if (from === undefined) from = 0;
    if (to === undefined || to > tr.doc.nodeSize - 2) to = tr.doc.nodeSize - 2;
    return {
        from: from,
        to: to,
        numReplaceSteps: numReplaceSteps,
        isAllText: isAllText,
        isReplacedWithSameSize: isReplacedWithSameSize
    };
};
module.exports["getTrMetadata"] = $dafa623a4437f2ee$export$5a67a4a1d2fbf068;

});

parcelRegister("ijJX5", function(module, exports) {

var $9kbTQ = parcelRequire("9kbTQ");


var $fRQ3t = parcelRequire("fRQ3t");


var $4o0zT = parcelRequire("4o0zT");

/**
 * Shared registry of React roots created via `createRoot`.
 *
 * Both `decorations-drag-handle.ts` (render) and `decorations-common.ts`
 * (unmount) must operate on the **same** root for a given DOM element, so
 * the WeakMap lives here and is imported by both modules.
 */ const $d66e963a386b9172$var$reactRoots = new WeakMap();
const $d66e963a386b9172$export$1e102deeee8fa6ca = (element, mountPoint)=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_react19_migration') || typeof (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render !== 'function') {
        let root = $d66e963a386b9172$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $fRQ3t.createRoot)(mountPoint);
            $d66e963a386b9172$var$reactRoots.set(mountPoint, root);
        }
        const activeRoot = root;
        // flushSync makes createRoot render synchronously, matching legacy
        // ReactDOM.render timing that the widget/focus/positioning code depends on.
        (0, $9kbTQ.flushSync)(()=>activeRoot.render(element));
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(element, mountPoint);
};
const $d66e963a386b9172$export$41348551f2ac3828 = (mountPoint)=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_react19_migration') || typeof (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render !== 'function') {
        const root = $d66e963a386b9172$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $d66e963a386b9172$var$reactRoots.delete(mountPoint);
        }
    } else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(mountPoint);
};
module.exports["renderToMountPoint"] = $d66e963a386b9172$export$1e102deeee8fa6ca;
module.exports["unmountFromMountPoint"] = $d66e963a386b9172$export$41348551f2ac3828;

});

parcelRegister("SlYRR", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $euISL = parcelRequire("euISL");

var $hZ5o2 = parcelRequire("hZ5o2");


var $57Rmq = parcelRequire("57Rmq");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");

const $37fff4366474b40a$export$199dae4875feadcd = (nodeType)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = nodeType.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].indexOf(nodeType) >= 0;
};
const $37fff4366474b40a$export$51b69e9dc2d60fca = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.layoutColumn;
};
const $37fff4366474b40a$export$a528a4f84f239e18 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.doc;
};
const $37fff4366474b40a$export$a1d4506bfd61c0e4 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.expand;
};
const $37fff4366474b40a$export$174a46ad1de68ba = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.nestedExpand;
};
const $37fff4366474b40a$export$7787d47a1b8939d0 = (node)=>{
    return node.type.name === 'paragraph' && node.marks.some((mark)=>mark.type.name === 'fontSize');
};
const $37fff4366474b40a$export$9d5fcdcf2394fab8 = ($from, $to)=>{
    const fromNode = $from.nodeAfter;
    const toNode = $to.nodeAfter;
    return !!(fromNode && toNode && fromNode.type.name === 'layoutColumn' && [
        'layoutSection',
        'layoutColumn'
    ].includes(toNode.type.name) && // fromNode can either be in the same layoutSection as toNode or is a layoutColumn inside the toNode (type layoutSection)
    ($from.sameParent($to) || $from.parent === toNode));
};
const $37fff4366474b40a$export$c78c24bf7f1a36c2 = (expandNode)=>{
    const { expand: expand, nestedExpand: nestedExpand } = expandNode.type.schema.nodes;
    if (expandNode.type === expand) return nestedExpand.createChecked(expandNode.attrs, expandNode.content, expandNode.marks);
    return null;
};
const $37fff4366474b40a$export$ca1d8e12fb5b3277 = (fragment)=>{
    const children = [];
    try {
        fragment.forEach((node)=>{
            if ($37fff4366474b40a$export$a1d4506bfd61c0e4(node.type)) {
                const nestedExpandNode = $37fff4366474b40a$export$c78c24bf7f1a36c2(node);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
};
const $37fff4366474b40a$export$ce4d3d0e85e5e737 = (fragment, schema, fromType, toType)=>{
    const children = [];
    const targetType = schema.nodes[toType];
    if (!targetType) return null;
    try {
        fragment.forEach((node)=>{
            if (node.type.name === fromType) children.push(targetType.create(node.attrs, node.content, node.marks));
            else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
};
const $37fff4366474b40a$export$805d193712b3b932 = (slice, schema, fromType, toType)=>{
    const fragment = $37fff4366474b40a$export$ce4d3d0e85e5e737(slice.content, schema, fromType, toType);
    if (!fragment) return null;
    return new (0, $aPdNQ.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $37fff4366474b40a$export$447e90e618548243 = (slice)=>{
    const fragment = $37fff4366474b40a$export$ca1d8e12fb5b3277(slice.content);
    if (!fragment) return null;
    return new (0, $aPdNQ.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $37fff4366474b40a$export$e639988f4c2f87a3 = (0, $dOBRD.default)((node)=>{
    try {
        return $37fff4366474b40a$export$c78c24bf7f1a36c2(node);
    } catch (e) {
        return null;
    }
});
const $37fff4366474b40a$export$bfcc41199ff04884 = (nodeTypesToCreate, nodeWithTargetFragment)=>{
    try {
        return !!nodeTypesToCreate.every((nodeTypeToCreate)=>nodeTypeToCreate.createChecked({}, nodeWithTargetFragment));
    } catch (e) {
        return false;
    }
};
function $37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, srcNode, $destNodePos, destNode) {
    let srcNodeType = srcNode.type;
    const schema = srcNodeType.schema;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader, expand: expand, nestedExpand: nestedExpand, doc: doc, panel: panel, panel_c1: panel_c1, layoutColumn: layoutColumn, layoutSection: layoutSection } = schema.nodes;
    const destParentNodeType = destParent?.type;
    const activeNodeType = srcNode?.type;
    const layoutColumnContent = srcNode.content;
    const isNestingTablesSupported = (0, $hZ5o2.isNestedTablesSupported)(schema);
    if (activeNodeType === layoutColumn && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
        // Allow drag layout column and drop into layout section
        if (destNode?.type === layoutSection || destParentNodeType === doc) return true;
        if (destParentNodeType === tableCell || destParentNodeType === tableHeader) {
            const contentContainsExpand = (0, $bjg0G.findChildrenByType)(srcNode, expand).length > 0;
            //convert expand to nestedExpand if there are expands inside the layout column
            // otherwise, the createChecked will fail as expand is not a valid child of tableCell/tableHeader, but nestedExpand is
            const convertedFragment = contentContainsExpand ? $37fff4366474b40a$export$ca1d8e12fb5b3277(layoutColumnContent) : layoutColumnContent;
            if (!convertedFragment) return false;
            return $37fff4366474b40a$export$bfcc41199ff04884([
                tableCell,
                tableHeader
            ], convertedFragment);
        }
        if (destParentNodeType === panel || (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && destParentNodeType === panel_c1) return $37fff4366474b40a$export$bfcc41199ff04884([
            panel
        ], layoutColumnContent);
        if (destParentNodeType === expand) return $37fff4366474b40a$export$bfcc41199ff04884([
            expand
        ], layoutColumnContent);
        if (destParentNodeType === nestedExpand) return $37fff4366474b40a$export$bfcc41199ff04884([
            nestedExpand
        ], layoutColumnContent);
    }
    // NOTE: this will block drop targets from showing for dragging a table into another table
    // unless nested tables are supported and the nesting depth does not exceed 1
    if ((destParentNodeType === tableCell || destParentNodeType === tableHeader) && activeNodeType === table) {
        const nestingDepth = (0, $euISL.getParentOfTypeCount)(table)($destNodePos);
        if (!isNestingTablesSupported || isNestingTablesSupported && nestingDepth > 1) return false;
    }
    if ($37fff4366474b40a$export$199dae4875feadcd(destParent.type) && $37fff4366474b40a$export$a1d4506bfd61c0e4(srcNodeType)) {
        if ($37fff4366474b40a$export$e639988f4c2f87a3(srcNode)) srcNodeType = nestedExpand;
        else return false;
    } else if (($37fff4366474b40a$export$a528a4f84f239e18(destParent.type) || $37fff4366474b40a$export$51b69e9dc2d60fca(destParent.type)) && $37fff4366474b40a$export$174a46ad1de68ba(srcNodeType)) srcNodeType = expand;
    // Downgrade variant node (e.g. panel_c1 → panel) when dest doesn't support it
    if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
        const baseName = (0, $57Rmq.getBaseNodeTypeName)(srcNodeType);
        if (baseName !== srcNodeType.name && !destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType)) {
            const baseType = schema.nodes[baseName];
            // Check if the node's content is valid in the base type (e.g. panel with table can't be downgraded)
            if (!baseType || !baseType.validContent(srcNode.content)) return false;
            srcNodeType = baseType;
        }
    }
    return destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType);
}
function $37fff4366474b40a$export$35c44269895720b6(slice, sliceFromPos, sliceToPos, destParent, indexIntoParent, $destNodePos, destNode) {
    let canMoveNodes = true;
    const doc = $destNodePos.doc;
    const nodesPos = [];
    // Drag multiple nodes to be inside themselves not allowed
    if ($destNodePos.pos < sliceToPos && $destNodePos.pos >= sliceFromPos) return false;
    // Multiple layout columns do not drop correctly.
    if (slice.content.firstChild?.type.name === 'layoutColumn') return false;
    for(let i = 0; i < slice.content.childCount; i++){
        const node = slice.content.maybeChild(i);
        if (i === 0) nodesPos[i] = sliceFromPos;
        else nodesPos[i] = nodesPos[i - 1] + (slice.content.maybeChild(i - 1)?.nodeSize || 0);
        if (node && node.isInline) {
            // If the node is an inline node, we need to find the parent node
            // as passing in them into canMoveNodeToIndex will return false
            const $nodePos = doc.resolve(nodesPos[i]);
            const parentNode = $nodePos.parent;
            if (!parentNode || parentNode && !$37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, parentNode, $destNodePos, destNode)) {
                canMoveNodes = false;
                break;
            }
        } else if (node && !$37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, node, $destNodePos, destNode)) {
            canMoveNodes = false;
            break;
        }
    }
    return canMoveNodes;
}
module.exports["isInsideTable"] = $37fff4366474b40a$export$199dae4875feadcd;
module.exports["isFontSizeMarkActive"] = $37fff4366474b40a$export$7787d47a1b8939d0;
module.exports["isInSameLayout"] = $37fff4366474b40a$export$9d5fcdcf2394fab8;
module.exports["transformFragmentExpandToNestedExpand"] = $37fff4366474b40a$export$ca1d8e12fb5b3277;
module.exports["transformSliceNodeType"] = $37fff4366474b40a$export$805d193712b3b932;
module.exports["transformSliceExpandToNestedExpand"] = $37fff4366474b40a$export$447e90e618548243;
module.exports["canMoveNodeToIndex"] = $37fff4366474b40a$export$918b4fd27bccdab5;
module.exports["canMoveSliceToIndex"] = $37fff4366474b40a$export$35c44269895720b6;

});

parcelRegister("1uWpr", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $i6cU6 = parcelRequire("i6cU6");


var $kAPZe = parcelRequire("kAPZe");

var $k8PFz = parcelRequire("k8PFz");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8LYsc = parcelRequire("8LYsc");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4Vdlk = parcelRequire("4Vdlk");


var $deUyp = parcelRequire("deUyp");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $lpNn5 = parcelRequire("lpNn5");


var $9HWym = parcelRequire("9HWym");


var $3BXSc = parcelRequire("3BXSc");


var $6FQH1 = parcelRequire("6FQH1");


var $aHnsS = parcelRequire("aHnsS");


var $jWiWP = parcelRequire("jWiWP");


var $2w4SV = parcelRequire("2w4SV");


var $bOZni = parcelRequire("bOZni");


var $hTjcC = parcelRequire("hTjcC");


var $frZvB = parcelRequire("frZvB");


var $9BGzJ = parcelRequire("9BGzJ");


var $eYPgl = parcelRequire("eYPgl");


var $bdkuW = parcelRequire("bdkuW");


var $fKt2m = parcelRequire("fKt2m");


var $lhJQI = parcelRequire("lhJQI");

function $4a329e028fe22022$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a329e028fe22022$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $4a329e028fe22022$var$buttonWrapperStylesNoBackground = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    }
});
const $4a329e028fe22022$var$buttonWrapperStylesPatch = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $7Y8M5.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $7Y8M5.akEditorTableToolbarSize)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $7Y8M5.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $7Y8M5.akEditorTableToolbarSize)
    }
});
// update color to match quick insert button for new editor controls
const $4a329e028fe22022$var$dragHandleColor = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
const $4a329e028fe22022$var$dragHandleButtonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $hTjcC.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $kAPZe.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $hTjcC.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $hTjcC.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24h x 12w, Dense: 13px -> 18h x 9w, Jira: 14px -> 21h x 12w
const $4a329e028fe22022$var$dragHandleButtonScaledStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.DRAG_HANDLE_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $kAPZe.DRAG_HANDLE_WIDTH))
});
const $4a329e028fe22022$var$dragHandleButtonSmallScreenStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $4a329e028fe22022$var$dragHandleButtonStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    paddingTop: `${"var(--ds-space-025, 2px)"}`,
    paddingBottom: `${"var(--ds-space-025, 2px)"}`,
    paddingLeft: '0',
    paddingRight: '0',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $hTjcC.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $kAPZe.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $hTjcC.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $hTjcC.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
const $4a329e028fe22022$var$focusedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:focus-visible': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $4a329e028fe22022$var$keyboardFocusedDragHandleStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $4a329e028fe22022$var$dragHandleContainerStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    boxSizing: 'border-box'
});
const $4a329e028fe22022$var$tooltipContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    bottom: `-${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    position: 'sticky',
    display: 'block',
    zIndex: 100 // card = 100
});
const $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    }
});
const $4a329e028fe22022$var$tooltipContainerStylesImprovedStickyHeaderWithMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] > [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithoutMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $4a329e028fe22022$var$dragHandleMultiLineSelectionFixFirefox = {
    name: "ut0e3u",
    styles: "&::selection{background-color:transparent;}"
};
const $4a329e028fe22022$var$layoutColumnDragHandleStyles = {
    name: "jbgpyq",
    styles: "transform:rotate(90deg)"
};
const $4a329e028fe22022$var$selectedStyles = {
    name: "1qq3fmc",
    styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-icon-selected, #1868DB)"
};
// [Chrome only] When selection contains multiple nodes and then drag a drag handle that is within the selection range,
// icon span receives dragStart event, instead of button, and since it is not registered as a draggable element
// with pragmatic DnD and pragmatic DnD is not triggered
const $4a329e028fe22022$var$handleIconDragStart = (e)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    if (!browser.chrome) return;
    // prevent dragStart handler triggered by icon
    e.stopPropagation();
    const dragEvent = new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: e.dataTransfer
    });
    if (e.target instanceof HTMLElement) // re-dispatch drag event on button so that pragmatic DnD can be triggered properly
    e.target.closest('button')?.dispatchEvent(dragEvent);
};
const $4a329e028fe22022$var$getNodeSpacingForPreview = (node)=>{
    if (!node) return (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.spacingBetweenNodesForPreview)[`heading${node.attrs.level}`] || (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
    return (0, $hTjcC.spacingBetweenNodesForPreview)[nodeTypeName] || (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
};
const $4a329e028fe22022$var$getNodeMargins = (node)=>{
    if (!node) return (0, $hTjcC.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.nodeMargins)[`heading${node.attrs.level}`] || (0, $hTjcC.nodeMargins)['default'];
    return (0, $hTjcC.nodeMargins)[nodeTypeName] || (0, $hTjcC.nodeMargins)['default'];
};
// Omit `isOpen` so the reducer toggles the menu for a re-clicked layout column.
const $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta = (anchorPos, openedViaKeyboard)=>({
        anchorPos: anchorPos,
        openedViaKeyboard: openedViaKeyboard
    });
const $4a329e028fe22022$var$getDragHandleAnchorReference = ({ edge: edge, safeAnchorName: safeAnchorName })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return `anchor(${safeAnchorName} ${edge}, anchor(${0, $hTjcC.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME} ${edge}))`;
    return `anchor(${safeAnchorName} ${edge})`;
};
const $4a329e028fe22022$export$a0c24614540b0efb = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, anchorRectCache: anchorRectCache })=>{
    const buttonRef = (0, $cozmU.useRef)(null);
    const mouseDownRef = (0, $cozmU.useRef)(false);
    const [dragHandleSelected, setDragHandleSelected] = (0, $cozmU.useState)(false);
    const [blockCardWidth, setBlockCardWidth] = (0, $cozmU.useState)(768);
    const [positionStylesOld, setPositionStylesOld] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Tracks whether the initial position calculation has been performed at least once.
    // The reliable-anchor early-return optimisation must not fire before the first calculation,
    // otherwise positionStylesOld stays as { display: 'none' } and the handle is never shown.
    const hasCalculatedInitialPosition = (0, $cozmU.useRef)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(Boolean(handleOptions?.isFocused));
    const { macroInteractionUpdates: macroInteractionUpdates, selection: selection, interactionState: interactionState, currentUserIntent: currentUserIntent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'selection',
        'blockControls',
        'interaction',
        'userIntent'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            selection: states.selectionState?.selection,
            interactionState: states.interactionState?.interactionState,
            currentUserIntent: states.userIntentState?.currentUserIntent
        }));
    const start = getPos();
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Dynamically calculate if node is top-level based on current position
    const isTopLevelNodeValue = (0, $cozmU.useMemo)(()=>{
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            return $pos?.parent.type.name === 'doc';
        }
        return true;
    }, [
        getPos,
        view.state.doc
    ]);
    (0, $cozmU.useEffect)(()=>{
        // blockCard/datasource width is rendered correctly after this decoraton does. We need to observe for changes.
        if (nodeType === 'blockCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            const container = dom?.querySelector('.datasourceView-content-inner-wrap');
            if (container) {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const width = entries[0].contentBoxSize[0].inlineSize;
                    setBlockCardWidth(width);
                });
                resizeObserver.observe(container);
                return ()=>resizeObserver.unobserve(container);
            }
        }
    }, [
        anchorName,
        nodeType,
        view.dom
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) return;
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'mouseUp',
            listener: ()=>mouseDownRef.current = false
        });
        return ()=>unbind();
    }, []);
    const handleMouseDown = (0, $cozmU.useCallback)(()=>{
        mouseDownRef.current = true;
    }, []);
    const handleMouseUp = (0, $cozmU.useCallback)((e)=>{
        // Stop propagation so that for drag handles in nested scenarios the click is captured
        // and doesn't propagate to the edge of the element and trigger a node selection
        // on the parent element
        if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) e.stopPropagation();
        // Fixes bug where selection toolbar is blocked when mouse is released on drag handle
        if (mouseDownRef.current) e.stopPropagation();
    }, []);
    const handleOnClickNew = (0, $cozmU.useCallback)((e)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta(startPos, false));
            const resolvedStartPos = tr.doc.resolve(startPos);
            const selection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection || tr.selection;
            api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeTypes: resolvedStartPos.nodeAfter?.type.name || ''
                }
            })(tr);
            (0, $2w4SV.expandAndUpdateSelection)({
                tr: tr,
                selection: selection,
                startPos: startPos,
                isShiftPressed: e.shiftKey,
                nodeType: nodeType,
                api: api
            });
            api?.blockControls?.commands.startPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands.toggleBlockMenu({
                anchorName: anchorName,
                openedViaKeyboard: false,
                triggerByNode: {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                }
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        api,
        view,
        getPos,
        nodeType,
        anchorName
    ]);
    const handleKeyDownNew = (0, $cozmU.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (e.key === 'Enter' || !e.repeat && e.key === ' ') {
            if ((0, $1hQ0e.getDocument)()?.activeElement !== buttonRef.current) return;
            e.preventDefault();
            e.stopPropagation();
            const startPos = getPos();
            api?.core?.actions.execute(({ tr: tr })=>{
                if (startPos === undefined) return tr;
                const selection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection || tr.selection;
                (0, $2w4SV.expandAndUpdateSelection)({
                    tr: tr,
                    selection: selection,
                    startPos: startPos,
                    isShiftPressed: e.shiftKey,
                    nodeType: nodeType,
                    api: api
                });
                api?.blockControls?.commands.startPreservingSelection()({
                    tr: tr
                });
                if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta(startPos, true));
                const triggerByNode = {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                };
                api?.blockControls?.commands.toggleBlockMenu({
                    anchorName: anchorName,
                    triggerByNode: triggerByNode,
                    openedViaKeyboard: true
                })({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen')({
                    tr: tr
                });
                return tr;
            });
            view.focus();
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api,
        nodeType,
        anchorName,
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element) return;
        return (0, $4Vdlk.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    const newHandlePosCheck = (0, $bOZni.isHandleCorrelatedToSelection)(view.state, tr.selection, handlePos);
                    if (!tr.selection.empty && newHandlePosCheck) api?.blockControls?.commands.setMultiSelectPositions()({
                        tr: tr
                    });
                    else tr = (0, $bOZni.selectNode)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const state = view.state;
                const { doc: doc, selection: selection } = state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                if (mSelect) {
                    const { anchor: anchor, head: head } = mSelect;
                    sliceFrom = Math.min(anchor, head);
                    sliceTo = Math.max(anchor, head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultiLine = startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultiLine) return {
                            x: 0,
                            y: 0
                        };
                        else {
                            // Calculate the offset of the preview container,
                            // So when drag multiple nodes, the preview align with the position of the selected nodes
                            const domAtPos = view.domAtPos.bind(view);
                            let domElementsHeightBeforeHandle = 0;
                            const nodesStartPos = [];
                            const nodesEndPos = [];
                            let activeNodeMarginTop = 0;
                            for(let i = 0; i < expandedSlice.content.childCount; i++){
                                if (i === 0) {
                                    nodesStartPos[i] = sliceFrom;
                                    nodesEndPos[i] = sliceFrom + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                } else {
                                    nodesStartPos[i] = nodesEndPos[i - 1];
                                    nodesEndPos[i] = nodesStartPos[i] + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                }
                                // when the node is before the handle, calculate the height of the node
                                if (nodesEndPos[i] <= startPos) {
                                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                                    const currentNodeElement = (0, $bjg0G.findDomRefAtPos)(nodesStartPos[i], domAtPos);
                                    const maybeCurrentNode = expandedSlice.content.maybeChild(i);
                                    const currentNodeSpacing = maybeCurrentNode ? $4a329e028fe22022$var$getNodeMargins(maybeCurrentNode).top + $4a329e028fe22022$var$getNodeMargins(maybeCurrentNode).bottom : 0;
                                    domElementsHeightBeforeHandle = domElementsHeightBeforeHandle + currentNodeElement.offsetHeight + currentNodeSpacing;
                                } else {
                                    // when the node is after the handle, calculate the top margin of the active node
                                    const maybeNextNode = expandedSlice.content.maybeChild(i);
                                    activeNodeMarginTop = maybeNextNode ? $4a329e028fe22022$var$getNodeMargins(maybeNextNode).top : 0;
                                    break;
                                }
                            }
                            return {
                                x: 0,
                                y: domElementsHeightBeforeHandle + activeNodeMarginTop
                            };
                        }
                    },
                    render: ({ container: container })=>{
                        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
                        if (!dom) return;
                        if (!isDraggingMultiLine) return (0, $9BGzJ.dragPreview)(container, {
                            dom: dom,
                            nodeType: nodeType
                        });
                        else {
                            const domAtPos = view.domAtPos.bind(view);
                            const previewContent = [];
                            expandedSlice.content.descendants((node, pos)=>{
                                // Get the dom element of the node
                                //eslint-disable-next-line @atlaskit/editor/no-as-casting
                                const nodeDomElement = (0, $bjg0G.findDomRefAtPos)(sliceFrom + pos, domAtPos);
                                const currentNodeSpacing = $4a329e028fe22022$var$getNodeSpacingForPreview(node);
                                previewContent.push({
                                    dom: nodeDomElement,
                                    nodeType: node.type.name,
                                    nodeSpacing: currentNodeSpacing
                                });
                                return false; // Only iterate through the first level of nodes
                            });
                            return (0, $9BGzJ.dragPreview)(container, previewContent);
                        }
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart () {
                if (start === undefined) return;
                api?.core?.actions.execute(({ tr: tr })=>{
                    let nodeTypes, hasSelectedMultipleNodes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const maybeNode = resolvedMovingNode.nodeAfter;
                    const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                    if (mSelect) {
                        const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, mSelect.anchor, mSelect.head);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    } else {
                        nodeTypes = maybeNode?.type.name;
                        hasSelectedMultipleNodes = false;
                    }
                    api?.blockControls?.commands.setNodeDragged(getPos, anchorName, nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api?.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        action: (0, $krYZG.ACTION).DRAGGED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        anchorName,
        api,
        getPos,
        nodeType,
        start,
        view
    ]);
    const calculatePositionOld = (0, $cozmU.useCallback)(()=>{
        const pos = getPos();
        const $pos = typeof pos === 'number' ? view.state.doc.resolve(pos) : undefined;
        const parentPos = $pos && $pos.depth ? $pos.before() : undefined;
        const node = parentPos !== undefined ? view.state.doc.nodeAt(parentPos) : undefined;
        const nodeTypeWithLevel = $pos?.nodeAfter?.isBlock ? (0, $9HWym.getNodeTypeWithLevel)($pos.nodeAfter) : nodeType;
        const parentNodeType = node?.type.name;
        const supportsAnchor = CSS.supports('top', `anchor(${anchorName} start)`) && CSS.supports('left', `anchor(${anchorName} start)`);
        const safeAnchorName = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: anchorName
        }) : anchorName;
        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: since the node decoration sets data-active-drag-handle on the
        // active node, we check for it directly. This is a cheap DOM attribute read (no reflow,
        // no style recalculation) and hides the control if the decoration hasn't been applied yet.
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !dom?.hasAttribute((0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR))) return {
            display: 'none'
        };
        const hasResizer = nodeType === 'table' || nodeType === 'mediaSingle';
        const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension' || nodeType === 'multiBodiedExtension' && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
        const isBlockCard = nodeType === 'blockCard' && !!blockCardWidth;
        const isEmbedCard = nodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $jWiWP.shouldBeSticky)(nodeType);
        if (supportsAnchor) {
            const anchorStart = $4a329e028fe22022$var$getDragHandleAnchorReference({
                edge: 'start',
                safeAnchorName: safeAnchorName
            });
            const anchorTop = $4a329e028fe22022$var$getDragHandleAnchorReference({
                edge: 'top',
                safeAnchorName: safeAnchorName
            });
            const anchorLeft = $4a329e028fe22022$var$getDragHandleAnchorReference({
                edge: 'left',
                safeAnchorName: safeAnchorName
            });
            const anchorRight = $4a329e028fe22022$var$getDragHandleAnchorReference({
                edge: 'right',
                safeAnchorName: safeAnchorName
            });
            const bottom = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $jWiWP.getControlBottomCSSValue)(safeAnchorName, isSticky, isTopLevelNodeValue, isLayoutColumn, (0, $hTjcC.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)) : {};
            return {
                left: isEdgeCase ? `calc(${anchorStart} + ${(0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc((${anchorRight} + ${anchorLeft})/2 - ${(0, $hTjcC.DRAG_HANDLE_HEIGHT) / 2}px)` : `calc(${anchorStart} - ${0, $kAPZe.DRAG_HANDLE_WIDTH}px - ${(0, $hTjcC.dragHandleGap)(nodeType, parentNodeType)}px)`,
                top: (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc(${anchorTop} - ${0, $kAPZe.DRAG_HANDLE_WIDTH}px)` : `calc(${anchorStart} + ${(0, $hTjcC.topPositionAdjustment)(nodeTypeWithLevel, dom?.getAttribute('layout') || '')}px)`,
                ...bottom
            };
        }
        const height = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName, anchorRectCache) || 0, isSticky, isTopLevelNodeValue, `${(0, $hTjcC.DRAG_HANDLE_HEIGHT)}`, isLayoutColumn) : {};
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType),
            top: (0, $jWiWP.getTopPosition)(dom, nodeTypeWithLevel),
            ...height
        };
    }, [
        anchorName,
        getPos,
        view,
        nodeType,
        blockCardWidth,
        macroInteractionUpdates,
        anchorRectCache,
        isTopLevelNodeValue,
        isLayoutColumn
    ]);
    const isReliableAnchorEnabled = (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true);
    const docDepForReliableAnchor = isReliableAnchorEnabled ? view.state.doc : undefined;
    // Effect 1 (reliable-anchor ON): fires when non-doc deps change (e.g. blockCardWidth,
    // anchorRectCache, macroInteractionUpdates, isTopLevelNodeValue, isLayoutColumn via
    // calculatePositionOld) — always recalculates without the doc guard, so non-doc position
    // changes are never incorrectly skipped.
    (0, $cozmU.useEffect)(()=>{
        if (!isReliableAnchorEnabled) return;
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType
    ]);
    // Effect 2 (reliable-anchor ON): fires when the doc changes — carries the DOM-attribute
    // guard to skip recalc when a drag handle is active (pure keystroke during drag).
    // Effect (reliable-anchor OFF): single combined effect, original behaviour.
    (0, $cozmU.useEffect)(()=>{
        if (isReliableAnchorEnabled) {
            // Doc-change only effect: apply the DOM-attribute guard.
            // React's dep comparison already ensures this only runs when docDepForReliableAnchor
            // (i.e. view.state.doc) changed, so no manual ref tracking is needed.
            if (!hasCalculatedInitialPosition.current) return;
            const calcPos = requestAnimationFrame(()=>{
                const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
                if (dom?.hasAttribute((0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR))) return;
                setPositionStylesOld(calculatePositionOld());
            });
            return ()=>{
                cancelAnimationFrame(calcPos);
            };
        }
        // reliable-anchor OFF: original single-effect behaviour (no guard).
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType,
        docDepForReliableAnchor
    ]);
    const isHandleShown = positionStylesOld.display !== 'none';
    (0, $cozmU.useEffect)(()=>{
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_react19_migration')) return;
        if (handleOptions?.isFocused && buttonRef.current) {
            const id = requestAnimationFrame(()=>{
                buttonRef.current?.focus();
            });
            return ()=>{
                cancelAnimationFrame(id);
                view.focus();
            };
        }
    }, [
        buttonRef,
        handleOptions?.isFocused,
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_react19_migration')) return;
        if (!(handleOptions?.isFocused && isHandleShown && buttonRef.current)) return;
        // isHandleShown means the handle has been positioned, but an ancestor can still be
        // visibility:hidden or display:none for a frame, in which case focus() is a silent no-op.
        // Focus now, and if activeElement shows it did not land, retry on the next few frames.
        let rafId;
        let attempts = 0;
        const MAX_ATTEMPTS = 5;
        const focusHandle = ()=>{
            const button = buttonRef.current;
            if (!button) return;
            button.focus();
            // getDocument() is the same document handleKeyDownNew reads activeElement from, so
            // this confirms Space/Enter will act on the handle rather than silently no-op.
            if ((0, $1hQ0e.getDocument)()?.activeElement === button || attempts >= MAX_ATTEMPTS) return;
            attempts++;
            rafId = requestAnimationFrame(focusHandle);
        };
        focusHandle();
        return ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            view.focus();
        };
    }, [
        buttonRef,
        handleOptions?.isFocused,
        view,
        isHandleShown
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (typeof start !== 'number' || !selection) return;
        setDragHandleSelected((0, $bOZni.isHandleCorrelatedToSelection)(view.state, selection, start));
    }, [
        start,
        selection,
        view
    ]);
    const dragHandleMessage = formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
        br: /*#__PURE__*/ (0, $lOiVq.jsx)("br", null)
    });
    // Create a string version for aria-label
    const dragHandleAriaLabel = formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
        br: ' '
    });
    let helpDescriptors = isTopLevelNodeValue ? [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveLeft),
            keymap: (0, $ldqjS.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveRight),
            keymap: (0, $ldqjS.dragToMoveRight)
        }
    ] : [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        }
    ];
    let isParentNodeOfTypeLayout;
    if (!isTopLevelNodeValue) {
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            isParentNodeOfTypeLayout = $pos?.parent?.type.name === 'layoutColumn';
        }
        if (isParentNodeOfTypeLayout) helpDescriptors = [
            ...helpDescriptors,
            {
                description: formatMessage((0, $i6cU6.messages).moveLeft),
                keymap: (0, $ldqjS.dragToMoveLeft)
            },
            {
                description: formatMessage((0, $i6cU6.messages).moveRight),
                keymap: (0, $ldqjS.dragToMoveRight)
            }
        ];
    }
    // When advanced layout is on, layout column drag handle show only show 'Drag to move', no shortcuts
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', true) && nodeType === 'layoutColumn') helpDescriptors = [
        {
            description: formatMessage((0, $i6cU6.messages).dragToRearrange)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveLeft),
            keymap: (0, $ldqjS.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveRight),
            keymap: (0, $ldqjS.dragToMoveRight)
        }
    ];
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) helpDescriptors = [
        {
            description: dragHandleMessage
        }
    ];
    const message = helpDescriptors.map((descriptor)=>{
        return descriptor.keymap ? [
            descriptor.description,
            (0, $ldqjS.getAriaKeyshortcuts)(descriptor.keymap)
        ] : [
            descriptor.description
        ];
    }).join('. ');
    const handleOnDrop = (event)=>{
        event.stopPropagation();
    };
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    const browser = (0, $8dxef.getBrowserInfo)();
    const renderButton = ()=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
            type: "button",
            css: [
                (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? $4a329e028fe22022$var$dragHandleButtonStyles : $4a329e028fe22022$var$dragHandleButtonStylesOld,
                (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') && $4a329e028fe22022$var$dragHandleColor,
                // ED-26266: Fixed the drag handle highlight when selecting multiple line in Firefox
                // See https://product-fabric.atlassian.net/browse/ED-26266
                browser.gecko && $4a329e028fe22022$var$dragHandleMultiLineSelectionFixFirefox,
                (0, $jkcNT.editorExperiment)('advanced_layouts', true) && isLayoutColumn && $4a329e028fe22022$var$layoutColumnDragHandleStyles,
                dragHandleSelected && hasHadInteraction && $4a329e028fe22022$var$selectedStyles,
                (0, $jkcNT.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') && $4a329e028fe22022$var$dragHandleButtonSmallScreenStyles,
                isFocused && $4a329e028fe22022$var$keyboardFocusedDragHandleStyles,
                $4a329e028fe22022$var$focusedStyles,
                $4a329e028fe22022$var$dragHandleButtonScaledStyles
            ],
            ref: buttonRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: !(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? positionStylesOld : {},
            onMouseDown: (0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true) ? handleMouseDown : undefined,
            onMouseUp: handleMouseUp,
            onClick: handleOnClickNew,
            onKeyDown: handleKeyDownNew,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDrop: handleOnDrop,
            "data-editor-block-ctrl-drag-handle": true,
            "data-blocks-drag-handle": (0, $iDrrr.fg)('confluence_remix_button_right_side_block_fg') || undefined,
            "data-testid": "block-ctrl-drag-handle",
            "aria-label": dragHandleAriaLabel,
            onBlur: ()=>{
                setIsFocused(false);
                const pos = getPos();
                if (pos !== undefined) api?.core?.actions.execute(({ tr: tr })=>{
                    tr.setMeta((0, $3BXSc.key), {
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType,
                            handleOptions: {
                                isFocused: false
                            }
                        }
                    });
                    return tr;
                });
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
            xcss: $4a329e028fe22022$var$iconWrapperStyles,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: $4a329e028fe22022$var$handleIconDragStart
        }, (0, $eYPgl.shouldUseNestedDragHandleIcon)(isTopLevelNodeValue, isLayoutColumn) ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $frZvB.DragHandleNestedIcon), null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            spacing: "spacious",
            label: "",
            size: "small"
        })));
    const stickyWithTooltip = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: positionStylesOld,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $4a329e028fe22022$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                $4a329e028fe22022$var$tooltipContainerStyles,
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && ((0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? $4a329e028fe22022$var$tooltipContainerStylesImprovedStickyHeaderWithMask : $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithMask),
                !(0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            position: 'top',
            tag: (0, $iDrrr.fg)('platform-dst-top-layer-tooltip') ? 'span' : 'div',
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $4a329e028fe22022$var$buttonWrapperStylesNoBackground,
                $4a329e028fe22022$var$buttonWrapperStylesPatch
            ]
        }, renderButton()))));
    const buttonWithTooltip = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, renderButton());
    const tooltipContent = isLayoutColumn && currentUserIntent === 'layoutColumnMenuPopupOpen' ? null : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.TooltipContentWithMultipleShortcuts), {
        helpDescriptors: helpDescriptors
    });
    return (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? stickyWithTooltip() : buttonWithTooltip();
};
const $4a329e028fe22022$export$c3c91925cdbf4b0b = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false
        })).rightSideControlsEnabled;
    // Layout column drag handles sit at the top-centre of each column, not on a left/right edge.
    // Don't restrict by hoverSide for layout columns — the drag handle should always be visible
    // when hovering anywhere over the column, regardless of which side of the layoutSection the
    // column is on. (The right-side remix button is a separate node decoration and is unaffected.)
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Skip the right-side controlSide restriction for non-top-level nodes. The restriction exists
    // to avoid showing the drag handle and remix button simultaneously — but remix only applies to
    // top-level nodes, so non-top-level nodes should never be restricted.
    // Gated behind platform_editor_controls_reliable_anchor.
    const skipControlSideRestriction = (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && isTopLevelNode === false;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: !isLayoutColumn && !skipControlSideRestriction && rightSideControlsEnabled ? 'left' : undefined,
        forceVisibleOnMouseOut: !!handleOptions?.isFocused,
        shouldUseDisplayContents: isLayoutColumn && (0, $iDrrr.fg)('platform-dst-top-layer-tooltip')
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($4a329e028fe22022$export$a0c24614540b0efb, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        anchorName: anchorName,
        nodeType: nodeType,
        handleOptions: handleOptions,
        anchorRectCache: anchorRectCache
    }));
};
module.exports["DragHandle"] = $4a329e028fe22022$export$a0c24614540b0efb;
module.exports["DragHandleWithVisibility"] = $4a329e028fe22022$export$c3c91925cdbf4b0b;

});

parcelRegister("a2W6S", function(module, exports) {
/** True when `mark` has an equal counterpart (type + attrs) in `marks`. */ const $45d5967a4988fece$var$hasMatchingMark = (mark, marks)=>{
    const found = mark.type.isInSet(marks);
    return !!found && mark.eq(found);
};
const $45d5967a4988fece$export$53f82211cca2767d = (state, pos, supportedMarkTypes)=>{
    const resolvedPos = state.doc.resolve(pos);
    const validMarkTypes = supportedMarkTypes.filter(Boolean);
    const supportedMarks = resolvedPos.marks().filter((mark)=>validMarkTypes.includes(mark.type));
    if (supportedMarks.length === 0) return [];
    const { nodeAfter: nodeAfter, nodeBefore: nodeBefore } = resolvedPos;
    const nextMarks = nodeAfter?.marks ?? [];
    const prevMarks = nodeBefore?.marks ?? [];
    const nextSupported = nextMarks.filter((m)=>validMarkTypes.includes(m.type));
    const allMatchNext = supportedMarks.every((m)=>$45d5967a4988fece$var$hasMatchingMark(m, nextMarks));
    // First node — no previous sibling to compare against.
    if (!nodeBefore) return nextSupported.length === supportedMarks.length && allMatchNext ? supportedMarks : [];
    // `supportedMarks` already comes from `nodeBefore` (via resolvedPos.marks()).
    // Compare counts to guard against extra supported marks on either side.
    const prevSupported = prevMarks.filter((m)=>validMarkTypes.includes(m.type));
    return prevSupported.length === nextSupported.length && allMatchNext ? supportedMarks : [];
};
module.exports["getMatchingBlockMarks"] = $45d5967a4988fece$export$53f82211cca2767d;

});

parcelRegister("64pwY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $57Rmq = parcelRequire("57Rmq");


var $4o0zT = parcelRequire("4o0zT");


var $vZEJe = parcelRequire("vZEJe");


var $4Vdlk = parcelRequire("4Vdlk");


var $jp2Q3 = parcelRequire("jp2Q3");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $4LOJc = parcelRequire("4LOJc");


var $hTjcC = parcelRequire("hTjcC");


var $fmErs = parcelRequire("fmErs");

function $17032211a95616ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH = 760;
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH = '--editor-block-controls-drop-indicator-width';
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN = '--editor-block-controls-drop-target-leftMargin';
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX = '--editor-block-controls-drop-target-zindex';
const $17032211a95616ca$export$b172475a7115c36a = '--editor-block-controls-drop-indicator-offset';
const $17032211a95616ca$export$d522271cd3bfae1d = '--editor-block-controls-drop-indicator-gap';
const $17032211a95616ca$var$styleDropTarget = /*#__PURE__*/ (0, $lOiVq.css)({
    marginLeft: `calc(-1 * var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0))`,
    paddingLeft: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0)`,
    position: 'absolute',
    left: '0',
    display: 'block',
    zIndex: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX}, 110)`,
    transform: `translateY(var(${$17032211a95616ca$export$b172475a7115c36a}, 0))`
});
const $17032211a95616ca$var$styleDropIndicator = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    margin: '0 auto',
    position: 'relative',
    width: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH}, 100%)`,
    display: 'none'
});
const $17032211a95616ca$var$styleDropIndicatorVisible = {
    name: "4zleql",
    styles: "display:block"
};
const $17032211a95616ca$var$nestedDropIndicatorStyle = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $17032211a95616ca$var$dropZoneStyles = {
    name: "y3ufic",
    styles: "margin:0;position:absolute;width:100%;z-index:110;min-height:4px"
};
const $17032211a95616ca$var$nestedDropZoneStyle = {
    name: "1h4fcj3",
    styles: "left:4px;right:4px;width:unset"
};
const $17032211a95616ca$var$enableDropZoneNext = [
    'paragraph',
    'mediaSingle',
    'heading',
    'codeBlock',
    'decisionList',
    'bulletList',
    'orderedList',
    'taskList',
    'extension',
    'blockCard',
    'syncBlock'
];
const $17032211a95616ca$var$getEnableDropZone = ()=>{
    return $17032211a95616ca$var$enableDropZoneNext;
};
// This z index is used in container like layout
const $17032211a95616ca$var$fullHeightStyleAdjustZIndexStyle = {
    name: "125wnaz",
    styles: "z-index:0"
};
const $17032211a95616ca$var$HoverZone = ({ onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop, node: node, pos: pos, parent: parent, editorWidth: editorWidth, anchorRectCache: anchorRectCache, position: position, isNestedDropTarget: isNestedDropTarget, dropTargetStyle: dropTargetStyle, api: api })=>{
    const ref = (0, $cozmU.useRef)(null);
    const isRemainingheight = dropTargetStyle === 'remainingHeight';
    const anchorName = (0, $cozmU.useMemo)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            if (node && typeof pos === 'number') {
                const posOffset = position === 'upper' ? -node.nodeSize : 0;
                return api?.core.actions.getAnchorIdForNode(node, pos + posOffset) || '';
            }
            return '';
        }
        return node ? (0, $9HWym.getNodeAnchor)(node) : '';
    }, [
        api,
        node,
        pos,
        position
    ]);
    const [_isActive, setActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const isInsideBodiedSyncBlock = parent?.type.name === 'bodiedSyncBlock';
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $4Vdlk.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                if ((!isNestedDropTarget || isInsideBodiedSyncBlock) && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) setActiveAnchor();
                onDragEnter();
            },
            onDragLeave: onDragLeave,
            onDrop: onDrop
        });
    }, [
        isNestedDropTarget,
        isInsideBodiedSyncBlock,
        onDragEnter,
        onDragLeave,
        onDrop,
        setActiveAnchor
    ]);
    const hoverZoneUpperStyle = (0, $cozmU.useMemo)(()=>{
        const heightStyleOffset = `var(--editor-block-controls-drop-indicator-gap, 0)/2`;
        const transformOffset = `var(${$17032211a95616ca$export$b172475a7115c36a}, 0)`;
        const heightStyle = anchorName && $17032211a95616ca$var$getEnableDropZone().includes(node?.type.name || '') ? (0, $a4QVD.isAnchorSupported)() ? `calc(anchor-size(${anchorName} height)/2 + ${heightStyleOffset})` : `calc(${(anchorRectCache?.getHeight(anchorName) || 0) / 2}px + ${heightStyleOffset})` : '4px';
        const transform = position === 'upper' ? `translateY(calc(-100% + ${transformOffset}))` : `translateY(${transformOffset})`;
        return /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: heightStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            transform: transform,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${editorWidth || 0}px`
        });
    }, [
        anchorName,
        anchorRectCache,
        editorWidth,
        node?.type.name,
        position
    ]);
    /**
   * 1. Above the last empty line
   * 2. Below the last element
   *
   * Both cases will take the remaining height of the the container
   */ const heightStyle = (0, $cozmU.useMemo)(()=>{
        // only apply upper drop zone
        if (isRemainingheight && position === 'upper') {
            // previous node
            const anchorName = node ? (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? api?.core.actions.getAnchorIdForNode(node, pos || -1) || '' : (0, $9HWym.getNodeAnchor)(node) : '';
            let top = 'unset';
            if (anchorName) {
                const enabledDropZone = $17032211a95616ca$var$getEnableDropZone().includes(node?.type.name || '');
                if ((0, $a4QVD.isAnchorSupported)()) top = enabledDropZone ? `calc(anchor(${anchorName} 50%))` : `calc(anchor(${anchorName} bottom) - 4px)`;
                else if (anchorRectCache) {
                    const preNodeTopPos = anchorRectCache.getTop(anchorName) || 0;
                    const prevNodeHeight = anchorRectCache.getHeight(anchorName) || 0;
                    top = enabledDropZone ? `calc(${preNodeTopPos}px + ${prevNodeHeight / 2}px)` : `calc(${preNodeTopPos}px + ${prevNodeHeight}px - 4px)`;
                } else // Should not happen
                return null;
            } else // first empty paragraph
            top = '4px';
            return /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                top: top,
                bottom: '4px',
                height: 'unset',
                zIndex: 10,
                transform: 'none'
            });
        }
        return null;
    }, [
        anchorRectCache,
        api,
        isRemainingheight,
        node,
        pos,
        position
    ]);
    const isFullHeightInLayout = isRemainingheight && parent?.type.name === 'layoutColumn';
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `drop-target-hover-zone-${position}`,
        "data-testid": `drop-target-zone-${position}`,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $17032211a95616ca$var$dropZoneStyles,
            isNestedDropTarget && $17032211a95616ca$var$nestedDropZoneStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            hoverZoneUpperStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            heightStyle,
            isFullHeightInLayout && $17032211a95616ca$var$fullHeightStyleAdjustZIndexStyle
        ]
    });
};
const $17032211a95616ca$export$79660a248b11010 = (props)=>{
    const { api: api, getPos: getPos, prevNode: prevNode, nextNode: nextNode, parentNode: parentNode, formatMessage: formatMessage, anchorRectCache: anchorRectCache, dropTargetStyle: dropTargetStyle = 'default', isSameLayout: isSameLayout } = props;
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const { lineLength: lineLength } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>({
            lineLength: states.widthState?.lineLength || $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH
        }));
    const isNestedDropTarget = parentNode?.type.name !== 'doc';
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = ()=>{
        if (!activeNode) return;
        const pos = getPos();
        if (activeNode && pos !== undefined) {
            const { pos: start } = activeNode;
            api?.core?.actions.execute(api?.blockControls?.commands?.moveNode(start, pos, undefined, formatMessage));
        }
    };
    const dynamicStyle = {
        width: isNestedDropTarget ? 'unset' : '100%',
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH]: isNestedDropTarget ? '100%' : `${lineLength || $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH}px`,
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN]: isNestedDropTarget ? (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && parentNode?.type ? (0, $hTjcC.getNestedNodeLeftPaddingMargin)((0, $57Rmq.getBaseNodeTypeName)(parentNode.type)) : (0, $hTjcC.getNestedNodeLeftPaddingMargin)(parentNode?.type.name) : '0',
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX]: (0, $jp2Q3.layers).navigation()
    };
    const isShowInlineDropTarget = (0, $4LOJc.shouldAllowInlineDropTarget)(isNestedDropTarget, nextNode, isSameLayout, activeNode, parentNode);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)($17032211a95616ca$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: prevNode,
        pos: getPos(),
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "upper",
        isNestedDropTarget: isNestedDropTarget,
        dropTargetStyle: dropTargetStyle,
        api: api
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $17032211a95616ca$var$styleDropTarget,
            isNestedDropTarget && $17032211a95616ca$var$nestedDropIndicatorStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyle,
        "data-testid": "block-ctrl-drop-target"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $17032211a95616ca$var$styleDropIndicator,
            isDraggedOver && $17032211a95616ca$var$styleDropIndicatorVisible
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "bottom"
    }))), dropTargetStyle !== 'remainingHeight' && /*#__PURE__*/ (0, $lOiVq.jsx)($17032211a95616ca$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: nextNode,
        pos: getPos(),
        parent: parentNode,
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "lower",
        isNestedDropTarget: isNestedDropTarget,
        api: api
    }), isShowInlineDropTarget && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fmErs.InlineDropTarget), {
        ...props,
        position: "left"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fmErs.InlineDropTarget), {
        ...props,
        position: "right"
    })));
};
module.exports["EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET"] = $17032211a95616ca$export$b172475a7115c36a;
module.exports["EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP"] = $17032211a95616ca$export$d522271cd3bfae1d;
module.exports["DropTarget"] = $17032211a95616ca$export$79660a248b11010;

});

parcelRegister("ddJ8T", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $vZEJe = parcelRequire("vZEJe");


var $4Vdlk = parcelRequire("4Vdlk");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $8v85f = parcelRequire("8v85f");


var $fKt2m = parcelRequire("fKt2m");

// 8px gap + 16px on left and right
const $210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH = 40;
const $210cdee26edd8583$var$dropTargetLayoutStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    width: `${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`,
    transform: 'translateX(-50%)',
    zIndex: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
});
const $210cdee26edd8583$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    position: 'relative',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0
});
const $210cdee26edd8583$export$448a3db73d1a77fe = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $9HWym.getNodeAnchor)(parent);
    const nextNodeAnchorName = ref.current?.parentElement?.nextElementSibling?.getAttribute((0, $fKt2m.getAnchorAttrName)());
    let height = '100%';
    if (nextNodeAnchorName) {
        if ((0, $a4QVD.isAnchorSupported)()) height = `anchor-size(${nextNodeAnchorName} height)`;
        else if (anchorRectCache) {
            const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
            height = `${layoutColumnRect?.height || 0}px`;
        }
    }
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $7Y8M5.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $cozmU.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $4Vdlk.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $210cdee26edd8583$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "right",
        gap: `-${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $210cdee26edd8583$var$dropTargetLayoutHintStyle
    }));
};
const $210cdee26edd8583$export$2afcb78657666b75 = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $9HWym.getNodeAnchor)(parent);
    const [nextNodeAnchorName, setNextNodeAnchorName] = (0, $cozmU.useState)(null);
    const readNextNodeAnchor = (0, $cozmU.useCallback)(()=>{
        const nextElementSibling = ref.current?.parentElement?.nextElementSibling;
        const attrName = (0, $fKt2m.getAnchorAttrName)();
        const nextAnchorName = nextElementSibling?.getAttribute(attrName) ?? null;
        setNextNodeAnchorName((prev)=>prev === nextAnchorName ? prev : nextAnchorName);
    }, []);
    const height = (0, $cozmU.useMemo)(()=>{
        if (nextNodeAnchorName) {
            if ((0, $a4QVD.isAnchorSupported)()) return `anchor-size(${nextNodeAnchorName} height)`;
            else if (anchorRectCache) {
                const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
                return `${layoutColumnRect?.height || 0}px`;
            }
        }
        // Stacked mode fallback: minimal height to avoid oversized hint on first render
        return '0px';
    }, [
        nextNodeAnchorName,
        anchorRectCache
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const raf = requestAnimationFrame(()=>{
            readNextNodeAnchor();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        readNextNodeAnchor
    ]);
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $7Y8M5.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $cozmU.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $4Vdlk.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
                readNextNodeAnchor();
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        readNextNodeAnchor
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $210cdee26edd8583$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "right",
        gap: `-${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $210cdee26edd8583$var$dropTargetLayoutHintStyle
    }));
};
module.exports["DropTargetLayout"] = $210cdee26edd8583$export$448a3db73d1a77fe;
module.exports["DropTargetLayoutNativeAnchorSupport"] = $210cdee26edd8583$export$2afcb78657666b75;

});

parcelRegister("icvkv", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

const $de3138cce29e20cc$export$b8ad888c900fcbc2 = ()=>{
    return (0, $jkcNT.editorExperiment)('advanced_layouts', true) ? 5 : 3;
};
const $de3138cce29e20cc$export$8a51600ccf088851 = 2;
module.exports["maxLayoutColumnSupported"] = $de3138cce29e20cc$export$b8ad888c900fcbc2;
module.exports["MIN_LAYOUT_COLUMN"] = $de3138cce29e20cc$export$8a51600ccf088851;

});

parcelRegister("cX57A", function(module, exports) {
const $e491c6d921040aae$var$IGNORE_NODES = [
    'tableRow',
    'listItem',
    'caption',
    'media'
];
const $e491c6d921040aae$var$blockLeafNodeNext = [
    'blockCard',
    'rule',
    'extension',
    'syncBlock'
];
const $e491c6d921040aae$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $e491c6d921040aae$export$2f588816c7e80081 = (state, $pos, nodeType)=>{
    const depth = $pos.depth;
    const blockLeafNodeList = $e491c6d921040aae$var$blockLeafNodeNext;
    // special cases like hr rule here
    if (blockLeafNodeList.includes(nodeType || '') || $pos.pos === 0) {
        const parent = $pos.node(depth);
        const node = $pos.nodeAfter;
        const index = $pos.index();
        const before = index > 0 ? parent.child(index - 1) : null;
        const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
        return {
            pos: $pos.pos,
            node: node,
            parent: parent,
            before: before,
            after: after,
            index: index,
            depth: depth
        };
    }
    const isRootNode = depth === 1;
    const node = $pos.node(depth);
    // go through the path to find the first node that is not allow child drop target
    // From top to bottom, we check the node types at each depth
    for(let i = 1; i < depth; i++){
        const nodeType = $pos.node(i).type.name;
        if ($e491c6d921040aae$var$DISABLE_CHILD_DROP_TARGET.includes(nodeType)) return $e491c6d921040aae$export$2f588816c7e80081(state, state.doc.resolve($pos.before(i + 1)), nodeType);
    }
    if ($e491c6d921040aae$var$IGNORE_NODES.includes(node.type.name) && !isRootNode) // If the node is an ignored node, we return the surrounding nodes of its parent
    return $e491c6d921040aae$export$2f588816c7e80081(state, state.doc.resolve($pos.before(depth - 1)));
    const pos = depth > 0 ? $pos.before(depth) : 0;
    const parent = isRootNode ? state.doc : $pos.node(depth - 1);
    const index = $pos.index(depth - 1);
    const before = index > 0 ? parent.child(index - 1) : null;
    const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
    return {
        pos: pos,
        node: node,
        parent: parent,
        before: before,
        after: after,
        index: index,
        depth: depth
    };
};
module.exports["findSurroundingNodes"] = $e491c6d921040aae$export$2f588816c7e80081;

});

parcelRegister("2ZDdD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $i6cU6 = parcelRequire("i6cU6");


var $k8PFz = parcelRequire("k8PFz");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8HW7o = parcelRequire("8HW7o");


var $gFEZF = parcelRequire("gFEZF");


var $3izAL = parcelRequire("3izAL");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9HWym = parcelRequire("9HWym");


var $jWiWP = parcelRequire("jWiWP");


var $69FTU = parcelRequire("69FTU");


var $hTjcC = parcelRequire("hTjcC");


var $bdkuW = parcelRequire("bdkuW");


var $g7xpB = parcelRequire("g7xpB");


var $fKt2m = parcelRequire("fKt2m");


var $5Cc13 = parcelRequire("5Cc13");


var $lhJQI = parcelRequire("lhJQI");

function $49dc35a076557bab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $49dc35a076557bab$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
const $49dc35a076557bab$var$stickyButtonStyles = (0, $buxP3.xcss)({
    top: '0',
    position: 'sticky',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)",
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.full',
    zIndex: 'card',
    outline: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24px x 24px, Dense: 13px -> ~18.5px x ~18.5px
const $49dc35a076557bab$var$stickyButtonDenseModeStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.QUICK_INSERT_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.QUICK_INSERT_WIDTH))
});
const $49dc35a076557bab$var$containerStaticStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    zIndex: 'card'
});
const $49dc35a076557bab$var$tooltipContainerStyles = {
    name: "1hhl1l9",
    styles: "top:8px;bottom:-8px;position:sticky;display:block;z-index:card"
};
const $49dc35a076557bab$var$tooltipContainerStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $49dc35a076557bab$var$tooltipContainerImprovedStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $49dc35a076557bab$var$tooltipContainerStylesStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $49dc35a076557bab$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $49dc35a076557bab$var$getQuickInsertAnchorReference = ({ edge: edge, safeAnchorName: safeAnchorName })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return `anchor(${safeAnchorName} ${edge}, anchor(${0, $hTjcC.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME} ${edge}))`;
    return `anchor(${safeAnchorName} ${edge})`;
};
const $49dc35a076557bab$export$c64bb72e819f7e01 = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const { macroInteractionUpdates: macroInteractionUpdates } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates
        }));
    const [positionStyles, setPositionStyles] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Adapted from `src/ui/drag-handle.tsx` as positioning logic is similar
    // CHANGES - added an offset so quick insert button can be positioned beside drag handle
    // CHANGES - removed `editorExperiment('nested-dnd', true)` check and rootNodeType calculation
    // CHANGES - replace anchorName with rootAnchorName
    // CHANGES - `removed editorExperiment('advanced_layouts', true) && isLayoutColumn` checks as quick insert button will not be positioned for layout column
    const calculatePosition = (0, $cozmU.useCallback)(()=>{
        const supportsAnchor = CSS.supports('top', `anchor(${rootAnchorName} start)`) && CSS.supports('left', `anchor(${rootAnchorName} start)`);
        const pos = getPos();
        const node = pos !== undefined ? view.state.doc.nodeAt(pos) : undefined;
        const safeAnchorName = (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName
        });
        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: the node decoration sets data-active-quick-insert on the
        // active root node. Check for it directly — cheap DOM attribute read, no reflow.
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !dom?.hasAttribute((0, $hTjcC.ACTIVE_QUICK_INSERT_ATTR))) return {
            display: 'none'
        };
        const hasResizer = rootNodeType === 'table' || rootNodeType === 'mediaSingle';
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension' || rootNodeType === 'multiBodiedExtension' && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
        const isBlockCard = rootNodeType === 'blockCard';
        const isEmbedCard = rootNodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        const anchorStart = $49dc35a076557bab$var$getQuickInsertAnchorReference({
            edge: 'start',
            safeAnchorName: safeAnchorName
        });
        const bottom = (0, $jWiWP.getControlBottomCSSValue)(safeAnchorName || anchorName, isSticky, true, false, (0, $hTjcC.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME));
        if (supportsAnchor) return {
            left: isEdgeCase ? `calc(${anchorStart} + ${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(${anchorStart} - ${(0, $hTjcC.QUICK_INSERT_DIMENSIONS).width}px - ${(0, $hTjcC.rootElementGap)(rootNodeType)}px + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)`,
            // small text requires further tweaking to positioning, re-using existing methods to calculate to keep it unified with drag handle
            top: `calc(${anchorStart} + ${(0, $hTjcC.topPositionAdjustment)(node && node.type.name === 'paragraph' ? (0, $9HWym.getNodeTypeWithLevel)(node) : rootNodeType)}px)`,
            ...bottom
        };
        // expensive, calls offsetHeight
        const nodeHeight = (0, $jWiWP.getNodeHeight)(dom, safeAnchorName || anchorName, anchorRectCache) || 0;
        const height = (0, $jWiWP.getControlHeightCSSValue)(nodeHeight, isSticky, true, "var(--ds-space-300, 24px)");
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)`,
            top: (0, $jWiWP.getTopPosition)(dom, rootNodeType),
            ...height
        };
    }, [
        rootAnchorName,
        getPos,
        view,
        rootNodeType,
        macroInteractionUpdates,
        anchorName,
        anchorRectCache
    ]);
    (0, $cozmU.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${rootAnchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStyles(calculatePosition());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStyles(calculatePosition());
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType
    ]);
    const handleQuickInsert = (0, $cozmU.useCallback)(()=>{
        // if the selection is not within the node this decoration is rendered at
        // then insert a newline and trigger quick insert
        const start = getPos();
        if (start !== undefined) {
            // if the selection is not within the node this decoration is rendered at
            // or the node is non-editable, then insert a newline and trigger quick insert
            const isSelectionInsideNode = (0, $g7xpB.isSelectionInNode)(start, view);
            if (!isSelectionInsideNode || (0, $g7xpB.isNonEditableBlock)(start, view)) api.core.actions.execute((0, $5Cc13.createNewLine)(start));
            const { codeBlock: codeBlock } = view.state.schema.nodes;
            const { selection: selection } = view.state;
            const codeBlockParentNode = (0, $bjg0G.findParentNodeOfType)(codeBlock)(selection);
            if (codeBlockParentNode) // Slash command is not meant to be triggered inside code block, hence always insert slash in a new line following
            api.core.actions.execute((0, $5Cc13.createNewLine)(codeBlockParentNode.pos));
            else if (isSelectionInsideNode) {
                // text or element with be deselected and the / added immediately after the paragraph
                // unless the selection is empty
                const currentSelection = view.state.selection;
                if ((0, $g7xpB.isInTextSelection)(view) && currentSelection.from !== currentSelection.to) {
                    const currentParagraphNode = (0, $bjg0G.findParentNode)((node)=>$49dc35a076557bab$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
                    if (currentParagraphNode) {
                        const newPos = //if the current selection is selected from right to left, then set the selection to the start of the paragraph
                        currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                        api.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.TextSelection).create(view.state.selection.$from.doc, newPos));
                            return tr;
                        });
                    }
                }
                if ((0, $g7xpB.isNestedNodeSelected)(view)) {
                    // if the nested selected node is non-editable, then insert a newline below the selected node
                    if ((0, $g7xpB.isNonEditableBlock)(view.state.selection.from, view)) api.core.actions.execute((0, $5Cc13.createNewLine)(view.state.selection.from));
                    else // otherwise need to force the selection to be at the start of the node, because
                    // prosemirror is keeping it as NodeSelection for nested nodes. Do this to keep it
                    // consistent NodeSelection for root level nodes.
                    api.core.actions.execute(({ tr: tr })=>{
                        (0, $5Cc13.createNewLine)(view.state.selection.from)({
                            tr: tr
                        });
                        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, view.state.selection.from));
                        return tr;
                    });
                }
                if (currentSelection instanceof (0, $8HW7o.CellSelection)) {
                    // find the last inline position in the selection
                    const lastInlinePosition = (0, $kCECX.TextSelection).near(view.state.selection.$to, -1);
                    lastInlinePosition && api.core.actions.execute(({ tr: tr })=>{
                        if (!(lastInlinePosition instanceof (0, $kCECX.TextSelection))) {
                            // this will create a new line after the node
                            (0, $5Cc13.createNewLine)(lastInlinePosition.from)({
                                tr: tr
                            });
                            // this will find the next valid text position after the node
                            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, lastInlinePosition.to));
                        } else tr.setSelection(lastInlinePosition);
                        return tr;
                    });
                }
            }
        }
        api.quickInsert?.actions.openTypeAhead('blockControl', true);
    }, [
        api,
        getPos,
        view
    ]);
    const handleMouseDown = (0, $cozmU.useCallback)(()=>{
        // close typeahead if it is open, must happen in mouseDown otherwise typeAhead popup will be dismissed and text is left
        if (api.typeAhead?.actions.isOpen(view.state)) api.typeAhead.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        api,
        view.state
    ]);
    const tooltipPressable = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            position: "top",
            content: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                description: formatMessage((0, $i6cU6.messages).insert)
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kh0hi.Pressable), {
            testId: "editor-quick-insert-button",
            type: "button",
            "aria-label": formatMessage((0, $i6cU6.messages).insert),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $49dc35a076557bab$var$stickyButtonStyles,
                $49dc35a076557bab$var$stickyButtonDenseModeStyles
            ],
            onClick: handleQuickInsert,
            onMouseDown: handleMouseDown
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: "add",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        })));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: positionStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $49dc35a076557bab$var$containerStaticStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $49dc35a076557bab$var$tooltipContainerStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? $49dc35a076557bab$var$tooltipContainerImprovedStylesStickyHeader : $49dc35a076557bab$var$tooltipContainerStylesStickyHeader,
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? $49dc35a076557bab$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix : $49dc35a076557bab$var$tooltipContainerStylesStickyHeaderWithMarksFix
        ]
    }, tooltipPressable()));
};
const $49dc35a076557bab$export$6ffb15bf86dea6dd = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, nodeType: nodeType, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false
        })).rightSideControlsEnabled;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: rightSideControlsEnabled ? 'left' : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($49dc35a076557bab$export$c64bb72e819f7e01, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        nodeType: nodeType,
        anchorName: anchorName,
        rootAnchorName: rootAnchorName,
        rootNodeType: rootNodeType,
        anchorRectCache: anchorRectCache
    }));
};
module.exports["QuickInsertWithVisibility"] = $49dc35a076557bab$export$6ffb15bf86dea6dd;

});

parcelRegister("6FQH1", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $aca3bcee9aa84af2$export$4d3f50627e188696 = new (0, $kCECX.PluginKey)('selectionPreservationPlugin');
module.exports["selectionPreservationPluginKey"] = $aca3bcee9aa84af2$export$4d3f50627e188696;

});

parcelRegister("b3nYA", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8QOo3 = parcelRequire("8QOo3");


var $i6cU6 = parcelRequire("i6cU6");


var $iQ6F7 = parcelRequire("iQ6F7");

var $4EksL = parcelRequire("4EksL");


var $jPUdw = parcelRequire("jPUdw");


var $1xYQH = parcelRequire("1xYQH");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");


var $4IGja = parcelRequire("4IGja");

var $5PIOe = parcelRequire("5PIOe");

var $guqmu = parcelRequire("guqmu");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $3BXSc = parcelRequire("3BXSc");


var $aHnsS = parcelRequire("aHnsS");


var $bbndg = parcelRequire("bbndg");


var $bnCpE = parcelRequire("bnCpE");


var $bOZni = parcelRequire("bOZni");


var $izfLh = parcelRequire("izfLh");


var $i2jOy = parcelRequire("i2jOy");


var $8v85f = parcelRequire("8v85f");


var $SlYRR = parcelRequire("SlYRR");


var $9aKak = parcelRequire("9aKak");

/**
 * This function transforms the slice to move
 * @param nodeCopy The slice contains the node to be moved
 * @param destType The type of the destiation node
 * @returns transformed slice or null if unable to
 */ function $ef5137d75ace3d5c$var$transformSourceSlice(nodeCopy, destType) {
    const srcNode = nodeCopy.content.firstChild;
    const schema = srcNode?.type.schema;
    if (!schema) return nodeCopy;
    const { doc: doc, layoutColumn: layoutColumn } = schema.nodes;
    const destTypeInTable = (0, $SlYRR.isInsideTable)(destType);
    const destTypeInDocOrLayoutCol = [
        doc,
        layoutColumn
    ].includes(destType);
    // Only run transformation loop if destination may need node conversions:
    // - Table destinations may need expand → nestedExpand
    // - Doc/layoutColumn destinations may need nestedExpand → expand
    // - When panel_c1 experiment is on:
    // - Expand/table/bodied extension destinations may need panel_c1 → panel downgrade
    // - Doc/layoutColumn destinations may need panel → panel_c1 upgrade
    const needsTransformCheck = destTypeInTable || destTypeInDocOrLayoutCol || (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
    if (!needsTransformCheck) return nodeCopy;
    let containsExpand = false;
    let containsNestedExpand = false;
    // Track variant nodes (e.g. panel_c1) and their base forms (e.g. panel).
    // Uses getBaseNodeTypeName to auto-detect variants — new variants only need
    // to be added to variantToBaseNameMap, no changes needed in the detection loop.
    let variantType = null;
    let baseOfVariantType = null;
    for(let i = 0; i < nodeCopy.content.childCount; i++){
        const node = nodeCopy.content.child(i);
        if (node.type === schema.nodes.expand) containsExpand = true;
        else if (node.type === schema.nodes.nestedExpand) containsNestedExpand = true;
        if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
            const baseName = (0, $57Rmq.getBaseNodeTypeName)(node.type);
            if (baseName !== node.type.name) variantType = node.type.name;
            else if (schema.nodes[`${baseName}_c1`]) baseOfVariantType = node.type.name;
        }
        if (containsExpand && containsNestedExpand && (variantType || baseOfVariantType)) break;
    }
    if (containsExpand && destTypeInTable) return (0, $SlYRR.transformSliceExpandToNestedExpand)(nodeCopy);
    else if (containsNestedExpand && destTypeInDocOrLayoutCol) return (0, $jPUdw.transformSliceNestedExpandToExpand)(nodeCopy, schema);
    // Downgrade variant → base (e.g. panel_c1 → panel) when dest doesn't support the variant
    if (variantType && schema.nodes[variantType]) {
        const destParent = destType.createAndFill();
        if (destParent && !(0, $57Rmq.isNodeTypeValidChildOf)(variantType, destParent, schema)) {
            const baseName = (0, $57Rmq.getBaseNodeTypeName)(schema.nodes[variantType]);
            return (0, $SlYRR.transformSliceNodeType)(nodeCopy, schema, variantType, baseName);
        }
    }
    // Upgrade base → variant (e.g. panel → panel_c1) when dest supports the variant
    if (baseOfVariantType) {
        const variantName = `${baseOfVariantType}_c1`;
        if (schema.nodes[variantName]) {
            const destParent = destType.createAndFill();
            if (destParent && (0, $57Rmq.isNodeTypeValidChildOf)(variantName, destParent, schema)) return (0, $SlYRR.transformSliceNodeType)(nodeCopy, schema, baseOfVariantType, variantName);
        }
    }
    return nodeCopy;
}
const $ef5137d75ace3d5c$var$nodesSupportDragLayoutColumnInto = [
    'tableCell',
    'tableHeader',
    'panel',
    'expand',
    'nestedExpand'
];
const $ef5137d75ace3d5c$var$isDragLayoutColumnIntoSupportedNodes = ($from, $to)=>{
    const isTopLevel = $to.depth === 0;
    const toParentTypeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)($to.parent.type) : $to.parent.type.name;
    const isDragIntoNodes = $ef5137d75ace3d5c$var$nodesSupportDragLayoutColumnInto.includes(toParentTypeName);
    const supportedCondition = isDragIntoNodes || isTopLevel;
    return $from.nodeAfter?.type.name === 'layoutColumn' && $from.parent.type.name === 'layoutSection' && supportedCondition;
};
/**
 *
 * @returns the start position of a node if the node can be moved, otherwise -1
 */ const $ef5137d75ace3d5c$var$getCurrentNodePos = (state)=>{
    const { selection: selection } = state;
    let currentNodePos = -1;
    // There are 3 cases when a node can be moved
    const focusedHandle = $ef5137d75ace3d5c$var$getFocusedHandle(state);
    if (focusedHandle) // 1. drag handle of the node is focused
    currentNodePos = focusedHandle.pos;
    else if ((0, $5PIOe.isInTable)(state)) {
        if ((0, $guqmu.isTableSelected)(selection)) // We only move table node if it's fully selected
        // to avoid shortcut collision with table drag and drop
        currentNodePos = (0, $4IGja.findTable)(selection)?.pos ?? currentNodePos;
    } else if (!(state.selection instanceof (0, $4EksL.GapCursorSelection))) {
        // 2. caret cursor is inside the node
        // 3. the start of the selection is inside the node
        currentNodePos = selection.$from.before(1);
        if (selection.$from.depth > 0) currentNodePos = (0, $bnCpE.getNestedNodePosition)({
            selection: selection,
            schema: state.schema,
            resolve: state.doc.resolve.bind(state.doc)
        });
    }
    return currentNodePos;
};
const $ef5137d75ace3d5c$var$getFocusedHandle = (state)=>{
    const { activeNode: activeNode } = (0, $3BXSc.key).getState(state) || {};
    return activeNode && activeNode.handleOptions?.isFocused ? activeNode : undefined;
};
const $ef5137d75ace3d5c$export$3438b98b9a6e008b = (api, direction, formatMessage)=>{
    return (state)=>{
        const { selection: selection } = state;
        const isParentNodeOfTypeLayout = !!(0, $bjg0G.findParentNodeOfType)([
            state.schema.nodes.layoutSection
        ])(state.selection);
        const expandedSelection = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
        const expandedAnchor = expandedSelection.$anchor.pos;
        const expandedHead = expandedSelection.$head.pos;
        let hoistedPos;
        const from = Math.min(expandedAnchor, expandedHead);
        // Nodes like lists nest within themselves, we need to find the top most position
        if (isParentNodeOfTypeLayout) {
            const LAYOUT_COL_DEPTH = 3;
            hoistedPos = state.doc.resolve(from).before(LAYOUT_COL_DEPTH);
        }
        const table = (0, $4o0zT.isExperimentEnabled)('platform_editor_fix_table_move_shortcut') && (0, $guqmu.isTableSelected)(selection) ? (0, $4IGja.findTable)(selection) : undefined;
        let currentNodePos;
        if (table) currentNodePos = table.pos;
        else if (!$ef5137d75ace3d5c$var$getFocusedHandle(state) && !selection.empty) currentNodePos = hoistedPos ?? from;
        else currentNodePos = $ef5137d75ace3d5c$var$getCurrentNodePos(state);
        if (currentNodePos > -1) {
            const $currentNodePos = state.doc.resolve(currentNodePos);
            let nodeAfterPos;
            if (table) nodeAfterPos = table.pos + table.node.nodeSize;
            else if (!$ef5137d75ace3d5c$var$getFocusedHandle(state)) nodeAfterPos = Math.max(expandedAnchor, expandedHead);
            else nodeAfterPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
            const isTopLevelNode = $currentNodePos.depth === 0;
            let moveToPos = -1;
            const isLayoutColumnSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'layoutColumn';
            if (direction === (0, $1xYQH.DIRECTION).LEFT) {
                if (isTopLevelNode && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
                    const nodeBefore = $currentNodePos.nodeBefore;
                    if (nodeBefore) moveToPos = currentNodePos - nodeBefore.nodeSize;
                    if (moveToPos < 0) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveToEnd: true,
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $8v85f.updateSelection)(tr, mappedTo, true);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    moveToPos = selection.from - ($currentNodePos.nodeBefore?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    // get the previous layoutSection node
                    const index = $currentNodePos.index($currentNodePos.depth - 1);
                    const grandParent = $currentNodePos.node($currentNodePos.depth - 1);
                    const previousNode = grandParent ? grandParent.maybeChild(index - 1) : null;
                    moveToPos = $currentNodePos.start() - (previousNode?.nodeSize || 1);
                }
            } else if (direction === (0, $1xYQH.DIRECTION).RIGHT) {
                if (isTopLevelNode && (0, $jkcNT.editorExperiment)('advanced_layouts', true)) {
                    const endOfDoc = $currentNodePos.end();
                    moveToPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
                    if (moveToPos >= endOfDoc) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $8v85f.updateSelection)(tr, mappedTo);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    const index = $currentNodePos.index($currentNodePos.depth);
                    const parent = $currentNodePos.node($currentNodePos.depth);
                    // get the next layoutColumn node
                    const nextNode = parent ? parent.maybeChild(index + 1) : null;
                    // if the current node is the last node, don't do anything
                    if (index >= parent.childCount - 1) // prevent event propagation to avoid moving the cursor and still select the node
                    return true;
                    const moveToEnd = index === parent.childCount - 2;
                    moveToPos = moveToEnd ? $currentNodePos.before() : selection.to + (nextNode?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        moveToEnd: moveToEnd,
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    moveToPos = $currentNodePos.after($currentNodePos.depth) + 1;
                }
            } else if (direction === (0, $1xYQH.DIRECTION).UP) {
                if (isLayoutColumnSelected) moveToPos = $currentNodePos.start() - 1;
                else moveToPos = (0, $9aKak.getPosWhenMoveNodeUp)($currentNodePos, currentNodePos);
            } else {
                const endOfDoc = $currentNodePos.end();
                if (nodeAfterPos > endOfDoc) return false;
                if (isLayoutColumnSelected) moveToPos = state.selection.$from.end() + 1;
                else moveToPos = (0, $9aKak.getPosWhenMoveNodeDown)({
                    $currentNodePos: $currentNodePos,
                    nodeAfterPos: nodeAfterPos,
                    tr: state.tr
                });
            }
            const nodeType = state.doc.nodeAt(currentNodePos)?.type.name;
            let shouldMoveNode = false;
            if (moveToPos > -1) {
                const isDestDepthSameAsSource = $currentNodePos.depth === state.doc.resolve(moveToPos).depth;
                const isSourceLayoutColumn = nodeType === 'layoutColumn';
                shouldMoveNode = isDestDepthSameAsSource || isSourceLayoutColumn;
            }
            const { $anchor: $newAnchor, $head: $newHead } = (0, $iQ6F7.expandSelectionBounds)($currentNodePos, selection.$to);
            if (shouldMoveNode) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    $ef5137d75ace3d5c$export$83751492c88cf2ca(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).SHORTCUT, formatMessage)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            } else {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            }
        }
        return false;
    };
};
const $ef5137d75ace3d5c$export$83751492c88cf2ca = (api)=>(start, to, inputMethod = (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, formatMessage)=>({ tr: tr })=>{
            if (!api || start < 0 || to < 0) return tr;
            const handleNode = tr.doc.nodeAt(start);
            if (!handleNode) return tr;
            const wasCollapsedHeading = (0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $bbndg.isCollapsedHeading)(api, start);
            let sliceFrom = start;
            let sliceTo;
            let sourceNodeTypes, hasSelectedMultipleNodes;
            if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            const preservedSelection = api?.blockControls.sharedState.currentState()?.preservedSelection;
            if (preservedSelection) {
                const $from = tr.doc.resolve(Math.min(start, preservedSelection.from));
                const expandedRange = $from.blockRange(preservedSelection.$to);
                sliceFrom = expandedRange ? expandedRange.start : preservedSelection.from;
                sliceTo = expandedRange ? expandedRange.end : preservedSelection.to;
                const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            } else {
                const slicePosition = (0, $i2jOy.getSelectedSlicePosition)(start, tr, api);
                sliceFrom = slicePosition.from;
                sliceTo = slicePosition.to;
                const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            }
            const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
            const $to = tr.doc.resolve(to);
            const $handlePos = tr.doc.resolve(start);
            const nodeCopy = tr.doc.slice(sliceFrom, sliceTo, false); // cut the content
            const destNode = $to.node();
            const destType = destNode.type;
            const destParent = $to.node($to.depth);
            const sourceNode = $handlePos.nodeAfter;
            //TODO: ED-26959 - Does this need to be updated with new selection logic above? ^
            // Move a layout column to top level, or table cell, or panel, or expand, only moves the content into them
            if (sourceNode && $ef5137d75ace3d5c$var$isDragLayoutColumnIntoSupportedNodes($handlePos, $to)) {
                // need update after we support single column layout.
                const layoutColumnContent = sourceNode.content;
                let fragment;
                // if drop into table, and layout column contains expand, transform it to nestedExpand
                if ([
                    'tableCell',
                    'tableHeader'
                ].includes($to.parent.type.name)) {
                    const contentContainsExpand = (0, $bjg0G.findChildrenByType)(sourceNode, expand).length > 0;
                    fragment = contentContainsExpand ? (0, $SlYRR.transformFragmentExpandToNestedExpand)((0, $aPdNQ.Fragment).from(layoutColumnContent)) : (0, $aPdNQ.Fragment).from(layoutColumnContent);
                    if (!fragment) return tr;
                } else fragment = (0, $aPdNQ.Fragment).from(layoutColumnContent);
                (0, $izfLh.removeFromSource)(tr, $handlePos, $handlePos.pos + sourceNode.nodeSize);
                const mappedTo = tr.mapping.map(to);
                tr.insert(mappedTo, fragment).setSelection((0, $kCECX.Selection).near(tr.doc.resolve(mappedTo))).scrollIntoView();
                return tr;
            }
            if (!(0, $SlYRR.canMoveNodeToIndex)(destParent, $to.index(), $handlePos.node().child($handlePos.index()), $to)) return tr;
            let convertedNodeSlice = $ef5137d75ace3d5c$var$transformSourceSlice(nodeCopy, destType);
            let convertedNode = convertedNodeSlice?.content;
            if (!convertedNode) return tr;
            // Currently we don't support breakout mark for children nodes of bodiedSyncBlock node
            // Hence strip out the mark for now
            if (destNode.type.name === 'bodiedSyncBlock') {
                const nodes = [];
                convertedNodeSlice?.content.forEach((node)=>{
                    nodes.push(node.mark(node.marks.filter((mark)=>mark.type.name !== 'breakout')));
                });
                convertedNodeSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0);
                convertedNode = convertedNodeSlice.content;
            }
            // delete the content from the original position
            tr.delete(sliceFrom, sliceTo);
            const mappedTo = tr.mapping.map(to);
            const isDestNestedLoneEmptyParagraph = destParent.type.name !== 'doc' && destParent.childCount === 1 && (0, $2w79Z.isEmptyParagraph)($to.nodeAfter);
            if (convertedNodeSlice && isDestNestedLoneEmptyParagraph) // if only a single empty paragraph within container, replace it
            tr.replace(mappedTo, mappedTo + 1, convertedNodeSlice);
            else // otherwise just insert the content at the new position
            tr.insert(mappedTo, convertedNode);
            const sliceSize = sliceTo - sliceFrom;
            if (inputMethod === (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP) tr = (0, $bOZni.setCursorPositionAtMovedNode)(tr, mappedTo, api);
            else if (preservedSelection) {
                const currMeta = tr.getMeta((0, $3BXSc.key));
                const nodeMovedOffset = mappedTo - sliceFrom;
                tr.setMeta((0, $3BXSc.key), {
                    ...currMeta,
                    preservedSelectionMapping: new (0, $eOaGc.Mapping)([
                        new (0, $eOaGc.StepMap)([
                            0,
                            0,
                            nodeMovedOffset
                        ])
                    ])
                });
            } else tr = api?.blockControls.commands.setMultiSelectPositions(mappedTo, mappedTo + sliceSize)({
                tr: tr
            }) ?? tr;
            const currMeta = tr.getMeta((0, $3BXSc.key));
            tr.setMeta((0, $3BXSc.key), {
                ...currMeta,
                nodeMoved: true
            });
            if (// when move node via block menu, we need to keep the focus on block menu popup, so don't move focus to editor in this scenario
            inputMethod !== (0, $krYZG.INPUT_METHOD).BLOCK_MENU) api?.core.actions.focus();
            const $mappedTo = tr.doc.resolve(mappedTo);
            if ((0, $4o0zT.isExperimentEnabled)('platform_editor_collapsible_headings')) (0, $bbndg.updateCollapsedHeadingAfterMove)({
                api: api,
                destinationPos: mappedTo,
                isNested: $mappedTo.parent.type.name !== 'doc',
                tr: tr,
                wasCollapsed: wasCollapsedHeading
            });
            const expandAncestor = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($to, [
                expand,
                nestedExpand
            ]);
            if (expandAncestor) {
                const wasExpandExpanded = (0, $8QOo3.expandedState).get(expandAncestor.node);
                const updatedExpandAncestor = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($mappedTo, [
                    expand,
                    nestedExpand
                ]);
                if (wasExpandExpanded !== undefined && updatedExpandAncestor) (0, $8QOo3.expandedState).set(updatedExpandAncestor.node, wasExpandExpanded);
            }
            if ((0, $jkcNT.editorExperiment)('advanced_layouts', true)) (0, $aHnsS.attachMoveNodeAnalytics)(tr, inputMethod, $handlePos.depth, sourceNodeTypes, $mappedTo?.depth, $mappedTo?.parent.type.name, $handlePos.sameParent($mappedTo), api, hasSelectedMultipleNodes);
            else api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).MOVED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: $handlePos.depth,
                    nodeTypes: sourceNodeTypes,
                    destinationNodeDepth: $mappedTo?.depth,
                    destinationNodeType: $mappedTo?.parent.type.name,
                    inputMethod: inputMethod,
                    hasSelectedMultipleNodes: hasSelectedMultipleNodes
                }
            })(tr);
            const movedMessage = to > sliceFrom ? (0, $i6cU6.messages).movedDown : (0, $i6cU6.messages).movedup;
            api?.accessibilityUtils?.actions.ariaNotify(formatMessage ? formatMessage(movedMessage) : movedMessage.defaultMessage, {
                priority: 'important'
            });
            return tr;
        };
module.exports["moveNodeViaShortcut"] = $ef5137d75ace3d5c$export$3438b98b9a6e008b;
module.exports["moveNode"] = $ef5137d75ace3d5c$export$83751492c88cf2ca;

});

parcelRegister("dhlUl", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $rOV4B = parcelRequire("rOV4B");


var $9HWym = parcelRequire("9HWym");


var $3BXSc = parcelRequire("3BXSc");


var $bnCpE = parcelRequire("bnCpE");


var $fKt2m = parcelRequire("fKt2m");

const $a2edf59f0dfc13ac$var$findParentPosForHandle = (state)=>{
    const { selection: { $from: $from } } = state;
    const { activeNode: activeNode } = (0, $3BXSc.key).getState(state) || {};
    // if a node handle is already focused, return the parent pos of that node (with focused handle)
    if (activeNode && activeNode.handleOptions?.isFocused) {
        const $activeNodePos = state.doc.resolve(activeNode.pos);
        // if the handle is at the top level already, do nothing
        if ($activeNodePos.depth === 0) return undefined;
        return $activeNodePos.before();
    }
    // if we are in second level of nested node, we should focus the node at level 1
    if ($from.depth <= 1) return $from.before(1);
    // if we are inside a table, we should focus the table's handle
    const parentTableNode = (0, $bjg0G.findParentNodeOfType)([
        state.schema.nodes.table
    ])(state.selection);
    if (parentTableNode) return parentTableNode.pos;
    // else find closest parent node
    return (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? // as opposed to old approach, node decoration is only added to the node that have drag handle,
    // hence, we need to return the exact position of the node that can have drag handle
    (0, $bnCpE.getNestedNodeStartingPosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    }) : (0, $bnCpE.getNestedNodePosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    });
};
const $a2edf59f0dfc13ac$var$findNextAnchorDecoration = (state)=>{
    const decorations = (0, $3BXSc.getDecorations)(state);
    if (!decorations) return undefined;
    const nextHandleNodePos = $a2edf59f0dfc13ac$var$findParentPosForHandle(state);
    if (nextHandleNodePos === undefined) return undefined;
    const nextHandleNode = state.doc.nodeAt(nextHandleNodePos);
    let nodeDecorations = nextHandleNode && (0, $rOV4B.findNodeDecs)(state, decorations, nextHandleNodePos, nextHandleNodePos + nextHandleNode.nodeSize);
    if (!nodeDecorations || nodeDecorations.length === 0) return undefined;
    // ensure the decoration covers the position of the look up node
    nodeDecorations = nodeDecorations.filter((decoration)=>{
        return decoration.from <= nextHandleNodePos;
    });
    if (nodeDecorations.length === 0) return undefined;
    // sort the decorations by the position of the node
    // so we can find the closest decoration to the node
    nodeDecorations.sort((a, b)=>{
        if (a.from === b.from) return a.to - b.to;
        return b.from - a.from;
    });
    // return the closest decoration to the node
    return nodeDecorations[0];
};
const $a2edf59f0dfc13ac$var$findNextAnchorNode = (view)=>{
    const nextHandleNodePos = $a2edf59f0dfc13ac$var$findParentPosForHandle(view.state);
    if (nextHandleNodePos === undefined) return undefined;
    const dom = view.nodeDOM(nextHandleNodePos);
    if (!(dom instanceof HTMLElement)) return undefined;
    const nodeDOM = dom.closest(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`);
    if (!nodeDOM) return undefined;
    const nodeType = nodeDOM?.getAttribute((0, $fKt2m.NODE_NODE_TYPE_ATTR_NAME));
    const anchorName = nodeDOM?.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME));
    if (nodeType && anchorName) return {
        pos: nextHandleNodePos,
        nodeType: nodeType,
        anchorName: anchorName
    };
};
const $a2edf59f0dfc13ac$export$c78ece06e89c3c69 = (api)=>(state, _, view)=>{
        if (api && (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const pos = $a2edf59f0dfc13ac$var$findParentPosForHandle(state);
            const node = pos === undefined ? undefined : state.doc.nodeAt(pos);
            const anchorName = node && pos !== undefined ? api.core.actions.getAnchorIdForNode(node, pos) : undefined;
            if (!node || pos === undefined || !anchorName) return false;
            return api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, (0, $9HWym.getNodeTypeWithLevel)(node), {
                isFocused: true
            }));
        }
        if (view && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            const anchorNode = $a2edf59f0dfc13ac$var$findNextAnchorNode(view);
            if (api && anchorNode) {
                const { pos: pos, anchorName: anchorName, nodeType: nodeType } = anchorNode;
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, nodeType, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        } else {
            const decoration = $a2edf59f0dfc13ac$var$findNextAnchorDecoration(state);
            if (api && decoration) {
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(decoration.from, decoration.spec.anchorName, decoration.spec.nodeTypeWithLevel, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        }
    };
module.exports["showDragHandleAtSelection"] = $a2edf59f0dfc13ac$export$c78ece06e89c3c69;

});

parcelRegister("2w4SV", function(module, exports) {

var $j8XGH = parcelRequire("j8XGH");


var $lVAkE = parcelRequire("lVAkE");

var $1GYCH = parcelRequire("1GYCH");


var $kCECX = parcelRequire("kCECX");


var $7qyBc = parcelRequire("7qyBc");


var $iDrrr = parcelRequire("iDrrr");


var $bOZni = parcelRequire("bOZni");


var $i2jOy = parcelRequire("i2jOy");

const $2741375fabeec33a$var$isPosWithinRange = (pos, range)=>{
    return range.start <= pos && range.end >= pos + 1;
};
/**
 * Expands the current selection to encompass the full block range
 * starting from the given resolved position.
 */ const $2741375fabeec33a$var$getExpandedSelectionRange = ({ selection: selection, doc: doc, resolvedStartPos: resolvedStartPos, isShiftPressed: isShiftPressed })=>{
    // When not pressing shift, expand the current selection
    // When shift selecting upwards, expand from start of node to selection end
    // When shift selecting downwards, expand from selection start to end of node
    const selectUp = resolvedStartPos.pos < selection.from;
    const $from = isShiftPressed && selectUp ? resolvedStartPos : selection.$from;
    const $to = isShiftPressed && !selectUp ? doc.resolve(resolvedStartPos.pos + 1) : selection.$to;
    const adjusted = isShiftPressed ? {
        $from: $from,
        $to: $to
    } : (0, $i2jOy.adjustSelectionBoundsForEdgePositions)($from, $to);
    return (0, $lVAkE.expandToBlockRange)(adjusted.$from, adjusted.$to);
};
const $2741375fabeec33a$export$35df69b489f451a1 = ({ tr: tr, selection: selection, startPos: startPos, isShiftPressed: isShiftPressed, nodeType: nodeType, api: api })=>{
    const resolvedStartPos = tr.doc.resolve(startPos);
    const expandedRange = $2741375fabeec33a$var$getExpandedSelectionRange({
        doc: tr.doc,
        selection: selection,
        resolvedStartPos: resolvedStartPos,
        isShiftPressed: isShiftPressed
    });
    // Set selection to expanded selection range if it encompasses the clicked drag handle
    if (expandedRange.range && $2741375fabeec33a$var$isPosWithinRange(startPos, expandedRange.range) && (0, $1GYCH.isMultiBlockRange)(expandedRange.range)) // Then create a selection from the start of the first node to the end of the last node
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(selection.from, expandedRange.$from.pos), Math.max(selection.to, expandedRange.$to.pos)));
    else if ((0, $iDrrr.fg)('platform_editor_maui_jira_updates')) // Under the gate (and when on the simplified newGetSelection path), use
    // the platform-level composer — same path as open-remix-modal, no drift.
    (0, $j8XGH.selectNodeAtPos)(tr, startPos, nodeType);
    else if (nodeType === 'table') (0, $7qyBc.selectTableClosestToPos)(tr, tr.doc.resolve(startPos + 1));
    else // Select the clicked drag handle's node only
    (0, $bOZni.selectNode)(tr, startPos, nodeType, api);
};
module.exports["expandAndUpdateSelection"] = $2741375fabeec33a$export$35df69b489f451a1;

});

parcelRegister("frZvB", function(module, exports) {
/** @jsxRuntime classic */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");

function $11a45f4f8c8dbe6d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $11a45f4f8c8dbe6d$var$spanStyles = {
    name: "jpyn4z",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0"
};
const $11a45f4f8c8dbe6d$var$svgSizeStyles = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $11a45f4f8c8dbe6d$var$svgStyles = {
    name: "1l1mozn",
    styles: "color:currentColor;overflow:hidden;pointer-events:none;vertical-align:bottom"
};
const $11a45f4f8c8dbe6d$export$bd2793d885851030 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "aria-hidden": true,
        css: $11a45f4f8c8dbe6d$var$spanStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "-8 -8 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        css: [
            $11a45f4f8c8dbe6d$var$svgStyles,
            $11a45f4f8c8dbe6d$var$svgSizeStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "2.75",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "13.25",
        r: "1.75",
        fill: "currentColor"
    })));
};
module.exports["DragHandleNestedIcon"] = $11a45f4f8c8dbe6d$export$bd2793d885851030;

});

parcelRegister("9BGzJ", function(module, exports) {

var $8dxef = parcelRequire("8dxef");

const $eb345a349d4a6459$var$previewStyle = {
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 3px)",
    borderWidth: "var(--ds-border-width-selected, 2px)",
    backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $eb345a349d4a6459$var$getPreviewContainerDimensionsForSingle = (dom, nodeType)=>{
    let nodeContainer = dom;
    const iframeContainer = dom.querySelector('iframe');
    if (nodeType === 'embedCard') nodeContainer = dom.querySelector('.rich-media-item') || dom;
    else if (nodeType === 'extension' && iframeContainer) nodeContainer = iframeContainer;
    const nodeContainerRect = nodeContainer.getBoundingClientRect();
    return {
        width: nodeContainerRect.width,
        height: nodeContainerRect.height
    };
};
const $eb345a349d4a6459$var$getPreviewContainerDimensions = (dragPreviewContent)=>{
    let maxWidth = 0;
    let heightSum = 0;
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const { width: width, height: height } = $eb345a349d4a6459$var$getPreviewContainerDimensionsForSingle(element.dom, element.nodeType);
        if (width > maxWidth) maxWidth = width;
        heightSum += height;
    }
    return {
        width: maxWidth,
        height: heightSum
    };
};
const $eb345a349d4a6459$var$createGenericPreview = ()=>{
    const generalPreview = document.createElement('div');
    // ProseMirror class is required to make sure the cloned dom is styled correctly
    generalPreview.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    generalPreview.style.border = `${$eb345a349d4a6459$var$previewStyle.borderWidth} ${$eb345a349d4a6459$var$previewStyle.borderStyle} ${$eb345a349d4a6459$var$previewStyle.borderColor}`;
    generalPreview.style.borderRadius = $eb345a349d4a6459$var$previewStyle.borderRadius;
    generalPreview.style.backgroundColor = $eb345a349d4a6459$var$previewStyle.backgroundColor;
    generalPreview.style.height = '100%';
    generalPreview.setAttribute('data-testid', 'block-ctrl-generic-drag-preview');
    return generalPreview;
};
const $eb345a349d4a6459$var$createContentPreviewElement = (dom, nodeType, nodeSpacing)=>{
    const contentPreviewOneElement = document.createElement('div');
    contentPreviewOneElement.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    const resizer = dom.querySelector('.resizer-item');
    const clonedDom = resizer && [
        'mediaSingle',
        'table'
    ].includes(nodeType) ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    resizer.cloneNode(true) : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom.cloneNode(true);
    const browser = (0, $8dxef.getBrowserInfo)();
    clonedDom.style.marginLeft = '0';
    clonedDom.style.marginTop = nodeSpacing ? `${nodeSpacing.top}` : '0';
    clonedDom.style.marginRight = '0';
    clonedDom.style.marginBottom = nodeSpacing ? `${nodeSpacing.bottom}` : '0';
    clonedDom.style.boxShadow = 'none';
    clonedDom.style.opacity = browser.windows ? '1' : '0.31';
    contentPreviewOneElement.appendChild(clonedDom);
    return contentPreviewOneElement;
};
const $eb345a349d4a6459$var$isGenericPreview = (dom, nodeType)=>{
    const embedCard = dom.querySelector('.embedCardView-content-wrap');
    return nodeType === 'embedCard' || !!embedCard || nodeType === 'extension' && !!dom.querySelector('iframe');
};
const $eb345a349d4a6459$var$createPreviewForElement = (dom, nodeType, nodeSpacing)=>{
    const shouldBeGenericPreview = $eb345a349d4a6459$var$isGenericPreview(dom, nodeType);
    if (shouldBeGenericPreview) return $eb345a349d4a6459$var$createGenericPreview();
    else return $eb345a349d4a6459$var$createContentPreviewElement(dom, nodeType, nodeSpacing);
};
const $eb345a349d4a6459$export$3ec2e625089820fa = (container, dragPreviewContent)=>{
    container.style.pointerEvents = 'none';
    if (!Array.isArray(dragPreviewContent) && typeof dragPreviewContent === 'object') dragPreviewContent = [
        dragPreviewContent
    ];
    const { width: maxWidth, height: maxHeight } = $eb345a349d4a6459$var$getPreviewContainerDimensions(dragPreviewContent);
    container.style.width = `${maxWidth}px`;
    container.style.height = `${maxHeight}px`;
    const previewWrapperFragment = document.createDocumentFragment();
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const contentPreviewOneElement = $eb345a349d4a6459$var$createPreviewForElement(element.dom, element.nodeType, element.nodeSpacing);
        previewWrapperFragment.appendChild(contentPreviewOneElement);
    }
    container.appendChild(previewWrapperFragment);
    const scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    const scrollParentClassNames = scrollParent?.className;
    // Add the scroll parent class to the container to ensure the cloned element is styled correctly
    container.className = scrollParentClassNames || '';
    container.classList.remove('fabric-editor-popup-scroll-parent');
    // Prevents a scrollbar from showing
    container.style.overflow = 'visible';
    return ()=>container;
};
module.exports["dragPreview"] = $eb345a349d4a6459$export$3ec2e625089820fa;

});

parcelRegister("eYPgl", function(module, exports) {
// Nested layout columns use the full block handle; other non-top-level nodes use the nested icon.
const $aed74123127af613$export$148a39002dbd1689 = (isTopLevelNode, isLayoutColumn)=>{
    if (isTopLevelNode) return false;
    if (isLayoutColumn) return false;
    return true;
};
module.exports["shouldUseNestedDragHandleIcon"] = $aed74123127af613$export$148a39002dbd1689;

});

parcelRegister("4LOJc", function(module, exports) {

var $2w79Z = parcelRequire("2w79Z");


var $jkcNT = parcelRequire("jkcNT");


var $1gg4H = parcelRequire("1gg4H");


var $icvkv = parcelRequire("icvkv");

const $119770649cfd47fd$var$syncedBlockTypes = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $119770649cfd47fd$export$9d1974d3f03f9d59 = (isNested, node, /**
	 * Is the active node in the same layout as the target node
	 */ isSameLayout = false, activeNode, parentNode)=>{
    const isInsideBodiedSyncBlock = parentNode?.type.name === 'bodiedSyncBlock';
    if ((0, $jkcNT.editorExperiment)('advanced_layouts', false) || isNested) {
        // If nested inside bodiedSyncBlock, enable inline drop target so user can drop to create a layout inside it
        if (isInsideBodiedSyncBlock) return true;
        return false;
    }
    if ((0, $1gg4H.isWrappedMedia)(node)) return false;
    if (activeNode?.nodeType === 'layoutSection') return false;
    if ($119770649cfd47fd$var$syncedBlockTypes.includes(activeNode?.nodeType || '') || $119770649cfd47fd$var$syncedBlockTypes.includes(node?.type.name || '')) return false;
    if (node?.type.name === 'layoutSection') return node.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout;
    return !(0, $2w79Z.isEmptyParagraph)(node);
};
module.exports["shouldAllowInlineDropTarget"] = $119770649cfd47fd$export$9d1974d3f03f9d59;

});

parcelRegister("fmErs", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $4o0zT = parcelRequire("4o0zT");


var $vZEJe = parcelRequire("vZEJe");


var $4Vdlk = parcelRequire("4Vdlk");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $8v85f = parcelRequire("8v85f");

function $64b8abc41abcb6e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH = '--editor-blocks-inline-hover-zone-width';
const $64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT = '--editor-blocks-inline-hover-zone-height';
const $64b8abc41abcb6e2$var$HOVER_ZONE_TOP = '--editor-blocks-inline-hover-zone-top';
const $64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM = '--editor-blocks-inline-hover-zone-bottom';
const $64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME = '--editor-blocks-inline-hover-zone-anchor-name';
const $64b8abc41abcb6e2$var$hoverZoneCommonStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    // above the top and bottom drop zone as block hover zone
    zIndex: 120,
    positionAnchor: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME})`,
    minWidth: "var(--ds-space-100, 8px)",
    left: 0,
    right: 0,
    width: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH})`,
    height: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT})`
});
const $64b8abc41abcb6e2$var$leftHoverZoneStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    right: `unset`,
    top: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_TOP})`,
    bottom: 'unset'
});
const $64b8abc41abcb6e2$var$rightHoverZoneStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    left: `unset`,
    top: 'unset',
    bottom: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM})`
});
// gap between node boundary and drop indicator/drop zone
const $64b8abc41abcb6e2$var$GAP = 4;
const $64b8abc41abcb6e2$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    position: 'absolute',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0,
    left: 0
});
const $64b8abc41abcb6e2$var$dropTargetLayoutHintLeftStyle = {
    name: "go864d",
    styles: "left:unset;right:0"
};
const $64b8abc41abcb6e2$var$defaultNodeDimension = {
    width: '0',
    height: '0',
    top: 'unset',
    bottom: 'unset'
};
const $64b8abc41abcb6e2$var$getWidthOffset = (node, width, position)=>{
    if ([
        'mediaSingle',
        'table',
        'embedCard'
    ].includes(node.type.name) || // block card (without datasource) is positioned left-aligned, hence share the same logic as align-start
    node.type.name === 'blockCard' && !node.attrs.datasource) {
        const isLeftPosition = position === 'left';
        if (node.attrs.layout === 'align-start' || node.type.name === 'blockCard') return isLeftPosition ? `-0.5*(var(--ak-editor--line-length) - ${width})` : `0.5*(var(--ak-editor--line-length) - ${width})`;
        else if (node?.attrs.layout === 'align-end') return isLeftPosition ? `0.5*(var(--ak-editor--line-length) - ${width})` : `-0.5*(var(--ak-editor--line-length) - ${width})`;
    }
    if (node.type.name === 'bodiedExtension' || node.type.name === 'extension' || node.type.name === 'multiBodiedExtension' && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '-12px';
};
const $64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH = 42;
const $64b8abc41abcb6e2$export$ade48236ff38648e = ({ api: api, nextNode: nextNode, position: position, anchorRectCache: anchorRectCache, getPos: getPos })=>{
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $cozmU.useMemo)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) return nextNode ? api?.core.actions.getAnchorIdForNode(nextNode, getPos() ?? -1) || '' : '';
        return nextNode ? (0, $9HWym.getNodeAnchor)(nextNode) : '';
    }, [
        api,
        getPos,
        nextNode
    ]);
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const isLeftPosition = position === 'left';
    const nodeDimension = (0, $cozmU.useMemo)(()=>{
        if (!nextNode) return $64b8abc41abcb6e2$var$defaultNodeDimension;
        const nextNodePos = getPos();
        let innerContainerWidth = null;
        let targetAnchorName = anchorName;
        if ([
            'blockCard',
            'embedCard',
            'extension'
        ].includes(nextNode.type.name)) {
            if (nextNode.attrs.layout === 'wide') innerContainerWidth = `max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))`;
            else if (nextNode.attrs.layout === 'full-width') innerContainerWidth = `min(calc(100cqw - ${0, $7Y8M5.akEditorBreakoutPadding}px), 1800px)`;
            if (nextNode.type.name === 'blockCard' && !nextNode.attrs.layout && nextNode.attrs.datasource) // block card with sourceNode and without layout has different width in full-width vs fixed-width editor
            // Hence we need to set it based on editor mode
            innerContainerWidth = 'var(--ak-editor-block-card-width)';
            if (nextNode.type.name === 'embedCard' && [
                'center',
                'align-start',
                'align-end'
            ].includes(nextNode.attrs.layout)) {
                const percentageWidth = ((parseFloat(nextNode.attrs.width) || 100) / 100).toFixed(2);
                innerContainerWidth = `calc(var(--ak-editor--line-length) * ${percentageWidth})`;
            }
        } else if (nextNode.type.name === 'table' && nextNode.firstChild) {
            const tableWidthAnchor = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration') ? typeof nextNodePos === 'number' ? api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '' : '' : (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
            const isNumberColumnEnabled = Boolean(nextNode.attrs.isNumberColumnEnabled);
            if ((0, $a4QVD.isAnchorSupported)()) innerContainerWidth = isNumberColumnEnabled ? `calc(anchor-size(${tableWidthAnchor} width) + ${$64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH}px)` : `anchor-size(${tableWidthAnchor} width)`;
            else innerContainerWidth = `${(anchorRectCache?.getRect(tableWidthAnchor)?.width || 0) + $64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH}px`;
            if (nextNode.attrs.width) // when the table has horizontal scroll
            innerContainerWidth = `min(${nextNode.attrs.width}px, ${innerContainerWidth})`;
        } else if (nextNode.type.name === 'mediaSingle' && nextNode.firstChild) {
            if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) // check pos is a number
            {
                if (typeof nextNodePos === 'number' && nextNode.firstChild?.type.name === 'media') targetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
            } else targetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
        }
        // Set the height target anchor name to the first or last column of the layout section so that it also works for stacked layout
        let heightTargetAnchorName = targetAnchorName;
        if (nextNode.type.name === 'layoutSection' && nextNode.firstChild && nextNode.lastChild) {
            if (isLeftPosition) {
                if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                    if (typeof nextNodePos === 'number') heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
                    else heightTargetAnchorName = '';
                } else heightTargetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
            } else if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_block_control_migration')) {
                if (typeof nextNodePos === 'number') {
                    const lastNodeStartPos = nextNode.content.size - nextNode.lastChild.nodeSize;
                    heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.lastChild, lastNodeStartPos + 1) || '';
                } else heightTargetAnchorName = '';
            } else heightTargetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.lastChild);
        }
        if ((0, $a4QVD.isAnchorSupported)()) {
            const width = innerContainerWidth || `anchor-size(${targetAnchorName} width)`;
            const height = `anchor-size(${heightTargetAnchorName} height)`;
            return {
                width: width,
                height: height,
                top: 'anchor(top)',
                bottom: 'anchor(bottom)',
                widthOffset: $64b8abc41abcb6e2$var$getWidthOffset(nextNode, width, position)
            };
        }
        if (anchorRectCache) {
            const nodeRect = anchorRectCache.getRect(targetAnchorName);
            const width = innerContainerWidth || `${nodeRect?.width || 0}px`;
            const top = nodeRect?.top ? `${nodeRect?.top}px` : 'unset';
            const bottom = `100% - ${nodeRect?.bottom || 0}px + ${$64b8abc41abcb6e2$var$GAP}px`;
            let height = `${nodeRect?.height || 0}px`;
            if (heightTargetAnchorName !== targetAnchorName) {
                const nodeHeightRect = anchorRectCache.getRect(heightTargetAnchorName);
                height = `${nodeHeightRect?.height || 0}px + ${$64b8abc41abcb6e2$var$GAP}px`;
            }
            return {
                width: width,
                height: height,
                top: top,
                bottom: bottom,
                widthOffset: $64b8abc41abcb6e2$var$getWidthOffset(nextNode, width, position)
            };
        }
        return $64b8abc41abcb6e2$var$defaultNodeDimension;
    }, [
        nextNode,
        anchorName,
        anchorRectCache,
        getPos,
        api,
        isLeftPosition,
        position
    ]);
    const onDrop = (0, $cozmU.useCallback)(()=>{
        const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
        if (!activeNode) return;
        const toPos = getPos();
        let mappedTo;
        if (activeNode && toPos !== undefined) {
            const { pos: start } = activeNode;
            const moveToEnd = position === 'right';
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(start, toPos, {
                    moveToEnd: moveToEnd
                })({
                    tr: tr
                });
                const insertLayoutStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertLayoutStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo, moveToEnd);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        position
    ]);
    const hoverZoneRectStyle = (0, $cozmU.useMemo)(()=>{
        const isLayoutNode = nextNode?.type.name === 'layoutSection';
        const layoutAdjustment = isLayoutNode ? {
            width: 11,
            height: 4,
            top: 6,
            bottom: 2
        } : undefined;
        return {
            [$64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH]: nodeDimension.widthOffset ? `calc((100% - ${nodeDimension.width})/2 - ${$64b8abc41abcb6e2$var$GAP}px + ${nodeDimension.widthOffset} - ${layoutAdjustment?.width || 0}px)` : `calc((100% - ${nodeDimension.width})/2 - ${$64b8abc41abcb6e2$var$GAP}px - ${layoutAdjustment?.width || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT]: `calc(${nodeDimension.height} + ${layoutAdjustment?.height || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_TOP]: `calc(${nodeDimension.top} + ${layoutAdjustment?.top || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM]: `calc(${nodeDimension.bottom} - ${layoutAdjustment?.bottom || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME]: anchorName
        };
    }, [
        nextNode?.type.name,
        nodeDimension,
        anchorName
    ]);
    const dropIndicatorPos = (0, $cozmU.useMemo)(()=>{
        return isLeftPosition ? 'right' : 'left';
    }, [
        isLeftPosition
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $4Vdlk.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        setIsDraggedOver
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        "data-testid": `drop-target-hover-zone-${position}`,
        css: [
            $64b8abc41abcb6e2$var$hoverZoneCommonStyle,
            isLeftPosition ? $64b8abc41abcb6e2$var$leftHoverZoneStyle : $64b8abc41abcb6e2$var$rightHoverZoneStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hoverZoneRectStyle
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: dropIndicatorPos
    }) : isActiveAnchor && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: [
            $64b8abc41abcb6e2$var$dropTargetLayoutHintStyle,
            isLeftPosition && $64b8abc41abcb6e2$var$dropTargetLayoutHintLeftStyle
        ]
    }));
};
module.exports["InlineDropTarget"] = $64b8abc41abcb6e2$export$ade48236ff38648e;

});

parcelRegister("8v85f", function(module, exports) {

var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");

const $f1fa1884dbbf5a48$export$fc81c36e83ce2f6b = (tr)=>tr.steps.find((step)=>step instanceof (0, $eOaGc.ReplaceStep) && [
            'layoutSection',
            'layoutColumn'
        ].includes(step.slice.content.firstChild?.type.name || ''));
const $f1fa1884dbbf5a48$export$2e8776145e31b87 = (tr, to, insertAtRight)=>{
    const $to = tr.doc.resolve(to);
    const toNode = $to.nodeAfter;
    let lastNode = toNode?.content.lastChild;
    if (!toNode || !lastNode) return tr;
    let offset = toNode.nodeSize;
    // drop at the start of the layoutSection or to create a new layoutSection
    if (toNode.type.name === 'layoutSection') {
        if (insertAtRight) {
            lastNode = toNode.content.lastChild?.lastChild;
            offset = toNode.nodeSize - 1;
        } else {
            lastNode = toNode.content.firstChild?.lastChild;
            offset = 1 + (toNode.content.firstChild?.nodeSize || 0);
        }
    }
    if ([
        'paragraph',
        'heading'
    ].includes(lastNode?.type.name || '')) tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(to + offset - 2)));
    else if (lastNode) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(to + offset - 1), (0, $eaLat.Side).RIGHT));
    return tr;
};
module.exports["getInsertLayoutStep"] = $f1fa1884dbbf5a48$export$fc81c36e83ce2f6b;
module.exports["updateSelection"] = $f1fa1884dbbf5a48$export$2e8776145e31b87;

});

parcelRegister("g7xpB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $445fdc1231eed741$export$714e822c87fefc18 = (view)=>{
    const selection = view.state.selection;
    return selection instanceof (0, $kCECX.NodeSelection) && selection.$from.depth > 0;
};
const $445fdc1231eed741$export$9aa13fc11fb69569 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    const endPos = start + node.nodeSize;
    const startPos = start;
    const { $from: $from, $to: $to } = view.state.selection;
    return $from.pos >= startPos && endPos >= $to.pos;
};
const $445fdc1231eed741$export$ec6e1e8159855f97 = (view)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $kCECX.TextSelection)) return true;
    else if (selection instanceof (0, $kCECX.NodeSelection)) // check if this is a node that can appear among text
    return selection.node.isInline;
};
const $445fdc1231eed741$export$907327ee9908a2 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    // We want to treat some elements as if they are non-editable blocks for
    // the purposes of quick insert.
    switch(node.type.name){
        // mediaSingle and mediaGroup always contain a media child node, which is
        // both a block and an atom. mediaSingle can also have a caption child node
        // which is an editable block.
        case 'mediaGroup':
        case 'mediaSingle':
            return true;
    }
    return node.isBlock && (node.isAtom || node.isLeaf);
};
module.exports["isNestedNodeSelected"] = $445fdc1231eed741$export$714e822c87fefc18;
module.exports["isSelectionInNode"] = $445fdc1231eed741$export$9aa13fc11fb69569;
module.exports["isInTextSelection"] = $445fdc1231eed741$export$ec6e1e8159855f97;
module.exports["isNonEditableBlock"] = $445fdc1231eed741$export$907327ee9908a2;

});

parcelRegister("5Cc13", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $a11aceeda7cf57c6$export$3ca0fafcb5f79c56 = (start)=>({ tr: tr })=>{
        const nodeSize = tr.doc.nodeAt(start)?.nodeSize;
        if (nodeSize === undefined) return tr;
        const position = start + nodeSize;
        tr.insert(position, tr.doc.type.schema.nodes.paragraph.create());
        return tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(position)));
    };
module.exports["createNewLine"] = $a11aceeda7cf57c6$export$3ca0fafcb5f79c56;

});

parcelRegister("bbndg", function(module, exports) {
const $c98671baab5825d6$export$4743a08233429483 = (api, headingPos)=>{
    const sectionEnd = api?.blockCollapse?.sharedState.currentState()?.collapsedSectionEnds.get(headingPos);
    return sectionEnd === undefined ? undefined : {
        from: headingPos,
        to: sectionEnd
    };
};
const $c98671baab5825d6$export$2cc0ed669795e688 = (api, headingPos)=>api?.blockCollapse?.sharedState.currentState()?.collapsedSectionEnds.has(headingPos) ?? false;
const $c98671baab5825d6$export$4b8c7e87a2c4e54b = ({ api: api, expand: expand, headingPos: headingPos, tr: tr })=>{
    const range = $c98671baab5825d6$export$4743a08233429483(api, headingPos);
    if (!range) return false;
    if (expand) api?.blockCollapse?.commands.expandHeading(headingPos)({
        tr: tr
    });
    api?.blockControls?.commands.setMultiSelectPositions(range.from, range.to)({
        tr: tr
    });
    return true;
};
const $c98671baab5825d6$export$94408caa6f98c4e6 = ({ api: api, destinationPos: destinationPos, isNested: isNested, tr: tr, wasCollapsed: wasCollapsed })=>{
    if (!wasCollapsed) return;
    if (isNested) {
        api?.blockCollapse?.commands.expandHeading(destinationPos)({
            tr: tr
        });
        return;
    }
    api?.blockCollapse?.commands.collapseHeadingsAtPositions([
        destinationPos
    ])({
        tr: tr
    });
};
module.exports["isCollapsedHeading"] = $c98671baab5825d6$export$2cc0ed669795e688;
module.exports["prepareCollapsedHeadingSelection"] = $c98671baab5825d6$export$4b8c7e87a2c4e54b;
module.exports["updateCollapsedHeadingAfterMove"] = $c98671baab5825d6$export$94408caa6f98c4e6;

});

parcelRegister("bnCpE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $dc8372ba6657a890$export$35954ff4e514ba11 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $kCECX.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const parentNodeOfSpecificTypes = (0, $bjg0G.findParentNodeOfType)([
            schema.nodes.bulletList,
            schema.nodes.orderedList,
            schema.nodes.blockquote,
            schema.nodes.taskList,
            schema.nodes.decisionList
        ])(selection);
        if (parentNodeOfSpecificTypes) {
            const parentNodeType = parentNodeOfSpecificTypes.node.type.name;
            nestedNodePos = [
                'bulletList',
                'orderedList'
            ].includes(parentNodeType) ? $pos.before($pos.depth - 1) : [
                'blockquote',
                'taskList',
                'decisionList'
            ].includes(parentNodeType) ? $pos.before() : nestedNodePos;
        }
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $dc8372ba6657a890$export$ac406f4d57a10c33 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $kCECX.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const { bulletList: bulletList, orderedList: orderedList, taskList: taskList, decisionList: decisionList, caption: caption } = schema.nodes;
        const isInList = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            orderedList,
            taskList
        ])(selection);
        const isInNodeWithoutDragHandle = (0, $bjg0G.findParentNodeOfType)([
            caption,
            decisionList
        ])(selection);
        if (isInList) // Only show drag handle at outermost list parent
        nestedNodePos = $dc8372ba6657a890$var$getOutermostListPos($pos, resolve);
        else if (isInNodeWithoutDragHandle) // return the position of their parent if there should be no drag handle before the node
        nestedNodePos = $pos.before();
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $dc8372ba6657a890$var$getOutermostListPos = ($pos, resolve)=>{
    if ($pos.depth === 0) return $pos.pos;
    const parentPos = $pos.before();
    const parentNode = $pos.parent;
    if (parentNode && [
        'bulletList',
        'listItem',
        'orderedList',
        'taskList',
        'taskItem'
    ].includes(parentNode.type.name)) return $dc8372ba6657a890$var$getOutermostListPos(resolve(parentPos), resolve);
    return $pos.pos;
};
module.exports["getNestedNodePosition"] = $dc8372ba6657a890$export$35954ff4e514ba11;
module.exports["getNestedNodeStartingPosition"] = $dc8372ba6657a890$export$ac406f4d57a10c33;

});

parcelRegister("izfLh", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $jkcNT = parcelRequire("jkcNT");


var $irTNm = parcelRequire("irTNm");


var $icvkv = parcelRequire("icvkv");


var $7vrPh = parcelRequire("7vrPh");

const $0896a2e13569b3ce$export$29bd206d467fd44 = (tr, $from, to)=>{
    const sourceContent = tr.doc.slice($from.pos, to).content;
    const isLayoutColumn = (0, $irTNm.isFragmentOfType)(sourceContent, 'layoutColumn');
    /**
	 * This logic is used to handle the case when a user tries to delete a layout column
	 * that contains only 2 child node, and single column layouts are not enabled.
	 * In this case, we delete the layout column and replace it with its content.
	 */ if (isLayoutColumn && !(0, $jkcNT.editorExperiment)('single_column_layouts', true)) {
        const sourceParent = $from.parent;
        if (sourceParent.childCount === (0, $icvkv.MIN_LAYOUT_COLUMN)) {
            // Only delete the layout content, but keep the layout column itself
            // This logic should be remove when we clean up the code for single column layouts.
            // since this step has no effect on the layout column, because the parent node is removed in the later step.
            tr.delete($from.pos + 1, to - 1);
            // This check should be remove when clean up the code for single column layouts.
            // since it has been checked in the previous step.
            if (sourceParent.childCount === 2) {
                const layoutContentFragment = $from.parentOffset === 0 ? (0, $aPdNQ.Fragment).from($from.parent.lastChild?.content) : (0, $aPdNQ.Fragment).from($from.parent.firstChild?.content);
                const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>{
                    return node.type.name === 'layoutSection';
                });
                if (parent && layoutContentFragment) {
                    const layoutSectionPos = tr.mapping.map(parent.pos);
                    // get the updated layout node size
                    const layoutSectionNodeSize = tr.doc.resolve(layoutSectionPos).nodeAfter?.nodeSize || 0;
                    tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment);
                }
            }
            return tr;
        } else (0, $7vrPh.updateColumnWidths)(tr, $from.parent, $from.before($from.depth), sourceParent.childCount - 1);
    }
    tr.delete($from.pos, to);
    return tr;
};
module.exports["removeFromSource"] = $0896a2e13569b3ce$export$29bd206d467fd44;

});

parcelRegister("9aKak", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $4IGja = parcelRequire("4IGja");

var $guqmu = parcelRequire("guqmu");


var $i2jOy = parcelRequire("i2jOy");

const $7a64999ea229affc$export$c57c553e4ac98a48 = (selection)=>{
    // Special case: if a table is selected, we want to move the entire table node
    const tableInfo = (0, $4IGja.findTable)(selection);
    if (tableInfo && (0, $guqmu.isTableSelected)(selection)) {
        const tablePos = tableInfo.pos;
        const tableTo = tablePos + tableInfo.node.nodeSize;
        return {
            from: tablePos,
            to: tableTo
        };
    }
    // Special case: if a media node (file) is selected, we need to get the parent mediaGroup
    // This handles the case where clicking on a file creates a NodeSelection of the media node
    // but we want to move the entire mediaGroup that wraps it
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file') {
        // The media node is wrapped in a mediaGroup, so we need to get the parent position
        const mediaGroupPos = selection.$from.pos - 1;
        const mediaGroupNode = selection.$from.doc.nodeAt(mediaGroupPos);
        if (mediaGroupNode && mediaGroupNode.type.name === 'mediaGroup') return {
            from: mediaGroupPos,
            to: mediaGroupPos + mediaGroupNode.nodeSize
        };
    }
    // Use createPreservedSelection to get properly expanded block boundaries
    const preservedSelection = (0, $i2jOy.createPreservedSelection)(selection.$from, selection.$to);
    if (!preservedSelection) return undefined;
    return {
        from: preservedSelection.from,
        to: preservedSelection.to
    };
};
const $7a64999ea229affc$export$6e259a78a1c38d78 = ($currentNodePos, currentNodePos)=>{
    const nodeIndex = $currentNodePos.index();
    const nodeBefore = $currentNodePos.depth > 1 && nodeIndex === 0 ? $currentNodePos.node($currentNodePos.depth) : $currentNodePos.nodeBefore;
    if (nodeBefore?.type.name === 'layoutColumn') return -1;
    return nodeBefore ? currentNodePos - nodeBefore.nodeSize : -1;
};
const $7a64999ea229affc$export$3545fa32cdadf3ca = ({ $currentNodePos: $currentNodePos, nodeAfterPos: nodeAfterPos, tr: tr })=>{
    const endOfDoc = $currentNodePos.end();
    if (nodeAfterPos > endOfDoc) return -1;
    const nodeAfter = tr.doc.nodeAt(nodeAfterPos);
    const nodeAtCurrentPos = tr.doc.nodeAt($currentNodePos.pos);
    // if move empty line down to another empty line, move to the position of the next empty line
    if (nodeAtCurrentPos?.content.size === 0 && nodeAtCurrentPos.type.name !== 'extension' && nodeAfter?.content.size === 0 && nodeAfter.type.name !== 'extension') return nodeAfterPos;
    // if not the last node, move to the end of the next node
    return nodeAfter ? nodeAfterPos + nodeAfter.nodeSize : -1;
};
const $7a64999ea229affc$export$c6093962982030d2 = ({ currentNodePos: currentNodePos, moveToPos: moveToPos, tr: tr })=>{
    // only move the node if the destination is at the same depth, not support moving a nested node to a parent node
    return moveToPos > -1 && tr.doc.resolve(currentNodePos).depth === tr.doc.resolve(moveToPos).depth;
};
const $7a64999ea229affc$export$cc4db90b9d5a445a = (tr)=>{
    const nodeBounds = $7a64999ea229affc$export$c57c553e4ac98a48(tr.selection);
    if (!nodeBounds || nodeBounds.from <= -1) return {
        moveUp: false,
        moveDown: false
    };
    const currentNodePos = nodeBounds.from;
    const $currentNodePos = tr.doc.resolve(currentNodePos);
    const nodeAfterPos = nodeBounds.to;
    const moveUpPos = $7a64999ea229affc$export$6e259a78a1c38d78($currentNodePos, currentNodePos);
    const moveDownPos = $7a64999ea229affc$export$3545fa32cdadf3ca({
        $currentNodePos: $currentNodePos,
        nodeAfterPos: nodeAfterPos,
        tr: tr
    });
    return {
        moveUp: $7a64999ea229affc$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveUpPos,
            tr: tr
        }),
        moveDown: $7a64999ea229affc$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveDownPos,
            tr: tr
        })
    };
};
module.exports["getNodeBoundsFromSelection"] = $7a64999ea229affc$export$c57c553e4ac98a48;
module.exports["getPosWhenMoveNodeUp"] = $7a64999ea229affc$export$6e259a78a1c38d78;
module.exports["getPosWhenMoveNodeDown"] = $7a64999ea229affc$export$3545fa32cdadf3ca;
module.exports["canMoveNodeUpOrDown"] = $7a64999ea229affc$export$cc4db90b9d5a445a;

});

parcelRegister("1gg4H", function(module, exports) {
const $16341d19456791c3$export$a5a8e8321fc18ce = (node)=>{
    if ('mediaSingle' === node?.type.name) {
        if ([
            'wrap-right',
            'wrap-left'
        ].includes(node.attrs.layout)) return true;
    }
    return false;
};
module.exports["isWrappedMedia"] = $16341d19456791c3$export$a5a8e8321fc18ce;

});

parcelRegister("irTNm", function(module, exports) {
const $054dddf2eb579832$export$2b4dd9f6b8f819da = (fragment, type)=>fragment.childCount === 1 && fragment.firstChild?.type.name === type;
const $054dddf2eb579832$export$8cb5c38ddf4d519f = (fragment, type)=>{
    for(let i = 0; i < fragment.childCount; i++){
        const child = fragment.child(i);
        if (child.type.name === type) return true;
    }
    return false;
};
module.exports["isFragmentOfType"] = $054dddf2eb579832$export$2b4dd9f6b8f819da;
module.exports["containsNodeOfType"] = $054dddf2eb579832$export$8cb5c38ddf4d519f;

});

parcelRegister("7vrPh", function(module, exports) {

var $hTjcC = parcelRequire("hTjcC");

const $fa015684aa46543e$export$6688b13ec132acdf = (tr, layoutNode, layoutNodePos, childCount)=>{
    const newColumnWidth = (0, $hTjcC.DEFAULT_COLUMN_DISTRIBUTIONS)[childCount];
    if (newColumnWidth) layoutNode.content.forEach((node, offset)=>{
        if (node.type.name === 'layoutColumn') tr.setNodeAttribute(layoutNodePos + offset + 1, 'width', newColumnWidth);
    });
    return {
        newColumnWidth: newColumnWidth,
        tr: tr
    };
};
module.exports["updateColumnWidths"] = $fa015684aa46543e$export$6688b13ec132acdf;

});


$parcel$global.rlb("5tzjb")
//# sourceMappingURL=twc-onboarding-experience.9ccf97bd.js.map
